/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	// templates
	__webpack_require__(1)
	var requireTemplates = __webpack_require__(2)
	requireTemplates.keys().forEach(requireTemplates)

	// images
	// var requireThumbs = require.context('./resources/img', true, /\.(jpg|png)$/);
	// requireThumbs.keys().forEach(requireThumbs);
	__webpack_require__(70)
	__webpack_require__(71)
	__webpack_require__(72)
	__webpack_require__(73)
	__webpack_require__(74)
	__webpack_require__(75)
	__webpack_require__(76)
	__webpack_require__(77)
	__webpack_require__(78)
	__webpack_require__(79)
	__webpack_require__(80)
	__webpack_require__(81)
	// requireThumbs = require.context('./resources/img/shimimaru', true, /\.(jpg|png)$/);
	// requireThumbs.keys().forEach(requireThumbs);

	// firebase init
	__webpack_require__(82)

	// js
	//require('./app/diable_console.js')
	__webpack_require__(83)
	__webpack_require__(84)
	__webpack_require__(85)
	__webpack_require__(86)
	__webpack_require__(87)
	__webpack_require__(88)
	__webpack_require__(92)
	__webpack_require__(93)
	__webpack_require__(94)

	__webpack_require__(95)
	__webpack_require__(96)
	__webpack_require__(97)
	__webpack_require__(98)
	__webpack_require__(99)

	__webpack_require__(100)
	//grequire('css-loader!./bower_components/angular-timeline/dist/angular-timeline-animations.css');

	__webpack_require__(104)
	controllers = __webpack_require__(105)
	services = __webpack_require__(113)
	controllers.keys().forEach(controllers)
	services.keys().forEach(services)
	__webpack_require__(126)
	__webpack_require__(127)

	// sass
	__webpack_require__(128)


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var path = 'templates/sign_in.html';
	var html = "<md-toolbar layout=row> <div class=md-toolbar-tools> <span><h1 translate=signin.title></h1></span> <span flex></span> <md-button ng-if=\"lang != 'ja'\" class=\"\" ng-click=\"switchLang('ja')\"> 日本語 </md-button> <md-button ng-if=\"lang != 'en'\" class=\"\" ng-click=\"switchLang('en')\"> English </md-button> </div> </md-toolbar> <md-content class=md-padding layout=column layout-align=\"center center\" layout-fill> <div class=md-whiteframe-z1 layout=column style=width:400px;max-width:90%;background:#fff> <md-toolbar> <h2 class=md-toolbar-tools translate=signin.signin></h2> </md-toolbar> <md-content class=md-padding layout=column style=background:#fff> <md-button ng-click=signInWithGoogle() class=\"md-warn md-raised\"> Google </md-button> <md-button ng-click=signInWithFacebook() class=\"md-primary md-raised\"> Facebook </md-button> <md-button ng-click=signInWithTwitter() class=md-raised style=background-color:#00e5ff;color:#fff> Twitter </md-button> </md-content> </div> <div class=\"md-padding md-whiteframe-z1\" layout=column layout-align=\"center center\" style=width:400px;margin-top:30px;background:#fff> <p translate=signin.browsers></p> <div layout=row layout-align=\"center center\"> <a style=\"margin:0 20px\" title=\"Google Chrome\" href=https://www.google.co.jp/chrome/ target=_blank> <img style=width:80px;height:80px ng-src=./resources/img/chrome.png /> </a> <a style=\"margin:0 20px\" title=\"Mozilla Firefox\" href=https://www.mozilla.org/ja/firefox target=_blank> <img style=width:80px;height:80px ng-src=./resources/img/firefox.png /> </a> </div> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./book/general.html": 3,
		"./connect.html": 4,
		"./credit.html": 5,
		"./dashboard.html": 6,
		"./dialogs/book.html": 7,
		"./dialogs/edit-profile.html": 8,
		"./dialogs/image.html": 9,
		"./dialogs/likes.html": 10,
		"./dialogs/links.html": 11,
		"./dialogs/mailing-list.html": 12,
		"./dialogs/profile.html": 13,
		"./dialogs/support.html": 14,
		"./dialogs/thumbnail.html": 15,
		"./dialogs/tutorial.html": 16,
		"./discussion.html": 17,
		"./editing_list.html": 18,
		"./entries.html": 19,
		"./fav_list.html": 20,
		"./forum.html": 21,
		"./guideline.html": 22,
		"./home.html": 23,
		"./home_alt.html": 24,
		"./introduction.html": 25,
		"./kula/char.html": 26,
		"./kula/learn.html": 27,
		"./kula/lesson.html": 28,
		"./kula/message-toast.html": 29,
		"./kula/quiz_dialog.html": 30,
		"./kula/start_quiz_dialog.html": 31,
		"./news.html": 32,
		"./partial/action-bottom-sheet.html": 33,
		"./partial/anction-bottom-sheet.html": 34,
		"./partial/comment.html": 35,
		"./partial/discussion_comment.html": 36,
		"./partial/entry_card.html": 37,
		"./partial/fav-list.html": 38,
		"./partial/forum.html": 39,
		"./partial/header.html": 40,
		"./partial/history.html": 41,
		"./partial/panel-notification-en.html": 42,
		"./partial/panel-notification.html": 43,
		"./partial/post-digest.html": 44,
		"./partial/post.html": 45,
		"./partial/quake.html": 46,
		"./partial/sidenav.html": 47,
		"./partial/timeline_event.html": 48,
		"./partial/timeline_event_en.html": 49,
		"./partial/user-menu-buttons.html": 50,
		"./partial/user_status.html": 51,
		"./personal.html": 52,
		"./post-single.html": 53,
		"./quakes.html": 54,
		"./sign_in.html": 1,
		"./timeline.html": 55,
		"./transcription.html": 56,
		"./transcription/action_buttons.html": 57,
		"./transcription/confirm_dialog.html": 58,
		"./transcription/content.html": 59,
		"./transcription/content_status.html": 60,
		"./transcription/diff_dialog.html": 61,
		"./transcription/finishing_dialog.html": 62,
		"./transcription/history.html": 63,
		"./transcription/input.html": 64,
		"./transcription/legends.html": 65,
		"./transcription/message-toast.html": 66,
		"./transcription/notes.html": 67,
		"./transcription/starting_dialog.html": 68,
		"./transcription/view.html": 69
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	var path = 'templates/book/general.html';
	var html = "<div class flex=30 layout=column> <h3>{{book.title}}</h3> <img ng-src=./resources/img/thumbnails/{{book.$id}}.min.jpg /> </div> <div class flex layout=column> <p>ID: {{book.$id}}</p> <p> <a href={{book.bib_url}} target=_blank>東京大学地震研究所所蔵 </a> </p> <p>{{book.comment}}</p> <p><a class=\"disaster tag\" ng-click=\"searchByTag(d['name'])\" ng-repeat=\"d in entry.disaster_list\"> {{d['name']}} <md-tooltip md-direction=bottom> {{d['name']}}（{{d['jp_date']}}）[{{d['en_date']}}] </md-tooltip> </a> <a class=\"region tag\" ng-repeat=\"region in entry.region_list\"> {{region}} <md-tooltip md-direction=bottom> 地域: {{region}} </md-tooltip> </a> </p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var path = 'templates/connect.html';
	var html = "<md-content flex=60 class=\"connect md-padding\" layout=column style=height:100% exec-on-scroll-bottom=loadMore()> <md-whiteframe class=\"md-whiteframe-2dp compose\" style=display:block layout=column> <textarea placeholder=質問・紹介したい内容をここに入力してください rows=4 ng-model=newPost.text style=height:100px>\n    </textarea> <div class=actions layout=row layout-align=\"left center\" style=height:50px> <label style=margin-left:10px>カテゴリ：</label> <md-select ng-model=newPost.category width=100px; aria-label=category> <md-option ng-value=c.value ng-repeat=\"c in postCategories\"> {{c.name}} </md-option> </md-select> <span flex></span> <md-button class=\"md-icon-button launch\" multiple=multiple accept=image/* ngf-select=selectFiles($files) ng-disabled=\"imagesToUpload.length >= 4\" ngf-multiple=true> <md-tooltip>写真を添付（4枚まで）</md-tooltip> <i class=material-icons>camera_alt</i> </md-button> <md-button class=\"md-raised md-primary\" ng-click=submitPost() ng-if=!uploading> 投稿 </md-button> <md-progress-circular ng-if=uploading class=md-hue-2 md-diameter=20px> </md-progress-circular> </div> <div class=\"images md-padding\" layout=row ng-if=imagesToUpload.length> <div class=thumbnail style=position:relative ng-repeat=\"img in imagesToUpload\"> <img class=clickable ngf-thumbnail=img style=margin:1px;max-width:100px;height:100px;display:inline-box ng-click=openThumbnailModal(img) /> <md-button ng-click=removeImage($index) aria-label=\"remove this image\" style=position:absolute;top:-15px;right:-15px class=\"md-icon-button launch\"> <md-tooltip>写真を削除</md-tooltip> <md-icon>close</md-icon> </md-button> </div> </div> </md-whiteframe> <md-subheader class=md-no-sticky>最近の投稿</md-subheader> <md-card class=post ng-repeat=\"post in posts\" ng-if=!post.sticky ng-init=\"user = users.get(post.uid)\" style=display:block ng-include=\"'templates/partial/post.html'\"> </md-card> <div layout=row class=md-padding layout-sm=column layout-align=space-around> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var path = 'templates/credit.html';
	var html = "<md-content flex=70 class=\"credit md-padding\"> <md-whiteframe class=\"md-whiteframe-2dp credit md-padding\" style=display:block> <h1>ライセンス</h1> <h3>翻刻文データについて</h3> <p>本サイトの翻刻文データは<a target=_blank href=https://creativecommons.org/licenses/by-sa/3.0/deed.ja>CC BY-SA</a>ライセンスのもと、出典を明示する限りにおいて事前の申請等の必要なく複製・再頒布が可能です。</p> <h3>史料画像について</h3> <p>本サイトで掲載している「石本文庫」の史料画像データは、東京大学地震研究所の許諾を得て公開しているものです。画像データの複製・再頒布にあたっては、地震研究所の許諾が別途必要になります。</p> <h3>学習コンテンツについて</h3> <p>本サイトに収録した「くずし字」の学習コンテンツは、大阪大学を中心とした科研挑戦的萌芽的研究「<a href=https://www.let.osaka-u.ac.jp/ja/research/community/hodo/iikura_KuLA target=_blank>日本の歴史的典籍に関する国際的教育プログラムの開発</a>」の成果として開発されたものです。</p> <h3>変体仮名の文字画像について</h3> <p>本サイトは、独立行政法人情報処理推進機構（IPA）および大学共同利用機関法人人間文化研究機構国立国語研究所（NINJAL）が提供する<a target=_blank href=http://mojikiban.ipa.go.jp/4488.html>変体仮名画像</a>を使用しています。同データは、<a target=_blank href=http://creativecommons.org/licenses/by-sa/2.1/jp/ >CC BY-SA</a>ライセンスのもと公開されています。</p> <h3>文字・用例画像について</h3> <p>本アプリに収録されている文字・用例画像は、大学共同利用機関法人人間文化研究機構国文学研究資料館の運営する画像データベースから採取したものです。使用にあたっては、各資料の所蔵機関から許諾を頂きました。</p> <ul> <li>好色一代男、日本永代蔵：国文学研究資料館</li> <li>西鶴置土産：東京大学総合図書館</li> <li>祇園物語：東京教育大学附属図書館</li> <li>西鶴織留：西尾市岩瀬文庫</li> <li>春色梅暦：岐阜大学図書館</li> </ul> <h1>クレジット</h1> <p>「みんなで翻刻」は、<a href=http://kozisin.info/ target=_blank>京都大学古地震研究会</a>の活動の一環として開発・運営されています。</p> <h2>監修</h2> <p>中西 一郎 （京都大学理学研究科）</p> <p>加納 靖之 （京都大学防災研究所）</p> <h2>設計・開発</h2> <p>橋本 雄太（京都大学文学研究科・院）</p> <h2>コンテンツ作成</h2> <h4>「くずし字学習の基礎」</h4> <p>大邑 潤三 （佛教大学文学研究科・院）</p> <h4>翻刻ガイドライン</h4> <p> 天野 たま （京都大学文学研究科・院）</p> <p> 久葉 智代 （京都大学文学研究科・院）</p> <p> 酒井 春乃 （京都大学文学部）</p> <h2>開発協力・動作検証</h2> <p>伊藤 和行 （京都大学文学研究科）</p> <p>小田木 洋子 （京都大学理学研究科）</p> <p>西川 真樹子 （京都大学図書館）</p> <p>水島 和哉 （京都大学経済学研究科）</p> <p>服部 健太郎 （京都大学理学研究科）</p> <p>堀川 晴央 （産業技術総合研究所）</p> <p>安国 良一 （住友史料館）</p> <p>山本 宗尚 （京都大学理学研究科）</p> <h2>「しみまる」デザイン・作画</h2> <p>西内 友美（笠間書院）</p> <h2>サイトロゴデザイン</h2> <p>平井 華恵 （大阪大学文学研究科）</p> <h1>くずし字学習支援アプリケーション「KuLA」</h1> <p>「みんなで翻刻」には、くずし字学習支援アプリ「KuLA」が組み込まれています。KuLAは、平成27年度科研挑戦的萌芽研究「日本の歴史的典籍に関する国際的教育プログラムの開発」（代表・飯倉洋一教授）の成果として開発されました。</p> <h2>監修</h2> <p>飯倉 洋一</p> <p><a href=http://researchmap.jp/okjm/ >岡島 昭浩</a></p> <p>矢田 勉</p> <h2>協力</h2> <p><a href=http://researchmap.jp/goyamarintaro/ >合山 林太郎</a></p> <h2>設計・開発</h2> <p><a href=https://twitter.com/yuta1984> 橋本 雄太</a></p> <h2>マネジメント</h2> <p>康 盛国</p> <h2>用例画像収集・文字解説</h2> <p>久田 行雄</p> <p>ダニエル・小林ベター</p> <p>藤本 能史</p> <h2>読解教材・解説文作成</h2> <p>有澤 知世</p> <p>寺田 伝</p> <h2>「しみまる」デザイン・作画</h2> <p>西内 友美（笠間書院）</p> <h2>アイコン／起動時画面</h2> <p>平井 華恵</p> <h2>英語訳</h2> <p>ダニエル・小林ベター</p> <h2>アプリケーションテスト</h2> <p>西内 友美（笠間書院）</p> <p>酒井 理恵</p> <p>日高 愛</p> <p>児玉 千広</p> <p>服部 健太郎</p> <p>南清恵</p> <p>加藤れん</p> <p>かさい</p> </md-whiteframe> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	var path = 'templates/dashboard.html';
	var html = "<md-toolbar class=toolbar layout=row style=\"min-height:50px;box-shadow:0 0 10px 0 rgba(0,0,0,.7);z-index:999\" ng-include=\"'templates/partial/header.html'\"> </md-toolbar> <md-content class=dashboard id=container layout=row style=height:100%> <md-sidenav hide-xs layout-xs=hide style=width:230px class=\"md-sidenav-left sidenav\" md-component-id=left md-is-locked-open=true md-whiteframe=2 ng-include=\"'templates/partial/sidenav.html'\"> </md-sidenav> <md-content flex ui-view style=width:100%;height:100% layout=row> </md-content> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/book.html';
	var html = "<md-dialog aria-label=史料詳細 style=height:70%;width:70%> <md-toolbar> <div class=md-toolbar-tools> <h2>{{book.title}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <md-icon aria-label=close>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <md-tabs md-border-bottom style=height:100%> <md-tab label=概要> <md-content class=md-padding layout=column> <div layout=row ng-include=\"'templates/book/general.html'\"> </div> </md-content> </md-tab> <md-tab label=画像> <md-content class=md-padding> <h1 class=md-display-2>Tab Three</h1> </md-content> </md-tab> <md-tab label=履歴> <md-content class=md-padding> </md-content> </md-tab> <md-tab label=議論> <md-content class=md-padding> </md-content> </md-tab> </md-tabs> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=cancel() md-autofocus> 閉じる </md-button> <span flex></span> <md-button ui-sref=\"transcription.view({id: book.$id})\" style=margin-right:20px> 翻刻ページへ </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/edit-profile.html';
	var html = "<md-dialog class=\"profile dialog\" aria-label=profile style=width:50%> <md-toolbar> <div class=md-toolbar-tools> <h2>プロフィールの編集</h2> </div> </md-toolbar> <md-dialog-content layout=column style=height:300px;width:100%> <md-list style=width:100%> <md-list-item class=md-3-line style=padding-bottom:5px> <img ng-src={{currentUser.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{currentUser.name}}</h3> <md-input-container style=width:100%> <label>プロフィール</label> <input ng-model=currentUser.profile> </md-input-container> <div class=status layout=row style=margin-top:5px> <span> <img ng-src=./resources/img/diamond.png> {{currentUser.gemCount || 0}} </span> <span> <img ng-src=resources/img/like.png> {{currentUser.likesCount || 0}} </span> <span> <img ng-src=./resources/img/pencil.png> {{currentUser.charCount || 0}} </span> </div> </div> </md-list-item> </md-list> </md-dialog-content> <md-dialog-actions layout=row style=width:100%> <md-button class=md-warn ng-click=cancel()> キャンセル </md-button> <span> </span> <md-button class=md-primary ng-click=save($event)> 保存 </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/image.html';
	var html = "<md-dialog aria-label=\"\"> <img ng-src=https://res-4.cloudinary.com/doyeq9idz/image/upload/{{id}}.jpg> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/likes.html';
	var html = "<md-dialog class=\"likes dialog\" aria-label=likes style=width:50%> <md-toolbar> <div class=md-toolbar-tools> <h2>あっぱれ！</h2> </div> </md-toolbar> <md-dialog-content layout=column style=height:500px> <md-content style=width:100%> <md-list style=width:100%> <md-list-item class=\"\" style=padding-bottom:5px ng-repeat=\"(uid, liked) in likes\" ng-if=liked ng-init=\"user = Users.get(uid)\"> <img open-profile=user alt=\"{{user.name }}\" ng-src={{user.avatar}} class=md-avatar /> <p open-profile=user>{{ user.name }}</p> </md-list-item> </md-list> </md-content> </md-dialog-content> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/links.html';
	var html = "<md-dialog class=\"tutorial dialog\" aria-label=サポート style=\"\"> <md-toolbar> <div class=md-toolbar-tools> <h2>ブログ・SNS</h2> </div> </md-toolbar> <md-dialog-content class=md-padding layout=row style=height:500px> <div class=shimimaru layout=column layout-align=\"center center\"> <div class=balloon style=height:180px;width:500px> 「みんなで翻刻」の情報は、以下でも提供しています。 <ul> <li> ブログ：<a target=_blank href=https://honkoku.org/blog/ >https://honkoku.org/blog/</a> </li> <li> Facebook：<a target=_blank href=https://www.facebook.com/honkoku>https://www.facebook.com/honkoku</a> </li> <li> Twitter: <a target=_blank href=https://twitter.com/CloudHonkoku>https://twitter.com/CloudHonkoku</a> </li> <li> メーリングリスト: <a target=_blank href=https://groups.google.com/forum/#!forum/honkoku>https://groups.google.com/forum/#!forum/honkoku</a> </li> </ul> ぜひ一度ご訪問ください！ </div> <img ng-src=./resources/img/shimimaru/14.png style=\"width:100px;display:block;margin:0 auto\"/> </div> </md-dialog-content> <md-dialog-actions layout=row ng-class=state.bgClass> <md-button class=md-raised ng-click=cancel() aria-label=close> 閉じる </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/mailing-list.html';
	var html = "<md-dialog class=\"tutorial dialog\" aria-label=サポート> <md-toolbar> <div class=md-toolbar-tools> <h2>「みんなで翻刻」メーリングリスト</h2> </div> </md-toolbar> <md-dialog-content layout=row style=height:500px> <div class=shimimaru layout=column layout-align=\"center center\"> <div class=balloon style=height:150px> 翻刻の作業方針や今後の開発方針を、<a ng-href=https://groups.google.com/forum/#!forum/honkoku target=_blank>メーリングリスト（Googleグループ）</a>を使って議論しています。 <br>ぜひ参加してください！ </div> <img ng-src=./resources/img/shimimaru/14.png style=\"width:100px;display:block;margin:0 auto\"/> </div> </md-dialog-content> <md-dialog-actions layout=row ng-class=state.bgClass> <md-button class=md-raised ng-click=cancel() aria-label=close> 閉じる </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/profile.html';
	var html = "<md-dialog class=\"profile dialog\" aria-label=profile style=width:50%> <md-toolbar> <div class=md-toolbar-tools> <h2>プロフィール - {{user.name}}</h2> </div> </md-toolbar> <md-dialog-content layout=column style=height:500px> <md-list style=width:100% class=\"\"> <md-list-item class=md-3-line style=padding-bottom:5px> <img ng-src={{user.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{user.name}} （レベル{{user.currentLevel || 1}}）</h3> <p>{{user.profile || 'プロフィールがありません'}}</p> <div class=status layout=row style=margin-top:5px> <span> <img ng-src=./resources/img/diamond.png> {{user.gemCount || 0}} </span> <span> <img ng-src=resources/img/like.png> {{user.likesCount || 0}} </span> <span> <img ng-src=./resources/img/pencil.png> {{user.charCount || 0}} </span> </div> </div> </md-list-item> </md-list> <md-content style=background:#fff> <md-list style=width:100% class=\"\"> <md-subheader>最近の投稿</md-subheader> <md-list-item ng-repeat=\"post in posts | orderBy: 'rtimestamp'\" ng-include=\"'templates/partial/post-digest.html'\" style=padding:12px class=\"md-3-line post-digest\" ng-if=posts.length> </md-list-item> </md-list> </md-content> </md-dialog-content> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/support.html';
	var html = "<md-dialog class=\"tutorial dialog\" aria-label=サポート> <md-toolbar> <div class=md-toolbar-tools> <h2>お問い合わせ</h2> </div> </md-toolbar> <md-dialog-content layout=row ng-click=proceed() style=height:500px> <div class=shimimaru layout=column layout-align=\"center center\"> <div class=balloon style=height:150px> 「みんなで翻刻」は <a href=http://kozisin.info target=_blank> 京都大学古地震研究会</a> が開発・運営しています。<br>お問い合わせは <b>support@honkoku.org</b> までどうぞ！ </div> <img ng-src=./resources/img/shimimaru/07.png style=\"width:100px;display:block;margin:0 auto\"/> </div> </md-dialog-content> <md-dialog-actions layout=row ng-class=state.bgClass> <md-button class=md-raised ng-click=cancel() aria-label=close> 閉じる </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/thumbnail.html';
	var html = "<md-dialog aria-label=\"\"> <img ngf-thumbnail=img> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var path = 'templates/dialogs/tutorial.html';
	var html = " <md-dialog class=\"tutorial dialog\" aria-label=イントロダクション style=width:70% controller=TutorialDialogCtrl> <md-toolbar> <div class=md-toolbar-tools> <h2>くずし字学習の基礎</h2> </div> </md-toolbar> <md-dialog-content layout=row ng-click=proceed() style=height:500px> <div class=shimimaru flex=50 layout=column layout-align=\"center center\"> <p><b>{{currentSpeech.header}}</b></p> <div class=balloon style=height:150px ng-bind-html=currentSpeech.text> </div> <img ng-src={{currentSpeech.expression}} style=\"width:100px;display:block;margin:0 auto\"/> </div> <div class=image flex=50 layout=row layout-align=\"center center\"> <img class=example ng-src=./resources/img/shimimaru/{{currentSpeech.image}} ng-if=currentSpeech.image style=max-width:90%;max-height:90%> </div> </md-dialog-content> <md-dialog-actions layout=row ng-class=state.bgClass> <md-button class=md-raised ng-click=rollback() aria-label=close> 前のセリフ </md-button> <span flex></span> <span style=text-align:center> 画面をクリック or スペースキーを押すと進みます<br> {{idx+1}}/{{length}}</span> <span flex></span> <md-button class=md-raised ng-click=cancel() aria-label=close> 閉じる </md-button> </md-dialog-actions> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	var path = 'templates/discussion.html';
	var html = "<md-content flex=60 class=\"connect md-padding\" style=height:100%> <md-card class=post style=display:block ng-init=\"user=Users.get(discussion.uid)\"> <md-card-header> <md-card-avatar> <img class=user-avatar ng-src={{user.avatar}} onerror='\"error.jpg\"!=this.src&&(this.src=\"./resources/img/person.svg\")' open-profile=user /> </md-card-avatar> <md-card-header-text> <span class=md-title style=font-size:20px> <span class=tag ng-class=discussion.getCategory().cls> {{discussion.getCategory().name}} </span> {{discussion.title}} </span> <span ng-if=!discussion.sticky class=md-subhead> 投稿者 <span class=link style=font-weight:700 open-profile=user>{{user.name}}</span>・ {{moment(discussion.timestamp).fromNow()}}</span> <span ng-if=discussion.sticky class=md-subhead>固定された投稿</span> </md-card-header-text> </md-card-header> <md-card-content style=margin-top:30px> <p class=text style=\"font-size:14px;margin:8px 0\" ng-bind-html=\"discussion.text | stripTags | linky:'_blank'| lb2br  | trust\"></p> <div class=images style=\"display:block;margin:10px 5px\"> <img ng-repeat=\"id in discussion.images\" ng-src=https://res-4.cloudinary.com/doyeq9idz/image/upload/c_thumb/{{id}}.jpg ng-click=openPhotoModal(id) class=clickable style=margin:1px;max-width:48%;display:inline-box /> </div> <div class=actions layout=row> <a class=like ng-class=\"{liked : discussion.likedByCurrentUser()}\" ng-if=\"currentUser.uid != discussion.uid\" ng-click=discussion.toggleLike()> <img ng-src=resources/img/like.png /> あっぱれ！ </a> <span flex></span> <a class=remove ng-if=discussion.isCreatedBy(currentUser) ng-click=removeDiscussion($event)>この投稿を削除</a> </div> <div class=comments style=\"margin:5px -16px -16px;padding:10px;background-color:#f6f7f9\"> <div class=info style=display:block> <span class=comment-count style=margin-right:10px> <i class=material-icons>chat</i> {{discussion.commentSize || 0}}</span> <span class=comment-count style=margin-right:10px open-likes=discussion.likes> <img ng-src=resources/img/like.png /> {{discussion.likeCount()}}</span> </div> <hr/> <div class=comment ng-repeat=\"(key, comment) in discussion.comments track by $index\" ng-init=\"user = Users.get(comment.uid)\" ng-if=\"objSize(discussion.comments)-$index <= (discussion.visibleCommentCount || 3)\" ng-include=\"'templates/partial/discussion_comment.html'\" layout=row> </div> <form class=reply-form layout=column ng-init=\"discussion.newComment={}\"> <div class=\"\" layout=row> <img class=user-avatar ng-src={{currentUser.avatar}} /> <textarea flex placeholder=コメントを入力... ng-model=discussion.newComment.text ng-keyup=handleKeyup($event) rows=2>\n            </textarea> <div layout=column> <md-button class=\"md-icon-button md-primary\" ng-click=sendComment(discussion)> <md-tooltip>コメントを送信</md-tooltip> <i class=material-icons>send</i> </md-button> <md-button class=\"md-icon-button launch\" multiple=multiple accept=image/* ngf-select=\"selectCommentFiles($files, discussion)\" ng-disabled=\"discussion.newComment.images.length >= 2\" ngf-multiple=true> <md-tooltip>写真を添付（2枚まで）</md-tooltip> <i class=material-icons>camera_alt</i> </md-button> </div> </div> </form> <div class=images-wrapper layout=row style=\"margin:15px 0 0 30px\" ng-if=discussion.newComment.images.length> <div ng-repeat=\"img in discussion.newComment.images\" style=position:relative> <img class=clickable ngf-thumbnail=img style=margin:5px;max-width:100px;height:100px;display:inline-box ng-click=openThumbnailModal(img) /> <md-button ng-click=discussion.newComment.images.splice($index,1) aria-label=\"remove this image\" style=position:absolute;top:-15px;right:-15px class=\"md-icon-button launch\"> <md-tooltip>写真を削除</md-tooltip> <md-icon>close</md-icon> </md-button> </div> </div> </div> </md-card-content> </md-card> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var path = 'templates/editing_list.html';
	var html = " <div class=\"entries md-whiteframe-2dp md-padding\" style=width:280px;height:300px;display:inline-block;margin:5px ng-repeat=\"e in editingList\" ng-init=\"book = Books.get(e.bookId)\"> <a ui-sref=\"transcription.content.input({id: e.bookId, content: e.content+1})\" class=title>{{book.title}}-コマ{{e.content+1}} <div class=thumbnail> <img ng-if=book.images ng-src=./resources/img/thumbnails/{{e.bookId}}.min.jpg> <img ng-if=!book.images ng-src=./resources/img/noimage.png /> </div> </a> <p>{{moment(event.timestamp).fromNow()}}に編集</p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var path = 'templates/entries.html';
	var html = "<md-content class=\"md-padding entries\" flex=100> <div class=queries style=margin-bottom:15px> <md-input-container class=\"md-block md-icon-float\" flex style=margin-bottom:0;padding-bottom:0> <label translate=seaarch></label> <md-icon>search</md-icon> <input ng-model=search.keyword placeholder=\"{{'entries.keyword' | translate}}\" ng-model-options=\"{debounce: 1000}\" type=search> </md-input-container> <md-checkbox style=\"margin:0 0 0 10px\" ng-model=search.showCompleted aria-label=\"show only event with comment\"> {{'entries.show-completed' | translate}} </md-checkbox> </div> <div class=book-list> <div style=width:300px;height:390px;display:inline-block class=entry-wrapper ng-repeat=\"entry in entries | filter : search.filter\" ng-include=\"'templates/partial/entry_card.html'\"> </div> </div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var path = 'templates/fav_list.html';
	var html = "<div style=width:300px;height:350px;display:inline-block class=entry-wrapper ng-repeat=\"fav in favs\" ng-init=\"entry = Books.get(fav.$id)\" ng-include=\"'templates/partial/entry_card.html'\"> </div> <p ng-if=\"!favs || !favs.length\"> 「お気に入り」に追加された資料はありません。<br> 史料をお気に入りに追加するには、翻刻画面で史料タイトル横にある「☆」アイコンを押してください。</p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var path = 'templates/forum.html';
	var html = "<md-content flex=60 class=\"connect md-padding\" exec-on-scroll-bottom=loadMore()> <md-whiteframe class=\"md-whiteframe-2dp compose\" ng-if=showForm style=\"margin:10px 0;display:block\" layout=column> <div class=md-padding layout=column> <md-input-container class=md-block style=width:100%;margin-bottom:0 required> <label style=color:#000>投稿タイトル</label> <input ng-model=newDiscussion.title placeholder=投稿のタイトルを入力してください md-maxlength=20> </md-input-container> <md-input-container class=md-block style=margin:0> <label style=color:#000>本文</label> <textarea ng-model=newDiscussion.text style=padding:0;height:150px placeholder=質問・議論・提案・紹介したい内容をここに入力してください md-maxlength=400 rows=3 md-select-on-focus></textarea> </md-input-container> </div> <div class=actions layout=row layout-align=\"left center\" style=height:50px> <label style=margin-left:10px>カテゴリ：</label> <md-select ng-model=newDiscussion.category width=100px; aria-label=category> <md-option ng-value=k ng-repeat=\"(k, v) in categories\"> {{v.name}} </md-option> </md-select> <span flex></span> <md-button class=\"md-icon-button launch\" multiple=multiple accept=image/* ngf-select=selectFiles($files) ng-disabled=\"imagesToUpload.length >= 4\" ngf-multiple=true> <md-tooltip>写真を添付（4枚まで）</md-tooltip> <i class=material-icons>camera_alt</i> </md-button> <md-button class=\"md-raised md-warn\" ng-click=toggleForm() ng-if=!uploading> キャンセル </md-button> <md-button class=\"md-raised md-primary\" ng-click=submit() ng-disabled=\"!newDiscussion.text.length  || !newDiscussion.title.length\" ng-if=!uploading> 投稿 </md-button> <md-progress-circular ng-if=uploading class=md-hue-2 md-diameter=20px> </md-progress-circular> </div> <div class=\"images md-padding\" layout=row ng-if=imagesToUpload.length> <div class=thumbnail style=position:relative ng-repeat=\"img in imagesToUpload\"> <img class=clickable ngf-thumbnail=img style=margin:1px;max-width:100px;height:100px;display:inline-box ng-click=openThumbnailModal(img) /> <md-button ng-click=removeImage($index) aria-label=\"remove this image\" style=position:absolute;top:-15px;right:-15px class=\"md-icon-button launch\"> <md-tooltip>写真を削除</md-tooltip> <md-icon>close</md-icon> </md-button> </div> </div> </md-whiteframe> <div layout=row style=margin-bottom:10px;height:50px> <md-subheader class=md-no-sticky>最近のフォーラムへの投稿</md-subheader> <span flex></span> <md-button class=\"md-raised md-primary\" ng-click=toggleForm() ng-if=!showForm> 新規投稿 </md-button> </div> <md-nav-bar md-selected-nav-item=selectedNavItem nav-bar-aria-label=\"navigation links\"> <md-nav-item md-nav-click=\"switchNavItem('latest')\" name=latest> 投稿順 </md-nav-item> <md-nav-item md-nav-click=\"switchNavItem('update')\" name=update> 更新順 </md-nav-item> <md-nav-item md-nav-click=\"switchNavItem('popular')\" name=popular> 人気順 </md-nav-item> </md-nav-bar> <md-list class=md-whiteframe-2dp style=padding:0;background:#fff;margin-top:10px> <md-list-item class=md-3-line ng-repeat=\"d in discussions\" ng-init=\"user=Users.get(d.uid)\" ui-sref=\"dashboard.discussion({id: d.$id})\" style=background:#fff> <img ng-src={{user.avatar}} class=md-avatar alt={{user.name}}> <div class=md-list-item-text layout=column> <h3> <span class=tag ng-class=d.getCategory().cls>{{d.getCategory().name}}</span> {{ d.title }} </h3> <p>投稿者 {{ user.name }}・{{ moment(d.timestamp).fromNow()}}</p> <p ng-if=d.commentSize ng-init=\"commenter=Users.get(d.latestComment().uid)\" style=font-size:11px> <img ng-src={{commenter.avatar}} class=md-avatar alt={{commenter.name}} style=height:16px;width:16px;margin:0> {{commenter.name}}さんがコメントしました （{{ moment(d.latestComment().timestamp).fromNow()}}） </p> <md-divider ng-if=!$last></md-divider> </div> <div layout=row> <span style=font-size:19px> <i style=vertical-align:middle class=material-icons>chat</i> {{d.commentSize || 0}} </span> </div> </md-list-item> </md-list> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	var path = 'templates/guideline.html';
	var html = "<md-content flex=70 class=\"document md-padding\" layout=column style=height:100%> <md-whiteframe class=\"md-whiteframe-2dp md-padding\" style=width:100%;display:block;box-sizing:border-box> <h1>翻刻ガイドライン</h1> <p>古い文献には、たくさんの特殊な文字や記法が使われています。 これらを翻刻する（活字に起こす）ためには、一定のルールを決めておく必要があります。</p> <h3>翻刻のサンプル</h3> <p>『<a href=# ui-sref=\"transcription.content.view({id: 'L000105', content: 1})\">諸国海辺地震津浪書</a>』は、古地震研究会で翻刻した史料です。ぜひ翻刻の参考にしてください。</p> <h3>基本方針</h3> <p>「みんなで翻刻」では、次の方針を史料翻刻の原則とします。</p> <p style=text-align:center;font-size:large><b>「見たままを翻刻し、原文の姿をできるかぎり残す」</b></p> <p> 史料ごとに翻刻の方針を検討する必要がある場合は、「ノート機能」（現在開発中）を用いて議論してください。よくわからない部分がある場合、「とりあえず翻刻をしてみて、他の人の修正を待つ」という参加の仕方も可能です。ぜひお気軽にご参加ください！</p> <p>以下では、句読点や文字などについて、翻刻の具体的な方針を説明します。 翻刻画面の「凡例」タブと合わせてご参照ください。</p> <h3>変体仮名の扱い</h3> <p>変体仮名は印刷活字体に改め、漢字はできるだけ当用漢字の字体に準拠してください。「ミ」「ハ」「乃」なども「まなぶ」機能に準拠して変体仮名として捉え、平仮名で翻刻してください。</p> <p>ただし、常用漢字・新字体のわからない異体字・旧字体については、そのまま翻刻していただいて結構です。わからない文字については、エディターの「不明瞭な文字」の機能をご活用ください。</p> <h3>合字や旧仮名の扱い</h3> <p>「ゐ」「ヰ」「ゑ」「ヱ」の入力にはエディターの「頻出」機能をご活用ください。</p> <h3>句読点、濁点、文章区切りの扱い</h3> <p>濁音、句読点、段落、スペース（闕字）、改行等は、原文のまま翻刻を行ってください。解釈によって補わないように注意してください。</p> <h3>ふりがな・ルビの扱い</h3> <p>ふりがなは、原文にある通り、エディターの「ルビ」機能を用いて可能な限り翻刻してください。左ルビは、エディターの「注記」機能を利用し、コメントとして入力してください。</p> <h3>繰り返し記号（踊り字）の扱い</h3> <p>くりかえし記号（ゝ、ゞ、ヽ、ヾ、〻、々、〳〵、〴〵）は、エディターの「踊り字」機能をお使いください。割書き、箱で囲われた文字、訓点の入力にも、それぞれエディターの機能をお使いください。</p> <h3>誤記・虫損の扱い</h3> <p>原文に誤り・脱字があると思われる箇所については、エディターの「注記」の機能を活用してメモを残してください。</p> <p>虫食い、汚れ等のために文字が判読できない箇所は、「□」で表してください。</p> <h3>その他</h3> <p>送り仮名や動詞の語尾、テニヲハの脱落は補わず、原文の通りに記してください。<b>小文字で表現されている読み添え仮名も、大きな文字（地の文と同じ大きさ）でそのまま翻刻してください</b>。</p> 書き込みや付箋、図の中の文字などは、注記を行い、本文とは区別して翻刻をしてください。手書 きで訂正してある部分などについては、注記機能をお使いください。 順序に迷う箇所も、文字に起こすことを重視し、適当な順序を決めて翻刻してください。 <p></p> </md-whiteframe> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	var path = 'templates/home.html';
	var html = "<md-content flex class=home layout=row style=height:100%> <md-content class=md-padding style=overflow-x:hidden> <div class=\"disp-options md-whiteframe-2dp\" layout=column> <div> <md-checkbox ng-model=dispOptions.showOnlyRequestReview aria-label=\"show only review requests\"> {{ 'home.toggle-review' | translate}} </md-checkbox> <md-checkbox style=margin-left:10px ng-model=dispOptions.showWithComment aria-label=\"show only event with comment\"> {{ 'home.toggle-comments' | translate}} </md-checkbox> </div> <div> <p style=\"margin:5px 0 0\" ng-if=\"lang == 'ja'\"> お知らせ：<a href=https://honkoku.org/yamana.html target=blank_>『岩手県海岸巡回古文書拾集録（日誌）』</a>をステージ9に追加しました（2018-08-18）<br> お知らせ：みんなで翻刻次期バージョンへの要望を<a href=https://honkoku.org/app/#/dashboard/discussion/-L1obSRjZ7GSbg8bDTX8>フォーラム</a>で募集しています（2018-01-09） </p> </div> </div> <md-card class=timeline-event ng-repeat=\"event in timeline | orderBy: '-timestamp'\" ng-init=\"user=Users.get(event.uid); book=Books.get(event.bookId)\" ng-if=\"isVisible(event) && lang == 'ja'\" ng-include=\"'templates/partial/timeline_event.html'\"> </md-card> <md-card class=timeline-event ng-repeat=\"event in timeline | orderBy: '-timestamp'\" ng-init=\"user=Users.get(event.uid); book=Books.get(event.bookId)\" ng-if=\"isVisible(event) && lang == 'en'\" ng-include=\"'templates/partial/timeline_event_en.html'\"> </md-card> </md-content> <div flex></div> <md-sidenav style=width:300px;height:100% class=\"md-sidenav-right sidenav\" md-component-id=right md-is-locked-open=true md-whiteframe=2> <md-content layout=column class=ranking> <h1>{{ 'home.progress' | translate}}</h1> <table style=\"width:95%;padding:0 5px 0 5px\"> <tr> <td style=min-width:90px>{{ 'home.total-chars' | translate}}</td> <td class=right>{{progress.charCount}}<br>（<span class=increase>+{{progress.charCountIncrease}}</span>）</td></tr> <tr><td>{{ 'home.total-images' | translate}}</td><td style=min-width:90px class=right>{{progress.progressSum}}/{{progress.contentSum}}<br>（{{progress.progressRatio}}％, <span class=increase>+{{progress.progressSumIncrease}}</span>）</td></tr> <tr><td>{{ 'home.total-records' | translate}}</td><td class=right>{{progress.completedBooks}}/{{progress.bookCount}}（<span class=increase>+{{progress.completedBooksIncrease}}</span>）</td></tr> <tr><td>{{ 'home.total-users' | translate}}</td><td class=right>{{progress.userCount}}</td></tr> </table> <h1>{{ 'home.leaderboard' | translate}}</h1> <md-list class=md-dense> <md-list-item class=md-2-line style=height:45px;min-height:45px ng-repeat=\"user in charRanking | orderBy: 'user.charCount':true\"> <span>{{$index+1}}.</span> <img ng-src={{user.avatar}} open-profile=user class=md-avatar err-src=resources/img/person.svg style=margin-top:0;margin-right:8px /> <div class=detail> <p class=name open-profile=user style=margin:0;padding:0> {{user.name || \"名前なし\"}}</p> <span class=\"count color-sub\">{{user.charCount || 0}} {{ 'home.chars' | translate}}</span> </div> </md-list-item> </md-list> </md-content> </md-sidenav> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	var path = 'templates/home_alt.html';
	var html = "<md-content flex=65 class=\"home md-padding\" layout=column style=height:100%> <md-whiteframe class=md-whiteframe-2dp style=display:block> <div class=\"content md-padding\"> <h3>おしらせ</h3> </div> </md-whiteframe> <md-whiteframe class=md-whiteframe-2dp style=display:block> <div class=\"content md-padding\"> <h3>はじめに</h3> </div> <hr> <div class=\"content md-padding\"> <h3>あなたが編集中</h3> </div> <hr> <div class=\"content md-padding\"> <h3>お気に入り</h3> </div> <hr> <div class=\"content md-padding\"> <h3>翻刻してみませんか？</h3> </div> </md-whiteframe> <md-whiteframe class=md-whiteframe-2dp style=display:block> <div class=\"content md-padding\"> <h3>「みんなで翻刻」現在の進捗（日次集計）</h3> <md-progress-linear md-mode=determinate value={{lastStat.progress_sum/lastStat.content_sum*100}}> </md-progress-linear> <p>全体進捗： <b>{{(lastStat.progress_sum/lastStat.content_sum*100).toFixed(2)}}%</b></p> <p>翻刻された文字数：<b>{{lastStat.char_count}}文字</b></p> <p>翻刻が完了した画像：<b>{{lastStat.progress_sum}}/{{lastStat.content_sum}}コマ</b></p> <p>翻刻が完了した史料：<b>{{lastStat.completed_books}}/114冊</b></p> <p>登録者数：<b>{{lastStat.user_count}}人</b></p> </div> </md-whiteframe> </md-content> <md-content flex=35 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var path = 'templates/introduction.html';
	var html = "<md-content flex=100 class=\"document learn md-padding\" layout=column style=height:100%> <md-whiteframe ng-if=\"lang =='ja'\" class=\"md-whiteframe-2dp md-padding lesson-list\" style=width:600px;display:block> <h2>ごあいさつ</h2> <p>「みんなで翻刻」へようこそ．</p> <p>このサイト（アプリ）は，過去の地震や災害，その他に関する古文書の翻刻を，web上でおこなうことを目的にしています． </p> <p>翻刻とは，古文書の文字を一文字ずつ活字（テキスト）になおしていく作業です． </p> <p>古文書に書かれていることをもとに，過去にどのような災害が発生し，どのような被害が生じたかを知ることは，将来の災害軽減に必ず役にたつと考えています．実際，古文書に書かれた記録をもとに，大地震発生の地域性や周期性に関する研究がすすんできました． </p> <p>過去のひとびとは膨大な記録を残してくれているのですが，活字になってデータとして活用しやすい状態になっている古文書はわずかです． </p> <p>ここは，このような古文書を翻刻するためのサイトなのです． </p> <p>過去の地震などの自然災害を主なテーマにしていますが，みなさんの興味によっては，また別の事柄も読み取れるかもしれません． </p> <p>アプリの使用方法については「凡例」をご覧ください． 翻刻にあたって，一定のルールを設けていますので，左メニューの「翻刻ガイドライン」をご参照ください．翻刻がひととおり完了しているもの（たとえば『<a href=http://honkoku.org/#/transcription/L000105/1/view>諸国海辺地震津波書</a>』）を参照していただくのもよいでしょう． </p> <p>自信がないとか，間違ってはいけないのではないか，と思われるかもしれません．気にせず，まずは入力してみてください．「みんなで翻刻」では，誰もが入力でき，修正もできます．間違いがあっても，上級者が修正してくれるはずです．あやふやな場合や複数の読み方が出きる場合などは，「ノート」機能をつかって議論することができます． </p> <p>翻刻するためには，くずし字を解読しなければなりません．くずし字解読について学ぶためのコンテンツ（「まなぶ」「つながる」）も用意しています． </p> <p>翻刻するにあたって，疑問点などありましたら「お問い合わせ」からご連絡ください．サイト自体も翻刻ルールについても，みなさんのご意見をもとに改善していきたいと考えています．</p> <p>現在翻刻できる古文書は，<a href=http://www.eri.u-tokyo.ac.jp/ >東京大学地震研究所</a>所蔵の石本文庫におさめられているものを利用しています．ステージ1の114冊は、原蔵者は東京大学地震研究所であり，画像を別の目的（研究や配布，放映など）に利用する場合には，<a href=http://www.eri.u-tokyo.ac.jp/tosho/keisai.html>別途許可が必要となります</a>．詳細は，東京大学地震研究所のサイトをご覧ください．</p> </md-whiteframe> <md-whiteframe ng-if=\"lang != 'ja'\" class=\"md-whiteframe-2dp md-padding lesson-list\" style=width:600px;display:block> <h2>Introduction</h2> <p>Welcome to Minna de Honkoku.</p> <p>This site (and app) are designed to for the online transcription of ancient documents related to past natural disasters such as earthquakes.</p> <p>The Japanese term <i>honkoku</i><span> (翻刻) refers here to the transcription of ancient texts, character by character, into machine-encoded, computerized text.</span></p> <p><span>Learning from ancient texts about previous disasters and the damage they caused will be of great value to future disaster mitigation efforts. Records from ancient texts are being used right now to study the location and periodicity of major earthquakes.</span></p> <p></p><p><span>Great numbers of records have been left to us by past generations, but only a small number have converted into computerized text data useful for research.</span></p><p></p><p><span>This site has been established in order to perform these kinds of useful transcriptions of ancient texts.</span></p><p></p><p><span>We are primarily interested in studying past earthquakes and other disasters, but users can participate in the project out of any number of other interests.</span></p><p></p><p><span>For information on using the app, please check the </span><span>R</span><span>eference</span><span> tab when viewing a manuscript </span><span>file. Some rules for transcription have been established for the project, and can be found under the </span><span>T</span><span>ranscription </span><span>G</span><span>uidelines</span><span> entry on the left hand side of the screen. It is also recommended that you refer to manuscript entries that have been completely transcribed, such as the </span><i>Shokoku Umibe Jishin Tsunami Sho</i><span> (</span><a href=http://honkoku.org/#/transcription/L000105/1/view target=_blank><span>諸国海辺地震津波書</span></a><span>).</span></p><p></p><p><span>W</span><span>hen getting into working with the system, you may feel uncertain about your transcriptions, or worry that you have made a mistake. However, </span><span>in these cases you should go ahead and </span><span>submit your work </span><span>without worrying</span><span>. </span><span>Minna de Honkoku is </span><span>designed to allow anyone to submit transcriptions, and anyone to correct submissions. Even if you make mistakes, experienced users will mostly likely correct your work. In case there are ambiguities of how a character should be interpreted or multiple possible readings of a character, you can use the </span><span>Note</span><span> functionality to discuss the matter with other users.</span></p><p></p><p><span>I</span><span>n order to make transcriptions on Minna de Honkoku, you need to know how to read </span><i>kuzushiji</i><span> (</span><span>崩し字</span><span>). Please make use of the learning tools on the site (under the </span><span>Learn</span><span> and </span><span>Connect</span><span> entries) to learn how to do so. </span></p><p></p><p><span>If you have any questions or concerns about transcription please contact us using the </span><span>Inquiries</span><span> entry. We welcome your comments about the site and transcription guidelines, and will use them to improve </span><span>the project.</span></p><p></p><p><span>T</span><span>he documents currently being transcribed are from the </span><a href=http://www.eri.u-tokyo.ac.jp/en/ target=_blank><span>Tokyo University Earthquake Research Institute’s</span></a><span> Ishimoto Collection. The 114 manuscripts in the Stage 1 collection are the property of the Tokyo University Earthquake Research Institute and the images of them on the site can only be used for other purposes (research, distribution, televising, etc.) </span><a href=http://www.eri.u-tokyo.ac.jp/tosho/keisai.html target=_blank><span>with express </span></a><a href=http://www.eri.u-tokyo.ac.jp/tosho/keisai.html target=_blank><span>special </span></a><a href=http://www.eri.u-tokyo.ac.jp/tosho/keisai.html target=_blank><span>permission from the Institute</span></a><span>. </span><span>For more details, please refer to the Tokyo University Earthquake Institute’s website.</span></p> </md-whiteframe> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var path = 'templates/kula/char.html';
	var html = "<h1 class=yomi>【{{char.char}}】</h1> <div class=delegate ng-if=char.main_image> </div> <div class=single> <img style=width:70px ng-src=resources/{{char.main_image}} /> <img ng-repeat=\"usecase in char.usecases_single\" ng-src=resources/{{usecase.path}} yomi={{usecase.yomi}} source={{usecase.source}} ng-click=openModal($event) ng-if=usecase /> </div> <p class=comment ng-if=char.comment> <b>《解説》</b><span ng-bind-html=char.comment></span> </p> <div class=multi> <h2>【用例】</h2> <div ng-repeat=\"usecase in char.usecases_multi\" style=display:inline-block layout=column> <p style=margin:0;padding-top:10px>{{usecase.yomi}}</p> <img ng-src=resources/{{usecase.path}} source={{usecase.source}} ng-click=openModal($event)> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var path = 'templates/kula/learn.html';
	var html = "<md-content flex=60 class=\"learn md-padding\" layout=column style=height:100%> <md-whiteframe class=\"md-whiteframe-2dp md-padding lesson-list\" style=display:block layout=row> <h2 class=section-header>はじめに</h2> <div class=lesson> <a ng-click=openTutorial(1)> <img class=lesson-icon ng-src=resources/img/shimimaru.png /> <p class=lesson-title>くずし字学習の基礎①</p> </a> </div> <div class=lesson> <a ng-click=openTutorial(2)> <img class=lesson-icon ng-src=resources/img/shimimaru/11.png /> <p class=lesson-title>くずし字学習の基礎②</p> </a> </div> <div class=lesson> <a ng-click=openTutorial(3)> <img class=lesson-icon ng-src=resources/img/shimimaru/14.png /> <p class=lesson-title>くずし字学習の基礎③</p> </a> </div> <div class=lesson style=margin-top:30px> <a href=\"https://itunes.apple.com/jp/app/kuzushi-zi-xue-xi-zhi-yuanapurikula/id1076911000?mt=8\" target=_blank> <img style=\"width:200px;display:block;margin:5px auto\" ng-src=resources/img/download_ios.png /> </a> <a href=\"https://play.google.com/store/apps/details?id=yuta.hashimoto.kula&hl=ja\" target=_blank> <img style=\"width:200px;display:block;margin:5px auto\" ng-src=resources/img/download_android.png /> </a> <p class=lesson-title>アプリ版はこちら</p> </div> <h2 class=section-header>変体仮名を学ぶ</h2> <div class=lesson ng-repeat=\"lesson in kanaLessons\"> <a ui-sref=\"dashboard.lesson({id: lesson.id})\"> <img class=lesson-icon ng-src={{lesson.img}} /> </a> <diamond count=\"{{progress[lesson.id] || 0}}\"></diamond> <p class=lesson-title>{{lesson.title}}</p> </div> <h2 class=section-header>草書体漢字を学ぶ</h2> <div class=lesson ng-repeat=\"lesson in kanjiLessons\"> <a ui-sref=\"dashboard.lesson({id: lesson.id})\"> <img class=lesson-icon ng-src={{lesson.img}} /> </a> <diamond count=\"{{progress[lesson.id] || 0}}\"></diamond> <p class=lesson-title>{{lesson.title}}</p> </div> <div class=shimimaru-message style=\"margin:20px 0 70px 0;text-align:center\"> <p class=balloon> 今後もどんどんコンテンツを追加します。お楽しみに！ </p> <img class=shimimaru ng-src=resources/img/shimimaru/07.png style=height:120px> </div> </md-whiteframe> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	var path = 'templates/kula/lesson.html';
	var html = "<md-content flex=100 class=\"char-lesson md-padding\" layout=column style=height:100%> <md-content class=\"md-whiteframe-2dp lesson-list\" style=height:100% layout=column> <md-toolbar md-scroll-shrink layout=row> <div class=md-toolbar-tools> <md-button class=md-icon-button ui-sref=dashboard.learn> <md-tooltip md-direction=bottom>レッスン一覧へ</md-tooltip> <md-icon>reply</md-icon> </md-button> {{lesson.title}} <span flex></span> <md-button class=\"md-raised md-warn\" ng-click=startQuiz()>テストを開始</md-button> </div> </md-toolbar> <div layout=row style=height:100%> <div flex=20 class=char-list style=height:100%;overflow-y:scroll> <md-list> <md-list-item ng-repeat=\"char in chars\" ui-sref-active=item-menu-active ui-sref=\".char({char_id: char.$id})\"> <img class=md-avatar ng-src=\"resources/{{char.main_image || char.usecases_single[0].path}}\"> <h2 class=char-yomi />{{char.char}} </md-list-item> </md-list> </div> <div class=\"char-view md-padding\" flex=80 ui-view style=height:100%;background-color:#fff> </div> </div> </md-content> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var path = 'templates/kula/message-toast.html';
	var html = "<md-toast class=message-toast style=font-size:24px> <div class=user-info> <img ng-src=./resources/img/diamond.png style=width:25px;display:inline;vertical-align:middle> おしらせ </div> <div class=content> <span> {{msg}} </span> </div> </md-toast> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var path = 'templates/kula/quiz_dialog.html';
	var html = "<md-dialog class=quiz-dialog aria-label=テスト style=width:60%> <form ng-cloak ng-submit=proceed()> <md-toolbar> <div class=md-toolbar-tools> <h2>テスト：{{lesson.title}}</h2> <span flex></span> </div> </md-toolbar> <md-dialog-content layout=column> <div class=\"progress md-padding\"> <md-progress-linear md-mode=determinate value={{quiz.progress/quiz.size*100.0}}> </md-progress-linear> </div> <div class=md-dialog-content layout=row layout-align=\"center center\"> <div class=shimimaru flex=50> <div class=balloon style=height:100px ng-bind-html=state.speech(quiz)> </div> <img ng-src={{state.img}} style=\"width:100px;display:block;margin:0 auto\"/> </div> <div flex=50 style=height:100%> <div class=quiz-image style=margin:auto;width:100px> <p ng-if=state.hideAnswer>{{quiz.current.questionText}}</p> <p ng-if=!state.hideAnswer>{{quiz.current.yomi}}</p> <img ng-src=resources/{{quiz.current.path}}> </div> </div> </div> <div class=\"input-container md-padding\"> <span class=block ng-if=!state.showCloseButton> <input maxlength={{answerLength}} placeholder=\"{{state.placeholder || 'Enterを押して次へ'}}\" ng-model=quiz.input focus-on=focus-input> <md-button class=\"md-fab md-raised md-mini md-primary\" ng-click=\"insertChar('ゐ')\">ゐ</md-button> <md-button class=\"md-fab md-raised md-mini md-primary\" ng-click=\"insertChar('ゑ')\">ゑ</md-button> <md-button class=\"md-fab md-raised md-mini md-primary\" ng-click=\"insertChar('ゝ')\">ゝ</md-button> </span> <span class=block ng-if=state.showCloseButton> <md-button class=\"md-raised md-primary\" ng-click=share()> 結果をシェア </md-button> </span> </div> </md-dialog-content> <md-dialog-actions layout=row ng-class=state.bgClass> <md-button class=md-raised ng-click=cancel() aria-label=close> 閉じる </md-button> <span flex></span> <md-button class=\"md-raised md-primary\" aria-label=proceed ng-disabled=\"(state.input && quiz.input.length==0) || state.showCloseButton\" type=submit> <span ng-if=state.input>回答</span> <span ng-if=!state.input>次へ</span> </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	var path = 'templates/kula/start_quiz_dialog.html';
	var html = "<md-dialog class=dialog aria-label=テストを開始> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>テストを開始</h2> <span flex></span> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div class=balloon> さあテストを始めよう！難易度を選んでね。 </div> <img ng-src=./resources/img/shimimaru/07.png style=\"width:100px;display:block;margin:0 auto\"/> <div laout=column layout-align=\"center center\"> <div> <md-button md-no-ink ng-click=start(10) class=\"block md-primary\"> １文字・10問 <diamond style=display:inline-block count=1> </diamond></md-button> </div> <div> <md-button ng-click=start(chars.length) md-no-ink class=\"block md-primary\"> １文字・{{chars.length}}問 <diamond style=display:inline-block count=2> </diamond></md-button> <md-button ng-click=\"start(10, true)\" md-no-ink class=\"block md-primary\"> 複数字・10問 <diamond style=display:inline-block count=3> </diamond></md-button> <md-button ng-click=\"start(chars.length, true)\" md-no-ink class=\"block md-primary\"> 複数字・{{chars.length}}問 <diamond style=display:inline-block count=5> </diamond></md-button> </div> <div> <md-button md-no-ink class=\"block md-warn\" ng-click=cancel()> キャンセル</md-button> </div> </div> </div> </md-dialog-content> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	var path = 'templates/news.html';
	var html = "<md-content class=news> <h2>工事中</h2> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	var path = 'templates/partial/action-bottom-sheet.html';
	var html = "<md-bottom-sheet class=md-grid layout=column ng-cloak> <div layout=row layout-align=\"center center\"> <h4>Since <code>clickOutsideToClose = false</code>, drag down or press ESC to close</h4> </div> <div> <md-list flex layout=row layout-align=\"center center\"> <md-list-item ng-repeat=\"item in items\"> <div> <md-button class=md-grid-item-content ng-click=listItemClick($index)> <md-icon md-svg-src={{item.icon}}></md-icon> <div class=md-grid-text> {{ item.name }} </div> </md-button> </div> </md-list-item> </md-list> </div> </md-bottom-sheet> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var path = 'templates/partial/anction-bottom-sheet.html';
	var html = "<md-bottom-sheet class=md-grid layout=column ng-cloak> <div layout=row layout-align=\"center center\"> <h4>Since <code>clickOutsideToClose = false</code>, drag down or press ESC to close</h4> </div> <div> <md-list flex layout=row layout-align=\"center center\"> <md-list-item ng-repeat=\"item in items\"> <div> <md-button class=md-grid-item-content ng-click=listItemClick($index)> <md-icon md-svg-src={{item.icon}}></md-icon> <div class=md-grid-text> {{ item.name }} </div> </md-button> </div> </md-list-item> </md-list> </div> </md-bottom-sheet> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var path = 'templates/partial/comment.html';
	var html = "<img ng-src={{user.avatar}} onerror='\"error.jpg\"!=this.src&&(this.src=\"./resources/img/person.svg\")' ng-src={{user.avatar}} style=width:30px;height:30px class=user-avatar open-profile=user> <div class=content layout=column style=width:100%> <div class=text> <span open-profile=user class=user-name>{{user.name}}</span> <span class=comment style=color:#000 ng-bind-html=\"comment.text | stripTags | linky:'_blank' | lb2br | trust\"> </span> </div> <p class=images> <img ng-repeat=\"id in comment.images\" class=clickable ng-src={{IMAGE_BASE_URL}}/c_thumb,w_150,h_150/{{id}}.jpg style=margin:1px;max-width:48%;display:inline-box ng-click=openPhotoModal(id) /> </p> <div class=actions layout=row style=margin-top:5px;width:100%> <a class=like ng-if=\"currentUser.uid != comment.uid\" ng-click=post.toggleLikeComment(key) ng-class=\"{liked : post.commentLikedByCurrentUser(comment)}\"> あっぱれ！ </a> <a ng-if=\"post.commentLikeCount(comment) > 0\" style=text-decoration:none open-likes=comment.likes> <img ng-src=resources/img/like.png style=height:20px;display:inline;vertical-align:middle /> {{post.commentLikeCount(comment)}} </a> <span class=moment style=font-size:12px;color:gray;margin-left:5px> {{moment(comment.timestamp).fromNow()}}</span> <span flex></span> <a class=remove ng-if=\"comment.uid==currentUser.$id\" ng-click=\"removeComment(post, key, $event)\">コメントを削除</a> </div> </div> <a ng-click=\"removeComment(post, key)\" ng-if=\"currentUser.uid == comment.uid\" style=position:absolute;top:5px;right:5px;color:red;font-size:15px>削除</a> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var path = 'templates/partial/discussion_comment.html';
	var html = "<img ng-src={{user.avatar}} onerror='\"error.jpg\"!=this.src&&(this.src=\"./resources/img/person.svg\")' ng-src={{user.avatar}} style=width:30px;height:30px class=user-avatar open-profile=user> <div class=content layout=column style=width:100%> <div class=text> <span open-profile=user class=user-name>{{user.name}}</span> <span class=comment style=color:#000 ng-bind-html=\"comment.text | stripTags | linky:'_blank' | lb2br | trust\"> </span> </div> <p class=images> <img ng-repeat=\"id in comment.images\" class=clickable ng-src={{IMAGE_BASE_URL}}/c_thumb,w_150,h_150/{{id}}.jpg style=margin:1px;max-width:48%;display:inline-box ng-click=openPhotoModal(id) /> </p> <div class=actions layout=row style=margin-top:5px;width:100%> <a class=like ng-if=\"currentUser.uid != comment.uid\" ng-click=discussion.toggleLikeComment(key) ng-class=\"{liked : discussion.commentLikedByCurrentUser(comment)}\"> あっぱれ！ </a> <a ng-if=\"discussion.commentLikeCount(comment) > 0\" style=text-decoration:none open-likes=comment.likes> <img ng-src=resources/img/like.png style=height:20px;display:inline;vertical-align:middle /> {{discussion.commentLikeCount(comment)}} </a> <span class=moment style=font-size:12px;color:gray;margin-left:5px> {{moment(comment.timestamp).fromNow()}}</span> <span flex></span> <a class=remove ng-if=\"comment.uid==currentUser.$id\" ng-click=\"removeComment(key, $event)\">コメントを削除</a> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	var path = 'templates/partial/entry_card.html';
	var html = " <div class=\"entry md-whiteframe-2dp\"> <a ui-sref=\"transcription.content.view({id: entry.$id, content: 1, ref: currentPath})\" class=title>{{entry.title}} <div class=thumbnail> <img ng-if=\"entry.size == entry.progress\" style=position:absolute;width:50%;transform:rotate(-20deg);left:20%;top:20% ng-src=./resources/img/comp_stamp.png /> <img ng-src=./resources/img/thumbnails/{{entry.$id}}.min.jpg> <span class=difficulty-indicator ng-switch=entry.difficulty ng-class=\"['low','middle','high'][entry.difficulty-1]\"> <span ng-switch-when=1>難易度: 低</span> <span ng-switch-when=2>難易度: 中</span> <span ng-switch-when=3>難易度: 高</span> </span> </div> </a> <div class=\"md-block progress\" style=\"padding:0 5px\"> <md-progress-linear md-mode=determinate value=\"{{entry.progress ? entry.progress*100/entry.size : 0}}\"> </md-progress-linear> <span>{{entry.progress || 0}}/{{entry.size}}{{'entry.completed' | translate}}</span> </div> <div class=\"md-block entry-info color-positive;\" style=\"padding:0 5px\"> <a class=\"entry-id color-positive\" ng-if=\"entry.stage != 9\" ng-href={{entry.bib_url}} target=_blank>{{'entry.eri' | translate}} </a> <a class=\"entry-id color-positive\" ng-if=\"entry.stage == 9\" ng-href={{entry.bib_url}} target=_blank>{{entry.attribution}} </a> <br> {{entry.doc_id}} <span ng-if=entry.published_at>（{{entry.published_at}}）</span> </div> <div class=md-block style=\"padding:0 5px\"> <a class=\"disaster tag\" ng-click=\"searchByTag(d['name'])\" ng-repeat=\"d in entry.disaster_list\"> {{d['name']}} <md-tooltip md-direction=bottom> {{d['name']}}（{{d['jp_date']}}）[{{d['en_date']}}] </md-tooltip> </a> <a class=\"region tag\" ng-click=searchByRegion(region) ng-repeat=\"region in entry.region_list\"> {{region}} <md-tooltip md-direction=bottom> 地域: {{region}} </md-tooltip> </a> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	var path = 'templates/partial/fav-list.html';
	var html = "<div style=width:300px;height:350px;display:inline-block class=entry-wrapper ng-repeat=\"fav in favs\" ng-init=\"entry = Books.get(fav.$id)\" ng-include=\"'templates/partial/entry_card.html'\"> </div> <p ng-if=\"!favs || !favs.length\"> 「お気に入り」に追加された資料はありません。<br> 史料をお気に入りに追加するには、翻刻画面で史料タイトル横にある「☆」アイコンを押してください。</p> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	var path = 'templates/partial/forum.html';
	var html = "<md-content flex layout=column> <md-list style=height:560px> <md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"msg in messages | orderBy: '-timestamp'\" ng-init=\"user = users.get(msg.uid)\"> <img ng-src={{user.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{user.name}}</h3> <p>{{msg.text}}</p> </div> </md-list-item> </md-list> </md-content> <div class=md-block style=position:absolute;width:100%;bottom:0> <md-button class=\"md-fab md-mini\" ng-click=submitMessage() style=position:absolute;right:3px;bottom:3px> <md-icon>send</md-icon> </md-button> <textarea ng-model=textEdit placeholder=メッセージを送信 style=width:100%;height:100% rows=4>\n  </textarea> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var path = 'templates/partial/header.html';
	var html = "<div class=\"header md-toolbar-tools\" ng-controller=HeaderCtrl> <span> <a ui-sref=dashboard.home> <img style=height:45px;display:inline;vertical-align:middle ng-src=./resources/img/shimimaru/07.png /> <img ng-if=\"lang == 'ja'\" style=height:30px;display:inline;vertical-align:middle ng-src=./resources/img/title-header.svg /> <h1 ng-if=\"lang != 'ja'\" style=\"display:inline;font-family:'Merienda One',Helvetica,sans-serif!important\">Minna de Honkoku</h1> </a> </span> <span flex></span> <md-button ng-if=\"lang != 'ja'\" class=md-raised ng-click=\"switchLang('ja')\"> 日本語 </md-button> <md-button ng-if=\"lang != 'en'\" class=md-raised ng-click=\"switchLang('en')\"> English </md-button> <span class=badge-container> <md-button class=\"notification-btn md-icon-button\" ng-click=showNotifications()> <md-tooltip>{{ 'header.notifications' | translate}} ({{notifications.getUnreadCount()}})</md-tooltip> <md-icon>notifications</md-icon> </md-button> <span ng-if=notifications.getUnreadCount() class=badge>{{notifications.getUnreadCount()}}</span> </span> <span ng-include=\"'templates/partial/user-menu-buttons.html'\"> </span></div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	var path = 'templates/partial/history.html';
	var html = "<md-list class=\"md-whiteframe-2dp md-dense\" style=margin:0;padding:0> <md-list-item ng-repeat=\"event in timeline | orderBy:'-timestamp'\" ng-init=\"book = Books.get(event.bookId)\" ui-sref=\"transcription.content.view({id: event.bookId, content: event.content+1})\" style=background:#fff> <span style=position:absolute;top:3px;right:3px;line-height:20px ng-if=event.requestReview class=\"tag bg-assertive\">添削希望</span> <div class=md-list-item-text> <h3 style=margin:0;padding:0>{{book.title}}（コマ{{event.content+1}}）</h3> <p style=margin:0;padding:0>{{event.comment}}</p> <p class=color-sub style=margin:0;padding:0> {{moment(event.timestamp).format(\"YYYY-MM-DD hh:mm:ss\")}} - <b>{{event.diffCount}}文字</b>を翻刻</p> </div> <md-divider ng-if=!$last></md-divider> </md-list-item> </md-list> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	var path = 'templates/partial/panel-notification-en.html';
	var html = "<md-content class=notifications style=height:100%;background:#fff> <md-list class=\"notification-list md-dense\" md-autofocus> <md-list-item ng-repeat=\"note in notifications track by $index\" ng-init=\"user = Users.get(note.subject_id)\" class=md-3-line ng-class=\"{activated : note.new}\" ng-click=jumpToSource(note)> <img ng-src={{user.avatar}} open-profile=user class=md-avatar err-src=resources/img/person.svg style=margin-top:0;margin-right:8px /> <div class=md-list-item-text> <p ng-switch on=note.type style=white-space:normal;font-size:14px> <span ng-switch-when=post_liked> <b>{{user.name}}</b> liked <b>your post</b> </span> <span ng-switch-when=comment_liked> <b>{{user.name}}</b> liked <b>your comment</b> </span> <span ng-switch-when=comment_created> <b>{{user.name}}</b> commented on <b>your post</b> </span> <span ng-switch-when=levelup> You reached <b>Level {{note.level}}</b>! </span> <span ng-switch-when=discussion_liked> <b>{{user.name}}</b> liked <b>your post</b> </span> <span ng-switch-when=discussion_comment_liked> <b>{{user.name}}</b> liked <b>your comment</b> </span> <span ng-switch-when=discussion_comment_created> <b>{{user.name}}</b> commented on <b>your post</b> </span> <span ng-switch-when=timeline_event_liked> <b>{{user.name}}</b> liked <b>your transcription</b> </span> <span ng-switch-when=timeline_event_created ng-init=\"book = Books.get(note.book_id)\"> <b>{{user.name}}</b> transcribed <b>{{book.title | ellipsis:8}}: Image{{note.content+1}}</b> too </span> </p> <p class=moment style=font-size:13px;color:gray;margin-top:3px> {{moment(note.timestamp*1000).locale('en').fromNow()}} </p> </div> </md-list-item> </md-list> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	var path = 'templates/partial/panel-notification.html';
	var html = "<md-content class=notifications style=height:100%;background:#fff> <md-list class=\"notification-list md-dense\" md-autofocus> <md-list-item ng-repeat=\"note in notifications track by $index\" ng-init=\"user = Users.get(note.subject_id)\" class=md-3-line ng-class=\"{activated : note.new}\" ng-click=jumpToSource(note)> <img ng-src={{user.avatar}} open-profile=user class=md-avatar err-src=resources/img/person.svg style=margin-top:0;margin-right:8px /> <div class=md-list-item-text> <p ng-switch on=note.type style=white-space:normal;font-size:14px> <span ng-switch-when=post_liked> <b>{{user.name}}</b>さんが<b>あなたの投稿</b>に「あっぱれ！」しました </span> <span ng-switch-when=comment_liked> <b>{{user.name}}</b>さんが<b>あなたのコメント</b>に「あっぱれ！」しました. </span> <span ng-switch-when=comment_created> <b>{{user.name}}</b>さんが<b>あなたの投稿</b>にコメントしました </span> <span ng-switch-when=levelup> レベルが<b>{{note.level}}</b>になりました！ </span> <span ng-switch-when=discussion_liked> <b>{{user.name}}</b>さんが<b>あなたの投稿</b>に「あっぱれ！」しました </span> <span ng-switch-when=discussion_comment_liked> <b>{{user.name}}</b>さんが<b>あなたのコメント</b>に「あっぱれ！」しました. </span> <span ng-switch-when=discussion_comment_created> <b>{{user.name}}</b>さんが<b>あなたの投稿</b>にコメントしました. </span> <span ng-switch-when=timeline_event_liked> <b>{{user.name}}</b>さんが<b>あなたの翻刻</b>に「あっぱれ！」しました. </span> <span ng-switch-when=timeline_event_created ng-init=\"book = Books.get(note.book_id)\"> <b>{{user.name}}</b>さんも<b>{{book.title | ellipsis:8}} - Image {{note.content+1}}</b>を翻刻しました </span> </p> <p class=moment style=font-size:13px;color:gray;margin-top:3px> {{moment(note.timestamp*1000).fromNow()}} </p> </div> </md-list-item> </md-list> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	var path = 'templates/partial/post-digest.html';
	var html = "<img ng-src={{user.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{user.name}}</h3> <p style=font-size:14px;font-weight:400> {{moment(post.timestamp).format('YYYY年MM月DD日 hh:mm')}}</p> <p style=font-weight:lighter;color:#000> {{post.text | ellipsis}} </p> <a class=link style=\"\" ng-click=moveToPost(post)>投稿ページへ</a> <div class=reactions layout=row style=margin-top:5px> <span class=image-count style=margin-right:10px> <i class=material-icons>camera_alt</i> {{post.imageCount()}} </span> <span class=comment-count style=margin-right:10px> <i class=material-icons>chat</i> {{post.commentCount()}} </span> <span class=like-count style=margin-right:10px> <img ng-src=resources/img/like.png /> {{post.likeCount()}} </span> </div> </div> <md-divider></md-divider> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var path = 'templates/partial/post.html';
	var html = "<md-card-header> <md-card-avatar> <img class=user-avatar ng-src={{user.avatar}} onerror='\"error.jpg\"!=this.src&&(this.src=\"./resources/img/person.svg\")' open-profile=user /> </md-card-avatar> <md-card-header-text> <span class=md-title> <span class=link style=font-weight:700 open-profile=user>{{user.name}}</span> </span> <span ng-if=!post.sticky class=md-subhead>{{moment(post.timestamp).fromNow()}}</span> <span ng-if=post.sticky class=md-subhead>固定された投稿</span> </md-card-header-text> </md-card-header> <md-card-content> <ng-switch on=post.category> <span class=\"post-type showcase\" ng-switch-when=showcase>資料紹介</span> <span class=\"post-type seeking\" ng-switch-when=seeking>情報求ム！</span> <span class=\"post-type question\" ng-switch-default>質問</span> </ng-switch> <p class=text style=\"font-size:14px;margin:8px 0\" ng-bind-html=\"post.text | stripTags | linky:'_blank'| lb2br  | trust\"></p> <div class=images style=display:block> <img ng-repeat=\"id in post.images\" ng-src=https://res-4.cloudinary.com/doyeq9idz/image/upload/c_thumb/{{id}}.jpg ng-click=openPhotoModal(id) class=clickable style=margin:1px;max-width:48%;display:inline-box /> </div> <div class=actions layout=row> <a class=like ng-class=\"{liked : post.likedByCurrentUser()}\" ng-if=\"currentUser.uid != post.uid\" ng-click=post.toggleLike()> <img ng-src=resources/img/like.png /> あっぱれ！ </a> <span flex></span> <a class=remove ng-if=post.isCreatedBy(currentUser) ng-click=\"removePost(post, $event)\">この投稿を削除</a> </div> <div class=comments style=\"margin:5px -16px -16px;padding:10px;background-color:#f6f7f9\"> <div class=info style=display:block> <span class=comment-count style=margin-right:10px> <i class=material-icons>chat</i> {{post.commentCount()}}</span> <span class=comment-count style=margin-right:10px open-likes=post.likes> <img ng-src=resources/img/like.png /> {{post.likeCount()}}</span> </div> <hr/> <a class=action ng-if=\"objSize(post.comments) > (post.visibleCommentCount || 3)\" ng-click=showMoreComments(post)> 以前のコメントを読み込む </a> <a class=action ng-if=!isSinglePage ui-sref=\"dashboard.post({post_id: post.$id})\"> すべて読む </a> <div class=comment ng-repeat=\"(key, comment) in post.comments track by $index\" ng-init=\"user = users.get(comment.uid)\" ng-if=\"objSize(post.comments)-$index <= (post.visibleCommentCount || 3)\" ng-include=\"'templates/partial/comment.html'\" layout=row> </div> <form class=reply-form layout=column ng-init=\"post.newComment={}\"> <div class=\"\" layout=row> <img class=user-avatar ng-src={{currentUser.avatar}} /> <textarea flex placeholder=コメントを入力... ng-model=post.newComment.text ng-keyup=handleKeyup($event) rows=2>\n        </textarea> <div layout=column> <md-button class=\"md-icon-button md-primary\" ng-click=sendComment(post)> <md-tooltip>コメントを送信</md-tooltip> <i class=material-icons>send</i> </md-button> <md-button class=\"md-icon-button launch\" multiple=multiple accept=image/* ngf-select=\"selectCommentFiles($files, post)\" ng-disabled=\"post.newComment.images.length >= 2\" ngf-multiple=true> <md-tooltip>写真を添付（2枚まで）</md-tooltip> <i class=material-icons>camera_alt</i> </md-button> </div> </div> </form> <div class=images-wrapper layout=row style=\"margin:15px 0 0 30px\" ng-if=post.newComment.images.length> <div ng-repeat=\"img in post.newComment.images\" style=position:relative> <img class=clickable ngf-thumbnail=img style=margin:5px;max-width:100px;height:100px;display:inline-box ng-click=openThumbnailModal(img) /> <md-button ng-click=post.newComment.images.splice($index,1) aria-label=\"remove this image\" style=position:absolute;top:-15px;right:-15px class=\"md-icon-button launch\"> <md-tooltip>写真を削除</md-tooltip> <md-icon>close</md-icon> </md-button> </div> </div> </div> </md-card-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	var path = 'templates/partial/quake.html';
	var html = "<img ng-src=./resources/img/quake.png class=md-avatar /> <div class=md-list-item-text> <h3><b> <span ng-if=quake.getName()>［{{quake.getName()}}］</span> {{quake.getDateString()}}（{{quake.getDateJP()}}） </b></h3> <p> 地域：{{quake.data.region}}<br> <span ng-if=quake.data.magnitude> マグニチュード：{{quake.data.magnitude}} </span> </p> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	var path = 'templates/partial/sidenav.html';
	var html = "<h2>{{ 'sidenav.introduction' | translate}}</h2> <md-button ui-sref-active=md-primary ui-sref=dashboard.home class=block> <md-icon class=material-icons>home</md-icon> {{ 'sidenav.home' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=dashboard.introduction class=block> <md-icon class=material-icons>info_outline</md-icon> {{ 'sidenav.greetings' | translate}} </md-button> <md-button ui-sref-active=md-primary ng-click=openLinksDialog() class=block> <md-icon class=material-icons>thumb_up</md-icon> {{ 'sidenav.blogs' | translate}} </md-button> <md-divider></md-divider> <h2>{{ 'sidenav.transcribe' | translate}}</h2> <md-button ui-sref-active=md-primary ui-sref=dashboard.guideline class=block> <md-icon class=material-icons>chrome_reader_mode</md-icon> {{ 'sidenav.guideline' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 9})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage9' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 8})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage8' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 7})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage7' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 6})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage6' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 5})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage5' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 4})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage4' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 3})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage3' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 2})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage2' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=\"dashboard.entries({stage: 1})\" class=block> <md-icon class=material-icons>search</md-icon> {{ 'sidenav.stage1' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=dashboard.personal.fav-list class=block> <md-icon class=material-icons>star</md-icon> {{ 'sidenav.history' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=dashboard.forum class=block> <md-icon class=material-icons>chat</md-icon> {{ 'sidenav.forum' | translate}} </md-button> <md-divider></md-divider> <h2>{{ 'sidenav.learn-kuzushiji' | translate}}</h2> <md-button ui-sref-active=md-primary ui-sref=dashboard.learn class=block> <md-icon class=material-icons>school</md-icon> {{ 'sidenav.learn' | translate}} </md-button> <md-button ui-sref-active=md-primary ui-sref=dashboard.connect class=block> <md-icon class=material-icons>public</md-icon> {{ 'sidenav.connect' | translate}} </md-button> <md-divider></md-divider> <md-button ui-sref-active=md-primary ui-sref=dashboard.credit class=block> <md-icon class=material-icons>group</md-icon> {{ 'sidenav.license' | translate}} </md-button> <md-button ng-click=openSupportDialog() class=block> <md-icon class=material-icons>contact_phone</md-icon> {{ 'sidenav.contact' | translate }} </md-button> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	var path = 'templates/partial/timeline_event.html';
	var html = "<md-card-header> <span class=\"tag bg-assertive\" ng-if=event.requestReview>添削希望</span> <md-card-avatar> <img class=md-avatar ng-src={{user.avatar}} err-src=resources/img/person.svg open-profile=user /> </md-card-avatar> <md-card-header-text> <span class=md-title><b open-profile=user>{{user.name}}</b>さんが<span ng-if=event.diffCount>{{event.diffCount}}文字</span>翻刻しました</span> <span class=md-subhead>{{moment(event.timestamp).fromNow()}} <span ng-if=\"event.likeCount() >0\" open-likes=event.likes> <img style=width:24px;height:24px;display:inline ng-src=resources/img/like.png /> {{event.likeCount()}} </span> </span> </md-card-header-text> </md-card-header> <md-card-content ng-if=event.comment style=\"padding:5px 16px\"> {{event.comment}} </md-card-content> <div class=page-info layout=row> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1, ref: currentPath})\" class=thumb flex=30> <img ng-src=./resources/img/thumbnails/{{book.$id}}.min.jpg> </a> <div class=content layout=column flex=70> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1, ref: currentPath})\"> {{book.title}}―コマ{{event.content+1}} </a> <p>{{event.text.trim().substring(0,50) | htmlToPlainText}}...</p> </div> </div> <div class=actions> <a class=like ng-class=\"{liked : event.likedByCurrentUser()}\" ng-if=\"currentUser.uid != event.uid\" ng-click=event.toggleLike()> <img ng-src=resources/img/like.png /> あっぱれ！ </a> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	var path = 'templates/partial/timeline_event_en.html';
	var html = "<md-card-header> <span class=\"tag bg-assertive\" ng-if=event.requestReview>Review me</span> <md-card-avatar> <img class=md-avatar ng-src={{user.avatar}} err-src=resources/img/person.svg open-profile=user /> </md-card-avatar> <md-card-header-text> <span class=md-title><b open-profile=user>{{user.name}}</b> transcribed <span ng-if=event.diffCount>{{event.diffCount}} characters</span></span> <span class=md-subhead>{{moment(event.timestamp).lang('en').fromNow()}} <span ng-if=\"event.likeCount() >0\" open-likes=event.likes> <img style=width:24px;height:24px;display:inline ng-src=resources/img/like.png /> {{event.likeCount()}} </span> </span> </md-card-header-text> </md-card-header> <md-card-content ng-if=event.comment style=\"padding:5px 16px\"> {{event.comment}} </md-card-content> <div class=page-info layout=row> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1, ref: currentPath})\" class=thumb flex=30> <img ng-src=./resources/img/thumbnails/{{book.$id}}.min.jpg> </a> <div class=content layout=column flex=70> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1, ref: currentPath})\"> {{book.title}}: Image {{event.content+1}} </a> <p>{{event.text.trim().substring(0,50) | htmlToPlainText}}...</p> </div> </div> <div class=actions> <a class=like ng-class=\"{liked : event.likedByCurrentUser()}\" ng-if=\"currentUser.uid != event.uid\" ng-click=event.toggleLike()> <img ng-src=resources/img/like.png /> Like </a> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var path = 'templates/partial/user-menu-buttons.html';
	var html = "<md-menu md-position-mode=\"target-right target\" style=z-index:999999> <md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-class=\"{active : hasNotifications}\" aria-label={{currentUser.name}} style=padding:0> <md-tooltip>{{currentUser.name}}</md-tooltip> <img class=\"\" style=\"width:40px;height:40px;padding:0;display:inline-block;background-repeat:no-repeat no-repeat;pointer-events:none\" ng-src={{currentUser.avatar}} /> </md-button> <md-menu-content width=4> <md-menu-item> <md-button ng-click=editProfile()> <div layout=row flex> <md-icon class=material-icons style=\"margin:auto 3px auto 0\">person</md-icon> {{ 'header.profile' | translate}} </div> </md-button> </md-menu-item> <md-divider></md-divider> <md-menu-item> <md-button> <div layout=row flex ng-click=logout()> <md-icon class=material-icons style=\"margin:auto 3px auto 0\">exit_to_app</md-icon> {{ 'header.signout' | translate}} </div> </md-button> </md-menu-item> </md-menu-content> </md-menu> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	var path = 'templates/partial/user_status.html';
	var html = "<md-card ng-controller=UserStatusCtrl class=user-status> <md-card-title style=padding-bottom:0> <md-card-title-text> <span class=md-headline>{{currentUser.name}}</span> <span class=md-subhead>{{currentUser.profile}}</span> <div class=status> <p> <img ng-src=./resources/img/diamond.png> {{currentUser.gemCount || 0}}/70 </p> <p><img ng-src=resources/img/like.png> {{currentUser.likesCount || 0}}</p> <p><img ng-src=./resources/img/pencil.png> {{currentUser.charCount || 0}}文字</p> </div> </md-card-title-text> <md-card-title-media> <img class=md-card-image style=max-width:150px;margin:5px ng-src={{currentUser.avatar}}> </md-card-title-media> </md-card-title> <div class=md-padding style=padding-top:0> <p style=text-align:center;margin:0> レベル {{currentUser.currentLevel || 1}}</p> <md-progress-linear md-mode=determinate value={{levelProgress}}> </md-progress-linear> <p style=text-align:center> {{pointsInCurrentLevel}}pt / {{levelPoints}}pt </p> </div> <md-card-actions layout=row layout-align=\"end center\"> </md-card-actions> </md-card> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	var path = 'templates/personal.html';
	var html = "<md-content flex=100 style=height:100% class=\"entries md-padding\"> <md-nav-bar md-selected-nav-item=selectedNavItem nav-bar-aria-label=\"navigation links\"> <md-nav-item md-nav-click=\"switchNavItem('fav-list')\" name=fav-list> お気に入り </md-nav-item> <md-nav-item md-nav-click=\"switchNavItem('history')\" name=history> 作業履歴 </md-nav-item> </md-nav-bar> <div class=md-padding ui-view></div> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	var path = 'templates/post-single.html';
	var html = "<md-content flex=60 class=\"connect md-padding\" style=height:100%> <md-card class=post ng-init=\"user = users.get(post.uid)\" style=display:block ng-include=\"'templates/partial/post.html'\"> </md-card> </md-content> <md-content flex=40 class=md-padding ng-include=\"'templates/partial/user_status.html'\"> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	var path = 'templates/quakes.html';
	var html = "<md-content flex=60 class=\"credit md-padding\"> <md-whiteframe class=\"md-whiteframe-2dp quakes md-padding\" style=display:block;background:#fff> <h1>江戸時代以前に日本で発生した地震</h1> <p>出典：国立天文台編『理科年表』</p> <md-list> <md-subheader class=\"md-no-sticky md-primary\">古墳・飛鳥時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year < 710\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> <md-subheader class=\"md-no-sticky md-primary\">奈良時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 710 && quake.date.year < 794\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> <a id=heian></a> <md-subheader class=\"md-no-sticky md-primary\">平安時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 794 && quake.date.year < 1185\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> <md-subheader class=\"md-no-sticky md-primary\">鎌倉時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 1185 && quake.date.year < 1333\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> <md-subheader class=\"md-no-sticky md-primary\">室町時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 1333 && quake.date.year < 1573\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> </md-list> <md-subheader class=\"md-no-sticky md-primary\">安土桃山時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 1573 && quake.date.year < 1603\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item> <md-subheader class=\"md-no-sticky md-primary\">江戸時代</md-subheader> <md-list-item class=\"md-3-line quake-event\" style=margin-bottom:18px ng-repeat=\"quake in quakes\" ng-if=\"quake.date.year >= 1603\" ng-include=\"'templates/partial/quake.html'\"> </md-list-item>   </md-whiteframe> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	var path = 'templates/timeline.html';
	var html = "<md-content flex class=home layout=row style=height:100%> <md-content class=md-padding style=\"\"> <md-card class=timeline-event ng-repeat=\"event in timeline | orderBy: '-timestamp'\" ng-init=\"user=Users.get(event.uid); book=Books.get(event.bookId)\"> <md-card-header> <md-card-avatar> <img class=md-avatar ng-src={{user.avatar}} /> </md-card-avatar> <md-card-header-text> <span class=md-title>{{user.name}} transcribed <span ng-if=event.diffCount>{{event.diffCount}} characters</span></span> <span class=md-subhead>{{moment(event.timestamp).fromNow()}}</span> </md-card-header-text> </md-card-header> <md-card-content ng-if=event.comment style=\"padding:5px 16px\"> {{event.comment}} </md-card-content> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1})\"> <img ng-src=./resources/img/thumbnails/{{book.$id}}.min.jpg class=md-card-image> </a> <md-card-title> <md-card-title-text> <span class=md-headline> <a ui-sref=\"transcription.content.view({id: book.$id, content:event.content+1})\"> {{book.title}} ― Image {{event.content+1}} </a> </span> </md-card-title-text> </md-card-title> </md-card> </md-content> <div flex></div> <md-sidenav style=width:260px;height:100% class=\"md-sidenav-right sidenav\" md-component-id=right md-is-locked-open=true md-whiteframe=2> <md-content layout=column class=ranking> <h1 style=margin-top:10px>Leaderboard</h1> <md-list class=md-dense> <md-list-item class=md-2-line ng-repeat=\"user in charRanking | orderBy: 'user.charCount':true\"> <span>{{$index+1}}.</span> <img onerror='\"error.jpg\"!=this.src&&(this.src=\"./resources/img/person.svg\")' ng-src={{user.avatar}} open-profile=user class=md-avatar style=margin-top:0;margin-right:8px /> <div class=detail> <p class=name open-profile=user style=margin:0;padding:0> {{user.name || \"名前なし\"}}</p> <span class=\"count color-sub\">{{user.charCount || 0}} chars</span> </div> </md-list-item> </md-list> </md-content> </md-sidenav> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	var path = 'templates/transcription.html';
	var html = "<div class=transcription style=height:100%;width:100% layout=column> <md-toolbar clas=header layout=row style=\"height:50px;min-height:50px;box-shadow:0 0 10px 0 rgba(0,0,0,.7)\"> <div class=md-toolbar-tools style=height:50px ng-cloak> <md-button class=md-icon-button ng-click=goBack()> <md-tooltip md-direction=bottom>{{'transcription.back' | translate}}</md-tooltip> <md-icon>reply</md-icon> </md-button> <span><h1>{{book.title}}</h1></span> <md-button class=\"md-icon-button fav-button\" ng-click=toggleFav() ng-class=\"{active: fav.$value}\"> <md-tooltip md-direction=bottom>{{'transcription.add-to-fav' | translate}}</md-tooltip> <md-icon>star_rate</md-icon> </md-button> <span flex></span> <span> <md-button class=md-icon-button aria-label=Left ui-sref=\"transcription.content.view({id: id, content: content+1})\" ng-disabled=\"content >=book.images.length\"> <md-tooltip>{{'transcription.next-image' | translate}}</md-tooltip> <md-icon class=material-icons>keyboard_arrow_left</md-icon> </md-button> </span> <span ui-view=content_status> </span> <span> <md-button class=md-icon-button aria-label=Right ui-sref=\"transcription.content.view({id: id, content: content-1})\" ng-disabled=\"content<=1\"> <md-tooltip>{{'transcription.previous-image' | translate}}</md-tooltip> <md-icon class=material-icons>keyboard_arrow_right</md-icon> </md-button> </span> <span flex></span> <span style=text-align:right ui-view=action_buttons></span> <span class=badge-container> <md-button class=\"notification-btn md-icon-button\" ng-click=showNotifications()> <md-tooltip>{{'transcription.notifications' | translate}} ({{notifications.getUnreadCount()}})</md-tooltip> <md-icon>notifications</md-icon> </md-button> <span ng-if=notifications.getUnreadCount() class=badge>{{notifications.getUnreadCount()}}</span> </span> <span ng-include=\"'templates/partial/user-menu-buttons.html'\"> </span></div> </md-toolbar> <md-content layout=row style=height:100%> <md-content class=editor layout=column flex=50 ui-view=content> </md-content> <div id=openseadragon-viewer flex=50 class=\"\" style=position:relative> </div> <span ng-if=\"book.stage <= 9\" style=position:absolute;bottom:3px;right:3px> {{'transcription.eri' | translate}} </span> </md-content> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/action_buttons.html';
	var html = "<md-button class=\"md-raised md-warn md-mini\" ng-click=startTranscribing($ev) ng-if=!transcription.isEditingByCurrentUser() ng-disabled=!transcription.isEditable()> <md-tooltip>{{'transcription.transcribe' | translate}}</md-tooltip> <md-icon>create</md-icon> {{'transcription.edit' | translate}} </md-button> <md-button class=\"md-warn md-raised md-mini\" ng-click=completeTranscription($ev) ng-if=transcription.isEditingByCurrentUser()> <md-tooltip>{{'transcription.save-message' | translate}}</md-tooltip> <md-icon>done</md-icon> {{'transcription.save' | translate}} </md-button> <md-button class=\"md-hue-2 md-raised md-mini\" ng-click=discardTemp() ng-if=transcription.isEditingByCurrentUser()> <md-tooltip>{{'transcription.discard-message' | translate}}</md-tooltip> <md-icon>delete</md-icon> {{'transcription.discard' | translate}} </md-button> <md-button class=\"md-raised md-mini\" ng-click=freeze() ng-if=\"currentUser.isAdmin() && !transcription.isFrozen()\"> <md-tooltip>一般編集者の編集を禁止します（管理者のみ）</md-tooltip> <md-icon>block</md-icon> 保護 </md-button> <md-button class=\"md-raised md-mini\" ng-click=unfreeze() ng-if=\"currentUser.isAdmin() && transcription.isFrozen()\"> <md-tooltip>保護状態を解除します（管理者のみ）</md-tooltip> <md-icon>block</md-icon> 保護解除 </md-button> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/confirm_dialog.html';
	var html = "<md-dialog class=confirm-dialog aria-label=編集を終了> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>編集を終了</h2> <span flex></span> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div class=balloon style=width:400px> この内容で保存していいかな？<br/> すべての文字が翻刻できていたら「<b>翻刻完了</b>」にチェックをつけてね。 読めない箇所が残っていても大丈夫！ <br><b>編集コメント</b>を記入しておくと、後の人の助けになるかも！ </div> <img ng-src=./resources/img/shimimaru/07.png style=\"width:100px;display:block;margin:0 auto\"/> <div laout=column> <textarea ng-model=comment md-autofocus style=\"width:95%;display:block;margin:5px auto\" placeholder=編集コメントを入力... rows=3></textarea> <md-checkbox ng-model=finished aria-label=\"post on timeline\" style=\"width:95%;display:block;margin:5px auto\"> 翻刻完了 </md-checkbox> <md-checkbox ng-model=shared aria-label=\"post on timeline\" style=\"width:95%;display:block;margin:5px auto\"> タイムラインで共有 </md-checkbox> <md-checkbox ng-model=requestReview aria-label=\"ask for review\" style=\"width:95%;display:block;margin:5px auto\"> 添削希望（他の参加者に翻刻文の添削をお願いします） </md-checkbox> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button md-autofocus ng-click=cancel()> キャンセル </md-button> <span flex></span> <md-button class=md-primary ng-click=submit()> 保存 </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/content.html';
	var html = "<md-nav-bar style=width:100% md-selected-nav-item=childState nav-bar-aria-label=navigation> <md-nav-item md-nav-sref=.view name=view>{{'transcription.view' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.input name=input>{{'transcription.input' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.notes name=notes>{{'transcription.notes' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.history name=history>{{'transcription.history' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.legends name=legends>{{'transcription.guide' | translate}}</md-nav-item> </md-nav-bar> <div ui-view flex style=background:#fff> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/content_status.html';
	var html = "<div class=content-status> <div class=content-count> <select ng-model=contentIndex ng-change=changeIndex() style=width:50px> <option ng-repeat=\"t in transcriptions\" value={{$index+1}}> {{$index+1}}（{{t.getCurrentState().label}}） </option> </select> /{{book.size}} {{'transcription.images' | translate}} </div> <div class=current-status> <span class=md-secondary> {{transcription.getCurrentState().label}} <span ng-if=transcription.isFrozen()>（保護中）</span> <i ng-if=transcription.realtimeMode style=font-size:16px;vertical-align:middle class=material-icons title=リアルタイム編集中>watch_later</i> </span> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/diff_dialog.html';
	var html = "<md-dialog class=diff-dialog aria-label=差分> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>編集履歴 - {{moment(event.timestamp).format(\"YYYY-MM-DD HH:mm:ss\")}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=close()> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content ng-bind-html=diffHtml> </md-dialog-content> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/finishing_dialog.html';
	var html = "<md-dialog aria-label=おつかれさま！> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>おつかれさま！</h2> <span flex></span> <md-button class=md-icon-button ng-click=close()> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div class=balloon> 今回翻刻した文字数は <span style=font-weight:700;color:#00f>{{diffCount}}文字</span> だよ。結果をシェアして自慢しよう！<br> </div> <img ng-src=./resources/img/shimimaru/07.png style=\"width:100px;display:block;margin:0 auto\"/> <div layout=row style=\"display:block;margin:0 auto;text-align:center\"> <md-button class=md-raised socialshare socialshare-provider=twitter socialshare-text={{diffCount}}文字翻刻しました！ socialshare-hashtags=\"みんなで翻刻, 歴史地震\" socialshare-url=http://honkoku.org style=background-color:#00e5ff;color:#fff> Twitter </md-button> <md-button class=\"md-primary md-raised\" socialshare socialshare-provider=facebook socialshare-text={{diffCount}}文字翻刻しました！ socialshare-hashtags=\"みんなで翻刻, 歴史地震\" socialshare-url=http://honkoku.org> Facebook </md-button> <md-button class=\"md-warn md-raised\" socialshare socialshare-provider=google socialshare-text={{diffCount}}文字翻刻しました！ socialshare-hashtags=\"みんなで翻刻, 歴史地震\" socialshare-url=http://honkoku.org> Google+ </md-button> </div> <div layout=row style=\"display:block;margin:0 auto;text-align:center\"> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button md-autofocus ng-click=close() style=display:block;margin:auto> 閉じる </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/history.html';
	var html = "<md-content style=height:100%;background:#fff class=history> <p ng-if=!timeline.length style=margin:auto;padding:10px>このコマはまだ編集されていません</p> <md-list class=md-dense style=background:#fff;padding:0> <md-list-item ng-repeat=\"event in timeline | orderBy:'-timestamp'\" ng-init=\"user = users.get(event.uid)\" style=\"padding:12px 7px 5px\" class=md-3-line> <span style=position:absolute;top:5px;right:5px;line-height:15px;font-size:13px ng-if=event.requestReview class=\"tag bg-assertive\">{{'transcription.review-me' | translate}}</span> <img ng-src={{user.avatar}} class=md-avatar err-src=resources/img/person.svg /> <div class=md-list-item-text> <h3 open-profile=user class=color-positive>{{user.name}}</h3> <p class=comment>{{event.comment}}</p> <p class=color-sub> {{moment(event.timestamp).format(\"YYYY-MM-DD HH:mm\")}} - {{event.diffCount}}{{'transcription.chars' | translate}} <span ng-if=\"event.likeCount() >0\" open-likes=event.likes> <img style=width:20px;height:20px;display:inline ng-src=resources/img/like.png /> {{event.likeCount()}} </span> </p> <div class=actions> <a class=like ng-class=\"{liked : event.likedByCurrentUser()}\" ng-if=\"currentUser.uid != event.uid\" ng-click=event.toggleLike()> <img ng-src=resources/img/like.png /> {{'transcription.like' | translate}} </a> <a class=like ng-click=\"showDiff(event.$id, $event)\"> <i class=material-icons style=vertical-align:middle;font-size:21px>remove_red_eye</i> {{'transcription.revision' | translate}} </a> </div> </div> <md-divider></md-divider> </md-list-item> </md-list> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/input.html';
	var html = " <md-content style=height:100% flex layout-padding contenteditable=false class=\"input noedit\" ng-if=\"!transcription.isEditingByCurrentUser() && !transcription.realtimeMode\" ng-model=transcription.text> </md-content> <md-content flex layout-padding contenteditable=false class=\"input noedit\" ng-if=\"!transcription.isEditingByCurrentUser() && transcription.realtimeMode\" ng-model=transcription.tempText> </md-content> <md-content flex layout-padding contenteditable=true layout-align=\"end center\" class=input id=transcription-input strip-tags=true ng-model=transcription.tempText ng-change=handleChange()> <div></div> </md-content> <div layout=column class=insert-buttons ng-if=transcription.isEditingByCurrentUser() style=position:absolute;bottom:5px> <md-button class=\"md-fab md-raised\" ng-click=insertRuby($event) md-direction=top ng-if=showActionButtons> <md-tooltip>選択領域にルビを挿入します</md-tooltip> ルビ </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertOdoriji($event) md-direction=top ng-if=showActionButtons> <md-tooltip> 選択箇所に踊り字を挿入します（続けて押すと種類が変化します） </md-tooltip> 踊り字 </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertFreq($event) ng-if=showActionButtons> <md-tooltip md-direction=top> 選択箇所に頻出文字を挿入します（続けて押すと種類が変化します） </md-tooltip> 頻出 </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertNote($event) ng-if=showActionButtons> <md-tooltip md-direction=top>選択領域に注記やコメントを挿入します</md-tooltip> 注記 </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertWarigaki($event) ng-if=showActionButtons> <md-tooltip md-direction=top>選択領域に割書を挿入します</md-tooltip> 割書 </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertHako($event) ng-if=showActionButtons> <md-tooltip md-direction=top>選択領域を箱で囲みます</md-tooltip> 箱 </md-button> <md-button class=\"md-fab md-raised\" ng-click=insertKunten($event) ng-if=showActionButtons> <md-tooltip md-direction=top>選択箇所に送り仮名か返り点を挿入します（続けて押すと種類が変化します）</md-tooltip> 訓点 </md-button> <md-button class=md-fab ng-click=toggleActionButtons()> <md-tooltip md-direction=top>特殊記法ボタンを表示／非表示</md-tooltip> <md-icon>menu</md-icon> </md-button> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/legends.html';
	var html = "<md-content ui-view flex layout-padding class=\"vertical-editor legends md-padding\" style=width:100%;box-sizing:content-box;padding-bottom:15px> <h2>ルビ</h2> <p>ルビは、漢字の後に全角の丸括弧を挿入することで入力します。漢字が連続している場合は、区切りを示すために文字の間に全角のパイプ（｜）か半角スペースを挿入して下さい。</p> <h3>入力例</h3> <p>◯嘉永七年寅の十一月｜諸国（しょこく）大｜地（ち）しんの巨細を…</p> <h3>出力</h3> <p>◯嘉永七年寅の十一月 <ruby><rb>諸国</rb><rt>しょこく</rt></ruby>大<ruby><rb>地</rb><rt>ち</rt></ruby>しんの巨細を… </p> <p>ルビを振るには、次の記法も利用できます。この記法を使うと、漢字以外の文字にもルビを振ることができます。</p> <p>◯嘉永七年寅の十一月《ルビ：諸国｜しょこく》大《ルビ：地｜ち》しんの巨細を…</p> <h2>返り点・送り仮名</h2> <p>漢文で利用される送り仮名は、文字を大括弧（［］）で囲むことで入力します。返り点は、中括弧（｛｝）で囲むことで入力します。返り点と訓点送り仮名が、同一の字間に置かれているときは、送り仮名を先、返り点を後に書いてください。</p> <h3>入力例</h3> <p>低［レテ］｛レ｝頭［ヲ］思［フ］｛ニ｝故郷［ヲ］｛一｝</p> <h3>出力</h3> <p>低<span class=okuri>レテ</span><span class=kaeriten>レ</span>頭<span class=okuri>ヲ</span>思<span class=okuri>フ</span><span class=kaeriten>ニ</span>故郷<span class=okuri>ヲ</span><span class=kaeriten>一</span></p> <h2>割書き</h2> <p>割書きは、次の記法で記述します。<br><b>《割書：割書の一行目｜割書きの二行目》</b></p> <h3>入力例</h3> <p>《割書：むかしむかし｜あるところに》おじいさんとおばあさんが…</p> <h3>出力</h3> <p><span class=warigaki> <span class=warigaki-right>&#12354;&#12427;&#12392;&#12371;&#12429;&#12395;</span> <span class=warigaki-left>&#12416;&#12363;&#12375;&#12416;&#12363;&#12375;</span> </span>おじいさんとおばあさんが…</p> <h2>注記</h2> <p>内容や読み方に関する注記は、墨付き括弧（【】）の中に入力します。注記は赤文字で表示され、最終出力時には削除されます。</p> <h3>入力例</h3> <p>この部分に【注記が入ります】。</p> <h3>出力</h3> <p>この部分に<span class=comment>（注記が入ります）</span>。</p> <h2>不明瞭な文字</h2> <p>文字の読み方に自信が持てないときは、文字の後に全角の「？」を記入しておきましょう。読めない箇所が複数文字にわたる時は、次の記法で記述します。<br> <b>《？：ここに読めない文字を入力》</b> </p> <h3>入力例</h3> <p>吉原は町家在郷？ともゆりくづれ《？：富士川》は津浪にて…</p> <h3>出力</h3> <p>吉原は町家在<span class=dubious>郷</span>ともゆりくづれ<span class=dubious>富士川</span>は津浪にて…</p> <h2>判読できない文字</h2> <p>まったく判読できない文字（虫損箇所など）は、四角（□）を置きます。</p> <h3>入力例</h3> <p>吉原は町家在□ともゆりくづれ□□□は津浪にて…</p> <h3>出力例</h3> <p>吉原は町家在<span class=dubious>□</span>ともゆりくづれ<span class=dubious>□□□</span>は津浪にて…</p> <br><br> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/message-toast.html';
	var html = "<md-toast class=message-toast ng-init=\"user = users.get(msg.uid)\"> <div class=user-info> <img class=user-avatar ng-src={{user.avatar}} style=\"\"/> <span class=name> {{user.name}} </span> </div> <div class=content> <span> {{msg.text}} </span> </div> </md-toast> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/notes.html';
	var html = "<md-content style=height:100%> <p ng-if=!notes.length style=margin:auto;padding:10px>このコマにはまだノートがありません</p> <md-list class=md-dense> <md-list-item ng-repeat=\"n in notes | orderBy:'-timestamp'\" ng-init=\"user = users.get(n.uid)\"> <img ng-src={{user.avatar}} class=md-avatar /> <div class=md-list-item-text> <h3>{{user.name}}</h3> <p>{{n.text}}</p> <p>{{moment(n.timestamp).fromNow()}}</p> </div> </md-list-item> </md-list> </md-content> <md-button ng-click=addNote($event) class=md-fab style=position:absolute;bottom:15px;right:5px> <md-tooltip md-direction=top> ノートを追加</md-tooltip> <md-icon>note_add</md-icon> </md-button> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/starting_dialog.html';
	var html = "<md-dialog aria-label=翻刻をはじめる> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>翻刻をはじめる</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div class=balloon style=width:360px> さあ翻刻を始めよう！<br/><font color=blue>「ライブ編集」</font>にチェックをつけると、他のユーザーにも編集過程が見えるようになるよ。授業や研究会で活用してね。<br/> 翻刻文は3秒おきに自動保存されるから、途中で他のページに移動しても大丈夫だよ。 </div> <img ng-src=./resources/img/shimimaru/04.png style=\"width:100px;display:block;margin:0 auto\"/> </div> <div style=text-align:center> <md-checkbox ng-model=realtimeMode> ライブ編集 </md-checkbox> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button md-autofocus ng-click=cancel() class=md-raised> キャンセル </md-button> <span flex></span> <md-button md-autofocus ng-click=start() class=\"md-raised md-primary\"> 翻刻を開始 </md-button> </md-dialog-actions> </form> </md-dialog> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	var path = 'templates/transcription/view.html';
	var html = "<md-content class=\"viewer vertical-editor\" style=height:100% ng-bind-html=viewHtml> </md-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/person.svg";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/title-header.svg";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/shimimaru.png";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/comp_stamp.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/diamond.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/diamond_inactive.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/pencil.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/quake.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/download_ios.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/download_android.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/chrome.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./resources/img/firefox.png";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	var config = {
	  apiKey: "AIzaSyCH_iWQnboGxikkqiQVVo6pV7LJHQRknjM",
	  authDomain: "kojishin-fce4e.firebaseapp.com",
	  databaseURL: "https://kojishin-fce4e.firebaseio.com",
	  storageBucket: "",
	};
	firebase.initializeApp(config);


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/*
	 * angular-socialshare
	 * 2.2.9
	 * 
	 * A social media url and content share module for angularjs.
	 * http://720kb.githb.io/angular-socialshare
	 * 
	 * MIT license
	 * Mon Sep 19 2016
	 */
	!function(e){"use strict";var o="socialshare",i="Socialshare",t=["facebook","facebook-messenger","sms","twitter","linkedin","google","pinterest","tumblr","reddit","stumbleupon","buffer","digg","delicious","vk","pocket","wordpress","flipboard","xing","hackernews","evernote","whatsapp","telegram","viber","skype","email","ok"],a=function(){var o=[{provider:"email",conf:{subject:"",body:"",to:"",cc:"",bcc:"",trigger:"click"}},{provider:"facebook",conf:{url:"",text:"",media:"",type:"",via:"",to:"",from:"",ref:"",display:"",source:"",caption:"",redirectUri:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"facebook-messenger",conf:{url:""}},{provider:"twitter",conf:{url:"",text:"",via:"",hashtags:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"linkedin",conf:{url:"",text:"",description:"",source:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"reddit",conf:{url:"",text:"",subreddit:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"vk",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"ok",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"digg",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"delicious",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"stumbleupon",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pinterest",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"google",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"tumblr",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"buffer",conf:{url:"",text:"",via:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"pocket",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"flipboard",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"hackernews",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"wordpress",conf:{url:"",text:"",media:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"xing",conf:{url:"",text:"",media:"",follow:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"evernote",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"whatsapp",conf:{url:"",text:""}},{provider:"sms",conf:{text:"",to:"",trigger:"click"}},{provider:"telegram",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}},{provider:"viber",conf:{url:"",text:""}},{provider:"skype",conf:{url:"",text:"",trigger:"click",popupHeight:600,popupWidth:500}}];return{configure:function(i){var a,r,s,h,c=0,p=0,n=e.injector(["ng"]).get("$log");if(i&&i.length>0)for(;c<i.length;c+=1)if(i[c].provider&&t.indexOf(i[c].provider)>-1){for(;p<o.length;p+=1)if(h=o[p],h&&h.provider&&i[c].provider===h.provider){for(a=Object.keys(h.conf),r=0;r<a.length;r+=1)s=a[r],s&&i[c].conf[s]&&(h.conf[s]=i[c].conf[s]);p=0;break}}else n.warn("Invalid provider at element "+c+" with name:"+i[c].provider)},$get:function(){return o}}},r=function(e,o){var i;o.socialshareType&&"feed"===o.socialshareType?(i="https://www.facebook.com/dialog/feed?",o.socialshareVia&&(i+="&app_id="+encodeURIComponent(o.socialshareVia)),o.socialshareRedirectUri&&(i+="&redirect_uri="+encodeURIComponent(o.socialshareRedirectUri)),o.socialshareUrl&&(i+="&link="+encodeURIComponent(o.socialshareUrl)),o.socialshareTo&&(i+="&to="+encodeURIComponent(o.socialshareTo)),o.socialshareDisplay&&(i+="&display="+encodeURIComponent(o.socialshareDisplay)),o.socialshareRef&&(i+="&ref="+encodeURIComponent(o.socialshareRef)),o.socialshareFrom&&(i+="&from="+encodeURIComponent(o.socialshareFrom)),o.socialshareDescription&&(i+="&description="+encodeURIComponent(o.socialshareDescription)),o.socialshareText&&(i+="&name="+encodeURIComponent(o.socialshareText)),o.socialshareCaption&&(i+="&caption="+encodeURIComponent(o.socialshareCaption)),o.socialshareMedia&&(i+="&picture="+encodeURIComponent(o.socialshareMedia)),o.socialshareSource&&(i+="&source="+encodeURIComponent(o.socialshareSource)),e.open(i,"Facebook","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)):o.socialshareType&&"send"===o.socialshareType?(i="https://www.facebook.com/dialog/send?",o.socialshareVia&&(i+="&app_id="+encodeURIComponent(o.socialshareVia)),o.socialshareRedirectUri&&(i+="&redirect_uri="+encodeURIComponent(o.socialshareRedirectUri)),o.socialshareUrl&&(i+="&link="+encodeURIComponent(o.socialshareUrl)),o.socialshareTo&&(i+="&to="+encodeURIComponent(o.socialshareTo)),o.socialshareDisplay&&(i+="&display="+encodeURIComponent(o.socialshareDisplay)),o.socialshareRef&&(i+="&ref="+encodeURIComponent(o.socialshareRef)),e.open(i,"Facebook","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)):e.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(o.socialshareUrl||e.location.href),"Facebook","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},s=function(e,o){var i="mailto:";o.socialshareTo&&(i+=encodeURIComponent(o.socialshareTo)),i+="?",o.socialshareBody&&(i+="body="+o.socialshareBody),o.socialshareSubject&&(i+="&subject="+encodeURIComponent(o.socialshareSubject)),o.socialshareCc&&(i+="&cc="+encodeURIComponent(o.socialshareCc)),o.socialshareBcc&&(i+="&bcc="+encodeURIComponent(o.socialshareBcc)),e.open(i,"_self")},h=function(e,o,i){var t="fb-messenger://share?link="+encodeURIComponent(o.socialshareUrl||e.location.href);i.attr("href",t),i.attr("target","_top")},c=function(e,o){var i="https://www.twitter.com/intent/tweet?";o.socialshareText&&(i+="text="+encodeURIComponent(o.socialshareText)),o.socialshareVia&&(i+="&via="+encodeURIComponent(o.socialshareVia)),o.socialshareHashtags&&(i+="&hashtags="+encodeURIComponent(o.socialshareHashtags)),i+="&url="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Twitter","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},p=function(e,o){e.open("https://plus.google.com/share?url="+encodeURIComponent(o.socialshareUrl||e.location.href),"Google+","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},n=function(e,o){var i="https://www.reddit.com/";i+=o.socialshareSubreddit?"r/"+o.socialshareSubreddit+"/submit?url=":"submit?url=",o.socialsharePopupWidth<900&&(o.socialsharePopupWidth=900),o.socialsharePopupHeight<650&&(o.socialsharePopupHeight=650),e.open(i+encodeURIComponent(o.socialshareUrl||e.location.href)+"&title="+encodeURIComponent(o.socialshareText),"Reddit","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},l=function(e,o){e.open("https://www.stumbleupon.com/submit?url="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&title="+encodeURIComponent(o.socialshareText),"StumbleUpon","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},d=function(e,o){var i="https://www.linkedin.com/shareArticle?mini=true";i+="&url="+encodeURIComponent(o.socialshareUrl||e.location.href),o.socialshareText&&(i+="&title="+encodeURIComponent(o.socialshareText)),o.socialshareDescription&&(i+="&summary="+encodeURIComponent(o.socialshareDescription)),o.socialshareSource&&(i+="&source="+encodeURIComponent(o.socialshareSource)),e.open(i,"Linkedin","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},u=function(e,o){e.open("https://www.pinterest.com/pin/create/button/?url="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&media="+encodeURIComponent(o.socialshareMedia)+"&description="+encodeURIComponent(o.socialshareText),"Pinterest","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},g=function(e,o){e.open("https://www.digg.com/submit?url="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&title="+encodeURIComponent(o.socialshareText),"Digg","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},f=function(e,o){if(o.socialshareMedia){var i="https://www.tumblr.com/share/photo?source="+encodeURIComponent(o.socialshareMedia);o.socialshareText&&(i+="&caption="+encodeURIComponent(o.socialshareText)),e.open(i,"Tumblr","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)}else e.open("https://www.tumblr.com/share/link?url="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&description="+encodeURIComponent(o.socialshareText),"Tumblr","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},m=function(e,o){var i="https://www.vk.com/share.php?url="+encodeURIComponent(o.socialshareUrl||e.location.href);o.socialshareText&&(i+="&title="+encodeURIComponent(o.socialshareText)),o.socialshareMedia&&(i+="&image="+encodeURIComponent(o.socialshareMedia)),o.socialshareDescription&&(i+="&description="+encodeURIComponent(o.socialshareDescription)),e.open(i,"Vk","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},b=function(e,o){e.open("http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&st.comments="+encodeURIComponent(o.socialshareText),"Ok","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},k=function(e,o){e.open("https://www.delicious.com/save?v=5&noui&jump=close&url="+encodeURIComponent(o.socialshareUrl||e.location.href)+"&title="+encodeURIComponent(o.socialshareText),"Delicious","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},U=function(e,o){var i="https://bufferapp.com/add?";o.socialshareText&&(i+="text="+encodeURIComponent(o.socialshareText)),o.socialshareVia&&(i+="&via="+encodeURIComponent(o.socialshareVia)),o.socialshareMedia&&(i+="&picture="+encodeURIComponent(o.socialshareMedia)),i+="&url="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Buffer","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},w=function(e,o){var i="https://news.ycombinator.com/submitlink?";o.socialshareText&&(i+="t="+encodeURIComponent(o.socialshareText)+"&"),i+="u="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Hackernews","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},P=function(e,o){var i="https://share.flipboard.com/bookmarklet/popout?v=2&";o.socialshareText&&(i+="title="+encodeURIComponent(o.socialshareText)+"&"),i+="url="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Flipboard","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},H=function(e,o){var i="https://getpocket.com/save?";o.socialshareText&&(i+="text="+encodeURIComponent(o.socialshareText)+"&"),i+="url="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Pocket","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},v=function(e,o){var i="http://wordpress.com/press-this.php?";o.socialshareText&&(i+="t="+encodeURIComponent(o.socialshareText)+"&"),o.socialshareMedia&&(i+="i="+encodeURIComponent(o.socialshareMedia)+"&"),i+="u="+encodeURIComponent(o.socialshareUrl||e.location.href),e.open(i,"Wordpress","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},W=function(e,o){var i="";o.socialshareFollow&&(i="&follow_url="+encodeURIComponent(o.socialshareFollow)),e.open("https://www.xing.com/spi/shares/new?url="+encodeURIComponent(o.socialshareUrl||e.location.href)+i,"Xing","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},R=function(e,o){var i="http://www.evernote.com/clip.action?url="+encodeURIComponent(o.socialshareUrl||e.location.href);o.socialshareText&&(i+="&title="+encodeURIComponent(o.socialshareText)),e.open(i,"Evernote","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},C=function(e,o,i){var t="whatsapp://send?text="+encodeURIComponent(o.socialshareText+" ")+encodeURIComponent(o.socialshareUrl||e.location.href);i.attr("href",t),i.attr("target","_top")},I=function(e,o,i){var t=encodeURIComponent(o.socialshareText),a=o.socialshareTo||"",r="sms:"+a+"?&body="+t;i.attr("href",r),i.attr("target","_blank")},x=function(e,o,i){var t="viber://forward?text="+encodeURIComponent(o.socialshareText+" ")+encodeURIComponent(o.socialshareUrl||e.location.href);i.attr("href",t),i.attr("target","_top")},S=function(e,o){var i="https://telegram.me/share/url?url="+encodeURIComponent(o.socialshareUrl||e.location.href);o.socialshareText&&(i+="&text="+encodeURIComponent(o.socialshareText)),e.open(i,"Telegram","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},y=function(e,o){var i="https://web.skype.com/share?source=button&url="+encodeURIComponent(o.socialshareUrl||e.location.href);o.socialshareText&&(i+="&text="+encodeURIComponent(o.socialshareText)),e.open(i,"Skype","toolbar=0,status=0,resizable=yes,width="+o.socialsharePopupWidth+",height="+o.socialsharePopupHeight+",top="+(e.innerHeight-o.socialsharePopupHeight)/2+",left="+(e.innerWidth-o.socialsharePopupWidth)/2)},T=["$window",function(e){this.emailShare=s,this.facebookShare=r,this.twitterShare=c,this.stumbleuponShare=l,this.pinterestShare=u,this.googleShare=p,this.bufferShare=U,this.hackernewsShare=w,this.okShare=b,this.deliciousShare=k,this.pocketShare=H,this.vkShare=m,this.flipboardShare=P,this.xingShare=W,this.diggShare=g,this.linkedinShare=d,this.wordpressShare=v,this.telegramShare=S,this.redditShare=n,this.evernoteShare=R,this.tumblrShare=f,this.skypeShare=y,this.share=function(o){switch(o.provider){case"email":this.emailShare(e,o.attrs);break;case"facebook":this.facebookShare(e,o.attrs);break;case"twitter":this.twitterShare(e,o.attrs);break;case"pinterest":this.pinterestShare(e,o.attrs);break;case"ok":this.okShare(e,o.attrs);break;case"vk":this.vkShare(e,o.attrs);break;case"delicious":this.deliciousShare(e,o.attrs);break;case"digg":this.diggShare(e,o.attrs);break;case"google":this.googleShare(e,o.attrs);break;case"reddit":this.redditShare(e,o.attrs);break;case"hackernews":this.hackernewsShare(e,o.attrs);break;case"skype":this.skypeShare(e,o.attrs);break;case"evernote":this.evernoteShare(e,o.attrs);break;case"pocket":this.pocketShare(e,o.attrs);break;case"tumblr":this.tumblrShare(e,o.attrs);break;case"telegram":this.telegramShare(e,o.attrs);break;case"xing":this.xingShare(e,o.attrs);break;case"buffer":this.bufferShare(e,o.attrs);break;case"stumbleupon":this.stumbleuponShare(e,o.attrs);break;case"linkedin":this.linkedinShare(e,o.attrs);break;case"wordpress":this.wordpressShare(e,o.attrs);break;case"flipboard":this.flipboardShare(e,o.attrs);break;default:return}}}],z=["$window","socialshareConf","Socialshare","$log",function(e,o,i){var a=function(a,r,s){for(var h,c=0,p=(function(){return!(s.socialshareProvider in D)||void D[s.socialshareProvider](e,s,r)});c<o.length;c+=1)if(o[c].provider===s.socialshareProvider){h=o[c];break}t.indexOf(h.provider)===-1&&i.warn("Invalid Provider Name : "+s.socialshareProvider),s.socialshareUrl=s.socialshareUrl||h.conf.url,s.socialshareText=s.socialshareText||h.conf.text,s.socialshareMedia=s.socialshareMedia||h.conf.media,s.socialshareType=s.socialshareType||h.conf.type,s.socialshareVia=s.socialshareVia||h.conf.via,s.socialshareTo=s.socialshareTo||h.conf.to,s.socialshareFrom=s.socialshareFrom||h.conf.from,s.socialshareRef=s.socialshareRef||h.conf.ref,s.socialshareDislay=s.socialshareDislay||h.conf.display,s.socialshareSource=s.socialshareSource||h.conf.source,s.socialshareCaption=s.socialshareCaption||h.conf.caption,s.socialshareRedirectUri=s.socialshareRedirectUri||h.conf.redirectUri,s.socialshareTrigger=s.socialshareTrigger||h.conf.trigger,s.socialsharePopupHeight=s.socialsharePopupHeight||h.conf.popupHeight,s.socialsharePopupWidth=s.socialsharePopupWidth||h.conf.popupWidth,s.socialshareSubreddit=s.socialshareSubreddit||h.conf.subreddit,s.socialshareDescription=s.socialshareDescription||h.conf.description,s.socialshareFollow=s.socialshareFollow||h.conf.follow,s.socialshareHashtags=s.socialshareHashtags||h.conf.hashtags,s.socialshareBody=s.socialshareBody||h.conf.body,s.socialshareSubject=s.socialshareSubject||h.conf.subject,s.socialshareCc=s.socialshareCc||h.conf.cc,s.socialshareBcc=s.socialshareBcc||h.conf.bcc,s.socialshareTrigger?r.bind(s.socialshareTrigger,p):p()};return{restrict:"A",link:a}}],D={email:s,facebook:r,"facebook-messenger":h,twitter:c,google:p,reddit:n,stumbleupon:l,linkedin:d,pinterest:u,digg:g,tumblr:f,vk:m,ok:b,delicious:k,buffer:U,hackernews:w,flipboard:P,pocket:H,wordpress:v,xing:W,evernote:R,whatsapp:C,sms:I,telegram:S,viber:x,skype:y};e.module("720kb.socialshare",[]).provider(o+"Conf",a).service(i,T).directive(o,z)}(angular);
	//# sourceMappingURL=angular-socialshare.js.map


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */

	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}

	var ngFileUpload = angular.module('ngFileUpload', []);

	ngFileUpload.version = '12.2.13';

	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;

	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };

	  var resumeSupported = this.isResumeSupported();

	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};

	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;

	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }

	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }

	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }

	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }

	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }


	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };

	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };

	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };

	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }

	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };

	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };

	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };

	  this.json = function (val) {
	    return angular.toJson(val);
	  };

	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }

	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };

	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }

	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }

	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }

	        return formData;
	      });
	    }

	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }

	    return sendHttp(config);
	  };

	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

	    return sendHttp(config);
	  };

	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };

	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };

	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };

	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}

	]);

	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };

	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };

	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };

	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };

	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };

	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };

	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }

	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }

	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];

	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }

	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }

	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }

	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }

	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }

	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];

	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }

	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }

	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }

	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }

	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }

	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }

	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }

	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }

	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

	    if (keep && !allNewFiles.length) return;

	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });

	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };

	  return upload;
	}]);

	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];

	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }

	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }

	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };

	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }

	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }

	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }

	    upload.registerModelChangeValidator(ngModel, attr, scope);

	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }

	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }

	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }

	      var fileElem = angular.element('<input type="file">');

	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);

	      generatedElems.push({el: elem, ref: label});

	      document.body.appendChild(label.append(fileElem)[0]);

	      return fileElem;
	    }

	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;

	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;

	      resetModel(evt);

	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }

	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }

	      return false;
	    }


	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;

	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }

	    var fileElem = elem;

	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }

	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);

	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }

	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }

	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }

	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });

	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });

	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });

	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }

	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);

	(function () {

	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;

	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });

	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);

	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }

	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }

	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }

	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });

	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }


	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);

	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);

	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);

	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);

	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);

	})();

	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;

	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }

	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };

	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };

	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };

	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }

	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };

	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };

	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];

	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });

	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };

	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }

	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];

	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }

	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });

	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });

	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }

	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }

	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }

	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }

	    var deffer = $q.defer();
	    var promises = [];

	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));

	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));

	    $q.all(promises).then(function () {

	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }

	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });

	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };

	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');

	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }

	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }

	        img.on('load', success);
	        img.on('error', error);

	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }

	        checkLoadErrorInCaseOfNoCallback();

	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });

	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };

	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }

	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }

	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;

	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }

	        checkLoadError();

	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });

	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);

	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;

	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };

	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);

	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };

	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };

	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };

	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }

	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };

	  return upload;
	}]);

	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);

	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });

	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);

	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();

	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };

	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }

	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }

	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }

	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;

	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);

	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }

	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }

	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }

	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }

	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }

	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;

	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }

	      var promises = [upload.emptyPromise()];

	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }

	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });

	      return defer.promise;
	    }
	  }

	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }

	})();

	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;

	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };

	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }

	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };

	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }

	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }

	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');

	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };

	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};

	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';

	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;

	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];

	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;

	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }

	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);

	      return output;
	    };

	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }

	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);

	      var image = this.exifManipulation(resizedFileBase64, segments);

	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };


	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };


	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };


	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;

	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };


	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];

	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }

	      return segments;
	    };


	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];

	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));

	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;

	        buf.push(chr1);

	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }

	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';

	      } while (i < input.length);

	      return buf;
	    };

	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };

	  return upload;
	}]);



/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Firebase-util:  A set of experimental power tools for Firebase.
	 *
	 * Version: 0.3.0gt
	 * URL: https://github.com/GartorwareCorp/firebase-util
	 * Date: 2016-06-22T11:35:37.495Z
	 * License: MIT http://firebase.mit-license.org/
	 */

	require=(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	(function (global){
	// place fbutil onto firebase.util namespace
	// if we are in the browser and firebase exists
	if( global.firebase ) {
	  global.firebase.util = require('firebase-util');
	}
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"firebase-util":undefined}],2:[function(require,module,exports){

	exports.NormalizedCollection = require('./libs/NormalizedCollection.js');
	},{"./libs/NormalizedCollection.js":6}],3:[function(require,module,exports){
	'use strict';

	var util = require('../../common/');

	/**
	 * A Record represents a set of merged data. The hierarchy of a normalized Collection
	 * can be traversed as normal using parent() and child() calls:
	 *    - RecordSet: The root of a normalized collection; a set of merged Firebase paths
	 *    - Record: A child of RecordSet obtained by calling .child(recordId)
	 *    - RecordField: A child of Record or RecordField which represents a wrapped Firebase path (no longer normalized)
	 *
	 * We wrap all of these levels, including the RecordField's, so that the
	 * parent() and child() calls work as expected and return the normalized chain instead
	 * of reverting to the underlying Firebase instances.
	 *
	 * AbstractRecord provides common functionality around observables, event handling, and field maps
	 * used by all three implementations.
	 *
	 * @param fieldMap the field map applied to Record objects
	 * @param {String} name
	 * @param {String} url
	 * @constructor
	 */
	function AbstractRecord(fieldMap, name, url) {
	  var self = this;
	  self._ref = null;
	  self._map = fieldMap;
	  self._name = name;
	  self._url = url;
	  self.lastMergedValue = util.undef; // starts undefined since first value may be null
	  self._obs = new util.Observable(
	    ['child_added', 'child_removed', 'child_changed', 'child_moved', 'value'],
	    {
	      onAdd: function(event) {
	        var count = self._obs.getObservers(event).length;
	        if( count === 1 ) {
	          self._start(event, self._obs.getObservers().length);
	        }
	      },
	      onRemove: function(event) {
	        var count = self._obs.getObservers(event).length;
	        if( count === 0 ) {
	          self._stop(event, self._obs.getObservers().length);
	        }
	      }
	    }
	  );
	}

	AbstractRecord.prototype = {
	  /**
	   * Called internally by AbstractRecord whenever the first listener
	   * is attached for a given event. Also includes a count of the
	   * total number of listeners
	   *
	   * @param {string} type
	   * @param {int} totalListeners
	   * @abstract
	   */
	  _start: abstract('_start'),

	  /**
	   * Called internally by AbstractRecord whenever
	   * the last listener is detached for a given type. Also provides
	   * the total listener count
	   *
	   * @param {string} type
	   * @param {int} totalListeners
	   * @abstract
	   */
	  _stop:  abstract('_stop'),

	  /**
	   * Should return true if the snapshots provided contain the child key and if it
	   * exists in the fields for this record type.
	   *
	   * @param {Array} snapshots
	   * @param {string} key
	   * @abstract
	   */
	  hasChild: abstract('hasChild'),

	  /**
	   * Given a list of snapshots to iterate, returns the valid keys
	   * which exist in both the snapshots and the field map, in the
	   * order they should be iterated.
	   *
	   * Calls iterator with a {string|number} key for the next field to
	   * iterate only.
	   *
	   * If iterator returns true, this method should abort and return true,
	   * otherwise it should return false (same as Snapshot.forEach).
	   *
	   * @param {Array} snaps
	   * @param {function} iterator
	   * @param {object} [context]
	   * @return {boolean} true if aborted
	   * @abstract
	   */
	  forEachKey: abstract('forEach'),

	  /**
	   * When .child() is called on a Snapshot, this will reconcile
	   * the correct refs and data for each child and return an array
	   * containing the child snapshots for the specified key. For
	   * a RecordSet, this should return children for all the fields
	   * in the field map. For a Record, this should return a child
	   * from the correct snapshot, or the first if the child is not
	   * in the map.
	   *
	   * @param {Array} snaps
	   * @param {string} key
	   * @abstract
	   */
	  getChildSnaps: abstract('getChildSnaps'),

	  /**
	   * This should take all the data from a set of snapshots and
	   * merge it together appropriately. For a RecordSet, this should
	   * return records ordered by the first reference. For a Record,
	   * this should return the fields in the field map.
	   *
	   * @param {Array} snaps
	   * @param {boolean} isExport
	   * @abstract
	   */
	  mergeData: abstract('mergeData'),

	  /**
	   * Returns the specific implementing class for this instance.
	   *
	   * @returns {Function}
	   */
	  getClass: abstract('getClass'),

	  /**
	   * Saves data back to the correct paths
	   *
	   * @param data
	   * @param {Object} props an object with callback[, context][, isUpdate]
	   */
	  saveData: abstract('saveData'),

	  /**
	   * Returns the priority for a given set of snapshots
	   * @param {Array} snapshots
	   * @return {int|string}
	   */
	  getPriority: abstract('getPriority'),

	  /**
	   * This returns the appropriate AbstractRecord type in the chain. Note that references
	   * created here will not be usable until setRef() is called, so this should only be used
	   * for passing into a Query. Use .child() for everything else.
	   *
	   * @param {String} childName
	   * @return {AbstractRecord}
	   */
	  makeChild: abstract('makeChild'),

	  /**
	   * @param {string} event
	   * @param {function} callback
	   * @param {function} [cancel]
	   * @param {object} [context]
	   */
	  watch: function(event, callback, cancel, context) {
	    this._obs.observe(event, callback, cancel, context);
	  },

	  /**
	   * @param {string} event
	   * @param {function} [callback]
	   * @param {object} [context]
	   */
	  unwatch: function(event, callback, context) {
	    this._obs.stopObserving(event, callback, context);
	  },

	  getFieldMap: function() {
	    return this._map;
	  },

	  getPathManager: function() {
	    return this._map.getPathManager();
	  },

	  setRef: function(ref) {
	    this._ref = ref;
	  },

	  getRef: function() {
	    return this._ref;
	  },

	  /**
	   * @param {String} key
	   * @returns {Record}
	   */
	  child: function(key) {
	    return this.getRef().ref.child(key).$getRecord();
	  },

	  /**
	   * Returns an appropriate path name or merged set of names for this record type.
	   * @return {String}
	   */
	  getName: function() {
	    return this._name;
	  },

	  /**
	   * Returns a Firebase URL or a merged set of URLs for the Record
	   * @return {String}
	   */
	  getUrl: function() {
	    return this._url;
	  },

	  trigger: function(snapshotFactory) {
	    util.log.debug('AbstractRecord._trigger: %s', snapshotFactory.toString());
	    this._obs.triggerEvent(snapshotFactory.event, snapshotFactory.create(this.getRef()));
	  },

	  /**
	   * @param {object} error
	   */
	  _cancel: function(error) {
	    util.error(error);
	    this._obs.abortObservers(error);
	  }
	};

	function abstract(method) {
	  return function() {
	    throw new Error('Classes implementing AbstractRecord must declare ' + method);
	  };
	}

	module.exports = AbstractRecord;
	},{"../../common/":25}],4:[function(require,module,exports){
	'use strict';

	var util = require('../../common');
	var PathManager = require('./PathManager');

	function FieldMap(pathManager) {
	  this.fields = {};
	  this.length = 0;
	  this.pathMgr = pathManager;
	}

	FieldMap.prototype = {
	  add: function(fieldProps) {
	    var f = new Field(parseProps(fieldProps, this.pathMgr));
	    if( this.fields.hasOwnProperty(f.alias) ) {
	      throw new Error('Duplicate field alias ' + f.alias + '(' + f.key + ')');
	    }
	    if( f.path === null ) {
	      throw new Error('Invalid path specified for field ' + f.key + '; it was not in the paths ' +
	        'provided, which are : ' + this.pathMgr.getPathNames().join(','));
	    }
	    var dep = f.path.getDependency();
	    if(dep !== null && getDepField(this.fields, dep) === null) {
	      throw new Error('Dynamic paths must reference a field declared in the map. Please add ' +
	        FieldMap.key(dep.path, dep.field) + ' to the select() criteria before using it in a ' +
	        'dynamic field');
	    }
	    this.fields[f.alias] = f;
	    this.length++;
	  },

	  forEach: function(callback, context) {
	    return util.find(this.fields, callback, context) !== util.undef;
	  },

	  getField: function(fieldName) {
	    return this.fields[fieldName]||null;
	  },

	  getPath: function(pathName) {
	    return this.getPathManager().getPath(pathName);
	  },

	  getPathManager: function() {
	    return this.pathMgr;
	  },

	  pathFor: function(fieldName) {
	    var f = this.getField(fieldName);
	    return f? f.path : this.pathMgr.first();
	  },

	  fieldsFor: function(pathName) {
	    return util.filter(util.toArray(this.fields), function(f) {
	      return f.pathName === pathName;
	    });
	  },

	  aliasFor: function(url) {
	    var f = util.find(this.fields, function(f) {
	      return f.url === url;
	    }, this);
	    return f? f.alias : null;
	  },

	  /**
	   * Pulls data out of a snapshot aliased by the field map. Only keys in the field map
	   * will be returned. Always returns an object. Does not return a priority at the root
	   * level but will return priorities for all children. If the snapshot contains a primitive,
	   * an empty object will be returned.
	   *
	   * This is not intended to provide finalized values but instead to provide an object representation
	   * of each snapshot useful for merging snapshot data into a finalized value (see Record.mergeData)
	   *
	   * @param {object} snapshot a Firebase snapshot
	   * @param {boolean} [isExport]
	   * @returns {object}
	   */
	  extractData: function(snapshot, isExport) {
	    var out = {};
	    var pathName = this.pathMgr.getPathName(snapshot.ref.toString());
	    if( pathName === null && snapshot.ref.parent !== null ) {
	      var parentPath = this.pathMgr.getPathFor(snapshot.ref.parent.toString());
	      if( parentPath && parentPath.hasDependency() ) {
	        pathName = parentPath.name();
	      }
	    }
	    var fx = isExport? 'exportVal' : 'val';
	    util.each(this.fieldsFor(pathName), function(f) {
	      switch(f.id) {
	        case '$key':
	          putIn(out, f.alias, snapshot.key);
	          break;
	        case '$value':
	          putIn(out, f.alias, snapshot[fx]());
	          break;
	        default:
	          if( snapshot.hasChild(f.id) ) {
	            putIn(out, f.alias, snapshot.child(f.id)[fx]());
	          }
	      }
	    });
	    return out;
	  },

	  /**
	   * Given an array of snapshots and an aliased fieldName, this will return the appropriate
	   * snapshot containing the corresponding field. If no snapshot matches a field in this map,
	   * it will return null.
	   *
	   * @param {Array} snaps a list of Firebase snapshots
	   * @param {String} fieldName
	   * @returns {object|null}
	   */
	  snapFor: function(snaps, fieldName) {
	    var url;
	    var path = this.pathFor(fieldName);
	    if( !path ) { return null; }
	    var dep = path.getDependency();
	    if( dep !== null ) {
	      var depField = getDepField(this.fields, dep);
	      var depSnap = this.snapFor(snaps, depField.alias);
	      if( depSnap ) {
	        if (dep.field === '$key') {
	          url = path.child(depSnap.key).url();
	        }
	        else if (dep.field === '$value') {
	          url = path.child(depSnap.val()).url();
	        }
	        else {
	          url = path.child(depSnap.child(dep.field).val()).url();
	        }
	      }
	    }
	    else {
	      url = path.url();
	    }
	    if( url ) {
	      return util.find(snaps, function (snap) {
	          return snap.ref.toString() === url;
	        }) || null;
	    }
	    else {
	      return null;
	    }
	  },

	  /**
	   * Since data can be nested under child keys, this method returns a map of fields->data which
	   * is flattened for each key.
	   *
	   * @param {object} data
	   * @returns {object} an array containing [ [Path, Object]... ] where each object is a key/value store
	   */
	  denest: function(data) {
	    var out = {};
	    util.each(this.getPathManager().getPaths(), function(p) {
	      out[p.name()] = { path: p, data: {} };
	    });

	    this.forEach(function(field) {
	      var val = getOut(data, field.alias);
	      if( val !== util.undef ) {
	        switch(field.id) {
	          case '$value':
	            out[field.pathName].data = val;
	            break;
	          case '$key':
	            // do nothing
	            break;
	          default:
	            out[field.pathName].data[field.id] = val;
	        }
	      }
	    });
	    return out;
	  },

	  idFor: function(fieldName) {
	    var f = this.getField(fieldName);
	    if( !f ) { return fieldName; }
	    return f.id;
	  }
	};

	FieldMap.key = function(path, field) {
	  if( typeof path !== 'string' ) {
	    path = path.name();
	  }
	  return path + '.' + field;
	};

	FieldMap.fieldMap = function(map, fieldName) {
	  var childPath;
	  var field = map.getField(fieldName);
	  if( field ) {
	    childPath = field.path;
	    if( field.id !== '$value' ) {
	      childPath = childPath.child(field.id);
	    }
	  }
	  else {
	    childPath = map.pathFor(fieldName).child(fieldName);
	  }
	  var pm = new PathManager([childPath]);
	  var fm = new FieldMap(pm);
	  fm.add({key: FieldMap.key(childPath, '$value'), alias: fieldName});
	  return fm;
	};

	/**
	 * Fetch a list of paths suitable for use in a Record.
	 *
	 * @param {FieldMap} map to be copied
	 * @param {string} recordId the push id for the record
	 * @returns {FieldMap} a copy of the field map with paths ajusted down to the child node
	 */
	FieldMap.recordMap = function(map, recordId) {
	  var mgr = map.getPathManager();
	  var paths = util.map(mgr.getPaths(), function(p) {
	    return p.normChild(recordId);
	  });
	  var childMap = new FieldMap(new PathManager(paths));
	  map.forEach(function(field) {
	    childMap.add({key: field.key, alias: field.alias});
	  });
	  return childMap;
	};

	function getDepField(fields, dep) {
	  return util.find(fields, function(field) {
	    return field.pathName === dep.path && field.id === dep.field;
	  }) || null;
	}

	function Field(props) {
	  // these properties are considered public and accessed directly by other classes
	  this.path = props.path;
	  this.id = props.id;
	  this.key = props.key;
	  this.alias = props.alias;
	  this.url = props.url;
	  this.pathName = props.pathName;
	  this.isNested = props.alias.indexOf('.') >= 0;
	}

	function parseProps(propsRaw, pathMgr) {
	  if( propsRaw instanceof Field ) {
	    return util.pick(propsRaw, ['path', 'id', 'key', 'alias', 'pathName', 'url']);
	  }
	  else if( typeof(propsRaw) === 'string' ) {
	    propsRaw = { key: propsRaw };
	  }
	  var parts = propsRaw.key.split('.');
	  var path = pathMgr.getPath(parts[0]);
	  return {
	    pathName: parts[0],
	    id: parts[1],
	    key: propsRaw.key,
	    alias: propsRaw.alias || parts[1],
	    path: path,
	    //todo-dynamic-keys this isn't correct for dynamic fields :(
	    //todo-dynamic-keys and probably not for $value and $key either
	    url: path? path.url() + '/' + parts[1] : null
	  };
	}

	function putIn(data, alias, val) {
	  if( val === null ) { return; }
	  if( alias.indexOf('.') > 0 ) {
	    var parts = alias.split('.').reverse(), p;
	    while(parts.length > 1 && (p = parts.pop())) {
	      data = data[p] = util.has(data, p)? data[p] : {};
	    }
	    alias = parts.pop();
	  }
	  data[alias] = val;
	}

	function getOut(data, alias) {
	  var key = alias;
	  if( !util.isObject(data) ) { return util.undef; }
	  var val = data[alias];
	  if( alias.indexOf('.') > 0 ) {
	    var parts = alias.split('.').reverse();
	    val = data;
	    while(parts.length) {
	      key = parts.pop();
	      val = util.isObject(val) && val.hasOwnProperty(key)? val[key] : util.undef;
	    }
	  }
	  return val;
	}

	module.exports = FieldMap;
	},{"../../common":25,"./PathManager":10}],5:[function(require,module,exports){
	'use strict';

	var util = require('../../common');

	function Filter() {
	  this.criteria = [];
	  util.each(arguments, this.add, this);
	}

	Filter.prototype = {
	  add: function(fn) {
	    this.criteria.push(
	      new Condition(fn)
	    );
	  },
	  test: function(recordData, key, priority) {
	    return util.contains(this.criteria, function(cond) {
	      return !cond.test(recordData, key, priority);
	    }) === false;
	  }
	};

	function Condition(fn) {
	  this.match = fn;
	}

	Condition.prototype.test = function(data, key, priority) {
	  return this.match(data, key, priority) === true;
	};

	module.exports = Filter;
	},{"../../common":25}],6:[function(require,module,exports){
	'use strict';

	var util          = require('../../common');
	var PathManager   = require('./PathManager');
	var Filter        = require('./Filter');
	var FieldMap      = require('./FieldMap');
	var NormalizedRef = require('./NormalizedRef');
	var RecordSet     = require('./RecordSet');

	/**
	 * @param {...object} path
	 * @constructor
	 */
	function NormalizedCollection(path) { //jshint unused:vars
	  assertPaths(arguments);
	  this.pathMgr = new PathManager(util.toArray(arguments));
	  this.map = new FieldMap(this.pathMgr);
	  this.filters = new Filter();
	  this.finalized = false;
	}

	NormalizedCollection.prototype = {
	  select: function(fieldName) { //jshint unused:vars
	    assertNotFinalized(this, 'select');
	    var args = util.args('NormalizedCollection.select', arguments, 1);
	    util.each(args.restAsList(0, ['string', 'object']), function(f) {
	      assertValidField(f);
	      this.map.add(f);
	    }, this);
	    return this;
	  },

	  filter: function(matchFn) { //jshint unused:vars
	    assertNotFinalized(this, 'filter');
	    var args = util.args('NormalizedCollection.filter', arguments, 1, 1);
	    this.filters.add(
	      args.nextReq('function')
	    );
	    return this;
	  },

	  ref: function() {
	    if( !this.map.length ) {
	      throw new Error('Must call select() with at least one field' +
	        ' before creating a ref');
	    }
	    this.finalized = true;
	    if( util.log.isInfoEnabled() ) {
	      util.log.info('NormalizedRef created using %s', buildDebugString(this));
	    }
	    var recordSet = new RecordSet(this.map, this.filters);
	    return new NormalizedRef(recordSet);
	  }
	};

	function assertPaths(args) {
	  if( args.length < 1 ) {
	    throw new Error('Must provide at least one path definition');
	  }
	  function notValidRef(p) {
	    if( util.isArray(p) ) {
	      p = p[0];
	    }
	    return !util.isFirebaseRef(p);
	  }
	  if( util.contains(args, notValidRef) ) {
	    throw new Error('Each argument to the NormalizedCollection constructor must be a ' +
	      'valid Firebase reference or an Array containing a Firebase ref as the first argument');
	  }
	}

	function assertNotFinalized(self, m) {
	  if( self.finalized ) {
	    throw new Error('Cannot call ' + m + '() after ref has been accessed');
	  }
	}

	function buildDebugString(nc) {
	  var paths = [];
	  var selects = [];
	  var filter = '';

	  util.each(nc.pathMgr.getPaths(), function(p) {
	    var dep = p.getDependency();
	    paths.push(
	      util.printf('\t"%s%s"%s',
	        p.url(),
	        p.id() === p.name()? '' : ' as ' + p.name(),
	        dep? '-> ' + dep.path + '.' + dep.field : ''
	      )
	    );
	  });

	  nc.map.forEach(function(f) {
	    selects.push(util.printf('"%s%s"', f.key, f.alias === f.id? '' : ' as ' + f.alias));
	    if( selects.length % 5 === 0 ) {
	      selects.push('\n');
	    }
	  });

	  if(nc.filters.criteria.length > 0) {
	    filter = util.printf('<%s filters applied>', nc.filters.criteria.length);
	  }

	  return util.printf('NormalizedCollection(\n%s\n).select(%s)%s.ref', paths.join('\n'), selects.join(', '), filter);
	}

	function assertValidField(f) {
	  var k;
	  if( typeof f === 'string' ) {
	    k = f;
	  }
	  else {
	    k = util.has(f, 'key')? f.key : util.undef;
	  }
	  if( typeof k !== 'string' || k.indexOf('.') <= 0 ) {
	    throw new Error('Each field passed to NormalizedCollection.select() must either be a string ' +
	    'in the format "pathAlias.fieldId", or an object in the format ' +
	    '{key: "pathAlias.fieldId", alias: "any_name_for_field"}, but I received ' + JSON.stringify(f));
	  }
	}

	module.exports = NormalizedCollection;
	},{"../../common":25,"./FieldMap":4,"./Filter":5,"./NormalizedRef":7,"./PathManager":10,"./RecordSet":14}],7:[function(require,module,exports){
	'use strict';

	var util      = require('../../common');
	var Query     = require('./Query');

	function NormalizedRef(record, parent) {
	  this._super(this, record);
	  this._parent = parent||null;
	  this._key = record.getName();
	  this._toString = record.getUrl();

	  this.parent = this._parent;
	  this.key = this._key;

	  var p = this;
	  while(p.parent !== null) {
	    p = p.parent;
	  }
	  this.root = p;
	}

	util.inherits(NormalizedRef, Query, {
	  'child': function(fieldName) {
	    var parts = fieldName.split('/').reverse(); // pop is faster than shift
	    var parent = this;
	    var ref = this;
	    while(parts.length) {
	      var key = parts.pop();
	      ref = new NormalizedRef(ref.$getRecord().makeChild(key), parent);
	      parent = ref;
	    }
	    return ref;
	  },

	  /** @deprecated */
	  'name': function() {
	    console.warn('The name() function has been deprecated. Use key instead.');
	    return this.key;
	  },

	  'toString': function() {
	    return this._toString;
	  },

	  //todo have set, update, push, remove attempt to revert any partial commits
	  //todo by running a transaction and, if the value is still the "new" partial
	  //todo value, then revert it to the old complete value

	  'set': function(data, callback, context) {
	    this.$getRecord().saveData(data, {callback: callback, context: context, isUpdate: false});
	  },

	  'update': function(data, callback, context) {
	    this.$getRecord().saveData(data, {callback: callback, context: context, isUpdate: true});
	  },

	  'remove': function(callback, context) {
	    this.$getRecord().saveData(null, {callback: callback, context: context, isUpdate: false});
	  },

	  'push': function(data, callback, context) { // jshint unused:false
	    var uid = this.$getMaster().push().key;
	    var child = this.child(uid);
	    if( arguments.length ) {
	      child.set.apply(child, arguments);
	    }
	    return child;
	  },

	  'setWithPriority': function(data, priority, callback, context) {
	    this.$getRecord().saveData(data, {
	      callback: callback, context: context, isUpdate: false, priority: priority
	    });
	  },

	  'setPriority': function(priority, callback, context) {
	    this.$getMaster().setPriority(priority, callback, context);
	  },

	  /****************************
	   * WRAPPER FUNCTIONS
	   ****************************/
	  'auth': wrapMaster('auth'),
	  'unauth': wrapMaster('unauth'),
	  'authWithCustomToken': wrapMaster('authWithCustomToken'),
	  'authAnonymously': wrapMaster('authAnonymously'),
	  'authWithPassword': wrapMaster('authWithPassword'),
	  'authWithOAuthPopup': wrapMaster('authWithOAuthPopup'),
	  'authWithOAuthRedirect': wrapMaster('authWithOAuthRedirect'),
	  'authWithOAuthToken': wrapMaster('authWithOAuthToken'),
	  'getAuth': wrapMaster('getAuth'),
	  'onAuth': wrapMaster('onAuth'),
	  'offAuth': wrapMaster('offAuth'),
	  'createUser': wrapMaster('createUser'),
	  'changePassword': wrapMaster('changePassword'),
	  'removeUser': wrapMaster('removeUser'),
	  'resetPassword': wrapMaster('resetPassword'),
	  'changeEmail': wrapMaster('changeEmail'),

	  'goOffline': wrapAll('goOffline'),
	  'goOnline': wrapAll('goOnline'),

	  /****************************
	   * UNSUPPORTED FUNCTIONS
	   ***************************/
	  'transaction': notSupported('transaction'), //todo use field map to pick fields and apply to each
	  'onDisconnect': notSupported('onDisconnect') //todo use field map to pick fields and apply to each
	});

	function wrapAll(method) {
	  return function() {
	    var args = util.toArray(arguments);
	    util.each(this.$getPaths(), function(p) {
	      var ref = p.ref;
	      ref[method].apply(ref, args);
	    });
	  };
	}

	function wrapMaster(method) {
	  return function() {
	    var args = util.toArray(arguments);
	    var ref = this.$getMaster();
	    return ref[method].apply(ref, args);
	  };
	}

	function notSupported(method) {
	  return function() {
	    throw new Error(method + ' is not supported for NormalizedCollection references. ' +
	      'Try calling it on the original reference used to create the NormalizedCollection instead.');
	  };
	}

	module.exports = NormalizedRef;
	},{"../../common":25,"./Query":11}],8:[function(require,module,exports){
	'use strict';

	var util = require('../../common');

	function NormalizedSnapshot(ref, snaps) {
	  this._ref = ref;
	  this._rec = ref.$getRecord();
	  if( !util.isArray(snaps) ) {
	    throw new Error('Must provide an array of snapshots to merge');
	  }
	  this._pri = this._rec.getPriority(snaps);
	  this._snaps = snaps;

	  this.key = this._rec.getName();
	  this.ref = this._ref.ref;
	}

	NormalizedSnapshot.prototype = {
	  val: function() {
	    if( !this._snaps.length ) {
	      return null;
	    }
	    return this._rec.mergeData(this._snaps, false);
	  },

	  child: function(key) {
	    var snap;
	    // keys may contain / to separate nested child paths
	    // so make a list of child keys (we reverse it once
	    // as this is faster than unshift() on each iteration)
	    var childParts = key.split('/').reverse();
	    // grab the first key and get the child snapshot
	    var firstChildName = childParts.pop();
	    snap = new NormalizedSnapshot(
	      this._ref.child(firstChildName),
	      this._rec.getChildSnaps(this._snaps, firstChildName)
	    );
	    // iterate any nested keys and keep calling child on them
	    while(childParts.length) {
	      snap = snap.child(childParts.pop());
	    }
	    return snap;
	  },

	  forEach: function(cb, context) {
	    return this._rec.forEachKey(this._snaps, function(childId, childAlias) {
	      if( childId === '$value' || childId === '$key' ) { return false; }
	      return cb.call(context, this.child(childAlias));
	    }, this);
	  },

	  hasChild: function(key) {
	    //todo optimize and/or memoize?
	    var parts = key.split('/').reverse();
	    var res = parts.length > 0;
	    var nextRef = this._ref;
	    var nsnap = this;
	    while(res && parts.length) {
	      var nextKey = parts.pop();
	      res = nextRef.$getRecord().hasChild(nsnap._snaps, nextKey);
	      if( res && parts.length ) {
	        nextRef = nextRef.child(nextKey);
	        nsnap = nsnap.child(nextKey);
	      }
	    }
	    return res;
	  },

	  /**
	   * Returns true if this snapshot has any child data. Does not return true for $key or $value
	   * fields.
	   *
	   * @returns {boolean}
	   */
	  hasChildren: function() {
	    // if there are any keys to iterate, and that key is not $key or $value
	    // then we have children
	    return this._rec.forEachKey(this._snaps, function(id) {
	      return id !== '$key' && id !== '$value';
	    });
	  },

	  /** @deprecated */
	  name: function() {
	    console.warn('name() has been deprecated. Use key instead.');
	    return this.key;
	  },

	  numChildren: function() {
	    //todo-bug does not account for nested aliases (they will change the count here)
	    var ct = 0;
	    this._rec.forEachKey(this._snaps, function(id) {
	      if( id !== '$key' && id !== '$value' ) { ct++; }
	    });
	    return ct;
	  },

	  getPriority: function() { return this._pri; },

	  exportVal: function() {
	    return this._rec.mergeData(this._snaps, true);
	  },

	  exists: function() {
	    return this.val() !== null;
	  }
	};

	module.exports = NormalizedSnapshot;
	},{"../../common":25}],9:[function(require,module,exports){
	'use strict';

	var util = require('../../common');

	function Path(pathProps, parent) {
	  var props = parseProps(pathProps);
	  this._ref = props.ref;
	  this._alias = props.alias;
	  this._dep = props.dep;
	  this._parent = parent || null;
	  this.ref = this._ref;
	  this.reff = this._ref.ref;
	  this.parent = this._parent;
	}

	Path.prototype = {
	  child: function(key) {
	    return new Path(this.reff.child(key), this);
	  },
	  normChild: function(key) {
	    var dep = this.getDependency();
	    if( dep !== null ) {
	      return new Path([this.reff, this.name(), dep.path+'.'+dep.field], this);
	    }
	    else {
	      return new Path([this.reff.child(key), this.name()], this);
	    }
	  },
	  hasDependency: function() {
	    return this._dep !== null;
	  },
	  getDependency: function() {
	    return this._dep;
	  },
	  url: function() { return this.reff.toString(); },
	  name: function() { return this._alias; },
	  id: function() { return this.reff.key; },
	  clone: function() {
	    return new Path([this._ref, this._alias, this._dep], this._parent);
	  }
	};

	function parseProps(props) {
	  var ref, alias, dep = null;
	  if( util.isArray(props) ) {
	    ref = props[0];
	    alias = props[1];
	    dep = props[2];
	  }
	  else if( util.isObject(props.ref) ) {
	    ref = props.ref;
	  }
	  else {
	    ref = props;
	  }
	  return {
	    ref: ref, alias: alias||ref.key, dep: parseDep(dep)
	  };
	}

	function parseDep(dep) {
	  if(util.isObject(dep) ) {
	    return dep;
	  }
	  else if( dep ) {
	    var parts = dep.split('.');
	    return { path: parts[0], field: parts[1] };
	  }
	  return null;
	}

	module.exports = Path;
	},{"../../common":25}],10:[function(require,module,exports){
	'use strict';

	var Path = require('./Path');
	var util = require('../../common');

	function PathManager(paths) {
	  this.paths = [];
	  this.pathsByUrl = {};
	  this.deps = {};
	  this.pathNames = [];
	  util.each(paths, this.add, this);
	}

	PathManager.prototype = {
	  add: function(pathProps) {
	    var path = pathProps instanceof Path? pathProps.clone() : new Path(pathProps);
	    if( !this.paths.length && path.hasDependency() ) {
	      throw new Error('The master path (i.e. the first) may not declare a dependency.' +
	        ' Perhaps you have put the wrong path first in the list?');
	    }
	    if( util.has(this.pathsByUrl, path.url()) ) {
	      throw new Error('Duplicate path: ' + path.url());
	    }
	    if( util.contains(this.pathNames, path.name()) ) {
	      throw new Error('Duplicate path name. The .key() value for each path must be unique, or you ' +
	          'can give each a path an alias by using [firebaseRef, alias] in the constructor. The aliases ' +
	          'must also be unique.');
	    }
	    this._map(path);
	    this.paths.push(path);
	    this.pathsByUrl[path.url()] = path.name();
	    this.pathNames.push(path.name());
	  },

	  count: function() {
	    return this.paths.length;
	  },

	  first: function() {
	    return this.paths[0];
	  },

	  getPath: function(pathName) {
	    return util.find(this.paths, function(p) {
	      return p.name() === pathName;
	    })||null;
	  },

	  getPathFor: function(url) {
	    var n = this.getPathName(url);
	    return n? this.getPath(n) : null;
	  },

	  getPaths: function() {
	    return this.paths.slice();
	  },

	  getPathName: function(url) {
	    return this.pathsByUrl[url] || null;
	  },

	  getPathNames: function() {
	    return this.pathNames.slice();
	  },

	  getUrls: function() {
	    return util.keys(this.pathsByUrl);
	  },

	  //todo remove?
	  getDependencyGraph: function() {
	    return util.extend(true, this.deps);
	  },

	  _map: function(path) {
	    var first = this.first();
	    var dep = path.getDependency();
	    if( !dep && first ) {
	      dep = { path: first.name(), field: '$key' };
	    }
	    if( dep ) {
	      this.deps[path.name()] = dep;
	      this._assertNotCircularDep(path.name());
	    }
	  },

	  _assertNotCircularDep: function(pathName) {
	    var map = [pathName], dep = this.deps[pathName];
	    while(util.isDefined(dep)) {
	      var p = dep.path;
	      if(util.contains(map, p)) {
	        map.push(p); // adds it into the error message chain
	        throw new Error('Circular dependencies in paths: ' + depChain(map, this.deps));
	      }
	      map.push(p);
	      dep = util.val(this.deps, p);
	    }
	  }
	};

	function depChain(map, deps) {
	  return util.map(map, function(p) {
	    return deps[p].path + '.' + deps[p].field;
	  }).join(' >> ');
	}

	module.exports = PathManager;
	},{"../../common":25,"./Path":9}],11:[function(require,module,exports){
	'use strict';

	var util = require('../../common');
	var Transmogrifier = require('./Transmogrifier');

	function Query(ref, record) {
	  var self = this;
	  self._ref = ref;
	  self._rec = record;
	  // necessary because util.inherit() can only call classes with an empty constructor
	  // so we can't depend on the params existing for that call
	  if( record ) { record.setRef(self); } //todo don't like this here, is awkward coupling

	  self.ref =  self._ref;
	}

	Query.prototype = {
	  'on': function(event, callback, cancel, context) {
	    if( arguments.length === 3 && util.isObject(cancel) ) {
	      context = cancel;
	      cancel = util.undef;
	    }

	    function cancelHandler(err) {
	      if( typeof(cancel) === 'function' && err !== null ) {
	        cancel.call(context, err);
	      }
	    }

	    this.$getRecord().watch(event, callback, cancelHandler, context);
	    return callback;
	  },

	  'once': function(event, callback, cancel, context) {
	    var self = this;
	    if( arguments.length === 3 && util.isObject(cancel) ) {
	      context = cancel;
	      cancel = util.undef;
	    }
	    function successHandler(snap) {
	      self.off(event, successHandler);
	      callback.call(context, snap);
	    }

	    function cancelHandler(err) {
	      if( typeof(cancel) === 'function' && err !== null ) {
	        cancel.call(context, err);
	      }
	    }

	    return this.on(event, successHandler, cancelHandler);
	  },

	  'off': function(event, callback, context) {
	    this.$getRecord().unwatch(event, callback, context);
	  },

	  /************************************
	   * Wrapped functions
	   ************************************/

	  'orderByChild': function() {
	    return this.$replicate('orderByChild', util.toArray(arguments));
	  },

	  'orderByKey': function() {
	    return this.$replicate('orderByKey', util.toArray(arguments));
	  },

	  'orderByValue': function() {
	    return this.$replicate('orderByValue', util.toArray(arguments));
	  },

	  'orderByPriority': function() {
	    return this.$replicate('orderByPriority', util.toArray(arguments));
	  },

	  'limitToFirst': function() {
	    return this.$replicate('limitToFirst', util.toArray(arguments));
	  },

	  'limitToLast': function() {
	    return this.$replicate('limitToLast', util.toArray(arguments));
	  },

	  /** @deprecated */
	  'limit': function() {
	    return this.$replicate('limit', util.toArray(arguments));
	  },

	  'startAt': function() {
	    return this.$replicate('startAt', util.toArray(arguments));
	  },

	  'endAt': function() {
	    return this.$replicate('endAt', util.toArray(arguments));
	  },

	  'equalTo': function() {
	    return this.$replicate('equalTo', util.toArray(arguments));
	  },

	  /****************************
	   * PACKAGE FUNCTIONS (not API)
	   ***************************/

	  /** @returns {Record} */
	  '$getRecord': function() { return this._rec; },

	  /** @return {Firebase} */
	  '$getMaster': function() { return this._rec.getPathManager().first().ref; },

	  /** @return {Array} */
	  '$getPaths': function() { return this._rec.getPathManager().getPaths(); },

	  /**
	   * @param {String} method
	   * @param {Array|arguments} args
	   * @returns {Query}
	   */
	  '$replicate': function(method, args) {
	    var rec = this.$getRecord();
	    var ref = this.$getMaster();
	    ref = ref[method].apply(ref, args);
	    return new Query(this._ref, Transmogrifier.replicate(rec, ref));
	  }
	};

	util.registerFirebaseWrapper(Query);
	module.exports = Query;
	},{"../../common":25,"./Transmogrifier":17}],12:[function(require,module,exports){
	'use strict';

	var FieldMap           = require('./FieldMap');
	var RecordField        = require('./RecordField');
	var AbstractRecord     = require('./AbstractRecord');
	var SnapshotFactory       = require('./SnapshotFactory');
	var util               = require('../../common');

	function Record(fieldMap) {
	  var name = fieldMap.getPathManager().first().id();
	  var url = util.mergeToString(fieldMap.getPathManager().getUrls());
	  this._super(fieldMap, name, url);
	  this._eventManagers = {};
	  util.log.debug('Record created', this.getName(), this.getUrl());
	}

	util.inherits(Record, AbstractRecord, {
	  makeChild: function(key) {
	    var fm = FieldMap.fieldMap(this.getFieldMap(), key);
	    return new RecordField(fm);
	  },

	  hasChild: function(snaps, key) {
	    var field = this.getFieldMap().getField(key);
	    if( !field ) { return false; }
	    var snap = this.getFieldMap().snapFor(snaps, key);
	    return snap !== null && snap.hasChild(key);
	  },

	  getChildSnaps: function(snaps, fieldName) {
	    var child;
	    var snap = this.getFieldMap().snapFor(snaps, fieldName);
	    var field = this.getFieldMap().getField(fieldName);
	    if( !field ) {
	      child = snap.child(fieldName);
	    }
	    else {
	      switch(field.id) {
	        case '$key':
	          throw new Error('Cannot get child snapshot from key (not a real child element)');
	        case '$value':
	          child = snap;
	          break;
	        default:
	          child = snap.child(field.id);
	      }
	    }
	    return [child];
	  },

	  /**
	   * Given a list of snapshots to iterate, returns the valid keys
	   * which exist in both the snapshots and the field map, in the
	   * order they should be iterated.
	   *
	   * Calls iterator with a {string|number} key for the next field to
	   * iterate only.
	   *
	   * If iterator returns true, this method should abort and return true,
	   * otherwise it should return false (same as Snapshot.forEach).
	   *
	   * @param {Array} snaps
	   * @param {function} iterator
	   * @param {object} [context]
	   * @return {boolean} true if aborted
	   * @abstract
	   */
	  forEachKey: function(snaps, iterator, context) {
	    function shouldIterate(snap, fieldId) {
	      switch(fieldId) {
	        case '$key':
	          return true;
	        case '$value':
	          return snap && snap.val() !== null;
	        default:
	          return snap && snap.hasChild(fieldId);
	      }
	    }
	    var map = this.getFieldMap();
	    return map.forEach(function(field) {
	      var snap = map.snapFor(snaps, field.alias);
	      if( shouldIterate(snap, field.id) ) {
	        return iterator.call(context, field.id, field.alias) === true;
	      }
	      return false;
	    });
	  },

	  /**
	   * Merge the data by iterating the snapshots in reverse order
	   * so that keys from later paths do not overwrite keys from earlier paths
	   *
	   * @param {Array} snaps list of snapshots to be merged
	   * @param {boolean} isExport true if exportVal() was called
	   * @returns {Object}
	   */
	  mergeData: function(snaps, isExport) {
	    var data = null, map = this.getFieldMap();

	    // if the master path is null, the record does not exist
	    // so we do not add any data
	    if( snaps.length > 0 && snaps[0].val() !== null ) {
	      data = util.extend.apply(null, util.map(snaps, function(ss) {
	        return map.extractData(ss, isExport);
	      }));

	      if( isExport && data !== null && snaps[0].getPriority() !== null ) {
	        if( !util.isObject(data) ) {
	          data = {'.value': data};
	        }
	        data['.priority'] = snaps[0].getPriority();
	      }
	    }

	    return data;
	  },

	  getPriority: function(snaps) {
	    return snaps[0].getPriority();
	  },

	  getClass: function() { return Record; },

	  saveData: function(data, props) {
	    var q = util.queue();
	    var map = this.getFieldMap();
	    var paths = this.getPathManager().getPaths();
	    if( props.isUpdate && !util.isObject(data) ) {
	      throw new Error('First argument to update() command must be an object');
	    }
	    if( data === null ) {
	      util.each(paths, function(p) {
	        if( !p.hasDependency() ) {
	          p.reff.remove(q.getHandler());
	        }
	      });
	    }
	    else if(util.isObject(data)) {
	      var denestedData = map.denest(data);
	      util.each(denestedData, function(parts) {
	        var path = parts.path;
	        var dataForPath = parts.data;
	        var ref = this._writeRef(denestedData, path);
	        if( ref !== null ) {
	          if( !util.isEmpty(dataForPath) || !props.isUpdate ) {
	            if( !util.isObject(dataForPath) ) {
	              dataForPath = {'.value': dataForPath};
	            }
	            if( !props.isUpdate ) {
	              addEmptyFields(map, path, dataForPath);
	            }
	            if( util.isDefined(props.priority) ) {
	              dataForPath['.priority'] = props.priority;
	            }
	            if( util.has(dataForPath, '.value') ) {
	              ref.set(dataForPath, q.getHandler());
	            }
	            else {
	              ref.update(dataForPath, q.getHandler());
	            }
	          }
	        }
	        else {
	          util.log.info('No dynamic key found for master', paths[0].ref.toString(), 'with dynamic path', path.ref.toString());
	        }
	      }, this);
	    }
	    else if( paths.length === 1 ) {
	      if( util.isDefined(props.priority) ) {
	        paths[0].ref.setWithPriority(data, props.priority, q.getHandler());
	      }
	      else {
	        paths[0].ref.set(data, q.getHandler());
	      }
	    }
	    else {
	      throw new Error('Cannot set multiple paths to a non-object value. ' +
	        'Since this is a NormalizedCollection, the data will be split between the paths. ' +
	        'But I can\'t split a primitive value');
	    }
	    q.handler(props.callback||util.noop, props.context);
	  },

	  getName: function() {
	    return this._name;
	  },

	  getUrl: function() {
	    return this._url;
	  },

	  _start: function(event) {
	    if( !util.has(this._eventManagers, event) ) {
	      util.log.debug('Record._start: event=%s, url=%s', event, this.getUrl());
	      this._eventManagers[event] = event === 'value'?
	        new ValueEventManager(this) : new ChildEventManager(event, this);
	    }
	    this._eventManagers[event].start();
	  },

	  _stop:   function(event) {
	    if (util.has(this._eventManagers, event)) {
	      util.log.debug('Record._stop: event=%s, url=%s', event, this.getUrl());
	      this._eventManagers[event].stop();
	    }
	  },

	  _writeRef: function(denestedData, path) {
	    var ref = path.reff;
	    var dep = path.getDependency();
	    if( dep !== null ) {
	      var depPath = this.getPathManager().getPath(dep.path);
	      var key = this._depKey(denestedData, depPath, dep.field);
	      ref = key === null? null : ref.child(key);
	    }
	    return ref;
	  },

	  _depKey: function(denestedData, path, fieldId) {
	    var key;
	    var dat = denestedData[path.name()].data;
	    switch(fieldId) {
	      case '$key':
	        key = path.id();
	        break;
	      case '$value':
	        key = util.has(dat, '.value')? dat['.value'] : util.isEmpty(dat)? null : dat;
	        break;
	      default:
	        key = util.has(dat, fieldId)? dat[fieldId] : null;
	    }
	    var type = typeof key;
	    if( key !== null && type !== 'string' ) {
	      throw new Error(
	          'Dynamic key values must be a string. Type was ' +
	          type + ' for ' + path.ref.toString() + '->' + fieldId
	      );
	    }
	    return key;
	  }
	});

	function ValueEventManager(rec) {
	  this.rec = rec;
	  this.pm = rec.getPathManager();
	  this.running = false;
	  this._init();
	}

	ValueEventManager.prototype = {
	  start: function() {
	    if( !this.running ) {
	      this.running = true;
	      util.each(this.pm.getPathNames(), this._startPath, this);
	    }
	  },

	  stop: function() {
	    if( this.running ) {
	      this.running = false;
	      util.each(this.subs, function(fn) {
	        fn();
	      });
	      this._init();
	    }
	  },

	  update: function(pathName, snap) {
	    this.snaps[pathName] = snap;
	    this._checkLoadState();
	    util.log('Record.ValueEventManager.update: url=%s, loadCompleted=%s', snap.ref.toString(), this.loadCompleted);
	    if( this.loadCompleted ) {
	      this.rec.trigger(new SnapshotFactory('value', this.rec.getName(), util.toArray(this.snaps)));
	    }
	  },

	  _startPath: function(pathName) {
	    var self = this;
	    var path = self.pm.getPath(pathName);
	    var fn = util.bind(self.update, self, pathName);
	    if( path.hasDependency() ) {
	      var dyno = new Dyno(path, this.rec.getFieldMap(), 'value', fn);
	      this.subs.push(dyno.dispose);
	    }
	    else {
	      path.ref.on('value', fn);
	      self.subs.push(function() {
	        path.ref.off('value', fn);
	      });
	    }
	  },

	  _checkLoadState: function() {
	    if( this.loadCompleted ) { return; }
	    var snaps = this.snaps;
	    var pathNames = this.pm.getPathNames();
	    this.loadCompleted = !util.contains(pathNames, function(p) {
	      return !snaps.hasOwnProperty(p);
	    });
	  },

	  _init: function() {
	    this.loadCompleted = false;
	    this.snaps = {};
	    this.subs = [];
	  }
	};

	function ChildEventManager(event, rec) {
	  this.event = event;
	  this.rec = rec;
	  this.map = rec.getFieldMap();
	  this.pm = rec.getPathManager();
	  this.subs = [];
	  this.dyno = null;
	}

	ChildEventManager.prototype = {
	  start: function() {
	    util.each(this.pm.getPathNames(), function(pathName) {
	      var event = this.event;
	      var path = this.pm.getPath(pathName);
	      var fn = util.bind(this.update, this);
	      if( path.hasDependency() ) {
	        this.dyno = new Dyno(path, this.map, event, fn);
	        this.subs.push(this.dyno.dispose);
	      }
	      else {
	        path.ref.on(event, fn);
	        this.subs.push(function() {
	          path.ref.off(event, fn);
	        });
	      }
	    }, this);
	  },

	  stop: function() {
	    util.each(this.subs, function(fn) {
	      fn();
	    });
	    this.subs = [];
	  },

	  update: function(snap, prev) {
	    if( snap !== null && this.map.aliasFor(snap.ref.toString()) !== null ) {
	      util.log('Record.ChildEventManager.update: event=%s, key=%s/%s', this.event, snap.ref.parent.key, snap.key);
	      this.rec.trigger(new SnapshotFactory(this.event, snap.key, snap, prev));
	    }
	  }
	};

	/**
	 * Process a path which depends on the value of another field. We have
	 * to monitor the field it depends on for value events and update
	 * the ref that we listen on whenever the id is modified.
	 *
	 * @param {Path} path
	 * @param {FieldMap } fieldMap
	 * @param {string} event
	 * @param {function} updateFn
	 * @constructor
	 */
	function Dyno(path, fieldMap, event, updateFn) {
	  var dep = path.getDependency();
	  var depPath = fieldMap.getPath(dep.path);
	  var depRef = depPath.ref;
	  if( dep.field === '$key' ) {
	    throw new Error('Dynamic paths do not support $key (you should probably just join on this path)');
	  }
	  if( dep.field !== '$value' ) {
	    depRef = depRef.child(dep.field);
	  }
	  var ref;

	  // establish our listener at the field which contains the id of our ref
	  var depFn = depRef.on('value', function(snap) {
	    if( ref && ref.key !== snap.val() ) {
	      util.log.debug('Record.Dyno: stopped monitoring %s', ref.toString());
	      // any time the id changes, remove the old listener
	      ref.off(event, updateFn);
	      updateFn(null);
	    }
	    if( snap.val() !== null ) {
	      // establish our listener at the correct dynamic id for values
	      ref = path.ref.child(snap.val());
	      ref.on(event, updateFn);
	      util.log('Record.Dyno: monitoring %s', ref.toString()); //debug
	    }
	  });

	  // create a dispose method that can turn off all our event listeners
	  // when _stop is called
	  this.dispose = function() {
	    depRef.off('value', depFn);
	    if( ref ) {
	      ref.off(event, updateFn);
	    }
	  };
	}

	function addEmptyFields(map, path, dataToSave) {
	  util.each(map.fieldsFor(path.name()), function(f) {
	    switch(f.id) {
	      case '$key':
	        // ignore key
	        break;
	      case '$value':
	        if( !util.has(dataToSave, '.value') ) {
	          dataToSave['.value'] = null;
	        }
	        break;
	      default:
	        if( !util.has(dataToSave, f.id) ) {
	          dataToSave[f.id] = null;
	        }
	    }
	  });
	}

	module.exports = Record;
	},{"../../common":25,"./AbstractRecord":3,"./FieldMap":4,"./RecordField":13,"./SnapshotFactory":16}],13:[function(require,module,exports){
	'use strict';

	var PathManager        = require('./PathManager');
	var FieldMap           = require('./FieldMap');
	var AbstractRecord     = require('./AbstractRecord');
	var SnapshotFactory       = require('./SnapshotFactory');
	var util               = require('../../common');

	function RecordField(fieldMap) {
	  this.handlers = {};
	  this.path = fieldMap.getPathManager().first();
	  this._super(fieldMap, this.path.name(), this.path.url());
	  if( fieldMap.getPathManager().count() !== 1 ) {
	    throw new Error('RecordField must have exactly one path, but we got '+ fieldMap.getPathManager().count());
	  }
	  if( fieldMap.length !== 1 ) {
	    throw new Error('RecordField must have exactly one field, but we found '+ fieldMap.length);
	  }
	  util.log.debug('RecordField created', this.getName(), this.getUrl());
	}

	util.inherits(RecordField, AbstractRecord, {
	  makeChild: function(key) {
	    var pm = new PathManager([this.path.child(key)]);
	    var fm = new FieldMap(pm);
	    fm.add({key: FieldMap.key(pm.first(), '$value'), alias: key});
	    return new RecordField(fm);
	  },

	  hasChild: function(snaps, key) {
	    return snaps[0].hasChild(key);
	  },

	  getChildSnaps: function(snaps, fieldName) {
	    // there is exactly one snap and there are no aliases to deal with
	    return [snaps[0].child(fieldName)];
	  },

	  /**
	   * There is nothing to merge at this level because there is only one
	   * path and no field map
	   *
	   * @param {Array} snaps list of snapshots to be merged
	   * @param {boolean} isExport true if exportVal() was called
	   * @returns {Object}
	   */
	  mergeData: function(snaps, isExport) {
	    return isExport? snaps[0].exportVal() : snaps[0].val();
	  },

	  getPriority: function(snaps) {
	    return snaps[0].getPriority();
	  },

	  /**
	   * Iterates all keys of snapshot.
	   *
	   * Calls iterator with a {string|number} key for the next field to
	   * iterate only.
	   *
	   * If iterator returns true, this method should abort and return true,
	   * otherwise it should return false (same as Snapshot.forEach).
	   *
	   * @param {Array} snaps
	   * @param {function} iterator
	   * @param {object} [context]
	   * @return {boolean} true if aborted
	   * @abstract
	   */
	  forEachKey: function(snaps, iterator, context) {
	    var firstSnap = snaps[0];
	    return firstSnap.forEach(function(ss) {
	      iterator.call(context, ss.key, ss.key);
	    });
	  },

	  saveData: function(data, opts) {
	    var ref = this.path.ref;
	    if( opts.isUpdate ) {
	      if( !util.isObject(data) ) {
	        throw new Error('When using update(), the data must be an object.');
	      }
	      if( util.has(opts, 'priority') ) {
	        data['.priority'] = opts.priority;
	      }
	      ref.update(data, wrapCallback(opts));
	    }
	    else if( util.has(opts, 'priority') ) {
	      ref.setWithPriority(data, opts.priority, wrapCallback(opts));
	    }
	    else {
	      ref.set(data, wrapCallback(opts));
	    }
	  },

	  getClass: function() { return RecordField; },

	  _start: function(event) {
	    var self = this;
	    this.handlers[event] = function(snap, prev) {
	      self.trigger(new SnapshotFactory(event, snap.key, snap, prev));
	    };
	    this.path.ref.on(event, this.handlers[event], this._cancel, this);
	  },

	  _stop:   function(event) {
	    if( this.handlers.hasOwnProperty(event) ) {
	      this.path.ref.off(event, this.handlers[event], this);
	    }
	  }
	});

	function wrapCallback(opts) {
	  if( opts.callback ) {
	    return function() {
	      opts.callback.apply(opts.context, arguments);
	    };
	  }
	  else {
	    return util.noop;
	  }
	}

	module.exports = RecordField;
	},{"../../common":25,"./AbstractRecord":3,"./FieldMap":4,"./PathManager":10,"./SnapshotFactory":16}],14:[function(require,module,exports){
	'use strict';

	var Record = require('./Record');
	var AbstractRecord = require('./AbstractRecord');
	var util = require('../../common');
	var FieldMap = require('./FieldMap');
	var RecordSetEventManager = require('./RecordSetEventManager');

	/**
	 * A "Record" (see AbstractRecord) represents a merged set of data used by NormalizedRef.
	 * It is used by NormalizedRef to create snapshots and monitor Firebase for data changes.
	 *
	 * A RecordSet represents the root level of NormalizedCollection's output. It is a list of
	 * collections (from multiple paths in Firebase) to be joined together.
	 *
	 * This is, for the purposes of a NormalizedCollections, the root of the data. Calls to parent()
	 * from here should return null, just like they would from the root of a Firebase. This is because
	 * the parent of a normalized collection is ambiguous, so there is no higher level of data.
	 *
	 * @param fieldMap this is the field map to be applied to each Record created when calling child()
	 * @param whereClause this filters the output data and events
	 * @constructor
	 */
	function RecordSet(fieldMap, whereClause) {
	  var name = util.mergeToString(fieldMap.getPathManager().getPathNames());
	  var url = util.mergeToString(fieldMap.getPathManager().getUrls());

	  // AbstractRecord makes this observable and abstracts some common impl details
	  // between RecordSet, Record, and RecordField
	  this._super(fieldMap, name, url);

	  // Used to filter the merged data and determine which merged Records should trigger events and
	  // which ones should be ignored
	  this.filters = whereClause;

	  // the RecordSetEventManager handles Firebase events and calls event handlers on
	  // this RecordSet appropriately. See RecordSetEventManager for more details
	  this.monitor = new RecordSetEventManager(this);
	}

	util.inherits(RecordSet, AbstractRecord, {
	  makeChild: function(key) {
	    var fm = FieldMap.recordMap(this.getFieldMap(), key);
	    return new Record(fm);
	  },

	  /**
	   * Override AbstractRecord's hasChild since we are dealing
	   * with record ids at this level. We use the master list to determine
	   * if records exist, so it's a pretty straightforward hasChild
	   * on the first snapshot.
	   *
	   * @param {Array} snaps a list of array snapshots to test for child
	   * @param {string} key
	   */
	  hasChild: function(snaps, key) {
	    return util.contains(snaps, function(s) {
	      return s.key() === key;
	    });
	  },

	  getChildSnaps: function(snapsArray, recordId) {
	    return util.filter(snapsArray, function(s) {
	      return s.key() === recordId;
	    });
	  },

	  /**
	   * Since the snapshots attached to this level are records, there isn't much
	   * to do for a merge. Just put them all together.
	   *
	   * @param {Array} snaps list of snapshots to be merged
	   * @param {boolean} isExport true if exportVal() was called
	   * @returns {Object}
	   */
	  mergeData: function(snaps, isExport) {
	    var self = this, out = null;
	    // if the master path is empty, there is no data to be merged
	    if( snaps.length && snaps[0].val() !== null ) {
	      out = {};
	      util.each(snaps, function(snap) {
	        if( snap.val() !== null && self.filters.test(snap.val(), snap.key, snap.getPriority()) ) {
	          out[snap.key] = isExport? snap.exportVal() : snap.val();
	        }
	      });
	    }
	    return out;
	  },

	  getPriority: function() {
	    return null;
	  },

	  /**
	   * Given a list of snapshots to iterate, returns the valid keys
	   * which exist in both the snapshots and the field map, in the
	   * order they should be iterated.
	   *
	   * Calls iterator with a {string|number} key for the next field to
	   * iterate only.
	   *
	   * If iterator returns true, this method should abort and return true,
	   * otherwise it should return false (same as Snapshot.forEach).
	   *
	   * @param {Array} snaps
	   * @param {function} iterator
	   * @param {object} [context]
	   * @return {boolean} true if aborted
	   * @abstract
	   */
	  forEachKey: function(snaps, iterator, context) {
	    snaps.forEach(function(snap) {
	      return iterator.call(context, snap.key, snap.key);
	    });
	  },

	  getClass: function() { return RecordSet; },

	  /**
	   * Saving a record set is done by grabbing each child record and calling save against that.
	   * This is the easiest approach since we must distribute fields to each appropriate path.
	   * It might be more efficient to bulk these into a single write op, and perhaps we should
	   * explore that if this proves to be slow.
	   *
	   * @param data
	   * @param {Object} opts
	   */
	  saveData: function(data, opts) {
	    var q = util.queue();
	    if( data === null ) {
	      util.each(this.getPathManager().getPaths(), function(path) {
	        path.ref.remove(q.getHandler());
	      });
	    }
	    else if( !util.isObject(data) ) {
	      throw new Error('Calls to set() or update() on a NormalizedCollection must pass either ' +
	          'null or an object value. There is no way to split a primitive value between the paths');
	    }
	    else {
	      util.each(data, function(v, k) {
	        if( k === '.value' || k === '.priority' ) {
	          throw new Error('Cannot use .priority or .value on the root path of a NormalizedCollection. ' +
	              'You probably meant to sort the records anyway (i.e. one level lower).');
	        }
	        this.child(k).saveData(v, {isUpdate: opts.isUpdate, callback: q.getHandler()});
	      }, this);
	      if( opts.priority ) {
	        this.getPathManager().first().ref.setPriority(opts.priority, q.getHandler());
	      }
	    }
	    q.handler(opts.callback||util.noop, opts.context);
	  },

	  /**
	   * Return the correct child key for a snapshot by determining if its corresponding path
	   * has dependencies. If so, we look up the id and return that child, otherwise, we just
	   * return the child for the recordId.
	   *
	   * If a dependency exists, but the required field is null or invalid, then we just return
	   * null in place of the snapshot.
	   *
	   * @private
	   */
	  _getChildKey: function(snap, snapsArray, recordId) {
	    var key = recordId;
	    var path = this.getPathManager().getPathFor(snap.ref.toString());
	    // resolve any dependencies to determine the child key's value
	    if( path.hasDependency() ) {
	      var dep = path.getDependency();
	      var depPath = this.getFieldMap().getPath(dep.path);
	      if( !depPath ) {
	        throw new Error('Invalid dependency path. ' + snap.ref.toString() +
	        ' depends on ' + dep.path +
	        ', but that alias does not exist in the paths provided.');
	      }
	      var depSnap = util.find(snapsArray, function(snap) {
	        return snap.ref.toString() === depPath.url();
	      });
	      if( depSnap ) {
	        depSnap = depSnap.child(recordId);
	        if( dep.field !== '$value' ) {
	          depSnap = depSnap.child(dep.field);
	        }
	        key = depSnap.val();
	      }
	      else {
	        key = null;
	      }
	    }
	    return key;
	  },

	  _start: function() {
	    this.monitor.start();
	  },

	  _stop:   function(event, count) {
	    if( count === 0 ) { this.monitor.stop(); }
	  }
	});

	module.exports = RecordSet;
	},{"../../common":25,"./AbstractRecord":3,"./FieldMap":4,"./Record":12,"./RecordSetEventManager":15}],15:[function(require,module,exports){
	'use strict';

	var SnapshotFactory = require('./SnapshotFactory');
	var util = require('../../common');

	/**
	 * Monitors the references attached to a RecordSet and maintains a cache of
	 * current snapshots (inside RecordList below). Any time there is an update, this calls
	 * RecordSet.trigger() to notify event listeners.
	 *
	 * @param parentRec
	 * @constructor
	 */
	function RecordSetEventManager(parentRec) {
	  var pm = parentRec.getPathManager();
	  this.masterRef = pm.first().ref;
	  this.url = this.masterRef.toString();
	  this.recList = new RecordList(parentRec, this.url);
	  this.running = false;
	}

	RecordSetEventManager.prototype = {
	  start: function() {
	    if( !this.running ) {
	      util.log('RecordSetEventManager: Loading normalized records from master list %s', this.url);
	      this.running = true;
	      this.masterRef.on('child_added',   this._add,    this);
	      this.masterRef.on('child_removed', this._remove, this);
	      this.masterRef.on('child_moved',   this._move,   this);
	      // make sure all existing keys are loaded into memory before we let recList trigger value events
	      this.masterRef.once('value', this.recList.masterPathLoaded, this.recList);
	    }
	    return this;
	  },

	  stop: function() {
	    if( this.running ) {
	      util.log('RecordSetEventManager: Stopped monitoring master list %s', this.url);
	      this.running = false;
	      this.masterRef.off('child_added',   this._add,    this);
	      this.masterRef.off('child_removed', this._remove, this);
	      this.masterRef.off('child_moved',   this._move,   this);
	      this.recList.unloaded();
	    }
	    return this;
	  },

	  _add: function(snap, prevChild) {
	    this.recList.add(snap.key, prevChild);
	  },

	  _remove: function(snap) {
	    this.recList.remove(snap.key);
	  },

	  _move: function(snap, prevChild) {
	    this.recList.move(snap.key, prevChild);
	  }
	};

	function RecordList(observable, url) {
	  this.obs = observable;
	  this.url = url;
	  this._reset();
	}

	RecordList.prototype = {
	  add: function(key, prevChild) {
	    util.log.debug('RecordList.add: key=%s, prevChild=%s', key, prevChild);
	    var rec = this.obs.child(key);
	    var fn = util.bind(this._valueUpdated, this, key);
	    this.loading[key] = {rec: rec, prev: prevChild, fn: fn, unwatch: function() { rec.unwatch('value', fn); }};
	    if( !this.loadComplete ) {
	      this.initialKeysLeft.push(key);
	    }
	    rec.watch('value', fn);
	  },

	  remove: function(key) {
	    util.log.debug('RecordList.remove: key=%s', key);
	    var oldSnap = this._dropRecord(key);
	    if( oldSnap !== null ) {
	      this._notify('child_removed', key, oldSnap);
	    }
	  },

	  move: function(key, prevChild) {
	    if(util.has(this.recs, key)) {
	      var currPos = util.indexOf(this.recIds, key);
	      this.recIds.splice(currPos, 1);
	      this._putAfter(key, prevChild);
	      this._notify('child_moved', key);
	    }
	  },

	  masterPathLoaded: function() {
	    util.log.debug('RecordList: Initial data has been loaded from master list at %s', this.url);
	    this.masterLoaded = true;
	    if( this._checkLoadState() ) {
	      this._notifyValue();
	    }
	  },

	  unloaded: function() {
	    this._reset();
	  },

	  findKey: function(key) {
	    return util.indexOf(this.recIds, key);
	  },

	  _reset: function() {
	    util.each(this.recs, function(rec, key) {
	      this.remove(key);
	    }, this);
	    util.each(this.filtered, function(rec, key) {
	      this._dropRecord(key);
	    }, this);
	    util.each(this.loading, function(rec, key) {
	      this._dropRecord(key);
	    }, this);
	    this.recs = {};
	    this.recIds = [];
	    this.snaps = {};
	    this.loading = {};
	    this.filtered = {};
	    this.loadComplete = false;
	    this.initialKeysLeft = [];
	    this.masterLoaded = false;
	  },

	  _valueUpdated: function(key, snap) {
	    var rec;
	    this.snaps[key] = snap;
	    if(util.has(this.loading, key)) {
	      // record has finished loading and merging paths
	      rec = this.loading[key];
	      delete this.loading[key];
	      this._processAdd(snap, rec);
	    }
	    else if(util.has(this.recs, key)) {
	      rec = this.recs[key];
	      this._processChange(snap, rec);
	    }
	    else if(util.has(this.filtered, key)) {
	      if( snap.val() !== null && this.obs.filters.test(snap.val(), key, snap.getPriority()) ) {
	        // the record data has changed and it is no longer part of the filtered
	        // content, so treat it as a newly added record
	        rec = this.filtered[key];
	        delete this.filtered[key];
	        util.log('RecordList: Unfiltered key %s', key);
	        this._processAdd(snap, rec);
	      }
	    }
	    else {
	      util.log('RecordList: Orphan key %s ignored. Probably a concurrent edit.', key);
	    }
	  },

	  _processAdd: function(snap, rec) {
	    var key = snap.key;
	    if( this.obs.filters.test(snap.val(), key, snap.getPriority()) ) {
	      this.recs[key] = rec;
	      this._putAfter(key, rec.prev);
	      this._notify('child_added', key);
	    }
	    else {
	      util.log('RecordList: Filtered key %s', key);
	      this.filtered[key] = rec;
	    }
	    if( this._checkLoadState(key) ) {
	      this._notifyValue();
	    }
	  },

	  _processChange: function(snap, rec) {
	    // null records are valid at the record level and can trigger value events, but at
	    // the Set level, they mean the record is in the process of being deleted so we
	    // ignore the value event here
	    if( snap.val() !== null ) {
	      var key = snap.key;
	      if( this.obs.filters.test(snap.val(), key, snap.getPriority()) ) {
	        // a changed record that has not been filtered
	        this._notify('child_changed', key);
	      }
	      else {
	        // record changes caused it to become filtered, so treat it as a removed rec
	        // however, we'll continue to watch it for changes so it can be unfiltered later
	        delete this.recs[key];
	        this.filtered[key] = rec;
	        this._notify('child_removed', key, this.snaps[key]);
	      }
	    }
	  },

	  _notify: function(event, key, oldSnap) {
	    var prev;
	    if( event === 'child_added' || event === 'child_moved' ) {
	      prev = this._getPrevChild(key);
	    }
	    util.log('RecordList._notify: event=%s, key=%s, prev=%s', event, key, prev);
	    var factory = new SnapshotFactory(event, key, oldSnap||this.snaps[key], prev);
	    this.obs.trigger(factory);
	    this._notifyValue();
	  },

	  _notifyValue: function() {
	    if( this.loadComplete ) {
	      util.log.debug('RecordList._notifyValue: snap_keys=%s', util.keys(this.snaps));
	      var factory = new SnapshotFactory('value', null, util.toArray(this.snaps));
	      this.obs.trigger(factory);
	    }
	  },

	  _getPrevChild: function(key) {
	    if( !this.recIds.length ) { return null; }
	    var pos = this.findKey(key);
	    if( pos === -1 ) {
	      return this.recIds[this.recIds.length-1];
	    }
	    else if( pos === 0 ) {
	      return null;
	    }
	    else {
	      return this.recIds[pos-1];
	    }
	  },

	  _posFor: function(prevKey) {
	    var pos, x;
	    if( prevKey === null ) {
	      pos = 0;
	    }
	    else {
	      x = this.findKey(prevKey);
	      pos = x === -1? this.recIds.length : x+1;
	    }
	    return pos;
	  },

	  _putAfter: function(key, prevChild) {
	    var newPos = this._posFor(prevChild);
	    this.recIds.splice(newPos, 0, key);
	  },

	  _dropRecord: function(key) {
	    var res = null;
	    if(this.recs[key]) {
	      res = this.snaps[key];
	      this.recs[key].unwatch();
	    }
	    if(this.loading[key]) {
	      this.loading[key].unwatch();
	    }
	    if(util.has(this.filtered, key)) {
	      this.filtered[key].unwatch();
	    }
	    delete this.loading[key];
	    delete this.snaps[key];
	    delete this.filtered[key];
	    delete this.recs[key];
	    util.remove(this.recIds, key);
	    return res;
	  },

	  /**
	   * Because the initial once('value') will probably trigger before all the child paths
	   * are retrieved (remember that we are monitoring multiple paths per child), we need
	   * to wait for them to load in before triggering our first value event.
	   * @private
	   */
	  _checkLoadState: function(key) {
	    if( !this.loadComplete ) {
	      if( key ) {
	        util.remove(this.initialKeysLeft, key);
	      }
	      if( !this.initialKeysLeft.length && this.masterLoaded ) {
	        this.loadComplete = true;
	        return true;
	      }
	    }
	    return false;
	  }
	};

	module.exports = RecordSetEventManager;
	},{"../../common":25,"./SnapshotFactory":16}],16:[function(require,module,exports){

	'use strict';

	var util = require('../../common');
	var NormalizedSnapshot = require('./NormalizedSnapshot.js');

	function SnapshotFactory(event, key, snaps, prevChild) {
	  this.event = event;
	  this.key = key;
	  this.snaps = unwrapSnapshots(snaps);
	  this.prevChild = prevChild;
	  assertValidTrigger(this);
	}

	SnapshotFactory.prototype.create = function(ref) {
	  var snapshot;
	  if( this.event === 'value' ) {
	    snapshot = new NormalizedSnapshot(ref, this.snaps);
	  }
	  else {
	    snapshot = new NormalizedSnapshot(ref.ref.child(this.key), this.snaps);
	  }
	  return snapshot;
	};

	SnapshotFactory.prototype.toString = function() {
	  return util.printf(
	    'SnapshotFactory(event=%s, key=%s, numberOfSnapshots=%s, prevChild=%s',
	    this.event, this.key, this.snaps.length, this.prevChild === util.undef? 'undefined' : this.prevChild
	  );
	};

	function assertValidTrigger(trigger) {
	  switch(trigger.event) {
	    case 'value':
	      break;
	    case 'child_added':
	    case 'child_moved':
	      if( typeof trigger.key !== 'string' || !trigger.key ) {
	        throw new Error('Invalid trigger key ' + trigger.key);
	      }
	      if( trigger.prevChild === util.undef ) {
	        throw new Error('Triggers must provide a valid prevChild value for child_added and child_moved events');
	      }
	      break;
	    case 'child_removed':
	    case 'child_changed':
	      if( typeof trigger.key !== 'string' || !trigger.key ) {
	        throw new Error('Invalid trigger key ' + trigger.key);
	      }
	      break;
	    default:
	      throw new Error('Invalid trigger event type: ' + trigger.event);
	  }
	}

	function unwrapSnapshots(snaps) {
	  if( snaps instanceof NormalizedSnapshot ) {
	    return snaps._snaps.slice();
	  }
	  if( !util.isArray(snaps) ) {
	    return [snaps];
	  }
	  return snaps.slice();
	}

	module.exports = SnapshotFactory;
	},{"../../common":25,"./NormalizedSnapshot.js":8}],17:[function(require,module,exports){
	'use strict';

	var util        = require('../../common');
	var PathManager = require('./PathManager');
	var Path        = require('./Path');
	var FieldMap    = require('./FieldMap');
	var RecordSet   = require('./RecordSet');

	module.exports = {
	  replicate: function(record, newMasterRef) {
	    // create a new set of paths
	    var paths = record.getPathManager().getPaths().slice(0);
	    var firstPath = paths[0];
	    paths[0] = new Path([newMasterRef, firstPath.name(), firstPath.getDependency()]);
	    var mgr = new PathManager(util.map(paths, function(p) { return p.clone(); }));

	    // create a new field map from the updated paths
	    var fieldMap = new FieldMap(mgr);
	    record.getFieldMap().forEach(fieldMap.add, fieldMap);

	    // recreate the AbstractRecord instance
	    var Clazz = record.getClass();
	    var rec;
	    if( Clazz === RecordSet ) {
	      rec = new Clazz(fieldMap, record.filters);
	    }
	    else {
	      rec = new Clazz(fieldMap);
	    }

	    // done!
	    return rec;
	  }
	};
	},{"../../common":25,"./FieldMap":4,"./Path":9,"./PathManager":10,"./RecordSet":14}],18:[function(require,module,exports){
	'use strict';
	var util = require('../common');
	var Scroll = require('./libs/Scroll.js');
	var Paginate = require('./libs/Paginate.js');
	var ReadOnlyRef = require('./libs/ReadOnlyRef.js');

	var DEFAULTS = {
	  field: null,
	  pageSize: 10,
	  windowSize: 250
	};

	exports.Scroll = function(baseRef, sortField, opts) {
	  if( !util.isFirebaseRef(baseRef) || util.isQueryRef(baseRef) ) {
	    throw new Error('First argument to Firebase.util.Scroll must be a valid Firebase ref. It cannot be a Query (e.g. you have called orderByChild()).');
	  }

	  if( typeof sortField !== 'string' ) {
	    throw new Error('Second argument to Firebase.util.Scroll must be a valid string');
	  }
	  if( arguments.length > 2 && !util.isObject(opts) ) {
	    throw new Error('Optional third argument to Firebase.util.Scroll must be an object of key/value pairs');
	  }
	  var ref = new ReadOnlyRef(baseRef);
	  ref.scroll = new Scroll(ref, sortField, calcOpts(opts, 'windowSize', 'Scroll'));
	  return ref;
	};

	exports.Paginate = function(baseRef, sortField, opts) {
	  if( !util.isFirebaseRef(baseRef) || util.isQueryRef(baseRef) ) {
	    throw new Error('First argument to Firebase.util.Paginate must be a valid Firebase ref. It cannot be a Query (e.g. you have called orderByChild()).');
	  }
	  if( typeof sortField !== 'string' ) {
	    throw new Error('Second argument to Firebase.util.Paginate must be a valid string');
	  }
	  if( arguments.length > 2 && !util.isObject(opts) ) {
	    throw new Error('Optional third argument to Firebase.util.Paginate must be an object of key/value pairs');
	  }
	  var ref = new ReadOnlyRef(baseRef);
	  ref.page = new Paginate(ref, sortField, calcOpts(opts, 'pageSize', 'Paginate'));
	  return ref;
	};

	function calcOpts(opts, maxFromKey, method) {
	  var res = util.extend({}, DEFAULTS, opts);
	  if( !res.maxCacheSize ) {
	    res.maxCacheSize = res[maxFromKey] * 3;
	  }
	  assertNumber(res, maxFromKey, method);
	  assertNumber(res, 'maxCacheSize', method);
	  return res;
	}

	function assertNumber(obj, key, method) {
	  if( typeof obj[key] !== 'number' ) {
	    throw new Error('Argument ' + key + ' passed into opts for ' + method + 'must be a number' );
	  }
	}
	},{"../common":25,"./libs/Paginate.js":21,"./libs/ReadOnlyRef.js":22,"./libs/Scroll.js":23}],19:[function(require,module,exports){
	'use strict';
	var util = require('../../common');
	var Offset = require('./Offset');

	function Cache(outRef, sortField, maxRecordsLoaded) {
	  util.log.debug('Cache: caching %s using field=%s maxRecordsLoaded=%d', outRef.toString(), sortField, maxRecordsLoaded);
	  this.offset = new Offset({field: sortField, max: maxRecordsLoaded, ref: outRef.ref});
	  this.outRef = outRef;
	  this.inRef = null;
	  this.queryRef = null;
	  this.countRef = null;
	  this.keys = {};
	  this.start = 0;
	  this.count = -1;
	  this.endCount = -1;
	  this.nextListeners = [];
	  this.offset.observe(this._keyChange, this);
	}

	Cache.prototype.moveTo = function(startOffset, numberOfRecords) {
	  util.log.debug('Cache.moveTo: startOffset=%d, numberOfRecords=%d', startOffset, numberOfRecords);
	  var s = this.start, e = this.count;
	  this.start = startOffset;
	  this.count = numberOfRecords;
	  this.endCount = this.start + this.count;
	  if( s !== this.start ) {
	    this.offset.goTo(startOffset, numberOfRecords);
	  }
	  else if( e !== this.count ) {
	    this._refChange();
	  }
	};

	Cache.prototype.hasNext = function() {
	  return this.count === -1 || this.endCount > this.start + this.count;
	};

	Cache.prototype.hasPrev = function() {
	  return this.start > 0;
	};

	Cache.prototype.observeHasNext = function(callback, context) {
	  var list = this.nextListeners;
	  var parts = [callback, context];
	  list.push(parts);
	  return function() {
	    util.remove(list, parts);
	  };
	};

	Cache.prototype.destroy = function() {
	  this._unsubscribe();
	  this.offset.destroy();
	  this.offset = null;
	  this.start = 0;
	  this.count = -1;
	  this.inRef = null;
	  this.outRef = null;
	  this.queryRef = null;
	  this.countRef = null;
	  this.keys = null;
	  this.nextListeners = null;
	};

	Cache.prototype._keyChange = function(val, key, ref) {
	  this.inRef = ref;
	  util.log.debug('Cache._keyChange: %s %s %s', val, key, ref.toString());
	  this._refChange();
	};

	Cache.prototype._unsubscribe = function() {
	  if( this.queryRef ) {
	    this.queryRef.off('child_added', this._add, this);
	    this.queryRef.off('child_removed', this._remove, this);
	    this.queryRef.off('child_moved', this._move, this);
	    this.queryRef.off('child_changed', this._change, this);
	    this.queryRef.off('value', this._value, this);
	    this.queryRef.off('value', this._removeOrphans, this);
	    this.queryRef = null;
	  }
	  if( this.countRef ) {
	    this.countRef.off('value', this._count, this);
	    this.countRef = null;
	  }
	};

	Cache.prototype._refChange = function() {
	  this._unsubscribe();
	  if( this.inRef && this.count > -1 ) {
	    this.countRef = this.inRef.limitToFirst(this.count+1);
	    this.countRef.on('value', this._count, this);
	    //todo we should queue all the events until the once('value') is completed
	    //todo so that we can trigger removed before added
	    this.queryRef = this.inRef.limitToFirst(this.count);
	    this.queryRef.on('child_added', this._add, this);
	    this.queryRef.on('child_removed', this._remove, this);
	    this.queryRef.on('child_moved', this._move, this);
	    this.queryRef.on('child_changed', this._change, this);
	    this.queryRef.on('value', this._value, this);
	    this.queryRef.once('value', this._removeOrphans, this);
	  }
	};

	Cache.prototype._add = function(snap, prevChild) {
	  var key = snap.key;
	  if( !util.has(this.keys, key) ) {
	    this.keys[key] = snap;
	    this.outRef.$trigger('child_added', snap, prevChild);
	  }
	  else if( !util.isEqual(this.keys[key], snap.val()) ) {
	    this._change(snap);
	  }
	};

	Cache.prototype._remove = function(snap) {
	  var key = snap.key;
	  if( util.has(this.keys, key) ) {
	    this.outRef.$trigger('child_removed', snap);
	    delete this.keys[key];
	  }
	};

	Cache.prototype._move = function(snap, prevChild) {
	  var key = snap.key;
	  if( util.has(this.keys, key) ) {
	    this.keys[key] = snap;
	    this.outRef.$trigger('child_moved', snap, prevChild);
	  }
	};

	Cache.prototype._change = function(snap) {
	  this.keys[snap.key] = snap;
	  this.outRef.$trigger('child_changed', snap);
	};

	Cache.prototype._value = function(snap) {
	  this.outRef.$trigger('value', snap);
	};

	Cache.prototype._count = function(snap) {
	  this.endCount = this.start + snap.numChildren();
	  var hasNext = this.hasNext();
	  util.each(this.nextListeners, function(parts) {
	    parts[0].call(parts[1], hasNext);
	  });
	};

	Cache.prototype._removeOrphans = function(valueSnap) {
	  util.each(this.keys, function(cachedSnap, key) {
	    if( !valueSnap.hasChild(key) ) {
	      this.outRef.$trigger('child_removed', cachedSnap);
	      delete this.keys[key];
	    }
	  }, this);
	};

	module.exports = Cache;
	},{"../../common":25,"./Offset":20}],20:[function(require,module,exports){
	'use strict';
	var util = require('../../common');

	function Offset(opts) {
	  this.keys = [];
	  this.field = opts.field;
	  this.ref = baseRef(opts.ref, opts.field);
	  this.max = opts.max;
	  this.listeners = [];
	  this.curr = 0;
	  this.sub = null;
	  this.isSubscribing = false;
	  this.lastNotifyValue = util.undef;
	  this._debouncedRecache = debounce(function() {
	    util.log.debug('Offset._debouncedRecache: recaching keys for offset %d', this.curr);
	    this.keys = [];
	    this._grow(this._listen);
	  }, this, 100, 1000);
	}

	Offset.prototype.goTo = function(newOffset) {
	  if( newOffset !== this.curr ) {
	    util.log('Offset.goTo: offset changed from %d to %d', this.curr, newOffset);
	    this.curr = newOffset;
	    this.lastNotifyValue = util.undef;
	    this._listen();
	  }
	};

	Offset.prototype.observe = function(callback, context) {
	  this.listeners.push([callback, context]);
	  var key = this.getKey();
	  var ref = offsetRef(this.ref, key);
	  callback.call(context, key && key.val, key && key.key, ref);
	};

	Offset.prototype.getKey = function(offset) {
	  if( !arguments.length ) { offset = this.curr; }
	  if( offset === 0 ) { return null; }
	  return this.keys.length > offset && this.keys[offset];
	};

	Offset.prototype.destroy = function() {
	  this._unsubscribe();
	  this.curr = 0;
	  this.keys = [];
	  this.lastNotifyValue = util.undef;
	  this.isSubscribing = false;
	};

	Offset.prototype._notify = function() {
	  var key = this.getKey();
	  if( !util.isEqual(this.lastNotifyValue, key) ) {
	    util.log('Offset._notify: key at offset %d is %s', this.curr, key && key.key);
	    this.lastNotifyValue = key;
	    var ref = offsetRef(this.ref, key);
	    util.each(this.listeners, function(parts) {
	      parts[0].call(parts[1], key && key.val, key && key.key, ref);
	    });
	  }
	};

	Offset.prototype._recache = function() {
	  if( !this.isSubscribing ) {
	    this._debouncedRecache();
	  }
	};

	var killCount = 0;
	Offset.prototype._grow = function(callback) {
	  var self = this;
	  var len = self.keys.length;
	  if( self.curr >= len ) {
	    var oldKey = self.getKey();
	    var startAt = lastKey(self.keys);
	    var limit = Math.min(self.curr + (startAt? 2 : 1) - len, self.max);
	    var ref = startAt !== null? self.ref.startAt(startAt.val, startAt.key) : self.ref;
	    ref.limitToFirst(limit).once('value', function(snap) {
	      var skipFirst = startAt !== null;
	      snap.forEach(function(ss) {
	        if( skipFirst ) {
	          skipFirst = false;
	          return;
	        }
	        self.keys.push(extractKey(ss, self.field));
	      });
	      if( killCount++ > 10000 ) {
	        throw new Error('Tried to fetch more than 10,000 pages to determine the correct offset. Giving up now. Sorry.');
	      }
	      if( self.curr >= self.keys.length && snap.numChildren() === limit ) {
	        // prevents recursive scoping
	        setTimeout(util.bind(self._grow, self, callback), 0);
	      }
	      else {
	        killCount = 0;
	        util.log.debug('Offset._grow: Cached %d keys', self.keys.length);
	        callback.call(self, !util.isEqual(self.getKey(), oldKey));
	      }
	    });
	  }
	  else {
	    callback.call(self, false);
	  }
	};

	Offset.prototype._startOffset = function() {
	  return Math.max(0, this.curr - this.max, this.curr - 10);
	};

	Offset.prototype._queryRef = function() {
	  var start = this._startOffset();
	  var ref = this.ref;
	  if( start > 0 ) {
	    var key = this.getKey(start);
	    ref = ref.startAt(key.val, key.key);
	  }
	  return ref.limitToLast(Math.max(this.curr - start, 1));
	};

	Offset.prototype._moved = function(snap) {
	  if( snap.key === this.getKey() ) {
	    this._recache();
	  }
	};

	Offset.prototype._unsubscribe = function() {
	  if( this.sub ) {
	    this.sub.off('child_added', this._recache, this);
	    this.sub.off('child_moved', this._moved, this);
	    this.sub.off('child_removed', this._recache, this);
	    this.sub.off('value', this._doneSubscribing, this);
	    this.sub = null;
	  }
	};

	Offset.prototype._subscribe = function() {
	  this._unsubscribe();
	  this.sub = this._queryRef();
	  this.isSubscribing = true;
	  this.sub.on('child_added', this._recache, this);
	  this.sub.on('child_moved', this._moved, this);
	  this.sub.on('child_removed', this._recache, this);
	  this.sub.once('value', this._doneSubscribing, this);
	};

	Offset.prototype._doneSubscribing = function() {
	  this.isSubscribing = false;
	  this._notify();
	};

	Offset.prototype._monitorEmptyOffset = function() {
	  var self = this;
	  var ref = self.ref;
	  var key = null;
	  function fn(snap) {
	    var count = snap.numChildren();
	    if( count > (key === null? 0 : 1) ) {
	      util.log.debug('Offset._monitorEmptyOffset: A value exists now.');
	      ref.off('value', fn);
	      self._grow();
	    }
	  }
	  if( this.keys.length ) {
	    key = lastKey(this.keys);
	    ref = ref.startAt(key.val, key.key);
	  }
	  util.log.debug('Offset._monitorEmptyOffset: No value exists at offset %d, currently %d keys at this path. Watching for a new value.', this.curr, this.keys.length);
	  ref.limitToFirst(2).on('value', fn);
	};

	Offset.prototype._listen = function() {
	  this._unsubscribe();
	  if( this.curr >= this.keys.length ) {
	    this._grow(function(/*changed*/) {
	      if( this.keys.length >= this.curr ) {
	        this._subscribe();
	      }
	      else {
	        this._monitorEmptyOffset();
	        this._notify();
	      }
	    });
	  }
	  else {
	    this._subscribe();
	  }
	};

	function extractKey(snap, field) {
	  var v;
	  switch(field) {
	    case '$key':
	      v = snap.key;
	      break;
	    case '$priority':
	      v = snap.getPriority();
	      break;
	    case '$value':
	      v = snap.val();
	      break;
	    default:
	      var obj = snap.val();
	      if( !util.isObject(obj) ) {
	        throw new Error('A value of type ' + typeof obj + 'Was found. ' +
	        'But we are attempting to order by child field "' + field + '". ' +
	        'Pagination requires all records to be objects or it can\'t determine an ' +
	        'appropriate offset value.');
	      }
	      else {
	        v = obj[field];
	      }
	  }
	  return {val: v, key: snap.key};
	}

	function offsetRef(baseRef, startKey) {
	  if( startKey === false ) {
	    return null;
	  }
	  else if( startKey === null ) {
	    return baseRef;
	  }
	  else {
	    return baseRef.startAt(startKey.val, startKey.key);
	  }
	}

	function baseRef(ref, field) {
	  if( field === '$key' ) {
	    return ref.orderByKey();
	  }
	  else if( field === '$priority' ) {
	    return ref.orderByPriority();
	  }
	  else if( field === '$value' ) {
	    return ref.orderByValue();
	  }
	  else {
	    return ref.orderByChild(field);
	  }
	}

	/**
	 * A rudimentary debounce method
	 * @param {function} fn the function to debounce
	 * @param {object} [ctx] the `this` context to set in fn
	 * @param {int} wait number of milliseconds to pause before sending out after each invocation
	 * @param {int} [maxWait] max milliseconds to wait before sending out, defaults to wait * 10 or 100
	 */
	function debounce(fn, ctx, wait, maxWait) {
	  var start, cancelTimer, args, runScheduledForNextTick;
	  if( typeof(ctx) === 'number' ) {
	    maxWait = wait;
	    wait = ctx;
	    ctx = null;
	  }

	  if( typeof wait !== 'number' ) {
	    throw new Error('Must provide a valid integer for wait. Try 0 for a default');
	  }
	  if( typeof(fn) !== 'function' ) {
	    throw new Error('Must provide a valid function to debounce');
	  }
	  if( !maxWait ) { maxWait = wait*10 || 100; }

	  // clears the current wait timer and creates a new one
	  // however, if maxWait is exceeded, calls runNow() on the next tick.
	  function resetTimer() {
	    if( cancelTimer ) {
	      cancelTimer();
	      cancelTimer = null;
	    }
	    if( start && Date.now() - start > maxWait ) {
	      if(!runScheduledForNextTick){
	        runScheduledForNextTick = true;
	        setTimeout(runNow, 0);
	      }
	    }
	    else {
	      if( !start ) { start = Date.now(); }
	      var to = setTimeout(runNow, wait);
	      cancelTimer = function() { clearTimeout(to); };
	    }
	  }

	  // Clears the queue and invokes the debounced function with the most recent arguments
	  function runNow() {
	    cancelTimer = null;
	    start = null;
	    runScheduledForNextTick = false;
	    fn.apply(ctx, args);
	  }

	  function debounced() {
	    args = Array.prototype.slice.call(arguments, 0);
	    resetTimer();
	  }
	  debounced.running = function() {
	    return start > 0;
	  };

	  return debounced;
	}

	function lastKey(list) {
	  var len = list.length;
	  return len? list[len-1] : null;
	}

	module.exports = Offset;
	},{"../../common":25}],21:[function(require,module,exports){
	'use strict';
	var util = require('../../common');
	var Cache = require('./Cache');

	/**
	 * @param {Firebase} ref
	 * @param {String} field
	 * @param {object} [opts]
	 * @constructor
	 */
	function Paginate(ref, field, opts) {
	  this.currPage = 0;
	  this.field = field;
	  this.ref = ref;
	  this.pageSize = opts.pageSize;
	  this.max = opts.maxCacheSize;
	  this.subs = [];
	  this.pageChangeListeners = [];
	  this.pageCountListeners = [];
	  this.cache = new Cache(ref, field, opts.maxCacheSize);
	  this.pageCount = -1;
	  this.couldHaveMore = false;
	  this.cache.observeHasNext(this._countPages, this);
	}

	/**
	 * Unload current records and load the next page into the PaginatedRef
	 *
	 * @return {Paginate} returns `this`
	 */
	Paginate.prototype.next = function() {
	  if( this.hasNext() ) {
	    this.currPage++;
	    util.log.debug('Paginate.next: current page is %d', this.currPage);
	    this._pageChange();
	  }
	  return this;
	};

	/**
	 * Unload current records and load the previous page into the PaginatedRef.
	 *
	 * @return {Paginate} returns `this`
	 */
	Paginate.prototype.prev = function() {
	  if( this.hasPrev() ) {
	    this.currPage--;
	    util.log.debug('Paginate.prev: current page is %d', this.currPage);
	    this._pageChange();
	  }
	  return this;
	};

	/**
	 * Skip to a specific page. The pageNumber must be less than pageCount.
	 *
	 * @param {int} pageNumber
	 * @return {Paginate} returns `this`
	 */
	Paginate.prototype.setPage = function(pageNumber) {
	  if( pageNumber > 0 && pageNumber <= this.pageCount ) {
	    this.currPage = pageNumber;
	    util.log.debug('Paginate.setPage: current page is %d', this.currPage);
	    this._pageChange();
	  }
	  else {
	    util.log.warn('Paginate.setPage: invalid page number %d', pageNumber);
	  }
	};

	/**
	 * @return {boolean} true if there are more records after the currently loaded page
	 */
	Paginate.prototype.hasNext = function() {
	  return this.cache.hasNext();
	};

	/**
	 * @return {boolean} true if there are more records before the currently loaded page
	 */
	Paginate.prototype.hasPrev = function() {
	  return this.currPage > 1;
	};

	/**
	 * Invoked whenever the page count changes. This may not be accurate if number of pages
	 * exceeds the maxCacheSize.
	 *
	 * The callback is delivered two arguments. The first is the {int} count, and the second
	 * is a {boolean}couldHaveMore which is true whenever we have run into maxCacheSize (i.e. there
	 * could be more)
	 *
	 * @param {Function} callback
	 * @param {Object} [context]
	 * @return {Function} a dispose function that cancels the listener
	 */
	Paginate.prototype.onPageChange = function(callback, context) {
	  var listeners = this.pageChangeListeners;
	  var parts = [callback, context];
	  listeners.push(parts);
	  callback.call(context, this.currPage);
	  return function() {
	    util.remove(listeners, parts);
	  };
	};

	/**
	 * Invoked whenever the local page count is changed. This may not include
	 * all records that exist on the remote server, as it is limited by maxCacheSize
	 */
	Paginate.prototype.onPageCount = function(callback, context) {
	  var listeners = this.pageCountListeners;
	  var parts = [callback, context];
	  listeners.push(parts);
	  if( this.pageCount > -1 ) {
	    callback.call(context, this.pageCount, this.couldHaveMore);
	  }
	  else {
	    this._countPages();
	  }
	  return function() {
	    util.remove(listeners, parts);
	  };
	};

	/**
	 * Asynchronously fetch the total page count. This maxes a REST API
	 * call using shallow=true. All the keys must be able to fit in memory at the same time.
	 *
	 * @param {Function} [callback]
	 * @param {Object} [context]
	 */
	Paginate.prototype.getCountByDowloadingAllKeys = function(callback, context) {
	  var self = this;
	  self.downloadingEverything = true;
	  var url = self.ref.ref.toString();
	  if( !url.match(/\/$/) ) { url += '/'; }
	  url += '.json?shallow=true';
	  microAjax(url, function(data) {
	    var count = 0;
	    try {
	      count = util.keys(JSON.parse(data)).length;
	    }
	    catch(e) {
	      util.log.warn(e);
	    }
	    util.log.debug('Paginate.getCountByDownloadingAllKeys: found %d keys', count);
	    self.downloadingEverything = false;
	    self.pageCount = countPages(count, self.pageSize);
	    self.couldHaveMore = false;
	    self._notifyPageCount();
	    if( callback ) { callback.call(context, count); }
	  });
	};

	/**
	 * Deletes locally cached data and cancels all listeners. Unloads
	 * records and triggers child_removed events.
	 */
	Paginate.prototype.destroy = function() {
	  this.cache.destroy();
	  this.cache = null;
	  this.ref = null;
	  util.each(this.subs, function(fn) { fn(); });
	  this.subs = [];
	  this.pageCountListeners.length = 0;
	  this.pageChangeListeners.length = 0;
	};

	Paginate.prototype._countPages = function() {
	  var self = this;
	  var currPage = self.currPage;
	  if( !this.downloadingEverything ) {
	    if( self.pageCount === -1 ) {
	      var max = self.max;
	      var pageSize = self.pageSize;
	      var ref = this.ref.ref.limitToFirst(max);
	      ref.once('value', function(snap) {
	        if( self.pageCount === -1 ) { // double-null check pattern (may have changed during async op)
	          self.couldHaveMore = snap.numChildren() === max;
	          self.pageCount = Math.ceil(snap.numChildren() / pageSize);
	          self._notifyPageCount();
	          self._countPages();
	        }
	      });
	    }
	    else if( currPage >= self.pageCount ) {
	      self.pageCount = currPage;
	      self.couldHaveMore = self.cache.hasNext();
	      self._notifyPageCount();
	    }
	  }
	};

	Paginate.prototype._pageChange = function() {
	  var currPage = this.currPage;
	  var start = (currPage -1) * this.pageSize;
	  this.cache.moveTo(start, this.pageSize);
	  this._countPages();
	  util.each(this.pageChangeListeners, function(parts) {
	    parts[0].call(parts[1], currPage);
	  });
	};

	Paginate.prototype._notifyPageCount = function() {
	  var pageCount = this.pageCount;
	  var couldHaveMore = this.couldHaveMore;
	  util.each(this.pageCountListeners, function(parts) {
	    parts[0].call(parts[1], pageCount, couldHaveMore);
	  });
	};

	function countPages(recordCount, pageSize) {
	  if( recordCount === 0 ) {
	    return 0;
	  }
	  else {
	    return Math.ceil(recordCount / pageSize);
	  }
	}

	// https://code.google.com/p/microajax/
	// new BSD license: http://opensource.org/licenses/BSD-3-Clause
	function microAjax(url,callbackFunction){var o={};o.bindFunction=function(caller,object){return function(){return caller.apply(object,[object]);};};o.stateChange=function(object){if(o.request.readyState==4) o.callbackFunction(o.request.responseText);};o.getRequest=function(){if(window.ActiveXObject) return new ActiveXObject('Microsoft.XMLHTTP');else if(window.XMLHttpRequest) return new XMLHttpRequest();return false;};o.postBody=(arguments[2]||"");o.callbackFunction=callbackFunction;o.url=url;o.request=o.getRequest();if(o.request){var req=o.request;req.onreadystatechange=o.bindFunction(o.stateChange,o);if(o.postBody!==""){req.open("POST",url,true);req.setRequestHeader('X-Requested-With','XMLHttpRequest');req.setRequestHeader('Content-type','application/x-www-form-urlencoded');req.setRequestHeader('Connection','close');}else{req.open("GET",url,true);} req.send(o.postBody);} return o;} // jshint ignore:line

	module.exports = Paginate;

	},{"../../common":25,"./Cache":19}],22:[function(require,module,exports){
	'use strict';
	var util      = require('../../common');

	function ReadOnlyRef(ref) {
	  this._ref = ref;
	  this._obs = new util.Observable(
	    ['value', 'child_added', 'child_removed', 'child_moved', 'child_changed']
	  );

	  this.ref = this._ref;
	}


	ReadOnlyRef.prototype = {
	  'on': function(event, callback, cancel, context) {
	    this._obs.observe(event, callback, cancel, context);
	  },

	  'once': function(event, callback, cancel, context) {
	    var self = this;
	    function fn(snap) {
	      /*jshint validthis:true */
	      self.off(event, fn, self);
	      callback.call(context, snap);
	    }
	    this.on(event, fn, cancel, this);
	  },

	  'off': function(event, callback, context) {
	    this._obs.stopObserving(event, callback, context);
	  },

	  /****************************
	   * WRAPPER FUNCTIONS
	   ****************************/
	  'child': wrapMaster('child'),
	  'parent': wrapMaster('parent'),
	  'root': wrapMaster('root'),
	  'name': wrapMaster('name'),
	  'key': wrapMaster('key'),
	  'toString': wrapMaster('toString'),

	  'auth': wrapMaster('auth'),
	  'unauth': wrapMaster('unauth'),
	  'authWithCustomToken': wrapMaster('authWithCustomToken'),
	  'authAnonymously': wrapMaster('authAnonymously'),
	  'authWithPassword': wrapMaster('authWithPassword'),
	  'authWithOAuthPopup': wrapMaster('authWithOAuthPopup'),
	  'authWithOAuthRedirect': wrapMaster('authWithOAuthRedirect'),
	  'authWithOAuthToken': wrapMaster('authWithOAuthToken'),
	  'getAuth': wrapMaster('getAuth'),
	  'onAuth': wrapMaster('onAuth'),
	  'offAuth': wrapMaster('offAuth'),
	  'createUser': wrapMaster('createUser'),
	  'changePassword': wrapMaster('changePassword'),
	  'removeUser': wrapMaster('removeUser'),
	  'resetPassword': wrapMaster('resetPassword'),
	  'changeEmail': wrapMaster('changeEmail'),

	  'goOffline': wrapMaster('goOffline'),
	  'goOnline': wrapMaster('goOnline'),

	  /****************************
	   * UNSUPPORTED FUNCTIONS
	   ***************************/
	  'set': isReadOnly('set'),
	  'update': isReadOnly('update'),
	  'remove': isReadOnly('remove'),
	  'push': isReadOnly('push'),
	  'setWithPriority': isReadOnly('setWithPriority'),
	  'setPriority': isReadOnly('setPriority'),
	  'transaction': isReadOnly('transaction'),

	  /** @deprecated */
	  'limit': notSupported('limit'),

	  'onDisconnect': notSupported('onDisconnect'),
	  'orderByChild': notSupported('orderByChild'),
	  'orderByKey': notSupported('orderByKey'),
	  'orderByPriority': notSupported('orderByPriority'),
	  'limitToFirst': notSupported('limitToFirst'),
	  'limitToLast': notSupported('limitToLast'),
	  'startAt': notSupported('startAt'),
	  'endAt': notSupported('endAt'),
	  'equalTo': notSupported('equalTo'),

	  /** INTERNAL METHODS */
	  $trigger: function() {
	    this._obs.triggerEvent.apply(this._obs, util.toArray(arguments));
	  }
	};

	function wrapMaster(method) {
	  return function() {
	    var args = util.toArray(arguments);
	    var ref = this.ref;
	    return ref[method].apply(ref, args);
	  };
	}

	function isReadOnly(method) {
	  return function() {
	    throw new Error(method + ' is not supported. This is a read-only reference. You can ' +
	    'modify child records after calling .child(), or work with the original by using .ref');
	  };
	}

	function notSupported(method) {
	  return function() {
	    throw new Error(method + ' is not supported for Paginate and Scroll references. ' +
	    'Try calling it on the original reference used to create the instance instead.');
	  };
	}

	module.exports = ReadOnlyRef;
	},{"../../common":25}],23:[function(require,module,exports){
	'use strict';
	var Cache = require('./Cache');

	/**
	 * @param {ReadOnlyRef} readOnlyRef
	 * @param {String} field
	 * @param {Object} [opts]
	 * @constructor
	 */
	function Scroll(readOnlyRef, field, opts) {
	  this.max = opts.windowSize;
	  this.start = 0;
	  this.end = 0;
	  this.cache = new Cache(readOnlyRef, field, opts.maxCacheSize);
	}

	/**
	 * Load the next numberToAppend records and trigger child_added events
	 * for them. If the total number of records exceeds maxRecords, then
	 * child_removed events will be triggered for the first items in the list.
	 *
	 * @param {int} numberToAppend
	 */
	Scroll.prototype.next = function(numberToAppend) {
	  if( this.hasNext() ) {
	    this.end = this.end + numberToAppend;
	    this.start = Math.max(0, this.end - this.max, this.start);
	    this.cache.moveTo(this.start, this.end - this.start);
	  }
	};

	/**
	 * Load the previous numberToAppend records and trigger child_added events
	 * for them. If the total number of records exceeds maxRecords, then
	 * child_removed events will be triggered for the last items in the list.
	 *
	 * @param {int} numberToPrepend
	 */
	Scroll.prototype.prev = function(numberToPrepend) {
	  if( this.hasPrev() ) {
	    this.start = Math.max(0, this.start - numberToPrepend);
	    this.end = Math.min(this.start + this.max, this.end);
	    this.cache.moveTo(this.start, this.end-this.start);
	  }
	};

	/**
	 * @return {boolean} true if there are more records after the currently loaded page
	 */
	Scroll.prototype.hasNext = function() {
	  return this.cache.hasNext();
	};

	/**
	 * @return {boolean} true if there are more records before the currently loaded page
	 */
	Scroll.prototype.hasPrev = function() {
	  return this.start > 0;
	};

	Scroll.prototype.observeHasNext = function(callback, context) {
	  return this.cache.observeHasNext(callback, context);
	};

	/**
	 * Deletes locally cached data and cancels all listeners. Unloads
	 * records and triggers child_removed events.
	 */
	Scroll.prototype.destroy = function() {
	  this.cache.destroy();
	  this.ref = null;
	  this.cache = null;
	};

	module.exports = Scroll;
	},{"./Cache":19}],24:[function(require,module,exports){
	/**
	 * This file loads all the public methods from
	 * the common/ library. To fetch all methods
	 * for internal use, just do require('./src/common'),
	 * which loads index.js and includes the private methods.
	 */

	var util = require('./index.js');
	exports.log = util.log;
	exports.logLevel = util.logLevel;
	exports.escapeEmail = util.escapeEmail;
	},{"./index.js":25}],25:[function(require,module,exports){
	/**
	 * This file loads the entire common/ package for INTERNAL USE.
	 * The public methods are specified by exports.js
	 */

	var util = require('./libs/util.js');
	var log = require('./libs/logger.js');

	util.extend(
	  exports,
	  util,
	  {
	    args: require('./libs/args.js'),
	    log: log,
	    logLevel: log.logLevel,
	    Observable: require('./libs/Observable.js'),
	    Observer: require('./libs/Observer.js'),
	    queue: require('./libs/queue.js')
	  }
	);
	},{"./libs/Observable.js":26,"./libs/Observer.js":27,"./libs/args.js":28,"./libs/logger.js":29,"./libs/queue.js":30,"./libs/util.js":31}],26:[function(require,module,exports){
	'use strict';

	var util = require('./util.js');
	var getArgs = require('./args.js');
	var log = require('./logger.js');
	var Observer = require('./Observer.js');

	/**
	 * A simple observer model for watching events.
	 * @param eventsMonitored
	 * @param [opts] can contain callbacks for onAdd, onRemove, and onEvent, as well as a list of oneTimeEvents
	 * @constructor
	 */
	function Observable(eventsMonitored, opts) {
	  if( !opts ) { opts = {}; }
	  this._observableProps = parseProps(eventsMonitored, opts);
	  this.resetObservers();
	}
	Observable.prototype = {
	  /**
	   * @param {String} event
	   * @param {Function|util.Observer} callback
	   * @param {Function} [cancelFn]
	   * @param {Object} [scope]
	   */
	  observe: function(event, callback, cancelFn, scope) {
	    var args = getArgs('observe', arguments, 2, 4), obs;
	    event = args.nextFromReq(this._observableProps.eventsMonitored);
	    if( event ) {
	      callback = args.nextReq('function');
	      cancelFn = args.next('function');
	      scope = args.next('object');
	      obs = new Observer(this, event, callback, scope, cancelFn);
	      this._observableProps.observers[event].push(obs);
	      this._observableProps.onAdd(event, obs);
	      if( this.isOneTimeEvent(event) ) {
	        checkOneTimeEvents(event, this._observableProps, obs);
	      }
	    }
	    return obs;
	  },

	  /**
	   * @param {String|Array} [event]
	   * @returns {boolean}
	   */
	  hasObservers: function(event) {
	    return this.getObservers(event).length > 0;
	  },

	  /**
	   * @param {String|Array} events
	   * @param {Function|Observer} callback
	   * @param {Object} [scope]
	   */
	  stopObserving: function(events, callback, scope) {
	    var args = getArgs('stopObserving', arguments);
	    events = args.next(['array', 'string'], this._observableProps.eventsMonitored);
	    callback = args.next(['function']);
	    scope = args.next(['object']);
	    util.each(events, function(event) {
	      var removes = [];
	      var observers = this.getObservers(event);
	      util.each(observers, function(obs) {
	        if( obs.matches(event, callback, scope) ) {
	          obs.notifyCancelled(null);
	          removes.push(obs);
	        }
	      }, this);
	      removeAll(this._observableProps.observers[event], removes);
	      if( removes.length ) {
	        this._observableProps.onRemove(event, removes);
	      }
	    }, this);
	  },

	  /**
	   * Turn off all observers and call cancel callbacks with an error
	   * @param {String} error
	   * @returns {*}
	   */
	  abortObservers: function(error) {
	    var removes = [];
	    if( this.hasObservers() ) {
	      var observers = this.getObservers().slice();
	      util.each(observers, function(obs) {
	        obs.notifyCancelled(error);
	        removes.push(obs);
	      }, this);
	      this.resetObservers();
	      if( removes.length ) {
	        this._observableProps.onRemove(this.event, removes);
	      }
	    }
	  },

	  /**
	   * @param {String|Array} [events]
	   * @returns {*}
	   */
	  getObservers: function(events) {
	    events = getArgs('getObservers', arguments).listFrom(this._observableProps.eventsMonitored, true);
	    return getObserversFor(this._observableProps, events);
	  },

	  triggerEvent: function(event) {
	    var args = getArgs('triggerEvent', arguments);
	    var events = args.listFromWarn(this._observableProps.eventsMonitored, true);
	    var passThruArgs = args.restAsList();
	    if( events ) {
	      util.each(events, function(e) {
	        if( this.isOneTimeEvent(event) ) {
	          if( util.isArray(this._observableProps.oneTimeResults, event) ) {
	            log.warn('One time event was triggered twice, should by definition be triggered once', event);
	            return;
	          }
	          this._observableProps.oneTimeResults[event] = passThruArgs;
	        }
	        var observers = this.getObservers(e), ct = 0;
	        util.each(observers, function(obs) {
	          obs.notify.apply(obs, passThruArgs.slice(0));
	          ct++;
	        });
	        this._observableProps.onEvent.apply(null, [e, ct].concat(passThruArgs.slice(0)));
	      }, this);
	    }
	  },

	  resetObservers: function() {
	    util.each(this._observableProps.eventsMonitored, function(key) {
	      this._observableProps.observers[key] = [];
	    }, this);
	  },

	  isOneTimeEvent: function(event) {
	    return util.contains(this._observableProps.oneTimeEvents, event);
	  },

	  observeOnce: function(event, callback, cancelFn, scope) {
	    var args = getArgs('observeOnce', arguments, 2, 4), obs;
	    event = args.nextFromWarn(this._observableProps.eventsMonitored);
	    if( event ) {
	      callback = args.nextReq('function');
	      cancelFn = args.next('function');
	      scope = args.next('object');
	      obs = new Observer(this, event, callback, scope, cancelFn, true);
	      this._observableProps.observers[event].push(obs);
	      this._observableProps.onAdd(event, obs);
	      if( this.isOneTimeEvent(event) ) {
	        checkOneTimeEvents(event, this._observableProps, obs);
	      }
	    }
	    return obs;
	  }
	};

	function removeAll(list, items) {
	  util.each(items, function(x) {
	    var i = util.indexOf(list, x);
	    if( i >= 0 ) {
	      list.splice(i, 1);
	    }
	  });
	}

	function getObserversFor(props, events) {
	  var out = [];
	  util.each(events, function(event) {
	    if( !util.has(props.observers, event) ) {
	      log.warn('Observable.hasObservers: invalid event type %s', event);
	    }
	    else {
	      if( props.observers[event].length ) {
	        out = out.concat(props.observers[event]);
	      }
	    }
	  });
	  return out;
	}

	function checkOneTimeEvents(event, props, obs) {
	  if( util.has(props.oneTimeResults, event) ) {
	    obs.notify.apply(obs, props.oneTimeResults[event]);
	  }
	}

	function parseProps(eventsMonitored, opts) {
	  return util.extend(
	    { onAdd: util.noop, onRemove: util.noop, onEvent: util.noop, oneTimeEvents: [] },
	    opts,
	    { eventsMonitored: eventsMonitored, observers: {}, oneTimeResults: {} }
	  );
	}

	module.exports = Observable;
	},{"./Observer.js":27,"./args.js":28,"./logger.js":29,"./util.js":31}],27:[function(require,module,exports){
	'use strict';
	var util = require('./util.js');

	/** Observer
	 ***************************************************
	 * @private
	 * @constructor
	 */
	function Observer(observable, event, notifyFn, context, cancelFn, oneTimeEvent) {
	  if( typeof(notifyFn) !== 'function' ) {
	    throw new Error('Must provide a valid notifyFn');
	  }
	  this.observable = observable;
	  this.fn = notifyFn;
	  this.event = event;
	  this.cancelFn = cancelFn||function() {};
	  this.context = context;
	  this.oneTimeEvent = !!oneTimeEvent;
	}

	Observer.prototype = {
	  notify: function() {
	    var args = util.toArray(arguments);
	    this.fn.apply(this.context, args);
	    if( this.oneTimeEvent ) {
	      this.observable.stopObserving(this.event, this.fn, this.context);
	    }
	  },

	  matches: function(event, fn, context) {
	    if( util.isArray(event) ) {
	      return util.contains(event, function(e) {
	        return this.matches(e, fn, context);
	      }, this);
	    }
	    return (!event || event === this.event) &&
	      (!fn || fn === this || fn === this.fn) &&
	      (!context || context === this.context);
	  },

	  notifyCancelled: function(err) {
	    this.cancelFn.call(this.context, err||null);
	  }
	};

	module.exports = Observer;
	},{"./util.js":31}],28:[function(require,module,exports){
	'use strict';
	var util = require('./util.js');
	var log = require('./logger.js');

	function Args(fnName, args, minArgs, maxArgs) {
	  if( typeof(fnName) !== 'string' || !util.isObject(args) ) {
	    throw new Error('Args requires at least 2 args: fnName, arguments[, minArgs, maxArgs]');
	  }
	  if( !(this instanceof Args) ) { // allow it to be called without `new` prefix
	    return new Args(fnName, args, minArgs, maxArgs);
	  }
	  this.fnName = fnName;
	  this.argList = util.toArray(args);
	  this.origArgs = util.toArray(args);
	  var len = this.length = this.argList.length;
	  this.pos = -1;
	  if(util.isUndefined(minArgs)) { minArgs = 0; }
	  if(util.isUndefined(maxArgs)) { maxArgs = this.argList.length; }
	  if( len < minArgs || len > maxArgs ) {
	    var rangeText = maxArgs > minArgs? util.printf('%d to %d', minArgs, maxArgs) : minArgs;
	    throw Error(util.printf('%s must be called with %s arguments, but received %d', fnName, rangeText, len));
	  }
	}

	Args.prototype = {
	  /**
	   * Grab the original list of args
	   * @return {Array} containing the original arguments
	   */
	  orig: function() { return this.origArgs.slice(0); },

	  /**
	   * Return whatever args remain as a list
	   * @returns {Array|string|Buffer|Blob|*}
	   */
	  restAsList: function(minLength, types) {
	    var list = this.argList.slice(0);
	    if( minLength || types ) {
	      for (var i = 0, len = list.length; i < len; i++) {
	        this._arg(types||true, null, i < minLength);
	      }
	    }
	    return list;
	  },

	  /**
	   * Advance the argument list by one and discard the value
	   * @return {Args}
	   */
	  skip: function() {
	    if( this.argList.length ) {
	      this.pos++;
	      this.argList.shift();
	    }
	    return this;
	  },

	  /**
	   * Read the next optional argument, but only if `types` is true, or it is of a type specified
	   * In the case that it is not present, return `defaultValue`
	   * @param {boolean|Array|string} types either `true` or one of array, string, object, number, int, boolean, boolean-like, or function
	   * @param [defaultValue]
	   */
	  next: function(types, defaultValue) {
	    return this._arg(types, defaultValue, false);
	  },

	  /**
	   * Read the next optional argument, but only if `types` is true, or it is of a type specified. In the case
	   * that it is not present, return `defaultValue` and log a warning to the console
	   * @param {boolean|Array|string} types either `true` or one of array, string, object, number, int, boolean, boolean-like, or function
	   * @param [defaultValue]
	   */
	  nextWarn: function(types, defaultValue) {
	    return this._arg(types, defaultValue, 'warn');
	  },

	  /**
	   * Read the next required argument, but only if `types` is true, or it is of a type specified. In the case
	   * that it is not present, throw an Error
	   * @param {boolean|Array|string} types either `true` or one of array, string, object, number, int, boolean, boolean-like, or function
	   */
	  nextReq: function(types) {
	    return this._arg(types, null, true);
	  },

	  /**
	   * Read the next optional argument, which must be one of the values in choices. If it is not present,
	   * return defaultValue.
	   * @param {Array} choices a list of allowed values
	   * @param [defaultValue]
	   */
	  nextFrom: function(choices, defaultValue) {
	    return this._from(choices, defaultValue, false);
	  },

	  /**
	   * Read the next optional argument, which must be one of the values in choices. If it is not present,
	   * return defaultValue and log a warning to the console.
	   * @param {Array} choices a list of allowed values
	   * @param [defaultValue]
	   */
	  nextFromWarn: function(choices, defaultValue) {
	    return this._from(choices, defaultValue, 'warn');
	  },

	  /**
	   * Read the next optional argument, which must be one of the values in choices. If it is not present,
	   * throw an Error.
	   * @param {Array} choices a list of allowed values
	   */
	  nextFromReq: function(choices) {
	    return this._from(choices, null, true);
	  },

	  /**
	   * Read the next optional argument and return it as an array (it can optionally be an array or a single value
	   * which will be coerced into an array). All values in the argument must be in choices or they are removed
	   * from the choices and a warning is logged. If no valid value is present, return defaultValue.
	   * @param {Array} choices a list of allowed values
	   * @param [defaultValue] a set of defaults, setting this to true uses the `choices` as default
	   */
	  listFrom: function(choices, defaultValue) {
	    return this._list(choices, defaultValue, false);
	  },

	  /**
	   * Read the next optional argument and return it as an array (it can optionally be an array or a single value
	   * which will be coerced into an array). All values in the argument must be in choices or they are removed
	   * from the choices and a warning is logged. If no valid value is present, return defaultValue and log a warning.
	   * @param {Array} choices a list of allowed values
	   * @param [defaultValue] a set of defaults, setting this to true uses the `choices` as default
	   */
	  listFromWarn: function(choices, defaultValue) {
	    return this._list(choices, defaultValue, 'warn');
	  },

	  /**
	   * Read the next optional argument and return it as an array (it can optionally be an array or a single value
	   * which will be coerced into an array). All values in the argument must be in choices or they are removed
	   * from the choices and a warning is logged. If no valid value is present, throw an Error.
	   * @param {Array} choices a list of allowed values
	   */
	  listFromReq: function(choices) {
	    return this._list(choices, null, true);
	  },

	  _arg: function(types, defaultValue, required) {
	    this.pos++;
	    if( util.isUndefined(types) || types === null ) { types = true; }
	    if( this.argList.length && isOfType(this.argList[0], types) ) {
	      return format(this.argList.shift(), types);
	    }
	    else {
	      if( required ) {
	        assertRequired(required, this.fnName, this.pos, util.printf('must be of type %s', types));
	      }
	      return defaultValue;
	    }
	  },

	  _from: function(choices, defaultValue, required) {
	    this.pos++;
	    if( this.argList.length && util.contains(choices, this.argList[0]) ) {
	      return this.argList.shift();
	    }
	    else {
	      if( required ) {
	        assertRequired(required, this.fnName, this.pos, util.printf('must be one of %s', choices));
	      }
	      return defaultValue;
	    }
	  },

	  _list: function(choices, defaultValue, required) {
	    this.pos++;
	    var out = [];
	    var list = this.argList[0];
	    if( this.argList.length && !util.isEmpty(list) && (util.isArray(list) || !util.isObject(list)) ) {
	      this.argList.shift();
	      if( util.isArray(list) ) {
	        out = util.map(list, function(v) {
	          if( util.contains(choices, v) ) {
	            return v;
	          }
	          else {
	            badChoiceWarning(this.fnName, v, choices);
	            return undefined;
	          }
	        }, this);
	      }
	      else {
	        if( util.contains(choices, list) ) {
	          out = [list];
	        }
	        else {
	          badChoiceWarning(this.fnName, list, choices);
	        }
	      }
	    }
	    if( util.isEmpty(out) ) {
	      if( required ) {
	        assertRequired(required, this.fnName, this.pos,
	          util.printf('choices must be in [%s]', choices));
	      }
	      return defaultValue === true? choices : defaultValue;
	    }
	    return out;
	  }

	};

	function isOfType(val, types) {
	  if( types === true ) { return true; }
	  if( !util.isArray(types) ) { types = [types]; }
	  return util.contains(types, function(type) {
	    switch(type) {
	      case 'array':
	        return util.isArray(val);
	      case 'string':
	        return typeof(val) === 'string';
	      case 'number':
	        return isFinite(parseInt(val, 10));
	      case 'int':
	      case 'integer':
	        return isFinite(parseFloat(val));
	      case 'object':
	        return util.isObject(val);
	      case 'function':
	        return typeof(val) === 'function';
	      case 'bool':
	      case 'boolean':
	        return typeof(val) === 'boolean';
	      case 'boolean-like':
	        return !util.isObject(val); // be lenient here
	      default:
	        throw new Error('Args received an invalid data type: '+type);
	    }
	  });
	}

	function assertRequired(required, fnName, pos, msg) {
	  msg = util.printf('%s: invalid argument at pos %d, %s (received %s)', fnName, pos, msg);
	  if( required === true ) {
	    throw new Error(msg);
	  }
	  else if( util.has(log, required) ) {
	    log[required](msg);
	  }
	  else {
	    throw new Error('The `required` value passed to Args methods must either be true or a method name from logger');
	  }
	}

	function badChoiceWarning(fnName, val, choices) {
	  log.warn('%s: invalid choice %s, must be one of [%s]', fnName, val, choices);
	}

	function format(val, types) {
	  if( types === true ) { return val; }
	  var type = util.isArray(types)? types[0] : types;
	  switch(type) {
	    case 'array':
	      return util.isArray(val)? val : [val];
	    case 'string':
	      return val + '';
	    case 'number':
	      return parseFloat(val);
	    case 'int':
	    case 'integer':
	      return parseInt(val, 10);
	    case 'bool':
	    case 'boolean':
	    case 'boolean-like':
	      return !!val;
	    case 'function':
	    case 'object':
	      return val;
	    default:
	      throw new Error('Args received an invalid data type: '+type);
	  }
	}

	module.exports = Args;
	},{"./logger.js":29,"./util.js":31}],29:[function(require,module,exports){
	'use strict';
	/*global window*/
	var DEFAULT_LEVEL = 2; //  errors and warnings
	var oldDebuggingLevel = false;
	var fakeConsole = {
	  error: noop, warn: noop, info: noop, log: noop, debug: noop, time: noop, timeEnd: noop, group: noop, groupEnd: noop
	};
	var util = require('./util.js');

	var logger = function() {
	  logger.log.apply(null, util.toArray(arguments));
	};

	/** hints for the IDEs */
	logger.warn = noop;
	logger.error = noop;
	logger.info = noop;
	logger.log = noop;
	logger.debug = noop;
	logger.isErrorEnabled = noop;
	logger.isWarnEnabled = noop;
	logger.isInfoEnabled = noop;
	logger.isLogEnabled = noop;
	logger.isDebugEnabled = noop;

	/**
	 * @param {int} level use -1 to turn off all logging, use 5 for maximum debugging
	 * @param {string|RegExp} [grep] filter logs to those whose first value matches this text or expression
	 */
	logger.logLevel = function(level, grep) {
	  if( typeof(level) !== 'number' ) { level = levelInt(level); }

	  if( oldDebuggingLevel === level ) { return function() {}; }

	  util.each(['error', 'warn', 'info', 'log', 'debug'], function(k, i) {
	    var isEnabled = typeof(console) !== 'undefined' && level >= i+1;
	    if( isEnabled ) {
	      // binding is necessary to prevent IE 8/9 from having a spaz when
	      // .apply and .call are used on console methods
	      var fn = util.bind(console[k==='debug'? 'log' : k], console);
	      logger[k] = function() {
	        var args = util.toArray(arguments);
	        if( args.length > 1 && typeof args[0] === 'string' ) {
	          var m = args[0].match(/(%s|%d|%j)/g);
	          if( m ) {
	            var newArgs = [util.printf.apply(util, args)];
	            args = args.length > m.length+1? newArgs.concat(args.slice(m.length+1)) : newArgs;
	          }
	        }
	        if( !grep || !filterThis(grep, args) ) {
	          fn.apply(typeof(console) === 'undefined'? fakeConsole : console, args);
	        }
	      };
	    }
	    else {
	      logger[k] = noop;
	    }
	    logger['is' + ucfirst(k) + 'Enabled'] = function() { return isEnabled; };
	  });

	  // provide a way to revert the debugging level if I want to change it temporarily
	  var off = (function(x) {
	    return function() { logger.logLevel(x); };
	  })(oldDebuggingLevel);
	  oldDebuggingLevel = level;

	  return off;
	};

	function ucfirst(s) {
	  return s.charAt(0).toUpperCase() + s.substr(1);
	}

	function getDefaultLevel() {
	  var m;
	  if( typeof(window) !== 'undefined' && window.location && window.location.search ) {
	    m = window.location.search.match('\bdebugLevel=([0-9]+)\b');
	  }
	  return m? parseInt(m[1], 10) : DEFAULT_LEVEL;
	}

	function noop() { return true; }

	function filterThis(expr, args) {
	  if( !args.length ) {
	    return true;
	  }
	  else if( expr instanceof RegExp ) {
	    return !expr.test(args[0]+'');
	  }
	  else {
	    return !(args[0]+'').match(expr);
	  }
	}

	function levelInt(x) {
	  switch(x) {
	    case false: return 0;
	    case 'off': return 0;
	    case 'none': return 0;
	    case 'error': return 1;
	    case 'warn': return 2;
	    case 'warning': return 2;
	    case 'info': return 3;
	    case 'log': return 4;
	    case 'debug': return 5;
	    case true: return DEFAULT_LEVEL;
	    case 'on': return DEFAULT_LEVEL;
	    case 'all': return DEFAULT_LEVEL;
	    default: return DEFAULT_LEVEL;
	  }
	}

	logger.logLevel(getDefaultLevel());
	module.exports = logger;
	},{"./util.js":31}],30:[function(require,module,exports){
	'use strict';
	var util = require('./util.js');

	function Queue(criteriaFunctions) {
	  this.needs = 0;
	  this.met = 0;
	  this.queued = [];
	  this.errors = [];
	  this.criteria = [];
	  this.processing = false;
	  util.each(criteriaFunctions, this.addCriteria, this);
	}

	Queue.prototype = {
	  /**
	   * @param {Function} criteriaFn
	   * @param {Object} [scope]
	   */
	  addCriteria: function(criteriaFn, scope) {
	    if( this.processing ) {
	      throw new Error('Cannot call addCriteria() after invoking done(), fail(), or handler() methods');
	    }
	    this.criteria.push(scope? [criteriaFn, scope] : criteriaFn);
	    return this;
	  },

	  /**
	   * Returns a node-like callback to be invoked when an op is completed.
	   * @returns {function}
	   */
	  getHandler: function() {
	    var doneCallback, result;
	    this.addCriteria(function(done) {
	      if( result !== util.undef ) {
	        done(result);
	      }
	      else {
	        doneCallback = done;
	      }
	    });
	    return function(err) {
	      if( doneCallback ) { doneCallback(err); }
	      else { result = err; }
	    };
	  },

	  ready: function() {
	    return this.needs === this.met;
	  },

	  done: function(fn, context) {
	    if( fn ) {
	      this._runOrStore(function() {
	        if( !this.hasErrors() ) { fn.call(context); }
	      });
	    }
	    return this;
	  },

	  fail: function(fn, context) {
	    this._runOrStore(function() {
	      if( this.hasErrors() ) { fn.apply(context, this.getErrors()); }
	    });
	    return this;
	  },

	  handler: function(fn, context) {
	    this._runOrStore(function() {
	      fn.apply(context, this.getErrors());
	    });
	    return this;
	  },

	  /**
	   * @param {Queue} queue
	   */
	  chain: function(queue) {
	    this.addCriteria(queue.handler, queue);
	    return this;
	  },

	  when: function(def) {
	    this._runOrStore(function() {
	      if( this.hasErrors() ) {
	        def.reject.apply(def, this.getErrors());
	      }
	      else {
	        def.resolve();
	      }
	    });
	  },

	  addError: function(e) {
	    this.errors.push(e);
	  },

	  hasErrors: function() {
	    return this.errors.length;
	  },

	  getErrors: function() {
	    return this.errors.slice(0);
	  },

	  _process: function() {
	    this.processing = true;
	    this.needs = this.criteria.length;
	    util.each(this.criteria, this._evaluateCriteria, this);
	  },

	  _evaluateCriteria: function(criteriaFn) {
	    var scope = null;
	    if( util.isArray(criteriaFn) ) {
	      scope = criteriaFn[1];
	      criteriaFn = criteriaFn[0];
	    }
	    try {
	      criteriaFn.call(scope, util.bind(this._criteriaMet, this));
	    }
	    catch(e) {
	      this.addError(e);
	    }
	  },

	  _criteriaMet: function(error) {
	    if( error ) { this.addError(error); }
	    this.met++;
	    if( this.ready() ) {
	      util.each(this.queued, this._run, this);
	    }
	  },

	  _runOrStore: function(fn) {
	    if( !this.processing ) { this._process(); }
	    if( this.ready() ) {
	      this._run(fn);
	    }
	    else {
	      this.queued.push(fn);
	    }
	  },

	  _run: function(fn) {
	    fn.call(this);
	  }
	};

	module.exports = function(criteriaFns, callback) {
	  var q = new Queue(criteriaFns);
	  if( callback ) { q.done(callback); }
	  return q;
	};

	},{"./util.js":31}],31:[function(require,module,exports){
	(function (global){
	/*jshint unused:vars */
	/*jshint bitwise:false */

	'use strict';

	var undef;
	var util = exports;
	var READ_EVENTS = ['value', 'child_added', 'child_removed', 'child_updated', 'child_changed'];

	util.undef = undef;
	util.firebase = global.firebase || require('firebase');

	util.isDefined = function(v) {
	  return v !== undef;
	};

	util.isUndefined = function(v) {
	  return v === undef;
	};

	util.isObject = function(v) {
	  return Object.prototype.isPrototypeOf(v);
	};

	util.isArray = function(v) {
	  return (Array.isArray || isArray).call(null, v);
	};

	util.isArrayLike = function(v) {
	  return util.isArray(v) || isArguments(v);
	};

	/**
	 * @param v value to test or if `key` is provided, the object containing method
	 * @param {string} [key] if provided, v is an object and this is the method we want to find
	 * @returns {*}
	 */
	util.isFunction = function(v, key) {
	  if( typeof(key) === 'string' ) {
	    return util.isObject(v) && util.has(v, key) && typeof(v[key]) === 'function';
	  }
	  else {
	    return typeof(v) === 'function';
	  }
	};

	util.toArray = function(vals, startFrom) {
	  var newVals = util.map(vals, function(v, k) { return v; });
	  return startFrom > 0? newVals.slice(startFrom) : newVals;
	};

	/**
	 * @param {boolean} [recursive] if true, keys are merged recursively, otherwise, they replace the base
	 * @param {...object} base
	 * @returns {Object}
	 */
	util.extend = function(recursive, base) {
	  var args = util.toArray(arguments);
	  var recurse = typeof args[0] === 'boolean' && args.shift();
	  var out = args.shift();
	  util.each(args, function(o) {
	    if( util.isObject(o) ) {
	      util.each(o, function(v,k) {
	        out[k] = recurse && util.isObject(out[k])? util.extend(true, out[k], v) : v;
	      });
	    }
	  });
	  return out;
	};

	util.bind = function(fn, scope) {
	  var args = Array.prototype.slice.call(arguments, 1);
	  return (fn.bind || bind).apply(fn, args);
	};

	/**
	 * @param {Object|Array} vals
	 * @returns {boolean}
	 */
	util.isEmpty = function(vals) {
	  return vals === undef || vals === null ||
	    (util.isArrayLike(vals) && vals.length === 0) ||
	    (util.isObject(vals) && !util.contains(vals, function(v) { return true; }));
	};

	/**
	 * @param {Object|Array} vals
	 * @returns {Array} of keys
	 */
	util.keys = function(vals) {
	  var keys = [];
	  util.each(vals, function(v, k) { keys.push(k); });
	  return keys;
	};

	/**
	 * Create an array using values returned by an iterator. Undefined values
	 * are discarded.
	 *
	 * @param vals
	 * @param iterator
	 * @param [scope]
	 * @returns {*}
	 */
	util.map = function(vals, iterator, scope) {
	  var out = [];
	  util.each(vals, function(v, k) {
	    var res = iterator.call(scope, v, k, vals);
	    if( res !== undef ) { out.push(res); }
	  });
	  return out;
	};

	/**
	 *
	 * @param {Object} list
	 * @param {Function} iterator
	 * @param {Object} [scope]
	 */
	util.mapObject = function(list, iterator, scope) {
	  var out = {};
	  util.each(list, function(v,k) {
	    var res = iterator.call(scope, v, k, list);
	    if( res !== undef ) {
	      out[k] = res;
	    }
	  });
	  return out;
	};

	/**
	 * Returns the first match
	 * @param {Object|Array} vals
	 * @param {Function} iterator
	 * @param {Object} [scope] set `this` in the callback or undefined
	 */
	util.find = function(vals, iterator, scope) {
	  if( util.isArrayLike(vals) ) {
	    for(var i = 0, len = vals.length; i < len; i++) {
	      if( iterator.call(scope, vals[i], i, vals) === true ) { return vals[i]; }
	    }
	  }
	  else if( util.isObject(vals) ) {
	    var key;
	    for (key in vals) {
	      if (vals.hasOwnProperty(key) && iterator.call(scope, vals[key], key, vals) === true) {
	        return vals[key];
	      }
	    }
	  }
	  return undef;
	};

	util.filter = function(list, iterator, scope) {
	  var isArray = util.isArrayLike(list);
	  var out = isArray? [] : {};
	  util.each(list, function(v,k) {
	    if( iterator.call(scope, v, k, list) ) {
	      if( isArray ) {
	        out.push(v);
	      }
	      else {
	        out[k] = v;
	      }
	    }
	  });
	  return out;
	};

	util.reduce = function(list, accumulator, iterator) {
	  util.each(list, function(v, k) {
	    accumulator = iterator(accumulator, v, k, list);
	  });
	  return accumulator;
	};

	util.has = function(vals, key) {
	  return util.isObject(vals) && vals[key] !== undef;
	};

	util.val = function(list, key) {
	  return util.has(list, key)? list[key] : undef;
	};

	util.contains = function(vals, iterator, scope) {
	  if( typeof(iterator) !== 'function' ) {
	    if( util.isArray(vals) ) {
	      return util.indexOf(vals, iterator) > -1;
	    }
	    iterator = (function(testVal) {
	      return function(v) { return v === testVal; };
	    })(iterator);
	  }
	  return util.find(vals, iterator, scope) !== undef;
	};

	util.each = function(vals, cb, scope) {
	  if( util.isArrayLike(vals) ) {
	    (vals.forEach || forEach).call(vals, cb, scope);
	  }
	  else if( util.isObject(vals) ) {
	    var key;
	    for (key in vals) {
	      if (vals.hasOwnProperty(key)) {
	        cb.call(scope, vals[key], key, vals);
	      }
	    }
	  }
	};

	util.indexOf = function(list, item) {
	  return (list.indexOf || indexOf).call(list, item);
	};

	util.remove = function(list, item) {
	  var res = false;
	  if( util.isArray(list) ) {
	    var i = util.indexOf(list, item);
	    if( i > -1 ) {
	      list.splice(i, 1);
	      res = true;
	    }
	  }
	  else if( util.isObject(list) ) {
	    var key;
	    for (key in list) {
	      if (list.hasOwnProperty(key) && item === list[key]) {
	        res = true;
	        delete list[key];
	        break;
	      }
	    }
	  }
	  return res;
	};

	/**
	 * Invoke a function after a setTimeout(..., 0), to help convert synch callbacks to async ones.
	 * Additional args after `scope` will be passed to the fn when it is invoked
	 *
	 * @param {Function} fn
	 * @param {Object} scope the `this` scope inside `fn`
	 */
	util.defer = function(fn, scope) {
	  var args = util.toArray(arguments);
	  setTimeout(util.bind.apply(null, args), 0);
	};

	/**
	 * Call a method on each instance contained in the list. Any additional args are passed into the method.
	 *
	 * @param {Object|Array} list contains instantiated objects
	 * @param {String} methodName
	 * @return {Array}
	 */
	util.call = function(list, methodName) {
	  var args = util.toArray(arguments, 2);
	  var res = [];
	  util.each(list, function(o) {
	    if( typeof(o) === 'function' && !methodName ) {
	      return res.push(o.apply(null, args));
	    }
	    if( util.isObject(o) && typeof(o[methodName]) === 'function' ) {
	      res.push(o[methodName].apply(o, args));
	    }
	  });
	  return res;
	};

	/**
	 * Determine if two variables are equal. They must be:
	 *  - of the same type
	 *  - arrays must be same length and all values pass isEqual()
	 *  - arrays must be in same order
	 *  - objects must contain the same keys and their values pass isEqual()
	 *  - object keys do not have to be in same order unless objectsSameOrder === true
	 *  - primitives must pass ===
	 *
	 * @param a
	 * @param b
	 * @param {boolean} [objectsSameOrder]
	 * @returns {boolean}
	 */
	util.isEqual = function(a, b, objectsSameOrder) {
	  if( a === b ) { return true; }
	  else if( typeof(a) !== typeof(b) ) {
	    return false;
	  }
	  else if( util.isObject(a) && util.isObject(b) ) {
	    var isA = util.isArrayLike(a);
	    var isB = util.isArrayLike(b);
	    if( isA || isB ) {
	      return isA && isB && a.length === b.length && !util.contains(a, function(v, i) {
	        return !util.isEqual(v, b[i]);
	      });
	    }
	    else {
	      var aKeys = objectsSameOrder? util.keys(a) : util.keys(a).sort();
	      var bKeys = objectsSameOrder? util.keys(b) : util.keys(b).sort();
	      return util.isEqual(aKeys, bKeys) &&
	        !util.contains(a, function(v, k) { return !util.isEqual(v, b[k]); });
	    }
	  }
	  else {
	    return false;
	  }
	};

	util.bindAll = function(context, methods) {
	  util.each(methods, function(m,k) {
	    if( typeof(m) === 'function' ) {
	      methods[k] = util.bind(m, context);
	    }
	  });
	  return methods;
	};

	util.printf = function() {
	  var localArgs = util.toArray(arguments);
	  var template = localArgs.shift();
	  var matches = template.match(/(%s|%d|%j)/g);
	  if( matches && localArgs.length ) {
	    util.find(matches, function (m) {
	      template = template.replace(m, format(localArgs.shift(), m));
	      return localArgs.length === 0;
	    });
	  }
	  return template;
	};

	util.mergeToString = function(list) {
	  if( list.length === 0 ) { return null; }
	  else if( list.length === 1 ) { return list[0]; }
	  else {
	    return '[' + list.join('][') + ']';
	  }
	};

	// credits: http://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
	util.construct = function(constructor, args) {
	  function F() {
	    return constructor.apply(this, args);
	  }
	  F.prototype = constructor.prototype;
	  return new F();
	};

	util.noop = function() {};

	var wrappingClasses = [];
	util.isFirebaseRef = function(x) {
	  // ES5 throws TypeError if getPrototypeOf() called on a non-object
	  if( !util.isObject(x) ) {
	    return false;
	  }

	  // necessary because instanceof won't work on Firebase Query objects
	  // so we can't simply do instanceof here
	  var proto = Object.getPrototypeOf(x);
	  if( proto && proto.constructor === util.firebase.database.prototype.constructor ) {
	    return true;
	  }

	  //todo-hack: SDK 3.0.x no longer works with the above. This is a hack to make that work until fixed
	  if( typeof(x.ref) === 'object' && typeof(x.ref.transaction) === 'function' ) {
	    return true;
	  }

	  return util.isFirebaseRefWrapper(x);
	};

	util.isFirebaseRefWrapper = function(x) {
	  return util.contains(wrappingClasses, function(C) {
	    return x instanceof C;
	  });
	};

	util.isQueryRef = function(x) {
	  return util.isFirebaseRef(x) && typeof x.transaction !== 'function';
	};

	// Add a Class as a valid substitute for a Firebase reference, so that it will
	// pass util.isFirebaseRef(). This means that it must provide all the Firebase
	// API methods and behave exactly like a Firebase instance in all cases.
	util.registerFirebaseWrapper = function(WrappingClass) {
	  wrappingClasses.push(WrappingClass);
	};

	// for test units
	util._mockFirebaseRef = function(mock) {
	  util.firebase = mock;
	};

	util.escapeEmail = function(email) {
	  return (email||'').replace('.', ',');
	};


	util.assertValidEvent = function(event) {
	  if( !util.contains(READ_EVENTS, event) ) {
	    throw new Error('Event must be one of ' + READ_EVENTS + ', but received ' + event);
	  }
	};

	/**
	 * Inherit prototype of another JS class. Adds an _super() method for the constructor to call.
	 * It takes any number of arguments (whatever the inherited classes constructor methods are),
	 *
	 * Limitations:
	 *    1. Inherited constructor must be callable with no arguments (to make instanceof work), but can be called
	 *       properly during instantiation with arguments by using _super(this, args...)
	 *    2. Can only inherit one super class, no exceptions
	 *    3. Cannot call prototype = {} after using this method
	 *
	 * @param {Function} Child
	 * @param {Function} Parent a class which can be constructed without passing any arguments
	 * @returns {Function}
	 */
	util.inherits = function(Child, Parent) {
	  var methodSets = [Child.prototype].concat(util.toArray(arguments).slice(2));
	  Child.prototype = new Parent();
	  Child.prototype.constructor = Parent;
	  util.each(methodSets, function(fnSet) {
	    util.each(fnSet, function(fn, key) {
	      Child.prototype[key] = fn;
	    });
	  });
	  Child.prototype._super = function() {
	    Parent.apply(this, arguments);
	  };
	  return Child;
	};

	util.deepCopy = function(data) {
	  if( !util.isObject(data) ) { return data; }
	  var out = util.isArrayLike(data)? [] : {};
	  util.each(data, function(v,k) {
	    out[k] = util.deepCopy(v);
	  });
	  return out;
	};

	util.pick = function(obj, keys) {
	  if( !util.isObject(obj) ) { return {}; }
	  var out = util.isArrayLike(obj)? [] : {};
	  util.each(keys, function(k) {
	    out[k] = obj[k];
	  });
	  return out;
	};

	util.eachByPath = function(map, data, callback, context) {
	  var dataByPath = {};
	  util.each(data, function(v,k) {
	    var p = map.pathFor(k);
	    var f = map.getField(k);
	    var key = f? f.id : k;
	    if( !util.has(dataByPath, p.name()) ) {
	      dataByPath[p.name()] = { path: p, data: {} };
	    }
	    dataByPath[p.name()].data[key] = v;
	  });

	  util.each(dataByPath, function(collated) {
	    callback.call(context, collated.path, collated.data);
	  });
	};

	function format(v, type) {
	  switch(type) {
	    case '%d':
	      return parseInt(v, 10);
	    case '%j':
	      v =  util.isObject(v)? JSON.stringify(v) : v+'';
	      if(v.length > 500) {
	        v = v.substr(0, 500)+'.../*truncated*/...}';
	      }
	      return v;
	    case '%s':
	      return v + '';
	    default:
	      return v;
	  }
	}

	function isArguments(o) {
	  return util.isObject(o) && o+'' === '[object Arguments]';
	}

	/****************************************
	 * POLYFILLS
	 ****************************************/

	// a polyfill for Function.prototype.bind (invoke using call or apply!)
	// credits: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
	function bind(oThis) {
	  /*jshint validthis:true */
	  if (typeof this !== 'function') {
	    // closest thing possible to the ECMAScript 5 internal IsCallable function
	    throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	  }

	  var aArgs = Array.prototype.slice.call(arguments, 1),
	    fToBind = this,
	    FNOP = function () {},
	    fBound = function () {
	      return fToBind.apply(
	          this instanceof FNOP && oThis? this : oThis,
	          aArgs.concat(Array.prototype.slice.call(arguments))
	      );
	    };

	  FNOP.prototype = this.prototype;
	  fBound.prototype = new FNOP();

	  return fBound;
	}

	// a polyfill for Array.prototype.forEach (invoke using call or apply!)
	// credits: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	function forEach(fn, scope) {
	  /*jshint validthis:true */
	  var i, len;
	  for (i = 0, len = this.length; i < len; ++i) {
	    if (i in this) {
	      fn.call(scope, this[i], i, this);
	    }
	  }
	}

	// a polyfill for Array.isArray
	// credits: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
	function isArray(vArg) {
	  return Object.prototype.toString.call(vArg) === '[object Array]';
	}

	// a polyfill for Array.indexOf
	// credits: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
	function indexOf(searchElement, fromIndex) {
	  /*jshint validthis:true */
	  if (this === null) {
	    throw new TypeError();
	  }
	  var n, k, t = Object(this),
	    len = t.length >>> 0;

	  if (len === 0) {
	    return -1;
	  }
	  n = 0;
	  if (arguments.length > 1) {
	    n = Number(arguments[1]);
	    if (n !== n) { // shortcut for verifying if it's NaN
	      n = 0;
	    } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	      n = (n > 0 || -1) * Math.floor(Math.abs(n));
	    }
	  }
	  if (n >= len) {
	    return -1;
	  }
	  for (k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++) {
	    if (k in t && t[k] === searchElement) {
	      return k;
	    }
	  }
	  return -1;
	}

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"firebase":"firebase"}],"firebase-util":[function(require,module,exports){
	/**
	 * This file establishes the firebase.util namespace and
	 * defines the exports for all packages when using node.js
	 */
	'use strict';

	var util = require('./common/index.js');

	// put all our public methods into the exported scope
	util.extend(exports,
	  require('./common/exports.js'),
	  require('./NormalizedCollection/exports.js'),
	  require('./Paginate/exports.js')
	);

	/*global window */
	if( typeof window !== 'undefined' ) {
	  if( !window.hasOwnProperty('firebase') ) {
	    console.warn('Firebase not found on the global window instance. Cannot add firebase.util namespace.');
	  }
	  else {
	    window.firebase.util = util;
	  }
	}
	},{"./NormalizedCollection/exports.js":2,"./Paginate/exports.js":18,"./common/exports.js":24,"./common/index.js":25}]},{},[1]);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/*!

	 diff v2.2.2

	Software License Agreement (BSD License)

	Copyright (c) 2009-2015, Kevin Decker <kpdecker@gmail.com>

	All rights reserved.

	Redistribution and use of this software in source and binary forms, with or without modification,
	are permitted provided that the following conditions are met:

	* Redistributions of source code must retain the above
	  copyright notice, this list of conditions and the
	  following disclaimer.

	* Redistributions in binary form must reproduce the above
	  copyright notice, this list of conditions and the
	  following disclaimer in the documentation and/or other
	  materials provided with the distribution.

	* Neither the name of Kevin Decker nor the names of its
	  contributors may be used to endorse or promote products
	  derived from this software without specific prior
	  written permission.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
	IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
	DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
	IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
	OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	@license
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["JsDiff"] = factory();
		else
			root["JsDiff"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};

	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {

	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;

	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};

	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;

	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}


	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;

	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;

	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";

	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.canonicalize = exports.convertChangesToXML = exports.convertChangesToDMP = exports.parsePatch = exports.applyPatches = exports.applyPatch = exports.createPatch = exports.createTwoFilesPatch = exports.structuredPatch = exports.diffJson = exports.diffCss = exports.diffSentences = exports.diffTrimmedLines = exports.diffLines = exports.diffWordsWithSpace = exports.diffWords = exports.diffChars = exports.Diff = undefined;
		/*istanbul ignore end*/
		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		/*istanbul ignore end*/
		var /*istanbul ignore start*/_character = __webpack_require__(2) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_word = __webpack_require__(3) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_sentence = __webpack_require__(6) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_css = __webpack_require__(7) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_json = __webpack_require__(8) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_apply = __webpack_require__(9) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_parse = __webpack_require__(10) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_create = __webpack_require__(12) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_dmp = __webpack_require__(13) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_xml = __webpack_require__(14) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/* See LICENSE file for terms of use */

		/*
		 * Text diff implementation.
		 *
		 * This library supports the following APIS:
		 * JsDiff.diffChars: Character by character diff
		 * JsDiff.diffWords: Word (as defined by \b regex) diff which ignores whitespace
		 * JsDiff.diffLines: Line based diff
		 *
		 * JsDiff.diffCss: Diff targeted at CSS content
		 *
		 * These methods are based on the implementation proposed in
		 * "An O(ND) Difference Algorithm and its Variations" (Myers, 1986).
		 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
		 */
		exports. /*istanbul ignore end*/Diff = _base2.default;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffChars = _character.diffChars;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWords = _word.diffWords;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = _word.diffWordsWithSpace;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffLines = _line.diffLines;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = _line.diffTrimmedLines;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffSentences = _sentence.diffSentences;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffCss = _css.diffCss;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffJson = _json.diffJson;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/structuredPatch = _create.structuredPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = _create.createTwoFilesPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = _create.createPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatch = _apply.applyPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = _apply.applyPatches;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/parsePatch = _parse.parsePatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToDMP = _dmp.convertChangesToDMP;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToXML = _xml.convertChangesToXML;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = _json.canonicalize;
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 1 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.default = /*istanbul ignore end*/Diff;
		function Diff() {}

		Diff.prototype = { /*istanbul ignore start*/
		  /*istanbul ignore end*/diff: function diff(oldString, newString) {
		    /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

		    var callback = options.callback;
		    if (typeof options === 'function') {
		      callback = options;
		      options = {};
		    }
		    this.options = options;

		    var self = this;

		    function done(value) {
		      if (callback) {
		        setTimeout(function () {
		          callback(undefined, value);
		        }, 0);
		        return true;
		      } else {
		        return value;
		      }
		    }

		    // Allow subclasses to massage the input prior to running
		    oldString = this.castInput(oldString);
		    newString = this.castInput(newString);

		    oldString = this.removeEmpty(this.tokenize(oldString));
		    newString = this.removeEmpty(this.tokenize(newString));

		    var newLen = newString.length,
		        oldLen = oldString.length;
		    var editLength = 1;
		    var maxEditLength = newLen + oldLen;
		    var bestPath = [{ newPos: -1, components: [] }];

		    // Seed editLength = 0, i.e. the content starts with the same values
		    var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
		    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
		      // Identity per the equality and tokenizer
		      return done([{ value: newString.join(''), count: newString.length }]);
		    }

		    // Main worker method. checks all permutations of a given edit length for acceptance.
		    function execEditLength() {
		      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
		        var basePath = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
		        var addPath = bestPath[diagonalPath - 1],
		            removePath = bestPath[diagonalPath + 1],
		            _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
		        if (addPath) {
		          // No one else is going to attempt to use this value, clear it
		          bestPath[diagonalPath - 1] = undefined;
		        }

		        var canAdd = addPath && addPath.newPos + 1 < newLen,
		            canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;
		        if (!canAdd && !canRemove) {
		          // If this path is a terminal then prune
		          bestPath[diagonalPath] = undefined;
		          continue;
		        }

		        // Select the diagonal that we want to branch from. We select the prior
		        // path whose position in the new string is the farthest from the origin
		        // and does not pass the bounds of the diff graph
		        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
		          basePath = clonePath(removePath);
		          self.pushComponent(basePath.components, undefined, true);
		        } else {
		          basePath = addPath; // No need to clone, we've pulled it from the list
		          basePath.newPos++;
		          self.pushComponent(basePath.components, true, undefined);
		        }

		        _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath);

		        // If we have hit the end of both strings, then we are done
		        if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) {
		          return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
		        } else {
		          // Otherwise track this path as a potential candidate and continue.
		          bestPath[diagonalPath] = basePath;
		        }
		      }

		      editLength++;
		    }

		    // Performs the length of edit iteration. Is a bit fugly as this has to support the
		    // sync and async mode which is never fun. Loops over execEditLength until a value
		    // is produced.
		    if (callback) {
		      (function exec() {
		        setTimeout(function () {
		          // This should not happen, but we want to be safe.
		          /* istanbul ignore next */
		          if (editLength > maxEditLength) {
		            return callback();
		          }

		          if (!execEditLength()) {
		            exec();
		          }
		        }, 0);
		      })();
		    } else {
		      while (editLength <= maxEditLength) {
		        var ret = execEditLength();
		        if (ret) {
		          return ret;
		        }
		      }
		    }
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/pushComponent: function pushComponent(components, added, removed) {
		    var last = components[components.length - 1];
		    if (last && last.added === added && last.removed === removed) {
		      // We need to clone here as the component clone operation is just
		      // as shallow array clone
		      components[components.length - 1] = { count: last.count + 1, added: added, removed: removed };
		    } else {
		      components.push({ count: 1, added: added, removed: removed });
		    }
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
		    var newLen = newString.length,
		        oldLen = oldString.length,
		        newPos = basePath.newPos,
		        oldPos = newPos - diagonalPath,
		        commonCount = 0;
		    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])) {
		      newPos++;
		      oldPos++;
		      commonCount++;
		    }

		    if (commonCount) {
		      basePath.components.push({ count: commonCount });
		    }

		    basePath.newPos = newPos;
		    return oldPos;
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/equals: function equals(left, right) {
		    return left === right;
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/removeEmpty: function removeEmpty(array) {
		    var ret = [];
		    for (var i = 0; i < array.length; i++) {
		      if (array[i]) {
		        ret.push(array[i]);
		      }
		    }
		    return ret;
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/castInput: function castInput(value) {
		    return value;
		  },
		  /*istanbul ignore start*/ /*istanbul ignore end*/tokenize: function tokenize(value) {
		    return value.split('');
		  }
		};

		function buildValues(diff, components, newString, oldString, useLongestToken) {
		  var componentPos = 0,
		      componentLen = components.length,
		      newPos = 0,
		      oldPos = 0;

		  for (; componentPos < componentLen; componentPos++) {
		    var component = components[componentPos];
		    if (!component.removed) {
		      if (!component.added && useLongestToken) {
		        var value = newString.slice(newPos, newPos + component.count);
		        value = value.map(function (value, i) {
		          var oldValue = oldString[oldPos + i];
		          return oldValue.length > value.length ? oldValue : value;
		        });

		        component.value = value.join('');
		      } else {
		        component.value = newString.slice(newPos, newPos + component.count).join('');
		      }
		      newPos += component.count;

		      // Common case
		      if (!component.added) {
		        oldPos += component.count;
		      }
		    } else {
		      component.value = oldString.slice(oldPos, oldPos + component.count).join('');
		      oldPos += component.count;

		      // Reverse add and remove so removes are output first to match common convention
		      // The diffing algorithm is tied to add then remove output and this is the simplest
		      // route to get the desired output with minimal overhead.
		      if (componentPos && components[componentPos - 1].added) {
		        var tmp = components[componentPos - 1];
		        components[componentPos - 1] = components[componentPos];
		        components[componentPos] = tmp;
		      }
		    }
		  }

		  // Special case handle for when one terminal is ignored. For this case we merge the
		  // terminal into the prior string and drop the change.
		  var lastComponent = components[componentLen - 1];
		  if (componentLen > 1 && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
		    components[componentLen - 2].value += lastComponent.value;
		    components.pop();
		  }

		  return components;
		}

		function clonePath(path) {
		  return { newPos: path.newPos, components: path.components.slice(0) };
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.characterDiff = undefined;
		exports. /*istanbul ignore end*/diffChars = diffChars;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/var characterDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/characterDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		function diffChars(oldStr, newStr, callback) {
		  return characterDiff.diff(oldStr, newStr, callback);
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2NoYXJhY3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQUdnQjs7QUFIaEI7Ozs7Ozs7dUJBRU8sSUFBTSx5RkFBZ0IscUVBQWhCO0FBQ04sU0FBUyxTQUFULENBQW1CLE1BQW5CLEVBQTJCLE1BQTNCLEVBQW1DLFFBQW5DLEVBQTZDO0FBQUUsU0FBTyxjQUFjLElBQWQsQ0FBbUIsTUFBbkIsRUFBMkIsTUFBM0IsRUFBbUMsUUFBbkMsQ0FBUCxDQUFGO0NBQTdDIiwiZmlsZSI6ImNoYXJhY3Rlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBjb25zdCBjaGFyYWN0ZXJEaWZmID0gbmV3IERpZmYoKTtcbmV4cG9ydCBmdW5jdGlvbiBkaWZmQ2hhcnMob2xkU3RyLCBuZXdTdHIsIGNhbGxiYWNrKSB7IHJldHVybiBjaGFyYWN0ZXJEaWZmLmRpZmYob2xkU3RyLCBuZXdTdHIsIGNhbGxiYWNrKTsgfVxuIl19


	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.wordDiff = undefined;
		exports. /*istanbul ignore end*/diffWords = diffWords;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = diffWordsWithSpace;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		/*istanbul ignore end*/
		var /*istanbul ignore start*/_params = __webpack_require__(4) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/

		// Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
		//
		// Ranges and exceptions:
		// Latin-1 Supplement, 0080–00FF
		//  - U+00D7  × Multiplication sign
		//  - U+00F7  ÷ Division sign
		// Latin Extended-A, 0100–017F
		// Latin Extended-B, 0180–024F
		// IPA Extensions, 0250–02AF
		// Spacing Modifier Letters, 02B0–02FF
		//  - U+02C7  ˇ &#711;  Caron
		//  - U+02D8  ˘ &#728;  Breve
		//  - U+02D9  ˙ &#729;  Dot Above
		//  - U+02DA  ˚ &#730;  Ring Above
		//  - U+02DB  ˛ &#731;  Ogonek
		//  - U+02DC  ˜ &#732;  Small Tilde
		//  - U+02DD  ˝ &#733;  Double Acute Accent
		// Latin Extended Additional, 1E00–1EFF
		var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;

		var reWhitespace = /\S/;

		var wordDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/wordDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		wordDiff.equals = function (left, right) {
		  return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
		};
		wordDiff.tokenize = function (value) {
		  var tokens = value.split(/(\s+|\b)/);

		  // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
		  for (var i = 0; i < tokens.length - 1; i++) {
		    // If we have an empty string in the next field and we have only word chars before and after, merge
		    if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
		      tokens[i] += tokens[i + 2];
		      tokens.splice(i + 1, 2);
		      i--;
		    }
		  }

		  return tokens;
		};

		function diffWords(oldStr, newStr, callback) {
		  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
		  return wordDiff.diff(oldStr, newStr, options);
		}
		function diffWordsWithSpace(oldStr, newStr, callback) {
		  return wordDiff.diff(oldStr, newStr, callback);
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 4 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports. /*istanbul ignore end*/generateOptions = generateOptions;
		function generateOptions(options, defaults) {
		  if (typeof options === 'function') {
		    defaults.callback = options;
		  } else if (options) {
		    for (var name in options) {
		      /* istanbul ignore else */
		      if (options.hasOwnProperty(name)) {
		        defaults[name] = options[name];
		      }
		    }
		  }
		  return defaults;
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL3BhcmFtcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQWdCO0FBQVQsU0FBUyxlQUFULENBQXlCLE9BQXpCLEVBQWtDLFFBQWxDLEVBQTRDO0FBQ2pELE1BQUksT0FBTyxPQUFQLEtBQW1CLFVBQW5CLEVBQStCO0FBQ2pDLGFBQVMsUUFBVCxHQUFvQixPQUFwQixDQURpQztHQUFuQyxNQUVPLElBQUksT0FBSixFQUFhO0FBQ2xCLFNBQUssSUFBSSxJQUFKLElBQVksT0FBakIsRUFBMEI7O0FBRXhCLFVBQUksUUFBUSxjQUFSLENBQXVCLElBQXZCLENBQUosRUFBa0M7QUFDaEMsaUJBQVMsSUFBVCxJQUFpQixRQUFRLElBQVIsQ0FBakIsQ0FEZ0M7T0FBbEM7S0FGRjtHQURLO0FBUVAsU0FBTyxRQUFQLENBWGlEO0NBQTVDIiwiZmlsZSI6InBhcmFtcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBnZW5lcmF0ZU9wdGlvbnMob3B0aW9ucywgZGVmYXVsdHMpIHtcbiAgaWYgKHR5cGVvZiBvcHRpb25zID09PSAnZnVuY3Rpb24nKSB7XG4gICAgZGVmYXVsdHMuY2FsbGJhY2sgPSBvcHRpb25zO1xuICB9IGVsc2UgaWYgKG9wdGlvbnMpIHtcbiAgICBmb3IgKGxldCBuYW1lIGluIG9wdGlvbnMpIHtcbiAgICAgIC8qIGlzdGFuYnVsIGlnbm9yZSBlbHNlICovXG4gICAgICBpZiAob3B0aW9ucy5oYXNPd25Qcm9wZXJ0eShuYW1lKSkge1xuICAgICAgICBkZWZhdWx0c1tuYW1lXSA9IG9wdGlvbnNbbmFtZV07XG4gICAgICB9XG4gICAgfVxuICB9XG4gIHJldHVybiBkZWZhdWx0cztcbn1cbiJdfQ==


	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.lineDiff = undefined;
		exports. /*istanbul ignore end*/diffLines = diffLines;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = diffTrimmedLines;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		/*istanbul ignore end*/
		var /*istanbul ignore start*/_params = __webpack_require__(4) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/var lineDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/lineDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		lineDiff.tokenize = function (value) {
		  var retLines = [],
		      linesAndNewlines = value.split(/(\n|\r\n)/);

		  // Ignore the final empty token that occurs if the string ends with a new line
		  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
		    linesAndNewlines.pop();
		  }

		  // Merge the content and line separators into single tokens
		  for (var i = 0; i < linesAndNewlines.length; i++) {
		    var line = linesAndNewlines[i];

		    if (i % 2 && !this.options.newlineIsToken) {
		      retLines[retLines.length - 1] += line;
		    } else {
		      if (this.options.ignoreWhitespace) {
		        line = line.trim();
		      }
		      retLines.push(line);
		    }
		  }

		  return retLines;
		};

		function diffLines(oldStr, newStr, callback) {
		  return lineDiff.diff(oldStr, newStr, callback);
		}
		function diffTrimmedLines(oldStr, newStr, callback) {
		  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
		  return lineDiff.diff(oldStr, newStr, options);
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.sentenceDiff = undefined;
		exports. /*istanbul ignore end*/diffSentences = diffSentences;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/var sentenceDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/sentenceDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		sentenceDiff.tokenize = function (value) {
		  return value.split(/(\S.+?[.!?])(?=\s+|$)/);
		};

		function diffSentences(oldStr, newStr, callback) {
		  return sentenceDiff.diff(oldStr, newStr, callback);
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL3NlbnRlbmNlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Z0NBUWdCOztBQVJoQjs7Ozs7Ozt1QkFHTyxJQUFNLHVGQUFlLHFFQUFmO0FBQ2IsYUFBYSxRQUFiLEdBQXdCLFVBQVMsS0FBVCxFQUFnQjtBQUN0QyxTQUFPLE1BQU0sS0FBTixDQUFZLHVCQUFaLENBQVAsQ0FEc0M7Q0FBaEI7O0FBSWpCLFNBQVMsYUFBVCxDQUF1QixNQUF2QixFQUErQixNQUEvQixFQUF1QyxRQUF2QyxFQUFpRDtBQUFFLFNBQU8sYUFBYSxJQUFiLENBQWtCLE1BQWxCLEVBQTBCLE1BQTFCLEVBQWtDLFFBQWxDLENBQVAsQ0FBRjtDQUFqRCIsImZpbGUiOiJzZW50ZW5jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cblxuZXhwb3J0IGNvbnN0IHNlbnRlbmNlRGlmZiA9IG5ldyBEaWZmKCk7XG5zZW50ZW5jZURpZmYudG9rZW5pemUgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc3BsaXQoLyhcXFMuKz9bLiE/XSkoPz1cXHMrfCQpLyk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZlNlbnRlbmNlcyhvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spIHsgcmV0dXJuIHNlbnRlbmNlRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.cssDiff = undefined;
		exports. /*istanbul ignore end*/diffCss = diffCss;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/var cssDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/cssDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		cssDiff.tokenize = function (value) {
		  return value.split(/([{}:;,]|\s+)/);
		};

		function diffCss(oldStr, newStr, callback) {
		  return cssDiff.diff(oldStr, newStr, callback);
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2Nzcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQU9nQjs7QUFQaEI7Ozs7Ozs7dUJBRU8sSUFBTSw2RUFBVSxxRUFBVjtBQUNiLFFBQVEsUUFBUixHQUFtQixVQUFTLEtBQVQsRUFBZ0I7QUFDakMsU0FBTyxNQUFNLEtBQU4sQ0FBWSxlQUFaLENBQVAsQ0FEaUM7Q0FBaEI7O0FBSVosU0FBUyxPQUFULENBQWlCLE1BQWpCLEVBQXlCLE1BQXpCLEVBQWlDLFFBQWpDLEVBQTJDO0FBQUUsU0FBTyxRQUFRLElBQVIsQ0FBYSxNQUFiLEVBQXFCLE1BQXJCLEVBQTZCLFFBQTdCLENBQVAsQ0FBRjtDQUEzQyIsImZpbGUiOiJjc3MuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRGlmZiBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgY29uc3QgY3NzRGlmZiA9IG5ldyBEaWZmKCk7XG5jc3NEaWZmLnRva2VuaXplID0gZnVuY3Rpb24odmFsdWUpIHtcbiAgcmV0dXJuIHZhbHVlLnNwbGl0KC8oW3t9OjssXXxcXHMrKS8pO1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIGRpZmZDc3Mob2xkU3RyLCBuZXdTdHIsIGNhbGxiYWNrKSB7IHJldHVybiBjc3NEaWZmLmRpZmYob2xkU3RyLCBuZXdTdHIsIGNhbGxiYWNrKTsgfVxuIl19


	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports.jsonDiff = undefined;

		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

		exports. /*istanbul ignore end*/diffJson = diffJson;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = canonicalize;

		var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _base2 = _interopRequireDefault(_base);

		/*istanbul ignore end*/
		var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/

		var objectPrototypeToString = Object.prototype.toString;

		var jsonDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/jsonDiff = new /*istanbul ignore start*/_base2.default() /*istanbul ignore end*/;
		// Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
		// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
		jsonDiff.useLongestToken = true;

		jsonDiff.tokenize = /*istanbul ignore start*/_line.lineDiff. /*istanbul ignore end*/tokenize;
		jsonDiff.castInput = function (value) {
		  return typeof value === 'string' ? value : JSON.stringify(canonicalize(value), undefined, '  ');
		};
		jsonDiff.equals = function (left, right) {
		  return (/*istanbul ignore start*/_base2.default. /*istanbul ignore end*/prototype.equals(left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'))
		  );
		};

		function diffJson(oldObj, newObj, callback) {
		  return jsonDiff.diff(oldObj, newObj, callback);
		}

		// This function handles the presence of circular references by bailing out when encountering an
		// object that is already on the "stack" of items being processed.
		function canonicalize(obj, stack, replacementStack) {
		  stack = stack || [];
		  replacementStack = replacementStack || [];

		  var i = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

		  for (i = 0; i < stack.length; i += 1) {
		    if (stack[i] === obj) {
		      return replacementStack[i];
		    }
		  }

		  var canonicalizedObj = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

		  if ('[object Array]' === objectPrototypeToString.call(obj)) {
		    stack.push(obj);
		    canonicalizedObj = new Array(obj.length);
		    replacementStack.push(canonicalizedObj);
		    for (i = 0; i < obj.length; i += 1) {
		      canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack);
		    }
		    stack.pop();
		    replacementStack.pop();
		    return canonicalizedObj;
		  }

		  if (obj && obj.toJSON) {
		    obj = obj.toJSON();
		  }

		  if ( /*istanbul ignore start*/(typeof /*istanbul ignore end*/obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
		    stack.push(obj);
		    canonicalizedObj = {};
		    replacementStack.push(canonicalizedObj);
		    var sortedKeys = [],
		        key = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
		    for (key in obj) {
		      /* istanbul ignore else */
		      if (obj.hasOwnProperty(key)) {
		        sortedKeys.push(key);
		      }
		    }
		    sortedKeys.sort();
		    for (i = 0; i < sortedKeys.length; i += 1) {
		      key = sortedKeys[i];
		      canonicalizedObj[key] = canonicalize(obj[key], stack, replacementStack);
		    }
		    stack.pop();
		    replacementStack.pop();
		  } else {
		    canonicalizedObj = obj;
		  }
		  return canonicalizedObj;
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports. /*istanbul ignore end*/applyPatch = applyPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = applyPatches;

		var /*istanbul ignore start*/_parse = __webpack_require__(10) /*istanbul ignore end*/;

		var /*istanbul ignore start*/_distanceIterator = __webpack_require__(11) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		var _distanceIterator2 = _interopRequireDefault(_distanceIterator);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/*istanbul ignore end*/function applyPatch(source, uniDiff) {
		  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

		  if (typeof uniDiff === 'string') {
		    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
		  }

		  if (Array.isArray(uniDiff)) {
		    if (uniDiff.length > 1) {
		      throw new Error('applyPatch only works with a single input.');
		    }

		    uniDiff = uniDiff[0];
		  }

		  // Apply the diff to the input
		  var lines = source.split('\n'),
		      hunks = uniDiff.hunks,
		      compareLine = options.compareLine || function (lineNumber, line, operation, patchContent) /*istanbul ignore start*/{
		    return (/*istanbul ignore end*/line === patchContent
		    );
		  },
		      errorCount = 0,
		      fuzzFactor = options.fuzzFactor || 0,
		      minLine = 0,
		      offset = 0,
		      removeEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
		      addEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

		  /**
		   * Checks if the hunk exactly fits on the provided location
		   */
		  function hunkFits(hunk, toPos) {
		    for (var j = 0; j < hunk.lines.length; j++) {
		      var line = hunk.lines[j],
		          operation = line[0],
		          content = line.substr(1);

		      if (operation === ' ' || operation === '-') {
		        // Context sanity check
		        if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
		          errorCount++;

		          if (errorCount > fuzzFactor) {
		            return false;
		          }
		        }
		        toPos++;
		      }
		    }

		    return true;
		  }

		  // Search best fit offsets for each hunk based on the previous ones
		  for (var i = 0; i < hunks.length; i++) {
		    var hunk = hunks[i],
		        maxLine = lines.length - hunk.oldLines,
		        localOffset = 0,
		        toPos = offset + hunk.oldStart - 1;

		    var iterator = /*istanbul ignore start*/(0, _distanceIterator2.default) /*istanbul ignore end*/(toPos, minLine, maxLine);

		    for (; localOffset !== undefined; localOffset = iterator()) {
		      if (hunkFits(hunk, toPos + localOffset)) {
		        hunk.offset = offset += localOffset;
		        break;
		      }
		    }

		    if (localOffset === undefined) {
		      return false;
		    }

		    // Set lower text limit to end of the current hunk, so next ones don't try
		    // to fit over already patched text
		    minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
		  }

		  // Apply patch hunks
		  for (var _i = 0; _i < hunks.length; _i++) {
		    var _hunk = hunks[_i],
		        _toPos = _hunk.offset + _hunk.newStart - 1;

		    for (var j = 0; j < _hunk.lines.length; j++) {
		      var line = _hunk.lines[j],
		          operation = line[0],
		          content = line.substr(1);

		      if (operation === ' ') {
		        _toPos++;
		      } else if (operation === '-') {
		        lines.splice(_toPos, 1);
		        /* istanbul ignore else */
		      } else if (operation === '+') {
		          lines.splice(_toPos, 0, content);
		          _toPos++;
		        } else if (operation === '\\') {
		          var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
		          if (previousOperation === '+') {
		            removeEOFNL = true;
		          } else if (previousOperation === '-') {
		            addEOFNL = true;
		          }
		        }
		    }
		  }

		  // Handle EOFNL insertion/removal
		  if (removeEOFNL) {
		    while (!lines[lines.length - 1]) {
		      lines.pop();
		    }
		  } else if (addEOFNL) {
		    lines.push('');
		  }
		  return lines.join('\n');
		}

		// Wrapper that supports multiple file patches via callbacks.
		function applyPatches(uniDiff, options) {
		  if (typeof uniDiff === 'string') {
		    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
		  }

		  var currentIndex = 0;
		  function processIndex() {
		    var index = uniDiff[currentIndex++];
		    if (!index) {
		      return options.complete();
		    }

		    options.loadFile(index, function (err, data) {
		      if (err) {
		        return options.complete(err);
		      }

		      var updatedContent = applyPatch(data, index, options);
		      options.patched(index, updatedContent);

		      setTimeout(processIndex, 0);
		    });
		  }
		  processIndex();
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wYXRjaC9hcHBseS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBR2dCO3lEQXFIQTs7QUF4SGhCOztBQUNBOzs7Ozs7O3VCQUVPLFNBQVMsVUFBVCxDQUFvQixNQUFwQixFQUE0QixPQUE1QixFQUFtRDtzREFBZCxnRUFBVSxrQkFBSTs7QUFDeEQsTUFBSSxPQUFPLE9BQVAsS0FBbUIsUUFBbkIsRUFBNkI7QUFDL0IsY0FBVSx3RUFBVyxPQUFYLENBQVYsQ0FEK0I7R0FBakM7O0FBSUEsTUFBSSxNQUFNLE9BQU4sQ0FBYyxPQUFkLENBQUosRUFBNEI7QUFDMUIsUUFBSSxRQUFRLE1BQVIsR0FBaUIsQ0FBakIsRUFBb0I7QUFDdEIsWUFBTSxJQUFJLEtBQUosQ0FBVSw0Q0FBVixDQUFOLENBRHNCO0tBQXhCOztBQUlBLGNBQVUsUUFBUSxDQUFSLENBQVYsQ0FMMEI7R0FBNUI7OztBQUx3RCxNQWNwRCxRQUFRLE9BQU8sS0FBUCxDQUFhLElBQWIsQ0FBUjtNQUNBLFFBQVEsUUFBUSxLQUFSO01BRVIsY0FBYyxRQUFRLFdBQVIsSUFBd0IsVUFBQyxVQUFELEVBQWEsSUFBYixFQUFtQixTQUFuQixFQUE4QixZQUE5QjttQ0FBK0MsU0FBUyxZQUFUOztHQUEvQztNQUN0QyxhQUFhLENBQWI7TUFDQSxhQUFhLFFBQVEsVUFBUixJQUFzQixDQUF0QjtNQUNiLFVBQVUsQ0FBVjtNQUNBLFNBQVMsQ0FBVDtNQUVBLHFFQVRKO01BVUksa0VBVko7Ozs7O0FBZHdELFdBNkIvQyxRQUFULENBQWtCLElBQWxCLEVBQXdCLEtBQXhCLEVBQStCO0FBQzdCLFNBQUssSUFBSSxJQUFJLENBQUosRUFBTyxJQUFJLEtBQUssS0FBTCxDQUFXLE1BQVgsRUFBbUIsR0FBdkMsRUFBNEM7QUFDMUMsVUFBSSxPQUFPLEtBQUssS0FBTCxDQUFXLENBQVgsQ0FBUDtVQUNBLFlBQVksS0FBSyxDQUFMLENBQVo7VUFDQSxVQUFVLEtBQUssTUFBTCxDQUFZLENBQVosQ0FBVixDQUhzQzs7QUFLMUMsVUFBSSxjQUFjLEdBQWQsSUFBcUIsY0FBYyxHQUFkLEVBQW1COztBQUUxQyxZQUFJLENBQUMsWUFBWSxRQUFRLENBQVIsRUFBVyxNQUFNLEtBQU4sQ0FBdkIsRUFBcUMsU0FBckMsRUFBZ0QsT0FBaEQsQ0FBRCxFQUEyRDtBQUM3RCx1QkFENkQ7O0FBRzdELGNBQUksYUFBYSxVQUFiLEVBQXlCO0FBQzNCLG1CQUFPLEtBQVAsQ0FEMkI7V0FBN0I7U0FIRjtBQU9BLGdCQVQwQztPQUE1QztLQUxGOztBQWtCQSxXQUFPLElBQVAsQ0FuQjZCO0dBQS9COzs7QUE3QndELE9Bb0RuRCxJQUFJLElBQUksQ0FBSixFQUFPLElBQUksTUFBTSxNQUFOLEVBQWMsR0FBbEMsRUFBdUM7QUFDckMsUUFBSSxPQUFPLE1BQU0sQ0FBTixDQUFQO1FBQ0EsVUFBVSxNQUFNLE1BQU4sR0FBZSxLQUFLLFFBQUw7UUFDekIsY0FBYyxDQUFkO1FBQ0EsUUFBUSxTQUFTLEtBQUssUUFBTCxHQUFnQixDQUF6QixDQUp5Qjs7QUFNckMsUUFBSSxXQUFXLGlGQUFpQixLQUFqQixFQUF3QixPQUF4QixFQUFpQyxPQUFqQyxDQUFYLENBTmlDOztBQVFyQyxXQUFPLGdCQUFnQixTQUFoQixFQUEyQixjQUFjLFVBQWQsRUFBMEI7QUFDMUQsVUFBSSxTQUFTLElBQVQsRUFBZSxRQUFRLFdBQVIsQ0FBbkIsRUFBeUM7QUFDdkMsYUFBSyxNQUFMLEdBQWMsVUFBVSxXQUFWLENBRHlCO0FBRXZDLGNBRnVDO09BQXpDO0tBREY7O0FBT0EsUUFBSSxnQkFBZ0IsU0FBaEIsRUFBMkI7QUFDN0IsYUFBTyxLQUFQLENBRDZCO0tBQS9COzs7O0FBZnFDLFdBcUJyQyxHQUFVLEtBQUssTUFBTCxHQUFjLEtBQUssUUFBTCxHQUFnQixLQUFLLFFBQUwsQ0FyQkg7R0FBdkM7OztBQXBEd0QsT0E2RW5ELElBQUksS0FBSSxDQUFKLEVBQU8sS0FBSSxNQUFNLE1BQU4sRUFBYyxJQUFsQyxFQUF1QztBQUNyQyxRQUFJLFFBQU8sTUFBTSxFQUFOLENBQVA7UUFDQSxTQUFRLE1BQUssTUFBTCxHQUFjLE1BQUssUUFBTCxHQUFnQixDQUE5QixDQUZ5Qjs7QUFJckMsU0FBSyxJQUFJLElBQUksQ0FBSixFQUFPLElBQUksTUFBSyxLQUFMLENBQVcsTUFBWCxFQUFtQixHQUF2QyxFQUE0QztBQUMxQyxVQUFJLE9BQU8sTUFBSyxLQUFMLENBQVcsQ0FBWCxDQUFQO1VBQ0EsWUFBWSxLQUFLLENBQUwsQ0FBWjtVQUNBLFVBQVUsS0FBSyxNQUFMLENBQVksQ0FBWixDQUFWLENBSHNDOztBQUsxQyxVQUFJLGNBQWMsR0FBZCxFQUFtQjtBQUNyQixpQkFEcUI7T0FBdkIsTUFFTyxJQUFJLGNBQWMsR0FBZCxFQUFtQjtBQUM1QixjQUFNLE1BQU4sQ0FBYSxNQUFiLEVBQW9CLENBQXBCOztBQUQ0QixPQUF2QixNQUdBLElBQUksY0FBYyxHQUFkLEVBQW1CO0FBQzVCLGdCQUFNLE1BQU4sQ0FBYSxNQUFiLEVBQW9CLENBQXBCLEVBQXVCLE9BQXZCLEVBRDRCO0FBRTVCLG1CQUY0QjtTQUF2QixNQUdBLElBQUksY0FBYyxJQUFkLEVBQW9CO0FBQzdCLGNBQUksb0JBQW9CLE1BQUssS0FBTCxDQUFXLElBQUksQ0FBSixDQUFYLEdBQW9CLE1BQUssS0FBTCxDQUFXLElBQUksQ0FBSixDQUFYLENBQWtCLENBQWxCLENBQXBCLEdBQTJDLElBQTNDLENBREs7QUFFN0IsY0FBSSxzQkFBc0IsR0FBdEIsRUFBMkI7QUFDN0IsMEJBQWMsSUFBZCxDQUQ2QjtXQUEvQixNQUVPLElBQUksc0JBQXNCLEdBQXRCLEVBQTJCO0FBQ3BDLHVCQUFXLElBQVgsQ0FEb0M7V0FBL0I7U0FKRjtLQWJUO0dBSkY7OztBQTdFd0QsTUEwR3BELFdBQUosRUFBaUI7QUFDZixXQUFPLENBQUMsTUFBTSxNQUFNLE1BQU4sR0FBZSxDQUFmLENBQVAsRUFBMEI7QUFDL0IsWUFBTSxHQUFOLEdBRCtCO0tBQWpDO0dBREYsTUFJTyxJQUFJLFFBQUosRUFBYztBQUNuQixVQUFNLElBQU4sQ0FBVyxFQUFYLEVBRG1CO0dBQWQ7QUFHUCxTQUFPLE1BQU0sSUFBTixDQUFXLElBQVgsQ0FBUCxDQWpId0Q7Q0FBbkQ7OztBQXFIQSxTQUFTLFlBQVQsQ0FBc0IsT0FBdEIsRUFBK0IsT0FBL0IsRUFBd0M7QUFDN0MsTUFBSSxPQUFPLE9BQVAsS0FBbUIsUUFBbkIsRUFBNkI7QUFDL0IsY0FBVSx3RUFBVyxPQUFYLENBQVYsQ0FEK0I7R0FBakM7O0FBSUEsTUFBSSxlQUFlLENBQWYsQ0FMeUM7QUFNN0MsV0FBUyxZQUFULEdBQXdCO0FBQ3RCLFFBQUksUUFBUSxRQUFRLGNBQVIsQ0FBUixDQURrQjtBQUV0QixRQUFJLENBQUMsS0FBRCxFQUFRO0FBQ1YsYUFBTyxRQUFRLFFBQVIsRUFBUCxDQURVO0tBQVo7O0FBSUEsWUFBUSxRQUFSLENBQWlCLEtBQWpCLEVBQXdCLFVBQVMsR0FBVCxFQUFjLElBQWQsRUFBb0I7QUFDMUMsVUFBSSxHQUFKLEVBQVM7QUFDUCxlQUFPLFFBQVEsUUFBUixDQUFpQixHQUFqQixDQUFQLENBRE87T0FBVDs7QUFJQSxVQUFJLGlCQUFpQixXQUFXLElBQVgsRUFBaUIsS0FBakIsRUFBd0IsT0FBeEIsQ0FBakIsQ0FMc0M7QUFNMUMsY0FBUSxPQUFSLENBQWdCLEtBQWhCLEVBQXVCLGNBQXZCLEVBTjBDOztBQVExQyxpQkFBVyxZQUFYLEVBQXlCLENBQXpCLEVBUjBDO0tBQXBCLENBQXhCLENBTnNCO0dBQXhCO0FBaUJBLGlCQXZCNkM7Q0FBeEMiLCJmaWxlIjoiYXBwbHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge3BhcnNlUGF0Y2h9IGZyb20gJy4vcGFyc2UnO1xuaW1wb3J0IGRpc3RhbmNlSXRlcmF0b3IgZnJvbSAnLi4vdXRpbC9kaXN0YW5jZS1pdGVyYXRvcic7XG5cbmV4cG9ydCBmdW5jdGlvbiBhcHBseVBhdGNoKHNvdXJjZSwgdW5pRGlmZiwgb3B0aW9ucyA9IHt9KSB7XG4gIGlmICh0eXBlb2YgdW5pRGlmZiA9PT0gJ3N0cmluZycpIHtcbiAgICB1bmlEaWZmID0gcGFyc2VQYXRjaCh1bmlEaWZmKTtcbiAgfVxuXG4gIGlmIChBcnJheS5pc0FycmF5KHVuaURpZmYpKSB7XG4gICAgaWYgKHVuaURpZmYubGVuZ3RoID4gMSkge1xuICAgICAgdGhyb3cgbmV3IEVycm9yKCdhcHBseVBhdGNoIG9ubHkgd29ya3Mgd2l0aCBhIHNpbmdsZSBpbnB1dC4nKTtcbiAgICB9XG5cbiAgICB1bmlEaWZmID0gdW5pRGlmZlswXTtcbiAgfVxuXG4gIC8vIEFwcGx5IHRoZSBkaWZmIHRvIHRoZSBpbnB1dFxuICBsZXQgbGluZXMgPSBzb3VyY2Uuc3BsaXQoJ1xcbicpLFxuICAgICAgaHVua3MgPSB1bmlEaWZmLmh1bmtzLFxuXG4gICAgICBjb21wYXJlTGluZSA9IG9wdGlvbnMuY29tcGFyZUxpbmUgfHwgKChsaW5lTnVtYmVyLCBsaW5lLCBvcGVyYXRpb24sIHBhdGNoQ29udGVudCkgPT4gbGluZSA9PT0gcGF0Y2hDb250ZW50KSxcbiAgICAgIGVycm9yQ291bnQgPSAwLFxuICAgICAgZnV6ekZhY3RvciA9IG9wdGlvbnMuZnV6ekZhY3RvciB8fCAwLFxuICAgICAgbWluTGluZSA9IDAsXG4gICAgICBvZmZzZXQgPSAwLFxuXG4gICAgICByZW1vdmVFT0ZOTCxcbiAgICAgIGFkZEVPRk5MO1xuXG4gIC8qKlxuICAgKiBDaGVja3MgaWYgdGhlIGh1bmsgZXhhY3RseSBmaXRzIG9uIHRoZSBwcm92aWRlZCBsb2NhdGlvblxuICAgKi9cbiAgZnVuY3Rpb24gaHVua0ZpdHMoaHVuaywgdG9Qb3MpIHtcbiAgICBmb3IgKGxldCBqID0gMDsgaiA8IGh1bmsubGluZXMubGVuZ3RoOyBqKyspIHtcbiAgICAgIGxldCBsaW5lID0gaHVuay5saW5lc1tqXSxcbiAgICAgICAgICBvcGVyYXRpb24gPSBsaW5lWzBdLFxuICAgICAgICAgIGNvbnRlbnQgPSBsaW5lLnN1YnN0cigxKTtcblxuICAgICAgaWYgKG9wZXJhdGlvbiA9PT0gJyAnIHx8IG9wZXJhdGlvbiA9PT0gJy0nKSB7XG4gICAgICAgIC8vIENvbnRleHQgc2FuaXR5IGNoZWNrXG4gICAgICAgIGlmICghY29tcGFyZUxpbmUodG9Qb3MgKyAxLCBsaW5lc1t0b1Bvc10sIG9wZXJhdGlvbiwgY29udGVudCkpIHtcbiAgICAgICAgICBlcnJvckNvdW50Kys7XG5cbiAgICAgICAgICBpZiAoZXJyb3JDb3VudCA+IGZ1enpGYWN0b3IpIHtcbiAgICAgICAgICAgIHJldHVybiBmYWxzZTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgdG9Qb3MrKztcbiAgICAgIH1cbiAgICB9XG5cbiAgICByZXR1cm4gdHJ1ZTtcbiAgfVxuXG4gIC8vIFNlYXJjaCBiZXN0IGZpdCBvZmZzZXRzIGZvciBlYWNoIGh1bmsgYmFzZWQgb24gdGhlIHByZXZpb3VzIG9uZXNcbiAgZm9yIChsZXQgaSA9IDA7IGkgPCBodW5rcy5sZW5ndGg7IGkrKykge1xuICAgIGxldCBodW5rID0gaHVua3NbaV0sXG4gICAgICAgIG1heExpbmUgPSBsaW5lcy5sZW5ndGggLSBodW5rLm9sZExpbmVzLFxuICAgICAgICBsb2NhbE9mZnNldCA9IDAsXG4gICAgICAgIHRvUG9zID0gb2Zmc2V0ICsgaHVuay5vbGRTdGFydCAtIDE7XG5cbiAgICBsZXQgaXRlcmF0b3IgPSBkaXN0YW5jZUl0ZXJhdG9yKHRvUG9zLCBtaW5MaW5lLCBtYXhMaW5lKTtcblxuICAgIGZvciAoOyBsb2NhbE9mZnNldCAhPT0gdW5kZWZpbmVkOyBsb2NhbE9mZnNldCA9IGl0ZXJhdG9yKCkpIHtcbiAgICAgIGlmIChodW5rRml0cyhodW5rLCB0b1BvcyArIGxvY2FsT2Zmc2V0KSkge1xuICAgICAgICBodW5rLm9mZnNldCA9IG9mZnNldCArPSBsb2NhbE9mZnNldDtcbiAgICAgICAgYnJlYWs7XG4gICAgICB9XG4gICAgfVxuXG4gICAgaWYgKGxvY2FsT2Zmc2V0ID09PSB1bmRlZmluZWQpIHtcbiAgICAgIHJldHVybiBmYWxzZTtcbiAgICB9XG5cbiAgICAvLyBTZXQgbG93ZXIgdGV4dCBsaW1pdCB0byBlbmQgb2YgdGhlIGN1cnJlbnQgaHVuaywgc28gbmV4dCBvbmVzIGRvbid0IHRyeVxuICAgIC8vIHRvIGZpdCBvdmVyIGFscmVhZHkgcGF0Y2hlZCB0ZXh0XG4gICAgbWluTGluZSA9IGh1bmsub2Zmc2V0ICsgaHVuay5vbGRTdGFydCArIGh1bmsub2xkTGluZXM7XG4gIH1cblxuICAvLyBBcHBseSBwYXRjaCBodW5rc1xuICBmb3IgKGxldCBpID0gMDsgaSA8IGh1bmtzLmxlbmd0aDsgaSsrKSB7XG4gICAgbGV0IGh1bmsgPSBodW5rc1tpXSxcbiAgICAgICAgdG9Qb3MgPSBodW5rLm9mZnNldCArIGh1bmsubmV3U3RhcnQgLSAxO1xuXG4gICAgZm9yIChsZXQgaiA9IDA7IGogPCBodW5rLmxpbmVzLmxlbmd0aDsgaisrKSB7XG4gICAgICBsZXQgbGluZSA9IGh1bmsubGluZXNbal0sXG4gICAgICAgICAgb3BlcmF0aW9uID0gbGluZVswXSxcbiAgICAgICAgICBjb250ZW50ID0gbGluZS5zdWJzdHIoMSk7XG5cbiAgICAgIGlmIChvcGVyYXRpb24gPT09ICcgJykge1xuICAgICAgICB0b1BvcysrO1xuICAgICAgfSBlbHNlIGlmIChvcGVyYXRpb24gPT09ICctJykge1xuICAgICAgICBsaW5lcy5zcGxpY2UodG9Qb3MsIDEpO1xuICAgICAgLyogaXN0YW5idWwgaWdub3JlIGVsc2UgKi9cbiAgICAgIH0gZWxzZSBpZiAob3BlcmF0aW9uID09PSAnKycpIHtcbiAgICAgICAgbGluZXMuc3BsaWNlKHRvUG9zLCAwLCBjb250ZW50KTtcbiAgICAgICAgdG9Qb3MrKztcbiAgICAgIH0gZWxzZSBpZiAob3BlcmF0aW9uID09PSAnXFxcXCcpIHtcbiAgICAgICAgbGV0IHByZXZpb3VzT3BlcmF0aW9uID0gaHVuay5saW5lc1tqIC0gMV0gPyBodW5rLmxpbmVzW2ogLSAxXVswXSA6IG51bGw7XG4gICAgICAgIGlmIChwcmV2aW91c09wZXJhdGlvbiA9PT0gJysnKSB7XG4gICAgICAgICAgcmVtb3ZlRU9GTkwgPSB0cnVlO1xuICAgICAgICB9IGVsc2UgaWYgKHByZXZpb3VzT3BlcmF0aW9uID09PSAnLScpIHtcbiAgICAgICAgICBhZGRFT0ZOTCA9IHRydWU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAvLyBIYW5kbGUgRU9GTkwgaW5zZXJ0aW9uL3JlbW92YWxcbiAgaWYgKHJlbW92ZUVPRk5MKSB7XG4gICAgd2hpbGUgKCFsaW5lc1tsaW5lcy5sZW5ndGggLSAxXSkge1xuICAgICAgbGluZXMucG9wKCk7XG4gICAgfVxuICB9IGVsc2UgaWYgKGFkZEVPRk5MKSB7XG4gICAgbGluZXMucHVzaCgnJyk7XG4gIH1cbiAgcmV0dXJuIGxpbmVzLmpvaW4oJ1xcbicpO1xufVxuXG4vLyBXcmFwcGVyIHRoYXQgc3VwcG9ydHMgbXVsdGlwbGUgZmlsZSBwYXRjaGVzIHZpYSBjYWxsYmFja3MuXG5leHBvcnQgZnVuY3Rpb24gYXBwbHlQYXRjaGVzKHVuaURpZmYsIG9wdGlvbnMpIHtcbiAgaWYgKHR5cGVvZiB1bmlEaWZmID09PSAnc3RyaW5nJykge1xuICAgIHVuaURpZmYgPSBwYXJzZVBhdGNoKHVuaURpZmYpO1xuICB9XG5cbiAgbGV0IGN1cnJlbnRJbmRleCA9IDA7XG4gIGZ1bmN0aW9uIHByb2Nlc3NJbmRleCgpIHtcbiAgICBsZXQgaW5kZXggPSB1bmlEaWZmW2N1cnJlbnRJbmRleCsrXTtcbiAgICBpZiAoIWluZGV4KSB7XG4gICAgICByZXR1cm4gb3B0aW9ucy5jb21wbGV0ZSgpO1xuICAgIH1cblxuICAgIG9wdGlvbnMubG9hZEZpbGUoaW5kZXgsIGZ1bmN0aW9uKGVyciwgZGF0YSkge1xuICAgICAgaWYgKGVycikge1xuICAgICAgICByZXR1cm4gb3B0aW9ucy5jb21wbGV0ZShlcnIpO1xuICAgICAgfVxuXG4gICAgICBsZXQgdXBkYXRlZENvbnRlbnQgPSBhcHBseVBhdGNoKGRhdGEsIGluZGV4LCBvcHRpb25zKTtcbiAgICAgIG9wdGlvbnMucGF0Y2hlZChpbmRleCwgdXBkYXRlZENvbnRlbnQpO1xuXG4gICAgICBzZXRUaW1lb3V0KHByb2Nlc3NJbmRleCwgMCk7XG4gICAgfSk7XG4gIH1cbiAgcHJvY2Vzc0luZGV4KCk7XG59XG4iXX0=


	/***/ },
	/* 10 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports. /*istanbul ignore end*/parsePatch = parsePatch;
		function parsePatch(uniDiff) {
		  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		  var diffstr = uniDiff.split('\n'),
		      list = [],
		      i = 0;

		  function parseIndex() {
		    var index = {};
		    list.push(index);

		    // Parse diff metadata
		    while (i < diffstr.length) {
		      var line = diffstr[i];

		      // File header found, end parsing diff metadata
		      if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) {
		        break;
		      }

		      // Diff index
		      var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
		      if (header) {
		        index.index = header[1];
		      }

		      i++;
		    }

		    // Parse file headers if they are defined. Unified diff requires them, but
		    // there's no technical issues to have an isolated hunk without file header
		    parseFileHeader(index);
		    parseFileHeader(index);

		    // Parse hunks
		    index.hunks = [];

		    while (i < diffstr.length) {
		      var _line = diffstr[i];

		      if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) {
		        break;
		      } else if (/^@@/.test(_line)) {
		        index.hunks.push(parseHunk());
		      } else if (_line && options.strict) {
		        // Ignore unexpected content unless in strict mode
		        throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
		      } else {
		        i++;
		      }
		    }
		  }

		  // Parses the --- and +++ headers, if none are found, no lines
		  // are consumed.
		  function parseFileHeader(index) {
		    var fileHeader = /^(\-\-\-|\+\+\+)\s+(\S*)\s?(.*?)\s*$/.exec(diffstr[i]);
		    if (fileHeader) {
		      var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
		      index[keyPrefix + 'FileName'] = fileHeader[2];
		      index[keyPrefix + 'Header'] = fileHeader[3];

		      i++;
		    }
		  }

		  // Parses a hunk
		  // This assumes that we are at the start of a hunk.
		  function parseHunk() {
		    var chunkHeaderIndex = i,
		        chunkHeaderLine = diffstr[i++],
		        chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);

		    var hunk = {
		      oldStart: +chunkHeader[1],
		      oldLines: +chunkHeader[2] || 1,
		      newStart: +chunkHeader[3],
		      newLines: +chunkHeader[4] || 1,
		      lines: []
		    };

		    var addCount = 0,
		        removeCount = 0;
		    for (; i < diffstr.length; i++) {
		      var operation = diffstr[i][0];

		      if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
		        hunk.lines.push(diffstr[i]);

		        if (operation === '+') {
		          addCount++;
		        } else if (operation === '-') {
		          removeCount++;
		        } else if (operation === ' ') {
		          addCount++;
		          removeCount++;
		        }
		      } else {
		        break;
		      }
		    }

		    // Handle the empty block count case
		    if (!addCount && hunk.newLines === 1) {
		      hunk.newLines = 0;
		    }
		    if (!removeCount && hunk.oldLines === 1) {
		      hunk.oldLines = 0;
		    }

		    // Perform optional sanity checking
		    if (options.strict) {
		      if (addCount !== hunk.newLines) {
		        throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
		      }
		      if (removeCount !== hunk.oldLines) {
		        throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
		      }
		    }

		    return hunk;
		  }

		  while (i < diffstr.length) {
		    parseIndex();
		  }

		  return list;
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 11 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/"use strict";

		exports.__esModule = true;

		exports.default = /*istanbul ignore end*/function (start, minLine, maxLine) {
		  var wantForward = true,
		      backwardExhausted = false,
		      forwardExhausted = false,
		      localOffset = 1;

		  return function iterator() {
		    if (wantForward && !forwardExhausted) {
		      if (backwardExhausted) {
		        localOffset++;
		      } else {
		        wantForward = false;
		      }

		      // Check if trying to fit beyond text length, and if not, check it fits
		      // after offset location (or desired location on first iteration)
		      if (start + localOffset <= maxLine) {
		        return localOffset;
		      }

		      forwardExhausted = true;
		    }

		    if (!backwardExhausted) {
		      if (!forwardExhausted) {
		        wantForward = true;
		      }

		      // Check if trying to fit before text beginning, and if not, check it fits
		      // before offset location
		      if (minLine <= start - localOffset) {
		        return - localOffset++;
		      }

		      backwardExhausted = true;
		      return iterator();
		    }

		    // We tried to fit hunk before text beginning and beyond text lenght, then
		    // hunk can't fit on the text. Return undefined
		  };
		};
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports. /*istanbul ignore end*/structuredPatch = structuredPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = createTwoFilesPatch;
		/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = createPatch;

		var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

		/*istanbul ignore start*/
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

		/*istanbul ignore end*/function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
		  if (!options) {
		    options = { context: 4 };
		  }

		  var diff = /*istanbul ignore start*/(0, _line.diffLines) /*istanbul ignore end*/(oldStr, newStr);
		  diff.push({ value: '', lines: [] }); // Append an empty value to make cleanup easier

		  function contextLines(lines) {
		    return lines.map(function (entry) {
		      return ' ' + entry;
		    });
		  }

		  var hunks = [];
		  var oldRangeStart = 0,
		      newRangeStart = 0,
		      curRange = [],
		      oldLine = 1,
		      newLine = 1;
		  /*istanbul ignore start*/
		  var _loop = function _loop( /*istanbul ignore end*/i) {
		    var current = diff[i],
		        lines = current.lines || current.value.replace(/\n$/, '').split('\n');
		    current.lines = lines;

		    if (current.added || current.removed) {
		      /*istanbul ignore start*/
		      var _curRange;

		      /*istanbul ignore end*/
		      // If we have previous context, start with that
		      if (!oldRangeStart) {
		        var prev = diff[i - 1];
		        oldRangeStart = oldLine;
		        newRangeStart = newLine;

		        if (prev) {
		          curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
		          oldRangeStart -= curRange.length;
		          newRangeStart -= curRange.length;
		        }
		      }

		      // Output our changes
		      /*istanbul ignore start*/(_curRange = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/lines.map(function (entry) {
		        return (current.added ? '+' : '-') + entry;
		      })));

		      // Track the updated file position
		      if (current.added) {
		        newLine += lines.length;
		      } else {
		        oldLine += lines.length;
		      }
		    } else {
		      // Identical context lines. Track line changes
		      if (oldRangeStart) {
		        // Close out any changes that have been output (or join overlapping)
		        if (lines.length <= options.context * 2 && i < diff.length - 2) {
		          /*istanbul ignore start*/
		          var _curRange2;

		          /*istanbul ignore end*/
		          // Overlapping
		          /*istanbul ignore start*/(_curRange2 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange2 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines)));
		        } else {
		          /*istanbul ignore start*/
		          var _curRange3;

		          /*istanbul ignore end*/
		          // end the range and output
		          var contextSize = Math.min(lines.length, options.context);
		          /*istanbul ignore start*/(_curRange3 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange3 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines.slice(0, contextSize))));

		          var hunk = {
		            oldStart: oldRangeStart,
		            oldLines: oldLine - oldRangeStart + contextSize,
		            newStart: newRangeStart,
		            newLines: newLine - newRangeStart + contextSize,
		            lines: curRange
		          };
		          if (i >= diff.length - 2 && lines.length <= options.context) {
		            // EOF is inside this hunk
		            var oldEOFNewline = /\n$/.test(oldStr);
		            var newEOFNewline = /\n$/.test(newStr);
		            if (lines.length == 0 && !oldEOFNewline) {
		              // special case: old has no eol and no trailing context; no-nl can end up before adds
		              curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
		            } else if (!oldEOFNewline || !newEOFNewline) {
		              curRange.push('\\ No newline at end of file');
		            }
		          }
		          hunks.push(hunk);

		          oldRangeStart = 0;
		          newRangeStart = 0;
		          curRange = [];
		        }
		      }
		      oldLine += lines.length;
		      newLine += lines.length;
		    }
		  };

		  for (var i = 0; i < diff.length; i++) {
		    /*istanbul ignore start*/
		    _loop( /*istanbul ignore end*/i);
		  }

		  return {
		    oldFileName: oldFileName, newFileName: newFileName,
		    oldHeader: oldHeader, newHeader: newHeader,
		    hunks: hunks
		  };
		}

		function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
		  var diff = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);

		  var ret = [];
		  if (oldFileName == newFileName) {
		    ret.push('Index: ' + oldFileName);
		  }
		  ret.push('===================================================================');
		  ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
		  ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));

		  for (var i = 0; i < diff.hunks.length; i++) {
		    var hunk = diff.hunks[i];
		    ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
		    ret.push.apply(ret, hunk.lines);
		  }

		  return ret.join('\n') + '\n';
		}

		function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
		  return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ },
	/* 13 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/"use strict";

		exports.__esModule = true;
		exports. /*istanbul ignore end*/convertChangesToDMP = convertChangesToDMP;
		// See: http://code.google.com/p/google-diff-match-patch/wiki/API
		function convertChangesToDMP(changes) {
		  var ret = [],
		      change = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
		      operation = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
		  for (var i = 0; i < changes.length; i++) {
		    change = changes[i];
		    if (change.added) {
		      operation = 1;
		    } else if (change.removed) {
		      operation = -1;
		    } else {
		      operation = 0;
		    }

		    ret.push([operation, change.value]);
		  }
		  return ret;
		}
		//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb252ZXJ0L2RtcC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQ2dCOztBQUFULFNBQVMsbUJBQVQsQ0FBNkIsT0FBN0IsRUFBc0M7QUFDM0MsTUFBSSxNQUFNLEVBQU47TUFDQSxnRUFESjtNQUVJLG1FQUZKLENBRDJDO0FBSTNDLE9BQUssSUFBSSxJQUFJLENBQUosRUFBTyxJQUFJLFFBQVEsTUFBUixFQUFnQixHQUFwQyxFQUF5QztBQUN2QyxhQUFTLFFBQVEsQ0FBUixDQUFULENBRHVDO0FBRXZDLFFBQUksT0FBTyxLQUFQLEVBQWM7QUFDaEIsa0JBQVksQ0FBWixDQURnQjtLQUFsQixNQUVPLElBQUksT0FBTyxPQUFQLEVBQWdCO0FBQ3pCLGtCQUFZLENBQUMsQ0FBRCxDQURhO0tBQXBCLE1BRUE7QUFDTCxrQkFBWSxDQUFaLENBREs7S0FGQTs7QUFNUCxRQUFJLElBQUosQ0FBUyxDQUFDLFNBQUQsRUFBWSxPQUFPLEtBQVAsQ0FBckIsRUFWdUM7R0FBekM7QUFZQSxTQUFPLEdBQVAsQ0FoQjJDO0NBQXRDIiwiZmlsZSI6ImRtcC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNlZTogaHR0cDovL2NvZGUuZ29vZ2xlLmNvbS9wL2dvb2dsZS1kaWZmLW1hdGNoLXBhdGNoL3dpa2kvQVBJXG5leHBvcnQgZnVuY3Rpb24gY29udmVydENoYW5nZXNUb0RNUChjaGFuZ2VzKSB7XG4gIGxldCByZXQgPSBbXSxcbiAgICAgIGNoYW5nZSxcbiAgICAgIG9wZXJhdGlvbjtcbiAgZm9yIChsZXQgaSA9IDA7IGkgPCBjaGFuZ2VzLmxlbmd0aDsgaSsrKSB7XG4gICAgY2hhbmdlID0gY2hhbmdlc1tpXTtcbiAgICBpZiAoY2hhbmdlLmFkZGVkKSB7XG4gICAgICBvcGVyYXRpb24gPSAxO1xuICAgIH0gZWxzZSBpZiAoY2hhbmdlLnJlbW92ZWQpIHtcbiAgICAgIG9wZXJhdGlvbiA9IC0xO1xuICAgIH0gZWxzZSB7XG4gICAgICBvcGVyYXRpb24gPSAwO1xuICAgIH1cblxuICAgIHJldC5wdXNoKFtvcGVyYXRpb24sIGNoYW5nZS52YWx1ZV0pO1xuICB9XG4gIHJldHVybiByZXQ7XG59XG4iXX0=


	/***/ },
	/* 14 */
	/***/ function(module, exports) {

		/*istanbul ignore start*/'use strict';

		exports.__esModule = true;
		exports. /*istanbul ignore end*/convertChangesToXML = convertChangesToXML;
		function convertChangesToXML(changes) {
		  var ret = [];
		  for (var i = 0; i < changes.length; i++) {
		    var change = changes[i];
		    if (change.added) {
		      ret.push('<ins>');
		    } else if (change.removed) {
		      ret.push('<del>');
		    }

		    ret.push(escapeHTML(change.value));

		    if (change.added) {
		      ret.push('</ins>');
		    } else if (change.removed) {
		      ret.push('</del>');
		    }
		  }
		  return ret.join('');
		}

		function escapeHTML(s) {
		  var n = s;
		  n = n.replace(/&/g, '&amp;');
		  n = n.replace(/</g, '&lt;');
		  n = n.replace(/>/g, '&gt;');
		  n = n.replace(/"/g, '&quot;');

		  return n;
		}
		//# sourceMappingURL=data:application/json;base64,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


	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	angular.module('angular-timeline', []);// Source: src/timeline-badge-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-badge
	 * @restrict AE
	 *
	 * @description
	 * Shown in the centre pane (or left on narrow devices) to indicate the activity.
	 */
	angular.module('angular-timeline').directive('timelineBadge', function() {
	  return {
	    require: '^timelineEvent',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-badge" ng-transclude></div>'
	  };
	});

	// Source: src/timeline-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline
	 * @restrict AE
	 *
	 * @description
	 * Primary container for displaying a vertical set of timeline events.
	 */
	angular.module('angular-timeline').directive('timeline', function() {
	  return {
	    restrict: 'AE',
	    transclude: true,
	    template: '<ul class="timeline" ng-transclude></ul>',
	    controller: function() {}
	  };
	});

	// Source: src/timeline-event-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline
	 * @restrict AE
	 *
	 * @description
	 * Represents an event occuring at a point in time, displayed on the left or the right
	 * of the timeline line.
	 *
	 * You typically embed a `timeline-badge` and `timeline-panel` element within a `timeline-event`.
	 *
	 * @param {string=} side  Define the side of the element (i.e. side="left", side="right", or use an {{ expression }}).
	 */

	angular.module('angular-timeline').directive('timelineEvent', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<li class="timeline-event" ng-class-odd="oddClass" ng-class-even="evenClass" ng-transclude></li>',
	    link: function(scope, element, attrs, controller) {

	      var checkClass = function(side, leftSide) {

	        var leftClass = '';
	        var rightClass = 'timeline-inverted';

	        if (side === 'left' || (!side && leftSide === true)) {
	          return leftClass;
	        }
	        else if ((side === 'alternate' || !side) && leftSide === false) {
	          return rightClass;
	        }
	        else if (side === 'right') {
	          return rightClass;
	        }
	        else {
	          return leftClass;
	        }
	      };

	      var updateRowClasses = function(value) {
	        scope.oddClass = checkClass(value, true);
	        scope.evenClass = checkClass(value, false);
	      };

	      attrs.$observe('side', function(newValue) {
	        updateRowClasses(newValue);
	      });

	      updateRowClasses(attrs.side);
	    }
	  };
	});

	// Source: src/timeline-footer-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-footer
	 * @restrict AE
	 *
	 * @description
	 * Optional element to add a footer section to the `timeline-panel` for links or other actions.
	 */
	angular.module('angular-timeline').directive('timelineFooter', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-footer" ng-transclude></div>'
	  };
	});

	// Source: src/timeline-heading-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-heading
	 * @restrict AE
	 *
	 * @description
	 * Optional element to show the heading for a `timeline-panel`.
	 */
	angular.module('angular-timeline').directive('timelineHeading', function() {
	  return {
	    require: '^timelinePanel',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-heading" ng-transclude></div>'
	  };
	});

	// Source: src/timeline-panel-directive.js
	/**
	 * @ngdoc directive
	 * @name angular-timeline.directive:timeline-panel
	 * @restrict AE
	 *
	 * @description
	 * An panel inside the `timeline-event` which shows detailed information about the event.
	 */
	angular.module('angular-timeline').directive('timelinePanel', function() {
	  return {
	    require: '^timeline',
	    restrict: 'AE',
	    transclude: true,
	    template: '<div class="timeline-panel" ng-transclude></div>'
	  };
	});


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(91)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./angular-timeline.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./angular-timeline.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(90)();
	// imports


	// module
	exports.push([module.id, ".nIk1BgCtI3t_z3DvFLkwz .Jzsj7oY-t_U8MAs6FLh2g{margin-right:4px;vertical-align:-1px}img{vertical-align:middle}._3IWEaWwseBPs5ivtSm0YVh{display:block;height:auto;max-width:100%}.lZQbPl2mT1v20T6UQ_co_{border-radius:3px}.eamTtv4Xz1YgnW2X0OQB6{background-color:#fff;border:1px solid #ededf0;border-radius:3px;display:inline-block;height:auto;line-height:1.428571429;max-width:100%;moz-transition:all .2s ease-in-out;o-transition:all .2s ease-in-out;padding:2px;transition:all .2s ease-in-out;webkit-transition:all .2s ease-in-out}.RO5GAKwaMLq5VE1fq-qSM{border-radius:50%}.caX2BIbm-uwhNsrw93Sg9{padding:0;list-style:none;position:relative}.caX2BIbm-uwhNsrw93Sg9:before{top:0;bottom:0;position:absolute;content:\" \";width:3px;background-color:#ccc;left:50%;margin-left:-1.5px}._2Q8HPBJzPC6km7UWBt1Tdx{margin-bottom:20px;position:relative}._1NYjlvVQB4Djdoay2Kv-UK{margin-top:10px;padding:10px 0}._1NYjlvVQB4Djdoay2Kv-UK a{color:#fff;background-color:#acb7c0;border-radius:.25em;padding:.8em 1em;margin:0}timeline-badge.QoMdFsuaoHd7wvU-jaHnO{background-color:#2e6da4!important}timeline-badge._1oLxsSVMeBJ-O6Pu_sgNRq{background-color:#3f903f!important}timeline-badge.D08WITUokNjx2ienyGELe{background-color:#f0ad4e!important}timeline-badge._2w64nm1zC6mQpmMGIiE6Bw{background-color:#d9534f!important}timeline-badge._3mEStjaig40LXYv_bhqGYg{background-color:#5bc0de!important}._1K5TvEdTD4y6lHOQzdAASv{margin-top:0}timeline-panel>*{margin:0}timeline-panel{background-color:#fff;float:left;border:1px solid #d4d4d4;border-radius:2px;padding:12px;position:relative;box-shadow:0 1px 6px rgba(0,0,0,.175)}timeline-panel:before{top:35px;right:-15px;border-top:15px solid transparent;border-left:15px solid #ccc;border-right:0 solid #ccc;border-bottom:15px solid transparent}timeline-panel:after,timeline-panel:before{position:absolute;display:inline-block;content:\" \"}timeline-panel:after{top:36px;right:-14px;border-top:14px solid transparent;border-left:14px solid #fff;border-right:0 solid #fff;border-bottom:14px solid transparent}timeline-badge{box-shadow:0 0 0 4px #fff,inset 0 2px 0 rgba(0,0,0,.08),0 3px 0 4px rgba(0,0,0,.05);color:#fff;width:50px;height:50px;line-height:50px;font-size:1.4em;text-align:center;position:absolute;top:26px;left:50%;margin-left:-25px;background-color:#999;z-index:100;border-top-right-radius:50%;border-top-left-radius:50%;border-bottom-right-radius:50%;border-bottom-left-radius:50%}._2_kl2unB5ItKHOKtQj1pxd timeline-panel{float:right}._2_kl2unB5ItKHOKtQj1pxd timeline-panel:before{border-left-width:0;border-right-width:15px;left:-15px;right:auto}._2_kl2unB5ItKHOKtQj1pxd timeline-panel:after{border-left-width:0;border-right-width:14px;left:-14px;right:auto}._2Q8HPBJzPC6km7UWBt1Tdx:after,._2Q8HPBJzPC6km7UWBt1Tdx:before{content:\" \";display:table}._2Q8HPBJzPC6km7UWBt1Tdx:after{clear:both}@media only screen and (min-width:768px){timeline-panel{width:calc(50% - 45px);width:-webkit-calc(50% - 45px)}}@media only screen and (max-width:767px){.caX2BIbm-uwhNsrw93Sg9:before{left:40px}timeline-panel{width:calc(100% - 85px);width:-webkit-calc(100% - 85px)}timeline-badge{left:15px;margin-left:0;top:36px}timeline-panel{float:right}timeline-panel:before{border-left-width:0;border-right-width:15px;left:-15px;right:auto;top:46px}timeline-panel:after{border-left-width:0;border-right-width:14px;left:-14px;right:auto;top:47px}}", ""]);

	// exports
	exports.locals = {
		"timeline-heading": "nIk1BgCtI3t_z3DvFLkwz",
		"glyphicon": "Jzsj7oY-t_U8MAs6FLh2g",
		"img-responsive": "_3IWEaWwseBPs5ivtSm0YVh",
		"img-rounded": "lZQbPl2mT1v20T6UQ_co_",
		"img-thumbnail": "eamTtv4Xz1YgnW2X0OQB6",
		"img-circle": "RO5GAKwaMLq5VE1fq-qSM",
		"timeline": "caX2BIbm-uwhNsrw93Sg9",
		"timeline-event": "_2Q8HPBJzPC6km7UWBt1Tdx",
		"timeline-footer": "_1NYjlvVQB4Djdoay2Kv-UK",
		"primary": "QoMdFsuaoHd7wvU-jaHnO",
		"success": "_1oLxsSVMeBJ-O6Pu_sgNRq",
		"warning": "D08WITUokNjx2ienyGELe",
		"danger": "_2w64nm1zC6mQpmMGIiE6Bw",
		"info": "_3mEStjaig40LXYv_bhqGYg",
		"timeline-title": "_1K5TvEdTD4y6lHOQzdAASv",
		"timeline-inverted": "_2_kl2unB5ItKHOKtQj1pxd"
	};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * @license Angulartics
	 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
	 * License: MIT
	 */
	!function(a,b){"use strict";function c(){
	// General buffering handler
	function b(a){return function(){k.waitForVendorCount&&(m[a]||(m[a]=[]),m[a].push(arguments))}}
	// As handlers are installed by plugins, they get pushed into a list and invoked in order.
	function c(b,c,d){return n[b]||(n[b]=[]),n[b].push(c),o[c]=d,function(){if(!this.settings.optOut){var c=Array.prototype.slice.apply(arguments);return this.$inject(["$q",a.bind(this,function(d){return d.all(n[b].map(function(b){var e=o[b]||{};if(e.async){var f=d.defer(),g=a.copy(c);return g.unshift(f.resolve),b.apply(this,g),f.promise}return d.when(b.apply(this,c))},this))})])}}}
	// Will run setTimeout if delay is > 0
	// Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
	// Plugins should take care to register handlers by order of precedence.
	function d(a,b){b?setTimeout(a,b):a()}
	// General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
	function e(b,e,f){
	// Do not add a handler if developerMode is true
	if(!j.developerMode){p[b]=c(b,e,f);var g=j[b],h=g?g.bufferFlushDelay:null,i=null!==h?h:j.bufferFlushDelay;a.forEach(m[b],function(a,b){d(function(){e.apply(this,a)},b*i)})}}function f(a){return a.replace(/^./,function(a){return a.toUpperCase()})}
	// Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
	function g(a){var d="register"+f(a);q[d]=function(b,c){e(a,b,c)},p[a]=c(a,b(a))}function h(b,c,d){a.forEach(c,d);for(var e in b)i[e]=b[e]}var i=this,j={pageTracking:{autoTrackFirstPage:!0,autoTrackVirtualPages:!0,trackRelativePath:!1,trackRoutes:!0,trackStates:!0,autoBasePath:!1,basePath:"",excludedRoutes:[]},eventTracking:{},bufferFlushDelay:1e3,// Support only one configuration for buffer flush delay to simplify buffering
	trackExceptions:!1,optOut:!1,developerMode:!1},l=["pageTrack","eventTrack","exceptionTrack","transactionTrack","setAlias","setUsername","setUserProperties","setUserPropertiesOnce","setSuperProperties","setSuperPropertiesOnce","incrementProperty","userTimings","clearCookies"],m={},n={},o={},p={settings:j};
	// Opt in and opt out functions
	p.setOptOut=function(a){this.settings.optOut=a,s()},p.getOptOut=function(){return this.settings.optOut};var q={$get:["$injector",function(a){return r(a)}],api:p,settings:j,virtualPageviews:function(a){this.settings.pageTracking.autoTrackVirtualPages=a},trackStates:function(a){this.settings.pageTracking.trackStates=a},trackRoutes:function(a){this.settings.pageTracking.trackRoutes=a},excludeRoutes:function(a){this.settings.pageTracking.excludedRoutes=a},firstPageview:function(a){this.settings.pageTracking.autoTrackFirstPage=a},withBase:function(b){this.settings.pageTracking.basePath=b?a.element(document).find("base").attr("href"):""},withAutoBase:function(a){this.settings.pageTracking.autoBasePath=a},trackExceptions:function(a){this.settings.trackExceptions=a},developerMode:function(a){this.settings.developerMode=a}},r=function(b){return a.extend(p,{$inject:b.invoke})},s=function(){h(q,l,g)};
	// Initial register
	h(q,l,g)}function d(b,c,d,e){function f(a){for(var b=0;b<d.settings.pageTracking.excludedRoutes.length;b++){var c=d.settings.pageTracking.excludedRoutes[b];if(c instanceof RegExp&&c.test(a)||a.indexOf(c)>-1)return!0}return!1}function g(a,b){f(a)||d.pageTrack(a,b)}d.settings.pageTracking.autoTrackFirstPage&&e.invoke(["$location",function(a){/* Only track the 'first page' if there are no routes or states on the page */
	var b=!0;if(e.has("$route")){var f=e.get("$route");if(f)for(var h in f.routes){b=!1;break}else null===f&&(b=!1)}else if(e.has("$state")){var i=e.get("$state");for(var j in i.get()){b=!1;break}}if(b)if(d.settings.pageTracking.autoBasePath&&(d.settings.pageTracking.basePath=c.location.pathname),d.settings.pageTracking.trackRelativePath){var k=d.settings.pageTracking.basePath+a.url();g(k,a)}else g(a.absUrl(),a)}]),d.settings.pageTracking.autoTrackVirtualPages&&e.invoke(["$location",function(a){d.settings.pageTracking.autoBasePath&&(/* Add the full route to the base. */
	d.settings.pageTracking.basePath=c.location.pathname+"#");var f=!0;if(d.settings.pageTracking.trackRoutes&&e.has("$route")){var h=e.get("$route");if(h)for(var i in h.routes){f=!1;break}else null===h&&(f=!1);b.$on("$routeChangeSuccess",function(b,c){if(!c||!(c.$$route||c).redirectTo){var e=d.settings.pageTracking.basePath+a.url();g(e,a)}})}d.settings.pageTracking.trackStates&&(e.has("$state")&&!e.has("$transitions")&&(f=!1,b.$on("$stateChangeSuccess",function(b,c){var e=d.settings.pageTracking.basePath+a.url();g(e,a)})),e.has("$state")&&e.has("$transitions")&&(f=!1,e.invoke(["$transitions",function(b){b.onSuccess({},function(b){var c=b.options();
	// only track for transitions that would have triggered $stateChangeSuccess
	if(c.notify){var e=d.settings.pageTracking.basePath+a.url();g(e,a)}})}]))),f&&b.$on("$locationChangeSuccess",function(b,c){if(!c||!(c.$$route||c).redirectTo)if(d.settings.pageTracking.trackRelativePath){var e=d.settings.pageTracking.basePath+a.url();g(e,a)}else g(a.absUrl(),a)})}]),d.settings.developerMode&&a.forEach(d,function(a,b){"function"==typeof a&&(d[b]=function(){})})}function e(b){return{restrict:"A",link:function(c,d,e){var f=e.analyticsOn||"click",g={};a.forEach(e.$attr,function(a,b){i(b)&&(g[j(b)]=e[b],e.$observe(b,function(a){g[j(b)]=a}))}),a.element(d[0]).bind(f,function(f){var i=e.analyticsEvent||h(d[0]);g.eventType=f.type,e.analyticsIf&&!c.$eval(e.analyticsIf)||(
	// Allow components to pass through an expression that gets merged on to the event properties
	// eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
	e.analyticsProperties&&a.extend(g,c.$eval(e.analyticsProperties)),b.eventTrack(i,g))})}}}function f(a){a.decorator("$exceptionHandler",["$delegate","$injector",function(a,b){return function(c,d){var e=a(c,d),f=b.get("$analytics");return f.settings.trackExceptions&&f.exceptionTrack(c,d),e}}])}function g(a){return["a:","button:","button:button","button:submit","input:button","input:submit"].indexOf(a.tagName.toLowerCase()+":"+(a.type||""))>=0}function h(a){return g(a)?a.innerText||a.value:a.id||a.name||a.tagName}function i(a){return"analytics"===a.substr(0,9)&&["On","Event","If","Properties","EventType"].indexOf(a.substr(9))===-1}function j(a){var b=a.slice(9);// slice off the 'analytics' prefix
	// slice off the 'analytics' prefix
	return"undefined"!=typeof b&&null!==b&&b.length>0?b.substring(0,1).toLowerCase()+b.substring(1):b}var k=window.angulartics||(window.angulartics={});k.waitForVendorCount=0,k.waitForVendorApi=function(a,b,c,d,e){e||k.waitForVendorCount++,d||(d=c,c=void 0),!Object.prototype.hasOwnProperty.call(window,a)||void 0!==c&&void 0===window[a][c]?setTimeout(function(){k.waitForVendorApi(a,b,c,d,!0)},b):(k.waitForVendorCount--,d(window[a]))},/**
	 * @ngdoc overview
	 * @name angulartics
	 */
	a.module("angulartics",[]).provider("$analytics",c).run(["$rootScope","$window","$analytics","$injector",d]).directive("analyticsOn",["$analytics",e]).config(["$provide",f])}(angular);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	!function(window,angular,undefined){"use strict";angular.module("angulartics.google.analytics",["angulartics"]).config(["$analyticsProvider",function($analyticsProvider){function detectUniversalAnalytics(){var gaNamespace=window.GoogleAnalyticsObject;return gaNamespace&&window[gaNamespace]}function detectClassicAnalytics(){return!angular.isUndefined(window._gaq)}function dimensionsAndMetrics(properties){var key,customData={};for(key in properties)key.indexOf("dimension")&&key.indexOf("metric")||(customData[key]=properties[key]);return customData}$analyticsProvider.settings.pageTracking.trackRelativePath=!0,$analyticsProvider.settings.ga={additionalAccountNames:undefined,additionalAccountHitTypes:{pageview:!0,event:!0,exception:!1,ecommerce:!1,userTiming:!1,setUserProperties:!1,userId:!1},disableEventTracking:null,disablePageTracking:null,enhancedEcommerce:!1,transport:null,userId:null},$analyticsProvider.registerPageTrack(function(path,properties){properties=properties||{},$analyticsProvider.settings.ga.disablePageTracking||dispatchToGa("pageview","send",angular.extend({},properties,{hitType:"pageview",page:path}))}),$analyticsProvider.registerEventTrack(function(action,properties){if(!$analyticsProvider.settings.ga.disableEventTracking&&(action||action+""=="0")){if(properties=properties||{},properties.category=properties.category||"Event",properties.value){var parsed=parseInt(properties.value,10);properties.value=isNaN(parsed)?0:parsed}angular.isFunction(properties.hitCallback)||(properties.hitCallback=null),properties.nonInteraction=properties.nonInteraction||properties.noninteraction,dispatchToGa("event","send",angular.extend({},properties,{hitType:"event",eventCategory:properties.category,eventAction:action,eventLabel:properties.label,eventValue:properties.value,nonInteraction:properties.nonInteraction,page:properties.page||window.location.hash.substring(1)||window.location.pathname,hitCallback:properties.hitCallback}))}}),$analyticsProvider.registerExceptionTrack(function(error,cause){dispatchToGa("exception","send",{hitType:"event",eventCategory:"Exceptions",eventAction:error.toString(),eventLabel:error.stack,nonInteraction:!0,page:window.location.hash.substring(1)||window.location.pathname,isException:!0})}),$analyticsProvider.registerSetUsername(function(userId){$analyticsProvider.settings.ga.userId=userId}),$analyticsProvider.registerSetUserProperties(function(properties){properties&&dispatchToGa("setUserProperties","set",dimensionsAndMetrics(properties))}),$analyticsProvider.registerUserTimings(function(properties){return!angular.isObject(properties)||angular.isArray(properties)?console.log("Required argument properties is missing or not an object"):(angular.forEach(["timingCategory","timingVar","timingValue"],function(prop){if(angular.isUndefined(properties[prop]))return console.log("Argument properties missing required property "+prop)}),void dispatchToGa("userTiming","send",{hitType:"timing",timingCategory:properties.timingCategory,timingVar:properties.timingVar,timingValue:properties.timingValue,timingLabel:properties.timingLabel,optSampleRate:properties.optSampleRate,page:properties.page||window.location.hash.substring(1)||window.location.pathname}))}),$analyticsProvider.registerTransactionTrack(function(transaction){var product,i;if(dispatchToGa("ecommerce","require","ecommerce"),dispatchToGa("ecommerce","ecommerce:addTransaction",transaction),transaction.products)for(i=0;i<transaction.products.length;i++)product=transaction.products[i],product.sku=product.id,product.id=transaction.id,dispatchToGa("ecommerce","ecommerce:addItem",transaction.products[i]);transaction.currencyCode&&dispatchToGa("ecommerce","_set",transaction.currencyCode),dispatchToGa("ecommerce","ecommerce:send",angular.copy(transaction))});var dispatchToGa=function(){function dispatchToUniversal_(command,fieldsObj,shouldCopyHit){var uaCommand,pluginName,userId=$analyticsProvider.settings.ga.userId;if("require"===command&&"ecommerce"===fieldsObj)return pluginName=fieldsObj,$analyticsProvider.settings.ga.enhancedEcommerce&&(pluginName="ec"),applyUniversalCall_([command,pluginName],shouldCopyHit);if(userId&&angular.isObject(fieldsObj)&&(fieldsObj.userId=userId),$analyticsProvider.settings.ga.transport&&(fieldsObj.transport=$analyticsProvider.settings.ga.transport),command.indexOf("ecommerce:")>-1&&$analyticsProvider.settings.ga.enhancedEcommerce)switch(command){case"ecommerce:addTransaction":command=["ec:setAction","purchase"];break;case"ecommerce:addItem":command="ec:addProduct",fieldsObj.id=fieldsObj.sku;break;case"ecommerce:send":command="send",fieldsObj.hitType="event",fieldsObj.eventCategory="Angulartics Enhanced Ecommerce",fieldsObj.eventAction="Purchase",fieldsObj.nonInteraction=!0}uaCommand=command instanceof Array?command.concat(fieldsObj):[command,fieldsObj],applyUniversalCall_(uaCommand,shouldCopyHit)}function applyUniversalCall_(commandArray,shouldCopyHit){var commandClone,userId=$analyticsProvider.settings.ga.userId,gaNamespace=window.GoogleAnalyticsObject;window[gaNamespace].apply(this,commandArray),shouldCopyHit&&(commandClone=angular.copy(commandArray),userId&&!$analyticsProvider.settings.ga.additionalAccountHitTypes.userId&&commandClone[2]&&"object"==typeof commandClone[2]&&delete commandClone[2].userId,angular.forEach($analyticsProvider.settings.ga.additionalAccountNames,function(accountName){commandClone[0]=accountName+"."+commandClone[0],window[gaNamespace].apply(this,commandClone)}))}function dispatchToClassic_(command,fieldsObj,shouldCopyHit){if("set"===command)return console.log('Classic Analytics does not support the "set" command or Custom Dimensions. Command ignored.');var classicCommand;if("send"===command)switch(fieldsObj.hitType){case"pageview":classicCommand=["_trackPageview",fieldsObj.page];break;case"event":classicCommand=["_trackEvent",fieldsObj.category,fieldsObj.action,fieldsObj.label,fieldsObj.value,fieldsObj.nonInteraction];break;case"timing":classicCommand=["_trackTiming",fieldsObj.timingCategory,fieldsObj.timingVar,fieldsObj.timingValue,fieldsObj.timingLabel,fieldsObj.optSampleRate]}return"ecommerce:addTransaction"===command&&(classicCommand=["_addTrans",fieldsObj.id,fieldsObj.affiliation,fieldsObj.revenue,fieldsObj.tax,fieldsObj.shipping,fieldsObj.billingCity,fieldsObj.billingRegion,fieldsObj.billingCountry]),"ecommerce:addItem"===command&&(classicCommand=["_addItem",fieldsObj.id,fieldsObj.sku,fieldsObj.name,fieldsObj.category,fieldsObj.price,fieldsObj.quantity]),"_set"===command&&(classicCommand=["_set","currencyCode",fieldsObj]),"ecommerce:send"===command&&(classicCommand=["_trackTrans"]),classicCommand?(window._gaq.push(classicCommand),void(shouldCopyHit&&angular.forEach($analyticsProvider.settings.ga.additionalAccountNames,function(accountName){var classicCommandClone=[].slice.call(classicCommand);classicCommandClone[0]=accountName+"."+classicCommandClone[0],window._gaq.push(classicCommandClone)}))):console.log("Unable to find command "+command+" or fieldsObj missing required properties. Command ignored.")}var handler;return detectClassicAnalytics()&&(handler=dispatchToClassic_),detectUniversalAnalytics()&&(handler=dispatchToUniversal_),handler?function(method,command,fieldsObj){var shouldCopyHit=$analyticsProvider.settings.ga.additionalAccountHitTypes[method];handler(command,fieldsObj,shouldCopyHit)}:angular.noop}()}])}(window,window.angular);
	//# sourceMappingURL=../dist/angulartics-ga.min.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	function g(a){throw a;}var i=void 0,j=!0,m=null,n=!1;function p(){return function(){}}function r(a){return function(){return this[a]}}function aa(a){return function(){return a}}var s,t=this;function ba(a,b){var c=a.split("."),d=t;!(c[0]in d)&&d.execScript&&d.execScript("var "+c[0]);for(var f;c.length&&(f=c.shift());)!c.length&&ca(b)?d[f]=b:d=d[f]?d[f]:d[f]={}}function da(){}function ea(a){a.pb=function(){return a.Bd?a.Bd:a.Bd=new a}}
	function fa(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ca(a){return a!==i}function ga(a){return"array"==fa(a)}function ha(a){var b=fa(a);return"array"==b||"object"==b&&"number"==typeof a.length}function u(a){return"string"==typeof a}function v(a){return"function"==fa(a)}function ia(a){var b=typeof a;return"object"==b&&a!=m||"function"==b}function ja(a){return a[ka]||(a[ka]=++la)}var ka="closure_uid_"+Math.floor(2147483648*Math.random()).toString(36),la=0;
	function ma(a,b,c){return a.call.apply(a.bind,arguments)}function na(a,b,c){a||g(Error());if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function oa(a,b,c){oa=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ma:na;return oa.apply(m,arguments)}
	function pa(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=Array.prototype.slice.call(arguments);b.unshift.apply(b,c);return a.apply(this,b)}}var qa=Date.now||function(){return+new Date};function z(a,b){function c(){}c.prototype=b.prototype;a.K=b.prototype;a.prototype=new c;a.prototype.constructor=a};function ra(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")}function sa(a){if(!ta.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(ua,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(va,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(wa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(xa,"&quot;"));return a}var ua=/&/g,va=/</g,wa=/>/g,xa=/\"/g,ta=/[&<>\"]/;function ya(a){return String(a).replace(/\-([a-z])/g,function(a,c){return c.toUpperCase()})};var B=Array.prototype,za=B.indexOf?function(a,b,c){return B.indexOf.call(a,b,c)}:function(a,b,c){c=c==m?0:0>c?Math.max(0,a.length+c):c;if(u(a))return!u(b)||1!=b.length?-1:a.indexOf(b,c);for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},C=B.forEach?function(a,b,c){B.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,f=u(a)?a.split(""):a,e=0;e<d;e++)e in f&&b.call(c,f[e],e,a)},Aa=B.filter?function(a,b,c){return B.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,f=[],e=0,h=u(a)?a.split(""):
	a,k=0;k<d;k++)if(k in h){var l=h[k];b.call(c,l,k,a)&&(f[e++]=l)}return f},Ba=B.map?function(a,b,c){return B.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,f=Array(d),e=u(a)?a.split(""):a,h=0;h<d;h++)h in e&&(f[h]=b.call(c,e[h],h,a));return f},Ca=B.every?function(a,b,c){return B.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,f=u(a)?a.split(""):a,e=0;e<d;e++)if(e in f&&!b.call(c,f[e],e,a))return n;return j};
	function Da(a,b){var c;a:{c=a.length;for(var d=u(a)?a.split(""):a,f=0;f<c;f++)if(f in d&&b.call(i,d[f],f,a)){c=f;break a}c=-1}return 0>c?m:u(a)?a.charAt(c):a[c]}function Ea(a,b){return 0<=za(a,b)}function D(a,b){var c=za(a,b);0<=c&&B.splice.call(a,c,1)}function Fa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}
	function Ga(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c],f;if(ga(d)||(f=ha(d))&&d.hasOwnProperty("callee"))a.push.apply(a,d);else if(f)for(var e=a.length,h=d.length,k=0;k<h;k++)a[e+k]=d[k];else a.push(d)}}function Ha(a,b,c){return 2>=arguments.length?B.slice.call(a,b):B.slice.call(a,b,c)}function Ia(a,b){return a>b?1:a<b?-1:0};var Ja,Ka,La,Ma,Na;function Oa(){return t.navigator?t.navigator.userAgent:m}function Pa(){return t.navigator}Ma=La=Ka=Ja=n;var Qa;if(Qa=Oa()){var Ra=Pa();Ja=0==Qa.indexOf("Opera");Ka=!Ja&&-1!=Qa.indexOf("MSIE");La=!Ja&&-1!=Qa.indexOf("WebKit");Ma=!Ja&&!La&&"Gecko"==Ra.product}var Sa=Ja,E=Ka,F=Ma,G=La,Ta=Pa();Na=-1!=(Ta&&Ta.platform||"").indexOf("Mac");var Ua=!!Pa()&&-1!=(Pa().appVersion||"").indexOf("X11"),Va;
	a:{var Wa="",Xa;if(Sa&&t.opera)var Ya=t.opera.version,Wa="function"==typeof Ya?Ya():Ya;else if(F?Xa=/rv\:([^\);]+)(\)|;)/:E?Xa=/MSIE\s+([^\);]+)(\)|;)/:G&&(Xa=/WebKit\/(\S+)/),Xa)var Za=Xa.exec(Oa()),Wa=Za?Za[1]:"";if(E){var $a,ab=t.document;$a=ab?ab.documentMode:i;if($a>parseFloat(Wa)){Va=String($a);break a}}Va=Wa}var bb={};
	function I(a){var b;if(!(b=bb[a])){b=0;for(var c=ra(String(Va)).split("."),d=ra(String(a)).split("."),f=Math.max(c.length,d.length),e=0;0==b&&e<f;e++){var h=c[e]||"",k=d[e]||"",l=RegExp("(\\d*)(\\D*)","g"),q=RegExp("(\\d*)(\\D*)","g");do{var w=l.exec(h)||["","",""],y=q.exec(k)||["","",""];if(0==w[0].length&&0==y[0].length)break;b=((0==w[1].length?0:parseInt(w[1],10))<(0==y[1].length?0:parseInt(y[1],10))?-1:(0==w[1].length?0:parseInt(w[1],10))>(0==y[1].length?0:parseInt(y[1],10))?1:0)||((0==w[2].length)<
	(0==y[2].length)?-1:(0==w[2].length)>(0==y[2].length)?1:0)||(w[2]<y[2]?-1:w[2]>y[2]?1:0)}while(0==b)}b=bb[a]=0<=b}return b}var cb={};function db(a){return cb[a]||(cb[a]=E&&!!document.documentMode&&document.documentMode>=a)};var eb,fb=!E||db(9);!F&&!E||E&&db(9)||F&&I("1.9.1");E&&I("9");var gb=E||Sa||G;function hb(a){a=a.className;return u(a)&&a.match(/\S+/g)||[]}function ib(a,b){var c=hb(a),d=Ha(arguments,1),f=c.length+d.length;jb(c,d);a.className=c.join(" ");return c.length==f}function kb(a,b){var c=hb(a),d=Ha(arguments,1),f=lb(c,d);a.className=f.join(" ");return f.length==c.length-d.length}function jb(a,b){for(var c=0;c<b.length;c++)Ea(a,b[c])||a.push(b[c])}function lb(a,b){return Aa(a,function(a){return!Ea(b,a)})}
	function mb(a,b,c){var d=hb(a);u(b)?D(d,b):ga(b)&&(d=lb(d,b));u(c)&&!Ea(d,c)?d.push(c):ga(c)&&jb(d,c);a.className=d.join(" ")};function J(a,b){this.x=ca(a)?a:0;this.y=ca(b)?b:0};function nb(a,b){this.width=a;this.height=b}nb.prototype.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this};nb.prototype.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this};function ob(a,b){for(var c in a)b.call(i,a[c],c,a)}var pb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function qb(a,b){for(var c,d,f=1;f<arguments.length;f++){d=arguments[f];for(c in d)a[c]=d[c];for(var e=0;e<pb.length;e++)c=pb[e],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function rb(a){return a?new sb(K(a)):eb||(eb=new sb)}function tb(){var a,b,c,d;a=document;if(a.querySelectorAll&&a.querySelector)return a.querySelectorAll(".openseadragon-container");if(a.getElementsByClassName){var f=a.getElementsByClassName("openseadragon-container");return f}f=a.getElementsByTagName("*");d={};for(b=c=0;a=f[b];b++){var e=a.className;"function"==typeof e.split&&Ea(e.split(/\s+/),"openseadragon-container")&&(d[c++]=a)}d.length=c;return d}
	function ub(a,b){ob(b,function(b,d){"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:d in vb?a.setAttribute(vb[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}var vb={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function wb(a,b,c){var d=arguments,f=document,e=d[0],h=d[1];if(!fb&&h&&(h.name||h.type)){e=["<",e];h.name&&e.push(' name="',sa(h.name),'"');if(h.type){e.push(' type="',sa(h.type),'"');var k={};qb(k,h);delete k.type;h=k}e.push(">");e=e.join("")}e=f.createElement(e);h&&(u(h)?e.className=h:ga(h)?ib.apply(m,[e].concat(h)):ub(e,h));2<d.length&&xb(f,e,d,2);return e}
	function xb(a,b,c,d){function f(c){c&&b.appendChild(u(c)?a.createTextNode(c):c)}for(;d<c.length;d++){var e=c[d];if(ha(e)&&!(ia(e)&&0<e.nodeType)){var h;a:{if(e&&"number"==typeof e.length){if(ia(e)){h="function"==typeof e.item||"string"==typeof e.item;break a}if(v(e)){h="function"==typeof e.item;break a}}h=n}C(h?Fa(e):e,f)}else f(e)}}function yb(a){for(var b;b=a.firstChild;)a.removeChild(b)}function zb(a){a&&a.parentNode&&a.parentNode.removeChild(a)}function Ab(a){return ia(a)&&1==a.nodeType}
	function Bb(a,b){if(a.contains&&1==b.nodeType)return a==b||a.contains(b);if("undefined"!=typeof a.compareDocumentPosition)return a==b||Boolean(a.compareDocumentPosition(b)&16);for(;b&&a!=b;)b=b.parentNode;return b==a}function K(a){return 9==a.nodeType?a:a.ownerDocument||a.document}function Cb(a){var b=a.getAttributeNode("tabindex");return b&&b.specified?(a=a.tabIndex,"number"==typeof a&&0<=a&&32768>a):n}function sb(a){this.M=a||t.document||document}s=sb.prototype;s.pd=rb;
	s.d=function(a){return u(a)?this.M.getElementById(a):a};s.ga=ub;s.createElement=function(a){return this.M.createElement(a)};s.createTextNode=function(a){return this.M.createTextNode(a)};function Db(a){var b=a.M,a=!G?b.documentElement:b.body,b=b.parentWindow||b.defaultView;return new J(b.pageXOffset||a.scrollLeft,b.pageYOffset||a.scrollTop)}s.appendChild=function(a,b){a.appendChild(b)};s.append=function(a,b){xb(K(a),a,arguments,1)};s.contains=Bb;var Eb;Eb=aa(j);/*
	 Portions of this code are from the Dojo Toolkit, received by
	 The Closure Library Authors under the BSD license. All other code is
	 Copyright 2005-2009 The Closure Library Authors. All Rights Reserved.

	The "New" BSD License:

	Copyright (c) 2005-2009, The Dojo Foundation
	All rights reserved.

	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are met:

	 Redistributions of source code must retain the above copyright notice, this
	    list of conditions and the following disclaimer.
	 Redistributions in binary form must reproduce the above copyright notice,
	    this list of conditions and the following disclaimer in the documentation
	    and/or other materials provided with the distribution.
	 Neither the name of the Dojo Foundation nor the names of its contributors
	    may be used to endorse or promote products derived from this software
	    without specific prior written permission.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
	ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE
	FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
	DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
	SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
	CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	function Fb(a,b){var c=b||[];a&&c.push(a);return c}var Gb=G&&"BackCompat"==document.compatMode,Hb=document.firstChild.children?"children":"childNodes",Ib=n;
	function Jb(a){function b(){0<=q&&(x.id=c(q,A).replace(/\\/g,""),q=-1);if(0<=w){var a=w==A?m:c(w,A);0>">~+".indexOf(a)?x.H=a:x.Qb=a;w=-1}0<=l&&(x.ca.push(c(l+1,A).replace(/\\/g,"")),l=-1)}function c(b,c){return ra(a.slice(b,c))}for(var a=0<=">~+".indexOf(a.slice(-1))?a+" * ":a+" ",d=[],f=-1,e=-1,h=-1,k=-1,l=-1,q=-1,w=-1,y="",H="",S,A=0,Me=a.length,x=m,M=m;y=H,H=a.charAt(A),A<Me;A++)if("\\"!=y)if(x||(S=A,x={Ua:m,Ba:[],Ab:[],ca:[],H:m,Qb:m,id:m,rc:function(){return Ib?this.he:this.H}},w=A),0<=f)if("]"==
	H){M.nc?M.yc=c(h||f+1,A):M.nc=c(f+1,A);if((f=M.yc)&&('"'==f.charAt(0)||"'"==f.charAt(0)))M.yc=f.slice(1,-1);x.Ab.push(M);M=m;f=h=-1}else"="==H&&(h=0<="|~^$*".indexOf(y)?y:"",M.type=h+H,M.nc=c(f+1,A-h.length),h=A+1);else 0<=e?")"==H&&(0<=k&&(M.value=c(e+1,A)),k=e=-1):"#"==H?(b(),q=A+1):"."==H?(b(),l=A):":"==H?(b(),k=A):"["==H?(b(),f=A,M={}):"("==H?(0<=k&&(M={name:c(k+1,A),value:m},x.Ba.push(M)),e=A):" "==H&&y!=H&&(b(),0<=k&&x.Ba.push({name:c(k+1,A)}),x.Ed=x.Ba.length||x.Ab.length||x.ca.length,x.ye=
	x.Ua=c(S,A),x.he=x.H=x.Qb?m:x.H||"*",x.H&&(x.H=x.H.toUpperCase()),d.length&&d[d.length-1].Qb&&(x.Ad=d.pop(),x.Ua=x.Ad.Ua+" "+x.Ua),d.push(x),x=m);return d}function Kb(a,b){return!a?b:!b?a:function(){return a.apply(window,arguments)&&b.apply(window,arguments)}}function Lb(a){return 1==a.nodeType}function Mb(a,b){return!a?"":"class"==b?a.className||"":"for"==b?a.htmlFor||"":"style"==b?a.style.cssText||"":(Ib?a.getAttribute(b):a.getAttribute(b,2))||""}
	var Nb={"*=":function(a,b){return function(c){return 0<=Mb(c,a).indexOf(b)}},"^=":function(a,b){return function(c){return 0==Mb(c,a).indexOf(b)}},"$=":function(a,b){return function(c){c=" "+Mb(c,a);return c.lastIndexOf(b)==c.length-b.length}},"~=":function(a,b){var c=" "+b+" ";return function(b){return 0<=(" "+Mb(b,a)+" ").indexOf(c)}},"|=":function(a,b){b=" "+b;return function(c){c=" "+Mb(c,a);return c==b||0==c.indexOf(b+"-")}},"=":function(a,b){return function(c){return Mb(c,a)==b}}},Ob="undefined"==
	typeof document.firstChild.nextElementSibling,Pb=!Ob?"nextElementSibling":"nextSibling",Qb=!Ob?"previousElementSibling":"previousSibling",Rb=Ob?Lb:Eb;function Sb(a){for(;a=a[Qb];)if(Rb(a))return n;return j}function Tb(a){for(;a=a[Pb];)if(Rb(a))return n;return j}function Ub(a){var b=a.parentNode,c=0,d=b[Hb],f=a._i||-1,e=b._l||-1;if(!d)return-1;d=d.length;if(e==d&&0<=f&&0<=e)return f;b._l=d;f=-1;for(b=b.firstElementChild||b.firstChild;b;b=b[Pb])Rb(b)&&(b._i=++c,a===b&&(f=c));return f}
	function Vb(a){return!(Ub(a)%2)}function Wb(a){return Ub(a)%2}
	var Yb={checked:function(){return function(a){return a.checked||a.attributes.checked}},"first-child":function(){return Sb},"last-child":function(){return Tb},"only-child":function(){return function(a){return!Sb(a)||!Tb(a)?n:j}},empty:function(){return function(a){for(var b=a.childNodes,a=a.childNodes.length-1;0<=a;a--){var c=b[a].nodeType;if(1===c||3==c)return n}return j}},contains:function(a,b){var c=b.charAt(0);if('"'==c||"'"==c)b=b.slice(1,-1);return function(a){return 0<=a.innerHTML.indexOf(b)}},
	not:function(a,b){var c=Jb(b)[0],d={D:1};"*"!=c.H&&(d.H=1);c.ca.length||(d.ca=1);var f=Xb(c,d);return function(a){return!f(a)}},"nth-child":function(a,b){if("odd"==b)return Wb;if("even"==b)return Vb;if(-1!=b.indexOf("n")){var c=b.split("n",2),d=c[0]?"-"==c[0]?-1:parseInt(c[0],10):1,f=c[1]?parseInt(c[1],10):0,e=0,h=-1;0<d?0>f?f=f%d&&d+f%d:0<f&&(f>=d&&(e=f-f%d),f%=d):0>d&&(d*=-1,0<f&&(h=f,f%=d));if(0<d)return function(a){a=Ub(a);return a>=e&&(0>h||a<=h)&&a%d==f};b=f}var k=parseInt(b,10);return function(a){return Ub(a)==
	k}}},Zb=E?function(a){var b=a.toLowerCase();"class"==b&&(a="className");return function(c){return Ib?c.getAttribute(a):c[a]||c[b]}}:function(a){return function(b){return b&&b.getAttribute&&b.hasAttribute(a)}};
	function Xb(a,b){if(!a)return Eb;var b=b||{},c=m;b.D||(c=Kb(c,Lb));b.H||"*"!=a.H&&(c=Kb(c,function(b){return b&&b.tagName==a.rc()}));b.ca||C(a.ca,function(a,b){var e=RegExp("(?:^|\\s)"+a+"(?:\\s|$)");c=Kb(c,function(a){return e.test(a.className)});c.count=b});b.Ba||C(a.Ba,function(a){var b=a.name;Yb[b]&&(c=Kb(c,Yb[b](b,a.value)))});b.Ab||C(a.Ab,function(a){var b,e=a.nc;a.type&&Nb[a.type]?b=Nb[a.type](e,a.yc):e.length&&(b=Zb(e));b&&(c=Kb(c,b))});b.id||a.id&&(c=Kb(c,function(b){return!!b&&b.id==a.id}));
	c||"default"in b||(c=Eb);return c}var $b={};
	function ac(a){var b=$b[a.Ua];if(b)return b;var c=a.Ad,c=c?c.Qb:"",d=Xb(a,{D:1}),f="*"==a.H,e=document.getElementsByClassName;if(c)if(e={D:1},f&&(e.H=1),d=Xb(a,e),"+"==c)var h=d,b=function(a,b,c){for(;a=a[Pb];)if(!Ob||Lb(a)){(!c||bc(a,c))&&h(a)&&b.push(a);break}return b};else if("~"==c)var k=d,b=function(a,b,c){for(a=a[Pb];a;){if(Rb(a)){if(c&&!bc(a,c))break;k(a)&&b.push(a)}a=a[Pb]}return b};else{if(">"==c)var l=d,l=l||Eb,b=function(a,b,c){for(var d=0,f=a[Hb];a=f[d++];)Rb(a)&&((!c||bc(a,c))&&l(a,d))&&
	b.push(a);return b}}else if(a.id)d=!a.Ed&&f?Eb:Xb(a,{D:1,id:1}),b=function(b,c){var f=rb(b).d(a.id),e;if(e=f&&d(f))if(!(e=9==b.nodeType)){for(e=f.parentNode;e&&e!=b;)e=e.parentNode;e=!!e}if(e)return Fb(f,c)};else if(e&&/\{\s*\[native code\]\s*\}/.test(String(e))&&a.ca.length&&!Gb)var d=Xb(a,{D:1,ca:1,id:1}),q=a.ca.join(" "),b=function(a,b){for(var c=Fb(0,b),f,e=0,h=a.getElementsByClassName(q);f=h[e++];)d(f,a)&&c.push(f);return c};else!f&&!a.Ed?b=function(b,c){for(var d=Fb(0,c),f,e=0,h=b.getElementsByTagName(a.rc());f=
	h[e++];)d.push(f);return d}:(d=Xb(a,{D:1,H:1,id:1}),b=function(b,c){for(var f=Fb(0,c),e,h=0,k=b.getElementsByTagName(a.rc());e=k[h++];)d(e,b)&&f.push(e);return f});return $b[a.Ua]=b}var cc={},dc={};function ec(a){var b=Jb(ra(a));if(1==b.length){var c=ac(b[0]);return function(a){if(a=c(a,[]))a.Pb=j;return a}}return function(a){for(var a=Fb(a),c,e,h=b.length,k,l,q=0;q<h;q++){l=[];c=b[q];e=a.length-1;0<e&&(k={},l.Pb=j);e=ac(c);for(var w=0;c=a[w];w++)e(c,l,k);if(!l.length)break;a=l}return l}}
	var fc=!!document.querySelectorAll&&(!G||I("526"));
	function gc(a,b){if(fc){var c=dc[a];if(c&&!b)return c}if(c=cc[a])return c;var c=a.charAt(0),d=-1==a.indexOf(" ");0<=a.indexOf("#")&&d&&(b=j);if(fc&&!b&&-1==">~+".indexOf(c)&&(!E||-1==a.indexOf(":"))&&!(Gb&&0<=a.indexOf("."))&&-1==a.indexOf(":contains")&&-1==a.indexOf("|=")){var f=0<=">~+".indexOf(a.charAt(a.length-1))?a+" *":a;return dc[a]=function(b){try{9==b.nodeType||d||g("");var c=b.querySelectorAll(f);E?c.Td=j:c.Pb=j;return c}catch(e){return gc(a,j)(b)}}}var e=a.split(/\s*,\s*/);return cc[a]=
	2>e.length?ec(a):function(a){for(var b=0,c=[],d;d=e[b++];)c=c.concat(ec(d)(a));return c}}var hc=0,ic=E?function(a){return Ib?a.getAttribute("_uid")||a.setAttribute("_uid",++hc)||hc:a.uniqueID}:function(a){return a._uid||(a._uid=++hc)};function bc(a,b){if(!b)return 1;var c=ic(a);return!b[c]?b[c]=1:0}
	function jc(a){if(a&&a.Pb)return a;var b=[];if(!a||!a.length)return b;a[0]&&b.push(a[0]);if(2>a.length)return b;hc++;if(E&&Ib){var c=hc+"";a[0].setAttribute("_zipIdx",c);for(var d=1,f;f=a[d];d++)a[d].getAttribute("_zipIdx")!=c&&b.push(f),f.setAttribute("_zipIdx",c)}else if(E&&a.Td)try{for(d=1;f=a[d];d++)Lb(f)&&b.push(f)}catch(e){}else{a[0]&&(a[0]._zipIdx=hc);for(d=1;f=a[d];d++)a[d]._zipIdx!=hc&&b.push(f),f._zipIdx=hc}return b}
	function L(a,b){if(!a)return[];if(a.constructor==Array)return a;if(!u(a))return[a];if(u(b)&&(b=u(b)?document.getElementById(b):b,!b))return[];var b=b||document,c=b.ownerDocument||b.documentElement;Ib=b.contentType&&"application/xml"==b.contentType||Sa&&(b.doctype||"[object XMLDocument]"==c.toString())||!!c&&(E?c.xml:b.xmlVersion||c.xmlVersion);return(c=gc(a)(b))&&c.Pb?c:jc(c)}L.Ba=Yb;ba("goog.dom.query",L);ba("goog.dom.query.pseudos",L.Ba);var kc=!E||db(9),lc=!E||db(9),mc=E&&!I("9");!G||I("528");F&&I("1.9b")||E&&I("8")||Sa&&I("9.5")||G&&I("528");F&&!I("8")||E&&I("9");function nc(){0!=oc&&(this.se=Error().stack,ja(this))}var oc=0;nc.prototype.ld=n;function pc(a,b){this.type=a;this.currentTarget=this.target=b}s=pc.prototype;s.Aa=n;s.defaultPrevented=n;s.Ub=j;s.stopPropagation=function(){this.Aa=j};s.preventDefault=function(){this.defaultPrevented=j;this.Ub=n};function qc(a){a.preventDefault()};function rc(a){rc[" "](a);return a}rc[" "]=da;function sc(a,b){a&&this.init(a,b)}z(sc,pc);var tc=[1,4,2];s=sc.prototype;s.target=m;s.relatedTarget=m;s.offsetX=0;s.offsetY=0;s.clientX=0;s.clientY=0;s.screenX=0;s.screenY=0;s.button=0;s.keyCode=0;s.charCode=0;s.ctrlKey=n;s.altKey=n;s.shiftKey=n;s.metaKey=n;s.Cc=n;s.n=m;
	s.init=function(a,b){var c=this.type=a.type;pc.call(this,c);this.target=a.target||a.srcElement;this.currentTarget=b;var d=a.relatedTarget;if(d){if(F){var f;a:{try{rc(d.nodeName);f=j;break a}catch(e){}f=n}f||(d=m)}}else"mouseover"==c?d=a.fromElement:"mouseout"==c&&(d=a.toElement);this.relatedTarget=d;this.offsetX=G||a.offsetX!==i?a.offsetX:a.layerX;this.offsetY=G||a.offsetY!==i?a.offsetY:a.layerY;this.clientX=a.clientX!==i?a.clientX:a.pageX;this.clientY=a.clientY!==i?a.clientY:a.pageY;this.screenX=
	a.screenX||0;this.screenY=a.screenY||0;this.button=a.button;this.keyCode=a.keyCode||0;this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.Cc=Na?a.metaKey:a.ctrlKey;this.state=a.state;this.n=a;a.defaultPrevented&&this.preventDefault();delete this.Aa};function uc(a){return(kc?0==a.n.button:"click"==a.type?j:!!(a.n.button&tc[0]))&&!(G&&Na&&a.ctrlKey)}
	s.stopPropagation=function(){sc.K.stopPropagation.call(this);this.n.stopPropagation?this.n.stopPropagation():this.n.cancelBubble=j};s.preventDefault=function(){sc.K.preventDefault.call(this);var a=this.n;if(a.preventDefault)a.preventDefault();else if(a.returnValue=n,mc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};s.Ud=r("n");function vc(){}var wc=0;s=vc.prototype;s.key=0;s.Ca=n;s.fd=n;s.init=function(a,b,c,d,f,e){v(a)?this.Dd=j:a&&a.handleEvent&&v(a.handleEvent)?this.Dd=n:g(Error("Invalid listener argument"));this.Ta=a;this.Hd=b;this.src=c;this.type=d;this.capture=!!f;this.Pa=e;this.fd=n;this.key=++wc;this.Ca=n};s.handleEvent=function(a){return this.Dd?this.Ta.call(this.Pa||this.src,a):this.Ta.handleEvent.call(this.Ta,a)};var xc={},N={},yc={},zc={};
	function O(a,b,c,d,f){if(b){if(ga(b)){for(var e=0;e<b.length;e++)O(a,b[e],c,d,f);return m}var d=!!d,h=N;b in h||(h[b]={m:0,O:0});h=h[b];d in h||(h[d]={m:0,O:0},h.m++);var h=h[d],k=ja(a),l;h.O++;if(h[k]){l=h[k];for(e=0;e<l.length;e++)if(h=l[e],h.Ta==c&&h.Pa==f){if(h.Ca)break;return l[e].key}}else l=h[k]=[],h.m++;var q=Ac,w=lc?function(a){return q.call(w.src,w.key,a)}:function(a){a=q.call(w.src,w.key,a);if(!a)return a},e=w;e.src=a;h=new vc;h.init(c,e,a,b,d,f);c=h.key;e.key=c;l.push(h);xc[c]=h;yc[k]||
	(yc[k]=[]);yc[k].push(h);a.addEventListener?(a==t||!a.hd)&&a.addEventListener(b,e,d):a.attachEvent(b in zc?zc[b]:zc[b]="on"+b,e);return c}g(Error("Invalid event type"))}function Bc(a,b,c,d,f){if(ga(b))for(var e=0;e<b.length;e++)Bc(a,b[e],c,d,f);else if(d=!!d,a=Cc(a,b,d))for(e=0;e<a.length;e++)if(a[e].Ta==c&&a[e].capture==d&&a[e].Pa==f){P(a[e].key);break}}
	function P(a){if(!xc[a])return n;var b=xc[a];if(b.Ca)return n;var c=b.src,d=b.type,f=b.Hd,e=b.capture;c.removeEventListener?(c==t||!c.hd)&&c.removeEventListener(d,f,e):c.detachEvent&&c.detachEvent(d in zc?zc[d]:zc[d]="on"+d,f);c=ja(c);yc[c]&&(f=yc[c],D(f,b),0==f.length&&delete yc[c]);b.Ca=j;if(b=N[d][e][c])b.Gd=j,Dc(d,e,c,b);delete xc[a];return j}
	function Dc(a,b,c,d){if(!d.Kb&&d.Gd){for(var f=0,e=0;f<d.length;f++)d[f].Ca?d[f].Hd.src=m:(f!=e&&(d[e]=d[f]),e++);d.length=e;d.Gd=n;0==e&&(delete N[a][b][c],N[a][b].m--,0==N[a][b].m&&(delete N[a][b],N[a].m--),0==N[a].m&&delete N[a])}}function Cc(a,b,c){var d=N;return b in d&&(d=d[b],c in d&&(d=d[c],a=ja(a),d[a]))?d[a]:m}
	function Ec(a,b,c,d,f){var e=1,b=ja(b);if(a[b]){a.O--;a=a[b];a.Kb?a.Kb++:a.Kb=1;try{for(var h=a.length,k=0;k<h;k++){var l=a[k];l&&!l.Ca&&(e&=Fc(l,f)!==n)}}finally{a.Kb--,Dc(c,d,b,a)}}return Boolean(e)}function Fc(a,b){a.fd&&P(a.key);return a.handleEvent(b)}
	function Ac(a,b){if(!xc[a])return j;var c=xc[a],d=c.type,f=N;if(!(d in f))return j;var f=f[d],e,h;if(!lc){var k;if(!(k=b))a:{k=["window","event"];for(var l=t;e=k.shift();)if(l[e]!=m)l=l[e];else{k=m;break a}k=l}e=k;k=j in f;l=n in f;if(k){if(0>e.keyCode||e.returnValue!=i)return j;a:{var q=n;if(0==e.keyCode)try{e.keyCode=-1;break a}catch(w){q=j}if(q||e.returnValue==i)e.returnValue=j}}q=new sc;q.init(e,this);e=j;try{if(k){for(var y=[],H=q.currentTarget;H;H=H.parentNode)y.push(H);h=f[j];h.O=h.m;for(var S=
	y.length-1;!q.Aa&&0<=S&&h.O;S--)q.currentTarget=y[S],e&=Ec(h,y[S],d,j,q);if(l){h=f[n];h.O=h.m;for(S=0;!q.Aa&&S<y.length&&h.O;S++)q.currentTarget=y[S],e&=Ec(h,y[S],d,n,q)}}else e=Fc(c,q)}finally{y&&(y.length=0)}return e}d=new sc(b,this);return e=Fc(c,d)};function Gc(a){nc.call(this);this.xd=a;this.j=[]}z(Gc,nc);var Hc=[];function Q(a,b,c,d,f){ga(c)||(Hc[0]=c,c=Hc);for(var e=0;e<c.length;e++){var h=O(b,c[e],d||a,f||n,a.xd||a);a.j.push(h)}return a}function Ic(a,b,c,d,f,e){if(ga(c))for(var h=0;h<c.length;h++)Ic(a,b,c[h],d,f,e);else{a:{d=d||a;e=e||a.xd||a;f=!!f;if(b=Cc(b,c,f))for(c=0;c<b.length;c++)if(!b[c].Ca&&b[c].Ta==d&&b[c].capture==f&&b[c].Pa==e){b=b[c];break a}b=m}b&&(b=b.key,P(b),D(a.j,b))}return a}
	Gc.prototype.Sb=function(){C(this.j,P);this.j.length=0};Gc.prototype.handleEvent=function(){g(Error("EventHandler.handleEvent not implemented"))};function Jc(){nc.call(this)}z(Jc,nc);s=Jc.prototype;s.hd=j;s.Bc=m;s.Gc=function(a){this.Bc=a};s.addEventListener=function(a,b,c,d){O(this,a,b,c,d)};s.removeEventListener=function(a,b,c,d){Bc(this,a,b,c,d)};
	s.dispatchEvent=function(a){var b=a.type||a,c=N;if(b in c){if(u(a))a=new pc(a,this);else if(a instanceof pc)a.target=a.target||this;else{var d=a,a=new pc(b,this);qb(a,d)}var d=1,f,c=c[b],b=j in c,e;if(b){f=[];for(e=this;e;e=e.Bc)f.push(e);e=c[j];e.O=e.m;for(var h=f.length-1;!a.Aa&&0<=h&&e.O;h--)a.currentTarget=f[h],d&=Ec(e,f[h],a.type,j,a)&&a.Ub!=n}if(n in c)if(e=c[n],e.O=e.m,b)for(h=0;!a.Aa&&h<f.length&&e.O;h++)a.currentTarget=f[h],d&=Ec(e,f[h],a.type,n,a)&&a.Ub!=n;else for(f=this;!a.Aa&&f&&e.O;f=
	f.Bc)a.currentTarget=f,d&=Ec(e,f,a.type,n,a)&&a.Ub!=n;a=Boolean(d)}else a=j;return a};function Kc(a,b,c,d){this.top=a;this.right=b;this.bottom=c;this.left=d}Kc.prototype.contains=function(a){return!this||!a?n:a instanceof Kc?a.left>=this.left&&a.right<=this.right&&a.top>=this.top&&a.bottom<=this.bottom:a.x>=this.left&&a.x<=this.right&&a.y>=this.top&&a.y<=this.bottom};function Lc(a,b,c,d){this.left=a;this.top=b;this.width=c;this.height=d}Lc.prototype.contains=function(a){return a instanceof Lc?this.left<=a.left&&this.left+this.width>=a.left+a.width&&this.top<=a.top&&this.top+this.height>=a.top+a.height:a.x>=this.left&&a.x<=this.left+this.width&&a.y>=this.top&&a.y<=this.top+this.height};function R(a,b,c){u(b)?Mc(a,c,b):ob(b,pa(Mc,a))}function Mc(a,b,c){a.style[ya(c)]=b}function T(a,b){var c=K(a);return c.defaultView&&c.defaultView.getComputedStyle&&(c=c.defaultView.getComputedStyle(a,m))?c[b]||c.getPropertyValue(b)||"":""}function Nc(a,b){return a.currentStyle?a.currentStyle[b]:m}function Oc(a,b){return T(a,b)||Nc(a,b)||a.style&&a.style[b]}function Pc(a,b,c){var d,f=F&&(Na||Ua)&&I("1.9");b instanceof J?(d=b.x,b=b.y):(d=b,b=c);a.style.left=Qc(d,f);a.style.top=Qc(b,f)}
	function Rc(a){var b=a.getBoundingClientRect();E&&(a=a.ownerDocument,b.left-=a.documentElement.clientLeft+a.body.clientLeft,b.top-=a.documentElement.clientTop+a.body.clientTop);return b}
	function Sc(a){if(E&&!db(8))return a.offsetParent;for(var b=K(a),c=Oc(a,"position"),d="fixed"==c||"absolute"==c,a=a.parentNode;a&&a!=b;a=a.parentNode)if(c=Oc(a,"position"),d=d&&"static"==c&&a!=b.documentElement&&a!=b.body,!d&&(a.scrollWidth>a.clientWidth||a.scrollHeight>a.clientHeight||"fixed"==c||"absolute"==c||"relative"==c))return a;return m}
	function Tc(a){var b,c=K(a),d=Oc(a,"position"),f=F&&c.getBoxObjectFor&&!a.getBoundingClientRect&&"absolute"==d&&(b=c.getBoxObjectFor(a))&&(0>b.screenX||0>b.screenY),e=new J(0,0),h;b=c?K(c):document;if(h=E)if(h=!db(9))rb(b),h=n;h=h?b.body:b.documentElement;if(a==h)return e;if(a.getBoundingClientRect)b=Rc(a),a=Db(rb(c)),e.x=b.left+a.x,e.y=b.top+a.y;else if(c.getBoxObjectFor&&!f)b=c.getBoxObjectFor(a),a=c.getBoxObjectFor(h),e.x=b.screenX-a.screenX,e.y=b.screenY-a.screenY;else{f=a;do{e.x+=f.offsetLeft;
	e.y+=f.offsetTop;f!=a&&(e.x+=f.clientLeft||0,e.y+=f.clientTop||0);if(G&&"fixed"==Oc(f,"position")){e.x+=c.body.scrollLeft;e.y+=c.body.scrollTop;break}f=f.offsetParent}while(f&&f!=a);if(Sa||G&&"absolute"==d)e.y-=c.body.offsetTop;for(f=a;(f=Sc(f))&&f!=c.body&&f!=h;)if(e.x-=f.scrollLeft,!Sa||"TR"!=f.tagName)e.y-=f.scrollTop}return e}function Uc(a,b){var c=Vc(a),d=Vc(b);return new J(c.x-d.x,c.y-d.y)}
	function Vc(a){var b=new J;if(1==a.nodeType){if(a.getBoundingClientRect){var c=Rc(a);b.x=c.left;b.y=c.top}else{var c=Db(rb(a)),d=Tc(a);b.x=d.x-c.x;b.y=d.y-c.y}if(F&&!I(12)){var f;E?f="-ms-transform":G?f="-webkit-transform":Sa?f="-o-transform":F&&(f="-moz-transform");var e;f&&(e=Oc(a,f));e||(e=Oc(a,"transform"));e?(a=e.match(Wc),a=!a?new J(0,0):new J(parseFloat(a[1]),parseFloat(a[2]))):a=new J(0,0);b=new J(b.x+a.x,b.y+a.y)}}else f=v(a.Ud),e=a,a.targetTouches?e=a.targetTouches[0]:f&&a.n.targetTouches&&
	(e=a.n.targetTouches[0]),b.x=e.clientX,b.y=e.clientY;return b}function Xc(a,b,c){b instanceof nb?(c=b.height,b=b.width):c==i&&g(Error("missing height argument"));a.style.width=Qc(b,j);a.style.height=Qc(c,j)}function Qc(a,b){"number"==typeof a&&(a=(b?Math.round(a):a)+"px");return a}
	function Yc(a){if("none"!=Oc(a,"display"))return Zc(a);var b=a.style,c=b.display,d=b.visibility,f=b.position;b.visibility="hidden";b.position="absolute";b.display="inline";a=Zc(a);b.display=c;b.position=f;b.visibility=d;return a}function Zc(a){var b=a.offsetWidth,c=a.offsetHeight,d=G&&!b&&!c;return(!ca(b)||d)&&a.getBoundingClientRect?(a=Rc(a),new nb(a.right-a.left,a.bottom-a.top)):new nb(b,c)}function $c(a){var b=Tc(a),a=Yc(a);return new Lc(b.x,b.y,a.width,a.height)}
	function U(a,b){var c=a.style;"opacity"in c?c.opacity=b:"MozOpacity"in c?c.MozOpacity=b:"filter"in c&&(c.filter=""===b?"":"alpha(opacity="+100*b+")")}function V(a,b){a.style.display=b?"":"none"}function ad(a){return"rtl"==Oc(a,"direction")}var bd=F?"MozUserSelect":G?"WebkitUserSelect":m;
	function cd(a,b){if(/^\d+px?$/.test(b))return parseInt(b,10);var c=a.style.left,d=a.runtimeStyle.left;a.runtimeStyle.left=a.currentStyle.left;a.style.left=b;var f=a.style.pixelLeft;a.style.left=c;a.runtimeStyle.left=d;return f}
	function dd(a,b){if(E){var c=cd(a,Nc(a,b+"Left")),d=cd(a,Nc(a,b+"Right")),f=cd(a,Nc(a,b+"Top")),e=cd(a,Nc(a,b+"Bottom"));return new Kc(f,d,e,c)}c=T(a,b+"Left");d=T(a,b+"Right");f=T(a,b+"Top");e=T(a,b+"Bottom");return new Kc(parseFloat(f),parseFloat(d),parseFloat(e),parseFloat(c))}var ed={thin:2,medium:4,thick:6};function fd(a,b){if("none"==Nc(a,b+"Style"))return 0;var c=Nc(a,b+"Width");return c in ed?ed[c]:cd(a,c)}
	function gd(a){if(E){var b=fd(a,"borderLeft"),c=fd(a,"borderRight"),d=fd(a,"borderTop"),a=fd(a,"borderBottom");return new Kc(d,c,a,b)}b=T(a,"borderLeftWidth");c=T(a,"borderRightWidth");d=T(a,"borderTopWidth");a=T(a,"borderBottomWidth");return new Kc(parseFloat(d),parseFloat(c),parseFloat(a),parseFloat(b))}var Wc=/matrix\([0-9\.\-]+, [0-9\.\-]+, [0-9\.\-]+, [0-9\.\-]+, ([0-9\.\-]+)p?x?, ([0-9\.\-]+)p?x?\)/;function hd(a,b,c){nc.call(this);this.target=a;this.handle=b||a;this.wc=c||new Lc(NaN,NaN,NaN,NaN);this.M=K(a);this.ka=new Gc(this);O(this.handle,["touchstart","mousedown"],this.le,n,this)}z(hd,Jc);var id=E||F&&I("1.9.3");s=hd.prototype;s.clientX=0;s.clientY=0;s.screenX=0;s.screenY=0;s.Ld=0;s.Md=0;s.Ka=0;s.La=0;s.md=j;s.xa=n;s.zd=0;s.de=0;s.ae=n;s.Hc=n;s.Eb=r("ka");function jd(a){ca(a.ra)||(a.ra=ad(a.target));return a.ra}
	s.le=function(a){var b="mousedown"==a.type;if(this.md&&!this.xa&&(!b||uc(a))){kd(a);if(0==this.zd)if(this.dispatchEvent(new ld("start",this,a.clientX,a.clientY,a)))this.xa=j,a.preventDefault();else return;else a.preventDefault();var b=this.M,c=b.documentElement,d=!id;Q(this.ka,b,["touchmove","mousemove"],this.Zd,d);Q(this.ka,b,["touchend","mouseup"],this.Cb,d);id?(c.setCapture(n),Q(this.ka,c,"losecapture",this.Cb)):Q(this.ka,b?b.parentWindow||b.defaultView:window,"blur",this.Cb);E&&this.ae&&Q(this.ka,
	b,"dragstart",qc);this.je&&Q(this.ka,this.je,"scroll",this.ge,d);this.clientX=this.Ld=a.clientX;this.clientY=this.Md=a.clientY;this.screenX=a.screenX;this.screenY=a.screenY;this.Hc?(a=this.target,b=a.offsetLeft,c=a.offsetParent,!c&&"fixed"==Oc(a,"position")&&(c=K(a).documentElement),c?(F?(d=gd(c),b+=d.left):db(8)&&(d=gd(c),b-=d.left),a=ad(c)?c.clientWidth-(b+a.offsetWidth):b):a=b):a=this.target.offsetLeft;this.Ka=a;this.La=this.target.offsetTop;this.Ac=Db(rb(this.M));this.de=qa()}else this.dispatchEvent("earlycancel")};
	s.Cb=function(a,b){this.ka.Sb();id&&this.M.releaseCapture();if(this.xa){kd(a);this.xa=n;var c=md(this,this.Ka),d=nd(this,this.La);this.dispatchEvent(new ld("end",this,a.clientX,a.clientY,a,c,d,b||"touchcancel"==a.type))}else this.dispatchEvent("earlycancel");("touchend"==a.type||"touchcancel"==a.type)&&a.preventDefault()};
	function kd(a){var b=a.type;"touchstart"==b||"touchmove"==b?a.init(a.n.targetTouches[0],a.currentTarget):("touchend"==b||"touchcancel"==b)&&a.init(a.n.changedTouches[0],a.currentTarget)}
	s.Zd=function(a){if(this.md){kd(a);var b=(this.Hc&&jd(this)?-1:1)*(a.clientX-this.clientX),c=a.clientY-this.clientY;this.clientX=a.clientX;this.clientY=a.clientY;this.screenX=a.screenX;this.screenY=a.screenY;if(!this.xa){var d=this.Ld-this.clientX,f=this.Md-this.clientY;if(d*d+f*f>this.zd)if(this.dispatchEvent(new ld("start",this,a.clientX,a.clientY,a)))this.xa=j;else{this.ld||this.Cb(a);return}}c=od(this,b,c);b=c.x;c=c.y;this.xa&&this.dispatchEvent(new ld("beforedrag",this,a.clientX,a.clientY,a,
	b,c))&&(pd(this,a,b,c),a.preventDefault())}};function od(a,b,c){var d=Db(rb(a.M)),b=b+(d.x-a.Ac.x),c=c+(d.y-a.Ac.y);a.Ac=d;a.Ka+=b;a.La+=c;b=md(a,a.Ka);a=nd(a,a.La);return new J(b,a)}s.ge=function(a){var b=od(this,0,0);a.clientX=this.clientX;a.clientY=this.clientY;pd(this,a,b.x,b.y)};function pd(a,b,c,d){a.kd(c,d);a.dispatchEvent(new ld("drag",a,b.clientX,b.clientY,b,c,d))}
	function md(a,b){var c=a.wc,d=!isNaN(c.left)?c.left:m,c=!isNaN(c.width)?c.width:0;return Math.min(d!=m?d+c:Infinity,Math.max(d!=m?d:-Infinity,b))}function nd(a,b){var c=a.wc,d=!isNaN(c.top)?c.top:m,c=!isNaN(c.height)?c.height:0;return Math.min(d!=m?d+c:Infinity,Math.max(d!=m?d:-Infinity,b))}s.kd=function(a,b){this.Hc&&jd(this)?this.target.style.right=a+"px":this.target.style.left=a+"px";this.target.style.top=b+"px"};
	function ld(a,b,c,d,f,e,h,k){pc.call(this,a);this.clientX=c;this.clientY=d;this.qe=f;this.left=ca(e)?e:b.Ka;this.top=ca(h)?h:b.La;this.ue=b;this.te=!!k}z(ld,pc);function qd(a){for(var b=0,c=0;a&&!isNaN(a.offsetLeft)&&!isNaN(a.offsetTop);)b+=a.offsetLeft-a.scrollLeft,c+=a.offsetTop-a.scrollTop,a=a.offsetParent;return{top:c,left:b}};function rd(){this.Za=[]}rd.prototype.addHandler=function(a,b){this.Za[a]||(this.Za[a]=[]);this.Za[a].push(b)};rd.prototype.Tb=function(a,b){var c=this.Za[a];c&&D(c,b)};rd.prototype.fireEvent=function(a,b,c){var d=n;(a=this.Za[a])&&C(a,function(a){a=a(b,c);ca(a)&&!a&&(d=j)});return d};function sd(a,b){this.Y={};this.j=[];var c=arguments.length;if(1<c){c%2&&g(Error("Uneven number of arguments"));for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){var f;if(a instanceof sd)td(a),f=a.j.concat(),d=W(a);else{var c=[],e=0;for(f in a)c[e++]=f;f=c;c=[];e=0;for(d in a)c[e++]=a[d];d=c}for(c=0;c<f.length;c++)this.set(f[c],d[c])}}s=sd.prototype;s.m=0;s.Ic=0;function W(a){td(a);for(var b=[],c=0;c<a.j.length;c++)b.push(a.Y[a.j[c]]);return b}
	s.clear=function(){this.Y={};this.Ic=this.m=this.j.length=0};s.remove=function(a){return ud(this.Y,a)?(delete this.Y[a],this.m--,this.Ic++,this.j.length>2*this.m&&td(this),j):n};function td(a){if(a.m!=a.j.length){for(var b=0,c=0;b<a.j.length;){var d=a.j[b];ud(a.Y,d)&&(a.j[c++]=d);b++}a.j.length=c}if(a.m!=a.j.length){for(var f={},c=b=0;b<a.j.length;)d=a.j[b],ud(f,d)||(a.j[c++]=d,f[d]=1),b++;a.j.length=c}}s.get=function(a,b){return ud(this.Y,a)?this.Y[a]:b};
	s.set=function(a,b){ud(this.Y,a)||(this.m++,this.j.push(a),this.Ic++);this.Y[a]=b};function ud(a,b){return Object.prototype.hasOwnProperty.call(a,b)};function vd(a,b){this.x=a;this.y=b};function wd(a){this.points=a}function xd(a){for(var b=0,c=a.length-1,d=0;d<a.length;d++)b+=(a[c].x+a[d].x)*(a[c].y-a[d].y),c=d;return b/2}
	function yd(a,b){for(var c,d=c=0,f,e=a.length-1,h=0;h<a.length;h++)f=a[h].x*a[e].y-a[e].x*a[h].y,c+=(a[h].x+a[e].x)*f,d+=(a[h].y+a[e].y)*f,e=h;f=6*xd(a);c=new vd(Math.abs(c/f),Math.abs(d/f));d=[];for(f=0;f<a.length;f++){var e=a[f],k=(0>xd(a)?-1:1)*b,h=e.x-c.x,l=e.y-c.y,q=0<k?1:0>k?-1:0,k=Math.sqrt(Math.pow(k,2)/(1+Math.pow(h/l,2)));d.push({x:e.x+Math.abs(h/l*k)*(0<h?1:0>h?-1:0)*q,y:e.y+Math.abs(k)*(0<l?1:0>l?-1:0)*q})}return d};function zd(a,b,c,d){0<c?(this.x=a,this.width=c):(this.x=a+c,this.width=-c);0<d?(this.y=b,this.height=d):(this.y=b+d,this.height=-d)};function Ad(a,b,c,d){this.type=a;this.geometry=b;c&&(this.units=c);this.style=d?d:{}}function Bd(a){return"rect"==a.type?a.geometry.width*a.geometry.height:"polygon"==a.type?Math.abs(xd(a.geometry.points)):0}function Cd(a){if("rect"==a.type)return a;if("polygon"==a.type){for(var b=a.geometry.points,c=b[0].x,d=b[0].x,f=b[0].y,e=b[0].y,h=1;h<b.length;h++)b[h].x>d&&(d=b[h].x),b[h].x<c&&(c=b[h].x),b[h].y>e&&(e=b[h].y),b[h].y<f&&(f=b[h].y);return new Ad("rect",new zd(c,f,d-c,e-f),n,a.style)}}
	function Dd(a,b){var c;c=a.geometry.points;var d=0>xd(c)?-1:1;if(4>c.length)c=yd(c,d*b);else{for(var f=c.length-1,e=1,h=[],k=0;k<c.length;k++)f=yd([c[f],c[k],c[e]],d*b),h.push(f[1]),f=k,e++,e>c.length-1&&(e=0);c=h}return new Ad("polygon",new wd(c),n,a.style)}function Ed(a,b){if("rect"==a.type){var c=b(a.geometry);return new Ad("rect",c,n,a.style)}if("polygon"==a.type){var d=[];C(a.geometry.points,function(a){d.push(b(a))});return new Ad("polygon",new wd(d),n,a.style)}}
	function Fd(a){return JSON.stringify(a.geometry)};function Gd(a,b,c){this.src=a;this.text=b;this.shapes=[c];this.context=document.URL};function Hd(){}function Id(a,b){a.g=new sd;a.Uc=[];a.bb=[];a.Ha=[];a.Fa=[];a.$b=[];a.ub={Ra:n,Qa:n};a.Ga=new sd;a.bc=i;a.bd=b}function Jd(a,b){var c=a.Ga.get(b);c||(c={Ra:n,Qa:n},a.Ga.set(b,c));return c}
	function Kd(a,b){var c=a.Fb(b);if(!a.g.get(c)){var d=a.zc(b),f=[],e=[];C(a.Uc,function(a){d.addHandler(a.type,a.Pa)});C(a.bb,function(a){if(a.onInitAnnotator)a.onInitAnnotator(d)});C(a.Fa,function(a){a.src==c&&(d.J(a),f.push(a))});C(a.$b,function(a){a.src==c&&(d.A(a),e.push(a))});C(f,function(b){D(a.Fa,b)});C(e,function(b){D(a.$b,b)});var h=a.Ga.get(c);h?(h.Ra&&d.N(),h.Qa&&d.ea(),a.Ga.remove(c)):(a.ub.Ra&&d.N(),a.ub.Qa&&d.ea());a.bc&&d.ga(a.bc);a.g.set(c,d);D(a.Ha,b)}}
	function Ld(a){var b,c;for(c=a.Ha.length;0<c;c--){for(var d=b=a.Ha[c-1],f=d.offsetTop,e=d.offsetLeft,h=d.offsetWidth,k=d.offsetHeight;d.offsetParent;)d=d.offsetParent,f+=d.offsetTop,e+=d.offsetLeft;f<window.pageYOffset+window.innerHeight&&(e<window.pageXOffset+window.innerWidth&&f+k>window.pageYOffset&&e+h>window.pageXOffset)&&Kd(a,b)}}function Md(a,b,c){if(b){var d=a.g.get(b);d?c?d.Da():d.ea():Jd(a,b).Qa=c}else C(W(a.g),function(a){c?a.Da():a.ea()}),a.ub.Qa=!c,C(W(a.Ga),function(a){a.Qa=!c})}
	function Nd(a,b,c){if(b){var d=a.g.get(b);d?c?d.Z():d.N():Jd(a,b).Ra=c}else C(W(a.g),function(a){c?a.Z():a.N()}),a.ub.Ra=!c,C(W(a.Ga),function(a){a.Ra=!c})}s=Hd.prototype;s.ba=function(a,b){var c=i,d=i;u(a)?(c=a,d=b):v(a)&&(d=a);c?(c=this.g.get(c))&&c.ba(d):C(W(this.g),function(a){a.ba(d)})};s.stopSelection=function(a){a?(a=this.g.get(a))&&a.stopSelection():C(W(this.g),function(a){a.stopSelection()})};
	s.J=function(a,b){if(Od(this,a.src)){var c=this.g.get(a.src);c?c.J(a,b):(this.Fa.push(a),b&&D(this.Fa,b))}};s.addHandler=function(a,b){C(W(this.g),function(c){c.addHandler(a,b)});this.Uc.push({type:a,Pa:b})};s.zb=function(a){this.bb.push(a);C(W(this.g),function(b){if(a.onInitAnnotator)a.onInitAnnotator(b)})};function Od(a,b){return ud(a.g.Y,b)?j:Da(a.Ha,function(c){return a.Fb(c)==b})!=m}
	s.destroy=function(a){if(a){var b=this.g.get(a);b&&(b.destroy(),this.g.remove(a))}else C(W(this.g),function(a){a.destroy()}),this.g.clear()};s.la=function(a){if(Od(this,a)&&(a=this.g.get(a)))return a.la().getName()};s.t=function(a){if(a){var b=this.g.get(a);return b?b.t():Aa(this.Fa,function(b){return b.src==a})}var c=[];C(W(this.g),function(a){Ga(c,a.t())});Ga(c,this.Fa);return c};s.ma=function(a){if(Od(this,a)&&(a=this.g.get(a)))return Ba(a.ma(),function(a){return a.getName()})};
	s.ea=function(a){Md(this,a,n)};s.N=function(a){Nd(this,a,n)};s.o=function(a){if(a){if(Od(this,a.src)){var b=this.g.get(a.src);b&&b.o(a)}}else C(W(this.g),function(a){a.o()})};s.init=function(){this.bd&&Ga(this.Ha,this.bd());Ld(this);var a=this,b=O(window,"scroll",function(){0<a.Ha.length?Ld(a):P(b)})};s.xc=function(a){this.Wb(a)&&Kd(this,a)};s.A=function(a){if(Od(this,a.src)){var b=this.g.get(a.src);b?b.A(a):this.$b.push(a)}};s.sb=function(a,b){if(Od(this,a)){var c=this.g.get(a);c&&c.Jd(b)}};
	s.ga=function(a){this.bc=a;C(W(this.g),function(b){b.ga(a)})};s.Da=function(a){Md(this,a,j)};s.Z=function(a){Nd(this,a,j)};function Pd(a,b){var c=rb().createElement("DIV");c.innerHTML=a(b||Qd,i,i);if(1==c.childNodes.length){var d=c.firstChild;if(1==d.nodeType)return d}return c}var Qd={};function Rd(a,b){a!=m&&this.append.apply(this,arguments)}s=Rd.prototype;s.wa="";s.set=function(a){this.wa=""+a};s.append=function(a,b,c){this.wa+=a;if(b!=m)for(var d=1;d<arguments.length;d++)this.wa+=arguments[d];return this};s.clear=function(){this.wa=""};s.toString=r("wa");/*
	 Portions of this code are from the google-caja project, received by
	 Google under the Apache license (http://code.google.com/p/google-caja/).
	 All other code is Copyright 2009 Google, Inc. All Rights Reserved.

	// Copyright (C) 2006 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.

	*/
	function Sd(){}
	var Td={we:"<",ve:">",oe:"&",xe:"\u00a0",ze:'"',pe:"'"},Ud={a:0,abbr:0,acronym:0,address:0,applet:16,area:2,b:0,base:18,basefont:18,bdo:0,big:0,blockquote:0,body:49,br:2,button:0,caption:0,center:0,cite:0,code:0,col:2,colgroup:1,dd:1,del:0,dfn:0,dir:0,div:0,dl:0,dt:1,em:0,fieldset:0,font:0,form:0,frame:18,frameset:16,h1:0,h2:0,h3:0,h4:0,h5:0,h6:0,head:49,hr:2,html:49,i:0,iframe:20,img:2,input:2,ins:0,isindex:18,kbd:0,label:0,legend:0,li:1,link:18,map:0,menu:0,meta:18,noframes:20,noscript:20,object:16,
	ol:0,optgroup:0,option:1,p:1,param:18,pre:0,q:0,s:0,samp:0,script:20,select:0,small:0,span:0,strike:0,strong:0,style:20,sub:0,sup:0,table:0,tbody:1,td:1,textarea:8,tfoot:1,th:1,thead:1,title:24,tr:1,tt:0,u:0,ul:0,"var":0},Vd=/&/g,Wd=/&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi,Xd=/</g,Yd=/>/g,Zd=/\"/g,$d=/=/g,ae=/\0/g,be=/&(#\d+|#x[0-9A-Fa-f]+|\w+);/g,ce=/^#(\d+)$/,de=/^#x([0-9A-Fa-f]+)$/,ee=RegExp("^\\s*(?:(?:([a-z][a-z-]*)(\\s*=\\s*(\"[^\"]*\"|'[^']*'|(?=[a-z][a-z-]*\\s*=)|[^>\"'\\s]*))?)|(/?>)|[^a-z\\s>]+)",
	"i"),fe=RegExp("^(?:&(\\#[0-9]+|\\#[x][0-9a-f]+|\\w+);|<[!]--[\\s\\S]*?--\>|<!\\w[^>]*>|<\\?[^>*]*>|<(/)?([a-z][a-z0-9]*)|([^<&>]+)|([<&>]))","i");
	Sd.prototype.parse=function(a,b){var c=m,d=n,f=[],e,h,k;a.Q=[];for(a.oa=n;b;){var l=b.match(d?ee:fe),b=b.substring(l[0].length);if(d)if(l[1]){var q=l[1].toLowerCase();if(l[2]){l=l[3];switch(l.charCodeAt(0)){case 34:case 39:l=l.substring(1,l.length-1)}l=l.replace(ae,"").replace(be,oa(this.be,this))}else l=q;f.push(q,l)}else l[4]&&(h!==i&&(k?a.Kd&&a.Kd(e,f):a.nd&&a.nd(e)),k&&h&12&&(c=c===m?b.toLowerCase():c.substring(c.length-b.length),d=c.indexOf("</"+e),0>d&&(d=b.length),h&4?a.gd&&a.gd(b.substring(0,
	d)):a.Id&&a.Id(b.substring(0,d).replace(Wd,"&amp;$1").replace(Xd,"&lt;").replace(Yd,"&gt;")),b=b.substring(d)),e=h=k=i,f.length=0,d=n);else if(l[1])ge(a,l[0]);else if(l[3])k=!l[2],d=j,e=l[3].toLowerCase(),h=Ud.hasOwnProperty(e)?Ud[e]:i;else if(l[4])ge(a,l[4]);else if(l[5])switch(l[5]){case "<":ge(a,"&lt;");break;case ">":ge(a,"&gt;");break;default:ge(a,"&amp;")}}for(c=a.Q.length;0<=--c;)a.ha.append("</",a.Q[c],">");a.Q.length=0};
	Sd.prototype.be=function(a){a=a.toLowerCase();if(Td.hasOwnProperty(a))return Td[a];var b=a.match(ce);return b?String.fromCharCode(parseInt(b[1],10)):(b=a.match(de))?String.fromCharCode(parseInt(b[1],16)):""};function he(){};/*
	 Portions of this code are from the google-caja project, received by
	 Google under the Apache license (http://code.google.com/p/google-caja/).
	 All other code is Copyright 2009 Google, Inc. All Rights Reserved.

	// Copyright (C) 2006 Google Inc.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.

	*/
	function ie(a,b,c){this.ha=a;this.Q=[];this.oa=n;this.Od=b;this.Ob=c}z(ie,he);
	var je={"*::class":9,"*::dir":0,"*::id":4,"*::lang":0,"*::onclick":2,"*::ondblclick":2,"*::onkeydown":2,"*::onkeypress":2,"*::onkeyup":2,"*::onload":2,"*::onmousedown":2,"*::onmousemove":2,"*::onmouseout":2,"*::onmouseover":2,"*::onmouseup":2,"*::style":3,"*::title":0,"*::accesskey":0,"*::tabindex":0,"*::onfocus":2,"*::onblur":2,"a::coords":0,"a::href":1,"a::hreflang":0,"a::name":7,"a::onblur":2,"a::rel":0,"a::rev":0,"a::shape":0,"a::target":10,"a::type":0,"area::accesskey":0,"area::alt":0,"area::coords":0,
	"area::href":1,"area::nohref":0,"area::onfocus":2,"area::shape":0,"area::tabindex":0,"area::target":10,"bdo::dir":0,"blockquote::cite":1,"br::clear":0,"button::accesskey":0,"button::disabled":0,"button::name":8,"button::onblur":2,"button::onfocus":2,"button::tabindex":0,"button::type":0,"button::value":0,"caption::align":0,"col::align":0,"col::char":0,"col::charoff":0,"col::span":0,"col::valign":0,"col::width":0,"colgroup::align":0,"colgroup::char":0,"colgroup::charoff":0,"colgroup::span":0,"colgroup::valign":0,
	"colgroup::width":0,"del::cite":1,"del::datetime":0,"dir::compact":0,"div::align":0,"dl::compact":0,"font::color":0,"font::face":0,"font::size":0,"form::accept":0,"form::action":1,"form::autocomplete":0,"form::enctype":0,"form::method":0,"form::name":7,"form::onreset":2,"form::onsubmit":2,"form::target":10,"h1::align":0,"h2::align":0,"h3::align":0,"h4::align":0,"h5::align":0,"h6::align":0,"hr::align":0,"hr::noshade":0,"hr::size":0,"hr::width":0,"img::align":0,"img::alt":0,"img::border":0,"img::height":0,
	"img::hspace":0,"img::ismap":0,"img::longdesc":1,"img::name":7,"img::src":1,"img::usemap":11,"img::vspace":0,"img::width":0,"input::accept":0,"input::accesskey":0,"input::autocomplete":0,"input::align":0,"input::alt":0,"input::checked":0,"input::disabled":0,"input::ismap":0,"input::maxlength":0,"input::name":8,"input::onblur":2,"input::onchange":2,"input::onfocus":2,"input::onselect":2,"input::readonly":0,"input::size":0,"input::src":1,"input::tabindex":0,"input::type":0,"input::usemap":11,"input::value":0,
	"ins::cite":1,"ins::datetime":0,"label::accesskey":0,"label::for":5,"label::onblur":2,"label::onfocus":2,"legend::accesskey":0,"legend::align":0,"li::type":0,"li::value":0,"map::name":7,"menu::compact":0,"ol::compact":0,"ol::start":0,"ol::type":0,"optgroup::disabled":0,"optgroup::label":0,"option::disabled":0,"option::label":0,"option::selected":0,"option::value":0,"p::align":0,"pre::width":0,"q::cite":1,"select::disabled":0,"select::multiple":0,"select::name":8,"select::onblur":2,"select::onchange":2,
	"select::onfocus":2,"select::size":0,"select::tabindex":0,"table::align":0,"table::bgcolor":0,"table::border":0,"table::cellpadding":0,"table::cellspacing":0,"table::frame":0,"table::rules":0,"table::summary":0,"table::width":0,"tbody::align":0,"tbody::char":0,"tbody::charoff":0,"tbody::valign":0,"td::abbr":0,"td::align":0,"td::axis":0,"td::bgcolor":0,"td::char":0,"td::charoff":0,"td::colspan":0,"td::headers":6,"td::height":0,"td::nowrap":0,"td::rowspan":0,"td::scope":0,"td::valign":0,"td::width":0,
	"textarea::accesskey":0,"textarea::cols":0,"textarea::disabled":0,"textarea::name":8,"textarea::onblur":2,"textarea::onchange":2,"textarea::onfocus":2,"textarea::onselect":2,"textarea::readonly":0,"textarea::rows":0,"textarea::tabindex":0,"tfoot::align":0,"tfoot::char":0,"tfoot::charoff":0,"tfoot::valign":0,"th::abbr":0,"th::align":0,"th::axis":0,"th::bgcolor":0,"th::char":0,"th::charoff":0,"th::colspan":0,"th::headers":6,"th::height":0,"th::nowrap":0,"th::rowspan":0,"th::scope":0,"th::valign":0,
	"th::width":0,"thead::align":0,"thead::char":0,"thead::charoff":0,"thead::valign":0,"tr::align":0,"tr::bgcolor":0,"tr::char":0,"tr::charoff":0,"tr::valign":0,"ul::compact":0,"ul::type":0};
	ie.prototype.Kd=function(a,b){if(!this.oa&&Ud.hasOwnProperty(a)){var c=Ud[a];if(!(c&32))if(c&16)this.oa=!(c&2);else{for(var d=b,f=0;f<d.length;f+=2){var e=d[f],h=d[f+1],k=m,l;if((l=a+"::"+e,je.hasOwnProperty(l))||(l="*::"+e,je.hasOwnProperty(l)))k=je[l];if(k!==m)switch(k){case 0:break;case 2:case 3:h=m;break;case 4:case 5:case 6:case 7:case 8:case 9:h=this.Ob?this.Ob(h):h;break;case 1:h=this.Od&&this.Od(h);break;case 11:h&&"#"===h.charAt(0)?(h=this.Ob?this.Ob(h):h)&&(h="#"+h):h=m;break;default:h=
	m}else h=m;d[f+1]=h}if(b=d){c&2||this.Q.push(a);this.ha.append("<",a);c=0;for(d=b.length;c<d;c+=2)f=b[c],e=b[c+1],e!==m&&e!==i&&this.ha.append(" ",f,'="',e.replace(Vd,"&amp;").replace(Xd,"&lt;").replace(Yd,"&gt;").replace(Zd,"&#34;").replace($d,"&#61;"),'"');this.ha.append(">")}}}};
	ie.prototype.nd=function(a){if(this.oa)this.oa=n;else if(Ud.hasOwnProperty(a)){var b=Ud[a];if(!(b&50)){if(b&1)for(b=this.Q.length;0<=--b;){var c=this.Q[b];if(c===a)break;if(!(Ud[c]&1))return}else for(b=this.Q.length;0<=--b&&this.Q[b]!==a;);if(!(0>b)){for(var d=this.Q.length;--d>b;)c=this.Q[d],Ud[c]&1||this.ha.append("</",c,">");this.Q.length=b;this.ha.append("</",a,">")}}}};function ge(a,b){a.oa||a.ha.append(b)}ie.prototype.Id=function(a){this.oa||this.ha.append(a)};
	ie.prototype.gd=function(a){this.oa||this.ha.append(a)};function ke(a,b,c,d,f){if(!E&&(!G||!I("525")))return j;if(Na&&f)return le(a);if(f&&!d||!c&&(17==b||18==b)||E&&d&&b==a)return n;switch(a){case 13:return!(E&&db(9));case 27:return!G}return le(a)}function le(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=a||G&&0==a)return j;switch(a){case 32:case 63:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:return j;default:return n}}
	function me(a){switch(a){case 61:return 187;case 59:return 186;case 224:return 91;case 0:return 224;default:return a}};function ne(a,b){nc.call(this);a&&oe(this,a,b)}z(ne,Jc);s=ne.prototype;s.F=m;s.Ib=m;s.uc=m;s.Jb=m;s.qa=-1;s.pa=-1;s.mc=n;
	var pe={3:13,12:144,63232:38,63233:40,63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},qe={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},re=E||G&&I("525"),se=Na&&F;s=ne.prototype;
	s.Wd=function(a){if(G&&(17==this.qa&&!a.ctrlKey||18==this.qa&&!a.altKey))this.pa=this.qa=-1;re&&!ke(a.keyCode,this.qa,a.shiftKey,a.ctrlKey,a.altKey)?this.handleEvent(a):(this.pa=F?me(a.keyCode):a.keyCode,se&&(this.mc=a.altKey))};s.Yd=function(a){this.pa=this.qa=-1;this.mc=a.altKey};
	s.handleEvent=function(a){var b=a.n,c,d,f=b.altKey;E&&"keypress"==a.type?(c=this.pa,d=13!=c&&27!=c?b.keyCode:0):G&&"keypress"==a.type?(c=this.pa,d=0<=b.charCode&&63232>b.charCode&&le(c)?b.charCode:0):Sa?(c=this.pa,d=le(c)?b.keyCode:0):(c=b.keyCode||this.pa,d=b.charCode||0,se&&(f=this.mc),Na&&(63==d&&224==c)&&(c=191));var e=c,h=b.keyIdentifier;c?63232<=c&&c in pe?e=pe[c]:25==c&&a.shiftKey&&(e=9):h&&h in qe&&(e=qe[h]);a=e==this.qa;this.qa=e;b=new te(e,d,a,b);b.altKey=f;this.dispatchEvent(b)};s.d=r("F");
	function oe(a,b,c){a.Jb&&a.detach();a.F=b;a.Ib=O(a.F,"keypress",a,c);a.uc=O(a.F,"keydown",a.Wd,c,a);a.Jb=O(a.F,"keyup",a.Yd,c,a)}s.detach=function(){this.Ib&&(P(this.Ib),P(this.uc),P(this.Jb),this.Jb=this.uc=this.Ib=m);this.F=m;this.pa=this.qa=-1};function te(a,b,c,d){d&&this.init(d,i);this.type="key";this.keyCode=a;this.charCode=b;this.repeat=c}z(te,sc);function ue(){}ea(ue);ue.prototype.fe=0;ue.pb();function ve(a){nc.call(this);this.kb=a||rb();this.ra=we}z(ve,Jc);ve.prototype.$d=ue.pb();var we=m;function xe(a,b){switch(a){case 1:return b?"disable":"enable";case 2:return b?"highlight":"unhighlight";case 4:return b?"activate":"deactivate";case 8:return b?"select":"unselect";case 16:return b?"check":"uncheck";case 32:return b?"focus":"blur";case 64:return b?"open":"close"}g(Error("Invalid component state"))}s=ve.prototype;s.Hb=m;s.fa=n;s.F=m;s.ra=m;s.za=m;s.hb=m;s.Ja=m;s.ne=n;s.d=r("F");
	s.Eb=function(){return this.sc||(this.sc=new Gc(this))};s.Gc=function(a){this.za&&this.za!=a&&g(Error("Method not supported"));ve.K.Gc.call(this,a)};s.pd=r("kb");s.jb=function(a){this.fa&&g(Error("Component already rendered"));if(a&&this.gb(a)){this.ne=j;if(!this.kb||this.kb.M!=K(a))this.kb=rb(a);this.jd(a);this.Ma()}else g(Error("Invalid element to decorate"))};s.gb=aa(j);s.jd=function(a){this.F=a};s.Ma=function(){function a(a){!a.fa&&a.d()&&a.Ma()}this.fa=j;this.hb&&C(this.hb,a,i)};
	s.Db=function(){function a(a){a.fa&&a.Db()}this.hb&&C(this.hb,a,i);this.sc&&this.sc.Sb();this.fa=n};s.nb=r("F");s.Va=function(a){this.fa&&g(Error("Component already rendered"));this.ra=a};
	s.removeChild=function(a,b){if(a){var c=u(a)?a:a.Hb||(a.Hb=":"+(a.$d.fe++).toString(36)),d;this.Ja&&c?(d=this.Ja,d=(c in d?d[c]:i)||m):d=m;a=d;c&&a&&(d=this.Ja,c in d&&delete d[c],D(this.hb,a),b&&(a.Db(),a.F&&zb(a.F)),c=a,c==m&&g(Error("Unable to set parent component")),c.za=m,ve.K.Gc.call(c,m))}a||g(Error("Child is not in parent component"));return a};function ye(){}var ze;ea(ye);s=ye.prototype;s.nb=function(a){return a};s.lb=function(a,b,c){if(a=a.d?a.d():a)if(E&&!I("7")){var d=Ae(hb(a),b);d.push(b);pa(c?ib:kb,a).apply(m,d)}else c?ib(a,b):kb(a,b)};s.gb=aa(j);
	s.jb=function(a,b){if(b.id){var c=b.id;if(a.za&&a.za.Ja){var d=a.za.Ja,f=a.Hb;f in d&&delete d[f];d=a.za.Ja;c in d&&g(Error('The object already contains the key "'+c+'"'));d[c]=a}a.Hb=c}(c=this.nb(b))&&c.firstChild?(c=c.firstChild.nextSibling?Fa(c.childNodes):c.firstChild,a.ib=c):a.ib=m;var e=0,h=this.ob(),k=this.ob(),l=n,q=n,c=n,d=hb(b);C(d,function(a){if(!l&&a==h)l=j,k==h&&(q=j);else if(!q&&a==k)q=j;else{var b=e;if(!this.Nd){this.Bb||Be(this);var c=this.Bb,d={},f;for(f in c)d[c[f]]=f;this.Nd=d}a=
	parseInt(this.Nd[a],10);e=b|(isNaN(a)?0:a)}},this);a.r=e;l||(d.push(h),k==h&&(q=j));q||d.push(k);(f=a.da)&&d.push.apply(d,f);if(E&&!I("7")){var w=Ae(d);0<w.length&&(d.push.apply(d,w),c=j)}if(!l||!q||f||c)b.className=d.join(" ");a.isEnabled()||this.Wa(b,1,j);a.r&8&&this.Wa(b,8,j);a.V&16&&this.Wa(b,16,!!(a.r&16));a.V&64&&this.Wa(b,64,!!(a.r&64));return b};
	s.Vb=function(a,b){var c=!b,d=E||Sa?a.getElementsByTagName("*"):m;if(bd){if(c=c?"none":"",a.style[bd]=c,d)for(var f=0,e;e=d[f];f++)e.style[bd]=c}else if(E||Sa)if(c=c?"on":"",a.setAttribute("unselectable",c),d)for(f=0;e=d[f];f++)e.setAttribute("unselectable",c)};s.Va=function(a,b){this.lb(a,this.ob()+"-rtl",b)};s.Cd=function(a){var b;return a.V&32&&(b=a.Na())?Cb(b):n};
	s.Fc=function(a,b){var c;if(a.V&32&&(c=a.Na())){if(!b&&a.r&32){try{c.blur()}catch(d){}a.r&32&&a.qd()}Cb(c)!=b&&(b?c.tabIndex=0:(c.tabIndex=-1,c.removeAttribute("tabIndex")))}};s.P=function(a,b,c){var d=a.d();if(d){var f;this.Bb||Be(this);(f=this.Bb[b])&&this.lb(a,f,c);this.Wa(d,b,c)}};s.Wa=function(a,b,c){ze||(ze={1:"disabled",8:"selected",16:"checked",64:"expanded"});(b=ze[b])&&a.setAttribute("aria-"+b,c)};
	s.sa=function(a,b){var c=this.nb(a);if(c&&(yb(c),b))if(u(b))if("textContent"in c)c.textContent=b;else if(c.firstChild&&3==c.firstChild.nodeType){for(;c.lastChild!=c.firstChild;)c.removeChild(c.lastChild);c.firstChild.data=b}else yb(c),c.appendChild(K(c).createTextNode(b));else{var d=function(a){if(a){var b=K(c);c.appendChild(u(a)?b.createTextNode(a):a)}};ga(b)?C(b,d):ha(b)&&!("nodeType"in b)?C(Fa(b),d):d(b)}};s.Na=function(a){return a.d()};s.ob=aa("goog-control");
	function Ae(a,b){var c=[];b&&(a=a.concat([b]));C([],function(d){Ca(d,pa(Ea,a))&&(!b||Ea(d,b))&&c.push(d.join("_"))});return c}function Be(a){var b=a.ob();a.Bb={1:b+"-disabled",2:b+"-hover",4:b+"-active",8:b+"-selected",16:b+"-checked",32:b+"-focused",64:b+"-open"}};var Ce={};function De(a,b,c){ve.call(this,c);if(!b){for(var b=this.constructor,d;b;){d=ja(b);if(d=Ce[d])break;b=b.K?b.K.constructor:m}b=d?v(d.pb)?d.pb():new d:m}this.G=b;this.ib=a}z(De,ve);s=De.prototype;s.ib=m;s.r=0;s.V=39;s.oc=255;s.me=0;s.Yb=j;s.da=m;s.tc=j;s.lc=n;s.ie=m;function Ee(a){a.fa&&n!=a.tc&&Fe(a,n);a.tc=n}s.Na=function(){return this.G.Na(this)};
	s.lb=function(a,b){b?a&&(this.da?Ea(this.da,a)||this.da.push(a):this.da=[a],this.G.lb(this,a,j)):a&&this.da&&(D(this.da,a),0==this.da.length&&(this.da=m),this.G.lb(this,a,n))};s.nb=function(){return this.G.nb(this.d())};s.gb=function(a){return this.G.gb(a)};s.jd=function(a){this.F=a=this.G.jb(this,a);var b=this.ie||i;b&&a.setAttribute("role",b);this.lc||this.G.Vb(a,n);this.Yb="none"!=a.style.display};
	s.Ma=function(){De.K.Ma.call(this);var a=this.G;this.ra==m&&(this.ra=ad(this.fa?this.F:this.kb.M.body));this.ra&&a.Va(this.d(),j);this.isEnabled()&&a.Fc(this,this.Yb);if(this.V&-2&&(this.tc&&Fe(this,j),this.V&32&&(a=this.Na()))){var b=this.vc||(this.vc=new ne);oe(b,a);Q(Q(Q(this.Eb(),b,"key",this.Xd),a,"focus",this.Vd),a,"blur",this.qd)}};
	function Fe(a,b){var c=a.Eb(),d=a.d();b?(Q(Q(Q(Q(c,d,"mouseover",a.vd),d,"mousedown",a.sd),d,"mouseup",a.wd),d,"mouseout",a.ud),a.Gb!=da&&Q(c,d,"contextmenu",a.Gb),E&&Q(c,d,"dblclick",a.rd)):(Ic(Ic(Ic(Ic(c,d,"mouseover",a.vd),d,"mousedown",a.sd),d,"mouseup",a.wd),d,"mouseout",a.ud),a.Gb!=da&&Ic(c,d,"contextmenu",a.Gb),E&&Ic(c,d,"dblclick",a.rd))}s.Db=function(){De.K.Db.call(this);this.vc&&this.vc.detach();this.Yb&&this.isEnabled()&&this.G.Fc(this,n)};
	s.sa=function(a){this.G.sa(this.d(),a);this.ib=a};s.Va=function(a){De.K.Va.call(this,a);var b=this.d();b&&this.G.Va(b,a)};s.Vb=function(a){this.lc=a;var b=this.d();b&&this.G.Vb(b,a)};s.isEnabled=function(){return!(this.r&1)};function Ge(a,b){He(a,2,b)&&a.P(2,b)}s.setActive=function(a){He(this,4,a)&&this.P(4,a)};s.P=function(a,b){this.V&a&&b!=!!(this.r&a)&&(this.G.P(this,a,b),this.r=b?this.r|a:this.r&~a)};function X(a,b){return!!(a.oc&b)&&!!(a.V&b)}
	function He(a,b,c){return!!(a.V&b)&&!!(a.r&b)!=c&&(!(a.me&b)||a.dispatchEvent(xe(b,c)))&&!a.ld}s.vd=function(a){(!a.relatedTarget||!Bb(this.d(),a.relatedTarget))&&(this.dispatchEvent("enter")&&this.isEnabled()&&X(this,2))&&Ge(this,j)};s.ud=function(a){if((!a.relatedTarget||!Bb(this.d(),a.relatedTarget))&&this.dispatchEvent("leave"))X(this,4)&&this.setActive(n),X(this,2)&&Ge(this,n)};s.Gb=da;
	s.sd=function(a){this.isEnabled()&&(X(this,2)&&Ge(this,j),uc(a)&&(X(this,4)&&this.setActive(j),this.G.Cd(this)&&this.Na().focus()));!this.lc&&uc(a)&&a.preventDefault()};s.wd=function(a){this.isEnabled()&&(X(this,2)&&Ge(this,j),this.r&4&&(Ie(this,a)&&X(this,4))&&this.setActive(n))};s.rd=function(a){this.isEnabled()&&Ie(this,a)};
	function Ie(a,b){if(X(a,16)){var c=!(a.r&16);He(a,16,c)&&a.P(16,c)}X(a,8)&&He(a,8,j)&&a.P(8,j);X(a,64)&&(c=!(a.r&64),He(a,64,c)&&a.P(64,c));c=new pc("action",a);b&&(c.altKey=b.altKey,c.ctrlKey=b.ctrlKey,c.metaKey=b.metaKey,c.shiftKey=b.shiftKey,c.Cc=b.Cc);return a.dispatchEvent(c)}s.Vd=function(){X(this,32)&&He(this,32,j)&&this.P(32,j)};s.qd=function(){X(this,4)&&this.setActive(n);X(this,32)&&He(this,32,n)&&this.P(32,n)};
	s.Xd=function(a){return this.Yb&&this.isEnabled()&&13==a.keyCode&&Ie(this,a)?(a.preventDefault(),a.stopPropagation(),j):n};v(De)||g(Error("Invalid component class "+De));v(ye)||g(Error("Invalid renderer class "+ye));var Je=ja(De);Ce[Je]=ye;function Ke(){return new De(m)}v(Ke)||g(Error("Invalid decorator function "+Ke));function Le(){}z(Le,ye);ea(Le);s=Le.prototype;s.jb=function(a,b){Ee(a);a.oc&=-256;a.fa&&a.r&32&&g(Error("Component already rendered"));a.r&32&&a.P(32,n);a.V&=-33;Le.K.jb.call(this,a,b);a.sa(b.value);return b};s.gb=function(a){return"TEXTAREA"==a.tagName};s.Va=da;s.Cd=function(a){return a.isEnabled()};s.Fc=da;s.P=function(a,b,c){Le.K.P.call(this,a,b,c);if((a=a.d())&&1==b)a.disabled=c};s.Wa=da;s.sa=function(a,b){a&&(a.value=b)};s.ob=aa("goog-textarea");function Ne(a,b,c){De.call(this,a,b||Le.pb(),c);Ee(this);this.Vb(j);a||(this.ib="")}z(Ne,De);var Oe=F||G;s=Ne.prototype;s.Sa=n;s.na=0;s.ce=0;s.Fd=0;s.yd=n;s.Nb=n;s.Ec=n;s.Dc=n;function Pe(a){return a.rb.top+a.rb.bottom+a.ed.top+a.ed.bottom}function Qe(a){var b=a.Fd,c=a.d();b&&(c&&a.Nb)&&(b-=Pe(a));return b}function Re(a){var b=a.ce,c=a.d();b&&(c&&a.Nb)&&(b-=Pe(a));return b}s.sa=function(a){Ne.K.sa.call(this,a);this.d()&&this.Oa()};
	s.Ma=function(){Ne.K.Ma.call(this);var a=this.d();R(a,{overflowY:"hidden",overflowX:"auto",boxSizing:"border-box",MsBoxSizing:"border-box",WebkitBoxSizing:"border-box",MozBoxSizing:"border-box"});this.rb=dd(a,"padding");this.ed=gd(a);Q(Q(Q(Q(this.Eb(),a,"scroll",this.Oa),a,"focus",this.Oa),a,"keyup",this.Oa),a,"mouseup",this.ee);this.d()&&this.Oa()};
	function Se(a){if(!a.yd){var b=a.d().cloneNode(n);R(b,{position:"absolute",height:"auto",top:"-9999px",margin:"0",padding:"1px",border:"1px solid #000",overflow:"hidden"});a.pd().M.body.appendChild(b);var c=b.scrollHeight;b.style.padding="10px";var d=b.scrollHeight;a.Ec=d>c;b.style.borderWidth="10px";a.Dc=b.scrollHeight>d;b.style.height="100px";100!=b.offsetHeight&&(a.Nb=j);zb(b);a.yd=j}var b=a.d(),c=a.d().scrollHeight,f=a.d(),d=f.offsetHeight-f.clientHeight;if(!a.Ec)var e=a.rb,d=d-(e.top+e.bottom);
	a.Dc||(f=gd(f),d-=f.top+f.bottom);c+=0<d?d:0;a.Nb?c-=Pe(a):(a.Ec||(d=a.rb,c+=d.top+d.bottom),a.Dc||(a=gd(b),c+=a.top+a.bottom));return c}function Te(a,b){a.na!=b&&(a.na=b,a.d().style.height=b+"px")}function Ue(a){a=a.d();a.style.height="auto";var b=a.value.match(/\n/g)||[];a.rows=b.length+1}
	s.Oa=function(){if(!this.Sa){var a=n;this.Sa=j;var b=this.d(),c=this.na;if(b.scrollHeight){var d=n,f=n,e=Se(this),h=b.offsetHeight,k=Qe(this),l=Re(this);k&&e<k?(Te(this,k),d=j):l&&e>l?(Te(this,l),b.style.overflowY="",f=j):h!=e?Te(this,e):this.na||(this.na=e);!d&&(!f&&Oe)&&(a=j)}else Ue(this);this.Sa=n;a&&(a=this.d(),this.Sa||(this.Sa=j,b=n,a.value||(a.value=" ",b=j),(f=a.scrollHeight)?(e=Se(this),d=Qe(this),h=Re(this),!(d&&e<=d)&&!(h&&e>=h)&&(h=this.rb,a.style.paddingBottom=h.bottom+1+"px",Se(this)==
	e&&(a.style.paddingBottom=h.bottom+f+"px",a.scrollTop=0,f=Se(this)-f,f>=d?Te(this,f):Te(this,d)),a.style.paddingBottom=h.bottom+"px")):Ue(this),b&&(a.value=""),this.Sa=n));c!=this.na&&this.dispatchEvent("resize")}};s.ee=function(){var a=this.d(),b=a.offsetHeight;a.filters&&a.filters.length&&(a=a.filters.item("DXImageTransform.Microsoft.DropShadow"))&&(b-=a.offX);b!=this.na&&(this.na=this.Fd=b)};E&&I(8);function Ve(a){return"object"===typeof a&&a&&0===a.re?a.content:String(a).replace(We,Xe)}var Ye={"\x00":"&#0;",'"':"&quot;","&":"&amp;","'":"&#39;","<":"&lt;",">":"&gt;","\t":"&#9;","\n":"&#10;","\x0B":"&#11;","\f":"&#12;","\r":"&#13;"," ":"&#32;","-":"&#45;","/":"&#47;","=":"&#61;","`":"&#96;","\u0085":"&#133;","\u00a0":"&#160;","\u2028":"&#8232;","\u2029":"&#8233;"};function Xe(a){return Ye[a]}var We=/[\x00\x22\x26\x27\x3c\x3e]/g;function Ze(){return'<div class="annotorious-popup top-left" style="position:absolute;z-index:1"><div class="annotorious-popup-buttons"><a class="annotorious-popup-button annotorious-popup-button-edit" title="Edit" href="javascript:void(0);">EDIT</a><a class="annotorious-popup-button annotorious-popup-button-delete" title="Delete" href="javascript:void(0);">DELETE</a></div><span class="annotorious-popup-text"></span></div>'}
	function $e(){return'<div class="annotorious-editor" style="position:absolute;z-index:1"><form><textarea class="annotorious-editor-text" placeholder="Add a Comment..." tabindex="1"></textarea><div class="annotorious-editor-button-container"><a class="annotorious-editor-button annotorious-editor-button-cancel" href="javascript:void(0);" tabindex="3">Cancel</a><a class="annotorious-editor-button annotorious-editor-button-save" href="javascript:void(0);" tabindex="2">Save</a></div></form></div>'};function af(a){function b(){var a=d.Ia;a.d()&&a.Oa()}this.element=Pd($e);this.e=a;this.Rd=a.getItem();this.Ia=new Ne("");this.Pd=L(".annotorious-editor-button-cancel",this.element)[0];this.Tc=L(".annotorious-editor-button-save",this.element)[0];var c;c=this.Tc;gb?c=c.parentElement:(c=c.parentNode,c=Ab(c)?c:m);this.Qd=c;this.Ya=[];var d=this;O(this.Pd,"click",function(b){b.preventDefault();a.stopSelection(d.$c);d.close()});O(this.Tc,"click",function(b){b.preventDefault();b=d.od();a.J(b);a.stopSelection();
	d.$c?a.fireEvent("onAnnotationUpdated",b,a.getItem()):a.fireEvent("onAnnotationCreated",b,a.getItem());d.close()});V(this.element,n);a.element.appendChild(this.element);this.Ia.jb(L(".annotorious-editor-text",this.element)[0]);var f=this.element;c=document.createElement("div");R(c,"position","absolute");R(c,"top","0px");R(c,"right","0px");R(c,"width","5px");R(c,"height","100%");R(c,"cursor","e-resize");f.appendChild(c);var e=gd(f),e=$c(f).width-e.right-e.left;c=new hd(c);c.wc=new Lc(e,0,800,0)||new Lc(NaN,
	NaN,NaN,NaN);c.kd=function(a){R(f,"width",a+"px");b&&b()}}s=af.prototype;s.kc=function(a){var b=wb("div","annotorious-editor-field");u(a)?b.innerHTML=a:v(a)?this.Ya.push({D:b,qc:a}):Ab(a)&&b.appendChild(a);a=this.Qd;a.parentNode&&a.parentNode.insertBefore(b,a)};s.open=function(a){(this.vb=this.$c=a)&&this.Ia.sa(String(a.text));V(this.element,j);this.Ia.d().focus();C(this.Ya,function(b){var c=b.qc(a);u(c)?b.D.innerHTML=c:Ab(c)&&(yb(b.D),b.D.appendChild(c))});this.e.fireEvent("onEditorShown",a)};
	s.close=function(){V(this.element,n);this.Ia.sa("")};s.setPosition=function(a){Pc(this.element,a.x,a.y)};s.od=function(){var a;a=this.Ia.d().value;var b=new Rd;(new Sd).parse(new ie(b,function(a){return a},i),a);a=b.toString();this.vb?this.vb.text=a:this.vb=new Gd(this.Rd.src,a,this.e.la().getShape());return this.vb};af.prototype.addField=af.prototype.kc;af.prototype.getAnnotation=af.prototype.od;function bf(a,b,c){var d=this;c||(c="Click and Drag to Annotate");this.element=Pd(cf,{Mb:c});this.e=a;this.Xc=L(".annotorious-hint-msg",this.element)[0];this.Vc=L(".annotorious-hint-icon",this.element)[0];this.ic=function(){d.show()};this.hc=function(){df(d)};this.Zb();df(this);b.appendChild(this.element)}
	bf.prototype.Zb=function(){var a=this;this.Zc=O(this.Vc,"mouseover",function(){a.show();window.clearTimeout(a.ec)});this.Yc=O(this.Vc,"mouseout",function(){df(a)});this.e.addHandler("onMouseOverItem",this.ic);this.e.addHandler("onMouseOutOfItem",this.hc)};bf.prototype.wb=function(){P(this.Zc);P(this.Yc);this.e.Tb("onMouseOverItem",this.ic);this.e.Tb("onMouseOutOfItem",this.hc)};
	bf.prototype.show=function(){window.clearTimeout(this.ec);U(this.Xc,0.8);var a=this;this.ec=window.setTimeout(function(){df(a)},3E3)};function df(a){window.clearTimeout(a.ec);U(a.Xc,0)}bf.prototype.destroy=function(){this.wb();delete this.Zc;delete this.Yc;delete this.ic;delete this.hc;zb(this.element)};function ef(a){this.element=Pd(Ze);this.e=a;this.Sd=L(".annotorious-popup-text",this.element)[0];this.R=L(".annotorious-popup-buttons",this.element)[0];this.cc=n;this.Ya=[];var b=L(".annotorious-popup-button-edit",this.R)[0],c=L(".annotorious-popup-button-delete",this.R)[0],d=this;O(b,"mouseover",function(){ib(b,"annotorious-popup-button-active")});O(b,"mouseout",function(){kb(b,"annotorious-popup-button-active")});O(b,"click",function(){U(d.element,0);R(d.element,"pointer-events","none");a.pc(d.f)});
	O(c,"mouseover",function(){ib(c,"annotorious-popup-button-active")});O(c,"mouseout",function(){kb(c,"annotorious-popup-button-active")});O(c,"click",function(){a.fireEvent("beforeAnnotationRemoved",d.f)||(U(d.element,0),R(d.element,"pointer-events","none"),a.A(d.f),a.fireEvent("onAnnotationRemoved",d.f))});ff&&(O(this.element,"mouseover",function(){window.clearTimeout(d.ac);0.9>(d.R.style[ya("opacity")]||"")&&U(d.R,0.9);d.clearHideTimer()}),O(this.element,"mouseout",function(){U(d.R,0);d.startHideTimer()}),
	a.addHandler("onMouseOutOfItem",function(){d.startHideTimer()}));U(this.R,0);U(this.element,0);R(this.element,"pointer-events","none");a.element.appendChild(this.element)}s=ef.prototype;s.kc=function(a){var b=wb("div","annotorious-popup-field");u(a)?b.innerHTML=a:v(a)?this.Ya.push({D:b,qc:a}):Ab(a)&&b.appendChild(a);this.element.appendChild(b)};
	s.startHideTimer=function(){this.cc=n;if(!this.cb){var a=this;this.cb=window.setTimeout(function(){a.e.fireEvent("beforePopupHide",a);a.cc||(U(a.element,0),R(a.element,"pointer-events","none"),U(a.R,0.9),delete a.cb)},150)}};s.clearHideTimer=function(){this.cc=j;this.cb&&(window.clearTimeout(this.cb),delete this.cb)};
	s.show=function(a,b){this.clearHideTimer();b&&this.setPosition(b);a&&this.setAnnotation(a);this.ac&&window.clearTimeout(this.ac);U(this.R,0.9);if(ff){var c=this;this.ac=window.setTimeout(function(){U(c.R,0)},1E3)}U(this.element,0.9);R(this.element,"pointer-events","auto");this.e.fireEvent("onPopupShown",this.f)};s.setPosition=function(a){Pc(this.element,new J(a.x,a.y))};
	s.setAnnotation=function(a){this.f=a;this.Sd.innerHTML=a.text?a.text.replace(/\n/g,"<br/>"):'<span class="annotorious-popup-empty">No comment</span>';"editable"in a&&a.editable==n?V(this.R,n):V(this.R,j);C(this.Ya,function(b){var c=b.qc(a);u(c)?b.D.innerHTML=c:Ab(c)&&(yb(b.D),b.D.appendChild(c))})};ef.prototype.addField=ef.prototype.kc;function gf(){}s=gf.prototype;s.J=function(a,b){this.h.J(a,b)};s.addHandler=function(a,b){this.w.addHandler(a,b)};s.fireEvent=function(a,b,c){return this.w.fireEvent(a,b,c)};s.la=r("v");s.o=function(a){this.h.o(a)};s.A=function(a){this.h.A(a)};s.Tb=function(a,b){this.w.Tb(a,b)};s.stopSelection=function(a){ff&&V(this.c,n);this.eb&&(this.eb(),delete this.eb);this.v.stopSelection();a&&this.h.J(a)};
	function hf(a,b){O(b,jf,function(c){console.log("start selection event");console.log(c);c=kf(c,b);a.h.o(n);a.yb?(V(a.c,j),a.v.startSelection(c.x,c.y)):(c=a.h.mb(c.x,c.y),0<c.length&&a.h.o(c[0]))})};function lf(a,b){this.W=a;this.e=b;this.Ea=[];this.aa=[];this.ua=this.W.getContext("2d");this.ta=j;this.xb=n;var c=this;O(this.W,mf,function(a){if(c.ta){var b=nf(c,a.offsetX,a.offsetY);b?(c.xb=c.xb&&b==c.f,c.f?c.f!=b&&(c.ta=n,c.e.popup.startHideTimer()):(c.f=b,of(c),c.e.fireEvent("onMouseOverAnnotation",{C:c.f,mouseEvent:a}))):!c.xb&&c.f&&(c.ta=n,c.e.popup.startHideTimer())}else c.Xa=a});O(this.W,jf,function(){c.f!==i&&c.f!=n&&c.e.fireEvent("onAnnotationClicked",c.f)});b.addHandler("onMouseOutOfItem",
	function(){delete c.f;c.ta=j});b.addHandler("beforePopupHide",function(){if(!c.ta&&c.Xa){var a=c.f;c.f=nf(c,c.Xa.offsetX,c.Xa.offsetY);c.ta=j;a!=c.f?(of(c),c.e.fireEvent("onMouseOutOfAnnotation",{C:a,mouseEvent:c.Xa}),c.e.fireEvent("onMouseOverAnnotation",{C:c.f,mouseEvent:c.Xa})):c.f&&c.e.popup.clearHideTimer()}else of(c)})}s=lf.prototype;
	s.J=function(a,b){b&&(b==this.f&&delete this.f,D(this.Ea,b),delete this.aa[Fd(b.shapes[0])]);this.Ea.push(a);var c=a.shapes[0];if("pixel"!=c.units)var d=this,c=Ed(c,function(a){return d.e.ya(a)});this.aa[Fd(a.shapes[0])]=c;of(this)};s.A=function(a){a==this.f&&delete this.f;D(this.Ea,a);delete this.aa[Fd(a.shapes[0])];of(this)};s.t=function(){return Fa(this.Ea)};s.o=function(a){(this.f=a)?this.xb=j:this.e.popup.startHideTimer();of(this);this.ta=j};
	function nf(a,b,c){a=a.mb(b,c);if(0<a.length)return a[0]}
	s.mb=function(a,b){var c=[],d=this;C(this.Ea,function(f){var e;e=d.aa[Fd(f.shapes[0])];if("rect"==e.type)e=a<e.geometry.x||b<e.geometry.y||a>e.geometry.x+e.geometry.width||b>e.geometry.y+e.geometry.height?n:j;else if("polygon"==e.type){e=e.geometry.points;for(var h=n,k=e.length-1,l=0;l<e.length;l++)e[l].y>b!=e[k].y>b&&a<(e[k].x-e[l].x)*(b-e[l].y)/(e[k].y-e[l].y)+e[l].x&&(h=!h),k=l;e=h}else e=n;e&&c.push(f)});B.sort.call(c,function(a,b){var c=d.aa[Fd(a.shapes[0])],k=d.aa[Fd(b.shapes[0])];return Bd(c)-
	Bd(k)}||Ia);return c};function pf(a,b,c){var d=Da(a.e.ma(),function(a){return a.getSupportedShapeType()==b.type});d?d.drawShape(a.ua,b,c):console.log("WARNING unsupported shape type: "+b.type)}function of(a){a.ua.clearRect(0,0,a.W.width,a.W.height);C(a.Ea,function(b){b!=a.f&&pf(a,a.aa[Fd(b.shapes[0])])});if(a.f){var b=a.aa[Fd(a.f.shapes[0])];pf(a,b,j);b=Cd(b).geometry;a.e.popup.show(a.f,new vd(b.x,b.y+b.height+5))}};var qf="ontouchstart"in window,ff=!qf,jf=qf?"touchstart":"mousedown",rf=qf?"touchenter":"mouseover",mf=qf?"touchmove":"mousemove",sf=qf?"touchend":"mouseup",tf=qf?"touchleave":"mouseout";function kf(a,b){var c=n;a.offsetX=a.offsetX?a.offsetX:n;a.offsetY=a.offsetY?a.offsetY:n;return c=(!a.offsetX||!a.offsetY)&&a.n.changedTouches?{x:a.n.changedTouches[0].clientX-qd(b).left,y:a.n.changedTouches[0].clientY-qd(b).top}:{x:a.offsetX,y:a.offsetY}};function uf(){}s=uf.prototype;s.init=function(a,b){this.Pc="#000000";this.Rc="#ffffff";this.Jc=n;this.Lc="#000000";this.Nc="#fff000";this.Kc=n;this.Mc=this.Sc=this.Qc=1;this.Oc=1.2;this.W=b;this.e=a;this.ua=b.getContext("2d");this.ua.lineWidth=1;this.dc=n};
	s.Zb=function(){var a=this,b=this.W;this.fc=O(this.W,mf,function(c){console.log(c);c=kf(c,b);if(a.dc){a.B={x:c.x,y:c.y};a.ua.clearRect(0,0,b.width,b.height);var c=a.B.x-a.L.x,d=a.B.y-a.L.y;a.drawShape(a.ua,{type:"rect",geometry:{x:0<c?a.L.x:a.B.x,y:0<d?a.L.y:a.B.y,width:Math.abs(c),height:Math.abs(d)},style:{}})}});this.gc=O(b,sf,function(c){var d=kf(c,b),f=a.getShape(),c=c.n?c.n:c;a.dc=n;f?(a.wb(),a.e.fireEvent("onSelectionCompleted",{mouseEvent:c,shape:f,viewportBounds:a.getViewportBounds()})):
	(a.e.fireEvent("onSelectionCanceled"),c=a.e.mb(d.x,d.y),0<c.length&&a.e.o(c[0]))})};s.wb=function(){this.fc&&(P(this.fc),delete this.fc);this.gc&&(P(this.gc),delete this.gc)};s.getName=aa("rect_drag");s.getSupportedShapeType=aa("rect");
	s.ga=function(a){a.hasOwnProperty("outline")&&(this.Pc=a.outline);a.hasOwnProperty("stroke")&&(this.Rc=a.stroke);a.hasOwnProperty("fill")&&(this.Jc=a.fill);a.hasOwnProperty("hi_outline")&&(this.Lc=a.hi_outline);a.hasOwnProperty("hi_stroke")&&(this.Nc=a.hi_stroke);a.hasOwnProperty("hi_fill")&&(this.Kc=a.hi_fill);a.hasOwnProperty("outline_width")&&(this.Qc=a.outline_width);a.hasOwnProperty("stroke_width")&&(this.Sc=a.stroke_width);a.hasOwnProperty("hi_outline_width")&&(this.Mc=a.hi_outline_width);a.hasOwnProperty("hi_stroke_width")&&
	(this.Oc=a.hi_stroke_width)};s.startSelection=function(a,b){var c={x:a,y:b};this.dc=j;this.Zb(c);this.L=new vd(a,b);this.e.fireEvent("onSelectionStarted",{offsetX:a,offsetY:b});R(document.body,"-webkit-user-select","none")};s.stopSelection=function(){this.wb();this.ua.clearRect(0,0,this.W.width,this.W.height);R(document.body,"-webkit-user-select","auto");delete this.B};
	s.getShape=function(){if(this.B&&3<Math.abs(this.B.x-this.L.x)&&3<Math.abs(this.B.y-this.L.y)){var a=this.getViewportBounds(),a=this.e.Xb({x:a.left,y:a.top,width:a.right-a.left,height:a.bottom-a.top});return new Ad("rect",a)}};s.getViewportBounds=function(){var a,b;this.B.x>this.L.x?(a=this.B.x,b=this.L.x):(a=this.L.x,b=this.B.x);var c,d;this.B.y>this.L.y?(c=this.L.y,d=this.B.y):(c=this.B.y,d=this.L.y);return{top:c,right:a,bottom:d,left:b}};
	s.drawShape=function(a,b,c){var d,f,e,h;b.style||(b.style={});"rect"==b.type&&(c?(d=b.style.hi_fill||this.Kc,c=b.style.hi_stroke||this.Nc,f=b.style.hi_outline||this.Lc,e=b.style.hi_outline_width||this.Mc,h=b.style.hi_stroke_width||this.Oc):(d=b.style.fill||this.Jc,c=b.style.stroke||this.Rc,f=b.style.outline||this.Pc,e=b.style.outline_width||this.Qc,h=b.style.stroke_width||this.Sc),b=b.geometry,f&&(a.lineJoin="round",a.lineWidth=e,a.strokeStyle=f,a.strokeRect(b.x+e/2,b.y+e/2,b.width-e,b.height-e)),
	c&&(a.lineJoin="miter",a.lineWidth=h,a.strokeStyle=c,a.strokeRect(b.x+e+h/2,b.y+e+h/2,b.width-2*e-h,b.height-2*e-h)),d&&(a.lineJoin="miter",a.lineWidth=h,a.fillStyle=d,a.fillRect(b.x+e+h/2,b.y+e+h/2,b.width-2*e-h,b.height-2*e-h)))};function vf(a){return'<canvas class="annotorious-item annotorious-opacity-fade" style="position:absolute; top:0px; left:0px; width:'+Ve(a.width)+"px; height:"+Ve(a.height)+'px; z-index:0" width="'+Ve(a.width)+'" height="'+Ve(a.height)+'"></canvas>'}
	function cf(a){return'<div class="annotorious-hint" style="white-space:nowrap; position:absolute; top:0px; left:0px; pointer-events:none;"><div class="annotorious-hint-msg annotorious-opacity-fade">'+Ve(a.Mb)+'</div><div class="annotorious-hint-icon" style="pointer-events:auto"></div></div>'};function wf(a,b){function c(b,c){R(d,"margin-"+b,c+"px");R(a,"margin-"+b,0);R(a,"padding-"+b,0)}this.$=a;this.ad={padding:a.style.padding,margin:a.style.margin};this.w=new rd;this.ia=[];this.yb=j;this.element=wb("div","annotorious-annotationlayer");R(this.element,"position","relative");R(this.element,"display","inline-block");var d=this.element,f=dd(a,"margin"),e=dd(a,"padding");(0!=f.top||0!=e.top)&&c("top",f.top+e.top);(0!=f.right||0!=e.right)&&c("right",f.right+e.right);(0!=f.bottom||0!=e.bottom)&&
	c("bottom",f.bottom+e.bottom);(0!=f.left||0!=e.left)&&c("left",f.left+e.left);(f=a.parentNode)&&f.replaceChild(this.element,a);this.element.appendChild(a);f=$c(a);this.ja=Pd(vf,{width:f.width,height:f.height});ff&&ib(this.ja,"annotorious-item-unfocus");this.element.appendChild(this.ja);this.c=Pd(vf,{width:f.width,height:f.height});ff&&V(this.c,n);this.element.appendChild(this.c);this.popup=b?b:new ef(this);f=new uf;f.init(this,this.c);this.ia.push(f);this.v=f;this.editor=new af(this);this.h=new lf(this.ja,
	this);this.$a=new bf(this,this.element);var h=this;ff&&(O(this.element,rf,function(a){a=a.relatedTarget;if(!a||!Bb(h.element,a))h.w.fireEvent("onMouseOverItem"),mb(h.ja,"annotorious-item-unfocus","annotorious-item-focus")}),O(this.element,tf,function(a){a=a.relatedTarget;if(!a||!Bb(h.element,a))h.w.fireEvent("onMouseOutOfItem"),mb(h.ja,"annotorious-item-focus","annotorious-item-unfocus")}));hf(this,qf?this.c:this.ja);this.w.addHandler("onSelectionCompleted",function(a){var b=a.viewportBounds;h.editor.setPosition(new vd(b.left+
	h.$.offsetLeft,b.bottom+4+h.$.offsetTop));h.editor.open(n,a)});this.w.addHandler("onSelectionCanceled",function(){ff&&V(h.c,n);h.v.stopSelection()})}z(wf,gf);s=wf.prototype;s.ba=p();s.cd=function(a){a.init(this,this.c);this.ia.push(a)};s.destroy=function(){var a=this.$;a.style.margin=this.ad.margin;a.style.padding=this.ad.padding;var b=this.element,c=b.parentNode;c&&c.replaceChild(a,b)};
	s.pc=function(a){this.h.A(a);var b=Da(this.ia,function(b){return b.getSupportedShapeType()==a.shapes[0].type});if(b){V(this.c,j);this.h.o(n);var c=this.c.getContext("2d"),d=a.shapes[0],f=this,d="pixel"==d.units?d:Ed(d,function(a){return f.ya(a)});b.drawShape(c,d)}b=Cd(a.shapes[0]).geometry;b="pixel"==a.shapes[0].units?new vd(b.x,b.y+b.height):this.ya(new vd(b.x,b.y+b.height));this.editor.setPosition(new vd(b.x+this.$.offsetLeft,b.y+4+this.$.offsetTop));this.editor.open(a)};
	s.ya=function(a){var b=Yc(this.$);return a.width?{x:a.x*b.width,y:a.y*b.height,width:a.width*b.width,height:a.height*b.height}:{x:a.x*b.width,y:a.y*b.height}};s.la=r("v");s.t=function(){return this.h.t()};s.mb=function(a,b){return Fa(this.h.mb(a,b))};s.ma=r("ia");s.getItem=function(){return{src:xf(this.$),element:this.$}};function xf(a){var b=a.getAttribute("data-original");return b?b:a.src}s.ea=function(){V(this.ja,n)};s.N=function(){this.yb=n;this.$a&&(this.$a.destroy(),delete this.$a)};
	s.Jd=function(a){(this.v=Da(this.ia,function(b){return b.getName()==a}))||console.log('WARNING: selector "'+a+'" not available')};s.ga=function(a){C(this.ia,function(b){b.ga(a)});of(this.h)};s.Da=function(){V(this.ja,j)};s.Z=function(){this.yb=j;this.$a||(this.$a=new bf(this,this.element))};s.stopSelection=function(a){ff&&V(this.c,n);this.v.stopSelection();a&&this.h.J(a)};
	s.Xb=function(a){var b=Yc(this.$);return a.width?{x:a.x/b.width,y:a.y/b.height,width:a.width/b.width,height:a.height/b.height}:{x:a.x/b.width,y:a.y/b.height}};wf.prototype.addSelector=wf.prototype.cd;wf.prototype.fireEvent=wf.prototype.fireEvent;wf.prototype.setCurrentSelector=wf.prototype.Jd;wf.prototype.toItemCoordinates=wf.prototype.Xb;function yf(){Id(this,function(){return L("img.annotatable",document)})}z(yf,Hd);yf.prototype.Fb=function(a){return xf(a)};yf.prototype.zc=function(a){return new wf(a)};yf.prototype.Wb=function(a){return Ab(a)?"IMG"==a.tagName:n};function zf(a){return'<div class="annotorious-opacity-fade" style="white-space:nowrap; position:absolute; pointer-events:none; top:80px; width:100%; text-align:center;"><div class="annotorious-ol-hint" style="width: 400px; margin:0px auto;">'+Ve(a.Mb)+"</dvi></div>"};function Af(a,b){this.X=a;this.S=$c(b.element);this.k=b.popup;R(this.k.element,"z-index",99E3);this.z=[];this.tb=new OpenLayers.Layer.Boxes("Annotorious");this.X.addLayer(this.tb);var c=this;this.X.events.register("move",this.X,function(){c.I&&c.ab()});b.addHandler("beforePopupHide",function(){c.va==c.I?c.k.clearHideTimer():c.fb(c.va,c.I)})}s=Af.prototype;s.destroy=function(){this.tb.destroy()};
	s.ab=function(){var a=this.I.Lb.div,b=$c(a),c=Uc(a,this.X.div),a=c.y,c=c.x,d=b.width,f=b.height,b=$c(this.k.element),a={y:a+f+5};c+b.width>this.S.width?(mb(this.k.element,"top-left","top-right"),a.x=c+d-b.width):(mb(this.k.element,"top-right","top-left"),a.x=c);0>a.x&&(a.x=0);a.x+b.width>this.S.width&&(a.x=this.S.width-b.width);a.y+b.height>this.S.height&&(a.y=this.S.height-b.height);this.k.setPosition(a)};s.jc=function(a){this.k.setAnnotation(a);this.ab();this.k.show()};
	s.fb=function(a,b){a?(Uc(a.Lb.div,this.X.div),ya("height"),R(a.qb,"border-color","#fff000"),this.I=a,this.jc(a.C)):delete this.I;b&&R(b.qb,"border-color","#fff")};
	s.J=function(a){var b=a.shapes[0].geometry,b=new OpenLayers.Marker.Box(new OpenLayers.Bounds(b.x,b.y,b.x+b.width,b.y+b.height));ib(b.div,"annotorious-ol-boxmarker-outer");R(b.div,"border",m);var c=wb("div","annotorious-ol-boxmarker-inner");Xc(c,"100%","100%");b.div.appendChild(c);var d={C:a,Lb:b,qb:c},f=this;O(c,"mouseover",function(){f.I||f.fb(d);f.va=d});O(c,"mouseout",function(){delete f.va;f.k.startHideTimer()});this.z.push(d);B.sort.call(this.z,function(a,b){return Bd(b.C.shapes[0])-Bd(a.C.shapes[0])}||
	Ia);var e=1E4;C(this.z,function(a){R(a.Lb.div,"z-index",e);e++});this.tb.addMarker(b)};s.A=function(a){var b=Da(this.z,function(b){return b.C==a});b&&(D(this.z,b),this.tb.removeMarker(b.Lb))};s.t=function(){return Ba(this.z,function(a){return a.C})};s.o=function(a){a||this.k.startHideTimer()};function Bf(a){function b(){var a=parseInt(T(d.element,"width"),10),b=parseInt(T(d.element,"height"),10);Xc(d.c,a,b);d.c.width=a;d.c.height=b}this.X=a;this.element=a.div;var c=this.element.style[ya("position")]||"";"absolute"!=c&&"relative"!=c&&R(this.element,"position","relative");this.w=new rd;this.U=Pd(zf,{Mb:"Click and Drag"});R(this.U,"z-index",9998);U(this.U,0);this.element.appendChild(this.U);this.popup=new ef(this);this.h=new Af(a,this);this.c=Pd(vf,{width:"0",height:"0"});V(this.c,n);R(this.c,
	"position","absolute");R(this.c,"top","0px");R(this.c,"z-index",9999);this.element.appendChild(this.c);var d=this;b();this.v=new uf;this.v.init(this,this.c);this.eb=i;this.editor=new af(this);R(this.editor.element,"z-index",1E4);window.addEventListener?window.addEventListener("resize",b,n):window.attachEvent&&window.attachEvent("onresize",b);O(this.element,"mouseover",function(a){a=a.relatedTarget;(!a||!Bb(d.element,a))&&d.w.fireEvent("onMouseOverItem")});O(this.element,"mouseout",function(a){a=a.relatedTarget;
	(!a||!Bb(d.element,a))&&d.w.fireEvent("onMouseOutOfItem")});O(this.c,"mousedown",function(a){var b=Vc(d.element);d.v.startSelection(a.clientX-b.x,a.clientY-b.y)});this.w.addHandler("onSelectionCompleted",function(a){R(d.c,"pointer-events","none");a=a.viewportBounds;d.editor.setPosition(new vd(a.left,a.bottom+4));d.editor.open()});this.w.addHandler("onSelectionCanceled",function(){d.stopSelection()})}z(Bf,gf);s=Bf.prototype;s.Z=p();s.N=p();
	s.ba=function(a){R(this.c,"pointer-events","auto");var b=this;V(this.c,j);U(this.U,0.8);window.setTimeout(function(){U(b.U,0)},2E3);a&&(this.eb=a)};s.destroy=function(){this.h.destroy();zb(this.U);zb(this.c)};s.cd=p();s.pc=function(a){this.h.A(a);var b=this.v,c=this;if(b){V(this.c,j);this.h.o(i);var d=this.c.getContext("2d"),f=Ed(a.shapes[0],function(a){return c.ya(a)});console.log(f);b.drawShape(d,f);b=Cd(f).geometry;this.editor.setPosition(new vd(b.x,b.y+b.height));this.editor.open(a)}};
	s.ya=function(a){var b=this.X.getViewPortPxFromLonLat(new OpenLayers.LonLat(a.x,a.y));return(a=a.width?this.X.getViewPortPxFromLonLat(new OpenLayers.LonLat(a.x+a.width,a.y+a.height)):n)?{x:b.x,y:a.y,width:a.x-b.x+2,height:b.y-a.y+2}:{x:b.x,y:b.y}};s.t=function(){return this.h.t()};s.ma=p();s.getItem=function(){return{src:"map://openlayers/something"}};s.sb=p();
	s.Xb=function(a){var b=this.X.getLonLatFromPixel(new OpenLayers.Pixel(a.x,a.y));return(a=a.width?new OpenLayers.Pixel(a.x+a.width-2,a.y+a.height-2):n)?(a=this.X.getLonLatFromPixel(a),b={x:b.lon,y:a.lat,width:a.lon-b.lon,height:b.lat-a.lat},console.log(b),b):{x:b.lon,y:b.lat}};function Cf(){Id(this)}z(Cf,Hd);Cf.prototype.Fb=aa("map://openlayers/something");Cf.prototype.zc=function(a){return new Bf(a)};Cf.prototype.Wb=function(a){return a instanceof OpenLayers.Map};function Df(a,b){this.T=a;this.S=$c(a.element);this.k=b.popup;R(this.k.element,"z-index",99E3);this.z=[];var c=this;this.T.addHandler("animation",function(){c.I&&c.ab()});b.addHandler("beforePopupHide",function(){c.va==c.I?c.k.clearHideTimer():c.fb(c.va,c.I)})}s=Df.prototype;
	s.ab=function(){var a=this.T.element,b=this.I.Rb,c=$c(b),b=Uc(b,a),a=b.y,b=b.x,d=c.width,f=c.height,c=$c(this.k.element),a={x:b,y:a+f+12};mb(this.k.element,"top-right","top-left");this.T.isFullPage()||(b+c.width>this.S.width&&(mb(this.k.element,"top-left","top-right"),a.x=b+d-c.width),0>a.x&&(a.x=0),a.x+c.width>this.S.width&&(a.x=this.S.width-c.width),a.y+c.height>this.S.height&&(a.y=this.S.height-c.height));this.k.setPosition(a)};s.jc=function(a){this.k.setAnnotation(a);this.ab();this.k.show()};
	s.fb=function(a,b){a?(R(a.qb,"border-color","#fff000"),this.I=a,this.jc(a.C)):delete this.I;b&&R(b.qb,"border-color","#fff")};
	s.J=function(a){var b=a.shapes[0].geometry,c=wb("div","annotorious-ol-boxmarker-outer"),d=wb("div","annotorious-ol-boxmarker-inner");Xc(d,"100%","100%");c.appendChild(d);var b=new OpenSeadragon.Rect(b.x,b.y,b.width,b.height),f={C:a,Rb:c,qb:d},e=this;O(d,"mouseover",function(){e.I||e.fb(f);e.va=f});O(d,"mouseout",function(){delete e.va;e.k.startHideTimer()});this.z.push(f);B.sort.call(this.z,function(a,b){return Bd(b.C.shapes[0])-Bd(a.C.shapes[0])}||Ia);var h=1;C(this.z,function(a){R(a.Rb,"z-index",
	h);h++});this.T.drawer.addOverlay(c,b)};s.A=function(a){var b=Da(this.z,function(b){return b.C==a});b&&(D(this.z,b),this.T.drawer.removeOverlay(b.Rb))};s.t=function(){return Ba(this.z,function(a){console.log(a);return a.C})};s.o=p();s.destroy=function(){var a=this;C(this.z,function(b){a.T.removeOverlay(b.Rb)});this.z=[]};function Ef(a){this.element=a.element;var b=document;b.querySelectorAll&&b.querySelector?b=b.querySelector(".openseadragon-container"):(b=document,b=(b.querySelectorAll&&b.querySelector?b.querySelectorAll(".openseadragon-container"):b.getElementsByClassName?b.getElementsByClassName("openseadragon-container"):tb())[0]);R(b||m,"z-index",0);this.T=a;this.w=new rd;this.ia=[];this.yb=j;this.U=Pd(zf,{Mb:"Click and Drag"});U(this.U,0);this.element.appendChild(this.U);this.popup=new ef(this);this.h=new Df(a,
	this);this.c=Pd(vf,{width:"0",height:"0"});V(this.c,n);this.element.appendChild(this.c);var c=this,a=parseInt(T(c.element,"width"),10),b=parseInt(T(c.element,"height"),10);Xc(c.c,a,b);c.c.width=a;c.c.height=b;a=new uf;a.init(this,this.c);this.ia.push(a);this.v=a;this.editor=new af(this);hf(this,this.c);this.w.addHandler("onSelectionCompleted",function(a){a=a.viewportBounds;c.editor.setPosition(new vd(a.left,a.bottom+4));c.editor.open()});this.w.addHandler("onSelectionCanceled",function(){c.stopSelection()})}
	z(Ef,gf);s=Ef.prototype;s.Z=p();s.N=p();s.destroy=function(){this.h.destroy();delete this.h};s.ba=function(a){R(this.c,"pointer-events","auto");var b=this;V(this.c,j);U(this.U,0.8);window.setTimeout(function(){U(b.U,0)},2E3);a&&(this.eb=a)};s.pc=function(a){this.h.A(a);var b=this.v,c=this;if(b){V(this.c,j);this.h.o(i);var d=this.c.getContext("2d"),f=Ed(a.shapes[0],function(a){return c.ya(a)});b.drawShape(d,f);b=Cd(f).geometry;this.editor.setPosition(new vd(b.x,b.y+b.height+4));this.editor.open(a)}};
	s.ya=function(a){var b=qd(this.element);b.top+=window.pageYOffset;b.left+=window.pageXOffset;var c=new OpenSeadragon.Point(a.x,a.y),a=a.width?new OpenSeadragon.Point(a.x+a.width,a.y+a.height):n,c=this.T.viewport.viewportToWindowCoordinates(c);return a?(a=this.T.viewport.viewportToWindowCoordinates(a),{x:c.x-b.left,y:c.y-b.top,width:a.x-c.x+2,height:a.y-c.y+2}):c};s.t=function(){return this.h.t()};s.ma=p();s.getItem=function(){return{src:"dzi://openseadragon/something"}};s.sb=p();s.la=r("v");
	s.Xb=function(a){var b=qd(this.element);b.top+=window.pageYOffset;b.left+=window.pageXOffset;var c=new OpenSeadragon.Point(a.x+b.left,a.y+b.top),a=a.width?new OpenSeadragon.Point(a.x+b.left+a.width-2,a.y+b.top+a.height-2):n,c=this.T.viewport.windowToViewportCoordinates(c);return a?(a=this.T.viewport.windowToViewportCoordinates(a),{x:c.x,y:c.y,width:a.x-c.x,height:a.y-c.y}):c};function Ff(){Id(this)}z(Ff,Hd);Ff.prototype.Fb=aa("dzi://openseadragon/something");Ff.prototype.zc=function(a){return new Ef(a)};Ff.prototype.Wb=function(a){return!a.id||0!=a.id.indexOf("openseadragon")||!a.hasOwnProperty("drawer")?n:j};function Y(){function a(){Gf(b)}this.Wc=n;this.l=[new yf];window.OpenLayers&&this.l.push(new Cf);window.OpenSeadragon&&this.l.push(new Ff);this.bb=[];var b=this;window.addEventListener?window.addEventListener("load",a,n):window.attachEvent&&window.attachEvent("onload",a)}function Gf(a){a.Wc||(C(a.l,function(a){a.init()}),C(a.bb,function(b){b.initPlugin&&b.initPlugin(a);C(a.l,function(a){a.zb(b)})}),a.Wc=j)}function Z(a,b){return Da(a.l,function(a){return Od(a,b)})}s=Y.prototype;
	s.ba=function(a,b){var c=i,d=i;u(a)?(c=a,d=b):v(a)&&(d=a);if(c){var f=Z(this,c);f&&f.ba(c,d)}else C(this.l,function(a){a.ba(d)})};s.J=function(a,b){var c;c=a.src;if(!(0<c.indexOf("://"))){var d=document.createElement("a");d.href=c;c=d.protocol+"//"+d.host+d.pathname}a.src=c;(c=Z(this,a.src))&&c.J(a,b)};s.addHandler=function(a,b){C(this.l,function(c){c.addHandler(a,b)})};
	s.zb=function(a,b){try{var c=new window.annotorious.plugin[a](b);"complete"==document.readyState?(c.initPlugin&&c.initPlugin(this),C(this.l,function(a){a.zb(c)})):this.bb.push(c)}catch(d){console.log("Could not load plugin: "+a)}};s.destroy=function(a){if(a){var b=Z(this,a);b&&b.destroy(a)}else C(this.l,function(a){a.destroy()})};s.la=function(a){var b=Z(this,a);if(b)return b.la(a)};s.t=function(a){if(a){var b=Z(this,a);return b?b.t(a):[]}var c=[];C(this.l,function(a){Ga(c,a.t())});return c};
	s.ma=function(a){var b=Z(this,a);return b?b.ma(a):[]};s.ea=function(a){if(a){var b=Z(this,a);b&&b.ea(a)}else C(this.l,function(a){a.ea()})};s.N=function(a){if(a){var b=Z(this,a);b&&b.N(a)}else C(this.l,function(a){a.N()})};s.stopSelection=function(a){if(a){var b=Z(this,a);b&&b.stopSelection(a)}else C(this.l,function(a){a.stopSelection()})};s.o=function(a){if(a){var b=Z(this,a.src);b&&b.o(a)}else C(this.l,function(a){a.o()})};
	s.xc=function(a){Gf(this);var b=Da(this.l,function(b){return b.Wb(a)});b?b.xc(a):g("Error: Annotorious does not support this media type in the current version or build configuration.")};s.Sb=function(a){var b=this;C(this.t(a),function(a){b.A(a)})};s.A=function(a){var b=Z(this,a.src);b&&b.A(a)};s.reset=function(){C(this.l,function(a){a.destroy();a.init()})};s.sb=function(a,b){var c=Z(this,a);c&&c.sb(a,b)};s.ga=function(a){C(this.l,function(b){b.ga(a)})};s.ke=function(a){a?this.Z(i):this.N(i)};
	s.Da=function(a){if(a){var b=Z(this,a);b&&b.Da(a)}else C(this.l,function(a){a.Da()})};s.Z=function(a){if(a){var b=Z(this,a);b&&b.Z(a)}else C(this.l,function(a){a.Z()})};window.anno=new Y;Y.prototype.activateSelector=Y.prototype.ba;Y.prototype.addAnnotation=Y.prototype.J;Y.prototype.addHandler=Y.prototype.addHandler;Y.prototype.addPlugin=Y.prototype.zb;Y.prototype.destroy=Y.prototype.destroy;Y.prototype.getActiveSelector=Y.prototype.la;Y.prototype.getAnnotations=Y.prototype.t;Y.prototype.getAvailableSelectors=Y.prototype.ma;Y.prototype.hideAnnotations=Y.prototype.ea;Y.prototype.hideSelectionWidget=Y.prototype.N;Y.prototype.highlightAnnotation=Y.prototype.o;
	Y.prototype.makeAnnotatable=Y.prototype.xc;Y.prototype.removeAll=Y.prototype.Sb;Y.prototype.removeAnnotation=Y.prototype.A;Y.prototype.reset=Y.prototype.reset;Y.prototype.setActiveSelector=Y.prototype.sb;Y.prototype.setProperties=Y.prototype.ga;Y.prototype.showAnnotations=Y.prototype.Da;Y.prototype.showSelectionWidget=Y.prototype.Z;window.annotorious||(window.annotorious={});window.annotorious.plugin||(window.annotorious.plugin={});
	window.annotorious.geometry||(window.annotorious.geometry={},window.annotorious.geometry.expand=Dd,window.annotorious.geometry.getBoundingRect=Cd);Y.prototype.setSelectionEnabled=Y.prototype.ke;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	/*
	 AngularJS v1.7.1
	 (c) 2010-2018 Google, Inc. http://angularjs.org
	 License: MIT
	*/
	(function(n,e){'use strict';function m(d,k,l){var a=l.baseHref(),h=d[0];return function(f,b,c){var d,g;c=c||{};g=c.expires;d=e.isDefined(c.path)?c.path:a;e.isUndefined(b)&&(g="Thu, 01 Jan 1970 00:00:00 GMT",b="");e.isString(g)&&(g=new Date(g));b=encodeURIComponent(f)+"="+encodeURIComponent(b);b=b+(d?";path="+d:"")+(c.domain?";domain="+c.domain:"");b+=g?";expires="+g.toUTCString():"";b+=c.secure?";secure":"";b+=c.samesite?";samesite="+c.samesite:"";c=b.length+1;4096<c&&k.warn("Cookie '"+f+"' possibly not set or overflowed because it was too large ("+
	c+" > 4096 bytes)!");h.cookie=b}}e.module("ngCookies",["ng"]).info({angularVersion:"1.7.1"}).provider("$cookies",[function(){var d=this.defaults={};this.$get=["$$cookieReader","$$cookieWriter",function(k,l){return{get:function(a){return k()[a]},getObject:function(a){return(a=this.get(a))?e.fromJson(a):a},getAll:function(){return k()},put:function(a,h,f){l(a,h,f?e.extend({},d,f):d)},putObject:function(a,d,f){this.put(a,e.toJson(d),f)},remove:function(a,h){l(a,void 0,h?e.extend({},d,h):d)}}}]}]);m.$inject=
	["$document","$log","$browser"];e.module("ngCookies").provider("$$cookieWriter",function(){this.$get=m})})(window,window.angular);
	//# sourceMappingURL=angular-cookies.min.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){
	t.$inject = ["e"];
	e.$inject = ["t", "r", "e", "i"];
	n.$inject = ["s", "o"];
	a.$inject = ["S", "L", "j", "w", "C"];
	r.$inject = ["u", "c"];
	i.$inject = ["s", "o"];
	l.$inject = ["i", "s"];
	u.$inject = ["t"];function t(e){"use strict";var n=e.storageKey(),a=e.storage(),t=function(){var t=e.preferredLanguage();angular.isString(t)?e.use(t):a.put(n,e.use())};t.displayName="fallbackFromIncorrectStorageValue",a?a.get(n)?e.use(a.get(n)).catch(t):t():angular.isString(e.preferredLanguage())&&e.use(e.preferredLanguage())}function e(t,r,e,i){"use strict";var z,c,T,x,F,I,_,n,V,R,D,K,U,M,H,G,q={},Y=[],B=t,J=[],Q="translate-cloak",W=!1,X=!1,Z=".",tt=!1,et=!1,nt=0,at=!0,a="default",s={default:function(t){return(t||"").split("-").join("_")},java:function(t){var e=(t||"").split("-").join("_"),n=e.split("_");return 1<n.length?n[0].toLowerCase()+"_"+n[1].toUpperCase():e},bcp47:function(t){var e=(t||"").split("_").join("-"),n=e.split("-");switch(n.length){case 1:n[0]=n[0].toLowerCase();break;case 2:n[0]=n[0].toLowerCase(),4===n[1].length?n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase():n[1]=n[1].toUpperCase();break;case 3:n[0]=n[0].toLowerCase(),n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase(),n[2]=n[2].toUpperCase();break;default:return e}return n.join("-")},"iso639-1":function(t){return(t||"").split("_").join("-").split("-")[0].toLowerCase()}},o=function(){if(angular.isFunction(i.getLocale))return i.getLocale();var t,e,n=r.$get().navigator,a=["language","browserLanguage","systemLanguage","userLanguage"];if(angular.isArray(n.languages))for(t=0;t<n.languages.length;t++)if((e=n.languages[t])&&e.length)return e;for(t=0;t<a.length;t++)if((e=n[a[t]])&&e.length)return e;return null};o.displayName="angular-translate/service: getFirstBrowserLanguage";var rt=function(){var t=o()||"";return s[a]&&(t=s[a](t)),t};rt.displayName="angular-translate/service: getLocale";var it=function(t,e){for(var n=0,a=t.length;n<a;n++)if(t[n]===e)return n;return-1},st=function(){return this.toString().replace(/^\s+|\s+$/g,"")},f=function(t){return angular.isString(t)?t.toLowerCase():t},ot=function(t){if(t){for(var e,n=[],a=f(t),r=0,i=Y.length;r<i;r++)n.push(f(Y[r]));if(-1<(r=it(n,a)))return Y[r];if(c)for(var s in c)if(c.hasOwnProperty(s)){var o=!1,l=Object.prototype.hasOwnProperty.call(c,s)&&f(s)===f(t);if("*"===s.slice(-1)&&(o=f(s.slice(0,-1))===f(t.slice(0,s.length-1))),(l||o)&&(e=c[s],-1<it(n,f(e))))return e}var u=t.split("_");return 1<u.length&&-1<it(n,f(u[0]))?u[0]:void 0}},lt=function(t,e){if(!t&&!e)return q;if(t&&!e){if(angular.isString(t))return q[t]}else angular.isObject(q[t])||(q[t]={}),angular.extend(q[t],ut(e));return this};this.translations=lt,this.cloakClassName=function(t){return t?(Q=t,this):Q},this.nestedObjectDelimeter=function(t){return t?(Z=t,this):Z};var ut=function(t,e,n,a){var r,i,s;for(r in e||(e=[]),n||(n={}),t)Object.prototype.hasOwnProperty.call(t,r)&&(s=t[r],angular.isObject(s)?ut(s,e.concat(r),n,r):(i=e.length?""+e.join(Z)+Z+r:r,e.length&&r===a&&(n[""+e.join(Z)]="@:"+i),n[i]=s));return n};ut.displayName="flatObject",this.addInterpolation=function(t){return J.push(t),this},this.useMessageFormatInterpolation=function(){return this.useInterpolation("$translateMessageFormatInterpolation")},this.useInterpolation=function(t){return R=t,this},this.useSanitizeValueStrategy=function(t){return e.useStrategy(t),this},this.preferredLanguage=function(t){return t?(ct(t),this):z};var ct=function(t){return t&&(z=t),z};this.translationNotFoundIndicator=function(t){return this.translationNotFoundIndicatorLeft(t),this.translationNotFoundIndicatorRight(t),this},this.translationNotFoundIndicatorLeft=function(t){return t?(U=t,this):U},this.translationNotFoundIndicatorRight=function(t){return t?(M=t,this):M},this.fallbackLanguage=function(t){return ft(t),this};var ft=function(t){return t?(angular.isString(t)?(x=!0,T=[t]):angular.isArray(t)&&(x=!1,T=t),angular.isString(z)&&it(T,z)<0&&T.push(z),this):x?T[0]:T};this.use=function(t){if(t){if(!q[t]&&!D)throw new Error("$translateProvider couldn't find translationTable for langKey: '"+t+"'");return F=t,this}return F},this.resolveClientLocale=function(){return rt()};var gt=function(t){return t?(B=t,this):n?n+B:B};this.storageKey=gt,this.useUrlLoader=function(t,e){return this.useLoader("$translateUrlLoader",angular.extend({url:t},e))},this.useStaticFilesLoader=function(t){return this.useLoader("$translateStaticFilesLoader",t)},this.useLoader=function(t,e){return D=t,K=e||{},this},this.useLocalStorage=function(){return this.useStorage("$translateLocalStorage")},this.useCookieStorage=function(){return this.useStorage("$translateCookieStorage")},this.useStorage=function(t){return _=t,this},this.storagePrefix=function(t){return t?(n=t,this):t},this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog")},this.useMissingTranslationHandler=function(t){return V=t,this},this.usePostCompiling=function(t){return W=!!t,this},this.forceAsyncReload=function(t){return X=!!t,this},this.uniformLanguageTag=function(t){return t?angular.isString(t)&&(t={standard:t}):t={},a=t.standard,this},this.determinePreferredLanguage=function(t){var e=t&&angular.isFunction(t)?t():rt();return z=Y.length&&ot(e)||e,this},this.registerAvailableLanguageKeys=function(t,e){return t?(Y=t,e&&(c=e),this):Y},this.useLoaderCache=function(t){return!1===t?H=void 0:!0===t?H=!0:void 0===t?H="$translationCache":t&&(H=t),this},this.directivePriority=function(t){return void 0===t?nt:(nt=t,this)},this.statefulFilter=function(t){return void 0===t?at:(at=t,this)},this.postProcess=function(t){return G=t||void 0,this},this.keepContent=function(t){return et=!!t,this},this.$get=["$log","$injector","$rootScope","$q",function(t,o,s,m){var i,$,y,b=o.get(R||"$translateDefaultInterpolation"),S=!1,L={},f={},j=function(t,s,o,l,u,c){!F&&z&&(F=z);var a=u&&u!==F?ot(u)||u:F;if(u&&v(u),angular.isArray(t)){return function(t){for(var a={},e=[],n=function(e){var n=m.defer(),t=function(t){a[e]=t,n.resolve([e,t])};return j(e,s,o,l,u,c).then(t,t),n.promise},r=0,i=t.length;r<i;r++)e.push(n(t[r]));return m.all(e).then(function(){return a})}(t)}var e=m.defer();t&&(t=st.apply(t));var n=function(){var t=f[a]||f[z];if($=0,_&&!t){var e=i.get(B);if(t=f[e],T&&T.length){var n=it(T,e);$=0===n?1:0,it(T,z)<0&&T.push(z)}}return t}();if(n){var r=function(){u||(a=F),h(t,s,o,l,a,c).then(e.resolve,e.reject)};r.displayName="promiseResolved",n.finally(r).catch(angular.noop)}else h(t,s,o,l,a,c).then(e.resolve,e.reject);return e.promise},w=function(t){return U&&(t=[U,t].join(" ")),M&&(t=[t,M].join(" ")),t},l=function(t){F=t,_&&i.put(j.storageKey(),F),s.$emit("$translateChangeSuccess",{language:t}),b.setLocale(F);var e=function(t,e){L[e].setLocale(F)};e.displayName="eachInterpolatorLocaleSetter",angular.forEach(L,e),s.$emit("$translateChangeEnd",{language:t})},u=function(n){if(!n)throw"No language key specified for loading.";var a=m.defer();s.$emit("$translateLoadingStart",{language:n}),S=!0;var t=H;"string"==typeof t&&(t=o.get(t));var e=angular.extend({},K,{key:n,$http:angular.extend({},{cache:t},K.$http)}),r=function(t){var e={};s.$emit("$translateLoadingSuccess",{language:n}),angular.isArray(t)?angular.forEach(t,function(t){angular.extend(e,ut(t))}):angular.extend(e,ut(t)),S=!1,a.resolve({key:n,table:e}),s.$emit("$translateLoadingEnd",{language:n})};r.displayName="onLoaderSuccess";var i=function(t){s.$emit("$translateLoadingError",{language:t}),a.reject(t),s.$emit("$translateLoadingEnd",{language:t})};return i.displayName="onLoaderError",o.get(D)(e).then(r,i),a.promise};if(_&&(!(i=o.get(_)).get||!i.put))throw new Error("Couldn't use storage '"+_+"', missing get() or put() method!");if(J.length){var e=function(t){var e=o.get(t);e.setLocale(z||F),L[e.getInterpolationIdentifier()]=e};e.displayName="interpolationFactoryAdder",angular.forEach(J,e)}var c=function(a,r,i,s,o){var l=m.defer(),t=function(t){if(Object.prototype.hasOwnProperty.call(t,r)&&null!==t[r]){s.setLocale(a);var e=t[r];if("@:"===e.substr(0,2))c(a,e.substr(2),i,s,o).then(l.resolve,l.reject);else{var n=s.interpolate(t[r],i,"service",o,r);n=O(r,t[r],n,i,a),l.resolve(n)}s.setLocale(F)}else l.reject()};return t.displayName="fallbackTranslationResolver",function(t){var e=m.defer();if(Object.prototype.hasOwnProperty.call(q,t))e.resolve(q[t]);else if(f[t]){var n=function(t){lt(t.key,t.table),e.resolve(t.table)};n.displayName="translationTableResolver",f[t].then(n,e.reject)}else e.reject();return e.promise}(a).then(t,l.reject),l.promise},g=function(t,e,n,a,r){var i,s=q[t];if(s&&Object.prototype.hasOwnProperty.call(s,e)&&null!==s[e]){if(a.setLocale(t),i=a.interpolate(s[e],n,"filter",r,e),i=O(e,s[e],i,n,t,r),!angular.isString(i)&&angular.isFunction(i.$$unwrapTrustedValue)){var o=i.$$unwrapTrustedValue();if("@:"===o.substr(0,2))return g(t,o.substr(2),n,a,r)}else if("@:"===i.substr(0,2))return g(t,i.substr(2),n,a,r);a.setLocale(F)}return i},C=function(t,e,n,a){return V?o.get(V)(t,F,e,n,a):t},N=function(t,e,n,a,r,i){var s=m.defer();if(t<T.length){var o=T[t];c(o,e,n,a,i).then(function(t){s.resolve(t)},function(){return N(t+1,e,n,a,r,i).then(s.resolve,s.reject)})}else if(r)s.resolve(r);else{var l=C(e,n,r);V&&l?s.resolve(l):s.reject(w(e))}return s.promise},p=function(t,e,n,a,r){var i;if(t<T.length){var s=T[t];(i=g(s,e,n,a,r))||""===i||(i=p(t+1,e,n,a))}return i},h=function(t,e,n,a,r,i){var s,o,l,u,c,f=m.defer(),g=r?q[r]:q,p=n?L[n]:b;if(g&&Object.prototype.hasOwnProperty.call(g,t)&&null!==g[t]){var h=g[t];if("@:"===h.substr(0,2))j(h.substr(2),e,n,a,r,i).then(f.resolve,f.reject);else{var d=p.interpolate(h,e,"service",i,t);d=O(t,h,d,e,r),f.resolve(d)}}else{var v;V&&!S&&(v=C(t,e,a)),r&&T&&T.length?(s=t,o=e,l=p,u=a,c=i,N(0<y?y:$,s,o,l,u,c)).then(function(t){f.resolve(t)},function(t){f.reject(w(t))}):V&&!S&&v?a?f.resolve(a):f.resolve(v):a?f.resolve(a):f.reject(w(t))}return f.promise},d=function(t,e,n,a,r){var i,s=a?q[a]:q,o=b;if(L&&Object.prototype.hasOwnProperty.call(L,n)&&(o=L[n]),s&&Object.prototype.hasOwnProperty.call(s,t)&&null!==s[t]){var l=s[t];"@:"===l.substr(0,2)?i=d(l.substr(2),e,n,a,r):(i=o.interpolate(l,e,"filter",r,t),i=O(t,l,i,e,a,r))}else{var u;V&&!S&&(u=C(t,e,r)),i=a&&T&&T.length?p(($=0)<y?y:$,t,e,o,r):V&&!S&&u?u:w(t)}return i},O=function(t,e,n,a,r,i){var s=G;return s&&("string"==typeof s&&(s=o.get(s)),s)?s(t,e,n,a,r,i):n},v=function(t){q[t]||!D||f[t]||(f[t]=u(t).then(function(t){return lt(t.key,t.table),t}))};j.preferredLanguage=function(t){return t&&ct(t),z},j.cloakClassName=function(){return Q},j.nestedObjectDelimeter=function(){return Z},j.fallbackLanguage=function(t){if(null!=t){if(ft(t),D&&T&&T.length)for(var e=0,n=T.length;e<n;e++)f[T[e]]||(f[T[e]]=u(T[e]));j.use(j.use())}return x?T[0]:T},j.useFallbackLanguage=function(t){if(null!=t)if(t){var e=it(T,t);-1<e&&(y=e)}else y=0},j.proposedLanguage=function(){return I},j.storage=function(){return i},j.negotiateLocale=ot,j.use=function(e){if(!e)return F;var n=m.defer();n.promise.then(null,angular.noop),s.$emit("$translateChangeStart",{language:e});var t=ot(e);return 0<Y.length&&!t?m.reject(e):(t&&(e=t),I=e,!X&&q[e]||!D||f[e]?f[e]?f[e].then(function(t){return I===t.key&&l(t.key),n.resolve(t.key),t},function(t){return!F&&T&&0<T.length&&T[0]!==t?j.use(T[0]).then(n.resolve,n.reject):n.reject(t)}):(n.resolve(e),l(e)):(f[e]=u(e).then(function(t){return lt(t.key,t.table),n.resolve(t.key),I===e&&l(t.key),t},function(t){return s.$emit("$translateChangeError",{language:t}),n.reject(t),s.$emit("$translateChangeEnd",{language:t}),m.reject(t)}),f[e].finally(function(){var t;I===(t=e)&&(I=void 0),f[t]=void 0}).catch(angular.noop)),n.promise)},j.resolveClientLocale=function(){return rt()},j.storageKey=function(){return gt()},j.isPostCompilingEnabled=function(){return W},j.isForceAsyncReloadEnabled=function(){return X},j.isKeepContent=function(){return et},j.refresh=function(t){if(!D)throw new Error("Couldn't refresh translation table, no loader registered!");s.$emit("$translateRefreshStart",{language:t});var e=m.defer(),n={};function a(e){var t=u(e);return(f[e]=t).then(function(t){q[e]={},lt(e,t.table),n[e]=!0},angular.noop),t}if(e.promise.then(function(){for(var t in q)q.hasOwnProperty(t)&&(t in n||delete q[t]);F&&l(F)},angular.noop).finally(function(){s.$emit("$translateRefreshEnd",{language:t})}),t)q[t]?a(t).then(e.resolve,e.reject):e.reject();else{var r=T&&T.slice()||[];F&&-1===r.indexOf(F)&&r.push(F),m.all(r.map(a)).then(e.resolve,e.reject)}return e.promise},j.instant=function(t,e,n,a,r){var i=a&&a!==F?ot(a)||a:F;if(null===t||angular.isUndefined(t))return t;if(a&&v(a),angular.isArray(t)){for(var s={},o=0,l=t.length;o<l;o++)s[t[o]]=j.instant(t[o],e,n,a,r);return s}if(angular.isString(t)&&t.length<1)return t;t&&(t=st.apply(t));var u,c,f=[];z&&f.push(z),i&&f.push(i),T&&T.length&&(f=f.concat(T));for(var g=0,p=f.length;g<p;g++){var h=f[g];if(q[h]&&void 0!==q[h][t]&&(u=d(t,e,n,i,r)),void 0!==u)break}u||""===u||(U||M?u=w(t):(u=b.interpolate(t,e,"filter",r),V&&!S&&(c=C(t,e,r)),V&&!S&&c&&(u=c)));return u},j.versionInfo=function(){return"2.18.1"},j.loaderCache=function(){return H},j.directivePriority=function(){return nt},j.statefulFilter=function(){return at},j.isReady=function(){return tt};var n=m.defer();n.promise.then(function(){tt=!0}),j.onReady=function(t){var e=m.defer();return angular.isFunction(t)&&e.promise.then(t),tt?e.resolve():n.promise.then(e.resolve),e.promise},j.getAvailableLanguageKeys=function(){return 0<Y.length?Y:null},j.getTranslationTable=function(t){return(t=t||j.use())&&q[t]?angular.copy(q[t]):null};var a=s.$on("$translateReady",function(){n.resolve(),a(),a=null}),r=s.$on("$translateChangeEnd",function(){n.resolve(),r(),r=null});if(D){if(angular.equals(q,{})&&j.use()&&j.use(j.use()),T&&T.length)for(var E=function(t){return lt(t.key,t.table),s.$emit("$translateChangeEnd",{language:t.key}),t},k=0,P=T.length;k<P;k++){var A=T[k];!X&&q[A]||(f[A]=u(A).then(E))}}else s.$emit("$translateReady",{language:j.use()});return j}]}function n(s,o){"use strict";var t={};return t.setLocale=function(t){t},t.getInterpolationIdentifier=function(){return"default"},t.useSanitizeValueStrategy=function(t){return o.useStrategy(t),this},t.interpolate=function(t,e,n,a,r){var i;return e=e||{},e=o.sanitize(e,"params",a,n),angular.isNumber(t)?i=""+t:angular.isString(t)?(i=s(t)(e),i=o.sanitize(i,"text",a,n)):i="",i},t}function a(S,L,j,w,C){"use strict";var N=function(t){return angular.isString(t)?t.toLowerCase():t};return{restrict:"AE",scope:!0,priority:S.directivePriority(),compile:function(t,h){var d=h.translateValues?h.translateValues:void 0,v=h.translateInterpolation?h.translateInterpolation:void 0,m=h.translateSanitizeStrategy?h.translateSanitizeStrategy:void 0,$=t[0].outerHTML.match(/translate-value-+/i),y="^(.*)("+L.startSymbol()+".*"+L.endSymbol()+")(.*)",b="^(.*)"+L.startSymbol()+"(.*)"+L.endSymbol()+"(.*)";return function(r,l,u){r.interpolateParams={},r.preText="",r.postText="",r.translateNamespace=function t(e){if(e.translateNamespace)return e.translateNamespace;if(e.$parent)return t(e.$parent)}(r);var i={},s=function(t){if(angular.isFunction(s._unwatchOld)&&(s._unwatchOld(),s._unwatchOld=void 0),angular.equals(t,"")||!angular.isDefined(t)){var e=function(){return this.toString().replace(/^\s+|\s+$/g,"")}.apply(l.text()),n=e.match(y);if(angular.isArray(n)){r.preText=n[1],r.postText=n[3],i.translate=L(n[2])(r.$parent);var a=e.match(b);angular.isArray(a)&&a[2]&&a[2].length&&(s._unwatchOld=r.$watch(a[2],function(t){i.translate=t,c()}))}else i.translate=e||void 0}else i.translate=t;c()},t=function(e){u.$observe(e,function(t){i[e]=t,c()})};!function(t,e,n){if(e.translateValues&&angular.extend(t,w(e.translateValues)(r.$parent)),$)for(var a in n)Object.prototype.hasOwnProperty.call(e,a)&&"translateValue"===a.substr(0,14)&&"translateValues"!==a&&(t[N(a.substr(14,1))+a.substr(15)]=n[a])}(r.interpolateParams,u,h);var e=!0;for(var n in u.$observe("translate",function(t){void 0===t?s(""):""===t&&e||(i.translate=t,c()),e=!1}),u)u.hasOwnProperty(n)&&"translateAttr"===n.substr(0,13)&&13<n.length&&t(n);if(u.$observe("translateDefault",function(t){r.defaultText=t,c()}),m&&u.$observe("translateSanitizeStrategy",function(t){r.sanitizeStrategy=w(t)(r.$parent),c()}),d&&u.$observe("translateValues",function(t){t&&r.$parent.$watch(function(){angular.extend(r.interpolateParams,w(t)(r.$parent))})}),$){var a=function(n){u.$observe(n,function(t){var e=N(n.substr(14,1))+n.substr(15);r.interpolateParams[e]=t})};for(var o in u)Object.prototype.hasOwnProperty.call(u,o)&&"translateValue"===o.substr(0,14)&&"translateValues"!==o&&a(o)}var c=function(){for(var t in i)i.hasOwnProperty(t)&&void 0!==i[t]&&f(t,i[t],r,r.interpolateParams,r.defaultText,r.translateNamespace)},f=function(e,t,n,a,r,i){t?(i&&"."===t.charAt(0)&&(t=i+t),S(t,a,v,r,n.translateLanguage,n.sanitizeStrategy).then(function(t){g(t,n,!0,e)},function(t){g(t,n,!1,e)})):g(t,n,!1,e)},g=function(t,e,n,a){if(n||void 0!==e.defaultText&&(t=e.defaultText),"translate"===a){(n||!n&&!S.isKeepContent()&&void 0===u.translateKeepContent)&&l.empty().append(e.preText+t+e.postText);var r=S.isPostCompilingEnabled(),i=void 0!==h.translateCompile,s=i&&"false"!==h.translateCompile;(r&&!i||s)&&j(l.contents())(e)}else{var o=u.$attr[a];"data-"===o.substr(0,5)&&(o=o.substr(5)),o=o.substr(15),l.attr(o,t)}};(d||$||u.translateDefault)&&r.$watch("interpolateParams",c,!0),r.$on("translateLanguageChanged",c);var p=C.$on("$translateChangeSuccess",c);l.text().length?u.translate?s(u.translate):s(""):u.translate&&s(u.translate),c(),r.$on("$destroy",p)}}}}function r(u,c){"use strict";return{restrict:"A",priority:u.directivePriority(),link:function(n,a,r){var i,s,o,l={},t=function(){angular.forEach(i,function(t,e){t&&(l[e]=!0,n.translateNamespace&&"."===t.charAt(0)&&(t=n.translateNamespace+t),u(t,s,r.translateInterpolation,void 0,n.translateLanguage,o).then(function(t){a.attr(e,t)},function(t){a.attr(e,t)}))}),angular.forEach(l,function(t,e){i[e]||(a.removeAttr(e),delete l[e])})};f(n,r.translateAttr,function(t){i=t},t),f(n,r.translateValues,function(t){s=t},t),f(n,r.translateSanitizeStrategy,function(t){o=t},t),r.translateValues&&n.$watch(r.translateValues,t,!0),n.$on("translateLanguageChanged",t);var e=c.$on("$translateChangeSuccess",t);t(),n.$on("$destroy",e)}}}function f(t,e,n,a){"use strict";e&&("::"===e.substr(0,2)?e=e.substr(2):t.$watch(e,function(t){n(t),a()},!0),n(t.$eval(e)))}function i(s,o){"use strict";return{compile:function(t){var i=function(t){t.addClass(s.cloakClassName())};return i(t),function(t,e,n){var a=function(t){t.removeClass(s.cloakClassName())}.bind(this,e),r=i.bind(this,e);n.translateCloak&&n.translateCloak.length?(n.$observe("translateCloak",function(t){s(t).then(a,r)}),o.$on("$translateChangeSuccess",function(){s(n.translateCloak).then(a,r)})):s.onReady(a)}}}}function s(){"use strict";return{restrict:"A",scope:!0,compile:function(){return{pre:function(t,e,n){t.translateNamespace=function t(e){if(e.translateNamespace)return e.translateNamespace;if(e.$parent)return t(e.$parent)}(t),t.translateNamespace&&"."===n.translateNamespace.charAt(0)?t.translateNamespace+=n.translateNamespace:t.translateNamespace=n.translateNamespace}}}}}function o(){"use strict";return{restrict:"A",scope:!0,compile:function(){return function(e,t,n){n.$observe("translateLanguage",function(t){e.translateLanguage=t}),e.$watch("translateLanguage",function(){e.$broadcast("translateLanguageChanged")})}}}}function l(i,s){"use strict";var t=function(t,e,n,a){if(!angular.isObject(e)){var r=this||{__SCOPE_IS_NOT_AVAILABLE:"More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"};e=i(e)(r)}return s.instant(t,e,n,a)};return s.statefulFilter()&&(t.$stateful=!0),t}function u(t){"use strict";return t("translations")}return t.$inject=["$translate"],e.$inject=["$STORAGE_KEY","$windowProvider","$translateSanitizationProvider","pascalprechtTranslateOverrider"],n.$inject=["$interpolate","$translateSanitization"],a.$inject=["$translate","$interpolate","$compile","$parse","$rootScope"],r.$inject=["$translate","$rootScope"],i.$inject=["$translate","$rootScope"],l.$inject=["$parse","$translate"],u.$inject=["$cacheFactory"],angular.module("pascalprecht.translate",["ng"]).run(t),t.displayName="runTranslate",angular.module("pascalprecht.translate").provider("$translateSanitization",function(){"use strict";var n,a,g,p=null,h=!1,d=!1;(g={sanitize:function(t,e){return"text"===e&&(t=i(t)),t},escape:function(t,e){return"text"===e&&(t=r(t)),t},sanitizeParameters:function(t,e){return"params"===e&&(t=o(t,i)),t},escapeParameters:function(t,e){return"params"===e&&(t=o(t,r)),t},sce:function(t,e,n){return"text"===e?t=s(t):"params"===e&&"filter"!==n&&(t=o(t,r)),t},sceParameters:function(t,e){return"params"===e&&(t=o(t,s)),t}}).escaped=g.escapeParameters,this.addStrategy=function(t,e){return g[t]=e,this},this.removeStrategy=function(t){return delete g[t],this},this.useStrategy=function(t){return h=!0,p=t,this},this.$get=["$injector","$log",function(u,c){var e,f={};return u.has("$sanitize")&&(n=u.get("$sanitize")),u.has("$sce")&&(a=u.get("$sce")),{useStrategy:(e=this,function(t){e.useStrategy(t)}),sanitize:function(t,e,n,a){if(p||h||d||(c.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."),d=!0),n||null===n||(n=p),!n)return t;a||(a="service");var r,i,s,o,l=angular.isArray(n)?n:[n];return r=t,i=e,s=a,o=l,angular.forEach(o,function(e){if(angular.isFunction(e))r=e(r,i,s);else if(angular.isFunction(g[e]))r=g[e](r,i,s);else{if(!angular.isString(g[e]))throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'");if(!f[g[e]])try{f[g[e]]=u.get(g[e])}catch(t){throw f[g[e]]=function(){},new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'")}r=f[g[e]](r,i,s)}}),r}}}];var r=function(t){var e=angular.element("<div></div>");return e.text(t),e.html()},i=function(t){if(!n)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");return n(t)},s=function(t){if(!a)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");return a.trustAsHtml(t)},o=function(t,n,a){if(angular.isDate(t))return t;if(angular.isObject(t)){var r=angular.isArray(t)?[]:{};if(a){if(-1<a.indexOf(t))throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object")}else a=[];return a.push(t),angular.forEach(t,function(t,e){angular.isFunction(t)||(r[e]=o(t,n,a))}),a.splice(-1,1),r}return angular.isNumber(t)?t:!0===t||!1===t?t:angular.isUndefined(t)||null===t?t:n(t)}}),angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider",{}).provider("$translate",e),e.displayName="displayName",angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation",n),n.displayName="$translateDefaultInterpolation",angular.module("pascalprecht.translate").constant("$STORAGE_KEY","NG_TRANSLATE_LANG_KEY"),angular.module("pascalprecht.translate").directive("translate",a),a.displayName="translateDirective",angular.module("pascalprecht.translate").directive("translateAttr",r),r.displayName="translateAttrDirective",angular.module("pascalprecht.translate").directive("translateCloak",i),i.displayName="translateCloakDirective",angular.module("pascalprecht.translate").directive("translateNamespace",s),s.displayName="translateNamespaceDirective",angular.module("pascalprecht.translate").directive("translateLanguage",o),o.displayName="translateLanguageDirective",angular.module("pascalprecht.translate").filter("translate",l),l.displayName="translateFilterFactory",angular.module("pascalprecht.translate").factory("$translationCache",u),u.displayName="$translationCache","pascalprecht.translate"});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){
	t.$inject = ["t"];function t(t){"use strict";var n;if(1===angular.version.major&&4<=angular.version.minor){var o=t.get("$cookies");n={get:function(t){return o.get(t)},put:function(t,e){o.put(t,e)}}}else{var r=t.get("$cookieStore");n={get:function(t){return r.get(t)},put:function(t,e){r.put(t,e)}}}return{get:function(t){return n.get(t)},set:function(t,e){n.put(t,e)},put:function(t,e){n.put(t,e)}}}return t.$inject=["$injector"],angular.module("pascalprecht.translate").factory("$translateCookieStorage",t),t.displayName="$translateCookieStorage","pascalprecht.translate"});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return e()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){
	t.$inject = ["a", "t"];function t(a,t){"use strict";var o,e={get:function(t){return o||(o=a.localStorage.getItem(t)),o},set:function(t,e){o=e,a.localStorage.setItem(t,e)},put:function(t,e){o=e,a.localStorage.setItem(t,e)}},r="localStorage"in a;if(r){var n="pascalprecht.translate.storageTest";try{null!==a.localStorage?(a.localStorage.setItem(n,"foo"),a.localStorage.removeItem(n),r=!0):r=!1}catch(t){r=!1}}return r?e:t}return t.$inject=["$window","$translateCookieStorage"],angular.module("pascalprecht.translate").factory("$translateLocalStorage",t),t.displayName="$translateLocalStorageFactory","pascalprecht.translate"});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	!function(e,i){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return i()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=i():i()}(0,function(){
	e.$inject = ["n", "a"];function e(n,a){"use strict";return function(r){if(!(r&&(angular.isArray(r.files)||angular.isString(r.prefix)&&angular.isString(r.suffix))))throw new Error("Couldn't load static files, no files and prefix or suffix specified!");r.files||(r.files=[{prefix:r.prefix,suffix:r.suffix}]);for(var e=function(e){if(!e||!angular.isString(e.prefix)||!angular.isString(e.suffix))throw new Error("Couldn't load static file, no prefix or suffix specified!");var i=[e.prefix,r.key,e.suffix].join("");return angular.isObject(r.fileMap)&&r.fileMap[i]&&(i=r.fileMap[i]),a(angular.extend({url:i,method:"GET"},r.$http)).then(function(e){return e.data},function(){return n.reject(r.key)})},i=[],t=r.files.length,f=0;f<t;f++)i.push(e({prefix:r.files[f].prefix,key:r.key,suffix:r.files[f].suffix}));return n.all(i).then(function(e){for(var i=e.length,r={},t=0;t<i;t++)for(var f in e[t])r[f]=e[t][f];return r})}}return e.$inject=["$q","$http"],angular.module("pascalprecht.translate").factory("$translateStaticFilesLoader",e),e.displayName="$translateStaticFilesLoader","pascalprecht.translate"});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(90)();
	// imports


	// module
	exports.push([module.id, ".annotorious-opacity-fade{-moz-transition-property:opacity;-moz-transition-duration:.5s;-moz-transition-delay:0s;-webkit-transition-property:opacity;-webkit-transition-duration:.5s;-webkit-transition-delay:0s;-o-transition-property:opacity;-o-transition-duration:.5s;-o-transition-delay:0s;transition-property:opacity;transition-duration:.5s;transition-delay:0s}.annotorious-item-focus{opacity:1}.annotorious-item-unfocus{opacity:.4}.annotorious-hint-msg{background-color:rgba(0,0,0,.5);margin:4px;padding:8px 15px 8px 30px;font-family:lucida grande,tahoma,verdana,arial,sans-serif;line-height:normal;font-size:12px;color:#fff;border-radius:4px;-moz-border-radius:4px;-webkit-border-radius:4px;-khtml-border-radius:4px}.annotorious-hint-icon{position:absolute;top:6px;left:5px;background:url(" + __webpack_require__(101) + ");background-repeat:no-repeat;width:19px;height:22px;margin:2px 4px 0 6px}.annotorious-popup{line-height:135%;font-family:Arial,Verdana,Sans;font-size:12px;color:#000;background-color:#fff;border:1px solid #ccc;padding:9px 8px;word-wrap:break-word;width:180px;border-radius:3px;-moz-border-radius:3px;-webkit-border-radius:3px;-khtml-border-radius:3px;box-shadow:0 5px 15px #111;-moz-transition-property:opacity;-moz-transition-duration:.5s;-moz-transition-delay:0s;-webkit-transition-property:opacity;-webkit-transition-duration:.5s;-webkit-transition-delay:0s;-o-transition-property:opacity;-o-transition-duration:.5s;-o-transition-delay:0s;transition-property:opacity;transition-duration:.5s;transition-delay:0s}.annotorious-popup-empty{color:#999;font-style:italic}.annotorious-popup-buttons{float:right;margin:0 0 1px 10px;height:16px;-moz-transition-duration:1s;-webkit-transition-duration:1s;-o-transition-duration:1s;transition-duration:1s}.annotorious-popup-button,.annotorious-popup-buttons{-moz-transition-property:opacity;-moz-transition-delay:0s;-webkit-transition-property:opacity;-webkit-transition-delay:0s;-o-transition-property:opacity;-o-transition-delay:0s;transition-property:opacity;transition-delay:0s}.annotorious-popup-button{font-size:10px;text-decoration:none;display:inline-block;color:#000;font-weight:700;margin-left:5px;opacity:.4;-moz-transition-duration:.5s;-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}.annotorious-popup-button:hover{background-color:transparent}.annotorious-popup-button-active{opacity:.9}.annotorious-popup-button-edit{background:url(" + __webpack_require__(102) + ");width:16px;height:16px;text-indent:100px;overflow:hidden}.annotorious-popup-button-delete{background:url(" + __webpack_require__(103) + ");width:16px;height:16px;text-indent:100px;overflow:hidden;float:right}.annotorious-popup-field{border-top:1px solid #ccc;margin:6px 0 0;padding-top:2px}.annotorious-editor{line-height:normal;padding:0 0 2px;background-color:#f2f2f2;color:#000;opacity:.97;border:1px solid #ccc;border-radius:3px;-moz-border-radius:3px;-webkit-border-radius:3px;-khtml-border-radius:3px;box-shadow:0 5px 15px #111}.annotorious-editor-text{border-width:0 0 1px;border-style:solid;border-color:#ccc;line-height:normal;background-color:#fff;width:240px;height:50px;outline:none;font-family:Verdana,Arial;font-size:11px;padding:4px;margin:0;color:#000;text-shadow:none;overflow-y:auto;display:block}.annotorious-editor-button-container{padding-top:2px}.annotorious-editor-button{float:right;line-height:normal;display:inline-block;text-align:center;text-decoration:none;font-family:Verdana,Arial;font-size:10px;border:1px solid #777;color:#ddd;padding:3px 8px;margin:1px 2px 0 1px;cursor:pointer;cursor:hand;background:-moz-linear-gradient(top,#888,#555);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#888888\",endColorstr=\"#555555\");border-radius:2px}.annotorious-editor-button:hover{background:#999}.annotorious-editor-field{border-bottom:1px solid #ccc;margin:0;background-color:#fff;padding:3px;font-family:Verdana,Arial;font-size:12px}.annotorious-ol-boxmarker-outer{border:1px solid #000}.annotorious-ol-boxmarker-inner{border:1px solid #fff;-ms-box-sizing:border-box;box-sizing:border-box}.annotorious-ol-hint{line-height:normal;font-family:Arial,Verdana,Sans;font-size:16px;color:#000;background-color:#fff;margin:0;padding:9px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-khtml-border-radius:5px}.annotorious-ol-hint-secondary{background-color:#fff000}canvas{z-index:2}canvas.hidden{z-index:-1;visibility:hidden}html.hasTouch .annotator-viewer li .annotator-controls{opacity:1}", ""]);

	// exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./bower_components/annotorious/css/feather_icon.png";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./bower_components/annotorious/css/pencil.png";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./bower_components/annotorious/css/delete.png";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology", ['ngMaterial', 'ui.router', 'firebase', 'ngSanitize', '720kb.socialshare', 'ngFileUpload', 'angular-timeline', 'angulartics', 'angulartics.google.analytics', 'ngCookies', 'pascalprecht.translate']);

	app.constant("CLOUDINARY_CONFIGS", {
	  UPLOAD_PRESET: 'k3zqtmgp',
	  UPLOAD_URL: 'https://api.cloudinary.com/v1_1/doyeq9idz/image/upload',
	  IMAGE_BASE_URL: 'https://res-4.cloudinary.com/doyeq9idz/image/upload'
	});

	app.constant('VAPID_PUBLIC_KEY', {
	  STRING: 'BCl283ur-v-hemp5ikrzX3w3n9Jg2ywjEtf-a2x19fchhizC6Plby5gBde7YGW4Vz9oS_poxW7IGhTTWoFfyHZs=',
	  ARRAY: new Uint8Array([4, 41, 118, 243, 123, 171, 250, 255, 161, 122, 106, 121, 138, 74, 243, 95, 124, 55, 159, 210, 96, 219, 44, 35, 18, 215, 254, 107, 108, 117, 245, 247, 33, 134, 44, 194, 232, 249, 91, 203, 152, 1, 117, 238, 216, 25, 110, 21, 207, 218, 18, 254, 154, 49, 91, 178, 6, 133, 52, 214, 160, 87, 242, 29, 155])
	});

	app.config(["$mdThemingProvider", "$mdIconProvider", "$translateProvider", function($mdThemingProvider, $mdIconProvider, $translateProvider) {
	  $mdIconProvider.defaultIconSet("./assets/svg/avatars.svg", 128).icon("menu", "./assets/svg/menu.svg", 24).icon("share", "./assets/svg/share.svg", 24).icon("google_plus", "./assets/svg/google_plus.svg", 512).icon("hangouts", "./assets/svg/hangouts.svg", 512).icon("twitter", "./assets/svg/twitter.svg", 512).icon("phone", "./assets/svg/phone.svg", 512);
	  $mdThemingProvider.theme('default').primaryPalette('blue').accentPalette('red');
	  $translateProvider.useStaticFilesLoader({
	    prefix: 'assets/i18n/locale-',
	    suffix: '.json'
	  });
	  $translateProvider.registerAvailableLanguageKeys(['en', 'ja'], {
	    'en_*': 'en',
	    'ja_*': 'ja'
	  });
	  $translateProvider.preferredLanguage('en');
	  $translateProvider.fallbackLanguage('ja');
	  $translateProvider.useLocalStorage();
	  return $translateProvider.useSanitizeValueStrategy(null);
	}]);

	app.run(["$rootScope", "$state", "$location", function($rootScope, $state, $location) {
	  return $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
	    var location;
	    if (error === "AUTH_REQUIRED") {
	      location = $location.path();
	      return $state.go('signin', {
	        redirect: location
	      });
	    }
	  });
	}]);

	app.config(["$stateProvider", "$urlRouterProvider", function($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('dashboard', {
	    url: '/dashboard',
	    abstract: true,
	    controller: 'DashboardCtrl',
	    templateUrl: 'templates/dashboard.html',
	    resolve: {
	      currentAuth: ["$firebaseAuth", function($firebaseAuth) {
	        return $firebaseAuth().$requireSignIn();
	      }]
	    }
	  });
	  $stateProvider.state('dashboard.introduction', {
	    url: '/introduction',
	    controller: 'IntroCtrl',
	    templateUrl: 'templates/introduction.html'
	  });
	  $stateProvider.state('dashboard.home', {
	    url: '',
	    controller: 'HomeCtrl',
	    templateUrl: 'templates/home.html'
	  });
	  $stateProvider.state('dashboard.guideline', {
	    url: '/guideline',
	    controller: 'GuidelineCtrl',
	    templateUrl: 'templates/guideline.html'
	  });
	  $stateProvider.state('dashboard.credit', {
	    url: '/credit',
	    controller: 'CreditCtrl',
	    templateUrl: 'templates/credit.html'
	  });
	  $stateProvider.state('dashboard.entries', {
	    url: '/entries/:stage',
	    controller: 'EntriesCtrl',
	    templateUrl: 'templates/entries.html'
	  });
	  $stateProvider.state('dashboard.profile', {
	    url: '/profile',
	    controller: 'ProfileCtrl',
	    templateUrl: 'templates/profile.html'
	  });
	  $stateProvider.state('dashboard.learn', {
	    url: '/learn',
	    controller: 'LearnCtrl',
	    templateUrl: 'templates/kula/learn.html'
	  });
	  $stateProvider.state('dashboard.lesson', {
	    url: '/lesson/:id',
	    controller: 'LessonCtrl',
	    templateUrl: 'templates/kula/lesson.html'
	  });
	  $stateProvider.state('dashboard.lesson.char', {
	    url: '/:char_id',
	    controller: 'CharCtrl',
	    templateUrl: 'templates/kula/char.html'
	  });
	  $stateProvider.state('dashboard.connect', {
	    url: '/connect',
	    controller: 'ConnectCtrl',
	    templateUrl: 'templates/connect.html'
	  });
	  $stateProvider.state('dashboard.post', {
	    url: '/post/:post_id',
	    controller: 'PostCtrl',
	    templateUrl: 'templates/post-single.html',
	    resolve: {
	      post: ["$stateParams", "PostFactory", function($stateParams, PostFactory) {
	        return PostFactory.get($stateParams.post_id).$loaded();
	      }]
	    }
	  });
	  $stateProvider.state('dashboard.connect.timeline', {
	    url: '/',
	    controller: 'ConnectCtrl',
	    templateUrl: 'templates/connect.html'
	  });
	  $stateProvider.state('dashboard.editing', {
	    url: '/editing',
	    controller: 'EditingListCtrl',
	    templateUrl: 'templates/editing_list.html'
	  });
	  $stateProvider.state('dashboard.personal', {
	    url: '/personal',
	    controller: 'PersonalCtrl',
	    templateUrl: 'templates/personal.html'
	  });
	  $stateProvider.state('dashboard.personal.fav-list', {
	    url: '/fav-list',
	    controller: 'FavListCtrl',
	    templateUrl: 'templates/partial/fav-list.html'
	  });
	  $stateProvider.state('dashboard.personal.history', {
	    url: '/history',
	    controller: 'PersonalHistoryCtrl',
	    templateUrl: 'templates/partial/history.html'
	  });
	  $stateProvider.state('signin', {
	    url: '/sign_in?redirect',
	    controller: 'SignInCtrl as signin',
	    templateUrl: 'templates/sign_in.html'
	  });
	  $stateProvider.state('dashboard.quakes', {
	    url: '/quakes',
	    controller: 'QuakesCtrl',
	    templateUrl: 'templates/quakes.html'
	  });
	  $stateProvider.state('dashboard.forum', {
	    url: '/forum',
	    controller: 'ForumCtrl',
	    templateUrl: 'templates/forum.html'
	  });
	  $stateProvider.state('dashboard.discussion', {
	    url: '/discussion/:id',
	    controller: 'DiscussionCtrl',
	    templateUrl: 'templates/discussion.html',
	    resolve: {
	      discussion: ["$stateParams", "DiscussionFactory", function($stateParams, DiscussionFactory) {
	        return DiscussionFactory.get($stateParams.id).$loaded();
	      }]
	    }
	  });
	  $stateProvider.state('transcription', {
	    url: '/transcription/:id?:ref',
	    abstract: true,
	    templateUrl: 'templates/transcription.html',
	    controller: 'TranscriptionCtrl',
	    resolve: {
	      currentAuth: ["$firebaseAuth", function($firebaseAuth) {
	        return $firebaseAuth().$requireSignIn();
	      }],
	      book: ["$stateParams", "Books", function($stateParams, Books) {
	        return Books.get($stateParams.id);
	      }],
	      transcriptionList: ["$stateParams", "Transcription", function($stateParams, Transcription) {
	        return Transcription.getList($stateParams.id);
	      }]
	    }
	  });
	  $stateProvider.state('transcription.content', {
	    url: '/:content',
	    views: {
	      content: {
	        templateUrl: 'templates/transcription/content.html',
	        controller: 'TranscriptionContentCtrl'
	      },
	      content_status: {
	        templateUrl: 'templates/transcription/content_status.html',
	        controller: 'TranscriptionContentStatusCtrl'
	      },
	      action_buttons: {
	        templateUrl: 'templates/transcription/action_buttons.html',
	        controller: 'TranscriptionActionButtonsCtrl'
	      }
	    },
	    resolve: {
	      transcription: ["$stateParams", "Transcription", function($stateParams, Transcription) {
	        return Transcription.get($stateParams.id, parseInt($stateParams.content) - 1);
	      }]
	    }
	  });
	  $stateProvider.state('transcription.content.view', {
	    url: '/view',
	    controller: 'TranscriptionEditorCtrl',
	    templateUrl: 'templates/transcription/view.html'
	  });
	  $stateProvider.state('transcription.content.input', {
	    url: '/input',
	    controller: 'TranscriptionInputCtrl',
	    templateUrl: 'templates/transcription/input.html'
	  });
	  $stateProvider.state('transcription.content.notes', {
	    url: '/notes',
	    controller: 'TranscriptionNotesCtrl',
	    templateUrl: 'templates/transcription/notes.html'
	  });
	  $stateProvider.state('transcription.content.history', {
	    url: '/history',
	    templateUrl: 'templates/transcription/history.html',
	    controller: 'TranscriptionHistoryCtrl'
	  });
	  $stateProvider.state('transcription.content.legends', {
	    url: '/legends',
	    controller: 'TranscriptionEditorCtrl',
	    templateUrl: 'templates/transcription/legends.html'
	  });
	  return $urlRouterProvider.otherwise("/dashboard");
	}]);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./book_controllers.coffee": 106,
		"./connect_controllers.coffee": 107,
		"./controllers.coffee": 108,
		"./learn_controllers.coffee": 109,
		"./partial_controllers.coffee": 110,
		"./personal_controllers.coffee": 111,
		"./transcription_controllers.coffee": 112
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 105;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("BookDialogCtrl", ["$scope", "Books", "book", function($scope, Books, book) {
	  console.log(book);
	  return $scope.book = book;
	}]);


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("ConnectCtrl", ["$scope", "$state", "$window", "$mdDialog", "PostFactory", "Users", "CurrentUser", "$firebaseObject", "CLOUDINARY_CONFIGS", function($scope, $state, $window, $mdDialog, PostFactory, Users, CurrentUser, $firebaseObject, CLOUDINARY_CONFIGS) {
	  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL;
	  $scope.currentUser = CurrentUser.get();
	  $scope.moment = $window.moment;
	  $scope.objSize = function(obj) {
	    if (!obj) {
	      return 0;
	    }
	    return Object.keys(obj).length;
	  };
	  $scope.posts = PostFactory.getScroll();
	  $scope.posts.$loaded(function() {
	    var i, len, p, ref, results;
	    ref = $scope.posts;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      p = ref[i];
	      results.push(p.visibleCommentCount = 3);
	    }
	    return results;
	  });
	  $scope.loadMore = function(count) {
	    if (count == null) {
	      count = 10;
	    }
	    return $scope.posts.$ref().scroll.next(count);
	  };
	  $scope.loadMore();
	  $scope.users = Users;
	  $scope.showMoreComments = function(post) {
	    post.visibleCommentCount || (post.visibleCommentCount = 3);
	    return post.visibleCommentCount += 3;
	  };
	  $scope.openPhotoModal = function(id) {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.id = id;
	      }],
	      templateUrl: 'templates/dialogs/image.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	  $scope.openThumbnailModal = function(img) {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        $scope.img = img;
	        return console.log(img);
	      }],
	      templateUrl: 'templates/dialogs/thumbnail.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	  $scope.sendComment = function(post) {
	    if (!(post.newComment.text.length > 0)) {
	      return;
	    }
	    return post.addComment(post.newComment).then(function() {
	      return post.newComment = {};
	    });
	  };
	  $scope.selectCommentFiles = function(files, post) {
	    var comment, file, i, len;
	    comment = post.newComment;
	    comment.images || (comment.images = []);
	    for (i = 0, len = files.length; i < len; i++) {
	      file = files[i];
	      if (comment.images.length >= 2) {
	        return alert('添付できる写真は2枚までです。');
	      }
	      comment.images.push(file);
	    }
	  };
	  $scope.removePost = function(post, ev) {
	    var confirm;
	    if (post.uid !== $scope.currentUser.$id) {
	      return;
	    }
	    confirm = $mdDialog.confirm().title('投稿の削除').textContent('この投稿を削除します。よろしいですか？').ariaLabel('removing post').targetEvent(ev).ok('削除').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      return post.$remove();
	    });
	  };
	  $scope.removeComment = function(post, key, ev) {
	    var confirm;
	    confirm = $mdDialog.confirm().title('コメントの削除').textContent('このコメントを削除します。よろしいですか？').ariaLabel('removing comment').targetEvent(ev).ok('削除').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      return post.removeComment(key);
	    });
	  };
	  $scope.initNewPost = function() {
	    $scope.newPost = {
	      text: "",
	      images: [],
	      category: $scope.postCategories[0].value
	    };
	    $scope.imagesToUpload = [];
	    $window.post = $scope.newPost;
	    return $scope.uploading = false;
	  };
	  $scope.postCategories = [
	    {
	      name: '質問',
	      value: 'question'
	    }, {
	      name: '情報求ム！',
	      value: 'seeking'
	    }, {
	      name: '資料紹介',
	      value: 'showcase'
	    }
	  ];
	  $scope.selectFiles = function(files) {
	    var file, i, len;
	    for (i = 0, len = files.length; i < len; i++) {
	      file = files[i];
	      if ($scope.imagesToUpload.length >= 4) {
	        return alert('添付できる写真は4枚までです。');
	      }
	      $scope.imagesToUpload.push(file);
	    }
	    return console.log(files);
	  };
	  $scope.removeImage = function(index) {
	    return $scope.imagesToUpload.splice(index, 1);
	  };
	  $scope.submitPost = function() {
	    $scope.uploading = true;
	    return PostFactory.add($scope.newPost, $scope.imagesToUpload).then(function() {
	      return $scope.initNewPost();
	    });
	  };
	  return $scope.initNewPost();
	}]);

	app.controller("PostCtrl", ["$scope", "$stateParams", "$mdDialog", "$window", "Users", "CLOUDINARY_CONFIGS", "post", function($scope, $stateParams, $mdDialog, $window, Users, CLOUDINARY_CONFIGS, post) {
	  var post_id;
	  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL;
	  post_id = $stateParams.post_id;
	  $scope.isSinglePage = true;
	  $scope.post = post;
	  $scope.users = Users;
	  $scope.moment = $window.moment;
	  $scope.sendComment = function() {
	    if (!(post.newComment.text.length > 0)) {
	      return;
	    }
	    return $scope.post.addComment(post.newComment).then(function() {
	      return $scope.post.newComment = {};
	    });
	  };
	  $scope.selectCommentFiles = function(files, post) {
	    var comment, file, i, len;
	    comment = $scope.post.newComment;
	    comment.images || (comment.images = []);
	    for (i = 0, len = files.length; i < len; i++) {
	      file = files[i];
	      if (comment.images.length >= 2) {
	        return alert('添付できる写真は2枚までです。');
	      }
	      comment.images.push(file);
	    }
	  };
	  $scope.removeComment = function(post, key, ev) {
	    var confirm;
	    confirm = $mdDialog.confirm().title('コメントの削除').textContent('このコメントを削除します。よろしいですか？').ariaLabel('removing comment').targetEvent(ev).ok('削除').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      return $scope.post.removeComment(key);
	    });
	  };
	  return $scope.openPhotoModal = function(id) {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.id = id;
	      }],
	      templateUrl: 'templates/dialogs/image.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	}]);

	app.controller("ProfileDialogCtrl", ["$scope", "$state", "$mdDialog", "$window", "PostFactory", "user", function($scope, $state, $mdDialog, $window, PostFactory, user) {
	  console.log(user);
	  $scope.user = user;
	  $scope.moment = $window.moment;
	  $scope.close = function() {
	    return $mdDialog.cancel();
	  };
	  $scope.posts = PostFactory.getListByUid(user.$id);
	  return $scope.moveToPost = function(post) {
	    $state.go("dashboard.post", {
	      post_id: post.$id
	    });
	    return $mdDialog.cancel();
	  };
	}]);

	app.controller("LikesDialogCtrl", ["$scope", "$state", "$mdDialog", "$window", "Users", "likes", function($scope, $state, $mdDialog, $window, Users, likes) {
	  $scope.Users = Users;
	  $scope.likes = likes;
	  return $scope.close = function() {
	    return $mdDialog.cancel();
	  };
	}]);


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("DashboardCtrl", ["$scope", "$window", "$state", "$translate", "currentAuth", "$firebaseAuth", "$mdDialog", "Users", "CurrentUser", "DesktopNotification", function($scope, $window, $state, $translate, currentAuth, $firebaseAuth, $mdDialog, Users, CurrentUser, DesktopNotification) {
	  $scope.authData = currentAuth;
	  $scope.currentUser = CurrentUser.get();
	  $translate.onReady(function() {
	    return $scope.lang = $translate.use();
	  });
	  $scope.switchLang = function(lang) {
	    return $translate.use(lang).then(function() {
	      return $scope.lang = $translate.use();
	    });
	  };
	  $scope.currentUser.$loaded(function() {
	    $scope.editingListSize = Object.keys($scope.currentUser.editing || {}).length;
	    return $scope.favListSize = Object.keys($scope.currentUser.favs || {}).length;
	  });
	  $scope.openSupportDialog = function() {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	      }],
	      templateUrl: 'templates/dialogs/support.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	  $scope.openMLDialog = function() {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	      }],
	      templateUrl: 'templates/dialogs/mailing-list.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	  $scope.openLinksDialog = function() {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	      }],
	      templateUrl: 'templates/dialogs/links.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	  if (DesktopNotification.checkNotificationSupport()) {
	    return DesktopNotification.enableNotification();
	  }
	}]);

	app.controller("HomeCtrl", ["$scope", "$window", "$location", "$translate", "Books", "Timeline", "Users", "DailyStats", function($scope, $window, $location, $translate, Books, Timeline, Users, DailyStats) {
	  $scope.timeline = Timeline.getList(50);
	  $scope.currentPath = $location.path();
	  $scope.Books = Books;
	  $scope.charRanking = Users.getCharRanking(100);
	  $scope.moment = $window.moment;
	  $scope.dispOptions = {
	    showOnlyRequestReview: false,
	    showWithComment: false
	  };
	  $scope.isVisible = function(event) {
	    var result;
	    result = false;
	    if ($scope.dispOptions.showOnlyRequestReview) {
	      result = event.requestReview;
	    } else if ($scope.dispOptions.showWithComment) {
	      result || (result = event.comment && event.comment.length > 0);
	    } else {
	      result = true;
	    }
	    return result;
	  };
	  $scope.Users = Users;
	  return DailyStats.getRecent(2).$loaded(function(stat) {
	    var today, yesterday;
	    today = stat[1];
	    yesterday = stat[0];
	    return $scope.progress = {
	      charCount: today.char_count,
	      charCountIncrease: today.char_count - yesterday.char_count,
	      completedBooks: today.completed_books,
	      completedBooksIncrease: today.completed_books - yesterday.completed_books,
	      progressSum: today.progress_sum,
	      progressRatio: Math.floor((today.progress_sum / today.content_sum) * 100),
	      progressSumIncrease: today.progress_sum - yesterday.progress_sum,
	      contentSum: today.content_sum,
	      userCount: today.user_count - 783,
	      bookCount: today.book_count
	    };
	  });
	}]);

	app.controller("ForumCtrl", ["$scope", "$window", "$state", "Users", "Discussion", "DiscussionFactory", "DiscussionCategories", function($scope, $window, $state, Users, Discussion, DiscussionFactory, DiscussionCategories) {
	  $scope.Users = Users;
	  $scope.moment = $window.moment;
	  $scope.showForm = false;
	  $scope.categories = DiscussionCategories;
	  $scope.toggleForm = function() {
	    $scope.newDiscussion = {
	      title: '',
	      text: '',
	      category: 'question',
	      commentCount: 0,
	      images: []
	    };
	    $scope.showForm = !$scope.showForm;
	    $scope.imagesToUpload = [];
	    return $scope.disableSubmit = false;
	  };
	  $scope.selectFiles = function(files) {
	    var file, i, len;
	    for (i = 0, len = files.length; i < len; i++) {
	      file = files[i];
	      if ($scope.imagesToUpload.length >= 4) {
	        return alert('添付できる写真は4枚までです。');
	      }
	      $scope.imagesToUpload.push(file);
	    }
	  };
	  $scope.removeImage = function(index) {
	    return $scope.imagesToUpload.splice(index, 1);
	  };
	  $scope.submit = function() {
	    $scope.disableSubmit = true;
	    return DiscussionFactory.add($scope.newDiscussion, $scope.imagesToUpload).then(function() {
	      return $scope.toggleForm();
	    });
	  };
	  $scope.switchNavItem = function(name) {
	    $scope.selectedNavItem = name;
	    switch (name) {
	      case 'update':
	        $scope.discussions = DiscussionFactory.getUpdated();
	        break;
	      case 'popular':
	        $scope.discussions = DiscussionFactory.getPopular();
	        break;
	      default:
	        $scope.discussions = DiscussionFactory.getLatest();
	    }
	    return $scope.discussions.$ref().scroll.next(100);
	  };
	  $scope.switchNavItem('latest');
	  return console.log($scope.discussions);
	}]);

	app.controller("DiscussionCtrl", ["$scope", "$state", "$stateParams", "$window", "$mdDialog", "discussion", "Users", "DiscussionFactory", "CurrentUser", "DiscussionCategories", "CLOUDINARY_CONFIGS", function($scope, $state, $stateParams, $window, $mdDialog, discussion, Users, DiscussionFactory, CurrentUser, DiscussionCategories, CLOUDINARY_CONFIGS) {
	  $scope.discussion = discussion;
	  $scope.categories = DiscussionCategories;
	  $scope.Users = Users;
	  $scope.discussion.newComment = {};
	  $scope.currentUser = CurrentUser.get();
	  $scope.moment = $window.moment;
	  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL;
	  $scope.sendComment = function() {
	    if (!(discussion.newComment.text.length > 0)) {
	      return;
	    }
	    return $scope.discussion.addComment(discussion.newComment).then(function() {
	      return $scope.discussion.newComment = {};
	    });
	  };
	  $scope.selectCommentFiles = function(files, discussion) {
	    var base, comment, file, i, len;
	    (base = $scope.discussion).newComment || (base.newComment = {});
	    comment = $scope.discussion.newComment;
	    comment.images || (comment.images = []);
	    for (i = 0, len = files.length; i < len; i++) {
	      file = files[i];
	      if (comment.images.length >= 2) {
	        return alert('添付できる写真は2枚までです。');
	      }
	      comment.images.push(file);
	    }
	  };
	  $scope.removeDiscussion = function(ev) {
	    var confirm;
	    confirm = $mdDialog.confirm().title('投稿の削除').textContent('この投稿を削除します。よろしいですか？').ariaLabel('removing comment').targetEvent(ev).ok('削除').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      $scope.discussion.$remove();
	      return $state.go('dashboard.forum');
	    });
	  };
	  $scope.removeComment = function(key, ev) {
	    var confirm;
	    confirm = $mdDialog.confirm().title('コメントの削除').textContent('このコメントを削除します。よろしいですか？').ariaLabel('removing comment').targetEvent(null).ok('削除').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      console.log(key);
	      return $scope.discussion.removeComment(key);
	    });
	  };
	  return $scope.openPhotoModal = function(id) {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        return $scope.id = id;
	      }],
	      templateUrl: 'templates/dialogs/image.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	}]);

	app.controller("GuidelineCtrl", ["$scope", "$state", function($scope, $state) {}]);

	app.controller("IntroCtrl", ["$scope", "$state", "$translate", function($scope, $state, $translate) {}]);

	app.controller("EntriesCtrl", ["$scope", "$state", "$sce", "$mdDialog", "$location", "$stateParams", "Books", function($scope, $state, $sce, $mdDialog, $location, $stateParams, Books) {
	  var stage;
	  stage = $stateParams.stage ? parseInt($stateParams.stage) : 1;
	  $scope.entries = Books.getByStage(stage);
	  $scope.currentPath = $location.path();
	  $scope.search = {};
	  $scope.search.keyword = "";
	  $scope.search.showCompleted = false;
	  $scope.search.filter = function(entry) {
	    var keyword, match, ref, ref1;
	    keyword = $scope.search.keyword;
	    if (!$scope.search.showCompleted && entry.size === entry.progress) {
	      return false;
	    }
	    if (keyword === null || keyword.length < 1) {
	      return true;
	    }
	    if (match = keyword.match(/^tag:\w?(.+)$/)) {
	      return (ref = entry.disaster_list) != null ? ref.some(function(tag) {
	        return match[1] === tag.name;
	      }) : void 0;
	    } else if (match = keyword.match(/^region:\w?(.+)$/)) {
	      return (ref1 = entry.region_list) != null ? ref1.some(function(region) {
	        return match[1] === region;
	      }) : void 0;
	    } else {
	      return new RegExp($scope.search.keyword).test(entry.title);
	    }
	  };
	  $scope.searchByTag = function(name) {
	    return $scope.search.keyword = "tag:" + name;
	  };
	  $scope.searchByRegion = function(name) {
	    return $scope.search.keyword = "region:" + name;
	  };
	  return $scope.openBookDialog = function(book) {
	    return $mdDialog.show({
	      controller: 'BookDialogCtrl',
	      templateUrl: 'templates/dialogs/book.html',
	      parent: angular.element(document.body),
	      locals: {
	        book: book
	      },
	      clickOutsideToClose: true
	    });
	  };
	}]);

	app.controller("CreditCtrl", ["$scope", "$state", function($scope, $state) {}]);

	app.controller("NewsCtrl", ["$scope", "$state", "$window", function($scope, $state, $window) {}]);

	app.controller("EditingListCtrl", ["$scope", "$window", "UserEditing", "Books", function($scope, $window, UserEditing, Books) {
	  $scope.editingList = UserEditing.getList();
	  $scope.Books = Books;
	  return $scope.moment = $window.moment;
	}]);

	app.controller("SignInCtrl", ["$scope", "$state", "$stateParams", "$firebaseAuth", "$location", "$timeout", "$translate", "CurrentUser", function($scope, $state, $stateParams, $firebaseAuth, $location, $timeout, $translate, CurrentUser) {
	  var goDashboardOrRedirect, updateUserData;
	  $translate.onReady(function() {
	    return $scope.lang = $translate.use();
	  });
	  $scope.switchLang = function(lang) {
	    return $translate.use(lang).then(function() {
	      return $scope.lang = $translate.use();
	    });
	  };
	  updateUserData = function(data) {
	    var ref, user;
	    user = CurrentUser.get();
	    data = {
	      name: data.displayName,
	      avatar: (ref = data.photoURL) != null ? ref.replace('http:', 'https:') : void 0,
	      providerId: data.providerId
	    };
	    return user.update(data);
	  };
	  goDashboardOrRedirect = function() {
	    console.log($stateParams.redirect);
	    if ($stateParams.redirect && $stateParams.redirect.length > 0) {
	      return $location.path(decodeURIComponent($stateParams.redirect));
	    } else {
	      return $timeout(function() {
	        console.log("going home");
	        return $state.go('dashboard.home');
	      });
	    }
	  };
	  $scope.signInWithGoogle = function() {
	    var provider;
	    console.log("google sign in");
	    provider = new firebase.auth.GoogleAuthProvider();
	    provider.addScope('https://www.googleapis.com/auth/plus.login');
	    return $firebaseAuth().$signInWithPopup(provider).then(function(auth) {
	      var data, user;
	      user = auth.user;
	      data = {
	        displayName: user.displayName || user.providerData[0].displayName,
	        photoURL: user.photoURL || user.providerData[0].photoURL,
	        providerId: "google.com"
	      };
	      updateUserData(data);
	      return goDashboardOrRedirect();
	    })["catch"](function(err) {
	      return console.log(err);
	    });
	  };
	  $scope.signInWithFacebook = function() {
	    return $firebaseAuth().$signInWithPopup("facebook").then(function(auth) {
	      var user;
	      console.log(auth);
	      user = auth.user;
	      updateUserData(user.providerData[0]);
	      return goDashboardOrRedirect();
	    })["catch"](function(err) {
	      return console.log(err);
	    });
	  };
	  return $scope.signInWithTwitter = function() {
	    return $firebaseAuth().$signInWithPopup("twitter").then(function(auth) {
	      var user;
	      user = auth.user;
	      updateUserData(user.providerData[0]);
	      return goDashboardOrRedirect();
	    })["catch"](function(err) {
	      return console.log(err);
	    });
	  };
	}]);

	app.controller('QuakesCtrl', ["$scope", "$mdDialog", "$window", "Quakes", function($scope, $mdDialog, $window, Quakes) {
	  $scope.quakes = Quakes.getList();
	  $scope.moment = $window.moment;
	  return console.log($scope.quakes);
	}]);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("LearnCtrl", ["$scope", "Lesson", "Chars", "LessonProgress", "TutorialDialog", function($scope, Lesson, Chars, LessonProgress, TutorialDialog) {
	  $scope.kanaLessons = Lesson.getKanaLessons();
	  $scope.kanjiLessons = Lesson.getKanjiLessons();
	  $scope.progress = {};
	  LessonProgress.getList().$loaded(function(progress) {
	    var i, len, p, results;
	    results = [];
	    for (i = 0, len = progress.length; i < len; i++) {
	      p = progress[i];
	      results.push($scope.progress[p.$id] = p.$value);
	    }
	    return results;
	  });
	  return $scope.openTutorial = function(number) {
	    return TutorialDialog.show(number);
	  };
	}]);

	app.controller("LessonCtrl", ["$scope", "$stateParams", "$window", "$mdDialog", "Lesson", "Chars", function($scope, $stateParams, $window, $mdDialog, Lesson, Chars) {
	  var chars, id;
	  id = $stateParams.id;
	  $scope.lesson = Lesson.get(id);
	  chars = Chars.getByLessonId(id);
	  $scope.chars = chars;
	  $scope.selectChar = function(index) {
	    return $scope.selected = $scope.chars[index];
	  };
	  return $scope.startQuiz = function() {
	    return $mdDialog.show({
	      controller: ["$scope", function($scope) {
	        $scope.lessonId = id;
	        $scope.chars = chars;
	        $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	        return $scope.start = function(size, askAllChars) {
	          if (askAllChars == null) {
	            askAllChars = false;
	          }
	          return $mdDialog.show({
	            controller: 'QuizCtrl',
	            templateUrl: 'templates/kula/quiz_dialog.html',
	            parent: angular.element(document.body),
	            clickOutsideToClose: false,
	            locals: {
	              lessonId: id,
	              size: size,
	              askAllChars: askAllChars
	            }
	          });
	        };
	      }],
	      templateUrl: 'templates/kula/start_quiz_dialog.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: true
	    });
	  };
	}]);

	app.controller("CharCtrl", ["$scope", "$stateParams", "Chars", "QuizState", function($scope, $stateParams, Chars, QuizState) {
	  var id;
	  id = parseInt($stateParams.char_id);
	  return $scope.char = Chars.get(id);
	}]);

	app.controller("QuizCtrl", ["$scope", "$timeout", "$mdDialog", "Quiz", "QuizState", "Lesson", "LessonProgress", "CurrentUser", "NotificationMsg", "lessonId", "size", "askAllChars", function($scope, $timeout, $mdDialog, Quiz, QuizState, Lesson, LessonProgress, CurrentUser, NotificationMsg, lessonId, size, askAllChars) {
	  var gemCount;
	  $scope.lesson = Lesson.get(lessonId);
	  gemCount = !askAllChars ? size <= 10 ? 1 : 2 : size <= 10 ? 3 : 5;
	  $scope.quiz = {
	    input: "",
	    progress: 0,
	    size: size,
	    correct: 0,
	    askAllChars: askAllChars,
	    quizArray: Quiz.getByLessonId(lessonId)
	  };
	  $scope.insertChar = function(char) {
	    var base;
	    (base = $scope.quiz).input || (base.input = "");
	    return $scope.quiz.input += char;
	  };
	  $scope.quiz.quizArray.$loaded(function() {
	    $scope.quiz.current = $scope.quiz.quizArray.getQuizAt(0, askAllChars);
	    QuizState.setState('asking');
	    $scope.state = QuizState.getState();
	    $scope.$broadcast('focus-input');
	    return $scope.answerLength = askAllChars ? 10 : 1;
	  });
	  $scope.proceed = function() {
	    var proceed;
	    if ($scope.state.showActionButton) {
	      return;
	    }
	    $scope.state = QuizState.proceed($scope.quiz);
	    if ($scope.state.isCleared) {
	      LessonProgress.setGemCount(lessonId, gemCount).then(function() {
	        return CurrentUser.get().updateGemCount().then(function() {
	          return NotificationMsg.show("宝石を" + gemCount + "個獲得しました");
	        });
	      });
	    }
	    if ($scope.state.waitFor) {
	      proceed = (function(_this) {
	        return function() {
	          return $scope.proceed();
	        };
	      })(this);
	      $timeout(proceed, $scope.state.waitFor);
	    }
	    if ($scope.state.input) {
	      return $scope.$broadcast('focus-input');
	    }
	  };
	  return $scope.cancel = function() {
	    return $mdDialog.hide();
	  };
	}]);

	app.controller('TutorialDialogCtrl', ["$scope", "$mdDialog", "speech", function($scope, $mdDialog, speech) {
	  console.log(speech);
	  $scope.idx = 0;
	  $scope.length = speech.length;
	  $scope.currentSpeech = speech[$scope.idx];
	  $scope.title = 'チュートリアル';
	  $scope.proceed = function() {
	    if ($scope.idx < speech.length - 1) {
	      $scope.idx += 1;
	      return $scope.currentSpeech = speech[$scope.idx];
	    }
	  };
	  $scope.rollback = function() {
	    if ($scope.idx > 0) {
	      $scope.idx -= 1;
	      return $scope.currentSpeech = speech[$scope.idx];
	    }
	  };
	  return $scope.cancel = function() {
	    return $mdDialog.hide();
	  };
	}]);


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("NotificationPanelCtrl", ["$scope", "$window", "$mdPanel", "Notification", "Users", "Books", function($scope, $window, $mdPanel, Notification, Users, Books) {
	  $scope.notifications = Notification.getList(50);
	  $scope.notifications.$loaded(function() {
	    var i, len, n, ref, results;
	    ref = $scope.notifications;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      n = ref[i];
	      n["new"] = !n.read;
	      n.read = true;
	      results.push($scope.notifications.$save(n));
	    }
	    return results;
	  });
	  $scope.Books = Books;
	  $scope.Users = Users;
	  $scope.moment = $window.moment;
	  return $scope.jumpToSource = function(rec) {
	    $scope.notifications.jumpToSource(rec);
	    return $window.panel.hide();
	  };
	}]);

	app.controller("HeaderCtrl", ["$scope", "$state", "$firebaseAuth", "$mdDialog", "$mdPanel", "$window", "$translate", "CurrentUser", "Notification", "DesktopNotification", function($scope, $state, $firebaseAuth, $mdDialog, $mdPanel, $window, $translate, CurrentUser, Notification, DesktopNotification) {
	  $scope.currentUser = CurrentUser.get();
	  console.log($scope.currentUser);
	  $scope.logout = function() {
	    console.log("sign out");
	    $firebaseAuth().$signOut();
	    return $state.go('signin');
	  };
	  $scope.toggleDesktopNotification = function() {
	    return DesktopNotification.enableNotification();
	  };
	  $scope.notifications = Notification.getList();
	  $scope.showNotifications = function() {
	    var config, position, template;
	    template = 'templates/partial/panel-notification.html';
	    if ($translate.use() === "en") {
	      template = 'templates/partial/panel-notification-en.html';
	    }
	    position = $mdPanel.newPanelPosition().relativeTo('.notification-btn').addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
	    config = {
	      attachTo: angular.element(document.body),
	      controller: 'NotificationPanelCtrl',
	      templateUrl: template,
	      panelClass: 'notification-panel',
	      position: position,
	      clickOutsideToClose: true,
	      escapeToClose: true,
	      focusOnOpen: false,
	      zIndex: 9999999
	    };
	    return $mdPanel.open(config).then(function(panel) {
	      return $window.panel = panel;
	    });
	  };
	  return $scope.editProfile = function() {
	    return $mdDialog.show({
	      controller: ["$scope", "$mdDialog", "CurrentUser", function($scope, $mdDialog, CurrentUser) {
	        $scope.currentUser = CurrentUser.get();
	        $scope.cancel = function() {
	          return $mdDialog.cancel();
	        };
	        return $scope.save = function(ev) {
	          console.log($scope.currentUser.profile);
	          return $scope.currentUser.$save().then(function() {
	            var alert;
	            alert = $mdDialog.alert().clickOutsideToClose(true).title('確認').textContent('プロフィールを編集しました').ariaLabel('Edited profile').ok('閉じる').targetEvent(ev);
	            return $mdDialog.show(alert);
	          });
	        };
	      }],
	      templateUrl: 'templates/dialogs/edit-profile.html',
	      parent: angular.element(document.body),
	      clickOutsideToClose: false
	    });
	  };
	}]);

	app.controller('UserStatusCtrl', ["$scope", "CurrentUser", "LevelTable", function($scope, CurrentUser, LevelTable) {
	  $scope.currentUser = CurrentUser.get();
	  return $scope.currentUser.$loaded(function() {
	    $scope.levelPoints = LevelTable.getLevelPoints($scope.currentUser.currentLevel || 1);
	    $scope.pointsInCurrentLevel = LevelTable.pointsInCurrentLevel($scope.currentUser.points);
	    return $scope.levelProgress = ($scope.pointsInCurrentLevel / $scope.levelPoints) * 100;
	  });
	}]);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("PersonalCtrl", ["$scope", "$state", function($scope, $state) {
	  $scope.selectedNavItem = $state.current.name.split('.').reverse()[0];
	  console.log($scope.selectedNavItem);
	  return $scope.switchNavItem = function(name) {
	    return $state.go("dashboard.personal." + name);
	  };
	}]);

	app.controller("FavListCtrl", ["$scope", "$window", "$location", "UserFavs", "Books", function($scope, $window, $location, UserFavs, Books) {
	  $scope.favs = UserFavs.getList();
	  $scope.Books = Books;
	  $scope.moment = $window.moment;
	  return $scope.currentPath = $location.path();
	}]);

	app.controller("PersonalHistoryCtrl", ["$scope", "$window", "$location", "CurrentUser", "Timeline", "Books", function($scope, $window, $location, CurrentUser, Timeline, Books) {
	  var uid;
	  uid = CurrentUser.get().$id;
	  $scope.timeline = Timeline.getListByUid(uid, 100);
	  console.log($scope.timeline);
	  $scope.Books = Books;
	  $scope.moment = $window.moment;
	  return $scope.currentPath = $location.path();
	}]);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.controller("TranscriptionCtrl", ["$scope", "$state", "$stateParams", "$mdDialog", "$mdSidenav", "$window", "$interval", "$mdToast", "$firebaseAuth", "$location", "$mdPanel", "Users", "UserFavs", "book", "transcriptionList", "currentAuth", "Notification", "CurrentUser", function($scope, $state, $stateParams, $mdDialog, $mdSidenav, $window, $interval, $mdToast, $firebaseAuth, $location, $mdPanel, Users, UserFavs, book, transcriptionList, currentAuth, Notification, CurrentUser) {
	  var showMessageInQueue;
	  $scope.logout = function() {
	    $firebaseAuth().$signOut();
	    return $state.go('signin');
	  };
	  $scope.goBack = function() {
	    var path, ref;
	    ref = $stateParams.ref;
	    path = ref ? decodeURIComponent(ref) : '/dashboard';
	    return $location.path(path);
	  };
	  $scope.moment = $window.moment;
	  $scope.auth = currentAuth;
	  $scope.book = book;
	  $window.book = book;
	  $scope.id = book.$id;
	  $scope.transcriptions = transcriptionList;
	  $scope.users = Users;
	  $scope.textEdit = "";
	  $scope.currentUser = CurrentUser.get();
	  $scope.toggleFav = function() {
	    return $scope.fav.toggle();
	  };
	  $scope.fav = UserFavs.getFav(book.$id);
	  $scope.notifications = Notification.getList();
	  $scope.showNotifications = function() {
	    var config, position;
	    position = $mdPanel.newPanelPosition().relativeTo('.notification-btn').addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);
	    config = {
	      attachTo: angular.element(document.body),
	      controller: 'NotificationPanelCtrl',
	      templateUrl: 'templates/partial/panel-notification.html',
	      panelClass: 'notification-panel',
	      position: position,
	      clickOutsideToClose: true,
	      escapeToClose: true,
	      focusOnOpen: false,
	      zIndex: 9999999
	    };
	    return $mdPanel.open(config).then(function(panel) {
	      return $window.panel = panel;
	    });
	  };
	  $scope.book.$loaded(function() {
	    var img, tyleSources;
	    tyleSources = (function() {
	      var i, len, ref1, results;
	      ref1 = $scope.book.dzi;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        img = ref1[i];
	        results.push('https://honkoku.org/dzi/' + img);
	      }
	      return results;
	    })();
	    $scope.viewer = OpenSeadragon({
	      id: 'openseadragon-viewer',
	      tileSources: tyleSources,
	      sequenceMode: true,
	      showNavigator: false,
	      navigatorPosition: "BOTTOM_LEFT",
	      defaultZoomLevel: 1,
	      showNavigationControl: true,
	      showFullPageControl: false,
	      showSequenceControl: false,
	      springStiffness: 18,
	      crossOriginPolicy: false,
	      zoomPerScroll: 1.1
	    });
	    $window.viewer = $scope.viewer;
	    return $window.anno.makeAnnotatable($scope.viewer);
	  });
	  $scope.toastMessageQueue = [];
	  showMessageInQueue = function() {
	    var msg, msgKey;
	    if (!($scope.toastMessageQueue.length > 0)) {
	      return;
	    }
	    msgKey = $scope.toastMessageQueue.shift();
	    if ($mdSidenav("left").isOpen()) {
	      return;
	    }
	    msg = $scope.messages.$getRecord(msgKey);
	    return $mdToast.show({
	      hideDelay: 3000,
	      position: 'bottom right',
	      templateUrl: 'templates/transcription/message-toast.html',
	      controller: ["$mdToast", "$scope", "Users", function($mdToast, $scope, Users) {
	        $scope.msg = msg;
	        return $scope.users = Users;
	      }]
	    });
	  };
	  return $interval(showMessageInQueue, 3000);
	}]);

	app.controller("TranscriptionEditorCtrl", ["$scope", "transcription", "$state", "$sce", function($scope, transcription, $state, $sce) {
	  $scope.transcription = transcription;
	  $scope.$parent.childState = $state.$current.name.split(".").reverse()[0];
	  console.log("editor", $state.$current.name.split(".").reverse()[0]);
	  $scope.viewHtml = $sce.trustAsHtml($scope.transcription.getFormattedHtml());
	  return transcription.$watch(function() {
	    return $scope.viewHtml = $sce.trustAsHtml($scope.transcription.getFormattedHtml());
	  });
	}]);

	app.controller("TranscriptionInputCtrl", ["$scope", "$window", "$state", "$sce", "$interval", "transcription", function($scope, $window, $state, $sce, $interval, transcription) {
	  $window.transcription = transcription;
	  $scope.transcription = transcription;
	  $scope.showActionButtons = false;
	  $scope.toggleActionButtons = function() {
	    return $scope.showActionButtons = !$scope.showActionButtons;
	  };
	  transcription.$loaded(function() {
	    var update;
	    console.log('editing');
	    if (transcription.isEditingByCurrentUser()) {
	      update = function() {
	        if (transcription.tempChanged) {
	          console.log('save temp');
	          return transcription.$save().then(function() {
	            return transcription.setTempChanged(false);
	          });
	        }
	      };
	      return $interval(update, 3000);
	    }
	  });
	  $scope.handleChange = function() {
	    return $scope.transcription.tempChanged = true;
	  };
	  $scope.insertRuby = function($event) {
	    var node, range, range2, repl, sel, text;
	    $event.stopImmediatePropagation();
	    sel = $window.getSelection();
	    text = sel.toString();
	    repl = "";
	    if (text && text.length > 0) {
	      repl = "《ルビ：" + text + "｜ここにルビを入力》";
	    } else {
	      repl = "《ルビ：漢字｜ここにルビを入力》";
	    }
	    if (sel.rangeCount) {
	      range = sel.getRangeAt(0);
	      range.deleteContents();
	      node = $window.document.createTextNode(repl);
	      range.insertNode(node);
	      range2 = $window.document.createRange();
	      range2.setStart(node, 4);
	      range2.setEnd(node, 6);
	      sel.removeAllRanges();
	      return sel.addRange(range2);
	    }
	  };
	  $scope.insertOdoriji = function($event) {
	    var current, index, list, node, range, range2, repl, sel;
	    $event.stopImmediatePropagation();
	    list = ['ゝ', 'ゞ', 'ヽ', 'ヾ', '〻', '々', '〳〵', '〴〵'];
	    sel = $window.getSelection();
	    if (sel.rangeCount === 0) {
	      return;
	    }
	    current = sel.toString();
	    index = list.indexOf(current);
	    if (index >= 0) {
	      sel.deleteFromDocument();
	      if (index >= list.length - 1) {
	        index = index - list.length;
	      }
	      repl = list[index + 1];
	    } else {
	      repl = list[0];
	    }
	    node = $window.document.createTextNode(repl);
	    range = sel.getRangeAt(0);
	    range.insertNode(node);
	    range2 = $window.document.createRange();
	    range2.setStart(node, 0);
	    range2.setEnd(node, repl.length);
	    sel.removeAllRanges();
	    return sel.addRange(range2);
	  };
	  $scope.insertFreq = function($event) {
	    var current, index, list, node, range, range2, repl, sel;
	    $event.stopImmediatePropagation();
	    list = ['□', 'ゟ', 'ゐ', 'ヰ', 'ゑ', 'ヱ'];
	    sel = $window.getSelection();
	    if (sel.rangeCount === 0) {
	      return;
	    }
	    current = sel.toString();
	    index = list.indexOf(current);
	    if (index >= 0) {
	      sel.deleteFromDocument();
	      if (index >= list.length - 1) {
	        index = index - list.length;
	      }
	      repl = list[index + 1];
	    } else {
	      repl = list[0];
	    }
	    node = $window.document.createTextNode(repl);
	    range = sel.getRangeAt(0);
	    range.insertNode(node);
	    range2 = $window.document.createRange();
	    range2.setStart(node, 0);
	    range2.setEnd(node, repl.length);
	    sel.removeAllRanges();
	    return sel.addRange(range2);
	  };
	  $scope.insertNote = function($event) {
	    var node, range, range2, repl, sel, text;
	    $event.stopImmediatePropagation();
	    sel = $window.getSelection();
	    text = sel.toString();
	    repl = "【ここに注記を入力】";
	    if (sel.rangeCount) {
	      range = sel.getRangeAt(0);
	      range.deleteContents();
	      node = $window.document.createTextNode(repl);
	      range.insertNode(node);
	      range2 = $window.document.createRange();
	      range2.setStart(node, repl.length - 9);
	      range2.setEnd(node, repl.length - 1);
	      sel.removeAllRanges();
	      return sel.addRange(range2);
	    }
	  };
	  $scope.insertWarigaki = function($event) {
	    var node, range, range2, repl, sel;
	    sel = $window.getSelection();
	    repl = "《割書：一行目｜二行目》";
	    if (sel.rangeCount) {
	      range = sel.getRangeAt(0);
	      range.deleteContents();
	      node = $window.document.createTextNode(repl);
	      range.insertNode(node);
	      range2 = $window.document.createRange();
	      range2.setStart(node, repl.length - 8);
	      range2.setEnd(node, repl.length - 5);
	      sel.removeAllRanges();
	      return sel.addRange(range2);
	    }
	  };
	  $scope.insertHako = function($event) {
	    var hasSelection, node, range, range2, repl, sel, text;
	    $event.stopImmediatePropagation();
	    sel = $window.getSelection();
	    text = sel.toString();
	    repl = "";
	    hasSelection = text && text.length;
	    if (hasSelection) {
	      repl = "《箱：" + text + "》";
	    } else {
	      repl = "《箱：》";
	    }
	    if (sel.rangeCount) {
	      range = sel.getRangeAt(0);
	      range.deleteContents();
	      node = $window.document.createTextNode(repl);
	      range.insertNode(node);
	      range2 = $window.document.createRange();
	      range2.setStart(node, repl.length - 1);
	      range2.setEnd(node, repl.length - 1);
	      sel.removeAllRanges();
	      return sel.addRange(range2);
	    }
	  };
	  return $scope.insertKunten = function($event) {
	    var current, kaeri, list, node, okuri, range, range2, repl, sel;
	    $event.stopImmediatePropagation();
	    okuri = '［オクリ］';
	    kaeri = '｛カエリ｝';
	    list = [okuri, kaeri];
	    sel = $window.getSelection();
	    if (sel.rangeCount === 0) {
	      return;
	    }
	    current = sel.toString();
	    if (current === okuri) {
	      sel.deleteFromDocument();
	      repl = kaeri;
	    } else if (current === kaeri) {
	      sel.deleteFromDocument();
	      repl = okuri;
	    } else {
	      repl = okuri;
	    }
	    node = $window.document.createTextNode(repl);
	    range = sel.getRangeAt(0);
	    range.insertNode(node);
	    range2 = $window.document.createRange();
	    range2.setStart(node, 0);
	    range2.setEnd(node, repl.length);
	    sel.removeAllRanges();
	    return sel.addRange(range2);
	  };
	}]);

	app.controller("TranscriptionNotesCtrl", ["$scope", "$mdDialog", "$window", "transcription", function($scope, $mdDialog, $window, transcription) {
	  transcription.$loaded(function() {
	    return $scope.notes = transcription.getNoteArray();
	  });
	  return $scope.addNote = function(ev) {
	    var prompt;
	    console.log("notes");
	    prompt = $mdDialog.prompt().title('ノートを追加').textContent('内容を入力してください').placeholder('ここに内容を入力').targetEvent(ev).ok('追加').cancel('キャンセル');
	    return $mdDialog.show(prompt).then(function(input) {
	      return transcription.addNote(input).$save();
	    });
	  };
	}]);

	app.controller("TranscriptionHistoryCtrl", ["$scope", "$mdDialog", "transcription", "Timeline", "Diff", function($scope, $mdDialog, transcription, Timeline, Diff) {
	  return transcription.$loaded(function() {
	    var code;
	    code = transcription.getCode();
	    $scope.timeline = Timeline.getListByCode(code);
	    return $scope.showDiff = function(id, ev) {
	      var diffHtml, selected;
	      selected = $scope.timeline.$getRecord(id);
	      diffHtml = Diff.styledDiffHtml(selected.previousText, selected.text);
	      return $mdDialog.show({
	        templateUrl: 'templates/transcription/diff_dialog.html',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        clickOutsideToClose: true,
	        controller: ["$scope", "$mdDialog", "$sce", "$window", function($scope, $mdDialog, $sce, $window) {
	          $scope.moment = $window.moment;
	          $scope.event = selected;
	          $scope.diffHtml = $sce.trustAsHtml(diffHtml);
	          return $scope.close = function() {
	            return $mdDialog.hide();
	          };
	        }]
	      });
	    };
	  });
	}]);

	app.controller("TranscriptionActionButtonsCtrl", ["$scope", "$mdDialog", "$mdToast", "$state", "$window", "Timeline", "Users", "Books", "transcription", "CurrentUser", function($scope, $mdDialog, $mdToast, $state, $window, Timeline, Users, Books, transcription, CurrentUser) {
	  transcription.$loaded(function() {
	    return $scope.transcription = transcription;
	  });
	  $scope.startTranscribing = function(ev) {
	    return $mdDialog.show({
	      templateUrl: 'templates/transcription/starting_dialog.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      controller: ["$scope", "$mdDialog", function($scope, $mdDialog) {
	        $scope.realtimeMode = false;
	        $scope.transcription = transcription;
	        $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	        return $scope.start = function() {
	          return $scope.transcription.startEditing($scope.realtimeMode).$save().then(function() {
	            $mdDialog.hide();
	            return $state.go("^.input");
	          });
	        };
	      }]
	    });
	  };
	  $scope.saveTempTranscription = function(ev) {
	    return $scope.transcription.setTempChanged(false).$save().then(function() {
	      var toast;
	      toast = $mdToast.simple().textContent('下書きを保存しました').position('bottom right').hideDelay(3000);
	      console.log(toast);
	      return $mdToast.show(toast);
	    });
	  };
	  $scope.discardTemp = function(ev) {
	    var confirm;
	    confirm = $mdDialog.confirm().title('作業内容の破棄').textContent('作業内容を破棄して、翻刻文を以前の状態に戻します。よろしいですか？').ariaLabel('Are you sure to disard the current text?').targetEvent(ev).ok('破棄').cancel('キャンセル');
	    return $mdDialog.show(confirm).then(function() {
	      return $scope.transcription.abortEditing().$save().then(function() {
	        var toast;
	        toast = $mdToast.simple().textContent('変更を破棄しました').position('bottom right').hideDelay(3000);
	        return $mdToast.show(toast);
	      });
	    });
	  };
	  $scope.completeTranscription = function(ev) {
	    var diffCount, previousText, text;
	    diffCount = $scope.transcription.countDiff();
	    previousText = $scope.transcription.text;
	    text = $scope.transcription.tempText;
	    return $mdDialog.show({
	      templateUrl: 'templates/transcription/confirm_dialog.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: false,
	      controller: ["$scope", "$mdDialog", function($scope, $mdDialog) {
	        $scope.finished = transcription.prevStatus === 'finished';
	        $scope.shared = true;
	        $scope.requestReview = false;
	        $scope.transcription = transcription;
	        $scope.diffCount = diffCount;
	        $scope.comment = "";
	        $scope.cancel = function() {
	          return $mdDialog.hide();
	        };
	        return $scope.submit = function() {
	          $mdDialog.hide();
	          $scope.transcription.endEditing();
	          if ($scope.finished) {
	            $scope.transcription.setFinished();
	          }
	          return $scope.transcription.$save().then(function() {
	            var book;
	            book = Books.get($scope.transcription.getBookId());
	            book.updateProgress();
	            Users.addCharCount(diffCount);
	            Timeline.$add({
	              event: 'transcription',
	              bookId: $scope.transcription.getBookId(),
	              content: parseInt($scope.transcription.$id),
	              comment: $scope.comment,
	              diffCount: diffCount,
	              shared: $scope.shared,
	              requestReview: $scope.requestReview,
	              code: $scope.transcription.getCode(),
	              previousText: previousText,
	              text: text
	            });
	            return $mdDialog.show({
	              templateUrl: 'templates/transcription/finishing_dialog.html',
	              parent: angular.element(document.body),
	              targetEvent: ev,
	              clickOutsideToClose: true,
	              controller: ["$scope", "$mdDialog", function($scope, $mdDialog) {
	                $scope.transcription = transcription;
	                $scope.diffCount = diffCount;
	                return $scope.close = function() {
	                  return $mdDialog.hide();
	                };
	              }]
	            });
	          });
	        };
	      }]
	    });
	  };
	  $scope.freeze = function() {
	    if (CurrentUser.get().isAdmin()) {
	      return $scope.transcription.freeze().$save();
	    }
	  };
	  return $scope.unfreeze = function() {
	    if (CurrentUser.get().isAdmin()) {
	      return $scope.transcription.unfreeze().$save();
	    }
	  };
	}]);

	app.controller("TranscriptionContentStatusCtrl", ["$scope", "$state", "transcription", function($scope, $state, transcription) {
	  $scope.transcription = transcription;
	  $scope.contentIndex = parseInt(transcription.$id) + 1 + "";
	  $scope.transcriptions = $scope.$parent.transcriptions;
	  return $scope.changeIndex = function() {
	    console.log("change");
	    return $state.go('transcription.content.view', {
	      content: parseInt($scope.contentIndex)
	    });
	  };
	}]);

	app.controller("TranscriptionContentCtrl", ["$scope", "$state", "$mdDialog", "$stateParams", "transcription", "$window", function($scope, $state, $mdDialog, $stateParams, transcription, $window) {
	  console.log("content");
	  $scope.content = parseInt($stateParams.content);
	  $scope.$parent.content = $scope.content;
	  $scope.transcription = transcription;
	  $scope.transcription.$loaded(function() {
	    $scope.$parent.transcription = $scope.transcription;
	    return $scope.$parent.editedByCurrentUser = $scope.transcription.editedBy === $scope.$parent.auth.uid;
	  });
	  $scope.childState = $state.$current.name.split(".").reverse()[0];
	  return $scope.$parent.book.$loaded(function() {
	    return $scope.$parent.viewer.goToPage($scope.content - 1);
	  });
	}]);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./connect_services.coffee": 114,
		"./learn_services.coffee": 115,
		"./services.coffee": 121,
		"./transcription_services.coffee": 123,
		"./user_services.coffee": 124
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 113;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	var app, ref;

	app = angular.module("seismology");

	ref = firebase.database().ref();

	app.factory('Likable', ["$firebaseAuth", "Notification", "Users", function($firebaseAuth, Notification, Users) {
	  return {
	    notifyLiked: function() {
	      return console.log("notifyLiked: NOT IMPLEMENTED");
	    },
	    toggleLike: function() {
	      var targetUid, uid;
	      console.log("liked", this.likes);
	      uid = $firebaseAuth().$getAuth().uid;
	      targetUid = this.uid;
	      this.likes || (this.likes = {});
	      this.likes[uid] = !this.likes[uid];
	      return this.$save().then((function(_this) {
	        return function() {
	          if (_this.likes[uid]) {
	            _this.notifyLiked();
	            return Users.upvote(targetUid);
	          } else {
	            return Users.downvote(targetUid);
	          }
	        };
	      })(this));
	    },
	    likeCount: function() {
	      var bool, count, ref1, uid;
	      if (!this.likes) {
	        return 0;
	      }
	      count = 0;
	      ref1 = this.likes;
	      for (uid in ref1) {
	        bool = ref1[uid];
	        if (bool) {
	          count += 1;
	        }
	      }
	      return count;
	    },
	    likedByCurrentUser: function() {
	      if (!this.likes) {
	        return false;
	      }
	      return this.likes[$firebaseAuth().$getAuth().uid];
	    }
	  };
	}]);

	app.factory('Commentable', ["$firebaseObject", "$firebaseArray", "$firebaseAuth", "Notification", "Users", "ImageUpload", function($firebaseObject, $firebaseArray, $firebaseAuth, Notification, Users, ImageUpload) {
	  return {
	    notifyCommentCreated: function(comment) {
	      return console.log("notifyCommentCreated: NOT IMPLEMENTED");
	    },
	    notifyCommentLiked: function(comment) {
	      return console.log("notifyCommentLiked: NOT IMPLEMENTED");
	    },
	    commentArray: function() {
	      return $firebaseArray(this.$ref().child('comments'));
	    },
	    latestComment: function() {
	      var key, keys;
	      if (!this.comments) {
	        return null;
	      }
	      keys = Object.keys(this.comments);
	      key = keys[keys.length - 1];
	      return this.comments[key];
	    },
	    commentCount: function() {
	      if (!this.comments) {
	        return 0;
	      }
	      return Object.keys(this.comments).length;
	    },
	    addComment: function(comment) {
	      var comments, i, image, imageList, len, ref1;
	      if (comment == null) {
	        comment = {};
	      }
	      comment.uid = $firebaseAuth().$getAuth().uid;
	      comment.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      comments = $firebaseArray(this.$ref().child('comments'));
	      comment.images || (comment.images = []);
	      imageList = [];
	      ref1 = comment.images;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        image = ref1[i];
	        imageList.push({
	          file: image
	        });
	      }
	      return ImageUpload.uploadImageList(imageList).then((function(_this) {
	        return function(data) {
	          var d;
	          console.log("image upload success");
	          comment.images = (function() {
	            var j, len1, results;
	            results = [];
	            for (j = 0, len1 = data.length; j < len1; j++) {
	              d = data[j];
	              results.push(d.public_id);
	            }
	            return results;
	          })();
	          return comments.$add(comment).then(function(created) {
	            _this.updateCommentCount();
	            return _this.notifyCommentCreated(created);
	          });
	        };
	      })(this));
	    },
	    updateCommentCount: function() {
	      var comments;
	      comments = $firebaseArray(this.$ref().child('comments'));
	      return comments.$loaded((function(_this) {
	        return function() {
	          _this.commentSize = comments.length;
	          _this.rcommentSize = -comments.length;
	          _this.updateTimestamp = firebase.database.ServerValue.TIMESTAMP;
	          _this.updateRtimestamp = -Date.now();
	          return _this.$save();
	        };
	      })(this));
	    },
	    removeComment: function(key) {
	      var commentObj, commentRef;
	      commentRef = this.$ref().child('comments').child(key);
	      commentObj = $firebaseObject(commentRef);
	      return commentObj.$remove();
	    },
	    toggleLikeComment: function(key) {
	      var commentObj, commentRef, uid;
	      commentRef = this.$ref().child('comments').child(key);
	      commentObj = $firebaseObject(commentRef);
	      uid = $firebaseAuth().$getAuth().uid;
	      return commentObj.$loaded((function(_this) {
	        return function() {
	          var targetUid;
	          targetUid = commentObj.uid;
	          commentObj.likes || (commentObj.likes = {});
	          commentObj.likes[uid] = !commentObj.likes[uid];
	          commentObj.$save().then(function() {});
	          if (commentObj.likes[uid]) {
	            _this.notifyCommentLiked(commentObj);
	            return Users.upvote(targetUid);
	          } else {
	            return Users.downvote(targetUid);
	          }
	        };
	      })(this));
	    },
	    commentLikeCount: function(comment) {
	      var bool, count, ref1, uid;
	      if (!comment.likes) {
	        return 0;
	      }
	      count = 0;
	      ref1 = comment.likes;
	      for (uid in ref1) {
	        bool = ref1[uid];
	        if (bool) {
	          count += 1;
	        }
	      }
	      return count;
	    },
	    commentLikedByCurrentUser: function(comment) {
	      if (!comment.likes) {
	        return false;
	      }
	      return comment.likes[$firebaseAuth().$getAuth().uid];
	    }
	  };
	}]);

	app.factory("Post", ["$firebaseAuth", "$firebaseObject", "Users", "Commentable", "Likable", "Notification", function($firebaseAuth, $firebaseObject, Users, Commentable, Likable, Notification) {
	  var factory;
	  factory = angular.extend(angular.extend({}, Likable), Commentable);
	  factory.imageCount = function() {
	    if (!this.images) {
	      return 0;
	    }
	    return Object.keys(this.images).length;
	  };
	  factory.isCreatedBy = function(user) {
	    return user.$id === this.uid;
	  };
	  factory.getUser = function() {
	    return Users.get(this.uid);
	  };
	  factory.notifyLiked = function() {
	    var uid;
	    uid = $firebaseAuth().$getAuth().uid;
	    return Notification.postLiked(this.$id, uid);
	  };
	  factory.notifyCommentCreated = function(comment) {
	    return Notification.commentCreated(this.$id, comment.key);
	  };
	  factory.notifyCommentLiked = function(comment) {
	    var uid;
	    uid = $firebaseAuth().$getAuth().uid;
	    return Notification.commentLiked(this.$id, comment.$id, uid);
	  };
	  return $firebaseObject.$extend(factory);
	}]);

	app.factory("PostList", ["$firebaseArray", "Post", function($firebaseArray, Post) {
	  return $firebaseArray.$extend({
	    $$added: function(snap) {
	      return new Post(snap.ref);
	    },
	    $$updated: function(snap) {
	      return this.$getRecord(snap.key).$$updated(snap);
	    }
	  });
	}]);

	app.factory("PostFactory", ["$firebaseObject", "$firebaseArray", "$firebaseAuth", "ImageUpload", "CurrentUser", "PostList", "Post", "Notification", function($firebaseObject, $firebaseArray, $firebaseAuth, ImageUpload, CurrentUser, PostList, Post, Notification) {
	  var postsRef;
	  postsRef = ref.child('posts');
	  return {
	    getScroll: function() {
	      return new PostList(new firebase.util.Scroll(postsRef, 'rtimestamp'));
	    },
	    getListByUid: function(uid, limit) {
	      var query;
	      if (limit == null) {
	        limit = 20;
	      }
	      query = postsRef.orderByChild("uid").equalTo(uid);
	      return new PostList(query);
	    },
	    add: function(post, images) {
	      var i, image, imageList, len, list;
	      if (post == null) {
	        post = {};
	      }
	      if (images == null) {
	        images = [];
	      }
	      if (CurrentUser.get().blocked) {
	        return alert("質問の投稿はできません。");
	      }
	      post.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      post.rtimestamp = -Date.now();
	      post.uid = CurrentUser.get().$id;
	      list = $firebaseArray(postsRef);
	      console.log(post);
	      if (images.length > 0) {
	        imageList = [];
	        for (i = 0, len = images.length; i < len; i++) {
	          image = images[i];
	          imageList.push({
	            file: image
	          });
	        }
	        return ImageUpload.uploadImageList(imageList).then(function(data) {
	          var d;
	          console.log("image upload success");
	          post.images = (function() {
	            var j, len1, results;
	            results = [];
	            for (j = 0, len1 = data.length; j < len1; j++) {
	              d = data[j];
	              results.push(d.public_id);
	            }
	            return results;
	          })();
	          return list.$add(post);
	        });
	      } else {
	        return list.$add(post).then(function(postsRef) {
	          return console.log(postsRef);
	        });
	      }
	    },
	    get: function(id) {
	      return new Post(postsRef.child(id));
	    }
	  };
	}]);

	app.factory("ImageUpload", ["$q", "Upload", "CLOUDINARY_CONFIGS", function($q, Upload, CLOUDINARY_CONFIGS) {
	  return {
	    uploadImage: function(file) {
	      var data, deferred;
	      deferred = $q.defer();
	      data = {
	        file: file,
	        'upload_preset': CLOUDINARY_CONFIGS.UPLOAD_PRESET,
	        'public_id': Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7)
	      };
	      Upload.upload({
	        url: CLOUDINARY_CONFIGS.UPLOAD_URL,
	        data: data
	      }).then(function(success) {
	        console.log(success);
	        return deferred.resolve(success.data);
	      })["catch"](function(err) {
	        console.log(err);
	        return deferred.reject(err);
	      });
	      return deferred.promise;
	    },
	    uploadImageList: function(images) {
	      var promises;
	      promises = images.map((function(_this) {
	        return function(image) {
	          console.log("image", image);
	          return _this.uploadImage(image.file, image.public_id);
	        };
	      })(this));
	      return $q.all(promises);
	    }
	  };
	}]);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var app, ref;

	app = angular.module("seismology");

	ref = firebase.database().ref();

	app.factory('Chars', ["$firebaseArray", "$firebaseObject", function($firebaseArray, $firebaseObject) {
	  var charsRef;
	  charsRef = ref.child('chars');
	  return {
	    getByLessonId: function(lessonId) {
	      var query;
	      query = charsRef.orderByChild('lesson_id').equalTo(lessonId);
	      return $firebaseArray(query);
	    },
	    get: function(id) {
	      var query;
	      return $firebaseObject(query = charsRef.child(id));
	    }
	  };
	}]);

	app.factory('Lesson', ["LessonProgress", function(LessonProgress) {
	  var lessons;
	  lessons = [
	    {
	      id: 'lesson-01',
	      type: 'kana',
	      title: '変体仮名 その１（あ〜か行）',
	      img: 'resources/img/chars/ipa/586e63bec5efcbec52bc4ddf6f1fe679.png'
	    }, {
	      id: 'lesson-02',
	      type: 'kana',
	      title: '変体仮名 その２（さ〜た行）',
	      img: 'resources/img/chars/ipa/3b08ac60c20eed5dd7a3b981e9de32cf.png'
	    }, {
	      id: 'lesson-03',
	      type: 'kana',
	      title: '変体仮名 その３（な〜は行）',
	      img: 'resources/img/chars/ipa/495d6de66707c7ff395382b1d468ed86.png'
	    }, {
	      id: 'lesson-04',
	      type: 'kana',
	      title: '変体仮名 その４（ま〜や行）',
	      img: 'resources/img/chars/ipa/4c8f8f42b7a14f667774193d4ee348f7.png'
	    }, {
	      id: 'lesson-05',
	      type: 'kana',
	      title: '変体仮名 その５（ら行〜ん）',
	      img: 'resources/img/chars/ipa/727a873d36c01e372b819f51778b898c.png'
	    }, {
	      id: 'lesson-06',
	      type: 'kanji',
	      title: '漢字 その１',
	      img: 'resources/img/top/lesson06.jpg'
	    }, {
	      id: 'lesson-07',
	      type: 'kanji',
	      title: '漢字 その２',
	      img: 'resources/img/top/lesson07.jpg'
	    }, {
	      id: 'lesson-08',
	      type: 'kanji',
	      title: '漢字 その３',
	      img: 'resources/img/top/lesson08.jpg'
	    }, {
	      id: 'lesson-09',
	      type: 'kanji',
	      title: '漢字 その４',
	      img: 'resources/img/top/lesson09.jpg'
	    }, {
	      id: 'lesson-10',
	      type: 'kanji',
	      title: '漢字 その５',
	      img: 'resources/img/top/lesson10.jpg'
	    }, {
	      id: 'lesson-11',
	      type: 'kanji',
	      title: '漢字 その６',
	      img: 'resources/img/top/lesson11.jpg'
	    }, {
	      id: 'lesson-12',
	      type: 'kanji',
	      title: '漢字 その７',
	      img: 'resources/img/top/lesson12.jpg'
	    }, {
	      id: 'lesson-13',
	      type: 'kanji',
	      title: '漢字 その８',
	      img: 'resources/img/top/lesson13.jpg'
	    }, {
	      id: 'lesson-14',
	      type: 'kanji',
	      title: '漢字 その９',
	      img: 'resources/img/top/lesson14.jpg'
	    }
	  ];
	  return {
	    getKanaLessons: function() {
	      return lessons.filter(function(l) {
	        return l.type === 'kana';
	      });
	    },
	    getKanjiLessons: function() {
	      return lessons.filter(function(l) {
	        return l.type === 'kanji';
	      });
	    },
	    get: function(id) {
	      var k, l, len, lesson;
	      lesson = null;
	      for (k = 0, len = lessons.length; k < len; k++) {
	        l = lessons[k];
	        if (l.id === id) {
	          lesson = l;
	        }
	      }
	      return lesson;
	    },
	    getLessonCount: function() {
	      return Object.keys(lessons).length;
	    }
	  };
	}]);

	app.factory('QuizArrayFactory', ["$firebaseArray", "$firebaseObject", "Chars", "DakutenConverter", function($firebaseArray, $firebaseObject, Chars, DakutenConverter) {
	  var chooseRandom, fisherYates, generateAnswers, generateQuestionText;
	  fisherYates = function(arr) {
	    var i, j, ref1;
	    i = arr.length;
	    if (!(i > 0)) {
	      return arr;
	    }
	    while (--i) {
	      j = Math.floor(Math.random() * (i + 1));
	      ref1 = [arr[j], arr[i]], arr[i] = ref1[0], arr[j] = ref1[1];
	    }
	    return arr;
	  };
	  chooseRandom = function(arr) {
	    var index;
	    index = Math.floor(Math.random() * arr.length);
	    return arr[index];
	  };
	  generateAnswers = function(char, quiz, askAllChars) {
	    var answers, body, dakuten, odorijiRemoved, singleChar;
	    answers = [];
	    if (askAllChars) {
	      body = quiz.yomi.substr(1);
	      odorijiRemoved = body.replace(/(.)[ゝゞ]/g, function(all, match) {
	        return match;
	      });
	      answers = [body, odorijiRemoved];
	    } else {
	      singleChar = char.char.replace(/（.+）/g, '');
	      dakuten = DakutenConverter.convert2Dakuten(singleChar);
	      answers = [singleChar, dakuten];
	    }
	    return answers;
	  };
	  generateQuestionText = function(char, quiz, askAllChars) {
	    var body, dakuten, head, singleChar, text;
	    text = "";
	    if (askAllChars) {
	      head = quiz.yomi[0];
	      body = Array(quiz.yomi.length).join('■');
	      text = head + body;
	    } else {
	      singleChar = char.char.replace(/（.+）/g, '');
	      text = quiz.yomi.replace(singleChar, "■");
	      dakuten = DakutenConverter.convert2Dakuten(singleChar);
	      if (dakuten) {
	        text = text.replace(dakuten, "■");
	      }
	    }
	    return text;
	  };
	  return $firebaseArray.$extend({
	    shuffle: function() {
	      this.$list = fisherYates(this.$list);
	      return this;
	    },
	    getQuizAt: function(index, askAllChars) {
	      var char, examples, quiz;
	      if (askAllChars == null) {
	        askAllChars = false;
	      }
	      char = this.$list[index];
	      examples = char['usecases_multi'];
	      quiz = chooseRandom(examples);
	      quiz.char = char;
	      quiz.questionText = generateQuestionText(char, quiz, askAllChars);
	      quiz.answers = generateAnswers(char, quiz, askAllChars);
	      return quiz;
	    }
	  });
	}]);

	app.factory('Quiz', ["$sce", "QuizArrayFactory", "Chars", function($sce, QuizArrayFactory, Chars) {
	  var charsRef;
	  charsRef = ref.child('chars');
	  return {
	    getByLessonId: function(lessonId, size) {
	      var array, query;
	      if (size == null) {
	        size = 10;
	      }
	      query = charsRef.orderByChild('lesson_id').equalTo(lessonId);
	      array = QuizArrayFactory(query);
	      array.$loaded(function() {
	        return array.shuffle();
	      });
	      return array;
	    }
	  };
	}]);

	app.factory('QuizState', function() {
	  var checkAnswer, states;
	  checkAnswer = function(quiz) {
	    return quiz.current.answers.indexOf(quiz.input) >= 0;
	  };
	  states = {
	    asking: {
	      speech: function(quiz) {
	        if (quiz.askAllChars) {
	          return "■の部分は何て読むかな？<b>" + (quiz.current.yomi.length - 1) + "文字</b>で答えてね";
	        } else {
	          return "■の文字は何て読むかな？<b>１文字</b>で答えてね";
	        }
	      },
	      img: "./resources/img/shimimaru/04.png",
	      input: true,
	      placeholder: '回答を入力',
	      hideAnswer: true,
	      next: function(quiz) {
	        if (checkAnswer(quiz)) {
	          quiz.correct += 1;
	          quiz.input = "";
	          return 'correct';
	        } else {
	          quiz.input = "";
	          return 'incorrect';
	        }
	      }
	    },
	    correct: {
	      speech: function(quiz) {
	        if (quiz.askAllChars) {
	          return "正解！「<b>" + quiz.current.yomi + "</b>」だね。";
	        } else {
	          return "正解！「<b>" + quiz.current.char.char + "</b>」だね。";
	        }
	      },
	      img: "./resources/img/shimimaru/14.png",
	      bgClass: "correct",
	      next: function(quiz) {
	        quiz.progress += 1;
	        if (quiz.progress >= quiz.size) {
	          return 'finishing';
	        } else {
	          quiz.current = quiz.quizArray.getQuizAt(quiz.progress, quiz.askAllChars);
	          return 'asking';
	        }
	      }
	    },
	    incorrect: {
	      speech: function(quiz) {
	        if (quiz.askAllChars) {
	          return "残念。正解は「<b>" + quiz.current.yomi + "</b>」だよ。";
	        } else {
	          return "残念。正解は「<b>" + quiz.current.char.char + "</b>」だよ。";
	        }
	      },
	      img: "./resources/img/shimimaru/05.png",
	      bgClass: "incorrect",
	      next: function(quiz) {
	        quiz.progress += 1;
	        if (quiz.progress >= quiz.size) {
	          return 'finishing';
	        } else {
	          quiz.current = quiz.quizArray.getQuizAt(quiz.progress, quiz.askAllChars);
	          return 'asking';
	        }
	      }
	    },
	    finishing: {
	      speech: function(quiz) {
	        return "お疲れさま！ これでテストは終了だよ。今回の結果は…";
	      },
	      waitFor: 2000,
	      img: "./resources/img/shimimaru/01.png",
	      next: function(quiz) {
	        var correctRatio;
	        correctRatio = quiz.correct / (quiz.size * 1.0);
	        if (correctRatio === 1) {
	          return 'resultPerfect';
	        } else if (correctRatio >= 0.8) {
	          return 'resultGood';
	        } else if (correctRatio > 0.4) {
	          return 'resultModerate';
	        } else {
	          return 'resultBad';
	        }
	      }
	    },
	    resultPerfect: {
	      speech: function(quiz) {
	        return "<b>" + quiz.size + "問全問正解</b>だ！ 完璧だね。";
	      },
	      waitFor: 2000,
	      img: "./resources/img/shimimaru/02.png",
	      next: function(quiz) {
	        return "end";
	      },
	      isCleared: true
	    },
	    resultGood: {
	      speech: function(quiz) {
	        return "<b>" + quiz.size + "問中" + quiz.correct + "問正解</b>。よくできました！";
	      },
	      waitFor: 3000,
	      img: "./resources/img/shimimaru/14.png",
	      next: function(quiz) {
	        return "end";
	      },
	      isCleared: true
	    },
	    resultModerate: {
	      speech: function(quiz) {
	        return "<b>" + quiz.size + "問中" + quiz.correct + "問正解</b>。まあまあだね。";
	      },
	      waitFor: 3000,
	      img: "./resources/img/shimimaru/06.png",
	      next: function(quiz) {
	        return "end";
	      }
	    },
	    resultBad: {
	      speech: function(quiz) {
	        return "</b>" + quiz.size + "問中" + quiz.correct + "問正解</b>。もう少し頑張って、再挑戦してね！";
	      },
	      waitFor: 3000,
	      img: "./resources/img/shimimaru/03.png",
	      next: function(quiz) {
	        return "end";
	      }
	    },
	    end: {
	      speech: function(quiz) {
	        return "テストを繰り返して、字形をしっかり覚えよう！";
	      },
	      img: "./resources/img/shimimaru/13.png",
	      showCloseButton: true
	    }
	  };
	  this.state = states.asking;
	  return {
	    getState: function() {
	      return this.state;
	    },
	    setState: function(key) {
	      return this.state = states[key];
	    },
	    proceed: function(quiz) {
	      var key;
	      key = this.state.next(quiz);
	      this.state = states[key];
	      return this.state;
	    },
	    getSpeech: function(quiz) {
	      var html;
	      html = $sce.trustAsHtml(this.state.speech(quiz));
	      return html;
	    }
	  };
	});

	app.factory("DakutenConverter", function() {
	  var dakuten, kana;
	  dakuten = "がぎぐけござじずぜぞだぢづでどばびぶべぼ";
	  kana = "かきくけこさしすせそたちつてとはひふへほ";
	  return {
	    convert2Kana: function(char) {
	      return kana.charAt(dakuten.indexOf(char));
	    },
	    convert2Dakuten: function(char) {
	      return dakuten.charAt(kana.indexOf(char));
	    },
	    isDakuten: function(char) {
	      return dakuten.indexOf(char) >= 0;
	    }
	  };
	});

	app.factory('LessonProgress', ["$firebaseObject", "$firebaseArray", "CurrentUser", "NotificationMsg", function($firebaseObject, $firebaseArray, CurrentUser, NotificationMsg) {
	  var progressRef, uid;
	  uid = CurrentUser.get().$id;
	  progressRef = ref.child('lesson-progress').child(uid);
	  return {
	    getList: function() {
	      return $firebaseArray(progressRef);
	    },
	    getListOf: function(uid) {
	      progressRef = ref.child('lesson-progress').child(uid);
	      return $firebaseArray(progressRef);
	    },
	    get: function(lessonId) {
	      return $firebaseObject(progressRef.child(lessonId));
	    },
	    setGemCount: function(lessonId, count) {
	      return progressRef.child(lessonId).transaction(function(currentCount) {
	        var newCount;
	        if (!currentCount || currentCount < count) {
	          newCount = count;
	        } else {
	          newCount = currentCount;
	        }
	        return newCount;
	      });
	    },
	    getGemCount: function() {
	      return this.getList().$loaded().then(function(progressList) {
	        var gemCount, k, l, len;
	        gemCount = 0;
	        for (k = 0, len = progressList.length; k < len; k++) {
	          l = progressList[k];
	          gemCount += l.$value;
	        }
	        return gemCount;
	      });
	    }
	  };
	}]);

	app.factory("TutorialDialog", ["$mdDialog", function($mdDialog) {
	  return {
	    show: function(number) {
	      var speech;
	      speech = __webpack_require__(116)("./learn_tutorial_" + number + ".tsv");
	      return $mdDialog.show({
	        controller: 'TutorialDialogCtrl',
	        parent: angular.element(document.body),
	        clickOutsideToClose: true,
	        templateUrl: 'templates/dialogs/tutorial.html',
	        locals: {
	          speech: speech
	        }
	      });
	    }
	  };
	}]);

	app.factory('NotificationMsg', ["$mdToast", function($mdToast) {
	  return {
	    show: function(msg) {
	      return $mdToast.show({
	        hideDelay: 3000,
	        position: 'bottom right',
	        templateUrl: 'templates/kula/message-toast.html',
	        controller: ["$mdToast", "$scope", function($mdToast, $scope) {
	          return $scope.msg = msg;
	        }]
	      });
	    }
	  };
	}]);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./learn_tutorial_0.tsv": 117,
		"./learn_tutorial_1.tsv": 118,
		"./learn_tutorial_2.tsv": 119,
		"./learn_tutorial_3.tsv": 120
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	var res = [{"header":"自己紹介","expression":"./resources/img/shimimaru/04.png","text":"こんにちは！<br/> このサイトの案内人（人？）<b>しみまる</b>です。どうぞよろしく！<br/><span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/02.png","text":"「みんなで翻刻」は<span class='blink'>▼</span>","image":"busho.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/05.png","text":"浮世絵の中に、文字が書かれているのをみたことがある？<span class='blink'>▼</span>","image":"ukiyoe.png"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/15.png","text":"これらは仮名や漢字で書かれているはずなのに、今とは違う姿をしていて、解説がなくては読めないことが多いよね！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/03.png","text":"街のお寿司屋さんやお蕎麦屋さんの看板が、変わった文字で書かれているのをみたことがない？<span class='blink'>▼</span>","image":"soba.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/04.png","text":"お箸の袋のこんな字は？漢字で書くと“御手茂登”、“茂”と“登”は変体仮名というもので、“おてもと”と読むんだ。<span class='blink'>▼</span>","image":"otemoto.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/07.png","text":"これらは、昔使われていた仮名や漢字の書き方で、その書き方でかかれた文字を「くずし字」と呼ぶんだよ！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/01.png","text":"「くずし字」の多くは御家流という流派の書体なんだ。武士の公式文書がこの書体で書かれたために一般にも普及し、長いこと日本の標準書体だったんだ。<span class='blink'>▼</span>","image":""},{"header":"レッスン完了！","expression":"./resources/img/shimimaru/13.png","text":"これで最初のレッスンは終了だよ。さあ次のレッスンに進もう！<span class='blink'>▼</span>","image":""}];res.columns = ["header","expression","text","image"];module.exports = res;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	var res = [{"header":"自己紹介","expression":"./resources/img/shimimaru/04.png","text":"こんにちは！<br/> ぼく、「<b>しみまる</b>」です。どうぞよろしく！<br/> 「みんなで翻刻」の案内役だよ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/02.png","text":"きみは、戦国武将の手紙をみたことがあるかな？<span class='blink'>▼</span>","image":"busho.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/05.png","text":"浮世絵の中に、文字が書かれているのをみたことがある？<span class='blink'>▼</span>","image":"ukiyoe.png"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/15.png","text":"これらは仮名や漢字で書かれているはずなのに、今とは違う姿をしていて、解説がなくては読めないことが多いよね！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/03.png","text":"街のお寿司屋さんやお蕎麦屋さんの看板が、変わった文字で書かれているのをみたことがない？<span class='blink'>▼</span>","image":"soba.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/04.png","text":"お箸の袋のこんな字は？漢字で書くと“御手茂登”、“茂”と“登”は変体仮名というもので、“おてもと”と読むんだ。<span class='blink'>▼</span>","image":"otemoto.jpg"},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/07.png","text":"これらは、昔使われていた仮名や漢字の書き方で、その書き方でかかれた文字を「くずし字」と呼ぶんだよ！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」とは","expression":"./resources/img/shimimaru/01.png","text":"「くずし字」の多くは御家流という流派の書体なんだ。武士の公式文書がこの書体で書かれたために一般にも普及し、長いこと日本の標準書体だったんだ。<span class='blink'>▼</span>","image":""},{"header":"レッスン完了！","expression":"./resources/img/shimimaru/13.png","text":"これで最初のレッスンは終了だよ。さあ次のレッスンに進もう！<span class='blink'>▼</span>","image":""}];res.columns = ["header","expression","text","image"];module.exports = res;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	var res = [{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/02.png","text":"右の画像は江戸時代に寺子屋で教科書として使われていたものだよ。現在一般的に使われている楷書体ではなく、初めからくずし字で読み書きを習っていたそうなんだ。<span class='blink'>▼</span>","image":"jitugo.jpg"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/01.png","text":"この「みんなで翻刻!地震史料」に入っている『諸国海辺地震津波書』は民衆向けに出版されたものだけど、くずし字で書かれていて、難しい漢字にはルビが振られているね。<span class='blink'>▼</span>","image":"shokoku.jpg"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/05.png","text":"江戸時代の人たちは識字率も高く、文字といえばくずし字が一般的だったんだ。<span class='blink'>▼</span>","image":"terakoya.jpg"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/06.png","text":"明治に入って現在のような活字が広まっても、くずし字は使われ続ける。それだけ人々に馴染み深いものだったんだ。<span class='blink'>▼</span>","image":"oushu.jpg"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/14.png","text":"昭和に入ってからも手書きの文章や日記などで用いられ続け、くずし字で書かれたものが多く残っているよ。<span class='blink'>▼</span>","image":"watuji.jpg"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/03.png","text":"でも現在では、書家など一部の人たちを除いて、くずし字を日常的に使う人はあまりいなくなってしまったんだ。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/12.png","text":"学校や家庭でくずし字を学ばないし、くずし字で書かれたものに触れる機会もほとんどないから、読んだり書いたりできないのは当然だよね。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/08.png","text":"さらに最近では、パソコンやスマホ、プリンターの普及で、文字を手書きする機会すら少なくなってしまったね。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/01.png","text":"だけど日本人は昔からずっと、くずし字を使い続けてきたから、多くの文章はくずし字で書かれているんだ。これらの中には、まだ活字化されていない文学作品や貴重書がいっぱいある。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/11.png","text":"こうした多くの古典籍が読めるようになったら楽しいと思わない？<br/>歴史や文化、教訓がつまった先祖からの贈り物が、読めないために活かされないのはもったいないよね！？<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/07.png","text":"だれも読まないなら、僕が食べてしまうよ！？<span class='blink'>▼</span>","image":"onsenyuraiki.png"},{"header":"なぜ「くずし字」が読めないのか：歴史編","expression":"./resources/img/shimimaru/14.png","text":"くずし字を学んで、古典籍が読めるようになると、新しい発見があるかもしれないね。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：仮名編","expression":"./resources/img/shimimaru/01.png","text":"ひらがな（仮名）は、漢字がもとになってできている文字だよ。<br/>たとえば、「あ」は、「安」という漢字をくずしてできた仮名なんだ。<span class='blink'>▼</span>","image":"149_a.jpg"},{"header":"なぜ「くずし字」が読めないのか：仮名編","expression":"./resources/img/shimimaru/02.png","text":"この、元になっている漢字を「字母（じぼ）」っていうんだ。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：仮名編","expression":"./resources/img/shimimaru/05.png","text":"たとえば、今の「安」からつくられた「あ」だけでなく、「阿」・「悪」・「愛」などを字母とするくずし字がつかわれていたんだよね。<span class='blink'>▼</span>","image":"625_a.jpg"},{"header":"なぜ「くずし字」が読めないのか：仮名編","expression":"./resources/img/shimimaru/03.png","text":"また、同じ字母からも、くずし具合やくずし方によって、数種類の「くずし字」が生まれたんだよ。<br/>今はそれぞれのひらがながひとつの形しかないから、「くずし字」で書かれた文章を読むのが難しいんだね。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/01.png","text":"漢字の中には、ぼくたちが一般的に用いている「楷書体」のほかに、「草書体」や「行書体」と呼ばれる書き方で書かれている字体があるんだ。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/14.png","text":"それらは字画を省略して書いたもので、「くずし字」と呼ばれているんだよ。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/15.png","text":"それらの中には、「楷書体」とあまり変わらないものもあるけど、全く違う形をしているものもあるんだ。<span class='blink'>▼</span>","image":""},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/02.png","text":"縦書きでスムーズに書くために、みんなの知っている書き順と違うことも多いよ。<span class='blink'>▼</span>","image":"hon.png"},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/12.png","text":"さらに旧字体や異体字など、現代のぼくたちには馴染みのない漢字も普通に使われているんだ。旧字体を前提としたくずし字も多いね。<span class='blink'>▼</span>","image":"den.png"},{"header":"なぜ「くずし字」が読めないのか：漢字編","expression":"./resources/img/shimimaru/10.png","text":"くずし方のパターンが決まっているものもあれば、元の形を大きくくずしている文字もあるから、それらを覚えていないと読むことが難しいんだ！<span class='blink'>▼</span>","image":""},{"header":"レッスン完了！","expression":"./resources/img/shimimaru/04.png","text":"これで2つめのレッスンも終わりだ！さあ次のレッスンに進もう。<span class='blink'>▼</span>","image":""}];res.columns = ["header","expression","text","image"];module.exports = res;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	var res = [{"header":"「くずし字」の文章を読むために：仮名と漢字","expression":"./resources/img/shimimaru/07.png","text":"「くずし字」で書かれた文章は、今では馴染みのない形の仮名（変体仮名）や漢字が使われているんだ。<br/>このような文章を読むためには・・・<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：仮名と漢字","expression":"./resources/img/shimimaru/11.png","text":"① 仮名の字母と、それに対応する変体仮名を覚えよう！<br/>仮名が多い文章や、漢字にふりがなを付した文章がだいたい読めるようになるよ！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：仮名と漢字","expression":"./resources/img/shimimaru/13.png","text":"練習問題機能で覚えたら、力だめしに、仮名で書かれた文章を読んでみよう。ここでは『福嶋縣岩代国　ばんだいさん一ツトセぶし』<br/>が良いかもね。<span class='blink'>▼</span>","image":"bandaisan.jpg"},{"header":"「くずし字」の文章を読むために：仮名と漢字","expression":"./resources/img/shimimaru/01.png","text":"② よく出てくる漢字の形を覚えよう！<br/>　漢字と仮名が交じっている文章がだいたい読めるようになるよ！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：仮名と漢字","expression":"./resources/img/shimimaru/04.png","text":"練習問題機能で覚えたら、力だめしに、漢字と仮名の交じった文章を読んでみよう。<br/>漢字にふり仮名が振ってある文章は練習にピッタリだね。ここでは『鎮火用心集　全』がおすすめ。<span class='blink'>▼</span>","image":"tinka.jpg"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/01.png","text":"③ 特殊な文字にも挑戦してみよう！<br/>むずかしい漢字や、大きくくずされた文字などがあるよ。<br/>練習問題で練習してみよう。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/02.png","text":"くずし字で書かれた文章では、繰り返しの記号が使われることが多いよ！<br/>この記号を、「踊り字」と呼ぶんだ！今でも使われているものもあるね。<span class='blink'>▼</span>","image":"odori.png"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/06.png","text":"この真ん中の、点みたいな記号は、直前の１文字を繰り返す時につかう踊り字だよ！<br/>この画像では、「か」を繰り返して「かかえ」と読むんだ。<span class='blink'>▼</span>","image":"kakae.jpg"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/14.png","text":"大きな「く」みたいな記号は、直前の２文字を繰り返す踊り字だよ！<br/>この画像では、「いよ」を繰り返して「いよいよ」と読むんだ。<span class='blink'>▼</span>","image":"iyoiyo.jpg"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/11.png","text":"踊り字には、濁点のついているものもあるよ！<br/>この画像では、「つね」を繰り返して「つねづね」と読むんだ。<span class='blink'>▼</span>","image":"tunedune.jpg"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/01.png","text":"また、文中には“合字”と呼ばれる文字が使われているんだ。いちばん有名なのが“ゟ”だね。<br/>これは平仮名の“よ”と“り”を合わせた字で、そのまま“より”と読むんだ。<span class='blink'>▼</span>","image":"yori.png"},{"header":"「くずし字」の文章を読むために：特殊な文字","expression":"./resources/img/shimimaru/12.png","text":"合字には他にも、片仮名の“コ”と“ト”をあわせた“ヿ”(こと)や、ト”と“キ”を合わせたものもあるね。<span class='blink'>▼</span>","image":"kanpo.jpg"},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/11.png","text":"練習を重ねるうちに、自分が苦手な文字（似ていて見分けにくいなど）がわかってくるから、そこを何度も練習することで、スムースに読めるようになるよ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/01.png","text":"また、くずし字は見て覚えるだけでなく、書いてみると良い練習になるよ。筆ペンなどで字をまねしてみよう！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/11.png","text":"わからない字を書いてみると、筆運びが理解できて解読につながることもあるんだ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/13.png","text":"ある程度覚えたら、文章を読んでみよう！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/13.png","text":"文章を読むためには、古語や古典文法の知識も必要だけど、一番大切なのは、とにかく何度も練習することだよ！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/11.png","text":"文章の中には、同じ文字が何度も出てくる場合があるから、最初は読めなかった文字が、読み進めるにしたがって読めるようになることもあるんだ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/06.png","text":"とくに、筆者に特有の書き方のクセがあって、一般的なくずし方で書かれていない場合もあるんだ。現代のぼくたちと同じだね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ①","expression":"./resources/img/shimimaru/11.png","text":"そういう時も、わからない字をチェックしておくと、後から同じ字が出てきて、パズルみたいに全部が解けることもあるんだ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/14.png","text":"わからない文字を、文脈から推測することもできるから、慣れるといろいろな文章を読むことができるようになる！<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/01.png","text":"違う字でもソックリなくずし方をする字もあるから気をつけてね。そういう時も文脈から判断して、シックリくる字を当てはめると良いんだ。<span class='blink'>▼</span>","image":"niteru.png"},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/05.png","text":"よく出てくる、“斗”は“計”と同じくずし方をするんだ。文脈にあわせて、どちらの意味なのか判断しよう。<span class='blink'>▼</span>","image":"bouka.jpg"},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/01.png","text":"さらに、偏(へん)や旁(つくり)のくずし方を覚えてしまうと便利だよ！<br/>全体がわからなくても、部分的に何の字が使われているかわかれば、候補がかなり絞り込めるよね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/04.png","text":"漢字の部品がわかったら、パソコンの手書き認識機能を使って、字の大まかな形から候補を抽出することもできるね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/10.png","text":"それから“〇衛門”とか“×之助”とか、よく人名に使われる漢字をおさえておくと役に立つんだ。<br/><span class='blink'>▼</span>","image":"shinshujishin.png"},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/04.png","text":"とくに、武士に多い“〇〇守”という官職名の〇〇には旧国名が入ることが多いんだ。<span class='blink'>▼</span>","image":"annseisokusai.jpg"},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/02.png","text":"次の官職名を読んでみよう！<br/>掃部頭・雅楽頭・采女正・内蔵助・縫殿助・主計助・・・いくつ読めたかな？<br/><br/>むずかしい官職名は字とともに読み方も要チェックだ！！調べてみよう。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/01.png","text":"街道の宿場名などの地名は、近くの地名が連続していることも多い。宿場の順番を調べてみよう。現代の地図に載ってない場合は、古地図も手がかりになるよ。<span class='blink'>▼</span>","image":"kaihoukai.jpg"},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/01.png","text":"そして必須アイテムは「くずし字辞典」！翻刻のプロを目指すなら手元にあった方が便利だね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/15.png","text":"最近は、辞典を買わなくても、「木簡字典・電子くずし字字典」などネット上で便利に調べられるサイトも充実しているね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/06.png","text":"でも、この「みんなで翻刻！」には、“つながる”機能や、“トーク”機能が実装されていて、わからない字を投稿してみんなに回答してもらったり、相談することができるんだ。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：解読のコツ②","expression":"./resources/img/shimimaru/14.png","text":"たくさんのユーザーが助けてくれるから、楽しく交流しながら、くずし字の学習や翻刻ができるね。<span class='blink'>▼</span>","image":""},{"header":"「くずし字」の文章を読むために：おわりに","expression":"./resources/img/shimimaru/13.png","text":"そしたら、ぼくの案内はここまでだよ。<br/>どんどん実力を上げて、たくさんの文書を翻刻したら、翻刻文字数ランキングのトップも夢じゃないよ！<br/>慣れてきたら、難易度の高い史料にも挑戦だ！！！<span class='blink'>▼</span>","image":""},{"header":"レッスン完了！","expression":"./resources/img/shimimaru/07.png","text":"これで最後のレッスンも終了。ここからは、実際のくずし字を見て字形を覚えよう！<span class='blink'>▼</span>","image":""}];res.columns = ["header","expression","text","image"];module.exports = res;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var app, ref;

	app = angular.module("seismology");

	ref = firebase.database().ref();

	app.factory("DailyStats", ["$firebaseObject", "$firebaseArray", "Users", function($firebaseObject, $firebaseArray, Users) {
	  var statsRef;
	  statsRef = ref.child('daily-stats');
	  return {
	    get: function(key) {
	      return $firebaseObject(statsRef.child(key));
	    },
	    getRecent: function(days) {
	      if (days == null) {
	        days = 1;
	      }
	      return $firebaseArray(statsRef.limitToLast(days));
	    }
	  };
	}]);

	app.factory("DiscussionCategories", function() {
	  return {
	    news: {
	      name: 'お知らせ',
	      value: 'news',
	      cls: 'bg-balanced'
	    },
	    question: {
	      name: '質問',
	      value: 'question',
	      cls: 'bg-positive'
	    },
	    information: {
	      name: '情報提供',
	      value: 'information',
	      cls: 'bg-calm'
	    },
	    bug: {
	      name: '不具合報告',
	      value: 'bug',
	      cls: 'bg-assertive'
	    },
	    request: {
	      name: '機能改善要望',
	      value: 'request',
	      cls: 'bg-energized'
	    },
	    others: {
	      name: 'その他',
	      value: 'others',
	      cls: 'bg-royal'
	    }
	  };
	});

	app.factory("Discussion", ["$firebaseObject", "$firebaseArray", "$firebaseAuth", "Commentable", "Likable", "Notification", "DiscussionCategories", function($firebaseObject, $firebaseArray, $firebaseAuth, Commentable, Likable, Notification, DiscussionCategories) {
	  var factory;
	  factory = angular.extend(angular.extend({}, Likable), Commentable);
	  factory.imageCount = function() {
	    if (!this.images) {
	      return 0;
	    }
	    return Object.keys(this.images).length;
	  };
	  factory.isCreatedBy = function(user) {
	    return user.$id === this.uid;
	  };
	  factory.getUser = function() {
	    return Users.get(this.uid);
	  };
	  factory.notifyLiked = function() {
	    var uid;
	    uid = $firebaseAuth().$getAuth().uid;
	    return Notification.discussionLiked(this.$id, uid);
	  };
	  factory.notifyCommentCreated = function(comment) {
	    return Notification.discussionCommentCreated(this.$id, comment.key);
	  };
	  factory.notifyCommentLiked = function(comment) {
	    var uid;
	    uid = $firebaseAuth().$getAuth().uid;
	    return Notification.discussionCommentLiked(this.$id, comment.$id, uid);
	  };
	  factory.getCategory = function() {
	    return DiscussionCategories[this.category];
	  };
	  return $firebaseObject.$extend(factory);
	}]);

	app.factory("DiscussionList", ["$firebaseArray", "Discussion", function($firebaseArray, Discussion) {
	  return $firebaseArray.$extend({
	    $$added: function(snap) {
	      return new Discussion(snap.ref);
	    },
	    $$updated: function(snap) {
	      return this.$getRecord(snap.key).$$updated(snap);
	    }
	  });
	}]);

	app.factory("DiscussionFactory", ["$firebaseArray", "DiscussionList", "CurrentUser", "ImageUpload", "Discussion", function($firebaseArray, DiscussionList, CurrentUser, ImageUpload, Discussion) {
	  var discussionsRef;
	  discussionsRef = ref.child('discussions');
	  return {
	    add: function(discussion, images) {
	      var i, image, imageList, len, list;
	      if (discussion == null) {
	        discussion = {};
	      }
	      if (images == null) {
	        images = [];
	      }
	      if (CurrentUser.get().blocked) {
	        return alert("質問の投稿はできません。");
	      }
	      discussion.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      discussion.rtimestamp = -Date.now();
	      discussion.updateTimestamp = firebase.database.ServerValue.TIMESTAMP;
	      discussion.updateRtimestamp = -Date.now();
	      discussion.commentSize = 0;
	      discussion.rcommentSize = 0;
	      discussion.uid = CurrentUser.get().$id;
	      list = $firebaseArray(discussionsRef);
	      if (images.length > 0) {
	        imageList = [];
	        for (i = 0, len = images.length; i < len; i++) {
	          image = images[i];
	          imageList.push({
	            file: image
	          });
	        }
	        return ImageUpload.uploadImageList(imageList).then(function(data) {
	          var d;
	          console.log("image upload success");
	          discussion.images = (function() {
	            var j, len1, results;
	            results = [];
	            for (j = 0, len1 = data.length; j < len1; j++) {
	              d = data[j];
	              results.push(d.public_id);
	            }
	            return results;
	          })();
	          return list.$add(discussion);
	        });
	      } else {
	        return list.$add(discussion).then(function(discussionsRef) {
	          return console.log(discussionsRef);
	        });
	      }
	    },
	    get: function(id) {
	      return new Discussion(discussionsRef.child(id));
	    },
	    getLatest: function() {
	      return new DiscussionList(new firebase.util.Scroll(discussionsRef, 'rtimestamp'));
	    },
	    getPopular: function() {
	      return new DiscussionList(new firebase.util.Scroll(discussionsRef, 'rcommentSize'));
	    },
	    getUpdated: function() {
	      return new DiscussionList(new firebase.util.Scroll(discussionsRef, 'updateRtimestamp'));
	    }
	  };
	}]);

	app.factory("BookFactory", ["$firebaseObject", "$firebaseArray", "Users", function($firebaseObject, $firebaseArray, Users) {
	  return $firebaseObject.$extend({
	    size: function() {
	      if (this.images) {
	        return this.images.length;
	      } else {
	        return 0;
	      }
	    },
	    toggleFav: function() {
	      var user;
	      user = Users.current();
	      user.favs || (user.favs = {});
	      if (user.favs[this.$id]) {
	        delete user.favs[this.$id];
	      } else {
	        user.favs[this.$id] = true;
	      }
	      return user.$save();
	    },
	    isFaved: function() {
	      return Users.current().favs[this.$id];
	    },
	    updateProgress: function() {
	      var finished;
	      finished = $firebaseArray(ref.child('transcriptions').child(this.$id).orderByChild('status').equalTo('finished'));
	      return finished.$loaded((function(_this) {
	        return function() {
	          console.log(finished.length);
	          _this.progress = finished.length;
	          return _this.$save();
	        };
	      })(this));
	    },
	    progressPrecentage: function() {
	      if (!this.progress) {
	        return 0;
	      }
	      return (this.progress / this.size) * 100;
	    }
	  });
	}]);

	app.factory("Books", ["$firebaseArray", "BookFactory", function($firebaseArray, BookFactory) {
	  var bookRef;
	  bookRef = ref.child('books');
	  return {
	    all: function() {
	      return $firebaseArray(bookRef.orderByChild('difficulty'));
	    },
	    getByStage: function(stageNum) {
	      return $firebaseArray(bookRef.orderByChild('stage').equalTo(stageNum));
	    },
	    get: function(id) {
	      return new BookFactory(bookRef.child(id));
	    }
	  };
	}]);

	app.factory("UserFavs", ["$firebaseArray", "$firebaseObject", "$firebaseAuth", "$firebaseUtils", function($firebaseArray, $firebaseObject, $firebaseAuth, $firebaseUtils) {
	  var UserFav;
	  UserFav = $firebaseObject.$extend({
	    toggle: function() {
	      return this.$loaded(function(fav) {
	        if (fav.$value) {
	          return fav.$remove();
	        } else {
	          fav.$value = true;
	          return fav.$save();
	        }
	      });
	    },
	    bookId: function() {
	      return this.$id;
	    }
	  });
	  return {
	    getRef: function() {
	      var uid;
	      uid = $firebaseAuth().$getAuth().uid;
	      return ref.child('users').child(uid).child('favs');
	    },
	    getList: function() {
	      return $firebaseArray(this.getRef());
	    },
	    getFav: function(bookId) {
	      return new UserFav(this.getRef().child(bookId));
	    }
	  };
	}]);

	app.factory("UserEditing", ["$firebaseArray", "$firebaseAuth", function($firebaseArray, $firebaseAuth) {
	  return {
	    getList: function() {
	      var editingRef, uid;
	      console.log("getlist");
	      uid = $firebaseAuth().$getAuth().uid;
	      console.log(uid);
	      editingRef = ref.child('users').child(uid).child('editing');
	      console.log(editingRef);
	      return $firebaseArray(editingRef);
	    }
	  };
	}]);

	app.factory("ForumFactory", ["$firebaseArray", "$firebaseAuth", function($firebaseArray, $firebaseAuth) {
	  return $firebaseArray.$extend({
	    addMessage: function(text) {
	      return this.$add({
	        text: text,
	        uid: $firebaseAuth().$getAuth().uid,
	        timestamp: firebase.database.ServerValue.TIMESTAMP
	      });
	    }
	  });
	}]);

	app.factory("ForumMessageList", ["$firebaseArray", "$firebaseAuth", "ForumFactory", function($firebaseArray, $firebaseAuth, ForumFactory) {
	  var forumsRef;
	  forumsRef = ref.child('forum');
	  return {
	    get: function(bookId, size) {
	      var forumRef;
	      if (size == null) {
	        size = 20;
	      }
	      forumRef = forumsRef.child(bookId).orderByChild("timestamp").limitToLast(size);
	      return new ForumFactory(forumRef);
	    }
	  };
	}]);

	app.factory("TimelineEvent", ["$firebaseObject", "$firebaseAuth", "Likable", "Notification", function($firebaseObject, $firebaseAuth, Likable, Notification) {
	  var factory;
	  factory = angular.extend({}, Likable);
	  factory.notifyLiked = function() {
	    return Notification.timelineEventLiked(this.$id);
	  };
	  return $firebaseObject.$extend(factory);
	}]);

	app.factory("TimelineList", ["$firebaseArray", "TimelineEvent", "Notification", function($firebaseArray, TimelineEvent, Notification) {
	  return $firebaseArray.$extend({
	    $$added: function(snap) {
	      return new TimelineEvent(snap.ref);
	    },
	    $$updated: function(snap) {
	      return this.$getRecord(snap.key).$$updated(snap);
	    }
	  });
	}]);

	app.factory("Timeline", ["$firebaseArray", "$firebaseAuth", "TimelineList", "Notification", function($firebaseArray, $firebaseAuth, TimelineList, Notification) {
	  var timelineRef;
	  timelineRef = ref.child('timeline');
	  return {
	    getList: function(limit) {
	      if (limit == null) {
	        limit = 30;
	      }
	      return new TimelineList(timelineRef.orderByChild('shared').equalTo(true).limitToLast(limit));
	    },
	    getListByCode: function(code, limit) {
	      var query;
	      if (limit == null) {
	        limit = 100;
	      }
	      query = timelineRef.orderByChild('code').equalTo(code).limitToLast(limit);
	      return new TimelineList(query);
	    },
	    getListByUid: function(uid, limit) {
	      var query;
	      if (limit == null) {
	        limit = 100;
	      }
	      query = timelineRef.orderByChild('uid').equalTo(uid).limitToLast(limit);
	      return new TimelineList(query);
	    },
	    $add: function(data) {
	      if (data == null) {
	        data = {};
	      }
	      data.uid = $firebaseAuth().$getAuth().uid;
	      data.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      return this.getList().$add(data).then((function(_this) {
	        return function(eventRef) {
	          return _this.notifyCreated(eventRef.key, data.code);
	        };
	      })(this));
	    },
	    notifyCreated: function(eventId, code) {
	      return this.getListByCode(code).$loaded(function(list) {
	        var event, hash, i, len, predesessorIds;
	        hash = {};
	        for (i = 0, len = list.length; i < len; i++) {
	          event = list[i];
	          hash[event.uid] = true;
	        }
	        predesessorIds = Object.keys(hash);
	        console.log('func', Notification);
	        return Notification.timelineEventCreated(eventId, predesessorIds);
	      });
	    }
	  };
	}]);

	app.factory("Quakes", function() {
	  var Quake, rows;
	  Quake = (function() {
	    function Quake(data) {
	      this.data = data;
	      this.setDate();
	    }

	    Quake.prototype.setDate = function() {
	      var ary;
	      ary = this.data.date.match(/^(\d+) +(-|\d+) +(-|\d+)$/);
	      return this.date = {
	        year: parseInt(ary[1]),
	        month: parseInt(ary[2]),
	        day: parseInt(ary[3])
	      };
	    };

	    Quake.prototype.getDateString = function() {
	      var str;
	      str = this.date.year + "年";
	      if (this.date.month) {
	        str += this.date.month + "月";
	      }
	      if (this.date.day) {
	        str += this.date.day + "月";
	      }
	      return str;
	    };

	    Quake.prototype.getDateJP = function() {
	      var ary, str;
	      ary = this.data.dateJP.match(/(.+) +(\d+) +(-|閏?\d+) +?(-|\d+)?/);
	      str = ary[1];
	      str += (parseInt(ary[2])) + "年";
	      if (ary[3] && ary[3] !== "-") {
	        str += ary[3] + "月";
	      }
	      if (ary[4] && ary[4] !== "-") {
	        str += ary[4] + "月";
	      }
	      return str;
	    };

	    Quake.prototype.getName = function() {
	      return this.data.name;
	    };

	    Quake.prototype.getComment = function() {
	      return this.date.comment;
	    };

	    return Quake;

	  })();
	  rows = __webpack_require__(122);
	  return {
	    getList: function() {
	      return rows.map(function(data) {
	        return new Quake(data);
	      });
	    }
	  };
	});


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	var res = [{"id":"1","date":"0416 8 23","dateJP":"允恭  5  7 14","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"遠飛鳥宮付近(大和)","name":"","tsunamiDmg":"","comment":"｢日本書紀｣に｢地震｣とあるのみ，被害の記述はないが，わが国の歴史に現れた最初の地震．"},{"id":"2","date":"0599 5 28","dateJP":"推古  7  4 27","latitude":"","longitude":"","magnitude":"7","Mw":"","dmgClass":"","region":"大和","name":"","tsunamiDmg":"","comment":"倒潰家屋を生じた．｢日本書紀｣にあり，地震による被害の記述としてはわが国最古のもの．"},{"id":"3","date":"679  -  -","dateJP":"天武  7 12  -","latitude":"","longitude":"","magnitude":"6.5〜7.5","Mw":"","dmgClass":"","region":"筑紫","name":"","tsunamiDmg":"","comment":"家屋の倒潰が多く，幅2丈，長さ3千余丈の地割れを生じた．"},{"id":"4","date":"0684 11 29","dateJP":"天武 13 10 14","latitude":"","longitude":"","magnitude":"≒8.25","Mw":"","dmgClass":"","region":"土佐その他南海・東海・西海地方","name":"","tsunamiDmg":"[3]","comment":"山崩れ，河湧き，家屋社寺の倒潰，人畜の死傷多く，津波来襲して土佐の船多数沈没．土佐で田苑50余万頃(約12km^2)沈下して海となった．南海トラフ沿いの巨大地震と思われる．"},{"id":"5","date":"0701 5 12","dateJP":"大宝  1  3 26","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"丹波","name":"","tsunamiDmg":"","comment":"地震うこと3日．若狭湾内の凡海郷が海に没したという｢冠島伝説｣があるが，疑わしい．"},{"id":"6","date":"0715 7 4","dateJP":"霊亀  1  5 25","latitude":"35.1","longitude":"137.8","magnitude":"6.5〜7.5","Mw":"","dmgClass":"","region":"遠江","name":"","tsunamiDmg":"","comment":"山崩れが天竜川を塞いだ．数十日後決壊，民家170余区が水没した．"},{"id":"7","date":"0715 7 5","dateJP":"霊亀  1  5 26","latitude":"34.8","longitude":"137.4","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"三河","name":"","tsunamiDmg":"","comment":"正倉47破壊，民家に陥没したものがあった．"},{"id":"8","date":"0734 5 18","dateJP":"天平  6  4  7","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"畿内・七道諸国","name":"","tsunamiDmg":"","comment":"民家倒潰し圧死多く，山崩れ，川塞ぎ，地割れが無数に生じた．"},{"id":"9","date":"0745 6 5","dateJP":"天平 17  4 27","latitude":"35.2","longitude":"136.6","magnitude":"≒7.9","Mw":"","dmgClass":"","region":"美濃","name":"","tsunamiDmg":"","comment":"櫓館・正倉・仏寺・堂塔・民家が多く倒潰し，摂津では余震が20日間止まなかった．"},{"id":"10","date":"0762 6 9","dateJP":"天平宝字  6  5  9","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"美濃・飛騨・信濃","name":"","tsunamiDmg":"","comment":"被害不詳．罹災者に対し1戸につき穀物2斛を賜った．"},{"id":"11","date":"818  -  -","dateJP":"弘仁  9  7  -","latitude":"","longitude":"","magnitude":"≧7.5","Mw":"","dmgClass":"","region":"関東諸国","name":"","tsunamiDmg":"","comment":"山崩れ谷埋まること数里，百姓が多数圧死した．従来，津波があったとされていたが，おそらく洪水であろう．"},{"id":"12","date":"0827 8 11","dateJP":"天長  4  7 12","latitude":"35","longitude":"135.75","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"舎屋多く潰れ，余震が翌年6月まであった．"},{"id":"13","date":"0830 2 3","dateJP":"天長  7  1  3","latitude":"39.8","longitude":"140.1","magnitude":"7.0〜7.5","Mw":"","dmgClass":"","region":"出羽","name":"","tsunamiDmg":"","comment":"秋田の城郭・官舎・寺社悉く倒れる．家屋も倒潰し，圧死15，傷100余．地割れ多く，河岸の崩れや川の氾濫があった．"},{"id":"14","date":"841  -  -","dateJP":"承和  8  -  -","latitude":"36.2","longitude":"138","magnitude":"≧6.5","Mw":"","dmgClass":"","region":"信濃","name":"","tsunamiDmg":"","comment":"墻屋が倒壊した．同年2月13日以前の地震．"},{"id":"15","date":"841  -  -","dateJP":"承和  8  -  -","latitude":"35.1","longitude":"138.9","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"伊豆","name":"","tsunamiDmg":"","comment":"里落完からず，死者があった．同年5月3日以前の地震．丹那断層の活動によるものか？"},{"id":"16","date":"850  -  -","dateJP":"嘉祥  3  -  -","latitude":"39","longitude":"139.7","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"出羽","name":"","tsunamiDmg":"[2]","comment":"地裂け，山崩れ，国府の城柵は傾頽し，圧死多数．最上川の岸崩れ，海水は国府から6里のところまで迫った．"},{"id":"17","date":"856  -  -","dateJP":"斉衡  3  3  -","latitude":"","longitude":"","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"京都およびその南方で屋舎が破壊し，仏塔が傾いた．"},{"id":"18","date":"0863 7 10","dateJP":"貞観  5  6 17","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"越中・越後","name":"","tsunamiDmg":"","comment":"山崩れ，谷埋まり，水湧き，民家破壊し，圧死多数．直江津付近にあった数個の小島が潰滅したという．"},{"id":"19","date":"0868 8 3","dateJP":"貞観 10  7  8","latitude":"34.8","longitude":"134.8","magnitude":"≧7.0","Mw":"","dmgClass":"","region":"播磨・山城","name":"","tsunamiDmg":"","comment":"播磨諸郡の官舎・諸定額寺の堂塔ことごとく頽れ倒れた．京都では垣屋に崩れたものがあった．山崎断層の活動によるものか？"},{"id":"20","date":"0869 7 13","dateJP":"貞観 11  5 26","latitude":"38.5","longitude":"144","magnitude":"8.3","Mw":"8.4","dmgClass":"","region":"三陸沿岸","name":"貞観の三陸沖地震","tsunamiDmg":"[4]","comment":"城郭・倉庫・門櫓・垣壁など崩れ落ち倒潰するもの無数．津波が多賀城下を襲い，溺死約1千．流光昼のごとく隠映すという．三陸沖の巨大地震とみられる．Mwは津波堆積物の調査による．"},{"id":"21","date":"0878 11 1","dateJP":"元慶  2  9 29","latitude":"35.5","longitude":"139.3","magnitude":"7.4","Mw":"","dmgClass":"","region":"関東諸国","name":"","tsunamiDmg":"","comment":"相模・武蔵が特にひどく，5〜6日震動が止まらなかった．公私の屋舎一つも全きものなく，地陥り往還不通となる．圧死多数．京都で有感．"},{"id":"22","date":"0880 11 23","dateJP":"元慶  4 10 14","latitude":"35.4","longitude":"133.2","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"出雲","name":"","tsunamiDmg":"","comment":"社寺・民家の破損が多く，余震は10月22日に至るも止まらなかった．この日京都でも強く感じたというがこの地震とは無関係で，規模ももっと小さかったとする説がある．"},{"id":"23","date":"0881 1 13","dateJP":"元慶  4 12  6","latitude":"","longitude":"","magnitude":"6.4","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"宮城の垣墻・官庁・民家の頽損するものはなはだ多く，余震が翌年まで続いた．"},{"id":"24","date":"0887 8 26","dateJP":"仁和  3  7 30","latitude":"33","longitude":"135","magnitude":"8.0〜8.5","Mw":"","dmgClass":"","region":"五畿・七道","name":"","tsunamiDmg":"[3]","comment":"京都で民家・官舎の倒潰多く，圧死多数．津波が沿岸を襲い溺死多数，特に摂津で津波の被害が大きかった．南海トラフ沿いの巨大地震と思われる．"},{"id":"25","date":"0890 7 10","dateJP":"寛平  2  6 16","latitude":"","longitude":"","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"家屋傾き，ほとんど倒潰寸前のものがあった．"},{"id":"26","date":"0934 7 16","dateJP":"承平  4  5 27","latitude":"","longitude":"","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"午刻に地震2回，京中の築垣が多く転倒した．"},{"id":"27","date":"0938 5 22","dateJP":"天慶  1  4 15","latitude":"35","longitude":"135.8","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"京都・紀伊","name":"","tsunamiDmg":"","comment":"宮中の内膳司頽れ，死4．舎屋・築垣倒れるもの多く，堂塔・仏像も多く倒れる．高野山の諸伽藍破壊．余震多く，8月6日に強震があった．"},{"id":"28","date":"0976 7 22","dateJP":"貞元  1  6 18","latitude":"34.9","longitude":"135.8","magnitude":"≧6.7","Mw":"","dmgClass":"","region":"山城・近江","name":"","tsunamiDmg":"","comment":"両京で屋舎・諸仏寺の転倒多く，死50以上．近江の国府・国分寺・関寺(大津市)で被害．余震が多かった．"},{"id":"29","date":"1038  -  -","dateJP":"長暦  1 12  -","latitude":"34.3","longitude":"135.6","magnitude":"","Mw":"","dmgClass":"","region":"紀伊","name":"","tsunamiDmg":"","comment":"高野山中の伽藍・院宇に転倒するもの多かった．"},{"id":"30","date":"1041 8 25","dateJP":"長久  2  7 20","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"法成寺の鐘楼が転倒した．"},{"id":"31","date":"1070 12 1","dateJP":"延久  2 10 20","latitude":"34.8","longitude":"135.8","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"山城・大和","name":"","tsunamiDmg":"","comment":"東大寺の巨鐘の鈕が切れて落ちた．京都では家々の築垣に被害があった．"},{"id":"32","date":"1091 9 28","dateJP":"寛治  5  8  7","latitude":"34.7","longitude":"135.8","magnitude":"6.2〜6.5","Mw":"","dmgClass":"","region":"山城・大和","name":"","tsunamiDmg":"","comment":"法成寺の仏像倒れ，その他の建物・仏像にも被害．大和国金峯山金剛蔵王宝殿が破損した．"},{"id":"33","date":"1093 3 19","dateJP":"寛治  7  2 14","latitude":"","longitude":"","magnitude":"6.0〜6.3","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"所々の塔が破損した．"},{"id":"34","date":"1096 12 17","dateJP":"永長  1 11 24","latitude":"","longitude":"","magnitude":"8.0〜8.5","Mw":"","dmgClass":"","region":"畿内・東海道","name":"","tsunamiDmg":"[2]","comment":"大極殿小破，東大寺の巨鐘落ちる．京都の諸寺に被害があった．近江の勢多橋落ちる．津波が伊勢・駿河を襲い，駿河で社寺・民家の流失400余．余震が多かった．東海沖の巨大地震とみられる．"},{"id":"35","date":"1099 2 22","dateJP":"康和  1  1 24","latitude":"","longitude":"","magnitude":"8.0〜8.3","Mw":"","dmgClass":"","region":"南海道・畿内","name":"","tsunamiDmg":"","comment":"興福寺・摂津天王寺で被害．土佐で田千余町みな海に沈む．津波があったらしい．"},{"id":"36","date":"1177 11 26","dateJP":"治承  1 10 27","latitude":"34.7","longitude":"135.8","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"大和","name":"","tsunamiDmg":"","comment":"東大寺で巨鐘が落ちるなどの被害．京都でも地震が強かった．"},{"id":"37","date":"1185 8 13","dateJP":"文治  1  7  9","latitude":"35","longitude":"135.8","magnitude":"≒7.4","Mw":"","dmgClass":"","region":"近江・山城・大和","name":"","tsunamiDmg":"","comment":"京都，特に白河辺の被害が大きかった．社寺・家屋の倒潰破損多く死多数．宇治橋落ち，死1．9月まで余震多く，特に8月12日の強い余震では多少の被害があった．"},{"id":"38","date":"1213 6 18","dateJP":"建保  1  5 21","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"山崩れ，地裂け，舎屋が破潰した．"},{"id":"39","date":"1227 4 1","dateJP":"安貞  1  3  7","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"地裂け，所々の門扉・築垣が転倒した．"},{"id":"40","date":"1230 3 15","dateJP":"寛喜  2 閏1 22","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"大慈寺の後山が頽れた．"},{"id":"41","date":"1240 3 24","dateJP":"仁治  1  2 22","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"鶴岡神宮寺風なくして倒れ，北山が崩れた．"},{"id":"42","date":"1241 5 22","dateJP":"仁治  2  4  3","latitude":"","longitude":"","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"[1]","comment":"津波を伴い，由比ヶ浜大鳥居内拝殿流失，岸にあった船10艘が破損した．"},{"id":"43","date":"1245 8 27","dateJP":"寛元  3  7 27","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"壁・築垣や所々の屋々に破損が多かった．"},{"id":"44","date":"1257 10 9","dateJP":"正嘉  1  8 23","latitude":"35.2","longitude":"139.5","magnitude":"7.0〜7.5","Mw":"","dmgClass":"","region":"関東南部","name":"","tsunamiDmg":"","comment":"鎌倉の社寺完きものなく，山崩れ，家屋転倒し，築地ことごとく破損．地割れを生じ，水が湧きでた．余震多数．同日三陸沿岸に津波が来襲したというが，疑わしい．"},{"id":"45","date":"1293 5 27","dateJP":"永仁  1  4 13","latitude":"","longitude":"","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"鎌倉強震，建長寺ほとんど炎上のほか，諸寺に被害．死数千あるいは2万3千余．余震が多かった．この日，越後魚沼郡で山崩れあり死多数というも，この地震との関係不明．"},{"id":"46","date":"1317 2 24","dateJP":"文保  1  1  5","latitude":"35","longitude":"135.8","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"これより先1月3日京都に強震，余震多く，この日大地震．白河辺の人家悉く潰れ，死5．諸寺に被害，清水寺出火．余震が5月になっても止まなかった．"},{"id":"47","date":"1325 12 5","dateJP":"正中  2 10 21","latitude":"35.6","longitude":"136.1","magnitude":"6.5","Mw":"","dmgClass":"","region":"近江北部・若狭","name":"","tsunamiDmg":"","comment":"荒地・中山崩れる．竹生島の一部が崩れて湖中に没した．越前国敦賀郡の気比神宮倒潰．京都で強く感じ，余震が年末まで続いた．"},{"id":"48","date":"1331 8 15","dateJP":"元弘  1  7  3","latitude":"33.7","longitude":"135.2","magnitude":"≧7.0","Mw":"","dmgClass":"","region":"紀伊","name":"","tsunamiDmg":"","comment":"紀伊国千里浜(田辺市の北)の遠干潟20余町が隆起して陸地となった．"},{"id":"49","date":"1350 7 6","dateJP":"正平  5  5 23","latitude":"35","longitude":"135.8","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"祇園社の石塔の九輪が落ち砕けた．余震が7月初旬まで続いた．"},{"id":"50","date":"1360 11 22","dateJP":"正平 15 10  5","latitude":"33.4","longitude":"136.2","magnitude":"7.5〜8.0","Mw":"","dmgClass":"","region":"紀伊・摂津","name":"","tsunamiDmg":"[2]","comment":"4日に大震，5日に再震，6日の六ツ時過ぎに津波が熊野尾鷲から摂津兵庫まで来襲し，人馬牛の死が多かった．"},{"id":"51","date":"1361 8 1","dateJP":"正平 16  6 22","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"畿内諸国","name":"","tsunamiDmg":"","comment":"この月18日より京都付近に地震多く，この日の地震で法隆寺の築地多少崩れる．23日にも地震あり．次の地震の前震か？"},{"id":"52","date":"1361 8 3","dateJP":"正平 16  6 24","latitude":"33","longitude":"135","magnitude":"8.25〜8.5","Mw":"","dmgClass":"","region":"畿内・土佐・阿波","name":"","tsunamiDmg":"[3]","comment":"摂津四天王寺の金堂転倒し，圧死5．その他，諸寺諸堂に被害が多かった．津波で摂津・阿波・土佐に被害，特に阿波の雪(由岐)湊で流失1700戸，流死60余．余震多数．南海トラフ沿いの巨大地震と思われる．"},{"id":"53","date":"1408 1 21","dateJP":"応永 14 12 14","latitude":"33","longitude":"136","magnitude":"7.0〜8.0","Mw":"","dmgClass":"","region":"紀伊・伊勢","name":"","tsunamiDmg":"[1]","comment":"熊野本宮の温泉の湧出80日間止まる．熊野で被害があったという．紀伊・伊勢・鎌倉に津波があったようである．"},{"id":"54","date":"1425 12 23","dateJP":"応永 32 11  5","latitude":"35","longitude":"135.8","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"築垣多く崩れる．余震があり，この日終日震う．"},{"id":"55","date":"1433 11 7","dateJP":"永享  5  9 16","latitude":"34.9","longitude":"139.5","magnitude":"≧7.0","Mw":"","dmgClass":"","region":"相模","name":"","tsunamiDmg":"[1]","comment":"相模大山仁王の首落ちる．鎌倉で社寺・築地の被害が多かった．当時東京湾に注いでいた利根川の水が逆流，津波か？余震が多かった．"},{"id":"56","date":"1449 5 13","dateJP":"宝徳  1  4 12","latitude":"35","longitude":"135.75","magnitude":"5.75〜6.5","Mw":"","dmgClass":"","region":"山城・大和","name":"","tsunamiDmg":"","comment":"10日から地震があった．洛中の堂塔・築地に被害多く，東山・西山で所々地裂ける．山崩れで人馬の死多数．淀大橋・桂橋落ちる．余震が7月まで続いた．"},{"id":"57","date":"1456 2 14","dateJP":"康正  1 12 29","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"紀伊","name":"","tsunamiDmg":"","comment":"熊野神社の宮殿・神倉崩れる．京都で強震？"},{"id":"58","date":"1466 5 29","dateJP":"文正  1  4  6","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"天満社・糺社の石灯籠倒れる．"},{"id":"59","date":"1494 6 19","dateJP":"明応  3  5  7","latitude":"34.6","longitude":"135.7","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"大和","name":"","tsunamiDmg":"","comment":"諸寺破損，矢田庄(大和郡山の西)の民家多く破損．余震が翌年に及んだ．"},{"id":"60","date":"1498 7 9","dateJP":"明応  7  6 11","latitude":"33","longitude":"132.25","magnitude":"7.0〜7.5","Mw":"","dmgClass":"","region":"日向灘","name":"","tsunamiDmg":"","comment":"九州で山崩れ，地裂け泥湧出．民屋はすべてこわれ死多数．伊予で地変．同日畿内に地震，被害はなかったらしい．同じ地震であれば震域が広く，震央に変更が必要．"},{"id":"61","date":"1498 9 20","dateJP":"明応  7  8 25","latitude":"34","longitude":"138","magnitude":"8.2〜8.4","Mw":"","dmgClass":"","region":"東海道全般","name":"","tsunamiDmg":"[3]","comment":"紀伊から房総にかけての海岸と甲斐で振動大きかったが，震害はそれほどでもない．津波が紀伊から房総の海岸を襲い，伊勢大湊で家屋流失1千戸，溺死5千，伊勢・志摩で溺死1万，静岡県志太郡で流死2万6千など．南海トラフ沿いの巨大地震とみられる．"},{"id":"62","date":"1502 1 28","dateJP":"文亀  1 12 10","latitude":"37.2","longitude":"138.2","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"越後南西部","name":"","tsunamiDmg":"","comment":"越後の国府(現直江津)で潰家，死多数．会津でも強く揺れた．"},{"id":"63","date":"1510 9 21","dateJP":"永正  7  8  8","latitude":"34.6","longitude":"135.6","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"摂津・河内","name":"","tsunamiDmg":"","comment":"摂津・河内の諸寺で被害．大阪で潰死者があった．余震が70余日続く．"},{"id":"64","date":"1517 7 18","dateJP":"永正 14  6 20","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"越後","name":"","tsunamiDmg":"","comment":"倒家が多かった．史料少なく詳細不明．"},{"id":"65","date":"1520 4 4","dateJP":"永正 17  3  7","latitude":"33","longitude":"136","magnitude":"7.0〜7.75","Mw":"","dmgClass":"","region":"紀伊・京都","name":"","tsunamiDmg":"[1]","comment":"熊野・那智の寺院破壊．津波があり，民家流失．京都で禁中の築地所々破損した．"},{"id":"66","date":"1525 9 20","dateJP":"大永  5  8 23","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"鎌倉","name":"","tsunamiDmg":"","comment":"由比ヶ浜の川・入江・沼が埋まって平地となった．27日まで昼夜地震があった．"},{"id":"67","date":"1579 2 25","dateJP":"天正  7  1 20","latitude":"34.7","longitude":"135.5","magnitude":"6","Mw":"","dmgClass":"","region":"摂津","name":"","tsunamiDmg":"","comment":"四天王寺の鳥居崩れ，余震3日にわたる．"},{"id":"68","date":"1586 1 18","dateJP":"天正 13 11 29","latitude":"36","longitude":"136.9","magnitude":"≒7.8","Mw":"","dmgClass":"","region":"畿内・東海・東山・北陸諸道","name":"","tsunamiDmg":"","comment":"飛騨白川谷で大山崩れ，帰雲山城，民家300余戸埋没し，死多数．飛騨・美濃・伊勢・近江など広域で被害．阿波でも地割れを生じ，余震は翌年まで続いた．震央を白川断層上と考えたが，伊勢湾とする説，二つの地震が続発したとする説などがあり，不明な点が多い．伊勢湾に津波があったかもしれない．"},{"id":"69","date":"1589 3 21","dateJP":"天正 17  2  5","latitude":"34.8","longitude":"138.2","magnitude":"6.7","Mw":"","dmgClass":"","region":"駿河・遠江","name":"","tsunamiDmg":"","comment":"民家多く破損し，興国寺・長久保・沼津などの城塀が破壊した．"},{"id":"70","date":"1596 9 1","dateJP":"慶長  1 閏7  9","latitude":"33.3","longitude":"131.6","magnitude":"7","Mw":"","dmgClass":"","region":"豊後","name":"","tsunamiDmg":"[2]","comment":"前月より前震があったらしい．この日の大地震で高崎山など崩れ，八幡村柞原八幡社拝殿など倒壊．海水が引いた後大津波が来襲し，別府湾沿岸で被害．大分などで家屋ほとんど流失．｢瓜生島｣(大分の北にあった沖ノ浜とされる)の80％陥没し，死708という．"},{"id":"71","date":"1596 9 5","dateJP":"慶長  1 閏7 13","latitude":"34.65","longitude":"135.6","magnitude":"7.5","Mw":"","dmgClass":"","region":"畿内","name":"","tsunamiDmg":"","comment":"京都では三条より伏見の間で被害が最も多く，伏見城天守大破，石垣崩れて圧死約500．諸寺・民家の倒潰も多く，死傷多数．堺で死600余．奈良・大阪・神戸でも被害が多かった．余震が翌年4月まで続いた．"},{"id":"72","date":"1605 2 3","dateJP":"慶長  9 12 16","latitude":"33.5","longitude":"138.5","magnitude":"7.9","Mw":"","dmgClass":"","region":"東海・南海・西海諸道","name":"慶長地震","tsunamiDmg":"[3]","comment":"地震の被害としては淡路島安坂村千光寺の諸堂倒れ，仏像が飛散したとあるのみ．津波が犬吠崎から九州までの太平洋岸に来襲して，八丈島で死57，浜名湖近くの橋本で100戸中80戸流され，死多数．紀伊西岸広村で1700戸中700戸流失，阿波宍喰で波高2丈，死1500余，土佐甲ノ浦で死350余，崎浜で死50余，室戸岬付近で死400余など．ほぼ同時に二つの地震が起こったとする考えと，東海沖の一つの地震とする考えがある．"},{"id":"72","date":"1605 2 3","dateJP":"慶長  9 12 16","latitude":"33","longitude":"134.9","magnitude":"7.9","Mw":"","dmgClass":"","region":"東海・南海・西海諸道","name":"慶長地震","tsunamiDmg":"[3]","comment":"地震の被害としては淡路島安坂村千光寺の諸堂倒れ，仏像が飛散したとあるのみ．津波が犬吠崎から九州までの太平洋岸に来襲して，八丈島で死57，浜名湖近くの橋本で100戸中80戸流され，死多数．紀伊西岸広村で1700戸中700戸流失，阿波宍喰で波高2丈，死1500余，土佐甲ノ浦で死350余，崎浜で死50余，室戸岬付近で死400余など．ほぼ同時に二つの地震が起こったとする考えと，東海沖の一つの地震とする考えがある．"},{"id":"73","date":"1611 9 27","dateJP":"慶長 16  8 21","latitude":"37.6","longitude":"139.8","magnitude":"≒6.9","Mw":"","dmgClass":"","region":"会津","name":"","tsunamiDmg":"","comment":"若松城下とその付近で社寺・民家の被害が大きく，死3700余．山崩れが会津川・只見川を塞ぎ，南北60kmの間に多数の沼を作った．"},{"id":"74","date":"1611 12 2","dateJP":"慶長 16 10 28","latitude":"39","longitude":"144","magnitude":"8.1","Mw":"","dmgClass":"","region":"三陸沿岸および北海道東岸","name":"慶長の三陸沖地震","tsunamiDmg":"[4]","comment":"三陸地方で強震．震害は軽く，津波の被害が大きかった．伊達領内で死1783，南部・津軽で人馬の死3千余という．三陸沿岸で家屋の流出が多く，北海道東部でも溺死が多かった．1933年の三陸地震津波に似ている．"},{"id":"75","date":"1614 11 26","dateJP":"慶長 19 10 25","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"","name":"","tsunamiDmg":"","comment":"従来，越後高田の地震とされていたもの．大地震の割に史料が少なく，震源については検討すべきことが多い．京都で家屋・社寺などが倒壊し，死2，傷370という．京都付近の地震とする説がある．"},{"id":"76","date":"1615 6 26","dateJP":"元和  1  6  1","latitude":"35.7","longitude":"139.7","magnitude":"6.25〜6.75","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"家屋が倒壊し，死傷多く，地割れを生じた．"},{"id":"77","date":"1616 9 9","dateJP":"元和  2  7 28","latitude":"38.1","longitude":"142","magnitude":"7","Mw":"","dmgClass":"","region":"仙台","name":"","tsunamiDmg":"","comment":"仙台城の石壁・櫓等破損．江戸で有感．津波を伴う？"},{"id":"78","date":"1619 5 1","dateJP":"元和  5  3 17","latitude":"32.5","longitude":"130.6","magnitude":"6","Mw":"","dmgClass":"","region":"肥後八代","name":"","tsunamiDmg":"","comment":"麦島城はじめ公私の家屋が破壊した．"},{"id":"79","date":"1625 1 21","dateJP":"寛永  1 12 13","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"安芸","name":"","tsunamiDmg":"","comment":"広島で大震．城中の石垣・多門・塀などが倒潰した．島根で有感．"},{"id":"80","date":"1625 7 21","dateJP":"寛永  2  6 17","latitude":"32.8","longitude":"130.6","magnitude":"5.0〜6.0","Mw":"","dmgClass":"","region":"熊本","name":"","tsunamiDmg":"","comment":"地震のため熊本城の火薬庫爆発，天守付近の石壁の一部が崩れた．城中の石垣にも被害，死約50．"},{"id":"81","date":"1627 10 22","dateJP":"寛永  4  9 14","latitude":"36.6","longitude":"138.2","magnitude":"6","Mw":"","dmgClass":"","region":"松代","name":"","tsunamiDmg":"","comment":"家屋倒潰80戸．死者があった．"},{"id":"82","date":"1628 8 10","dateJP":"寛永  5  7 11","latitude":"","longitude":"","magnitude":"6","Mw":"","dmgClass":"","region":"江戸・相模東部","name":"","tsunamiDmg":"","comment":"江戸城の石垣所々崩れる．戸塚で道路破壊，八王子で有感．"},{"id":"83","date":"1630 8 2","dateJP":"寛永  7  6 24","latitude":"35.75","longitude":"139.75","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"江戸城の石垣崩れ，塀も破損した．"},{"id":"84","date":"1633 3 1","dateJP":"寛永 10  1 21","latitude":"35.2","longitude":"139.2","magnitude":"7","Mw":"","dmgClass":"","region":"相模・駿河・伊豆","name":"","tsunamiDmg":"[1]","comment":"小田原城の矢倉・門塀・石壁ことごとく破壊．小田原で民家の倒潰多く，死150．箱根で山崩れ．熱海に津波が襲来した．"},{"id":"85","date":"1635 3 12","dateJP":"寛永 12  1 23","latitude":"35.75","longitude":"139.75","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"長屋の塀など破損．増上寺の石灯籠ほとんど倒れる．戸塚で有感．"},{"id":"86","date":"1640 7 31","dateJP":"寛永 17  6 13","latitude":"42.1","longitude":"140.7","magnitude":"","Mw":"","dmgClass":"","region":"北海道噴火湾","name":"","tsunamiDmg":"[2]","comment":"駒ヶ岳噴火に伴い津波があり，死700余，昆布舟流出100余．"},{"id":"87","date":"1640 11 23","dateJP":"寛永 17 10 10","latitude":"36.3","longitude":"136.2","magnitude":"6.25〜6.75","Mw":"","dmgClass":"","region":"加賀大聖寺","name":"","tsunamiDmg":"","comment":"家屋の損潰多く，人畜の死傷も多かった．"},{"id":"88","date":"1644 10 18","dateJP":"正保  1  9 18","latitude":"39.4","longitude":"140","magnitude":"6.5","Mw":"","dmgClass":"","region":"羽後","name":"","tsunamiDmg":"","comment":"本荘城廓大破し，屋倒れ，死者があった．市街で焼失が多かった．金浦村・石沢村で被害．院内村で地裂け，水が湧出した．"},{"id":"89","date":"1646 6 9","dateJP":"正保  3  4 26","latitude":"38.1","longitude":"140.65","magnitude":"6.5〜6.7","Mw":"","dmgClass":"","region":"陸前・岩代・下野","name":"","tsunamiDmg":"","comment":"仙台城・白石城で被害．会津で少々地割れ．日光東照宮で石垣など破損．江戸でもかなり強かった．"},{"id":"90","date":"1646 12 7","dateJP":"正保  3 11  1","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"方々の石垣崩れ，家も損じ，地割れがあった．江戸城の石垣が所々破損した．"},{"id":"91","date":"1647 6 16","dateJP":"正保  4  5 14","latitude":"","longitude":"","magnitude":"6.5","Mw":"","dmgClass":"","region":"武蔵・相模","name":"","tsunamiDmg":"","comment":"江戸城や大名屋敷で被害，死者があった．小田原でも城の石垣が崩れるなどの被害．余震が多かった．"},{"id":"92","date":"1648 6 13","dateJP":"慶安  1  4 22","latitude":"35.2","longitude":"139.2","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"相模・江戸","name":"","tsunamiDmg":"","comment":"小田原城破損，領内で潰家が多かった．箱根で落石，死1．江戸で舟のごとく揺れ，瓦落ち，土蔵や練塀の半数が崩れ倒れた．小田原や江戸の大きな被害は疑問とする説がある．"},{"id":"93","date":"1649 3 17","dateJP":"慶安  2  2  5","latitude":"33.7","longitude":"132.5","magnitude":"7","Mw":"","dmgClass":"","region":"安芸・伊予","name":"","tsunamiDmg":"","comment":"松山城・宇和島城の石垣や塀が崩れ，民家も破損．広島では侍屋敷・町屋少々潰れ，破損が多かった．"},{"id":"94","date":"1649 7 30","dateJP":"慶安  2  6 21","latitude":"35.8","longitude":"139.5","magnitude":"7","Mw":"","dmgClass":"","region":"武蔵・下野","name":"","tsunamiDmg":"","comment":"川越で大地震，町屋700軒ほど大破．江戸城で石垣など破損．侍屋敷・長屋破損し，圧死多数．上野東照宮の大仏の頭落ちる．日光東照宮破損．余震日々40〜50回．"},{"id":"95","date":"1649 9 1","dateJP":"慶安  2  7 25","latitude":"35.5","longitude":"139.7","magnitude":"6.4","Mw":"","dmgClass":"","region":"川崎・江戸","name":"","tsunamiDmg":"","comment":"川崎駅の民屋140〜150軒，寺7宇が崩潰．近くの村で民屋が破倒し，人畜の死傷多数．江戸でも被害．"},{"id":"96","date":"1650 4 24","dateJP":"慶安  3  3 24","latitude":"","longitude":"","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"日光","name":"","tsunamiDmg":"","comment":"江戸・日光で地震強く，日光東照宮で石垣など破損．"},{"id":"97","date":"1659 4 21","dateJP":"万治  2  2 30","latitude":"37.1","longitude":"139.8","magnitude":"6.75〜7.0","Mw":"","dmgClass":"","region":"岩代・下野","name":"","tsunamiDmg":"","comment":"猪苗代城の石垣2ヶ所崩れる．南会津の田嶋町で人家297軒など倒れ，死8．塩原温泉一村ほとんど土砂に埋まり，死多数．"},{"id":"98","date":"1662 6 16","dateJP":"寛文  2  5  1","latitude":"35.2","longitude":"135.95","magnitude":"7.25〜7.6","Mw":"","dmgClass":"","region":"山城・大和・河内・和泉・摂津・丹後・若狭・近江・美濃・伊勢・駿河・三河・信濃","name":"","tsunamiDmg":"","comment":"比良岳付近の被害が甚大．滋賀唐崎で田畑85町湖中に没し潰家1570．大溝で潰家1020余，死37．彦根で潰家1千，死30余．榎村で死300，所川村で死260余．京都で町屋倒壊1千，死200余など．諸所の城破損．大きな内陸地震で，比良断層または花折断層の活動とする説がある．"},{"id":"99","date":"1662 10 31","dateJP":"寛文  2  9 20","latitude":"31.7","longitude":"132","magnitude":"7.5〜7.75","Mw":"","dmgClass":"","region":"日向・大隅","name":"","tsunamiDmg":"[2]","comment":"日向灘沿岸に被害．城の破損，潰家多く，死者があった．山崩れ，津波を生じ，宮崎県沿岸7ヶ村周囲7里35町の地が陥没して海となった．日向灘の地震の中でも特に被害が大きかった．"},{"id":"100","date":"1664 1 4","dateJP":"寛文  3 12  6","latitude":"","longitude":"","magnitude":"5.9","Mw":"","dmgClass":"","region":"山城","name":"","tsunamiDmg":"","comment":"二条城や伏見の諸邸破損，洛中の築垣所々崩れる．吉田神社・下加茂社の石灯籠倒れる．余震が月末まで続いた．"},{"id":"101","date":"1664 8 3","dateJP":"寛文  4  6 12","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"紀伊熊野","name":"","tsunamiDmg":"","comment":"新宮丹鶴城の松の間崩れる．和歌山で有感．"},{"id":"102","date":"1664  -  -","dateJP":"寛文  4  -  -","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"琉球","name":"","tsunamiDmg":"[1]","comment":"琉球の鳥島で地震，死1．近くの海底から噴火があったという．津波があった．"},{"id":"103","date":"1665 6 25","dateJP":"寛文  5  5 12","latitude":"","longitude":"","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"二条城の石垣12〜13間崩れ，二の丸殿舎など少々破損．"},{"id":"104","date":"1666 2 1","dateJP":"寛文  5 12 27","latitude":"37.1","longitude":"138.2","magnitude":"≒6.75","Mw":"","dmgClass":"","region":"越後西部","name":"","tsunamiDmg":"","comment":"積雪14〜15尺のときに地震．高田城破損，侍屋敷700余潰れ，民家の倒潰も多かった．夜火災，死約1500．"},{"id":"105","date":"1667  -  -","dateJP":"寛文  7  -  -","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"琉球","name":"","tsunamiDmg":"[1]","comment":"宮古島で地震強く，洲鎌村の旱田1210坪約3尺沈下して水田となる．"},{"id":"106","date":"1667 8 22","dateJP":"寛文  7  7  3","latitude":"40.6","longitude":"141.6","magnitude":"6.0〜6.4","Mw":"","dmgClass":"","region":"八戸","name":"","tsunamiDmg":"","comment":"市中の建物の破損が夥しかった．津軽・盛岡で有感．"},{"id":"107","date":"1668 6 14","dateJP":"寛文  8  5  5","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"越中","name":"","tsunamiDmg":"","comment":"伏木・放生津・小杉で潰家があった．高岡城の橋潰れる．"},{"id":"108","date":"1668 8 28","dateJP":"寛文  8  7 21","latitude":"","longitude":"","magnitude":"≒5.9","Mw":"","dmgClass":"","region":"仙台","name":"","tsunamiDmg":"","comment":"仙台城の石垣崩れる．迫町で道割れ，家破損．江戸で有感．"},{"id":"109","date":"1670 6 22","dateJP":"寛文 10  5  5","latitude":"37.85","longitude":"139.25","magnitude":"≒6.75","Mw":"","dmgClass":"","region":"越後村上","name":"","tsunamiDmg":"","comment":"上川4万石のうち農家503軒潰れ，死13．盛岡・江戸でも有感．"},{"id":"110","date":"1671  -  -","dateJP":"寛文 11  8  -","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"花巻","name":"","tsunamiDmg":"","comment":"町屋10軒ほど倒れ，庇の落下が多かった．"},{"id":"111","date":"1674 4 15","dateJP":"延宝  2  3 10","latitude":"40.6","longitude":"141.6","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"八戸","name":"","tsunamiDmg":"","comment":"城内・諸士屋敷・町屋に破損が多かった．"},{"id":"112","date":"1676 7 12","dateJP":"延宝  4  6  2","latitude":"34.5","longitude":"131.8","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"石見","name":"","tsunamiDmg":"","comment":"津和野城や侍屋敷の石垣などに被害．家屋倒潰133，死7．"},{"id":"113","date":"1677 4 13","dateJP":"延宝  5  3 12","latitude":"40.5","longitude":"142.3","magnitude":"7.9","Mw":"","dmgClass":"","region":"陸中・陸奥","name":"延宝の三陸沖地震","tsunamiDmg":"[2]","comment":"八戸・盛岡在に家具破損等の震害があった．三陸一帯に津波があった．宮古代官所管内で流失家屋35．余震が多かった．1968年十勝沖地震と似ている．"},{"id":"114","date":"1677 11 4","dateJP":"延宝  5 10  9","latitude":"35.5","longitude":"142","magnitude":"≒8.0","Mw":"","dmgClass":"","region":"磐城・常陸・安房・上総・下総","name":"","tsunamiDmg":"[2]","comment":"上旬より地震が多かった．磐城から房総にかけて津波があり，小名浜・中之作・薄磯・四倉・江名・豊間などで死・不明130余，水戸領内で溺死36，房総で溺死246余，奥州岩沼領で死123．陸に近いM6級の地震とする説がある．"},{"id":"115","date":"1678 10 2","dateJP":"延宝  6  8 17","latitude":"39","longitude":"142","magnitude":"7.5","Mw":"","dmgClass":"","region":"陸中・出羽","name":"","tsunamiDmg":"","comment":"花巻で城の石垣崩れ，家屋も損壊，死1．白石城の石垣崩れる．秋田・米沢で家屋に被害．"},{"id":"116","date":"1683 6 17","dateJP":"天和  3  5 23","latitude":"36.7","longitude":"139.6","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"日光","name":"","tsunamiDmg":"","comment":"4月5日より地震多く，この日大地震．東照宮の石垣などに被害．北方の山が崩れた．"},{"id":"117","date":"1683 6 18","dateJP":"天和  3  5 24","latitude":"36.75","longitude":"139.65","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"日光","name":"","tsunamiDmg":"","comment":"卯刻から辰刻まで地震7回，巳ノ下刻に大地震．石垣・灯籠がほとんど倒れた．夜中までに地震約200回．江戸でも小被害．"},{"id":"118","date":"1683 10 20","dateJP":"天和  3  9  1","latitude":"36.9","longitude":"139.7","magnitude":"7","Mw":"","dmgClass":"","region":"下野・岩代","name":"","tsunamiDmg":"","comment":"下野の三依川五十里村で山崩れ川を塞ぎ，湖を生じた．会津・日光でも山崩れ，石垣崩れなどの被害．1日，2日で地震760回余，1日から晦日までで1400回余．江戸で有感．"},{"id":"119","date":"1685  -  -","dateJP":"貞享  2  3  -","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"三河","name":"","tsunamiDmg":"","comment":"渥美郡で山崩れ．家屋倒潰し，人畜の死が多かった．疑わしきか？"},{"id":"120","date":"1686 1 4","dateJP":"貞享  2 12 10","latitude":"34","longitude":"132.6","magnitude":"7.0〜7.4","Mw":"","dmgClass":"","region":"安芸・伊予","name":"","tsunamiDmg":"","comment":"広島県中西部を中心に家屋などの被害が多く，死者があった．宮嶋・萩・岩国・松山・三原などで被害．"},{"id":"121","date":"1686 10 3","dateJP":"貞享  3  8 16","latitude":"34.7","longitude":"137.6","magnitude":"7","Mw":"","dmgClass":"","region":"遠江・三河","name":"","tsunamiDmg":"","comment":"遠江で新居の関所など少々被害，死者があった．三河で田原城の矢倉など破損，死者があった．"},{"id":"122","date":"1694 6 19","dateJP":"元禄  7  5 27","latitude":"40.2","longitude":"140.1","magnitude":"7","Mw":"","dmgClass":"","region":"能代付近","name":"","tsunamiDmg":"","comment":"42ヶ村に被害，特に能代は壊滅的打撃を受けた．全体で死394，家屋崩れ1273，焼失859など．秋田・弘前でも被害．岩木山で岩石崩れ，硫黄平に火を発した．"},{"id":"123","date":"1694 12 12","dateJP":"元禄  7 10 26","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"丹後","name":"","tsunamiDmg":"","comment":"宮津で地割れて泥噴出．家屋破損，特に土蔵は大破損．"},{"id":"124","date":"1696 6 1","dateJP":"元禄  9  5  2","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"宮古島","name":"","tsunamiDmg":"","comment":"府庫・拝殿・寺院・仮屋などの石垣が崩潰した．"},{"id":"125","date":"1697 11 25","dateJP":"元禄 10 10 12","latitude":"35.4","longitude":"139.6","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"相模・武蔵","name":"","tsunamiDmg":"","comment":"鎌倉で鶴岡八幡宮の鳥居倒れ，潰家があった．江戸城の石垣崩れる．日光で有感．"},{"id":"126","date":"1698 10 24","dateJP":"元禄 11  9 21","latitude":"33.1","longitude":"131.5","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"豊後","name":"","tsunamiDmg":"","comment":"大分城の石垣・壁など崩れる．岡城破損．佐賀で有感1日に6回．"},{"id":"127","date":"1700 4 15","dateJP":"元禄 13  2 26","latitude":"33.9","longitude":"129.6","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"壱岐・対馬","name":"","tsunamiDmg":"","comment":"24日より地震，26日の地震で壱岐の村里の石垣・墓所ことごとく崩れ，屋宅大半崩れる．対馬で石垣が崩れるなどの被害．佐賀・平戸などで有感．"},{"id":"128","date":"1703 12 31","dateJP":"元禄 16 11 23","latitude":"33.25","longitude":"131.35","magnitude":"6.5","Mw":"","dmgClass":"","region":"豊後","name":"","tsunamiDmg":"","comment":"府内(大分)山奥22ヶ村で潰家273，破損369，死1．油布院筋・大分領で農家580軒潰れる．豊後頭無村(現日出町豊岡)で人家崩れ，人馬の死があった．"},{"id":"129","date":"1703 12 31","dateJP":"元禄 16 11 23","latitude":"34.7","longitude":"139.8","magnitude":"7.9〜8.2","Mw":"","dmgClass":"","region":"江戸・関東諸国","name":"元禄地震","tsunamiDmg":"[3]","comment":"相模・武蔵・上総・安房で震度大．特に小田原で被害大きく，城下は全滅，12ヶ所から出火，壊家8千以上，死2300以上．東海道は川崎から小田原までほとんど全滅し，江戸・鎌倉などでも被害が大きかった．津波が犬吠崎から下田の沿岸を襲い，死数千．1923年関東地震に似た相模トラフ沿いの巨大地震と思われるが，地殻変動はより大きかった．"},{"id":"130","date":"1704 5 27","dateJP":"宝永  1  4 24","latitude":"40.4","longitude":"140","magnitude":"7","Mw":"","dmgClass":"","region":"羽後・陸奥","name":"","tsunamiDmg":"","comment":"能代の被害が最大．被害家屋1193のうち倒潰435，焼失758，死58．山崩れが多く，十二湖を生じた．岩館付近の海岸で最大190cm隆起．弘前でも城・民家などに被害があった．"},{"id":"131","date":"1705 5 24","dateJP":"宝永  2 閏4  2","latitude":"33","longitude":"131.2","magnitude":"","Mw":"","dmgClass":"","region":"阿蘇付近","name":"","tsunamiDmg":"","comment":"阿蘇で坊の大破や崩れがあったという．岡城で被害があったという．"},{"id":"132","date":"1706 1 19","dateJP":"宝永  2 12  5","latitude":"38.6","longitude":"139.9","magnitude":"5.75","Mw":"","dmgClass":"","region":"羽前","name":"","tsunamiDmg":"","comment":"湯殿山付近のきわめて局地的な小被害地震．家屋の破損や地割れがあった．"},{"id":"133","date":"1706 10 21","dateJP":"宝永  3  9 15","latitude":"35.6","longitude":"139.8","magnitude":"≒5.75","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"江戸城や大名屋敷などで多少の被害．"},{"id":"134","date":"1707 10 28","dateJP":"宝永  4 10  4","latitude":"33.2","longitude":"135.9","magnitude":"8.6","Mw":"","dmgClass":"","region":"五畿・七道","name":"宝永地震","tsunamiDmg":"[4]","comment":"わが国最大級の地震の一つ．全体で少なくとも死2万，潰家6万，流出家2万．震害は東海道・伊勢湾・紀伊半島で最もひどく，津波が紀伊半島から九州までの太平洋沿岸や瀬戸内海を襲った．津波の被害は土佐が最大．室戸・串本・御前崎で1〜2m隆起し，高知市の東部の地約20km^2が最大2m沈下した．遠州灘沖および紀伊半島沖で二つの巨大地震が同時に起こったとも考えられる．"},{"id":"135","date":"1708 2 13","dateJP":"宝永  5  1 22","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"紀伊・伊勢・京都","name":"","tsunamiDmg":"[1]","comment":"地震い，汐溢れて山田吹上町に至る．宝永地震の余震か？"},{"id":"136","date":"1710 9 15","dateJP":"宝永  7  8 22","latitude":"37","longitude":"141.5","magnitude":"6.5","Mw":"","dmgClass":"","region":"磐城","name":"","tsunamiDmg":"","comment":"平(いわき)で城などに被害．江戸で天水ひるがえるほど．"},{"id":"137","date":"1710 10 3","dateJP":"宝永  7 閏8 11","latitude":"35.5","longitude":"133.7","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"伯耆・美作","name":"","tsunamiDmg":"","comment":"河村・久米両郡(現鳥取県東伯郡)で被害最大．山崩れ人家を潰す．倉吉・八橋町・大山・鳥取で被害．死多数．"},{"id":"138","date":"1711 3 19","dateJP":"正徳  1  2  1","latitude":"35.2","longitude":"133.8","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"因幡・伯耆","name":"","tsunamiDmg":"","comment":"因伯両国で家380潰れ，死4．山崩れや田畠の被害があった．"},{"id":"139","date":"1714 4 28","dateJP":"正徳  4  3 15","latitude":"36.7","longitude":"137.85","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"信濃北西部","name":"","tsunamiDmg":"","comment":"大町組(大町以北の北安曇郡)で死56，全潰194，半潰141．善光寺でも被害があった．"},{"id":"140","date":"1715 2 2","dateJP":"正徳  4 12 28","latitude":"35.4","longitude":"136.6","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"大垣・名古屋・福井","name":"","tsunamiDmg":"","comment":"大垣城・名古屋城で石垣崩れる．福井で崩家があり，奈良・京都・伊賀上野・松本で有感．"},{"id":"141","date":"1717 5 13","dateJP":"享保  2  4  3","latitude":"38.5","longitude":"142.5","magnitude":"7.5","Mw":"","dmgClass":"","region":"仙台・花巻","name":"","tsunamiDmg":"","comment":"仙台城の石垣崩れる．花巻で破損家屋多く，地割れや泥の噴出があった．津軽・角館・盛岡・江戸等で有感．"},{"id":"142","date":"1718 8 22","dateJP":"享保  3  7 26","latitude":"35.3","longitude":"137.9","magnitude":"7","Mw":"","dmgClass":"","region":"信濃・三河","name":"","tsunamiDmg":"","comment":"伊那遠山谷で山崩れ，せき止められた遠山川が後に決壊し，死50余．飯田長久寺の唐門倒れた．日光・尾張・江戸でも有感．"},{"id":"143","date":"1723 12 19","dateJP":"享保  8 11 22","latitude":"32.9","longitude":"130.6","magnitude":"6.5","Mw":"","dmgClass":"","region":"肥後・豊後・筑後","name":"","tsunamiDmg":"","comment":"肥後で倒家980，死2．飽田・山本・山鹿・玉名・菊地・合志各郡で強く，柳川辺でも強く感じた．"},{"id":"144","date":"1725 5 29","dateJP":"享保 10  4 18","latitude":"36.25","longitude":"139.7","magnitude":"6","Mw":"","dmgClass":"","region":"日光","name":"","tsunamiDmg":"","comment":"東照宮の石矢来・石灯籠倒れる．江戸でもやや強く感じた．"},{"id":"145","date":"1725 6 17","dateJP":"享保 10  5  7","latitude":"36.4","longitude":"136.4","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"加賀小松","name":"","tsunamiDmg":"","comment":"城の石垣・蔵など少々破損．金沢で同日4〜5回地震．"},{"id":"146","date":"1725 8 14","dateJP":"享保 10  7  7","latitude":"36","longitude":"138.1","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"高遠・諏訪","name":"","tsunamiDmg":"","comment":"高遠城の石垣・塀・土居夥しく崩れる．諏訪高島城の石垣・塀・門夥しく崩れ，城内外侍屋敷の破損87．郷村36ヶ村で倒家347など，死4．山崩れがあった．江戸・八王子・奈良で有感．"},{"id":"147","date":"1729 3 8","dateJP":"享保 14  2  9","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"伊豆","name":"","tsunamiDmg":"","comment":"大地割れ，川筋に水湧く．下田で家・土蔵傾倒．余震が20日すぎまで続いた．"},{"id":"148","date":"1729 8 1","dateJP":"享保 14  7  7","latitude":"37.4","longitude":"137.1","magnitude":"6.6〜7.0","Mw":"","dmgClass":"","region":"能登","name":"","tsunamiDmg":"","comment":"珠洲郡・鳳至郡で損・潰家791，死5，山崩れ1731ヶ所．輪島村で潰家28，能登半島先端で被害が大きかった．"},{"id":"---","date":"1730 7 9","dateJP":"享保 15  5 25","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"陸前","name":"","tsunamiDmg":"[1]","comment":"前日のチリのパルパライソ沖の地震による津波．陸前沿岸で田畑を損じた．"},{"id":"149","date":"1731 10 7","dateJP":"享保 16  9  7","latitude":"38","longitude":"140.6","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"岩代","name":"","tsunamiDmg":"","comment":"桑折で家屋300余崩れ，橋84落ちる．白石城で被害．蔵王の高湯や仙台でも被害が多かったという．"},{"id":"150","date":"1731 11 13","dateJP":"享保 16 10 14","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"近江八幡・刈谷","name":"","tsunamiDmg":"","comment":"近江八幡で青屋橋の石垣破損し，刈谷で本城厩前の塀倒れる．"},{"id":"151","date":"1733 9 18","dateJP":"享保 18  8 11","latitude":"","longitude":"","magnitude":"6.6","Mw":"","dmgClass":"","region":"安芸","name":"","tsunamiDmg":"","comment":"奥郡に被害，因幡でも地大いに震う．京都・池田・讃岐で有感．"},{"id":"152","date":"1735 5 6","dateJP":"享保 20 閏3 14","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"日光・守山","name":"","tsunamiDmg":"","comment":"東照宮で石垣少々崩れる．守山(現郡山市内)で稗蔵の壁所々割れる．江戸で有感．従来，3月14日とされていたもの．"},{"id":"153","date":"1736 4 30","dateJP":"元文  1  3 20","latitude":"","longitude":"","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"仙台","name":"","tsunamiDmg":"","comment":"仙台で城の石畳や澱橋など破損．余目・江戸で有感．"},{"id":"154","date":"1738 1 3","dateJP":"元文  2 閏11 13","latitude":"37","longitude":"138.7","magnitude":"≒5.5","Mw":"","dmgClass":"","region":"中魚沼群","name":"","tsunamiDmg":"","comment":"蘆ヶ崎村(現津南町)付近で14日朝まで80回余，翌年に及ぶ．蔵の壁損じ，釜潰れる．信州青倉村(現栄村)で家蔵破損．"},{"id":"155","date":"1739 8 16","dateJP":"元文  4  7 12","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"陸奥","name":"","tsunamiDmg":"","comment":"南部高森(場所不明)で特に強く，青森で蔵潰れる．八戸で諸士町家ともに被害が多かった．"},{"id":"156","date":"1741 8 29","dateJP":"寛保  1  7 19","latitude":"41.6","longitude":"139.4","magnitude":"","Mw":"","dmgClass":"","region":"渡島西岸・津軽・佐渡","name":"","tsunamiDmg":"[3]","comment":"渡島大島この月の上旬より活動，13日に噴火した．19日早朝に津波，北海道で死1467，流出家屋729，船1521破壊．津軽で田畑の損も多く，流失潰家約100，死37．佐渡・能登・若狭にも津波．"},{"id":"157","date":"1746 5 14","dateJP":"延享  3  3 24","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"江戸・日光","name":"","tsunamiDmg":"","comment":"日光東照宮の石矢来約20間倒れ，石垣少々崩る．岩手県大迫町・宮城県宮崎町・江戸・八王子・日光・福井・京都・津軽で有感．"},{"id":"158","date":"1749 5 25","dateJP":"寛延  2  4 10","latitude":"33.2","longitude":"132.6","magnitude":"6.75","Mw":"","dmgClass":"","region":"宇和島・大分","name":"","tsunamiDmg":"","comment":"宇和島城で所々破損，矢来大破．大分で千石橋破損．土佐・広島・伊賀・延岡で強く感じた．"},{"id":"159","date":"1751 3 26","dateJP":"宝暦  1  2 29","latitude":"35","longitude":"135.8","magnitude":"5.5〜6.0","Mw":"","dmgClass":"","region":"京都","name":"","tsunamiDmg":"","comment":"諸社寺の築地や町屋など破損．越中で強く感じ，鳥取・金沢・大阪・池田で有感．"},{"id":"160","date":"1751 5 21","dateJP":"宝暦  1  4 26","latitude":"37.1","longitude":"138.2","magnitude":"7.0〜7.4","Mw":"","dmgClass":"","region":"越後・越中","name":"","tsunamiDmg":"","comment":"高田城で所々破損，町方3ヶ所から出火した．鉢崎・糸魚川間の谷で山崩れ多く，圧死多数．富山・金沢でも強く感じ，日光で有感．全体で，死1500以上．余震が多かった．"},{"id":"161","date":"1755 3 29","dateJP":"宝暦  5  2 17","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"陸奥八戸","name":"","tsunamiDmg":"","comment":"殿中ならびに外通りに被害．津軽・盛岡で有感．"},{"id":"162","date":"1755 4 21","dateJP":"宝暦  5  3 10","latitude":"36.75","longitude":"139.6","magnitude":"","Mw":"","dmgClass":"","region":"日光","name":"","tsunamiDmg":"","comment":"東照宮の石矢来・石垣などに被害．江戸・八戸で被害．"},{"id":"163","date":"1756 2 20","dateJP":"宝暦  6  1 21","latitude":"35.7","longitude":"140.9","magnitude":"5.5〜6.0","Mw":"","dmgClass":"","region":"銚子","name":"","tsunamiDmg":"","comment":"蔵にいたみがあった．酒・醤油の桶を揺り返し，石塔倒れる．江戸・八王子・日光で有感．"},{"id":"164","date":"1760 5 15","dateJP":"宝暦 10  4  1","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"琉球","name":"","tsunamiDmg":"","comment":"城墻57ヶ所崩れる．余震があった．"},{"id":"165","date":"1762 10 18","dateJP":"宝暦 12  9  2","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"土佐","name":"","tsunamiDmg":"","comment":"高岡郡で瓦落ち，山崩れる．16日まで少々ずつ地震．岩国・宇和島・筑後で有感．"},{"id":"166","date":"1762 10 31","dateJP":"宝暦 12  9 15","latitude":"38.1","longitude":"138.7","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"佐渡","name":"","tsunamiDmg":"[1]","comment":"石垣・家屋が破損，銀山道が崩れ，死者があった．鵜島村で津波により26戸流出．新潟で地割れを生じ，砂と水を噴出．酒田・羽前南村山郡・日光で有感．"},{"id":"167","date":"1763 1 29","dateJP":"宝暦 12 12 16","latitude":"41","longitude":"142.3","magnitude":"7.4","Mw":"","dmgClass":"","region":"陸奥八戸","name":"","tsunamiDmg":"[1]","comment":"11月初めより地震があり，この日大地震．寺院・民家が破損した．平館で家潰1，死3．函館でも強く感じた．津波があり，余震が多かった．1968年十勝沖地震と似ているので，もっと沖の大きな地震かもしれない．"},{"id":"168","date":"1763 3 11","dateJP":"宝暦 13  1 27","latitude":"41","longitude":"142","magnitude":"≒7.25","Mw":"","dmgClass":"","region":"陸奥八戸","name":"宝暦の八戸沖地震","tsunamiDmg":"[0]","comment":"前年12月の地震以来震動とまらず，この日強震．建物の被害が多かった．"},{"id":"169","date":"1763 3 15","dateJP":"宝暦 13  2  1","latitude":"41","longitude":"142","magnitude":"7","Mw":"","dmgClass":"","region":"陸奥八戸","name":"","tsunamiDmg":"","comment":"城の塀倒れ，御朱印蔵の屋根破損．"},{"id":"170","date":"1766 3 8","dateJP":"明和  3  1 28","latitude":"40.7","longitude":"140.5","magnitude":"7.25","Mw":"","dmgClass":"","region":"津軽","name":"","tsunamiDmg":"","comment":"弘前から津軽半島にかけて被害が大きかった．弘前城破損，各地に地割れ．津軽藩の被害(社寺含まず)は，潰家5千余，焼失200余，圧死約1千，焼死約300．余震が年末まで続いた．"},{"id":"171","date":"1767 5 4","dateJP":"明和  4  4  7","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"陸中","name":"","tsunamiDmg":"","comment":"鬼柳(現北上市)で潰家1，焼失20余．津軽・八戸・盛岡・花巻・羽前南村山郡・江戸・八王子で有感．"},{"id":"172","date":"1767 10 22","dateJP":"明和  4  9 30","latitude":"35.7","longitude":"139.8","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"瓦が落ち，14〜15軒潰れ，所々破損があった．"},{"id":"173","date":"1768 7 22","dateJP":"明和  5  6  9","latitude":"26.2","longitude":"127.5","magnitude":"","Mw":"","dmgClass":"","region":"琉球","name":"","tsunamiDmg":"[1]","comment":"王城などの石垣が崩れた．津波が来て，慶良間島で田園と民家9戸を損じた．"},{"id":"174","date":"1768 9 8","dateJP":"明和  5  7 28","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"陸奥八戸","name":"","tsunamiDmg":"","comment":"29日にも2回地震，家屋・塀などの被害が少なくなかった．和賀郡沢内で震動が強かった．"},{"id":"175","date":"1769 7 12","dateJP":"明和  6  6  9","latitude":"40.6","longitude":"141.6","magnitude":"","Mw":"","dmgClass":"","region":"八戸","name":"","tsunamiDmg":"","comment":"御殿通り・外側通りで所々破損，南宗寺で御霊屋など破損．大橋落ちる．"},{"id":"176","date":"1769 8 29","dateJP":"明和  6  7 28","latitude":"33","longitude":"132.1","magnitude":"7.75","Mw":"","dmgClass":"","region":"日向・豊後・肥後","name":"","tsunamiDmg":"[1]","comment":"延岡城・大分城で被害多く，寺社・町屋の破損が多かった．熊本領内でも被害が多く，宇和島で強く感じた．津波があった．"},{"id":"177","date":"1771 4 24","dateJP":"明和  8  3 10","latitude":"24","longitude":"124.3","magnitude":"7.4","Mw":"","dmgClass":"","region":"八重山・宮古両群島","name":"八重山地震津波","tsunamiDmg":"[4]","comment":"震害はなかったようである．津波による被害が大きく，石垣島が特にひどかった．全体で家屋流失2千余，溺死約1万2千．"},{"id":"178","date":"1772 6 3","dateJP":"安永  1  5  3","latitude":"39.35","longitude":"141.9","magnitude":"6.75","Mw":"","dmgClass":"","region":"陸前・陸中","name":"","tsunamiDmg":"","comment":"遠野・宮古・大槌・沢内で落石や山崩れ，死12．花巻城で所々破損，地割れあり．盛岡で家屋破損．江戸など有感．1987年1月9日の地震に似ており，海岸近くのやや深い地震の可能性がある．"},{"id":"179","date":"1778 2 14","dateJP":"安永  7  1 18","latitude":"34.6","longitude":"132","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"石見","name":"","tsunamiDmg":"","comment":"那賀郡波佐村で石垣崩れ，都茂村で落石．安芸より備前まで強く震い，筑前で有感．"},{"id":"180","date":"1780 7 20","dateJP":"安永  9  6 19","latitude":"38.9","longitude":"139.9","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"酒田","name":"","tsunamiDmg":"","comment":"土蔵倒れかかって小家1軒潰れ，死2．亀ヶ崎城内で被害．余目・金浦でも小被害．"},{"id":"181","date":"1782 8 23","dateJP":"天明  2  7 15","latitude":"35.4","longitude":"139.1","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"相模・武蔵・甲斐","name":"","tsunamiDmg":"[1]","comment":"月はじめより前震があり，15日に2度大震．小田原城破損，人家約800破損．箱根・大山・富士山で山崩れ．江戸でも潰家や死者があった．熱海で津波があったらしい．"},{"id":"182","date":"1786 3 23","dateJP":"天明  6  2 24","latitude":"35.2","longitude":"139.1","magnitude":"5〜5.5","Mw":"","dmgClass":"","region":"箱根","name":"","tsunamiDmg":"","comment":"23〜24日で地震100回余．大石落ち，人家を多く破った．関所の石垣など破損．"},{"id":"183","date":"1789 5 11","dateJP":"寛政  1  4 17","latitude":"33.7","longitude":"134.3","magnitude":"7","Mw":"","dmgClass":"","region":"阿波","name":"","tsunamiDmg":"","comment":"阿波富岡町で文珠院や町屋の土蔵に被害，山崩れがあった．南部の沿岸地方，土佐室津に被害．広島・鳥取・岡山・山口で有感．震央は紀伊水道の可能性もある．"},{"id":"184","date":"1791 1 1","dateJP":"寛政  2 11 27","latitude":"35.8","longitude":"139.6","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"川越・蕨","name":"","tsunamiDmg":"","comment":"蕨で堂塔が転倒し，土蔵なども破損．川越で喜多院の本社屋根・瑞籬など破損．"},{"id":"185","date":"1791 7 23","dateJP":"寛政  3  6 23","latitude":"36.2","longitude":"138","magnitude":"≒6.75","Mw":"","dmgClass":"","region":"松本","name":"","tsunamiDmg":"","comment":"松本城で塀など崩れる．人家・土蔵も多く崩れた．27日暮までに地震79回．高山・甲府で有感．"},{"id":"186","date":"1792 5 21","dateJP":"寛政  4  4  1","latitude":"32.8","longitude":"130.3","magnitude":"6.4","Mw":"","dmgClass":"","region":"雲仙岳","name":"","tsunamiDmg":"[3]","comment":"前年10月から始まった地震が11月10日頃から強くなり，山崩れなどでたびたび被害があった．4月1日に大地震2回，前山(天狗山)の東部がくずれ，崩土約0.34km^3が島原海に入り津波を生じた．対岸の肥後でも被害が多く，津波による死者は全体で約1万5千，｢島原大変肥後迷惑｣と呼ばれた．"},{"id":"187","date":"1792 6 13","dateJP":"寛政  4  4 24","latitude":"43.75","longitude":"140","magnitude":"≒7.1","Mw":"","dmgClass":"","region":"後志","name":"","tsunamiDmg":"[2]","comment":"津波があった．忍路で港頭の岸壁が崩れ，海岸に引き上げていた夷船漂流，出漁中の夷人5人溺死．美国でも溺死若干．"},{"id":"188","date":"1793 1 13","dateJP":"寛政  4 12  2","latitude":"34.1","longitude":"131.5","magnitude":"6.25〜6.5","Mw":"","dmgClass":"","region":"長門・周防","name":"","tsunamiDmg":"","comment":"防府で人家の損壊が多かったという．"},{"id":"189","date":"1793 2 8","dateJP":"寛政  4 12 28","latitude":"40.85","longitude":"139.95","magnitude":"6.9〜7.1","Mw":"","dmgClass":"","region":"西津軽","name":"","tsunamiDmg":"[1]","comment":"鰺ヶ沢・深浦で激しく，全体で潰家154，死12など．大戸瀬を中心に約12kmの沿岸が最高3.5m隆起した．小津波があり，余震が続いた．"},{"id":"190","date":"1793 2 17","dateJP":"寛政  5  1  7","latitude":"38.3","longitude":"144","magnitude":"8.2","Mw":"","dmgClass":"","region":"陸前・陸中・磐城","name":"","tsunamiDmg":"[2]","comment":"仙台領内で家屋損壊1千余，死12．沿岸に津波が来て，全体で家潰流失1730余，船流破33，死44以上．余震が多かった．宮城県沖の巨大地震と考えられる．"},{"id":"191","date":"1794 11 25","dateJP":"寛政  6 11  3","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"江戸","name":"","tsunamiDmg":"","comment":"鳥取藩上屋敷・幕府書物方番所で被害．日光・甲府・矢祭・花巻で有感．"},{"id":"192","date":"1796 1 3","dateJP":"寛政  7 11 24","latitude":"35.7","longitude":"134.3","magnitude":"5〜6","Mw":"","dmgClass":"","region":"因幡","name":"","tsunamiDmg":"","comment":"岩美町で倉の壁が落ち，石塔倒れ，地下水の異常があった．余震が翌年正月まであった．"},{"id":"193","date":"1799 6 29","dateJP":"寛政 11  5 26","latitude":"36.6","longitude":"136.7","magnitude":"6","Mw":"","dmgClass":"","region":"加賀","name":"","tsunamiDmg":"","comment":"上下動が激しく，屋根石が1尺も飛び上がったという．金沢城で石垣破損，城下で潰家4169．能美・石川・河北郡で損家1003，潰家964．全体で死21．"},{"id":"194","date":"1801 5 27","dateJP":"享和  1  4 15","latitude":"35.3","longitude":"140.1","magnitude":"","Mw":"","dmgClass":"","region":"上総","name":"","tsunamiDmg":"","comment":"久留里城の塀など破損，民家の潰れるもの多かった．江戸で有感．"},{"id":"195","date":"1802 11 18","dateJP":"享和  2 10 23","latitude":"35.2","longitude":"136.5","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"畿内・名古屋","name":"","tsunamiDmg":"","comment":"奈良春日の石灯籠かなり倒れ，名古屋で本町御門西の土居の松倒れ，高壁崩れる．彦根・京都で有感．やや深い地震か？"},{"id":"196","date":"1802 12 9","dateJP":"享和  2 11 15","latitude":"37.8","longitude":"138.35","magnitude":"6.5〜7.0","Mw":"","dmgClass":"","region":"佐渡","name":"","tsunamiDmg":"","comment":"巳刻の地震で微小被害，未刻の地震は大きく，佐渡3郡全体で焼失328，潰家732，死19．島の西南海岸が最大2m強隆起した．鶴岡で強く感じ，米沢・江戸・日光・高山・秋田・弘前で有感．"},{"id":"197","date":"1804 7 10","dateJP":"文化  1  6  4","latitude":"39.05","longitude":"139.95","magnitude":"7","Mw":"","dmgClass":"","region":"羽前・羽後","name":"象潟地震","tsunamiDmg":"","comment":"5月より付近で鳴動があった．被害は全体で潰家5千以上，死300以上．象潟湖が隆起して乾陸あるいは沼となった．余震が多かった．象潟・酒田などに津波の記事がある．"},{"id":"198","date":"1810 9 25","dateJP":"文化  7  8 27","latitude":"39.9","longitude":"139.9","magnitude":"6.5","Mw":"","dmgClass":"","region":"羽後","name":"","tsunamiDmg":"","comment":"男鹿半島の東半分5月頃より鳴動し，7月中旬から地震が頻発，27日に大地震．寒風山を中心に被害があり，全潰1003，死57．秋田で強く感じ，角館・大館・鯵ヶ沢・弘前・鶴岡で有感．"},{"id":"199","date":"1811 1 27","dateJP":"文化  8  1  3","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"三宅島","name":"","tsunamiDmg":"","comment":"噴火活動による地震．山崩れ・地割れを生じた．"},{"id":"200","date":"1812 4 21","dateJP":"文化  9  3 10","latitude":"33.5","longitude":"133.5","magnitude":"","Mw":"","dmgClass":"","region":"土佐","name":"","tsunamiDmg":"","comment":"高知で土蔵壁落ち，瓦落下，塀の損所があった．中村の方が強かったともいう．"},{"id":"201","date":"1812 12 7","dateJP":"文化  9 11  4","latitude":"35.45","longitude":"139.65","magnitude":"6.25","Mw":"","dmgClass":"","region":"武蔵・相模","name":"","tsunamiDmg":"","comment":"江戸で小被害があった．最戸村(現横浜市港南区)で潰家22．その他神奈川・川崎・保土ヶ谷などに潰家や死者があった．"},{"id":"202","date":"1815 3 1","dateJP":"文化 12  1 21","latitude":"36.4","longitude":"136.5","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"加賀小松","name":"","tsunamiDmg":"","comment":"小松城の破損多く，岐阜県白鳥町の悲願寺で香炉が落ちた．金沢で強かった．"},{"id":"203","date":"1817 12 12","dateJP":"文化 14 11  5","latitude":"35.2","longitude":"139.05","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"箱根","name":"","tsunamiDmg":"","comment":"箱根で落石，江戸で幕府書物方の蔵に小被害．秩父・甲府・八王子で有感．"},{"id":"204","date":"1819 8 2","dateJP":"文政  2  6 12","latitude":"35.2","longitude":"136.3","magnitude":"7.25","Mw":"","dmgClass":"","region":"伊勢・美濃・近江","name":"","tsunamiDmg":"","comment":"近江八幡で潰家82，死5．木曽川下流では香取(多度町)で40軒全滅，金廻では海寿寺潰れ圧死70．名古屋・犬山・四日市・京都などのほか，金沢・敦賀・出石・大和郡山などでも被害．"},{"id":"205","date":"1821 9 12","dateJP":"文政  4  8 16","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"津軽・青森・八戸","name":"","tsunamiDmg":"","comment":"青森で小店の屋根落ち，子供1人死亡．八戸で城などに被害．"},{"id":"206","date":"1821 12 13","dateJP":"文政  4 11 19","latitude":"37.45","longitude":"139.6","magnitude":"5.5〜6.0","Mw":"","dmgClass":"","region":"岩代","name":"","tsunamiDmg":"","comment":"大沼郡大石組の狭い範囲に強震．130軒壊れ，破損300余軒，死若干．上下動が強く，山崩れがあった．翌年1月4日，さらに強い地震があった．"},{"id":"207","date":"1823 9 29","dateJP":"文政  6  8 25","latitude":"40","longitude":"141.1","magnitude":"5.75〜6","Mw":"","dmgClass":"","region":"陸中岩手山","name":"","tsunamiDmg":"","comment":"山崩れあり，西根八ヶ村に被害，潰家105など．岩手山の北30kmにある七時雨山も崩れ，死69，不明4．"},{"id":"208","date":"1826 8 28","dateJP":"文政  9  7 25","latitude":"36.2","longitude":"137.25","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"飛騨大野郡","name":"","tsunamiDmg":"","comment":"地裂け，石垣崩れる．土蔵の壁土落ち，石塔・石灯籠が倒れた．"},{"id":"209","date":"1828 5 26","dateJP":"文政 11  4 13","latitude":"32.6","longitude":"129.9","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"長崎","name":"","tsunamiDmg":"","comment":"出島の周壁が数ヶ所潰裂．天草で激しかったという．天草の海中で噴火に似た現象があったという．"},{"id":"210","date":"1828 12 18","dateJP":"文政 11 11 12","latitude":"37.6","longitude":"138.9","magnitude":"6.9","Mw":"","dmgClass":"","region":"越後","name":"","tsunamiDmg":"","comment":"激震地域は信濃川流域の平地．三条・見付・今町・与板などで被害が大きかった．武者によると全体で全潰9808，焼失1204，死1443であるが，実際はもっと多かったらしい．地割れから水や砂の噴出がみられたり，流砂現象がみられた．"},{"id":"211","date":"1830 8 19","dateJP":"天保  1  7  2","latitude":"35.1","longitude":"135.6","magnitude":"6.5","Mw":"","dmgClass":"","region":"京都および隣国","name":"","tsunamiDmg":"","comment":"洛中洛外の土蔵はほとんど被害を受けたが，民家の倒潰はほとんどなかった．御所・二条城などで被害．京都での死280．上下動が強く，余震が非常に多かった．"},{"id":"212","date":"1831 11 14","dateJP":"天保  2 10 11","latitude":"33.2","longitude":"130.3","magnitude":"≒6.1","Mw":"","dmgClass":"","region":"肥前","name":"","tsunamiDmg":"","comment":"佐賀城の石垣崩れ，侍屋敷・町郷に破損多く，潰家もあった．"},{"id":"213","date":"1832 3 15","dateJP":"天保  3  2 13","latitude":"40.7","longitude":"141.6","magnitude":"≒6.5","Mw":"","dmgClass":"","region":"八戸","name":"","tsunamiDmg":"","comment":"土蔵の破損が多かった．南宗寺・本寿寺の石碑所々痛む．"},{"id":"214","date":"1833 5 27","dateJP":"天保  4  4  9","latitude":"35.5","longitude":"136.6","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"美濃西部","name":"","tsunamiDmg":"","comment":"大垣北方の村々で山崩れ多く，死者11という．余震が多く，8月まで続く．震源は根尾谷断層に近い．"},{"id":"215","date":"1833 12 7","dateJP":"天保  4 10 26","latitude":"38.9","longitude":"139.25","magnitude":"7.5","Mw":"","dmgClass":"","region":"羽前・羽後・越後・佐渡","name":"","tsunamiDmg":"[2]","comment":"庄内地方で特に被害が大きく，潰家475，死42．津波が本庄から新潟に至る海岸と佐渡を襲い，能登で大破流出家約345，死約100．"},{"id":"216","date":"1834 2 9","dateJP":"天保  5  1  1","latitude":"43.3","longitude":"141.4","magnitude":"≒6.4","Mw":"","dmgClass":"","region":"石狩","name":"","tsunamiDmg":"","comment":"地割れ，泥噴出．アイヌの家23潰れる．その他，会所などに被害．"},{"id":"217","date":"1835 3 12","dateJP":"天保  6  2 14","latitude":"35.1","longitude":"132.6","magnitude":"≒5.5","Mw":"","dmgClass":"","region":"石見","name":"","tsunamiDmg":"","comment":"島根県高畑村で石地蔵・石塔・墓石などが倒れ，蔵の壁が破れ，石垣が崩れた．"},{"id":"218","date":"1835 7 20","dateJP":"天保  6  6 25","latitude":"38.5","longitude":"142.5","magnitude":"7","Mw":"","dmgClass":"","region":"仙台","name":"","tsunamiDmg":"[2]","comment":"仙台城で石垣崩れ，藩内で被害．岩手県藤沢町で石垣崩れ，蔵の壁を損じた．"},{"id":"219","date":"1836 3 31","dateJP":"天保  7  2 15","latitude":"34.4","longitude":"139.2","magnitude":"5〜6","Mw":"","dmgClass":"","region":"伊豆新島","name":"","tsunamiDmg":"","comment":"神社・寺の石垣崩れる．江戸で有感．2月末まで地震続く．"},{"id":"220","date":"1839 5 1","dateJP":"天保 10  3 18","latitude":"","longitude":"","magnitude":"≒7.0","Mw":"","dmgClass":"","region":"釧路・厚岸","name":"","tsunamiDmg":"","comment":"国泰寺門前の石灯籠大破，戸障子破損．津軽で強く感じた．"},{"id":"221","date":"1841 4 22","dateJP":"天保 12  3  2","latitude":"35","longitude":"138.5","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"駿河","name":"","tsunamiDmg":"","comment":"駿府城の石垣崩れ，久能山東照宮の堂・門など破損．江尻・清水辺で家や蔵の壁が落ち，地裂け，水吹き出す．三保の松原の砂地が2千坪ほど沈下した．"},{"id":"222","date":"1841 11 3","dateJP":"天保 12  9 20","latitude":"33.2","longitude":"132.4","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"宇和島","name":"","tsunamiDmg":"","comment":"宇和島城の塀・壁など破損．四国・中国の西部と筑後で有感．"},{"id":"223","date":"1842 4 17","dateJP":"天保 13  3  7","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"琉球","name":"","tsunamiDmg":"","comment":"宮古島などで5日頃から地震，7日の地震で石墻が多く崩れた．14日まで数十回の地震があった．"},{"id":"224","date":"1843 3 9","dateJP":"天保 14  2  9","latitude":"35.35","longitude":"139.1","magnitude":"6.5","Mw":"","dmgClass":"","region":"足柄・御殿場","name":"","tsunamiDmg":"","comment":"足柄萱沼村で石垣・堤の崩れ多く，御殿場の近くや津久井でも被害があった．"},{"id":"225","date":"1843 4 25","dateJP":"天保 14  3 26","latitude":"42","longitude":"146","magnitude":"≒7.5","Mw":"","dmgClass":"","region":"釧路・根室","name":"","tsunamiDmg":"[2]","comment":"厚岸国泰寺で被害があった．津波があり，全体で死46．家屋破壊76．八戸にも津波．松前・津軽で強く感じ，江戸でも有感．"},{"id":"226","date":"1844 8 8","dateJP":"弘化  1  6 25","latitude":"33","longitude":"131.3","magnitude":"","Mw":"","dmgClass":"","region":"肥後北部","name":"","tsunamiDmg":"","comment":"28日まで地震が多く，久住北里で特に強かった．杖立村で落石により百姓屋崩れる．"},{"id":"227","date":"1847 2 15","dateJP":"弘化  4  1  1","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"越後高田","name":"","tsunamiDmg":"","comment":"諸所破損，長屋も破損．"},{"id":"228","date":"1847 5 8","dateJP":"弘化  4  3 24","latitude":"36.7","longitude":"138.2","magnitude":"7.4","Mw":"","dmgClass":"","region":"信濃北部および越後西部","name":"善光寺地震","tsunamiDmg":"","comment":"被害範囲は高田から松本に至る地域で，特に水内・更級両郡の被害が最大だった．松代領で潰家9550，死2695，飯山領で潰家1977，死586，善光寺領で潰家2285，死2486など．全国からの善光寺の参詣者7千〜8千の内，生き残ったもの約1割という．山地で山崩れが多く，松代領では4万ヶ所以上．虚空蔵山が崩れて犀川をせき止め，上流は湖となったが，4月13日に決壊して流出家屋810，流死100余．"},{"id":"229","date":"1847 5 13","dateJP":"弘化  4  3 29","latitude":"37.2","longitude":"138.3","magnitude":"6.5","Mw":"","dmgClass":"","region":"越後頸城郡","name":"","tsunamiDmg":"","comment":"善光寺地震の被害と区別できないところが多い．潰家・大破ならびに死傷があった．地割れを生じ，泥を噴出し，田畑が埋没したところもあった．"},{"id":"230","date":"1848 1 10","dateJP":"弘化  4 12  5","latitude":"33.2","longitude":"130.4","magnitude":"5.9","Mw":"","dmgClass":"","region":"筑後","name":"","tsunamiDmg":"","comment":"柳川で家屋の倒潰があった．"},{"id":"231","date":"1848 1 13","dateJP":"弘化  4 12  8","latitude":"40.7","longitude":"140.6","magnitude":"6","Mw":"","dmgClass":"","region":"津軽","name":"","tsunamiDmg":"","comment":"弘前の城内・城下で被害．黒石・猿賀(弘前の北東)辺で特に強く，潰家があったらしい．"},{"id":"232","date":"1848 1 25","dateJP":"弘化  4 12 20","latitude":"32.85","longitude":"130.65","magnitude":"","Mw":"","dmgClass":"","region":"熊本","name":"","tsunamiDmg":"","comment":"熊本城内で石垣を損じ，座敷などの壁が落ちた．"},{"id":"233","date":"1853 1 26","dateJP":"嘉永  5 12 17","latitude":"36.6","longitude":"138.1","magnitude":"6.5","Mw":"","dmgClass":"","region":"信濃北部","name":"","tsunamiDmg":"","comment":"善光寺で被害．長野市中で下屋の破損があった．松代領で潰家23．"},{"id":"234","date":"1853 3 11","dateJP":"嘉永  6  2  2","latitude":"35.3","longitude":"139.15","magnitude":"6.7","Mw":"","dmgClass":"","region":"小田原付近","name":"","tsunamiDmg":"","comment":"小田原で被害が大きく，城内で潰れや大破があった．小田原領で潰家1千余，死24．山崩れが多かった．"},{"id":"235","date":"1854 7 9","dateJP":"安政  1  6 15","latitude":"34.75","longitude":"136.1","magnitude":"7.25","Mw":"","dmgClass":"","region":"伊賀・伊勢・大和および隣国","name":"","tsunamiDmg":"","comment":"12日頃から前震があった．上野付近で潰家2千余，死約600，奈良で潰家700以上，死約300など，全体で死者は1500を越える．上野の北方で西南西−東北東方向の断層を生じ，南側の1kmの地域が最大1.5m相対的に沈下した．木津川断層の活動であろう．"},{"id":"236","date":"1854 8 28","dateJP":"安政  1 閏7  5","latitude":"40.6","longitude":"141.6","magnitude":"6.5","Mw":"","dmgClass":"","region":"陸奥","name":"","tsunamiDmg":"","comment":"三戸・八戸で被害．地割れがあった．"},{"id":"237","date":"1854 12 23","dateJP":"安政  1 11  4","latitude":"34","longitude":"137.8","magnitude":"8.4","Mw":"","dmgClass":"","region":"東海・東山・南海諸道","name":"安政東海地震","tsunamiDmg":"[3]","comment":"被害は関東から近畿に及び，特に沼津から伊勢湾にかけての海岸がひどかった．津波が房総から土佐までの沿岸を襲い，被害をさらに大きくした．この地震による居宅の潰・焼失は約3万軒，死者は2千〜3千人と思われる．沿岸では著しい地殻変動が認められた．地殻変動や津波の解析から，震源域が駿河湾深くまで入り込んでいた可能性が指摘されており，すでに100年以上経過していることから，次の東海地震の発生が心配されている．"},{"id":"238","date":"1854 12 24","dateJP":"安政  1 11  5","latitude":"33","longitude":"135","magnitude":"8.4","Mw":"","dmgClass":"","region":"畿内・東海・東山・北陸・南海・山陰・山陽道","name":"安政南海地震","tsunamiDmg":"[4]","comment":"東海地震の32時間後に発生，近畿付近では二つの地震の被害をはっきりとは区別できない．被害地域は中部から九州に及ぶ．津波が大きく，波高は串本で15m，久礼で16m，種崎で11mなど．地震と津波の被害の区別が難しい．死者数千．室戸・紀伊半島は南上がりの傾動を示し，室戸・串本で約1m隆起，甲浦・加太で約1m沈下した．"},{"id":"239","date":"1854 12 26","dateJP":"安政  1 11  7","latitude":"33.25","longitude":"132","magnitude":"7.3〜7.5","Mw":"","dmgClass":"","region":"伊予西部・豊後","name":"","tsunamiDmg":"","comment":"南海地震の被害と区別が難しい．伊予大洲・吉田で潰家があった．鶴崎で倒れ屋敷100，土佐でも強く感じた．"},{"id":"240","date":"1855 3 15","dateJP":"安政  2  1 27","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"遠江・駿河","name":"","tsunamiDmg":"","comment":"大井川の堤揺れ込み，焼津で古い割れ目から水が噴出．"},{"id":"241","date":"1855 3 18","dateJP":"安政  2  2  1","latitude":"36.25","longitude":"136.9","magnitude":"6.75","Mw":"","dmgClass":"","region":"飛騨白川・金沢","name":"","tsunamiDmg":"","comment":"野谷村で寺・民家に破損があった．保木脇村で民家2軒が山抜けのため潰れ，死12．金沢城で石垣など破損．"},{"id":"242","date":"1855 8 16","dateJP":"安政  2  7  4","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"米子","name":"","tsunamiDmg":"","comment":"城内で所々崩れ，地割れもあった．"},{"id":"243","date":"1855 9 13","dateJP":"安政  2  8  3","latitude":"38.1","longitude":"142","magnitude":"7.3","Mw":"","dmgClass":"","region":"陸前","name":"","tsunamiDmg":"","comment":"仙台で屋敷の石垣，堂寺の石塔・灯籠崩れる．山形県・岩手県南部・新潟県分水町・常陸太田で有感．"},{"id":"244","date":"1855 11 7","dateJP":"安政  2  9 28","latitude":"34.5","longitude":"137.75","magnitude":"7.0〜7.5","Mw":"","dmgClass":"","region":"遠州灘","name":"","tsunamiDmg":"","comment":"前年の東海地震の最大余震．掛塚・下前野・袋井・掛川辺がひどく，ほとんど全滅．死者があった．津波があった．"},{"id":"245","date":"1855 11 11","dateJP":"安政  2 10  2","latitude":"35.65","longitude":"139.8","magnitude":"7.0〜7.1","Mw":"","dmgClass":"","region":"江戸および付近","name":"江戸地震","tsunamiDmg":"","comment":"下町で特に被害が大きかった．地震後30余ヶ所から出火したが，風が静かで焼失面積は2.2km^2にとどまった．江戸町方の被害は，潰れ焼失1万4千余軒，死4千余．武家方には死約2600等の被害があり，合わせて死は計1万とも．瓦版が多数発行された．"},{"id":"246","date":"1856 8 23","dateJP":"安政  3  7 23","latitude":"41","longitude":"142.3","magnitude":"7.5","Mw":"","dmgClass":"","region":"日高・胆振・渡島・津軽・南部","name":"安政の八戸沖地震","tsunamiDmg":"[2]","comment":"震害は少なかったが，津波が三陸及び北海道の南岸を襲った．南部藩で流失93，潰106，溺死26，八戸藩でも死3など．余震が多かった．1968年十勝沖地震に津波の様子がよく似ており，もう少し海溝寄りの地震かもしれない．"},{"id":"247","date":"1856 11 4","dateJP":"安政  3 10  7","latitude":"35.7","longitude":"139.5","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"江戸・所沢","name":"","tsunamiDmg":"","comment":"江戸で壁の剥落や積瓦の落下があり，傷23．粂川で家屋倒潰15という．"},{"id":"248","date":"1857 7 8","dateJP":"安政  4 閏5 17","latitude":"34.4","longitude":"131.4","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"萩","name":"","tsunamiDmg":"","comment":"城内で石垣などに小被害．市中でも小被害があった．"},{"id":"249","date":"1857 7 14","dateJP":"安政  4 閏5 23","latitude":"34.8","longitude":"138.2","magnitude":"6.25","Mw":"","dmgClass":"","region":"駿河","name":"","tsunamiDmg":"","comment":"田中城内で被害．藤枝・静岡で強くゆれ，相良で人家が倒れたという．"},{"id":"250","date":"1857 10 12","dateJP":"安政  4  8 25","latitude":"34","longitude":"132.75","magnitude":"7.25","Mw":"","dmgClass":"","region":"伊予・安芸","name":"","tsunamiDmg":"","comment":"今治で城内破損，郷町で潰家3，死1．宇和島・松山・広島などで被害．郡中で死4．"},{"id":"251","date":"1858 4 9","dateJP":"安政  5  2 26","latitude":"36.4","longitude":"137.2","magnitude":"7.0〜7.1","Mw":"","dmgClass":"","region":"飛騨・越中・加賀・越前","name":"飛越地震","tsunamiDmg":"","comment":"飛騨北部・越中で被害が大きく，飛騨で潰家319，死203．山崩れも多く，常願寺川の上流が堰止められ，後に決壊して流出および潰家1600余，溺死140の被害を出した．跡津川断層の運動(右横ずれ)によると考えられる．"},{"id":"252","date":"1858 4 9","dateJP":"安政  5  2 26","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"丹後宮津","name":"","tsunamiDmg":"","comment":"地割れを生じ，家屋が大破した．"},{"id":"253","date":"1858 4 23","dateJP":"安政  5  3 10","latitude":"36.6","longitude":"137.9","magnitude":"5.7","Mw":"","dmgClass":"","region":"信濃北西部","name":"","tsunamiDmg":"","comment":"大町組で家・蔵が潰れ，山崩れがあった．この地震が引金で，2月26日の地震で堰止められたところが崩れたと考えられる．"},{"id":"254","date":"1858 7 8","dateJP":"安政  5  5 28","latitude":"40.7","longitude":"142","magnitude":"7.3","Mw":"","dmgClass":"","region":"八戸・三戸","name":"","tsunamiDmg":"","comment":"八戸・三戸で土蔵・堤水門・橋など破損．青森・弘前・陸奥・田名部・鰺ヶ沢・秋田で強く感じた．"},{"id":"255","date":"1858 8 24","dateJP":"安政  5  7 16","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"紀伊","name":"","tsunamiDmg":"","comment":"田辺で瓦が落ち，壁が崩れた家があった．"},{"id":"256","date":"1858 9 29","dateJP":"安政  5  8 23","latitude":"40.9","longitude":"140.8","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"青森","name":"","tsunamiDmg":"","comment":"安方町で米蔵潰れる．狩場沢村(現平内町)で道路に亀裂があった．"},{"id":"257","date":"1859 1 5","dateJP":"安政  5 12  2","latitude":"34.8","longitude":"131.9","magnitude":"6.2","Mw":"","dmgClass":"","region":"石見","name":"","tsunamiDmg":"","comment":"島根県一帯で強く，波佐村で山崩れがあった．周布村・美濃村・下道川村などで被害．家潰56．"},{"id":"258","date":"1859 1 11","dateJP":"安政  5 12  8","latitude":"35.9","longitude":"139.7","magnitude":"≒6.0","Mw":"","dmgClass":"","region":"岩槻","name":"","tsunamiDmg":"","comment":"城の本丸櫓・多門その他破損．江戸・佐野・鹿沼で有感．"},{"id":"259","date":"1859 10 4","dateJP":"安政  6  9  9","latitude":"34.5","longitude":"132","magnitude":"6.0〜6.5","Mw":"","dmgClass":"","region":"石見","name":"","tsunamiDmg":"","comment":"島根県那賀郡で強く，周布村でも潰家や地割れがあった．広島城内でも被害があった．"},{"id":"260","date":"1861 10 21","dateJP":"文久  1  9 18","latitude":"38.5","longitude":"142","magnitude":"7.3","Mw":"","dmgClass":"","region":"陸前・磐城","name":"","tsunamiDmg":"","comment":"陸前の遠田・志田・登米・桃生等の各郡で特に被害が多く，潰家・死傷があった．江戸・新潟県分水町・長野・長万部・津軽まで有感．"},{"id":"261","date":"1865 2 24","dateJP":"元治  2  1 29","latitude":"","longitude":"","magnitude":"≒6.25","Mw":"","dmgClass":"","region":"播磨・丹波","name":"","tsunamiDmg":"","comment":"加古川上流の杉原谷で家屋が多く破壊したという．"},{"id":"262","date":"1866 11 24","dateJP":"慶応  2 10 18","latitude":"","longitude":"","magnitude":"","Mw":"","dmgClass":"","region":"銚子","name":"","tsunamiDmg":"","comment":"銚子市後飯町の浅間社の石の鳥居倒れる．日光・相馬・成田・江戸・干潟で有感．"}];res.columns = ["id","date","dateJP","latitude","longitude","magnitude","Mw","dmgClass","region","name","tsunamiDmg","comment"];module.exports = res;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	var app, ref;

	app = angular.module("seismology");

	ref = firebase.database().ref();

	app.factory("TranscriptionFactory", ["$firebaseObject", "$firebaseArray", "$firebaseAuth", "TextConverter", "Users", "History", "Timeline", "Books", "$sce", "$window", "CurrentUser", function($firebaseObject, $firebaseArray, $firebaseAuth, TextConverter, Users, History, Timeline, Books, $sce, $window, CurrentUser) {
	  var STATES;
	  STATES = {
	    "default": {
	      code: 'default',
	      label: '未着手',
	      desc: 'まだ翻刻されていません'
	    },
	    initiated: {
	      code: 'initiated',
	      label: '着手済み',
	      desc: '一部の文字のみ翻刻が完了した状態です'
	    },
	    finished: {
	      code: 'finished',
	      label: '翻刻完了',
	      desc: 'すべての文字の翻刻が完了した状態です。'
	    },
	    editing_current: {
	      code: 'editing_current',
	      label: 'あなたが編集中',
	      desc: 'あなたが編集中のため，他ユーザーは変更できません'
	    },
	    editing_others: {
	      code: 'editing_others',
	      label: '他ユーザーが編集中',
	      desc: '他のユーザーが編集中のため，変更できません'
	    },
	    frozen: {
	      code: 'frozen',
	      label: '保護中',
	      desc: '管理メンバーを除き翻刻文を変更できません．'
	    }
	  };
	  return $firebaseObject.$extend({
	    editingListRef: function() {
	      var uid;
	      uid = $firebaseAuth().$getAuth().uid;
	      return ref.child('users').child(uid).child("editing");
	    },
	    getEditingRecord: function() {
	      var bookId, bookId_content, content, uid;
	      bookId = this.getBookId();
	      content = this.$id;
	      bookId_content = bookId + "_" + content;
	      uid = $firebaseAuth().$getAuth().uid;
	      return $firebaseObject(ref.child('users').child(uid).child("editing").child(bookId_content));
	    },
	    addToEditingRecord: function() {
	      var record;
	      record = this.getEditingRecord();
	      record.bookId = this.getBookId();
	      record.content = parseInt(this.$id);
	      record.timestamp = this.timestamp;
	      return record.$save()["catch"](function(err) {
	        return console.log(err);
	      });
	    },
	    removeFromEditingRecord: function() {
	      return this.getEditingRecord().$remove();
	    },
	    getBookId: function() {
	      return this.$ref().toString().split("/").reverse()[1];
	    },
	    getCode: function() {
	      return this.getBookId() + '-' + this.$id;
	    },
	    startEditing: function(realtimeMode) {
	      if (realtimeMode == null) {
	        realtimeMode = false;
	      }
	      this.prevStatus = this.status;
	      this.status = "editing";
	      this.realtimeMode = realtimeMode;
	      this.tempEditedBy = $firebaseAuth().$getAuth().uid;
	      this.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      this.tempText = this.text;
	      this.tempChanged = false;
	      this.addToEditingRecord();
	      return this;
	    },
	    endEditing: function() {
	      this.status = "initiated";
	      this.realtimeMode = false;
	      this.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      this.editedBy = $firebaseAuth().$getAuth().uid;
	      this.text = this.tempText;
	      this.tempChanged = false;
	      this.removeFromEditingRecord();
	      return this;
	    },
	    abortEditing: function() {
	      this.status = this.prevStatus || "initiated";
	      this.realtimeMode = false;
	      this.tempText = null;
	      this.tempEditedBy = null;
	      this.tempChanged = false;
	      this.removeFromEditingRecord();
	      return this;
	    },
	    setTempChanged: function(changed) {
	      if (changed == null) {
	        changed = true;
	      }
	      this.tempChanged = changed;
	      return this;
	    },
	    setFinished: function() {
	      this.status = 'finished';
	      return this;
	    },
	    freeze: function() {
	      var tempChanged;
	      this.frozen = true;
	      this.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      this.editedBy = $firebaseAuth().$getAuth().uid;
	      tempChanged = false;
	      return this;
	    },
	    unfreeze: function() {
	      var tempChanged;
	      this.frozen = false;
	      this.timestamp = firebase.database.ServerValue.TIMESTAMP;
	      this.editedBy = $firebaseAuth().$getAuth().uid;
	      tempChanged = false;
	      return this;
	    },
	    isEditable: function() {
	      if (CurrentUser.get().isAdmin()) {
	        return true;
	      }
	      if (this.isFrozen()) {
	        return false;
	      }
	      return (this.status === "default") || (this.status === "initiated") || (this.status === "finished");
	    },
	    isEditingByCurrentUser: function() {
	      var uid;
	      if (this.status === "editing") {
	        uid = $firebaseAuth().$getAuth().uid;
	        return this.tempEditedBy === uid;
	      } else {
	        return false;
	      }
	    },
	    isFrozen: function() {
	      return this.frozen;
	    },
	    getCurrentState: function() {
	      if (this.status === "editing") {
	        if (this.isEditingByCurrentUser()) {
	          return STATES['editing_current'];
	        } else {
	          return STATES['editing_others'];
	        }
	      } else {
	        return STATES[this.status];
	      }
	    },
	    getFormattedHtml: function() {
	      var html, text;
	      if (this.isEditingByCurrentUser() || this.realtimeMode) {
	        text = this.tempText;
	      } else {
	        text = this.text;
	      }
	      if (!text) {
	        return "";
	      }
	      html = TextConverter.convert(text);
	      return html;
	    },
	    addHistory: function() {
	      var history;
	      history = History.getList(this.getBookId());
	      console.log(history);
	      return history.$add({
	        event: 'transcription',
	        uid: $firebaseAuth().$getAuth().uid,
	        timestamp: firebase.database.ServerValue.TIMESTAMP,
	        data: this
	      });
	    },
	    getTrustedText: function() {
	      return $sce.trustAsHtml(this.text);
	    },
	    getNoteArray: function(bookId, index, size) {
	      var notesRef;
	      if (size == null) {
	        size = 20;
	      }
	      notesRef = this.$ref().child("notes").orderByChild("timestamp").limitToLast(size);
	      return $firebaseArray(notesRef);
	    },
	    addNote: function(text) {
	      var timestamp, uid;
	      uid = $firebaseAuth().$getAuth().uid;
	      timestamp = firebase.database.ServerValue.TIMESTAMP;
	      return this.getNoteArray().$add({
	        uid: uid,
	        timestamp: timestamp,
	        text: text
	      });
	    },
	    countDiff: function() {
	      var count, d, diff, i, len;
	      diff = $window.JsDiff.diffChars(this.text.replace(/<br>/g, ""), this.tempText.replace(/<br>/g, ""));
	      count = 0;
	      console.log(diff);
	      for (i = 0, len = diff.length; i < len; i++) {
	        d = diff[i];
	        if (d.added) {
	          count += d.value.length;
	        }
	      }
	      return count;
	    }
	  });
	}]);

	app.factory("Diff", ["$window", function($window) {
	  return {
	    diffChars: function(original, revised) {
	      return $window.JsDiff.diffChars(original, revised);
	    },
	    styledDiffHtml: function(original, revised) {
	      var d, diff, html, i, len;
	      diff = this.diffChars(original, revised);
	      html = "";
	      for (i = 0, len = diff.length; i < len; i++) {
	        d = diff[i];
	        if (d.added) {
	          html += "<span class='diff added'>" + d.value + "</span>";
	        } else if (d.removed) {
	          html += "<span class='diff removed'>" + d.value + "</span>";
	        } else {
	          html += d.value;
	        }
	      }
	      return html;
	    }
	  };
	}]);

	app.factory("History", ["$firebaseArray", function($firebaseArray) {
	  var historyRef;
	  historyRef = ref.child('history');
	  return {
	    getList: function(bookId, limit) {
	      if (limit == null) {
	        limit = 20;
	      }
	      return $firebaseArray(historyRef.child(bookId).limitToLast(limit));
	    }
	  };
	}]);

	app.factory("TextConverter", ["$sanitize", function($sanitize) {
	  return {
	    ruby: function(text) {
	      text = text.replace(/\(/g, "（").replace(/\)/g, "）");
	      return text.replace(/｜?\w?([一-龠々■？ゝゞヽヾ〻々〳〵〴〵]+?)（(.+?)）/g, function(match, kanji, ruby) {
	        return "<ruby>\n  <rb>" + ($sanitize(kanji)) + "</rb>\n  <rt>" + ($sanitize(ruby)) + "</rt>            \n</ruby>";
	      });
	    },
	    rubyWildChar: function(text) {
	      return text.replace(/《ルビ：(.+?)｜(.+?)》/g, function(match, kanji, ruby) {
	        return "<ruby>\n  <rb>" + ($sanitize(kanji)) + "</rb>\n  <rt>" + ($sanitize(ruby)) + "</rt>            \n</ruby>";
	      });
	    },
	    warigaki: function(text) {
	      return text.replace(/《割書：(.+?)｜(.+?)》/g, function(match, right, left) {
	        return "<span class=\"warigaki\">\n  <span class=\"warigaki-left\">" + ($sanitize(left)) + "</span>\n  <span class=\"warigaki-right\">" + ($sanitize(right)) + "</span>            \n</span>";
	      });
	    },
	    hako: function(text) {
	      return text.replace(/《箱：((?:.|\n)+?)》/g, function(match, content) {
	        console.log("hako", content);
	        return "<span class='hako'>" + content + "</span>";
	      });
	    },
	    comment: function(text) {
	      return text.replace(/【(.+?)】/g, function(match, content) {
	        return "<span class='comment'>（" + ($sanitize(content)) + "）</span>";
	      });
	    },
	    dubiousSingle: function(text) {
	      return text.replace(/(.)？/g, function(match, content) {
	        return "<span class='dubious' >" + ($sanitize(content)) + "</span>";
	      });
	    },
	    dubiousMulti: function(text) {
	      return text.replace(/《？：([\s\S]+?)》/g, function(match, content) {
	        return "<span class='dubious'>" + ($sanitize(content)) + "</span>";
	      });
	    },
	    illegible: function(text) {
	      return text.replace(/(□+)/g, function(match, content) {
	        return "<span class='illegible'>" + content + "</span>";
	      });
	    },
	    kaeriten: function(text) {
	      return text.replace(/｛(.+?)｝/g, function(match, content) {
	        return "<span class='kaeriten'>" + content + "</span>";
	      });
	    },
	    okuri: function(text) {
	      return text.replace(/［(.+?)］/g, function(match, content) {
	        return "<span class='okuri'>" + content + "</span>";
	      });
	    },
	    convert: function(text) {
	      var c, conversions, i, len;
	      conversions = ["illegible", "ruby", "rubyWildChar", "hako", "warigaki", "dubiousMulti", "dubiousSingle", "comment", "kaeriten", "okuri"];
	      for (i = 0, len = conversions.length; i < len; i++) {
	        c = conversions[i];
	        text = this[c].call(this, text);
	      }
	      return text;
	    }
	  };
	}]);

	app.factory("TranscriptionList", ["$firebaseArray", "TranscriptionFactory", function($firebaseArray, TranscriptionFactory) {
	  return $firebaseArray.$extend({
	    $$added: function(snap) {
	      return new TranscriptionFactory(snap.ref);
	    },
	    $$updated: function(snap) {
	      return this.$getRecord(snap.key).$$updated(snap);
	    }
	  });
	}]);

	app.factory("Transcription", ["$firebaseArray", "TranscriptionFactory", "TranscriptionList", function($firebaseArray, TranscriptionFactory, TranscriptionList) {
	  var temporary, trscRef;
	  trscRef = ref.child('transcriptions');
	  temporary = {};
	  return {
	    get: function(bookId, contentId) {
	      return new TranscriptionFactory(trscRef.child(bookId).child(contentId));
	    },
	    getList: function(bookId) {
	      return new TranscriptionList(trscRef.child(bookId));
	    },
	    saveTemp: function(text) {}
	  };
	}]);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var app, ref;

	app = angular.module("seismology");

	ref = firebase.database().ref();

	app.factory("LevelTable", function() {
	  var table;
	  table = __webpack_require__(125);
	  return {
	    getLevelOf: function(points) {
	      var index;
	      index = table.findIndex(function(level) {
	        return points < level;
	      });
	      return index;
	    },
	    pointsInCurrentLevel: function(points) {
	      var index;
	      if (!points) {
	        return 0;
	      }
	      index = table.findIndex(function(levelPoint) {
	        return points < levelPoint;
	      });
	      return points - table[index - 1];
	    },
	    getLevelPoints: function(level) {
	      return table[level] - table[level - 1];
	    }
	  };
	});

	app.factory("CurrentUserFactory", ["$firebaseObject", "$firebaseArray", "LevelTable", "Notification", "Admins", function($firebaseObject, $firebaseArray, LevelTable, Notification, Admins) {
	  var PT_CHAR, PT_DIAMOND, PT_LIKE;
	  PT_DIAMOND = 100;
	  PT_LIKE = 300;
	  PT_CHAR = 1;
	  return $firebaseObject.$extend({
	    update: function(data) {
	      var k, promises, v;
	      promises = (function() {
	        var results;
	        results = [];
	        for (k in data) {
	          v = data[k];
	          results.push(this.$ref().child(k).set(v));
	        }
	        return results;
	      }).call(this);
	      return Promise.all(promises);
	    },
	    updateGemCount: function() {
	      var progress, progressRef;
	      ref = firebase.database().ref();
	      progressRef = ref.child('lesson-progress').child(this.$id);
	      progress = $firebaseArray(progressRef);
	      return progress.$loaded().then((function(_this) {
	        return function(ary) {
	          var count, i, len, p;
	          count = 0;
	          for (i = 0, len = ary.length; i < len; i++) {
	            p = ary[i];
	            count += p.$value;
	          }
	          return _this.update({
	            gemCount: count
	          });
	        };
	      })(this));
	    },
	    updatePoints: function() {
	      return this.$loaded((function(_this) {
	        return function() {
	          var points;
	          _this.gemCount || (_this.gemCount = 0);
	          _this.likesCount || (_this.likesCount = 0);
	          _this.charCount || (_this.charCount = 0);
	          points = (PT_DIAMOND * _this.gemCount) + (PT_LIKE * _this.likesCount) + (PT_CHAR * _this.charCount);
	          return _this.update({
	            points: points
	          });
	        };
	      })(this));
	    },
	    updateLevel: function() {
	      var level;
	      this.currentLevel || (this.currentLevel = 1);
	      level = LevelTable.getLevelOf(this.points);
	      if (level > this.currentLevel) {
	        this.currentLevel = level;
	        return this.update({
	          currentLevel: level
	        }).then(function() {
	          return Notification.levelUp(level);
	        });
	      }
	    },
	    isAdmin: function() {
	      return Admins.isAdmin(this.$id);
	    }
	  });
	}]);

	app.factory("Admins", ["$firebaseArray", function($firebaseArray) {
	  var admins, adminsRef;
	  adminsRef = firebase.database().ref().child('/admins');
	  admins = $firebaseArray(adminsRef);
	  return {
	    isAdmin: function(uid) {
	      var ref1;
	      return (ref1 = admins.$getRecord(uid)) != null ? ref1.$value : void 0;
	    }
	  };
	}]);

	app.factory("CurrentUser", ["$firebaseObject", "$firebaseAuth", "CurrentUserFactory", function($firebaseObject, $firebaseAuth, CurrentUserFactory) {
	  return {
	    initUser: function() {
	      var charCount, gemCount, points, uid, user, userRef;
	      ref = firebase.database().ref();
	      uid = $firebaseAuth().$getAuth().uid;
	      userRef = ref.child('users').child(uid);
	      user = new CurrentUserFactory(userRef);
	      gemCount = $firebaseObject(userRef.child('gemCount'));
	      charCount = $firebaseObject(userRef.child('charCount'));
	      points = $firebaseObject(userRef.child('points'));
	      gemCount.$watch((function(_this) {
	        return function(data) {
	          return user.updatePoints();
	        };
	      })(this));
	      charCount.$watch(function() {
	        return user.updatePoints();
	      });
	      points.$watch(function() {
	        return user.updateLevel();
	      });
	      return user;
	    },
	    get: function() {
	      this.user || (this.user = this.initUser());
	      return this.user;
	    }
	  };
	}]);

	app.factory("UserFactory", ["$firebaseObject", function($firebaseObject) {
	  return $firebaseObject.$extend({
	    upvote: function() {
	      return usersRef.child(uid + '/likesCount').transaction(function(current) {
	        return (current || 0) + 1;
	      });
	    }
	  });
	}]);

	app.factory("Users", ["$firebaseObject", "$firebaseAuth", "$firebaseArray", "$firebase", function($firebaseObject, $firebaseAuth, $firebaseArray, $firebase) {
	  var cache, currentUser, usersRef;
	  usersRef = ref.child('users');
	  cache = {};
	  currentUser = null;
	  return {
	    update: function(uid, data) {
	      var user;
	      user = $firebaseObject(usersRef.child(uid));
	      user.name = data.displayName;
	      user.avatar = data.photoURL;
	      user.providerId = data.providerId;
	      return user.$save();
	    },
	    current: function() {
	      return this.get($firebaseAuth().$getAuth().uid);
	    },
	    get: function(uid) {
	      var user;
	      if ((user = cache[uid])) {
	        return user;
	      } else {
	        user = $firebaseObject(usersRef.child(uid));
	        cache[uid] = user;
	        return user;
	      }
	    },
	    getCharRanking: function(limit) {
	      if (limit == null) {
	        limit = 30;
	      }
	      return $firebaseArray(usersRef.orderByChild('charCount').limitToLast(limit));
	    },
	    upvote: function(uid) {
	      return usersRef.child(uid + '/likesCount').transaction(function(current) {
	        return (current || 0) + 1;
	      });
	    },
	    downvote: function(uid) {
	      return usersRef.child(uid + '/likesCount').transaction(function(current) {
	        return (current || 0) - 1;
	      });
	    },
	    addCharCount: function(count) {
	      var uid;
	      uid = $firebaseAuth().$getAuth().uid;
	      return usersRef.child(uid + '/charCount').transaction(function(current) {
	        return (current || 0) + count;
	      });
	    }
	  };
	}]);

	app.factory("NotificationList", ["$firebaseArray", "$state", function($firebaseArray, $state) {
	  return $firebaseArray.$extend({
	    getUnreadCount: function() {
	      var count, i, len, n, ref1;
	      count = 0;
	      ref1 = this.$list;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        n = ref1[i];
	        if (!n.read) {
	          count += 1;
	        }
	      }
	      return count;
	    },
	    jumpToSource: function(record) {
	      var data;
	      console.log(record);
	      switch (record.type) {
	        case 'post_liked':
	          return $state.go('dashboard.post', {
	            post_id: record.post_id
	          });
	        case 'comment_liked':
	          return $state.go('dashboard.post', {
	            post_id: record.post_id
	          });
	        case 'comment_created':
	          return $state.go('dashboard.post', {
	            post_id: record.post_id
	          });
	        case 'discussion_liked':
	          return $state.go('dashboard.discussion', {
	            id: record.discussion_id
	          });
	        case 'discussion_comment_liked':
	          return $state.go('dashboard.discussion', {
	            id: record.discussion_id
	          });
	        case 'discussion_comment_created':
	          return $state.go('dashboard.discussion', {
	            id: record.discussion_id
	          });
	        case 'timeline_event_liked':
	          data = {
	            id: record.book_id,
	            content: record.content + 1
	          };
	          return $state.go('transcription.content.history', data);
	        case 'timeline_event_created':
	          data = {
	            id: record.book_id,
	            content: record.content + 1
	          };
	          return $state.go('transcription.content.history', data);
	      }
	    }
	  });
	}]);

	app.factory('AppServer', ["$http", function($http) {
	  var SERVER_URL;
	  SERVER_URL = "https://wahon-server.herokuapp.com/";
	  return {
	    post: function(path, data) {
	      return $http({
	        method: 'post',
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        },
	        url: SERVER_URL + path,
	        transformRequest: function(data) {
	          return $.param(data);
	        },
	        data: data
	      });
	    }
	  };
	}]);

	app.factory("Notification", ["$http", "$firebaseArray", "$firebaseAuth", "NotificationList", function($http, $firebaseArray, $firebaseAuth, NotificationList) {
	  var SERVER_URL, post;
	  SERVER_URL = "https://wahon-server.herokuapp.com/notifications/";
	  post = function(url, data) {
	    return $http({
	      method: 'post',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      url: url,
	      transformRequest: function(obj) {
	        var k, str, v;
	        str = [];
	        for (k in data) {
	          v = data[k];
	          str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
	        }
	        return str.join("&");
	      },
	      data: data
	    });
	  };
	  return {
	    levelUp: function(level) {
	      var uid, url;
	      this.levelsNotified || (this.levelsNotified = {});
	      console.log(this.levelsNotified);
	      if (this.levelsNotified[level]) {
	        return;
	      }
	      uid = $firebaseAuth().$getAuth().uid;
	      url = SERVER_URL + "users/levelup";
	      this.levelsNotified[level] = true;
	      return post(url, {
	        uid: uid
	      });
	    },
	    commentCreated: function(postId, commentId) {
	      var url;
	      url = SERVER_URL + "comments";
	      return post(url, {
	        post_id: postId,
	        comment_id: commentId
	      });
	    },
	    postLiked: function(postId, userId) {
	      var url;
	      url = SERVER_URL + "likes/post";
	      return post(url, {
	        post_id: postId,
	        liker_uid: userId
	      });
	    },
	    commentLiked: function(postId, commentId, userId) {
	      var url;
	      url = SERVER_URL + "likes/comment";
	      return post(url, {
	        post_id: postId,
	        comment_id: commentId,
	        liker_uid: userId
	      });
	    },
	    discussionCommentCreated: function(discussionId, commentId) {
	      var url;
	      url = SERVER_URL + ("discussions/" + discussionId + "/comments");
	      return post(url, {
	        comment_id: commentId
	      });
	    },
	    discussionLiked: function(discussionId, userId) {
	      var url;
	      url = SERVER_URL + ("discussions/" + discussionId + "/likes");
	      return post(url, {
	        liker_uid: userId
	      });
	    },
	    discussionCommentLiked: function(discussionId, commentId, userId) {
	      var url;
	      url = SERVER_URL + ("discussions/" + discussionId + "/comments/" + commentId + "/likes");
	      return post(url, {
	        liker_uid: userId
	      });
	    },
	    timelineEventLiked: function(eventId) {
	      var url;
	      url = SERVER_URL + ("timeline/" + eventId + "/likes");
	      return post(url, {
	        liker_uid: $firebaseAuth().$getAuth().uid
	      });
	    },
	    timelineEventCreated: function(eventId, predesessorIds) {
	      var url;
	      url = SERVER_URL + ("timeline/" + eventId);
	      post(url, {
	        predesessorIds: predesessorIds.join(',')
	      });
	      return console.log(predesessorIds.join(','));
	    },
	    getList: function(limit) {
	      var query, uid;
	      if (limit == null) {
	        limit = 20;
	      }
	      uid = $firebaseAuth().$getAuth().uid;
	      ref = firebase.database().ref().child('notifications').child(uid);
	      query = ref.orderByChild('rtimestamp').limitToFirst(limit);
	      return new NotificationList(query);
	    },
	    getUnread: function(limit) {
	      var query, uid;
	      if (limit == null) {
	        limit = 20;
	      }
	      uid = $firebaseAuth().$getAuth().uid;
	      ref = firebase.database().ref().child('notifications').child(uid);
	      query = ref.orderByChild("read").equalTo(false).limitToFirst(limit);
	      return $firebaseArray(query);
	    }
	  };
	}]);

	app.factory("DesktopNotification", ["$http", "$window", "CurrentUser", "AppServer", "VAPID_PUBLIC_KEY", function($http, $window, CurrentUser, AppServer, VAPID_PUBLIC_KEY) {
	  return {
	    registerServiceWorker: function() {
	      return $window.navigator.serviceWorker.register('push.js');
	    },
	    requestPermission: function() {
	      return $window.Notification.requestPermission();
	    },
	    subscribePush: function() {
	      return $window.navigator.serviceWorker.ready.then(function(sw) {
	        var opts;
	        opts = {
	          userVisibleOnly: true,
	          applicationServerKey: VAPID_PUBLIC_KEY.ARRAY
	        };
	        return sw.pushManager.subscribe(opts);
	      });
	    },
	    getSubscription: function() {
	      return $window.navigator.serviceWorker.ready.then(function(sw) {
	        return sw.pushManager.getSubscription();
	      });
	    },
	    sendSubscriptionToServer: function(subscription) {
	      return AppServer.post(subscription);
	    },
	    checkNotificationSupport: function() {
	      var notificationSupport, workerSupport;
	      notificationSupport = $window.Notification;
	      workerSupport = $window.navigator && $window.navigator.serviceWorker;
	      return notificationSupport && workerSupport;
	    },
	    enableNotification: function() {
	      return this.registerServiceWorker().then((function(_this) {
	        return function() {
	          return _this.subscribePush();
	        };
	      })(this)).then((function(_this) {
	        return function() {
	          return _this.getSubscription();
	        };
	      })(this)).then((function(_this) {
	        return function(subscription) {
	          var data;
	          data = {
	            subscription: subscription.toJSON(),
	            uid: CurrentUser.get().$id
	          };
	          return AppServer.post('push/subscribe', data);
	        };
	      })(this)).then((function(_this) {
	        return function() {
	          return _this.requestPermission();
	        };
	      })(this));
	    }
	  };
	}]);


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = [0,500,1000,1500,2000,2500,3000,4000,5000,6000,7000,8000,10000,12000,14000,16000,18000,20000,22000,24000,26000,28000,31000,34000,37000,40000,43000,46000,49000,52000,55000,58000,61000,64000,67000,70000,73000,76000,79000,82000,85000,88000,91000,94000,97000,100000,103000,106000,109000,112000,115000,118000,124000,130000,136000,142000,148000,154000,160000,166000,172000,178000,184000,190000,196000,202000,208000,214000,220000,226000,232000,238000,244000,250000,256000,262000,268000,274000,280000,286000,292000,298000,304000,310000,316000,322000,328000,334000,340000,346000,352000,358000,364000,370000,376000,382000,388000,394000,400000,406000,412000]

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.directive('contenteditable', ["$window", function($window) {
	  return {
	    require: 'ngModel',
	    restrict: 'A',
	    link: function(scope, elm, attr, ngModel) {
	      var updateViewValue;
	      updateViewValue = function() {
	        return ngModel.$setViewValue(this.innerHTML);
	      };
	      elm.on('keyup', updateViewValue);
	      scope.$on('$destroy', function() {
	        return elm.off('keyup', updateViewValue);
	      });
	      ngModel.$render = function() {
	        return elm.html(ngModel.$viewValue);
	      };
	      return elm.on('paste', function(e) {
	        var text;
	        e.preventDefault();
	        text = e.clipboardData.getData("text/plain");
	        return document.execCommand("insertHTML", false, text);
	      });
	    }
	  };
	}]);

	app.directive('focusOn', function() {
	  return function(scope, elem, attr) {
	    return scope.$on(attr.focusOn, function(e) {
	      return elem[0].focus();
	    });
	  };
	});

	app.directive('execOnScrollBottom', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var raw;
	      raw = element[0];
	      return element.on('scroll', function() {
	        if (raw.scrollTop + raw.offsetHeight === raw.scrollHeight) {
	          return scope.$eval(attrs.execOnScrollBottom);
	        }
	      });
	    }
	  };
	});

	app.directive('diamond', function() {
	  return {
	    restrict: 'E',
	    scope: {
	      'count': '@'
	    },
	    link: function(scope, element, attrs) {
	      return attrs.$observe('count', function() {
	        scope.count1 = parseInt(scope.count);
	        scope.count2 = 5 - scope.count1;
	        scope.arr1 = new Array(scope.count1);
	        return scope.arr2 = new Array(scope.count2);
	      });
	    },
	    template: "<div class='diamond'>\n  <img ng-repeat='c in arr1 track by $index' src='resources/img/diamond.png'>\n  <img ng-repeat='c in arr2 track by $index' src='resources/img/diamond_inactive.png'>\n</div>"
	  };
	});

	app.directive('openProfile', ["$mdDialog", function($mdDialog) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var diagName;
	      element.addClass('open-profile');
	      diagName = attrs.openDialog;
	      return element.on('click', function() {
	        console.log(scope.$eval(attrs.locals));
	        return $mdDialog.show({
	          controller: "ProfileDialogCtrl",
	          templateUrl: "templates/dialogs/profile.html",
	          parent: angular.element(document.body),
	          clickOutsideToClose: true,
	          locals: {
	            user: scope.$eval(attrs.openProfile)
	          }
	        });
	      });
	    }
	  };
	}]);

	app.directive('openLikes', ["$mdDialog", function($mdDialog) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      var diagName;
	      element.addClass('open-likes');
	      diagName = attrs.openDialog;
	      return element.on('click', function() {
	        console.log(scope.$eval(attrs.locals));
	        return $mdDialog.show({
	          controller: "LikesDialogCtrl",
	          templateUrl: "templates/dialogs/likes.html",
	          parent: angular.element(document.body),
	          clickOutsideToClose: true,
	          locals: {
	            likes: scope.$eval(attrs.openLikes)
	          }
	        });
	      });
	    }
	  };
	}]);

	app.directive('errSrc', function() {
	  return {
	    link: function(scope, element, attrs) {
	      element.bind('error', function() {
	        if (attrs.src !== attrs.errSrc) {
	          attrs.$set('src', attrs.errSrc);
	        }
	      });
	    }
	  };
	});


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	var app;

	app = angular.module("seismology");

	app.filter('lb2br', ["$sce", function($sce) {
	  return function(input) {
	    var pat, regex;
	    pat = "(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)";
	    regex = new RegExp(pat, 'g');
	    return input.replace(regex, '<br/>').replace(/(<br\/>){3,}/, '<br/><br/>');
	  };
	}]);

	app.filter('stripTags', function() {
	  return function(input) {
	    return String(input).replace(/<[^>]+>/gm, '');
	  };
	});

	app.filter('trust', ["$sce", function($sce) {
	  return function(input) {
	    return $sce.trustAsHtml(input);
	  };
	}]);

	app.filter('ellipsis', function() {
	  return function(input, length) {
	    if (length == null) {
	      length = 100;
	    }
	    if (input && input.length > length) {
	      return input.substring(0, length) + "...";
	    } else {
	      return input;
	    }
	  };
	});

	app.filter('htmlToPlainText', function() {
	  return function(text) {
	    if (text) {
	      return String(text).replace(/<[^>]+>/gm, '');
	    } else {
	      return '';
	    }
	  };
	});

	app.filter('reverse', function() {
	  return function(items) {
	    return items.slice().reverse();
	  };
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(91)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/sass-loader/index.js?sourceMap!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/sass-loader/index.js?sourceMap!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(90)();
	// imports


	// module
	exports.push([module.id, ".balloon{-webkit-border-radius:10px;position:relative;width:90%;border:1px solid #ccc;background-color:#fff;padding:10px;display:block;margin:5px auto 10px}.balloon:before{bottom:-10px;border-top:10px solid #ccc}.balloon:after,.balloon:before{content:\"\";position:absolute;left:50%;margin-left:-10px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent}.balloon:after{bottom:-9px;border-top:10px solid #fff}.dialog .block{display:block;margin:auto}.section-header{margin-top:10px;color:#fff;font-size:26px;font-weight:700;font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif;background-color:#5e84ff;-webkit-border-radius:20px;padding:3px;text-align:center}.lesson{position:relative;margin-bottom:15px;text-align:center}.lesson a{text-decoration:none}.lesson .lesson-icon{width:80px;cursor:pointer;height:80px;-webkit-border-radius:50%;border:6px solid #2b746e;padding:3px}.lesson .lesson-icon:active{box-shadow:0 0 12px rgba(0,0,0,.9);filter:brightness(50%)}.lesson .lesson-icon.activated{filter:brightness(50%)}.lesson .activated .lesson-icon{filter:brightness(50%);box-shadow:0 0 12px rgba(0,0,0,.9)}.lesson .test{border:6px solid red}.lesson .lesson-title{font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif;font-size:16px;font-weight:700;text-align:center;margin:0;color:#747474}.lesson img.cleared{width:60px;position:absolute;top:-10px;left:25%}.learn .lesson-list{background-color:#fff}.learn .lesson-list .wrapper{text-align:center}.learn .lesson-list .wrapper .activated .book-thumb{opacity:.7}.learn .lesson-list .wrapper .book-thumb{width:90%;margin:5px;-webkit-border-radius:10px}.learn .lesson-list .wrapper .book-thumb.activated,.learn .lesson-list .wrapper .book-thumb:hover{opacity:.7}.learn .lesson-list .wrapper .description{text-align:left;margin-bottom:15px;padding:5px;color:#444}.learn .lesson-list .wrapper .section-header{margin-top:10px;color:#fff;font-size:26px;font-weight:700;background-color:#5e84ff;-webkit-border-radius:20px;padding:3px}.char-lesson .md-toolbar-tools,.char-lesson md-toolbar,.learn .lesson-list .wrapper .section-header{font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif}.char-lesson .char-list{border-right:1px solid #ddd}.char-lesson .char-list md-list{padding:0}.char-lesson .char-list md-list h2{font-size:18px;font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif}.char-lesson .char-list md-list .item-menu-active{background-color:#ddd}.char-lesson .char-view{font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif;writing-mode:vertical-rl}.char-lesson .char-view .multi img,.char-lesson .char-view .single img{max-width:50px;margin:4px}.quiz-dialog .balloon{max-width:300px}.quiz-dialog .quiz-image{margin:auto;font-family:ipa-mincho,\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D,serif;font-size:26px;writing-mode:vertical-rl}.quiz-dialog .quiz-image p{margin:0}.quiz-dialog .quiz-image img{max-height:250px}.quiz-dialog .input-container .block{display:block;text-align:center}.quiz-dialog .input-container input{margin-left:70px;outline:none;border:1px solid #aaa;transition:all .3s;resize:none;font-size:26px;text-align:center}.quiz-dialog .input-container input:focus{box-shadow:0 0 7px #1abc9c;border:1px solid #1abc9c}.quiz-dialog md-dialog-actions{background-color:#ddd}.quiz-dialog md-dialog-actions.correct{background-color:#def0a5}.quiz-dialog md-dialog-actions.incorrect{background-color:#ffd4cc}.color-light{color:#fff}.color-stable{color:#f8f8f8}.color-positive{color:#387ef5}.color-calm{color:#11c1f3}.color-balanced{color:#33cd5f}.color-energized{color:#ffc900}.color-assertive{color:#ef473a}.color-royal{color:#886aea}.color-dark{color:#747474}.color-sub{color:rgba(0,0,0,.54)}.bg-light{background:#fff}.bg-stable{background:#f8f8f8}.bg-positive{background:#387ef5}.bg-calm{background:#11c1f3}.bg-balanced{background:#33cd5f}.bg-energized{background:#ffc900}.bg-assertive{background:#ef473a}.bg-royal{background:#886aea}.bg-dark{background:#747474}.bg-sub{background:rgba(0,0,0,.54)}.bg-default{background:#f6f7f9}html{overflow:hidden}body,html{height:100%}body{font-family:Roboto,sans-serif;font-size:14px;margin:0;padding:0;overflow:auto}.md-subheader,md-content{background:#e9ebee}md-whiteframe{background:#fff}.block{text-align:left}.user-avatar{display:inline;vertical-align:middle;border-radius:50%;width:40px;height:40px}.link{color:#167ac6;cursor:pointer;font-size:14px}.link:hover{text-decoration:underline}.tag{font-size:14px;padding:3px;margin:2px;border-radius:5px;display:inline-block;color:#fff}hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.clickable{cursor:pointer}diamond{display:block;margin-bottom:-5px}diamond .diamond{display:block;margin:0}diamond .diamond img{width:30px;vertical-align:middle}.open-likes,.open-profile{cursor:pointer}.open-likes:hover,.open-profile:hover{text-decoration:underline}.profile .status img{height:26px;vertical-align:middle}.profile .status span{margin-right:10px;font-size:16px;font-weight:400}.post-digest{padding:10px 0}.post-digest i.material-icons{font-size:19px;vertical-align:bottom}.post-digest p{font-weight:400}.post-digest .reactions img{height:20px;display:inline;vertical-align:middle}.notification-panel{background:#fff;border-radius:4px;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12);height:400px;width:350px}.notification-panel .activated{background:#ddd}.header .badge-container{position:relative;margin-right:5px}.header .badge{background-color:#fa3e3e;border-radius:5px;color:#fff;padding:2px 4px;font-size:12px;position:absolute;top:0;right:5px}.dialog.tutorial .blink{animation:blink 1s steps(5,start) infinite;-webkit-animation:blink 1s steps(5,start) infinite}@keyframes blink{to{visibility:hidden}}md-toast.message-toast .md-toast-content{height:80px;font-size:12px}md-toast.message-toast .md-toast-content .user-info{position:absolute;top:5px;left:5px}md-toast.message-toast .md-toast-content .user-info img{width:20px;height:20px;border-radius:50%;display:inline}md-toast.message-toast .md-toast-content .user-info .name{display:inline}md-toast.message-toast .md-toast-content .content{position:absolute;top:30px;left:10px}.confirm-dialog textarea{resize:none;padding:5px}.confirm-dialog textarea:focus{outline:none!important}.diff-dialog{width:80%}.diff-dialog md-dialog-content{text-align:left;padding:5px;box-sizing:border-box;height:100%;writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl}.diff-dialog md-dialog-content .added{background:#eaf2c2;color:#406619;text-decoration:none}.diff-dialog md-dialog-content .removed{text-decoration:none;color:#b30000;background:#fadad7}.user-status{font-size:18px}.user-status .status{margin:10px 5px}.user-status .status p{margin:3px}.user-status .status img{width:35px;vertical-align:middle;margin-right:5px}.user-status .progress{position:relative;width:100%;height:30px;background-color:grey}.user-status .progress .bar{position:absolute;width:1%;height:100%;background-color:green}.md-open-menu-container{z-index:999999}.toolbar h1{font-family:\\\\30D2\\30E9\\30AE\\30CE\\660E\\671D ProN W6,HiraMinProN-W6,\"HG\\660E\\671D  E\",\"\\FF2D\\FF33   \\FF30\\660E\\671D\",MS PMincho,MS\\ \\660E\\671D}.sidenav{padding:10px 2px 10px 0}.sidenav h2{margin:3px 8px;font-size:14px;font-weight:400;color:#cc181e}.sidenav .md-button{margin:1px 10px;font-size:13px}.sidenav .md-button md-icon{font-size:22px;margin-right:3px}.sidenav .md-button .badge{text-align:right;position:absolute;right:10px}.sidenav md-divider{margin:10px 3px}.sidenav .ranking table td{vertical-align:top}.sidenav .ranking table td.right{text-align:right;max-width:120px}.sidenav .ranking table td .increase{color:green}.sidenav .ranking h1{font-size:18px;margin:10px 0 0 13px}.sidenav .ranking ol{margin:0;padding-left:25px}.sidenav .ranking ol li{margin:7px 0}.sidenav .ranking ol li .detail{display:inline-block;vertical-align:middle;margin-left:5px}.sidenav .ranking ol li .detail .name{font-size:14px;display:block}.sidenav .ranking ol li .detail .count{font-size:12px;display:block}.home hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.home md-whiteframe{margin-top:10px}.home h3{margin:0;font-weight:400}.home .disp-options{background-color:#fff;width:600px;margin:0 10px;padding:10px;box-sizing:border-box}.home .disp-options md-checkbox{margin:0}.home .timeline-event{width:600px;margin-bottom:10px;position:relative}.home .timeline-event .actions .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0);filter:saturate(0);margin:2px 10px 8px;font-size:14px}.home .timeline-event .actions .like img{height:22px;display:inline;vertical-align:middle}.home .timeline-event .actions .like:hover{text-decoration:underline;filter:none}.home .timeline-event .actions .like.active,.home .timeline-event .actions .like.liked{color:#387ef5;filter:none}.home .timeline-event .tag{position:absolute;top:5px;right:5px}.home .timeline-event .page-info{height:140px;border:1px solid #ddd;border-radius:20px;margin:5px 10px}.home .timeline-event .page-info .actions{border-top:#ddd}.home .timeline-event .page-info a.thumb{border-radius:20px 0 0 20px;overflow:hidden}.home .timeline-event .page-info a.thumb img{border-radius:20px 0 0 20px}.home .timeline-event .page-info a.thumb:hover{overflow:hidden;filter:brightness(80%);-webkit-filter:brightness(80%)}.home .timeline-event .page-info .content{padding:10px}.home .timeline-event .page-info .content a{display:block;font-size:18px;text-decoration:none;color:#167ac6;white-space:nowrap;text-overflow:ellipsis}.home .timeline-event .page-info .content a:hover{text-decoration:underline;filter:brightness(80%);-webkit-filter:brightness(80%)}.transcription md-tabs{height:100%}.transcription .fav-button.active md-icon{color:gold}.transcription .content-status{width:200px;margin:0 auto}.transcription .content-status .content-count{font-size:20px;text-align:center}.transcription .content-status .current-status{font-size:14px;margin-top:-5px;text-align:center;border-radius:8px;padding:3px}.transcription .editor{border-right:1px solid #ddd;height:100%;width:100%}.transcription .editor .flex{overflow-x:scroll;overflow-y:hidden;height:100%}.transcription .editor .flex .vertical-editor{writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;text-align:left;display:inline-block;overflow-x:scroll;padding:5px 0;line-height:2;font-size:15px}.transcription .editor .flex .vertical-editor .warigaki{display:inline-table;writing-mode:vertical-lr;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;vertical-align:top}.transcription .editor .flex .vertical-editor .warigaki-left,.transcription .editor .flex .vertical-editor .warigaki-right{font-size:50%;display:table-row;line-height:150%}.transcription .editor .flex .vertical-editor .hako{margin:2px;border:1px solid #000;display:inline}.transcription .editor .flex .vertical-editor .comment{color:red}.transcription .editor .flex .vertical-editor .comment:before{content:\"\\1F4AC\";font-size:12px;margin:5px 0 -5px}.transcription .editor .flex .vertical-editor .dubious,.transcription .editor .flex .vertical-editor .illegible{background-color:#ff0}.transcription .editor .flex .vertical-editor .dubious:after,.transcription .editor .flex .vertical-editor .illegible:after{content:\"\\2753\";font-size:5px}.transcription .editor .flex .vertical-editor .kaeriten{font-size:1px;vertical-align:sub}.transcription .editor .flex .vertical-editor .okuri{font-size:1px;vertical-align:super}.transcription .editor .flex .viewer{min-width:100%;width:100%;box-sizing:border-box;background:#fff}.transcription .editor .flex .input{background:#fff;writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;text-align:left;box-sizing:border-box;display:inline-block;overflow-x:scroll;height:100%;width:100%;padding:3px}.transcription .editor .flex .input.noedit{background-color:#f5f5f5}.transcription .editor .flex .input div{padding:0!important}.transcription .editor .flex .insert-buttons .md-button{opacity:.7}.transcription .editor .flex .legends{box-sizing:border-box}.transcription .editor .flex .legends h2,.transcription .editor .flex .legends h3,.transcription .editor .flex .legends p{padding:0}.transcription .editor .flex .legends h2{margin:0 25px 3px 0;border-top:8px solid #b82c5f}.transcription .editor .flex .legends h3{margin:5px 5px 0 0}.transcription .editor .flex .legends p{margin:10px 0 0}.transcription .editor .flex .history h3{color:#387ef5;font-weight:700;font-size:14px}.transcription .editor .flex .history .comment{margin:8px 0;font-size:13px;color:#000}.transcription .editor .flex .history .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0);filter:saturate(0);margin-top:8px}.transcription .editor .flex .history .like img{height:22px;display:inline;vertical-align:middle}.transcription .editor .flex .history .like:hover{text-decoration:underline;filter:none}.transcription .editor .flex .history .like.active,.transcription .editor .flex .history .like.liked{color:#387ef5;filter:none}.transcription-sidenav md-tabs{height:100%}.transcription-sidenav .msg-input{width:100%;height:80px;margin:0}.transcription-sidenav .msg-input .submit-button{position:absolute;right:3px;top:90px}.transcription-sidenav .msg-input textarea{box-sizing:border-box;height:100%;width:100%;resize:none;border:none;padding:10px;box-shadow:0 0 10px rgba(0,0,0,.4)}.transcription-sidenav .msg-input textarea:focus{outline:none!important}.entries{background-color:#f5f5f5}.entries .entry-wrapper{padding:3px;margin:3px}.entries .entry{background-color:#fff;display:table;position:relative;width:100%;height:100%}.entries .entry .title{width:280px;text-align:center;display:block;margin:10px auto 5px;font-size:18px;text-decoration:none;color:#167ac6;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.entries .entry .title:hover{text-decoration:underline;filter:brightness(80%);-webkit-filter:brightness(80%)}.entries .entry .entry-id{text-decoration:none}.entries .entry .entry-id:hover{text-decoration:underline}.entries .entry .thumbnail{height:220px;position:relative}.entries .entry .thumbnail img{max-width:280px;max-height:220px;margin:0 auto;display:block}.entries .entry .thumbnail .difficulty-indicator{position:absolute;bottom:3px;left:5px;color:#fff;font-size:11px;padding:2px 4px;font-weight:700;border-radius:5px}.entries .entry .thumbnail .low{background-color:#33cd5f}.entries .entry .thumbnail .middle{background-color:#ffc900}.entries .entry .thumbnail .high{background-color:#ef473a}.entries .entry md-progress-linear{margin:5px auto;width:280px}.entries .entry .progress{font-size:11px;text-align:center}.entries .entry .entry-info{font-size:11px}.entries .entry .tag{font-size:10px;padding:3px;margin:2px;border-radius:5px;display:inline-block;color:#fff}.entries .entry .tag.disaster{background-color:#387ef5}.entries .entry .tag.region{background-color:#11c1f3}.entries .entry .tag:hover{text-decoration:underline;filter:brightness(50%);cursor:pointer}.connect .compose{background-color:#f6f7f9;diplay:block;background:#fff;margin:8px}.connect .compose textarea{width:100%;height:100%;resize:none;overflow:scroll;outline:none;padding:8px;border:none;box-sizing:border-box;box-shadow:none;background-color:#fff}.connect .compose .actions{border-top:1px solid #ddd;background-color:#f6f7f9}.connect .compose .images{background-color:#f6f7f9}.connect .post{position:relative}.connect .post md-card-header{padding-bottom:0}.connect .post md-card-content{padding-top:0}.connect .post .remove{cursor:pointer;color:#ef473a;text-decoration:none}.connect .post .remove:hover{text-decoration:underline}.connect .post .post-type{position:absolute;top:10px;right:6px;color:#fff;padding:2px 5px;border-radius:8px;font-size:15px}.connect .post .post-type.question{background:#387ef5}.connect .post .post-type.seeking{background:#ef473a}.connect .post .post-type.showcase{background:#33cd5f}.connect .post .text{color:#000;overflow:hidden}.connect .post .photo{display:block;max-height:150px;max-width:100%;border-radius:10px;margin:3px auto}.connect .post .actions .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0);filter:saturate(0)}.connect .post .actions .like img{height:22px;display:inline;vertical-align:middle}.connect .post .actions .like:hover{text-decoration:underline;filter:none}.connect .post .actions .like.active,.connect .post .actions .like.liked{color:#387ef5;filter:none}.connect .post .info i.material-icons{font-size:19px;vertical-align:bottom}.connect .post .info img{height:20px;display:inline;vertical-align:middle}.connect .post .comments{border-top:1px solid #ddd}.connect .post .comments hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.connect .post .comments .action{font-size:12px;color:#387ef5;cursor:pointer}.connect .post .comments .action:hover{text-decoration:underline}.connect .post .comments .reply-form img{width:30px;height:30px;margin:3px}.connect .post .comments .reply-form textarea{resize:none;overflow:scroll;outline:none;padding:3px;margin:3px;border:1px solid #ddd}.connect .post .comments .reply-form button{margin:0}.connect .post .comments .comment{margin:9px 3px;font-size:12px}.connect .post .comments .comment .user-avatar{cursor:pointer;min-width:30px;min-height:30px;margin-right:5px}.connect .post .comments .comment .content{margin-left:4px}.connect .post .comments .comment .content .user-name{cursor:pointer;font-weight:700;color:#387ef5}.connect .post .comments .comment .content .user-name:hover{text-decoration:underline}.connect .post .comments .comment .content .images{padding:0;margin:0}.connect .post .comments .comment .content .actions .like{filter:none;-webkit-filter:none;font-style:bold;text-decoration:none;display:inline-block;cursor:pointer}.connect .post .comments .comment .content .actions .like:hover{text-decoration:underline}.connect .post .comments .comment .content .actions .like.activated,.connect .post .comments .comment .content .actions .like.liked{color:#387ef5;-webkit-filter:none;filter:none}.connect .post .comments .comment .content .actions a img{height:12px;display:inline;vertical-align:middle}", "", {"version":3,"sources":["/./app/assets/app.scss","/./app/app/assets/shimimaru.scss","/./app/app/assets/kula.scss","/./app/app/assets/app.scss"],"names":[],"mappings":"AAAA,SCAA,2BAC2B,kBACb,UACH,sBACC,sBACU,aACT,cACA,oBACD,CAAA,gBAGD,aACF,AAIF,0BACM,CAEE,+BAnBP,WAUE,kBACC,AACF,SACF,kBACO,QACR,SACC,AACM,mCACC,mCACC,CAYA,AAZA,eAIJ,YACF,AAIF,0BACM,CAEE,eCjBX,cAAiB,WAAgB,CAAA,gBAAQ,gBAI7B,WACL,eACI,gBACE,+JAjBjB,yBAEA,2BAkBsB,YAClB,iBAAuB,CAAA,QACvB,kBACY,mBAIZ,iBACA,CAAA,UAAe,oBACH,CAAA,qBAEf,WAAqB,eAElB,YACE,0BAEL,yBACA,WACA,CAAA,4BACO,mCAEH,sBAAqB,CAAA,+BACd,sBATI,CAAA,gCAWe,uBAGvB,kCAAoC,CAAA,cAAgB,oBArB5D,CAAA,sBAwBS,+JApDO,eAEhB,gBACA,kBACA,SACA,aAmDU,CAAE,oBACE,WACb,kBAEA,UAtDM,QAsBP,CAAA,oBAmCM,qBACK,CAAS,6BAOhB,iBAEI,CAAA,oDAEH,UALL,CAAA,yCAOgB,UAAY,WAAa,0BAHjC,CAAA,kGAKH,UAIW,CAbhB,0CASgB,gBAIsB,mBAZlC,YAGI,UAWH,CAAA,6CAGa,gBACF,WAlBZ,eAGI,gBAiBH,AA5FmB,yBACxB,2BAEA,WACA,CAAA,oGAwFK,8JA5FmB,CA8GhB,wBA9GgB,2BACxB,CAAA,gCAEA,SACA,CAAA,mCAwGA,eAII,8JAEI,CAAA,kDAlHgB,qBACxB,CAAA,wBACA,+JAmHsB,AATtB,wBAaC,CAAA,uEAvHD,eACA,UACA,CAAA,sBAEA,eAoHC,CAAA,yBACA,YAAc,+JAE0B,eAAS,AAMlD,wBAKQ,CAAA,2BAxIE,QAAc,CAAA,6BACxB,gBACA,CAAA,qCAEA,cACW,iBAqIQ,CAAA,oCACgB,iBACpB,aATf,sBAUS,AANL,mBAOS,YAXb,eAaI,iBACH,CAAA,0CAdD,2BAea,wBAED,CAAO,+BAEd,qBACA,CAAA,uCAEgB,wBAtBrB,CAAA,yCAyBgB,wBAAY,CAAA,aACX,UAAA,CAAA,cA1BjB,aA8BI,CAAA,gBACI,aAAkB,CAAQ,YA/BlC,aA8BI,CAAA,gBAEe,aAAA,CAAgB,iBAhCnC,aA8BI,CAAA,iBAAiB,aAGA,CAAA,aCnJrB,aAAa,CAAA,YAAgB,aACf,CAAA,WAX2B,qBAYpB,CAXa,UAWC,eAClB,CAXiB,WAWP,kBACN,CAXa,aAWC,kBAVD,CAAA,SAWG,kBACpB,CAAA,aAAoB,kBAVH,CAAA,cAWL,kBACF,CAAA,cACX,kBAAqB,CAAA,UAC3B,kBAAqB,CAAA,SACpB,kBAAsB,CAAA,QAAA,0BACI,CAAA,YAC5B,kBAAoB,CAAA,KAChB,eArBqB,CAqBG,UArBH,WAqBG,CAI5B,AAJ4B,KACvB,8BACA,eArBoB,AAsBzB,SAAW,UAAW,aACtB,CAAA,yBACD,kBAAY,CAAA,cACT,eAAa,CAAA,OACpB,eACU,CAAO,aAEpB,eAIG,sBAAkC,kBAElC,WACA,WACA,CAAA,MAAS,cACC,eAGF,cAAc,CAAA,YAAY,yBACvB,CAAA,KAAY,eAGvB,YAAY,WACf,kBAGmB,qBACA,UAChB,CAAA,GAAa,0BAEL,gBA5DC,cAiED,cACR,CAAA,WAHJ,cAIa,CAAA,QAAe,cAAe,kBAKvC,CAAA,iBACQ,cACR,QACA,CAAA,qBACA,WACH,qBAEkB,CAAA,0BAEhB,cACA,CAAA,sCAMF,yBAIG,CAAA,qBAFG,YAIA,qBAJP,CAAA,sBAMY,kBAAc,eAA0B,eAIrC,CAAA,aACH,cADZ,CAAa,8BAED,eAAiB,qBAIzB,CAAO,eACU,eAAuB,CAAA,4BAC/B,YAAc,eAAkB,qBAAmB,CAAA,oBAM5D,gBADJ,kBAEK,wGAGG,aACiB,WACJ,CAAA,+BAEX,eAKR,CAAA,yBACA,kBACA,gBAA0B,CAAC,eAAI,yBACX,kBACV,WAAS,gBACnB,eACO,kBAPT,MAAmB,SAQjB,CAAA,wBAAkC,2CA4BO,kDAG1C,CAAA,iBACA,GAAA,iBACS,CAAA,CAAA,AAIT,yCAOe,YAAS,cAAgB,CAAA,oDACQ,kBAEhD,QACM,QACL,CAAA,wDAKmB,WAQb,YAAA,kBACJ,cAEH,CAAA,0DACA,cACI,CAAA,kDALiB,kBACD,SAGpB,SAIC,CAAA,yBACA,YAAmB,WACV,CAAA,+BATP,sBAGH,CAAU,aAST,SAbF,CAAA,+BACI,gBAeH,YACc,sBACQ,YACrB,AAQD,yBAFG,6BAGc,6BAKP,CAAA,sCAEV,mBACO,cACP,oBACQ,CAAA,wCAER,qBAA0B,cAC1B,kBACA,CAAA,aAAA,cAVD,CAAA,qBAEI,eASG,CACF,uBACA,UACA,CAAA,yBAdL,WAEI,sBAcH,gBACI,CAAe,uBAEf,kBACH,WAME,YAAW,qBACX,CAAA,4BAFJ,kBAII,SAJJ,YAEI,sBAGgB,CAAA,wBAAyB,cAL7C,CAAA,YAOI,6IAPJ,CAAY,SAOR,uBAOC,CAAA,YACA,eACA,eAAwB,gBAC3B,aAK6B,CAAE,oBAE1B,gBAtRE,cAAA,CAAA,4BAAsD,eAAgB,gBAAuB,CAAA,2BAsRxE,iBAIjB,kBADb,UAEQ,CAAA,oBACS,eACT,CAAA,2BAJR,kBAOQ,CAAA,iCAPR,iBASQ,eACa,CAAE,qCAJnB,WAOU,CACF,qBACA,eACA,oBAGR,CAAA,qBAAoB,SAnBxB,iBAqBQ,CAAK,wBArBb,YAoBI,CAAA,gCAG+B,qBAvBnC,sBAqBa,eAGY,CAAA,sCAEd,eAA0B,aAAc,CA1BnD,uCA6BY,eA7BZ,aA2BQ,CAAE,SAIM,0BAJR,gBAMY,cAAS,cACT,CAAA,oBACA,eAnCpB,CAAQ,SAoBI,SAYI,eAIU,CAAA,oBAA2B,sBANzC,YAOQ,cAAQ,aAAkB,qBASvC,CAAA,gCACA,QACA,CAAA,sBACY,YACf,mBACI,iBAED,CAAA,qCACH,eACI,qBACA,eACM,qBAEN,2BALJ,mBAMI,oBAfH,cAiBD,CAAA,yCAGY,YApBhB,eAiBI,qBAzMA,CAAA,2CAEQ,0BACc,WAMtB,CAAA,uFAgMA,cAIH,WAzMM,CACC,2BAEA,kBAAgB,QAClB,SAiMF,CAAA,iCA9LS,aAAiB,sBAA2B,mBA8LrD,eAKC,CAlMA,0CAkMA,eAxV6B,CAAA,yCA4V1B,4BAES,eA5BjB,CAAA,6CAgCK,2BACA,CAAA,+CAhBD,gBAkBC,uBAnCL,8BA8BC,CAAU,0CAUT,YAxCF,CAAA,4CAyCO,cAAe,eAzCtB,qBA8BC,cAQK,mBAKU,sBACF,CAAA,kDA3BV,0BA+BC,uBA/BD,8BA+BC,CAAA,uBAIC,WAAW,CAAK,0CAGhB,UAAa,CAAA,+BAtCf,YAAA,aAaH,CAAU,8CA6BR,eAAQ,iBACR,CAAA,+CAWW,eADd,gBAEI,kBAES,kBAJb,WAQI,CAAA,uBACU,4BATd,YAQI,UAGH,CAAA,6BAEI,kBAbL,kBAQI,WAOH,CAAA,8CAIuB,yBAnBxB,6BA8B8B,8BAEtB,gBAhCR,qBAkCK,kBACA,cACA,cApCL,cA6BI,CAAA,wDASoB,qBACR,AACI,yBACC,6BAEnB,8BACY,kBACH,CAAM,2HAKG,cAAsB,kBACR,gBAC5B,CAAA,oDAEc,WAAA,sBAzBhB,cAQC,CAAA,uDAJJ,SAII,CAAA,8DAsBC,iBA3DN,eA6BI,iBAQC,CAAA,gHA6BH,qBAlEF,CAAA,4HA6BI,gBAQC,aAiCH,CAAA,wDAAU,cACN,kBAAyB,CAvE/B,qDAsEE,cAtEF,oBAiCC,CAAA,qCAuC2B,eAAkB,WAAW,sBA3CrD,eAQC,CAAA,oCAuCe,gBA5EpB,AAqCK,yBA0Ce,6BACsB,8BAI9B,gBACV,sBAEA,qBACA,kBAxFF,YA6BI,WAIH,WA0DC,CAAA,2CACsB,wBACR,CAAA,wCAEd,mBAAmB,CAAA,wDAGV,UACT,CAAA,sCAGc,qBAtGhB,CAAc,0HAAd,SA6BI,CAAA,yCAiFuB,oBA9G3B,4BAiHE,CAAA,yCApFE,kBAqFF,CAAA,wCAAG,eAlHS,CA6BV,yCA7BJ,cA6BI,gBAmFgB,cAIQ,CAAA,+CApH5B,aA6BW,eAmFS,UAON,CAAA,4CAPF,eAQC,qBAxHb,eAiCC,qBAzaiC,2BAogBuB,mBA5HzD,cA6BW,CAIV,gDA4FmD,YAAc,eA7HlE,qBA2HY,CAAA,kDAvXR,0BACS,WAMT,CAAA,qGAmXiB,cAvXL,WACC,CAAA,+BAEX,WAsPQ,CA6BV,kCAhRO,WAAE,YAAiB,QAAW,CAAA,iDAiXzB,kBA9HhB,UA6BI,QAIH,CAAK,2CAnR2C,sBAAQ,YAsXrD,WAAkB,YADtB,YAAA,aAGC,kCAHD,CAAA,iDAMK,sBACW,CAAE,SAPlB,wBAEI,CAAA,wBAQC,YAAsB,UACd,CAAA,gBAER,sBAEA,cACA,kBAAqB,WAAA,WAhB1B,CAAA,uBAEI,YAOK,kBAQa,cAAmB,qBAOrC,eADJ,qBAEI,cAA+B,gBAFnC,mBAIC,sBACO,CAAE,6BAEJ,0BAPE,uBAUI,8BAEE,CAAA,0BAET,oBACA,CAAA,gCAEA,yBACa,CAAA,2BACE,aAhBhB,iBAiBQ,CACV,+BACA,gBAAQ,iBACQ,cAAA,aApBd,CAAA,iDAAA,kBAyBS,WAAA,SAAiB,WA5B9B,eA8BC,gBACmB,gBACL,iBA7BX,CAAA,gCA+BsB,wBAEX,CAAE,mCAjCb,wBAoCC,CAAA,iCAEH,wBAEO,CAAA,mCAGP,gBACA,WAAA,CAAa,0BAjBd,eAmBS,iBAjlBwB,CAAA,4BA8jBjC,cAoBY,CAAA,qBAlDb,eA8BC,YAqBI,WAAM,kBAjlB8B,qBAmlBxC,UAAA,CAAA,8BAEiB,wBAEjB,CAAA,4BAEgB,wBAEhB,CAAA,2BA7DD,0BAiEK,uBAEA,cACA,CAAA,kBACO,yBACM,aAnEd,gBAoEW,UAAE,CAAA,2BApEb,WA6DC,YAQU,YAzmBmB,gBAoiB9B,aA6DC,YAUH,YAAiB,sBACT,AAUF,gBAAkB,qBACH,CAAA,2BAHvB,0BAMY,wBAEA,CAAM,0BAEN,wBAEA,CAAA,eACA,iBACA,CAAA,8BACA,gBACA,CAAA,+BACkB,aAhB1B,CAAA,uBAmBQ,eAloBH,cAmoBG,oBArBZ,CAAA,6BAwBY,yBAGR,CAAA,0BA3BJ,kBA4BQ,SAAiB,UAAA,WA5BzB,gBA6BQ,kBAAiB,cA7BjB,CA2BJ,mCA5oB8B,kBAmpBtB,CAAA,kCAHG,kBAIK,CAAA,mCAEnB,kBACc,CAAA,qBAGV,WACA,eAAiB,CACjB,sBACA,cA5CL,iBAqCC,eAQe,mBA7ChB,eAqCC,CAAA,8BAtpBiC,eAinB1B,qBAqCG,eAUK,qBApBZ,2BAuBI,kBAvBJ,CAAA,kCA2BC,YACA,eACA,qBACA,CAAM,oCAGN,0BAtiBD,WAAiB,CAAA,yEAST,cANR,WAkgBA,CAAA,sCAhgBI,eACA,qBACF,CAAA,yBAGD,YAAQ,eAAiB,qBAA2B,CAAA,yBACpD,yBA0hBG,CAAA,4BAhrB0B,0BAgpB9B,gBAoCS,cAAgB,cAAkB,CAAA,iCApCtC,eAsCO,cACA,cACA,CAAA,uCAKR,yBAtrBC,CAAA,yCAurBkB,WAvrBlB,YAwrBM,UACA,CAAA,8CAHP,YAKW,gBAEH,aApsByB,YAqsBjB,WAhFxB,qBA6EY,CAAA,4CA7EJ,QAwEA,CAAA,kCAayB,eAAiB,cArFlD,CAAA,+CAuF4B,eACE,eACD,gBAET,gBACA,CAAM,2CARd,eAUI,CAAM,sDAGE,eACG,gBAvEvB,aAqEQ,CAAA,4DAMQ,yBAtGpB,CAAA,mDA0GoB,UA1GpB,QA2BI,CAAA,0DAkFoB,YAAa,oBA7GrC,gBAwEQ,qBAiCQ,qBAKgB,cAAe,CAAE,gEAGrB,yBAtFxB,CAAA,oIA6FiC,cACD,oBA9FhC,WA6Ca,CAwBL,0DA0ByC,YA1HrD,eAwEQ,qBAiCQ,CAAQ","file":"app.scss","sourcesContent":[".balloon{-webkit-border-radius:10px;position:relative;width:90%;border:1px solid #ccc;background-color:#fff;padding:10px;display:block;margin:5px auto 10px}.balloon:before{content:\"\";position:absolute;bottom:-10px;left:50%;margin-left:-10px;width:0;height:0;border-top:10px solid #ccc;border-left:10px solid transparent;border-right:10px solid transparent}.balloon:after{content:\"\";position:absolute;bottom:-9px;left:50%;margin-left:-10px;width:0;height:0;border-top:10px solid #fff;border-left:10px solid transparent;border-right:10px solid transparent}.dialog .block{display:block;margin:auto}.section-header{margin-top:10px;color:white;font-size:26px;font-weight:bold;font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif;background-color:#5E84FF;-webkit-border-radius:20px;padding:3px;text-align:center}.lesson{position:relative;margin-bottom:15px;text-align:center}.lesson a{text-decoration:none}.lesson .lesson-icon{width:80px;cursor:pointer;height:80px;-webkit-border-radius:50%;border:solid #2B746E 6px;padding:3px}.lesson .lesson-icon:active{box-shadow:0 0 12px rgba(0,0,0,0.9);filter:brightness(50%)}.lesson .lesson-icon.activated{filter:brightness(50%)}.lesson .activated .lesson-icon{filter:brightness(50%);box-shadow:0 0 12px rgba(0,0,0,0.9)}.lesson .test{border:solid red 6px}.lesson .lesson-title{font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif;font-size:16px;font-weight:bold;text-align:center;margin:0;color:#747474}.lesson img.cleared{width:60px;position:absolute;top:-10px;left:25%}.learn .lesson-list{background-color:white}.learn .lesson-list .wrapper{text-align:center}.learn .lesson-list .wrapper .activated .book-thumb{opacity:0.7}.learn .lesson-list .wrapper .book-thumb{width:90%;margin:5px;-webkit-border-radius:10px}.learn .lesson-list .wrapper .book-thumb:hover,.learn .lesson-list .wrapper .book-thumb.activated{opacity:0.7}.learn .lesson-list .wrapper .description{text-align:left;margin-bottom:15px;padding:5px;color:#444444}.learn .lesson-list .wrapper .section-header{margin-top:10px;color:white;font-size:26px;font-weight:bold;font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif;background-color:#5E84FF;-webkit-border-radius:20px;padding:3px}.char-lesson md-toolbar,.char-lesson .md-toolbar-tools{font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif}.char-lesson .char-list{border-right:1px solid #ddd}.char-lesson .char-list md-list{padding:0}.char-lesson .char-list md-list h2{font-size:18px;font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif}.char-lesson .char-list md-list .item-menu-active{background-color:#dddddd}.char-lesson .char-view{font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif;-webkit-writing-mode:vertical-rl;writing-mode:vertical-rl}.char-lesson .char-view .single img,.char-lesson .char-view .multi img{max-width:50px;margin:4px}.quiz-dialog .balloon{max-width:300px}.quiz-dialog .quiz-image{margin:auto;font-family:\"ipa-mincho\",\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\",serif;font-size:26px;-webkit-writing-mode:vertical-rl;writing-mode:vertical-rl}.quiz-dialog .quiz-image p{margin:0}.quiz-dialog .quiz-image img{max-height:250px}.quiz-dialog .input-container .block{display:block;text-align:center}.quiz-dialog .input-container input{margin-left:70px;outline:none;border:1px solid #aaa;-webkit-transition:all .3s;transition:all .3s;resize:none;font-size:26px;text-align:center}.quiz-dialog .input-container input:focus{box-shadow:0 0 7px #1abc9c;border:1px solid #1abc9c}.quiz-dialog md-dialog-actions{background-color:#dddddd}.quiz-dialog md-dialog-actions.correct{background-color:#def0a5}.quiz-dialog md-dialog-actions.incorrect{background-color:#ffd4cc}.color-light{color:#fff}.color-stable{color:#f8f8f8}.color-positive{color:#387ef5}.color-calm{color:#11c1f3}.color-balanced{color:#33cd5f}.color-energized{color:#ffc900}.color-assertive{color:#ef473a}.color-royal{color:#886aea}.color-dark{color:#747474}.color-sub{color:rgba(0,0,0,0.54)}.bg-light{background:#fff}.bg-stable{background:#f8f8f8}.bg-positive{background:#387ef5}.bg-calm{background:#11c1f3}.bg-balanced{background:#33cd5f}.bg-energized{background:#ffc900}.bg-assertive{background:#ef473a}.bg-royal{background:#886aea}.bg-dark{background:#747474}.bg-sub{background:rgba(0,0,0,0.54)}.bg-default{background:#f6f7f9}html{overflow:hidden;height:100%}body{font-family:'Roboto', sans-serif;font-size:14px;height:100%;margin:0px;padding:0px;overflow:auto}md-content,.md-subheader{background:#e9ebee}md-whiteframe{background:white}.block{text-align:left}.user-avatar{display:inline;vertical-align:middle;border-radius:50%;width:40px;height:40px}.link{color:#167ac6;cursor:pointer;font-size:14px}.link:hover{text-decoration:underline}.tag{font-size:14px;padding:3px;margin:2px;border-radius:5px;display:inline-block;color:white}hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.clickable{cursor:pointer}diamond{display:block;margin-bottom:-5px}diamond .diamond{display:block;margin:0}diamond .diamond img{width:30px;vertical-align:middle}.open-profile,.open-likes{cursor:pointer}.open-profile:hover,.open-likes:hover{text-decoration:underline}.profile .status img{height:26px;vertical-align:middle}.profile .status span{margin-right:10px;font-size:16px;font-weight:normal}.post-digest{padding:10px 0 10px}.post-digest i.material-icons{font-size:19px;vertical-align:bottom}.post-digest p{font-weight:normal}.post-digest .reactions img{height:20px;display:inline;vertical-align:middle}.notification-panel{background:white;border-radius:4px;box-shadow:0 7px 8px -4px rgba(0,0,0,0.2),0 13px 19px 2px rgba(0,0,0,0.14),0 5px 24px 4px rgba(0,0,0,0.12);height:400px;width:350px}.notification-panel .activated{background:#ddd}.header .badge-container{position:relative;margin-right:5px}.header .badge{background-color:#fa3e3e;border-radius:5px;color:white;padding:2px 4px;font-size:12px;position:absolute;top:0;right:5px}.dialog.tutorial .blink{animation:blink 1s steps(5, start) infinite;-webkit-animation:blink 1s steps(5, start) infinite}@keyframes blink{to{visibility:hidden}}@-webkit-keyframes blink{to{visibility:hidden}}md-toast.message-toast .md-toast-content{height:80px;font-size:12px}md-toast.message-toast .md-toast-content .user-info{position:absolute;top:5px;left:5px}md-toast.message-toast .md-toast-content .user-info img{width:20px;height:20px;border-radius:50%;display:inline}md-toast.message-toast .md-toast-content .user-info .name{display:inline}md-toast.message-toast .md-toast-content .content{position:absolute;top:30px;left:10px}.confirm-dialog textarea{resize:none;padding:5px}.confirm-dialog textarea:focus{outline:none !important}.diff-dialog{width:80%}.diff-dialog md-dialog-content{text-align:left;padding:5px;box-sizing:border-box;height:100%;-webkit-writing-mode:vertical-rl;writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl}.diff-dialog md-dialog-content .added{background:#eaf2c2;color:#406619;text-decoration:none}.diff-dialog md-dialog-content .removed{text-decoration:none;color:#b30000;background:#fadad7}.user-status{font-size:18px}.user-status .status{margin:10px 5px}.user-status .status p{margin:3px}.user-status .status img{width:35px;vertical-align:middle;margin-right:5px}.user-status .progress{position:relative;width:100%;height:30px;background-color:grey}.user-status .progress .bar{position:absolute;width:1%;height:100%;background-color:green}.md-open-menu-container{z-index:999999}.toolbar h1{font-family:\"ヒラギノ明朝 ProN W6\",\"HiraMinProN-W6\",\"HG明朝E\",\"ＭＳ Ｐ明朝\",\"MS PMincho\",\"MS 明朝\"}.sidenav{padding:10px 2px 10px 0px}.sidenav h2{margin:3px 8px;font-size:14px;font-weight:normal;color:#cc181e}.sidenav .md-button{margin:1px 10px;font-size:13px}.sidenav .md-button md-icon{font-size:22px;margin-right:3px}.sidenav .md-button .badge{text-align:right;position:absolute;right:10px}.sidenav md-divider{margin:10px 3px}.sidenav .ranking table td{vertical-align:top}.sidenav .ranking table td.right{text-align:right;max-width:120px}.sidenav .ranking table td .increase{color:green}.sidenav .ranking h1{font-size:18px;margin:10px 0 0 13px}.sidenav .ranking ol{margin:0;padding-left:25px}.sidenav .ranking ol li{margin:7px 0}.sidenav .ranking ol li .detail{display:inline-block;vertical-align:middle;margin-left:5px}.sidenav .ranking ol li .detail .name{font-size:14px;display:block}.sidenav .ranking ol li .detail .count{font-size:12px;display:block}.home hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.home md-whiteframe{margin-top:10px}.home h3{margin:0;font-weight:normal}.home .disp-options{background-color:white;width:600px;margin:0 10px;padding:10px;box-sizing:border-box}.home .disp-options md-checkbox{margin:0}.home .timeline-event{width:600px;margin-bottom:10px;position:relative}.home .timeline-event .actions .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0%);filter:saturate(0%);margin:2px 10px 8px;font-size:14px}.home .timeline-event .actions .like img{height:22px;display:inline;vertical-align:middle}.home .timeline-event .actions .like:hover{text-decoration:underline;filter:none}.home .timeline-event .actions .like.active,.home .timeline-event .actions .like.liked{color:#387ef5;filter:none}.home .timeline-event .tag{position:absolute;top:5px;right:5px}.home .timeline-event .page-info{height:140px;border:1px solid #ddd;border-radius:20px;margin:5px 10px}.home .timeline-event .page-info .actions{border-top:#ddd}.home .timeline-event .page-info a.thumb{border-radius:20px 0 0 20px;overflow:hidden}.home .timeline-event .page-info a.thumb img{border-radius:20px 0 0 20px}.home .timeline-event .page-info a.thumb:hover{overflow:hidden;filter:brightness(80%);-webkit-filter:brightness(80%)}.home .timeline-event .page-info .content{padding:10px}.home .timeline-event .page-info .content a{display:block;font-size:18px;text-decoration:none;color:#167ac6;white-space:nowrap;text-overflow:ellipsis}.home .timeline-event .page-info .content a:hover{text-decoration:underline;filter:brightness(80%);-webkit-filter:brightness(80%)}.transcription md-tabs{height:100%}.transcription .fav-button.active md-icon{color:gold}.transcription .content-status{width:200px;margin:0 auto}.transcription .content-status .content-count{font-size:20px;text-align:center}.transcription .content-status .current-status{font-size:14px;margin-top:-5px;text-align:center;border-radius:8px;padding:3px}.transcription .editor{border-right:#ddd 1px solid;height:100%;width:100%}.transcription .editor .flex{overflow-x:scroll;overflow-y:hidden;height:100%}.transcription .editor .flex .vertical-editor{-webkit-writing-mode:vertical-rl;writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;text-align:left;display:inline-block;overflow-x:scroll;padding:5px 0;line-height:2;font-size:15px}.transcription .editor .flex .vertical-editor .warigaki{display:inline-table;-webkit-writing-mode:vertical-lr;writing-mode:vertical-lr;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;vertical-align:top}.transcription .editor .flex .vertical-editor .warigaki-left,.transcription .editor .flex .vertical-editor .warigaki-right{font-size:50%;display:table-row;line-height:150%}.transcription .editor .flex .vertical-editor .hako{margin:2px;border:1px solid black;display:inline}.transcription .editor .flex .vertical-editor .comment{color:red}.transcription .editor .flex .vertical-editor .comment:before{content:'\\1F4AC';font-size:12px;margin:5px 0 -5px}.transcription .editor .flex .vertical-editor .dubious,.transcription .editor .flex .vertical-editor .illegible{background-color:yellow}.transcription .editor .flex .vertical-editor .dubious:after,.transcription .editor .flex .vertical-editor .illegible:after{content:'\\2753';font-size:5px}.transcription .editor .flex .vertical-editor .kaeriten{font-size:1px;vertical-align:sub}.transcription .editor .flex .vertical-editor .okuri{font-size:1px;vertical-align:super}.transcription .editor .flex .viewer{min-width:100%;width:100%;box-sizing:border-box;background:white}.transcription .editor .flex .input{background:white;-webkit-writing-mode:vertical-rl;writing-mode:vertical-rl;-ms-writing-mode:vertical-rl;-moz-writing-mode:vertical-rl;text-align:left;box-sizing:border-box;display:inline-block;overflow-x:scroll;height:100%;width:100%;padding:3px}.transcription .editor .flex .input.noedit{background-color:#f5f5f5}.transcription .editor .flex .input div{padding:0 !important}.transcription .editor .flex .insert-buttons .md-button{opacity:0.7}.transcription .editor .flex .legends{box-sizing:border-box}.transcription .editor .flex .legends h2,.transcription .editor .flex .legends h3,.transcription .editor .flex .legends p{padding:0}.transcription .editor .flex .legends h2{margin:0 25px 3px 0;border-top:8px solid #B82C5F}.transcription .editor .flex .legends h3{margin:5px 5px 0 0}.transcription .editor .flex .legends p{margin:10px 0 0 0}.transcription .editor .flex .history h3{color:#387ef5;font-weight:bold;font-size:14px}.transcription .editor .flex .history .comment{margin:8px 0;font-size:13px;color:black}.transcription .editor .flex .history .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0%);filter:saturate(0%);margin-top:8px}.transcription .editor .flex .history .like img{height:22px;display:inline;vertical-align:middle}.transcription .editor .flex .history .like:hover{text-decoration:underline;filter:none}.transcription .editor .flex .history .like.active,.transcription .editor .flex .history .like.liked{color:#387ef5;filter:none}.transcription-sidenav md-tabs{height:100%}.transcription-sidenav .msg-input{width:100%;height:80px;margin:0}.transcription-sidenav .msg-input .submit-button{position:absolute;right:3px;top:90px}.transcription-sidenav .msg-input textarea{box-sizing:border-box;height:100%;width:100%;resize:none;border:none;padding:10px;box-shadow:0 0 10px rgba(0,0,0,0.4)}.transcription-sidenav .msg-input textarea:focus{outline:none !important}.entries{background-color:whitesmoke}.entries .entry-wrapper{padding:3px;margin:3px}.entries .entry{background-color:white;display:table;position:relative;width:100%;height:100%}.entries .entry .title{width:280px;text-align:center;display:block;margin:10px auto 5px;font-size:18px;text-decoration:none;color:#167ac6;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.entries .entry .title:hover{text-decoration:underline;filter:brightness(80%);-webkit-filter:brightness(80%)}.entries .entry .entry-id{text-decoration:none}.entries .entry .entry-id:hover{text-decoration:underline}.entries .entry .thumbnail{height:220px;position:relative}.entries .entry .thumbnail img{max-width:280px;max-height:220px;margin:0 auto;display:block}.entries .entry .thumbnail .difficulty-indicator{position:absolute;bottom:3px;left:5px;color:white;font-size:11px;padding:2px 4px;font-weight:bold;border-radius:5px}.entries .entry .thumbnail .low{background-color:#33cd5f}.entries .entry .thumbnail .middle{background-color:#ffc900}.entries .entry .thumbnail .high{background-color:#ef473a}.entries .entry md-progress-linear{margin:5px auto;width:280px}.entries .entry .progress{font-size:11px;text-align:center}.entries .entry .entry-info{font-size:11px}.entries .entry .tag{font-size:10px;padding:3px;margin:2px;border-radius:5px;display:inline-block;color:white}.entries .entry .tag.disaster{background-color:#387ef5}.entries .entry .tag.region{background-color:#11c1f3}.entries .entry .tag:hover{text-decoration:underline;filter:brightness(50%);cursor:pointer}.connect .compose{background-color:#f6f7f9;diplay:block;background:white;margin:8px}.connect .compose textarea{width:100%;height:100%;resize:none;overflow:scroll;outline:none;padding:8px;border:none;box-sizing:border-box;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;background-color:white}.connect .compose .actions{border-top:1px solid #ddd;background-color:#f6f7f9}.connect .compose .images{background-color:#f6f7f9}.connect .post{position:relative}.connect .post md-card-header{padding-bottom:0}.connect .post md-card-content{padding-top:0}.connect .post .remove{cursor:pointer;color:#ef473a;text-decoration:none}.connect .post .remove:hover{text-decoration:underline}.connect .post .post-type{position:absolute;top:10px;right:6px;color:white;padding:2px 5px;border-radius:8px;font-size:15px}.connect .post .post-type.question{background:#387ef5}.connect .post .post-type.seeking{background:#ef473a}.connect .post .post-type.showcase{background:#33cd5f}.connect .post .text{color:black;overflow:hidden}.connect .post .photo{display:block;max-height:150px;max-width:100%;border-radius:10px;margin:3px auto}.connect .post .actions .like{font-size:12px;text-decoration:none;cursor:pointer;display:inline-block;-webkit-filter:saturate(0%);filter:saturate(0%)}.connect .post .actions .like img{height:22px;display:inline;vertical-align:middle}.connect .post .actions .like:hover{text-decoration:underline;filter:none}.connect .post .actions .like.active,.connect .post .actions .like.liked{color:#387ef5;filter:none}.connect .post .info i.material-icons{font-size:19px;vertical-align:bottom}.connect .post .info img{height:20px;display:inline;vertical-align:middle}.connect .post .comments{border-top:1px solid #ddd}.connect .post .comments hr{border-top:1px solid #ddd;border-bottom:0;border-left:0;border-right:0}.connect .post .comments .action{font-size:12px;color:#387ef5;cursor:pointer}.connect .post .comments .action:hover{text-decoration:underline}.connect .post .comments .reply-form img{width:30px;height:30px;margin:3px}.connect .post .comments .reply-form textarea{resize:none;overflow:scroll;outline:none;padding:3px;margin:3px;border:1px solid #ddd}.connect .post .comments .reply-form button{margin:0}.connect .post .comments .comment{margin:9px 3px;font-size:12px}.connect .post .comments .comment .user-avatar{cursor:pointer;min-width:30px;min-height:30px;margin-right:5px}.connect .post .comments .comment .content{margin-left:4px}.connect .post .comments .comment .content .user-name{cursor:pointer;font-weight:bold;color:#387ef5}.connect .post .comments .comment .content .user-name:hover{text-decoration:underline}.connect .post .comments .comment .content .images{padding:0;margin:0}.connect .post .comments .comment .content .actions .like{filter:none;-webkit-filter:none;font-style:bold;text-decoration:none;display:inline-block;cursor:pointer}.connect .post .comments .comment .content .actions .like:hover{text-decoration:underline}.connect .post .comments .comment .content .actions .like.activated,.connect .post .comments .comment .content .actions .like.liked{color:#387ef5;-webkit-filter:none;filter:none}.connect .post .comments .comment .content .actions a img{height:12px;display:inline;vertical-align:middle}\n",".balloon {\n    -webkit-border-radius: 10px;\n    position: relative;\n    width: 90%;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    padding: 10px;\n    display: block;\n    margin: 5px auto 10px;    \n    &:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: -10px;\n\tleft: 50%;\n\tmargin-left: -10px;\n\twidth: 0;\n\theight: 0;\n\tborder-top: 10px solid #ccc;\n\tborder-left: 10px solid transparent;\n\tborder-right: 10px solid transparent;\n    }\n    &:after {\n\tcontent: \"\";\n\tposition: absolute;\n\tbottom: -9px;\n\tleft: 50%;\n\tmargin-left: -10px;\n\twidth: 0;\n\theight: 0;\n\tborder-top: 10px solid #fff;\n\tborder-left: 10px solid transparent;\n\tborder-right: 10px solid transparent;\n    }\n}\n","$bg-color: #E4E4E4;\n$mincho:  \"ipa-mincho\", \"ヒラギノ明朝 ProN W6\",\n\"HiraMinProN-W6\",\n\"HG明朝E\",\n\"ＭＳ Ｐ明朝\",\n\"MS PMincho\",\n\"MS 明朝\",\nserif;\n$dark: rgb(116, 116, 116);\n$border: #dddddd;\n$correct: #def0a5;\n$incorrect: #ffd4cc;\n\n.dialog {\n    .block {display: block; margin: auto;}\n}\n\n.section-header{\n    margin-top: 10px;\n    color: white;\n    font-size: 26px;\n    font-weight: bold;\n    font-family: $mincho;\n    //\t    box-shadow: 0 0 8px rgba(0, 0, 0, .8);\n    background-color: #5E84FF;\n    -webkit-border-radius: 20px;\n    padding: 3px;\n    text-align: center;\n}\n\n.lesson {\n    position: relative;\n    margin-bottom: 15px;\n    text-align: center;    \n    a{\n\ttext-decoration:none;\t\n     }\n    .lesson-icon{\n\twidth: 80px;\n        cursor: pointer;\n\theight: 80px;\n\t-webkit-border-radius: 50%;\n\tborder: solid #2B746E 6px;\n\tpadding: 3px;\n\t&:active{\n\t    box-shadow: 0 0 12px rgba(0, 0, 0, .9);\n\t    filter:brightness(50%);\n\t}\n\t&.activated {filter:brightness(50%);}\n    }\n    .activated {\n        .lesson-icon{filter:brightness(50%);box-shadow: 0 0 12px rgba(0, 0, 0, .9);}\n    }\n    .test {\n\tborder: solid red 6px;\n    }\n    .lesson-title {\n\tfont-family: $mincho;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\ttext-align: center;\n        margin: 0;\n\tcolor: $dark;\n    }\n    img.cleared {\n\twidth: 60px;\n\tposition: absolute;\n\ttop: -10px;\n\tleft: 25%;\n    }\n}\n\n.learn{\n    .lesson-list {\n        //background-image: url('../images/paper_bg.jpg');\n        background-color: white;\t\n        .wrapper{\n\t    text-align: center;\n            .activated {\n                .book-thumb{opacity: 0.7;}\n            }\n\t    .book-thumb{\n\t        width: 90%;\n\t        margin: 5px;\n\t        -webkit-border-radius: 10px;\n\t        &:hover, &.activated {opacity: 0.7;}\n\t    }\n\t    .description {\n\t        text-align: left;\n\t        margin-bottom: 15px;\n\t        padding: 5px;\n\t        color: #444444;\n\t    }\n\t    .section-header{\n\t        margin-top: 10px;\n\t        color: white;\n\t        font-size: 26px;\n\t        font-weight: bold;\n\t        font-family: $mincho;\n                //\t    box-shadow: 0 0 8px rgba(0, 0, 0, .8);\n\t        background-color: #5E84FF;\n\t        -webkit-border-radius: 20px;\n\t        padding: 3px;\n\t    }\n\n        }\n    }\n}\n\n.char-lesson {\n    md-toolbar, .md-toolbar-tools{\n        font-family: $mincho;\n    }\n    .char-list {\n        border-right: 1px solid $border;\n        md-list{\n            padding: 0;\n            h2{font-size: 18px; font-family: $mincho;}\n\t    .item-menu-active{background-color: #dddddd;}\n        }\n    }\n    .char-view {\n\tfont-family: $mincho;\n\t-webkit-writing-mode: vertical-rl;\n\twriting-mode: vertical-rl;\n        .single, .multi {\n            img {max-width: 50px; margin: 4px;}\n        }\n    }        \n    \n}\n\n.quiz-dialog {\n    .balloon {\n        max-width: 300px;\n    }\n    .quiz-image {\n        margin: auto;\n\tfont-family: $mincho;\n        font-size: 26px;\n\t-webkit-writing-mode: vertical-rl;\n\twriting-mode: vertical-rl;\n        p{margin: 0;}\n        img{ max-height: 250px;}\n    }\n    .input-container {\n\t.block{display: block; text-align: center}\n        input {\n            margin-left: 70px;\n            outline: none;\n\t    border: 1px solid #aaa;\n\t    -webkit-transition: all .3s;\n\t    transition: all .3s;\n            resize: none;\n            font-size: 26px;\n            text-align: center;\n            &:focus {\n                box-shadow: 0 0 7px #1abc9c;\n\t        border: 1px solid #1abc9c;\n            }\n        }\n    }\n    md-dialog-actions {\n        background-color: #dddddd;\n        &.correct {background-color: $correct;}\n        &.incorrect {background-color: $incorrect;}\n    }\n}\n","// global\n\n@import 'shimimaru';\n@import 'kula';  \n\n$mincho: \"ヒラギノ明朝 ProN W6\",    \"HiraMinProN-W6\",    \"HG明朝E\",    \"ＭＳ Ｐ明朝\",    \"MS PMincho\",    \"MS 明朝\";\n$link-color: #167ac6;\n$light:                           #fff !default;\n$stable:                          #f8f8f8 !default;\n$positive:                        #387ef5 !default;\n$calm:                            #11c1f3 !default;\n$balanced:                        #33cd5f !default;\n$energized:                       #ffc900 !default;\n$assertive:                       #ef473a !default;\n$royal:                           #886aea !default;\n$dark:                            #444 !default;\n$border: #dddddd;\n\n.color-light{color: $light;}\n.color-stable{color: $stable;}\n.color-positive{color: $positive;}\n.color-calm{color: $calm;}\n.color-balanced{color: $balanced;}\n.color-energized{color: $energized;}\n.color-assertive{color: $assertive;}\n.color-royal{color: $royal;}\n.color-dark{color: $dark;}\n.color-sub{color: rgba(0,0,0,0.54);}\n.bg-light{background: $light;}\n.bg-stable{background: $stable;}\n.bg-positive{background: $positive;}\n.bg-calm{background: $calm;}\n.bg-balanced{background: $balanced;}\n.bg-energized{background: $energized;}\n.bg-assertive{background: $assertive;}\n.bg-royal{background: $royal;}\n.bg-dark{background: $dark;}\n.bg-sub{background: rgba(0,0,0,0.54);}\n.bg-default{background: #f6f7f9;}\nhtml {\n    overflow: hidden;\n    height: 100%;\n}\n\n\nbody {\n    font-family: 'Roboto', sans-serif;\n    font-size:14px;\n    height:100%;\n    margin: 0px;\n    padding: 0px;\n    overflow: auto;\n//    font-family: $mincho;\n}\nmd-content, .md-subheader{background: #e9ebee;}\nmd-whiteframe {background: white;}\n\n.block {\n    text-align: left;\n}\n\n.user-avatar {\n    display: inline;\n    vertical-align: middle;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n}\n\n.link {\n    color: $link-color;\n    cursor: pointer;\n    font-size: 14px;\n    &:hover {text-decoration: underline;}\n}\n\n.tag {\n    font-size: 14px;\n    padding: 3px;\n    margin: 2px;\n    border-radius: 5px;\n    display: inline-block;\n    color: white;\n}\t\t\n\nhr{border-top: 1px solid $border;\n   border-bottom: 0;\n   border-left: 0;\n   border-right: 0;}\n\n//////////////////////////////////////////////////////////////////////////\n\n.clickable{\n    cursor: pointer;\n}\n\ndiamond{\n    display: block;\n    margin-bottom: -5px;\n    .diamond {\n       display: block;\n        margin: 0;\n        img{width: 30px; vertical-align: middle;}\n    }\n}\n\n.open-profile, .open-likes{\n    cursor: pointer;\n    &:hover{text-decoration: underline;}\n}\n\n.profile {\n    .status {\n        img {height: 26px; vertical-align: middle;}\n        span{margin-right: 10px; font-size: 16px;font-weight: normal;}\n    }\n        \n}\n\n.post-digest {\n    padding: 10px 0 10px;\n    i.material-icons{font-size: 19px; vertical-align: bottom;}\n    p{font-weight: normal;}    \n    .reactions {\n        img {\n            height: 20px;\n            display: inline;\n            vertical-align: middle\n        }            \n    }\n}\n\n.notification-panel {\n  background: white;\n  border-radius: 4px;\n  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2),\n      0 13px 19px 2px rgba(0, 0, 0, 0.14),\n      0 5px 24px 4px rgba(0, 0, 0, 0.12);\n  height: 400px;\n  width: 350px;\n  .activated {background: $border;}\n}\n\n//////////////////////////////////////////////////////////////////\n// mixin\n//////////////////////////////////////////////////////////////////\n@mixin like{\n    font-size: 12px;\n    text-decoration: none;\n    cursor: pointer;\n    display: inline-block;\n    img {\n        height: 22px;\n        display: inline;\n        vertical-align: middle\n    }\n    -webkit-filter: saturate(0%);\n    filter: saturate(0%);\n    &:hover {text-decoration: underline;filter: none;}\n    &.active, &.liked {color: $positive; filter: none;}\n}\n\n \n\n//////////////////////////////////////////////////////////////////////////\n\n.header {\n\n    .badge-container {position: relative; margin-right: 5px;}\n    .badge{\n\tbackground-color: #fa3e3e;\n\tborder-radius: 5px;\n\tcolor: white;\t\n\tpadding: 2px 4px;\n\tfont-size: 12px;\n\tposition: absolute; \n\ttop: 0;\n\tright: 5px;\t\n    }    \n}\n\n.dialog {\n    &.tutorial {\n\t.blink {\n\t    animation: blink 1s steps(5, start) infinite;\n\t    -webkit-animation: blink 1s steps(5, start) infinite;\n\t}\n\t@keyframes blink {\n\t    to {\n\t\tvisibility: hidden;\n\t    }\n\t}\n\t@-webkit-keyframes blink {\n\t    to {\n\t\tvisibility: hidden;\n\t    }\n\t}\n\n    }\n}\n\n\nmd-toast.message-toast {\n    .md-toast-content {\n\theight: 80px;\n\tfont-size: 12px;\n\t.user-info {\n\t    position: absolute;\n\t    top: 5px; left: 5px;\n\t    img {\n\t\twidth: 20px; height: 20px;\n\t\tborder-radius: 50%;\n\t\tdisplay: inline;\n\t    }\n\t    .name {\n\t\tdisplay: inline;\n\t    }\n\t}\n\t.content{\n\t    position: absolute;\n\t    top: 30px; left: 10px;\t    \n\t}\n    }\n}\n\n\n.confirm-dialog {\n    textarea {\n\tresize: none;\n\tpadding: 5px;\n\t&:focus{outline: none !important;}\n    }\n}\n\n.diff-dialog {\n    width: 80%;\n    md-dialog-content {\n\ttext-align: left;\n\tpadding: 5px;\n\tbox-sizing:border-box;\n\theight: 100%;\n\t-webkit-writing-mode: vertical-rl;\n\twriting-mode: vertical-rl;\n\t-ms-writing-mode: vertical-rl;\n\t-moz-writing-mode: vertical-rl;\t\n\t.added {\n\t    background: #eaf2c2;\n\t    color: #406619;\n\t    text-decoration: none;\n\t}\n\t.removed {\n\t    text-decoration: none;\n\t    color: #b30000;\n\t    background: #fadad7;\n\t}\n    }\n}\n \n\n.user-status {\n    font-size: 18px;\n    .status{\n\tmargin: 10px 5px;\n\tp {margin: 3px;}\n\timg {width: 35px; vertical-align: middle; margin-right: 5px;}\n    }\n    .progress {\n\tposition: relative;\n\twidth: 100%;\n\theight: 30px;\n\tbackground-color: grey;\n\t.bar {\n\t    position: absolute;\n\t    width: 1%;\n\t    height: 100%;\n\t    background-color: green;\t    \n\t}\n    }\n}\n\n\n.md-open-menu-container{z-index: 999999;}\n.toolbar {\n    h1{font-family: $mincho;}\n}\n\n.sidenav {\n    padding: 10px 2px 10px 0px;\n    h2 {margin: 3px 8px;\n        font-size: 14px;\n        font-weight: normal;\n        color: #cc181e;}\n    .md-button{\n        margin: 1px 10px;\n        font-size: 13px;\n        md-icon {\n            font-size: 22px;\n            margin-right: 3px;\n        }\n        .badge {\n            text-align: right;\n            position: absolute;\n            right: 10px;\n        }\n    }\n    md-divider {margin: 10px 3px;}\n    .ranking {\n        table{\n            td{vertical-align: top;\n               &.right{text-align: right; max-width: 120px;}\n               .increase{color: green;}}\n        }\n        h1{font-size: 18px; margin: 10px 0 0 13px; }\n        ol {\n            margin: 0;\n            padding-left: 25px;\n            li {\n                margin: 7px 0;\n                .detail {\n                    display: inline-block;\n                    vertical-align: middle;\n                    margin-left: 5px;\n                    .name{font-size: 14px; display: block;}\n                    .count {font-size: 12px; display: block;}\n                }\n            }\n        }\n    }\n}\n\n\n.home {\n    hr{border-top: 1px solid $border;\n       border-bottom: 0;\n       border-left: 0;\n       border-right: 0;}\n    md-whiteframe {\n        margin-top: 10px;\n    }\n    h3{margin:0;font-weight: normal;}\n    .disp-options{\n        background-color: white;\n        width: 600px;\n        margin: 0 10px;\n        padding: 10px;\n        box-sizing: border-box;\n        md-checkbox {margin: 0;}\n    }\n    .timeline-event {\n\twidth: 600px;\n\tmargin-bottom: 10px;\n        position: relative;\n\t.actions {\n\t    .like{ @include like;\n\t\t   margin: 2px 10px 8px;\n\t\t   font-size: 14px;}\n\t}\n        .tag {\n            position: absolute;\n            top: 5px; right: 5px;\n        }\n\t.page-info {\n\t    height: 140px;\n\t    border: 1px solid $border;\n\t    border-radius: 20px;\n\t    margin: 5px 10px;\n\t    .actions {\n\t\tborder-top: $border;\n\t    }\n\t    a.thumb {\n\t\tborder-radius: 20px 0 0 20px;\n\t\toverflow: hidden;\n\t\timg {border-radius: 20px 0 0 20px;}\n\t\t&:hover {\n\t\t    overflow: hidden;\t\t\n\t\t    filter: brightness(80%);\n\t\t    -webkit-filter: brightness(80%);\n\t\t}\n\t    }\n\t    .content {\n\t\tpadding: 10px;\n\t\ta{\n\t\t    display:block;\n\t\t    font-size: 18px;\n\t\t    text-decoration: none;\n\t\t    color: $link-color;\n\t\t    white-space: nowrap;\n\t\t    text-overflow: ellipsis;\n\t\t    &:hover {\n\t\t\ttext-decoration: underline;\n\t\t\tfilter: brightness(80%);\n\t\t\t-webkit-filter: brightness(80%);\n\t\t    }\n\t\t    \n\t\t}\n\t    }\n\t}\n    }    \n}\n\n\n.transcription {\n    md-tabs { height: 100%;}\n    .fav-button{\n\t&.active {\n\t    md-icon{color: gold;}\n\t    \n\t}\n    }\n    .content-status {\n\twidth: 200px;\n\tmargin: 0 auto;\n\t.content-count {\n\t    font-size: 20px;\n\t    text-align: center;\n\t}\n\t.current-status {\n\t    font-size: 14px;\n\t    margin-top: -5px;\n\t    text-align: center;\n\t    border-radius: 8px;\n\t    padding: 3px;\n\t    /* color: white; */\n\t    /* .status-waiting {background-color: $stable;} */\n\t    /* .status-transcribing {background-color: $assertive;} */\n\t    /* .status-unfinished {background-color: $energized;} */\n\t    /* .status-finished {background-color: $royal;} */\n\t    /* .status-finished {background-color: $calm;} */\n\t}\n    }\n    .editor {\n        border-right: $border 1px solid;\n\theight: 100%;\n\twidth: 100%;\n\t.flex {\n\t    overflow-x: scroll;\n\t    overflow-y: hidden;\n\t    height: 100%;\n\t    .vertical-editor {\n\t\t-webkit-writing-mode: vertical-rl;\n\t\twriting-mode: vertical-rl;\n\t\t-ms-writing-mode: vertical-rl;\n\t\t-moz-writing-mode: vertical-rl;\n\t\ttext-align: left;\n\t\tdisplay: inline-block;\n\t\toverflow-x: scroll;\n\t\tpadding: 5px 0;\n\t\tline-height: 2; \n\t\tfont-size: 15px;\n\t\t.warigaki {\n                    display: inline-table;\n                    -webkit-writing-mode: vertical-lr;\n                    writing-mode: vertical-lr;\n\t\t    -ms-writing-mode: vertical-rl;\n\t\t    -moz-writing-mode: vertical-rl;\t\t\n                    vertical-align: top;                \n\t\t}\n\t\t.warigaki-left, .warigaki-right {\n                    font-size:50%;\n                    display: table-row;\n\t\t    line-height: 150%;\n\t\t}\n\t\t.hako {\n                    margin: 2px;\n                    border: 1px solid black;\n                    display: inline;\n\t\t}\n\t\t.comment {\n\t\t    color: red;\n\t\t    &:before{content: '\\1F4AC';font-size: 12px;margin: 5px 0 -5px;}\n\t\t}\n\t\t.dubious, .illegible {\n\t\t    background-color: yellow;\n                    &:after{content: '\\2753';font-size: 5px;}\n\t\t}\n                .kaeriten {\n                    font-size: 1px;\n                    vertical-align: sub;                    \n                }\n                .okuri {\n                    font-size: 1px;\n                    vertical-align: super; \n                }                \n\t\t\n\t    }\n            .viewer {\n\t\tmin-width: 100%;\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t\tbackground: white;\n            }\n            .input {\n\t\tbackground: white;\t\t\n\t\t-webkit-writing-mode: vertical-rl;\n\t\twriting-mode: vertical-rl;\n\t\t-ms-writing-mode: vertical-rl;\n\t\t-moz-writing-mode: vertical-rl;\n\t\ttext-align: left;\n\t\tbox-sizing: border-box;\n\t\tdisplay: inline-block;\n\t\toverflow-x: scroll;\n\t\theight:100%;\n                width: 100%;                \n                padding: 3px;\n\t\t&.noedit {\n                    background-color: #f5f5f5;\n\t\t}\n                div{padding:0 !important; }\n                \n            }\n            .insert-buttons {\n                .md-button{opacity: 0.7;}\n            }\n            .legends{\n\t\tbox-sizing: border-box;\t\t\n\t\th2,h3,p {padding: 0}\n\t\th2 {\n                    margin: 0 25px 3px 0;\n                    border-top: 8px solid #B82C5F;\n\t\t}\n\t\th3 {margin: 5px 5px 0 0;}\n\t\tp {margin: 10px 0 0 0;}\n\n            }\n            .history {\n                h3{color: $positive; font-weight: bold; font-size: 14px;}\n                .comment {margin: 8px 0; font-size:13px; color: black;}\n                .like{ @include like; margin-top: 8px;}\n            }\n\t}\n    }    \n}\n.transcription-sidenav {\n    md-tabs { height: 100%;}\n    .msg-input{\n\twidth: 100%; height: 80px;\n\tmargin: 0;\n\t.submit-button {\n\t    position: absolute;\n\t    right: 3px; top: 90px;\n\t}\n\ttextarea {\n\t    box-sizing:border-box;\n\t    height: 100%;\n\t    width: 100%;\n\t    resize: none;\n\t    border: none;\n\t    padding: 10px;\n\t    box-shadow: 0 0 10px rgba(0,0,0,0.4);\n\t    &:focus{outline: none !important;}\n\t}\n    }\n}\n\n\n.entries {\n    background-color: whitesmoke;\n    .entry-wrapper {padding: 3px; margin: 3px;}\n    .entry {\n\tbackground-color: white;\n\tdisplay: table;\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\t.title {\n\t    width: 280px;\n\t    text-align: center;\n\t    display: block;\n\t    margin: 10px auto 5px;\n\t    font-size: 18px;\n\t    text-decoration: none;\n\t    color: $link-color;\n\t    overflow: hidden;\n\t    white-space: nowrap;\n\t    text-overflow: ellipsis;\t\t\t       \n\t    &:hover {\n\t\ttext-decoration: underline;\n\t\tfilter: brightness(80%);\n\t\t-webkit-filter: brightness(80%);\n\t    }\n\t}\n\t.entry-id {\n\t    text-decoration: none;\n\t    &:hover{text-decoration: underline;}\n\t}\n\t.thumbnail {\n            height: 220px;\n\t    position: relative;\n            img{\n\t        max-width: 280px;\n\t        max-height: 220px;\n\t        margin: 0 auto;\n\t        display: block;\n            }\n\t    .difficulty-indicator {\n\t\tposition: absolute;\n\t\tbottom: 3px;\n\t\tleft: 5px;\n\t\tcolor: white;\n\t\tfont-size: 11px;\n\t\tpadding: 2px 4px;\n\t\tfont-weight: bold;\n\t\tborder-radius: 5px;\t    \n\t    }\n\t    .low{background-color: $balanced;}\n\t    .middle{background-color: $energized;}\n\t    .high{background-color: $assertive;}\t    \n\t}\n\tmd-progress-linear {\n\t    margin: 5px auto;\n\t    width: 280px;\n\t}\n\t.progress {\n\t    font-size: 11px;\n\t    text-align: center;\n\t}\n\t.entry-info {\n\t    font-size: 11px;\n\t}\n\t.tag {\n\t    font-size: 10px;\n\t    padding: 3px;\n\t    margin: 2px;\n\t    border-radius: 5px;\n\t    display: inline-block;\n\t    color: white;\n\t    &.disaster {background-color: $positive;}\n\t    &.region {background-color: $calm;}\n\t    &:hover{\n\t\ttext-decoration: underline;\n\t\tfilter: brightness(50%);\n\t\tcursor: pointer;\n\t    }\n\t}\t\t\n    }\n\n}\n\n.connect{\n    .compose {\n        background-color: #f6f7f9;        \n        diplay:block; background: white; margin: 8px;\n\n        textarea {\n            width: 100%;\n            height: 100%;\n            resize: none;\n            overflow: scroll;\n            outline: none;\n            padding: 8px;\n            border: none;\n            box-sizing: border-box;            \n            -webkit-box-shadow: none;\n            -moz-box-shadow: none;\n            box-shadow: none;            \n            background-color: white;\n        }\n        .actions {\n            border-top: 1px solid $border;\n            background-color: #f6f7f9;        \n        }\n        .images {\n            background-color: #f6f7f9;\n        }\n    }\n    .post {\n        md-card-header { padding-bottom: 0;}\n        md-card-content {padding-top: 0;}\n        position: relative;\n        .remove {\n            cursor: pointer;\n            color: $assertive;\n            text-decoration: none;\n            &:hover{text-decoration: underline;}\n        }        \n\t.post-type {            \n\t    position: absolute;\n\t    top: 10px;\n\t    right: 6px;\n\t    color: white;\t    \n\t    padding: 2px 5px;\n\t    border-radius: 8px;\n\t    font-size: 15px;\n\t    &.question{background: $positive;}\n\t    &.seeking{background: $assertive;}\n\t    &.showcase{background: $balanced;}\n\t}\n\t.text {color: black;\n\t       overflow: hidden;\n\t      }\n\t.photo {\n\t    display: block;\n\t    max-height: 150px;\n\t    max-width: 100%;\n\t    border-radius: 10px;\n\t    margin: 3px auto;\n\t}\n        .actions {\n\t    .like{ @include like;}\n\t}\n        .info{\n            i.material-icons{font-size: 19px; vertical-align: bottom;}\n            img {\n                height: 20px;\n                display: inline;\n                vertical-align: middle\n            }\n            \n            \n        }\n        .comments {\n            hr{border-top: 1px solid $border;\n               border-bottom: 0;\n               border-left: 0;\n               border-right: 0;}\n            .action {\n                font-size: 12px;\n                color: $positive;\n                cursor: pointer;\n                &:hover{text-decoration: underline;}\n            }\n            border-top: 1px solid $border;\n            .reply-form {\n                img {width: 30px; height: 30px; margin: 3px;}\n                textarea {\n                    resize: none;\n                    overflow: scroll;\n                    outline: none;\n                    padding: 3px;\n                    margin: 3px;\n                    border: 1px solid $border;                    \n                }\n                button{margin: 0;}\n            }\n            .comment {\n                margin: 9px 3px;\n                font-size: 12px;\n                .user-avatar{\n                    cursor: pointer;                        \n                    min-width: 30px;\n                    min-height: 30px;\n                    margin-right: 5px;}\n                \n                .content {\n                    margin-left: 4px;\n                    .user-name {\n                        cursor: pointer;                        \n                        font-weight: bold; color:$positive;\n                        &:hover{text-decoration: underline;}\n                    }\n                    .text {}\n                    .images{padding: 0;\n                            margin: 0;}\n                    .actions {                        \n                        .like {\n                            filter: none; -webkit-filter: none;                         \n                            font-style: bold;\n                            text-decoration: none;\n                            display: inline-block;\n                            cursor: pointer;\n                            &:hover{text-decoration: underline;}\n                            &.activated, &.liked {\n                                color:$positive;                            \n                                -webkit-filter: none;\n                                filter: none;\n                            }\n                        }\n                        a {\n                            img {\n                                height: 12px;\n                                display: inline;\n                                vertical-align: middle\n                            }\n                        }\n                    }\n                }                \n            }\n        }\n    }\n}\n\n"],"sourceRoot":"webpack://"}]);

	// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist.js